import * as s from "react";
import le, { isValidElement as Nw, useContext as qt, createContext as uo, useRef as Xe, useLayoutEffect as Iw, useEffect as Bt, useState as Ht, forwardRef as ar, useMemo as nn, Children as Pw, createRef as Rw, useCallback as Wn, useImperativeHandle as qr, cloneElement as Mw, Component as wh } from "react";
import * as Tw from "react-dom";
import $u, { createPortal as Eh, unstable_batchedUpdates as Oh, flushSync as bi } from "react-dom";
var fo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _w(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jl = {}, Dw = {
  get exports() {
    return Jl;
  },
  set exports(e) {
    Jl = e;
  }
}, za = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gm;
function kw() {
  if (Gm)
    return za;
  Gm = 1;
  var e = le, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(l, c, u) {
    var d, f = {}, m = null, v = null;
    u !== void 0 && (m = "" + u), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (v = c.ref);
    for (d in c)
      r.call(c, d) && !a.hasOwnProperty(d) && (f[d] = c[d]);
    if (l && l.defaultProps)
      for (d in c = l.defaultProps, c)
        f[d] === void 0 && (f[d] = c[d]);
    return { $$typeof: t, type: l, key: m, ref: v, props: f, _owner: o.current };
  }
  return za.Fragment = n, za.jsx = i, za.jsxs = i, za;
}
var Aa = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Um;
function Lw() {
  return Um || (Um = 1, process.env.NODE_ENV !== "production" && function() {
    var e = le, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h = Symbol.iterator, p = "@@iterator";
    function g(ne) {
      if (ne === null || typeof ne != "object")
        return null;
      var ye = h && ne[h] || ne[p];
      return typeof ye == "function" ? ye : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(ne) {
      {
        for (var ye = arguments.length, ce = new Array(ye > 1 ? ye - 1 : 0), Ce = 1; Ce < ye; Ce++)
          ce[Ce - 1] = arguments[Ce];
        C("error", ne, ce);
      }
    }
    function C(ne, ye, ce) {
      {
        var Ce = b.ReactDebugCurrentFrame, je = Ce.getStackAddendum();
        je !== "" && (ye += "%s", ce = ce.concat([je]));
        var Ne = ce.map(function(De) {
          return String(De);
        });
        Ne.unshift("Warning: " + ye), Function.prototype.apply.call(console[ne], console, Ne);
      }
    }
    var S = !1, $ = !1, x = !1, w = !1, N = !1, O;
    O = Symbol.for("react.module.reference");
    function E(ne) {
      return !!(typeof ne == "string" || typeof ne == "function" || ne === r || ne === a || N || ne === o || ne === u || ne === d || w || ne === v || S || $ || x || typeof ne == "object" && ne !== null && (ne.$$typeof === m || ne.$$typeof === f || ne.$$typeof === i || ne.$$typeof === l || ne.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ne.$$typeof === O || ne.getModuleId !== void 0));
    }
    function I(ne, ye, ce) {
      var Ce = ne.displayName;
      if (Ce)
        return Ce;
      var je = ye.displayName || ye.name || "";
      return je !== "" ? ce + "(" + je + ")" : ce;
    }
    function k(ne) {
      return ne.displayName || "Context";
    }
    function M(ne) {
      if (ne == null)
        return null;
      if (typeof ne.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ne == "function")
        return ne.displayName || ne.name || null;
      if (typeof ne == "string")
        return ne;
      switch (ne) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof ne == "object")
        switch (ne.$$typeof) {
          case l:
            var ye = ne;
            return k(ye) + ".Consumer";
          case i:
            var ce = ne;
            return k(ce._context) + ".Provider";
          case c:
            return I(ne, ne.render, "ForwardRef");
          case f:
            var Ce = ne.displayName || null;
            return Ce !== null ? Ce : M(ne.type) || "Memo";
          case m: {
            var je = ne, Ne = je._payload, De = je._init;
            try {
              return M(De(Ne));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, _ = 0, D, R, T, L, F, j, A;
    function B() {
    }
    B.__reactDisabledLog = !0;
    function K() {
      {
        if (_ === 0) {
          D = console.log, R = console.info, T = console.warn, L = console.error, F = console.group, j = console.groupCollapsed, A = console.groupEnd;
          var ne = {
            configurable: !0,
            enumerable: !0,
            value: B,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ne,
            log: ne,
            warn: ne,
            error: ne,
            group: ne,
            groupCollapsed: ne,
            groupEnd: ne
          });
        }
        _++;
      }
    }
    function Y() {
      {
        if (_--, _ === 0) {
          var ne = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, ne, {
              value: D
            }),
            info: P({}, ne, {
              value: R
            }),
            warn: P({}, ne, {
              value: T
            }),
            error: P({}, ne, {
              value: L
            }),
            group: P({}, ne, {
              value: F
            }),
            groupCollapsed: P({}, ne, {
              value: j
            }),
            groupEnd: P({}, ne, {
              value: A
            })
          });
        }
        _ < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = b.ReactCurrentDispatcher, te;
    function ee(ne, ye, ce) {
      {
        if (te === void 0)
          try {
            throw Error();
          } catch (je) {
            var Ce = je.stack.trim().match(/\n( *(at )?)/);
            te = Ce && Ce[1] || "";
          }
        return `
` + te + ne;
      }
    }
    var oe = !1, X;
    {
      var W = typeof WeakMap == "function" ? WeakMap : Map;
      X = new W();
    }
    function re(ne, ye) {
      if (!ne || oe)
        return "";
      {
        var ce = X.get(ne);
        if (ce !== void 0)
          return ce;
      }
      var Ce;
      oe = !0;
      var je = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ne;
      Ne = G.current, G.current = null, K();
      try {
        if (ye) {
          var De = function() {
            throw Error();
          };
          if (Object.defineProperty(De.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(De, []);
            } catch (Nt) {
              Ce = Nt;
            }
            Reflect.construct(ne, [], De);
          } else {
            try {
              De.call();
            } catch (Nt) {
              Ce = Nt;
            }
            ne.call(De.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Nt) {
            Ce = Nt;
          }
          ne();
        }
      } catch (Nt) {
        if (Nt && Ce && typeof Nt.stack == "string") {
          for (var Fe = Nt.stack.split(`
`), ot = Ce.stack.split(`
`), pt = Fe.length - 1, St = ot.length - 1; pt >= 1 && St >= 0 && Fe[pt] !== ot[St]; )
            St--;
          for (; pt >= 1 && St >= 0; pt--, St--)
            if (Fe[pt] !== ot[St]) {
              if (pt !== 1 || St !== 1)
                do
                  if (pt--, St--, St < 0 || Fe[pt] !== ot[St]) {
                    var Ot = `
` + Fe[pt].replace(" at new ", " at ");
                    return ne.displayName && Ot.includes("<anonymous>") && (Ot = Ot.replace("<anonymous>", ne.displayName)), typeof ne == "function" && X.set(ne, Ot), Ot;
                  }
                while (pt >= 1 && St >= 0);
              break;
            }
        }
      } finally {
        oe = !1, G.current = Ne, Y(), Error.prepareStackTrace = je;
      }
      var Wt = ne ? ne.displayName || ne.name : "", rn = Wt ? ee(Wt) : "";
      return typeof ne == "function" && X.set(ne, rn), rn;
    }
    function Z(ne, ye, ce) {
      return re(ne, !1);
    }
    function H(ne) {
      var ye = ne.prototype;
      return !!(ye && ye.isReactComponent);
    }
    function U(ne, ye, ce) {
      if (ne == null)
        return "";
      if (typeof ne == "function")
        return re(ne, H(ne));
      if (typeof ne == "string")
        return ee(ne);
      switch (ne) {
        case u:
          return ee("Suspense");
        case d:
          return ee("SuspenseList");
      }
      if (typeof ne == "object")
        switch (ne.$$typeof) {
          case c:
            return Z(ne.render);
          case f:
            return U(ne.type, ye, ce);
          case m: {
            var Ce = ne, je = Ce._payload, Ne = Ce._init;
            try {
              return U(Ne(je), ye, ce);
            } catch {
            }
          }
        }
      return "";
    }
    var ae = Object.prototype.hasOwnProperty, ue = {}, de = b.ReactDebugCurrentFrame;
    function se(ne) {
      if (ne) {
        var ye = ne._owner, ce = U(ne.type, ne._source, ye ? ye.type : null);
        de.setExtraStackFrame(ce);
      } else
        de.setExtraStackFrame(null);
    }
    function ie(ne, ye, ce, Ce, je) {
      {
        var Ne = Function.call.bind(ae);
        for (var De in ne)
          if (Ne(ne, De)) {
            var Fe = void 0;
            try {
              if (typeof ne[De] != "function") {
                var ot = Error((Ce || "React class") + ": " + ce + " type `" + De + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ne[De] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ot.name = "Invariant Violation", ot;
              }
              Fe = ne[De](ye, De, Ce, ce, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (pt) {
              Fe = pt;
            }
            Fe && !(Fe instanceof Error) && (se(je), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ce || "React class", ce, De, typeof Fe), se(null)), Fe instanceof Error && !(Fe.message in ue) && (ue[Fe.message] = !0, se(je), y("Failed %s type: %s", ce, Fe.message), se(null));
          }
      }
    }
    var me = Array.isArray;
    function Se(ne) {
      return me(ne);
    }
    function ve(ne) {
      {
        var ye = typeof Symbol == "function" && Symbol.toStringTag, ce = ye && ne[Symbol.toStringTag] || ne.constructor.name || "Object";
        return ce;
      }
    }
    function ge(ne) {
      try {
        return $e(ne), !1;
      } catch {
        return !0;
      }
    }
    function $e(ne) {
      return "" + ne;
    }
    function we(ne) {
      if (ge(ne))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ve(ne)), $e(ne);
    }
    var _e = b.ReactCurrentOwner, ze = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Te, ke, Le;
    Le = {};
    function Ee(ne) {
      if (ae.call(ne, "ref")) {
        var ye = Object.getOwnPropertyDescriptor(ne, "ref").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return ne.ref !== void 0;
    }
    function xe(ne) {
      if (ae.call(ne, "key")) {
        var ye = Object.getOwnPropertyDescriptor(ne, "key").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return ne.key !== void 0;
    }
    function he(ne, ye) {
      if (typeof ne.ref == "string" && _e.current && ye && _e.current.stateNode !== ye) {
        var ce = M(_e.current.type);
        Le[ce] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', M(_e.current.type), ne.ref), Le[ce] = !0);
      }
    }
    function pe(ne, ye) {
      {
        var ce = function() {
          Te || (Te = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        ce.isReactWarning = !0, Object.defineProperty(ne, "key", {
          get: ce,
          configurable: !0
        });
      }
    }
    function Pe(ne, ye) {
      {
        var ce = function() {
          ke || (ke = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        ce.isReactWarning = !0, Object.defineProperty(ne, "ref", {
          get: ce,
          configurable: !0
        });
      }
    }
    var Re = function(ne, ye, ce, Ce, je, Ne, De) {
      var Fe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: ne,
        key: ye,
        ref: ce,
        props: De,
        // Record the component responsible for creating this element.
        _owner: Ne
      };
      return Fe._store = {}, Object.defineProperty(Fe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Fe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ce
      }), Object.defineProperty(Fe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: je
      }), Object.freeze && (Object.freeze(Fe.props), Object.freeze(Fe)), Fe;
    };
    function at(ne, ye, ce, Ce, je) {
      {
        var Ne, De = {}, Fe = null, ot = null;
        ce !== void 0 && (we(ce), Fe = "" + ce), xe(ye) && (we(ye.key), Fe = "" + ye.key), Ee(ye) && (ot = ye.ref, he(ye, je));
        for (Ne in ye)
          ae.call(ye, Ne) && !ze.hasOwnProperty(Ne) && (De[Ne] = ye[Ne]);
        if (ne && ne.defaultProps) {
          var pt = ne.defaultProps;
          for (Ne in pt)
            De[Ne] === void 0 && (De[Ne] = pt[Ne]);
        }
        if (Fe || ot) {
          var St = typeof ne == "function" ? ne.displayName || ne.name || "Unknown" : ne;
          Fe && pe(De, St), ot && Pe(De, St);
        }
        return Re(ne, Fe, ot, je, Ce, _e.current, De);
      }
    }
    var Ze = b.ReactCurrentOwner, Ie = b.ReactDebugCurrentFrame;
    function Be(ne) {
      if (ne) {
        var ye = ne._owner, ce = U(ne.type, ne._source, ye ? ye.type : null);
        Ie.setExtraStackFrame(ce);
      } else
        Ie.setExtraStackFrame(null);
    }
    var bt;
    bt = !1;
    function He(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === t;
    }
    function nt() {
      {
        if (Ze.current) {
          var ne = M(Ze.current.type);
          if (ne)
            return `

Check the render method of \`` + ne + "`.";
        }
        return "";
      }
    }
    function et(ne) {
      {
        if (ne !== void 0) {
          var ye = ne.fileName.replace(/^.*[\\\/]/, ""), ce = ne.lineNumber;
          return `

Check your code at ` + ye + ":" + ce + ".";
        }
        return "";
      }
    }
    var Ge = {};
    function Ae(ne) {
      {
        var ye = nt();
        if (!ye) {
          var ce = typeof ne == "string" ? ne : ne.displayName || ne.name;
          ce && (ye = `

Check the top-level render call using <` + ce + ">.");
        }
        return ye;
      }
    }
    function qe(ne, ye) {
      {
        if (!ne._store || ne._store.validated || ne.key != null)
          return;
        ne._store.validated = !0;
        var ce = Ae(ye);
        if (Ge[ce])
          return;
        Ge[ce] = !0;
        var Ce = "";
        ne && ne._owner && ne._owner !== Ze.current && (Ce = " It was passed a child from " + M(ne._owner.type) + "."), Be(ne), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ce, Ce), Be(null);
      }
    }
    function Je(ne, ye) {
      {
        if (typeof ne != "object")
          return;
        if (Se(ne))
          for (var ce = 0; ce < ne.length; ce++) {
            var Ce = ne[ce];
            He(Ce) && qe(Ce, ye);
          }
        else if (He(ne))
          ne._store && (ne._store.validated = !0);
        else if (ne) {
          var je = g(ne);
          if (typeof je == "function" && je !== ne.entries)
            for (var Ne = je.call(ne), De; !(De = Ne.next()).done; )
              He(De.value) && qe(De.value, ye);
        }
      }
    }
    function Ke(ne) {
      {
        var ye = ne.type;
        if (ye == null || typeof ye == "string")
          return;
        var ce;
        if (typeof ye == "function")
          ce = ye.propTypes;
        else if (typeof ye == "object" && (ye.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ye.$$typeof === f))
          ce = ye.propTypes;
        else
          return;
        if (ce) {
          var Ce = M(ye);
          ie(ce, ne.props, "prop", Ce, ne);
        } else if (ye.PropTypes !== void 0 && !bt) {
          bt = !0;
          var je = M(ye);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", je || "Unknown");
        }
        typeof ye.getDefaultProps == "function" && !ye.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ye(ne) {
      {
        for (var ye = Object.keys(ne.props), ce = 0; ce < ye.length; ce++) {
          var Ce = ye[ce];
          if (Ce !== "children" && Ce !== "key") {
            Be(ne), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ce), Be(null);
            break;
          }
        }
        ne.ref !== null && (Be(ne), y("Invalid attribute `ref` supplied to `React.Fragment`."), Be(null));
      }
    }
    function Ve(ne, ye, ce, Ce, je, Ne) {
      {
        var De = E(ne);
        if (!De) {
          var Fe = "";
          (ne === void 0 || typeof ne == "object" && ne !== null && Object.keys(ne).length === 0) && (Fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ot = et(je);
          ot ? Fe += ot : Fe += nt();
          var pt;
          ne === null ? pt = "null" : Se(ne) ? pt = "array" : ne !== void 0 && ne.$$typeof === t ? (pt = "<" + (M(ne.type) || "Unknown") + " />", Fe = " Did you accidentally export a JSX literal instead of a component?") : pt = typeof ne, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", pt, Fe);
        }
        var St = at(ne, ye, ce, je, Ne);
        if (St == null)
          return St;
        if (De) {
          var Ot = ye.children;
          if (Ot !== void 0)
            if (Ce)
              if (Se(Ot)) {
                for (var Wt = 0; Wt < Ot.length; Wt++)
                  Je(Ot[Wt], ne);
                Object.freeze && Object.freeze(Ot);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Je(Ot, ne);
        }
        return ne === r ? Ye(St) : Ke(St), St;
      }
    }
    function Qe(ne, ye, ce) {
      return Ve(ne, ye, ce, !0);
    }
    function it(ne, ye, ce) {
      return Ve(ne, ye, ce, !1);
    }
    var yt = it, Tt = Qe;
    Aa.Fragment = r, Aa.jsx = yt, Aa.jsxs = Tt;
  }()), Aa;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = kw() : e.exports = Lw();
})(Dw);
const We = Jl.jsx, Fw = Jl.jsxs;
var wu = {}, jw = {
  get exports() {
    return wu;
  },
  set exports(e) {
    wu = e;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var a = "", i = 0; i < arguments.length; i++) {
        var l = arguments[i];
        l && (a = o(a, r(l)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var i = "";
      for (var l in a)
        t.call(a, l) && a[l] && (i = o(i, l));
      return i;
    }
    function o(a, i) {
      return i ? a ? a + " " + i : a + i : a;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(jw);
const J = wu;
function fe() {
  return fe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fe.apply(this, arguments);
}
var yi = {}, zw = {
  get exports() {
    return yi;
  },
  set exports(e) {
    yi = e;
  }
}, Qt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ym;
function Aw() {
  if (Ym)
    return Qt;
  Ym = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), l = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function p(g) {
    if (typeof g == "object" && g !== null) {
      var b = g.$$typeof;
      switch (b) {
        case e:
          switch (g = g.type, g) {
            case n:
            case o:
            case r:
            case u:
            case d:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case l:
                case i:
                case c:
                case m:
                case f:
                case a:
                  return g;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return Qt.ContextConsumer = i, Qt.ContextProvider = a, Qt.Element = e, Qt.ForwardRef = c, Qt.Fragment = n, Qt.Lazy = m, Qt.Memo = f, Qt.Portal = t, Qt.Profiler = o, Qt.StrictMode = r, Qt.Suspense = u, Qt.SuspenseList = d, Qt.isAsyncMode = function() {
    return !1;
  }, Qt.isConcurrentMode = function() {
    return !1;
  }, Qt.isContextConsumer = function(g) {
    return p(g) === i;
  }, Qt.isContextProvider = function(g) {
    return p(g) === a;
  }, Qt.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, Qt.isForwardRef = function(g) {
    return p(g) === c;
  }, Qt.isFragment = function(g) {
    return p(g) === n;
  }, Qt.isLazy = function(g) {
    return p(g) === m;
  }, Qt.isMemo = function(g) {
    return p(g) === f;
  }, Qt.isPortal = function(g) {
    return p(g) === t;
  }, Qt.isProfiler = function(g) {
    return p(g) === o;
  }, Qt.isStrictMode = function(g) {
    return p(g) === r;
  }, Qt.isSuspense = function(g) {
    return p(g) === u;
  }, Qt.isSuspenseList = function(g) {
    return p(g) === d;
  }, Qt.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === o || g === r || g === u || g === d || g === v || typeof g == "object" && g !== null && (g.$$typeof === m || g.$$typeof === f || g.$$typeof === a || g.$$typeof === i || g.$$typeof === c || g.$$typeof === h || g.getModuleId !== void 0);
  }, Qt.typeOf = p, Qt;
}
var Jt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xm;
function Bw() {
  return Xm || (Xm = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), l = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h = !1, p = !1, g = !1, b = !1, y = !1, C;
    C = Symbol.for("react.module.reference");
    function S(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === n || H === o || y || H === r || H === u || H === d || b || H === v || h || p || g || typeof H == "object" && H !== null && (H.$$typeof === m || H.$$typeof === f || H.$$typeof === a || H.$$typeof === i || H.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === C || H.getModuleId !== void 0));
    }
    function $(H) {
      if (typeof H == "object" && H !== null) {
        var U = H.$$typeof;
        switch (U) {
          case e:
            var ae = H.type;
            switch (ae) {
              case n:
              case o:
              case r:
              case u:
              case d:
                return ae;
              default:
                var ue = ae && ae.$$typeof;
                switch (ue) {
                  case l:
                  case i:
                  case c:
                  case m:
                  case f:
                  case a:
                    return ue;
                  default:
                    return U;
                }
            }
          case t:
            return U;
        }
      }
    }
    var x = i, w = a, N = e, O = c, E = n, I = m, k = f, M = t, P = o, _ = r, D = u, R = d, T = !1, L = !1;
    function F(H) {
      return T || (T = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(H) {
      return L || (L = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function A(H) {
      return $(H) === i;
    }
    function B(H) {
      return $(H) === a;
    }
    function K(H) {
      return typeof H == "object" && H !== null && H.$$typeof === e;
    }
    function Y(H) {
      return $(H) === c;
    }
    function G(H) {
      return $(H) === n;
    }
    function te(H) {
      return $(H) === m;
    }
    function ee(H) {
      return $(H) === f;
    }
    function oe(H) {
      return $(H) === t;
    }
    function X(H) {
      return $(H) === o;
    }
    function W(H) {
      return $(H) === r;
    }
    function re(H) {
      return $(H) === u;
    }
    function Z(H) {
      return $(H) === d;
    }
    Jt.ContextConsumer = x, Jt.ContextProvider = w, Jt.Element = N, Jt.ForwardRef = O, Jt.Fragment = E, Jt.Lazy = I, Jt.Memo = k, Jt.Portal = M, Jt.Profiler = P, Jt.StrictMode = _, Jt.Suspense = D, Jt.SuspenseList = R, Jt.isAsyncMode = F, Jt.isConcurrentMode = j, Jt.isContextConsumer = A, Jt.isContextProvider = B, Jt.isElement = K, Jt.isForwardRef = Y, Jt.isFragment = G, Jt.isLazy = te, Jt.isMemo = ee, Jt.isPortal = oe, Jt.isProfiler = X, Jt.isStrictMode = W, Jt.isSuspense = re, Jt.isSuspenseList = Z, Jt.isValidElementType = S, Jt.typeOf = $;
  }()), Jt;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Aw() : e.exports = Bw();
})(zw);
function Pn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return le.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(Pn(r)) : yi.isFragment(r) && r.props ? n = n.concat(Pn(r.props.children, t)) : n.push(r));
  }), n;
}
var Eu = {}, tf = [], Hw = function(t) {
  tf.push(t);
};
function Br(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = tf.reduce(function(r, o) {
      return o(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function Vw(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = tf.reduce(function(r, o) {
      return o(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function Nh() {
  Eu = {};
}
function Ih(e, t, n) {
  !t && !Eu[n] && (e(!1, n), Eu[n] = !0);
}
function tt(e, t) {
  Ih(Br, e, t);
}
function Zl(e, t) {
  Ih(Vw, e, t);
}
tt.preMessage = Hw;
tt.resetWarned = Nh;
tt.noteOnce = Zl;
function mt(e) {
  return mt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mt(e);
}
function Ww(e, t) {
  if (mt(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (mt(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ph(e) {
  var t = Ww(e, "string");
  return mt(t) == "symbol" ? t : String(t);
}
function z(e, t, n) {
  return t = Ph(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Qm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function V(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qm(Object(n), !0).forEach(function(r) {
      z(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function es(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function ii(e) {
  return es(e) ? e : e instanceof le.Component ? $u.findDOMNode(e) : null;
}
function Fo(e, t, n) {
  var r = s.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function Ci(e, t) {
  typeof e == "function" ? e(t) : mt(e) === "object" && e && "current" in e && (e.current = t);
}
function Un() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(o) {
    return o;
  });
  return r.length <= 1 ? r[0] : function(o) {
    t.forEach(function(a) {
      Ci(a, o);
    });
  };
}
function Gr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Fo(function() {
    return Un.apply(void 0, t);
  }, t, function(r, o) {
    return r.length !== o.length || r.every(function(a, i) {
      return a !== o[i];
    });
  });
}
function Sr(e) {
  var t, n, r = yi.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
function Kw(e) {
  return !/* @__PURE__ */ Nw(e) || yi.isFragment(e) ? !1 : Sr(e);
}
var Ou = /* @__PURE__ */ s.createContext(null);
function qw(e) {
  var t = e.children, n = e.onBatchResize, r = s.useRef(0), o = s.useRef([]), a = s.useContext(Ou), i = s.useCallback(function(l, c, u) {
    r.current += 1;
    var d = r.current;
    o.current.push({
      size: l,
      element: c,
      data: u
    }), Promise.resolve().then(function() {
      d === r.current && (n == null || n(o.current), o.current = []);
    }), a == null || a(l, c, u);
  }, [n, a]);
  return /* @__PURE__ */ s.createElement(Ou.Provider, {
    value: i
  }, t);
}
var Rh = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(o, a) {
      return o[0] === n ? (r = a, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), o = this.__entries__[r];
        return o && o[1];
      }, t.prototype.set = function(n, r) {
        var o = e(this.__entries__, n);
        ~o ? this.__entries__[o][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, o = e(r, n);
        ~o && r.splice(o, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var o = 0, a = this.__entries__; o < a.length; o++) {
          var i = a[o];
          n.call(r, i[1], i[0]);
        }
      }, t;
    }()
  );
}(), Nu = typeof window < "u" && typeof document < "u" && window.document === document, ts = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Gw = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(ts) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), Uw = 2;
function Yw(e, t) {
  var n = !1, r = !1, o = 0;
  function a() {
    n && (n = !1, e()), r && l();
  }
  function i() {
    Gw(a);
  }
  function l() {
    var c = Date.now();
    if (n) {
      if (c - o < Uw)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(i, t);
    o = c;
  }
  return l;
}
var Xw = 20, Qw = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Jw = typeof MutationObserver < "u", Zw = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Yw(this.refresh.bind(this), Xw);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Nu || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Jw ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Nu || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, o = Qw.some(function(a) {
        return !!~r.indexOf(a);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), Mh = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var o = r[n];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, pa = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || ts;
}, Th = Os(0, 0, 0, 0);
function ns(e) {
  return parseFloat(e) || 0;
}
function Jm(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, o) {
    var a = e["border-" + o + "-width"];
    return r + ns(a);
  }, 0);
}
function eE(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, o = t; r < o.length; r++) {
    var a = o[r], i = e["padding-" + a];
    n[a] = ns(i);
  }
  return n;
}
function tE(e) {
  var t = e.getBBox();
  return Os(0, 0, t.width, t.height);
}
function nE(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return Th;
  var r = pa(e).getComputedStyle(e), o = eE(r), a = o.left + o.right, i = o.top + o.bottom, l = ns(r.width), c = ns(r.height);
  if (r.boxSizing === "border-box" && (Math.round(l + a) !== t && (l -= Jm(r, "left", "right") + a), Math.round(c + i) !== n && (c -= Jm(r, "top", "bottom") + i)), !oE(e)) {
    var u = Math.round(l + a) - t, d = Math.round(c + i) - n;
    Math.abs(u) !== 1 && (l -= u), Math.abs(d) !== 1 && (c -= d);
  }
  return Os(o.left, o.top, l, c);
}
var rE = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof pa(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof pa(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function oE(e) {
  return e === pa(e).document.documentElement;
}
function aE(e) {
  return Nu ? rE(e) ? tE(e) : nE(e) : Th;
}
function iE(e) {
  var t = e.x, n = e.y, r = e.width, o = e.height, a = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, i = Object.create(a.prototype);
  return Mh(i, {
    x: t,
    y: n,
    width: r,
    height: o,
    top: n,
    right: t + r,
    bottom: o + n,
    left: t
  }), i;
}
function Os(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var lE = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Os(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = aE(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), sE = (
  /** @class */
  function() {
    function e(t, n) {
      var r = iE(n);
      Mh(this, { target: t, contentRect: r });
    }
    return e;
  }()
), cE = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new Rh(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof pa(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new lE(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof pa(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new sE(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), _h = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Rh(), Dh = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = Zw.getInstance(), r = new cE(t, n, this);
      _h.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  Dh.prototype[e] = function() {
    var t;
    return (t = _h.get(this))[e].apply(t, arguments);
  };
});
var uE = function() {
  return typeof ts.ResizeObserver < "u" ? ts.ResizeObserver : Dh;
}(), zr = /* @__PURE__ */ new Map();
function kh(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = zr.get(r)) === null || n === void 0 || n.forEach(function(o) {
      return o(r);
    });
  });
}
var Lh = new uE(kh);
process.env.NODE_ENV;
process.env.NODE_ENV;
function dE(e, t) {
  zr.has(e) || (zr.set(e, /* @__PURE__ */ new Set()), Lh.observe(e)), zr.get(e).add(t);
}
function fE(e, t) {
  zr.has(e) && (zr.get(e).delete(t), zr.get(e).size || (Lh.unobserve(e), zr.delete(e)));
}
function $n(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Zm(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Ph(r.key), r);
  }
}
function wn(e, t, n) {
  return t && Zm(e.prototype, t), n && Zm(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Iu(e, t) {
  return Iu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Iu(e, t);
}
function wr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Iu(e, t);
}
function oo(e) {
  return oo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, oo(e);
}
function Ns() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ns = function() {
    return !!e;
  })();
}
function Me(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nf(e, t) {
  if (t && (mt(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Me(e);
}
function Ur(e) {
  var t = Ns();
  return function() {
    var r = oo(e), o;
    if (t) {
      var a = oo(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return nf(this, o);
  };
}
var mE = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n() {
    return $n(this, n), t.apply(this, arguments);
  }
  return wn(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(s.Component);
function vE(e, t) {
  var n = e.children, r = e.disabled, o = s.useRef(null), a = s.useRef(null), i = s.useContext(Ou), l = typeof n == "function", c = l ? n(o) : n, u = s.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), d = !l && /* @__PURE__ */ s.isValidElement(c) && Sr(c), f = d ? c.ref : null, m = Gr(f, o), v = function() {
    var b;
    return ii(o.current) || // Support `nativeElement` format
    (o.current && mt(o.current) === "object" ? ii((b = o.current) === null || b === void 0 ? void 0 : b.nativeElement) : null) || ii(a.current);
  };
  s.useImperativeHandle(t, function() {
    return v();
  });
  var h = s.useRef(e);
  h.current = e;
  var p = s.useCallback(function(g) {
    var b = h.current, y = b.onResize, C = b.data, S = g.getBoundingClientRect(), $ = S.width, x = S.height, w = g.offsetWidth, N = g.offsetHeight, O = Math.floor($), E = Math.floor(x);
    if (u.current.width !== O || u.current.height !== E || u.current.offsetWidth !== w || u.current.offsetHeight !== N) {
      var I = {
        width: O,
        height: E,
        offsetWidth: w,
        offsetHeight: N
      };
      u.current = I;
      var k = w === Math.round($) ? $ : w, M = N === Math.round(x) ? x : N, P = V(V({}, I), {}, {
        offsetWidth: k,
        offsetHeight: M
      });
      i == null || i(P, g, C), y && Promise.resolve().then(function() {
        y(P, g);
      });
    }
  }, []);
  return s.useEffect(function() {
    var g = v();
    return g && !r && dE(g, p), function() {
      return fE(g, p);
    };
  }, [o.current, r]), /* @__PURE__ */ s.createElement(mE, {
    ref: a
  }, d ? /* @__PURE__ */ s.cloneElement(c, {
    ref: m
  }) : c);
}
var Fh = /* @__PURE__ */ s.forwardRef(vE);
process.env.NODE_ENV !== "production" && (Fh.displayName = "SingleObserver");
var gE = "rc-observer-key";
function pE(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : Pn(n);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? Br(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && Br(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(o, a) {
    var i = (o == null ? void 0 : o.key) || "".concat(gE, "-").concat(a);
    return /* @__PURE__ */ s.createElement(Fh, fe({}, e, {
      key: i,
      ref: a === 0 ? t : void 0
    }), o);
  });
}
var Mn = /* @__PURE__ */ s.forwardRef(pE);
process.env.NODE_ENV !== "production" && (Mn.displayName = "ResizeObserver");
Mn.Collection = qw;
function an(e, t) {
  var n = V({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function Pu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function hE(e) {
  if (Array.isArray(e))
    return Pu(e);
}
function jh(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function rf(e, t) {
  if (e) {
    if (typeof e == "string")
      return Pu(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Pu(e, t);
  }
}
function bE() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function be(e) {
  return hE(e) || jh(e) || rf(e) || bE();
}
var zh = function(t) {
  return +setTimeout(t, 16);
}, Ah = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (zh = function(t) {
  return window.requestAnimationFrame(t);
}, Ah = function(t) {
  return window.cancelAnimationFrame(t);
});
var ev = 0, Is = /* @__PURE__ */ new Map();
function Bh(e) {
  Is.delete(e);
}
var _t = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  ev += 1;
  var r = ev;
  function o(a) {
    if (a === 0)
      Bh(r), t();
    else {
      var i = zh(function() {
        o(a - 1);
      });
      Is.set(r, i);
    }
  }
  return o(n), r;
};
_t.cancel = function(e) {
  var t = Is.get(e);
  return Bh(e), Ah(t);
};
process.env.NODE_ENV !== "production" && (_t.ids = function() {
  return Is;
});
function Hh(e) {
  if (Array.isArray(e))
    return e;
}
function yE(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, a, i, l = [], c = !0, u = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (r = a.call(n)).done) && (l.push(r.value), l.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, o = d;
    } finally {
      try {
        if (!c && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (u)
          throw o;
      }
    }
    return l;
  }
}
function Vh() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q(e, t) {
  return Hh(e) || yE(e, t) || rf(e, t) || Vh();
}
function rs(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function pn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Ru(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var tv = "data-rc-order", nv = "data-rc-priority", CE = "rc-util-key", Mu = /* @__PURE__ */ new Map();
function Wh() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : CE;
}
function Ps(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function SE(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function Kh(e) {
  return Array.from((Mu.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function qh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!pn())
    return null;
  var n = t.csp, r = t.prepend, o = t.priority, a = o === void 0 ? 0 : o, i = SE(r), l = i === "prependQueue", c = document.createElement("style");
  c.setAttribute(tv, i), l && a && c.setAttribute(nv, "".concat(a)), n != null && n.nonce && (c.nonce = n == null ? void 0 : n.nonce), c.innerHTML = e;
  var u = Ps(t), d = u.firstChild;
  if (r) {
    if (l) {
      var f = Kh(u).filter(function(m) {
        if (!["prepend", "prependQueue"].includes(m.getAttribute(tv)))
          return !1;
        var v = Number(m.getAttribute(nv) || 0);
        return a >= v;
      });
      if (f.length)
        return u.insertBefore(c, f[f.length - 1].nextSibling), c;
    }
    u.insertBefore(c, d);
  } else
    u.appendChild(c);
  return c;
}
function Gh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Ps(t);
  return Kh(n).find(function(r) {
    return r.getAttribute(Wh(t)) === e;
  });
}
function Si(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Gh(e, t);
  if (n) {
    var r = Ps(t);
    r.removeChild(n);
  }
}
function xE(e, t) {
  var n = Mu.get(e);
  if (!n || !Ru(document, n)) {
    var r = qh("", t), o = r.parentNode;
    Mu.set(e, o), e.removeChild(r);
  }
}
function ao(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Ps(n);
  xE(r, n);
  var o = Gh(t, n);
  if (o) {
    var a, i;
    if ((a = n.csp) !== null && a !== void 0 && a.nonce && o.nonce !== ((i = n.csp) === null || i === void 0 ? void 0 : i.nonce)) {
      var l;
      o.nonce = (l = n.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return o.innerHTML !== e && (o.innerHTML = e), o;
  }
  var c = qh(e, n);
  return c.setAttribute(Wh(n), t), c;
}
function $E(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function vt(e, t) {
  if (e == null)
    return {};
  var n = $E(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Hr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function o(a, i) {
    var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, c = r.has(a);
    if (tt(!c, "Warning: There may be circular references"), c)
      return !1;
    if (a === i)
      return !0;
    if (n && l > 1)
      return !1;
    r.add(a);
    var u = l + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(i) || a.length !== i.length)
        return !1;
      for (var d = 0; d < a.length; d++)
        if (!o(a[d], i[d], u))
          return !1;
      return !0;
    }
    if (a && i && mt(a) === "object" && mt(i) === "object") {
      var f = Object.keys(a);
      return f.length !== Object.keys(i).length ? !1 : f.every(function(m) {
        return o(a[m], i[m], u);
      });
    }
    return !1;
  }
  return o(e, t);
}
var wE = "%";
function Tu(e) {
  return e.join(wE);
}
var EE = /* @__PURE__ */ function() {
  function e(t) {
    $n(this, e), z(this, "instanceId", void 0), z(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return wn(e, [{
    key: "get",
    value: function(n) {
      return this.opGet(Tu(n));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(n) {
      return this.cache.get(n) || null;
    }
  }, {
    key: "update",
    value: function(n, r) {
      return this.opUpdate(Tu(n), r);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(n, r) {
      var o = this.cache.get(n), a = r(o);
      a === null ? this.cache.delete(n) : this.cache.set(n, a);
    }
  }]), e;
}(), ha = "data-token-hash", br = "data-css-hash", OE = "data-cache-path", eo = "__cssinjs_instance__";
function NE() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(br, "]")) || [], n = document.head.firstChild;
    Array.from(t).forEach(function(o) {
      o[eo] = o[eo] || e, o[eo] === e && document.head.insertBefore(o, n);
    });
    var r = {};
    Array.from(document.querySelectorAll("style[".concat(br, "]"))).forEach(function(o) {
      var a = o.getAttribute(br);
      if (r[a]) {
        if (o[eo] === e) {
          var i;
          (i = o.parentNode) === null || i === void 0 || i.removeChild(o);
        }
      } else
        r[a] = !0;
    });
  }
  return new EE(e);
}
var Rs = /* @__PURE__ */ s.createContext({
  hashPriority: "low",
  cache: NE(),
  defaultCache: !0
});
function IE(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var of = /* @__PURE__ */ function() {
  function e() {
    $n(this, e), z(this, "cache", void 0), z(this, "keys", void 0), z(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return wn(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(n) {
      var r, o, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = {
        map: this.cache
      };
      return n.forEach(function(l) {
        if (!i)
          i = void 0;
        else {
          var c;
          i = (c = i) === null || c === void 0 || (c = c.map) === null || c === void 0 ? void 0 : c.get(l);
        }
      }), (r = i) !== null && r !== void 0 && r.value && a && (i.value[1] = this.cacheCallTimes++), (o = i) === null || o === void 0 ? void 0 : o.value;
    }
  }, {
    key: "get",
    value: function(n) {
      var r;
      return (r = this.internalGet(n, !0)) === null || r === void 0 ? void 0 : r[0];
    }
  }, {
    key: "has",
    value: function(n) {
      return !!this.internalGet(n);
    }
  }, {
    key: "set",
    value: function(n, r) {
      var o = this;
      if (!this.has(n)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var a = this.keys.reduce(function(u, d) {
            var f = Q(u, 2), m = f[1];
            return o.internalGet(d)[1] < m ? [d, o.internalGet(d)[1]] : u;
          }, [this.keys[0], this.cacheCallTimes]), i = Q(a, 1), l = i[0];
          this.delete(l);
        }
        this.keys.push(n);
      }
      var c = this.cache;
      n.forEach(function(u, d) {
        if (d === n.length - 1)
          c.set(u, {
            value: [r, o.cacheCallTimes++]
          });
        else {
          var f = c.get(u);
          f ? f.map || (f.map = /* @__PURE__ */ new Map()) : c.set(u, {
            map: /* @__PURE__ */ new Map()
          }), c = c.get(u).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(n, r) {
      var o = n.get(r[0]);
      if (r.length === 1) {
        var a;
        return o.map ? n.set(r[0], {
          map: o.map
        }) : n.delete(r[0]), (a = o.value) === null || a === void 0 ? void 0 : a[0];
      }
      var i = this.deleteByPath(o.map, r.slice(1));
      return (!o.map || o.map.size === 0) && !o.value && n.delete(r[0]), i;
    }
  }, {
    key: "delete",
    value: function(n) {
      if (this.has(n))
        return this.keys = this.keys.filter(function(r) {
          return !IE(r, n);
        }), this.deleteByPath(this.cache, n);
    }
  }]), e;
}();
z(of, "MAX_CACHE_SIZE", 20);
z(of, "MAX_CACHE_OFFSET", 5);
var rv = 0, Uh = /* @__PURE__ */ function() {
  function e(t) {
    $n(this, e), z(this, "derivatives", void 0), z(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = rv, t.length === 0 && Br(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), rv += 1;
  }
  return wn(e, [{
    key: "getDerivativeToken",
    value: function(n) {
      return this.derivatives.reduce(function(r, o) {
        return o(n, r);
      }, void 0);
    }
  }]), e;
}(), Oc = new of();
function _u(e) {
  var t = Array.isArray(e) ? e : [e];
  return Oc.has(t) || Oc.set(t, new Uh(t)), Oc.get(t);
}
var PE = /* @__PURE__ */ new WeakMap(), Nc = {};
function RE(e, t) {
  for (var n = PE, r = 0; r < t.length; r += 1) {
    var o = t[r];
    n.has(o) || n.set(o, /* @__PURE__ */ new WeakMap()), n = n.get(o);
  }
  return n.has(Nc) || n.set(Nc, e()), n.get(Nc);
}
var ov = /* @__PURE__ */ new WeakMap();
function li(e) {
  var t = ov.get(e) || "";
  return t || (Object.keys(e).forEach(function(n) {
    var r = e[n];
    t += n, r instanceof Uh ? t += r.id : r && mt(r) === "object" ? t += li(r) : t += r;
  }), ov.set(e, t)), t;
}
function av(e, t) {
  return rs("".concat(t, "_").concat(li(e)));
}
var si = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, ""), Yh = "_bAmBoO_";
function ME(e, t, n) {
  if (pn()) {
    var r, o;
    ao(e, si);
    var a = document.createElement("div");
    a.style.position = "fixed", a.style.left = "0", a.style.top = "0", t == null || t(a), document.body.appendChild(a), process.env.NODE_ENV !== "production" && (a.innerHTML = "Test", a.style.zIndex = "9999999");
    var i = n ? n(a) : (r = getComputedStyle(a).content) === null || r === void 0 ? void 0 : r.includes(Yh);
    return (o = a.parentNode) === null || o === void 0 || o.removeChild(a), Si(si), i;
  }
  return !1;
}
var Ic = void 0;
function TE() {
  return Ic === void 0 && (Ic = ME("@layer ".concat(si, " { .").concat(si, ' { content: "').concat(Yh, '"!important; } }'), function(e) {
    e.className = si;
  })), Ic;
}
var Du = pn();
function q(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function os(e, t, n) {
  var r, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (a)
    return e;
  var i = V(V({}, o), {}, (r = {}, z(r, ha, t), z(r, br, n), r)), l = Object.keys(i).map(function(c) {
    var u = i[c];
    return u ? "".concat(c, '="').concat(u, '"') : null;
  }).filter(function(c) {
    return c;
  }).join(" ");
  return "<style ".concat(l, ">").concat(e, "</style>");
}
var Xh = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(n ? "".concat(n, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, _E = function(t, n, r) {
  return Object.keys(t).length ? ".".concat(n).concat(r != null && r.scope ? ".".concat(r.scope) : "", "{").concat(Object.entries(t).map(function(o) {
    var a = Q(o, 2), i = a[0], l = a[1];
    return "".concat(i, ":").concat(l, ";");
  }).join(""), "}") : "";
}, Qh = function(t, n, r) {
  var o = {}, a = {};
  return Object.entries(t).forEach(function(i) {
    var l, c, u = Q(i, 2), d = u[0], f = u[1];
    if (r != null && (l = r.preserve) !== null && l !== void 0 && l[d])
      a[d] = f;
    else if ((typeof f == "string" || typeof f == "number") && !(r != null && (c = r.ignore) !== null && c !== void 0 && c[d])) {
      var m, v = Xh(d, r == null ? void 0 : r.prefix);
      o[v] = typeof f == "number" && !(r != null && (m = r.unitless) !== null && m !== void 0 && m[d]) ? "".concat(f, "px") : String(f), a[d] = "var(".concat(v, ")");
    }
  }), [a, _E(o, n, {
    scope: r == null ? void 0 : r.scope
  })];
}, iv = process.env.NODE_ENV !== "test" && pn() ? s.useLayoutEffect : s.useEffect, Pt = function(t, n) {
  var r = s.useRef(!0);
  iv(function() {
    return t(r.current);
  }, n), iv(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, as = function(t, n) {
  Pt(function(r) {
    if (!r)
      return t();
  }, n);
}, DE = V({}, s), lv = DE.useInsertionEffect, kE = function(t, n, r) {
  s.useMemo(t, r), Pt(function() {
    return n(!0);
  }, r);
}, LE = lv ? function(e, t, n) {
  return lv(function() {
    return e(), t();
  }, n);
} : kE, FE = V({}, s), jE = FE.useInsertionEffect, zE = function(t) {
  var n = [], r = !1;
  function o(a) {
    if (r) {
      process.env.NODE_ENV !== "production" && Br(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    n.push(a);
  }
  return s.useEffect(function() {
    return r = !1, function() {
      r = !0, n.length && n.forEach(function(a) {
        return a();
      });
    };
  }, t), o;
}, AE = function() {
  return function(t) {
    t();
  };
}, BE = typeof jE < "u" ? zE : AE;
function HE() {
  return !1;
}
var ku = !1;
function VE() {
  return ku;
}
const WE = process.env.NODE_ENV === "production" ? HE : VE;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var Pc = window;
  if (typeof Pc.webpackHotUpdate == "function") {
    var KE = Pc.webpackHotUpdate;
    Pc.webpackHotUpdate = function() {
      return ku = !0, setTimeout(function() {
        ku = !1;
      }, 0), KE.apply(void 0, arguments);
    };
  }
}
function af(e, t, n, r, o) {
  var a = s.useContext(Rs), i = a.cache, l = [e].concat(be(t)), c = Tu(l), u = BE([c]), d = WE(), f = function(p) {
    i.opUpdate(c, function(g) {
      var b = g || [void 0, void 0], y = Q(b, 2), C = y[0], S = C === void 0 ? 0 : C, $ = y[1], x = $;
      process.env.NODE_ENV !== "production" && $ && d && (r == null || r(x, d), x = null);
      var w = x || n(), N = [S, w];
      return p ? p(N) : N;
    });
  };
  s.useMemo(
    function() {
      f();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [c]
    /* eslint-enable */
  );
  var m = i.opGet(c);
  process.env.NODE_ENV !== "production" && !m && (f(), m = i.opGet(c));
  var v = m[1];
  return LE(function() {
    o == null || o(v);
  }, function(h) {
    return f(function(p) {
      var g = Q(p, 2), b = g[0], y = g[1];
      return h && b === 0 && (o == null || o(v)), [b + 1, y];
    }), function() {
      i.opUpdate(c, function(p) {
        var g = p || [], b = Q(g, 2), y = b[0], C = y === void 0 ? 0 : y, S = b[1], $ = C - 1;
        return $ === 0 ? (u(function() {
          (h || !i.opGet(c)) && (r == null || r(S, !1));
        }), null) : [C - 1, S];
      });
    };
  }, [c]), v;
}
var qE = {}, GE = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", xo = /* @__PURE__ */ new Map();
function UE(e) {
  xo.set(e, (xo.get(e) || 0) + 1);
}
function YE(e, t) {
  if (typeof document < "u") {
    var n = document.querySelectorAll("style[".concat(ha, '="').concat(e, '"]'));
    n.forEach(function(r) {
      if (r[eo] === t) {
        var o;
        (o = r.parentNode) === null || o === void 0 || o.removeChild(r);
      }
    });
  }
}
var XE = 0;
function QE(e, t) {
  xo.set(e, (xo.get(e) || 0) - 1);
  var n = Array.from(xo.keys()), r = n.filter(function(o) {
    var a = xo.get(o) || 0;
    return a <= 0;
  });
  n.length - r.length > XE && r.forEach(function(o) {
    YE(o, t), xo.delete(o);
  });
}
var JE = function(t, n, r, o) {
  var a = r.getDerivativeToken(t), i = V(V({}, a), n);
  return o && (i = o(i)), i;
}, Jh = "token";
function ZE(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = qt(Rs), o = r.cache.instanceId, a = r.container, i = n.salt, l = i === void 0 ? "" : i, c = n.override, u = c === void 0 ? qE : c, d = n.formatToken, f = n.getComputedToken, m = n.cssVar, v = RE(function() {
    return Object.assign.apply(Object, [{}].concat(be(t)));
  }, t), h = li(v), p = li(u), g = m ? li(m) : "", b = af(Jh, [l, e.id, h, p, g], function() {
    var y, C = f ? f(v, u, e) : JE(v, u, e, d), S = V({}, C), $ = "";
    if (m) {
      var x = Qh(C, m.key, {
        prefix: m.prefix,
        ignore: m.ignore,
        unitless: m.unitless,
        preserve: m.preserve
      }), w = Q(x, 2);
      C = w[0], $ = w[1];
    }
    var N = av(C, l);
    C._tokenKey = N, S._tokenKey = av(S, l);
    var O = (y = m == null ? void 0 : m.key) !== null && y !== void 0 ? y : N;
    C._themeKey = O, UE(O);
    var E = "".concat(GE, "-").concat(rs(N));
    return C._hashId = E, [C, E, S, $, (m == null ? void 0 : m.key) || ""];
  }, function(y) {
    QE(y[0]._themeKey, o);
  }, function(y) {
    var C = Q(y, 4), S = C[0], $ = C[3];
    if (m && $) {
      var x = ao($, rs("css-variables-".concat(S._themeKey)), {
        mark: br,
        prepend: "queue",
        attachTo: a,
        priority: -999
      });
      x[eo] = o, x.setAttribute(ha, S._themeKey);
    }
  });
  return b;
}
var e1 = function(t, n, r) {
  var o = Q(t, 5), a = o[2], i = o[3], l = o[4], c = r || {}, u = c.plain;
  if (!i)
    return null;
  var d = a._tokenKey, f = -999, m = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(f)
  }, v = os(i, l, d, m, u);
  return [f, d, v];
}, t1 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Zh = "comm", eb = "rule", tb = "decl", n1 = "@import", r1 = "@keyframes", o1 = "@layer", nb = Math.abs, lf = String.fromCharCode;
function rb(e) {
  return e.trim();
}
function jl(e, t, n) {
  return e.replace(t, n);
}
function a1(e, t, n) {
  return e.indexOf(t, n);
}
function xi(e, t) {
  return e.charCodeAt(t) | 0;
}
function $i(e, t, n) {
  return e.slice(t, n);
}
function jr(e) {
  return e.length;
}
function i1(e) {
  return e.length;
}
function cl(e, t) {
  return t.push(e), e;
}
var Ms = 1, ba = 1, ob = 0, cr = 0, Cn = 0, Na = "";
function sf(e, t, n, r, o, a, i, l) {
  return { value: e, root: t, parent: n, type: r, props: o, children: a, line: Ms, column: ba, length: i, return: "", siblings: l };
}
function l1() {
  return Cn;
}
function s1() {
  return Cn = cr > 0 ? xi(Na, --cr) : 0, ba--, Cn === 10 && (ba = 1, Ms--), Cn;
}
function yr() {
  return Cn = cr < ob ? xi(Na, cr++) : 0, ba++, Cn === 10 && (ba = 1, Ms++), Cn;
}
function Io() {
  return xi(Na, cr);
}
function zl() {
  return cr;
}
function Ts(e, t) {
  return $i(Na, e, t);
}
function Lu(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function c1(e) {
  return Ms = ba = 1, ob = jr(Na = e), cr = 0, [];
}
function u1(e) {
  return Na = "", e;
}
function Rc(e) {
  return rb(Ts(cr - 1, Fu(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function d1(e) {
  for (; (Cn = Io()) && Cn < 33; )
    yr();
  return Lu(e) > 2 || Lu(Cn) > 3 ? "" : " ";
}
function f1(e, t) {
  for (; --t && yr() && !(Cn < 48 || Cn > 102 || Cn > 57 && Cn < 65 || Cn > 70 && Cn < 97); )
    ;
  return Ts(e, zl() + (t < 6 && Io() == 32 && yr() == 32));
}
function Fu(e) {
  for (; yr(); )
    switch (Cn) {
      case e:
        return cr;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Fu(Cn);
        break;
      case 40:
        e === 41 && Fu(e);
        break;
      case 92:
        yr();
        break;
    }
  return cr;
}
function m1(e, t) {
  for (; yr() && e + Cn !== 47 + 10; )
    if (e + Cn === 42 + 42 && Io() === 47)
      break;
  return "/*" + Ts(t, cr - 1) + "*" + lf(e === 47 ? e : yr());
}
function v1(e) {
  for (; !Lu(Io()); )
    yr();
  return Ts(e, cr);
}
function g1(e) {
  return u1(Al("", null, null, null, [""], e = c1(e), 0, [0], e));
}
function Al(e, t, n, r, o, a, i, l, c) {
  for (var u = 0, d = 0, f = i, m = 0, v = 0, h = 0, p = 1, g = 1, b = 1, y = 0, C = "", S = o, $ = a, x = r, w = C; g; )
    switch (h = y, y = yr()) {
      case 40:
        if (h != 108 && xi(w, f - 1) == 58) {
          a1(w += jl(Rc(y), "&", "&\f"), "&\f", nb(u ? l[u - 1] : 0)) != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        w += Rc(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        w += d1(h);
        break;
      case 92:
        w += f1(zl() - 1, 7);
        continue;
      case 47:
        switch (Io()) {
          case 42:
          case 47:
            cl(p1(m1(yr(), zl()), t, n, c), c);
            break;
          default:
            w += "/";
        }
        break;
      case 123 * p:
        l[u++] = jr(w) * b;
      case 125 * p:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            g = 0;
          case 59 + d:
            b == -1 && (w = jl(w, /\f/g, "")), v > 0 && jr(w) - f && cl(v > 32 ? cv(w + ";", r, n, f - 1, c) : cv(jl(w, " ", "") + ";", r, n, f - 2, c), c);
            break;
          case 59:
            w += ";";
          default:
            if (cl(x = sv(w, t, n, u, d, o, l, C, S = [], $ = [], f, a), a), y === 123)
              if (d === 0)
                Al(w, t, x, x, S, a, f, l, $);
              else
                switch (m === 99 && xi(w, 3) === 110 ? 100 : m) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Al(e, x, x, r && cl(sv(e, x, x, 0, 0, o, l, C, o, S = [], f, $), $), o, $, f, l, r ? S : $);
                    break;
                  default:
                    Al(w, x, x, x, [""], $, 0, l, $);
                }
        }
        u = d = v = 0, p = b = 1, C = w = "", f = i;
        break;
      case 58:
        f = 1 + jr(w), v = h;
      default:
        if (p < 1) {
          if (y == 123)
            --p;
          else if (y == 125 && p++ == 0 && s1() == 125)
            continue;
        }
        switch (w += lf(y), y * p) {
          case 38:
            b = d > 0 ? 1 : (w += "\f", -1);
            break;
          case 44:
            l[u++] = (jr(w) - 1) * b, b = 1;
            break;
          case 64:
            Io() === 45 && (w += Rc(yr())), m = Io(), d = f = jr(C = w += v1(zl())), y++;
            break;
          case 45:
            h === 45 && jr(w) == 2 && (p = 0);
        }
    }
  return a;
}
function sv(e, t, n, r, o, a, i, l, c, u, d, f) {
  for (var m = o - 1, v = o === 0 ? a : [""], h = i1(v), p = 0, g = 0, b = 0; p < r; ++p)
    for (var y = 0, C = $i(e, m + 1, m = nb(g = i[p])), S = e; y < h; ++y)
      (S = rb(g > 0 ? v[y] + " " + C : jl(C, /&\f/g, v[y]))) && (c[b++] = S);
  return sf(e, t, n, o === 0 ? eb : l, c, u, d, f);
}
function p1(e, t, n, r) {
  return sf(e, t, n, Zh, lf(l1()), $i(e, 2, -2), 0, r);
}
function cv(e, t, n, r, o) {
  return sf(e, t, n, tb, $i(e, 0, r), $i(e, r + 1, -1), r, o);
}
function ju(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function h1(e, t, n, r) {
  switch (e.type) {
    case o1:
      if (e.children.length)
        break;
    case n1:
    case tb:
      return e.return = e.return || e.value;
    case Zh:
      return "";
    case r1:
      return e.return = e.value + "{" + ju(e.children, r) + "}";
    case eb:
      if (!jr(e.value = e.props.join(",")))
        return "";
  }
  return jr(n = ju(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function ab(e, t) {
  var n = t.path, r = t.parentSelectors;
  tt(!1, "[Ant Design CSS-in-JS] ".concat(n ? "Error in ".concat(n, ": ") : "").concat(e).concat(r.length ? " Selector: ".concat(r.join(" | ")) : ""));
}
var b1 = function(t, n, r) {
  if (t === "content") {
    var o = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, a = ["normal", "none", "initial", "inherit", "unset"];
    (typeof n != "string" || a.indexOf(n) === -1 && !o.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")) && ab("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(n, "\"'`."), r);
  }
}, y1 = function(t, n, r) {
  t === "animation" && r.hashId && n !== "none" && ab("You seem to be using hashed animation '".concat(n, "', in which case 'animationName' with Keyframe as value is recommended."), r);
}, uv = "data-ant-cssinjs-cache-path", ib = "_FILE_STYLE__", Po, lb = !0;
function C1() {
  if (!Po && (Po = {}, pn())) {
    var e = document.createElement("div");
    e.className = uv, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(o) {
      var a = o.split(":"), i = Q(a, 2), l = i[0], c = i[1];
      Po[l] = c;
    });
    var n = document.querySelector("style[".concat(uv, "]"));
    if (n) {
      var r;
      lb = !1, (r = n.parentNode) === null || r === void 0 || r.removeChild(n);
    }
    document.body.removeChild(e);
  }
}
function S1(e) {
  return C1(), !!Po[e];
}
function x1(e) {
  var t = Po[e], n = null;
  if (t && pn())
    if (lb)
      n = ib;
    else {
      var r = document.querySelector("style[".concat(br, '="').concat(Po[e], '"]'));
      r ? n = r.innerHTML : delete Po[e];
    }
  return [n, t];
}
var sb = "_skip_check_", cb = "_multi_value_";
function zu(e) {
  var t = ju(g1(e), h1);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function $1(e) {
  return mt(e) === "object" && e && (sb in e || cb in e);
}
function w1(e, t, n) {
  if (!t)
    return e;
  var r = ".".concat(t), o = n === "low" ? ":where(".concat(r, ")") : r, a = e.split(",").map(function(i) {
    var l, c = i.trim().split(/\s+/), u = c[0] || "", d = ((l = u.match(/^\w+/)) === null || l === void 0 ? void 0 : l[0]) || "";
    return u = "".concat(d).concat(o).concat(u.slice(d.length)), [u].concat(be(c.slice(1))).join(" ");
  });
  return a.join(",");
}
var E1 = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, o = r.root, a = r.injectHash, i = r.parentSelectors, l = n.hashId, c = n.layer, u = n.path, d = n.hashPriority, f = n.transformers, m = f === void 0 ? [] : f, v = n.linters, h = v === void 0 ? [] : v, p = "", g = {};
  function b(x) {
    var w = x.getName(l);
    if (!g[w]) {
      var N = e(x.style, n, {
        root: !1,
        parentSelectors: i
      }), O = Q(N, 1), E = O[0];
      g[w] = "@keyframes ".concat(x.getName(l)).concat(E);
    }
  }
  function y(x) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return x.forEach(function(N) {
      Array.isArray(N) ? y(N, w) : N && w.push(N);
    }), w;
  }
  var C = y(Array.isArray(t) ? t : [t]);
  if (C.forEach(function(x) {
    var w = typeof x == "string" && !o ? {} : x;
    if (typeof w == "string")
      p += "".concat(w, `
`);
    else if (w._keyframe)
      b(w);
    else {
      var N = m.reduce(function(O, E) {
        var I;
        return (E == null || (I = E.visit) === null || I === void 0 ? void 0 : I.call(E, O)) || O;
      }, w);
      Object.keys(N).forEach(function(O) {
        var E = N[O];
        if (mt(E) === "object" && E && (O !== "animationName" || !E._keyframe) && !$1(E)) {
          var I = !1, k = O.trim(), M = !1;
          (o || a) && l ? k.startsWith("@") ? I = !0 : k = w1(O, l, d) : o && !l && (k === "&" || k === "") && (k = "", M = !0);
          var P = e(E, n, {
            root: M,
            injectHash: I,
            parentSelectors: [].concat(be(i), [k])
          }), _ = Q(P, 2), D = _[0], R = _[1];
          g = V(V({}, g), R), p += "".concat(k).concat(D);
        } else {
          let F = function(j, A) {
            process.env.NODE_ENV !== "production" && (mt(E) !== "object" || !(E != null && E[sb])) && [b1, y1].concat(be(h)).forEach(function(Y) {
              return Y(j, A, {
                path: u,
                hashId: l,
                parentSelectors: i
              });
            });
            var B = j.replace(/[A-Z]/g, function(Y) {
              return "-".concat(Y.toLowerCase());
            }), K = A;
            !t1[j] && typeof K == "number" && K !== 0 && (K = "".concat(K, "px")), j === "animationName" && A !== null && A !== void 0 && A._keyframe && (b(A), K = A.getName(l)), p += "".concat(B, ":").concat(K, ";");
          };
          var T, L = (T = E == null ? void 0 : E.value) !== null && T !== void 0 ? T : E;
          mt(E) === "object" && E !== null && E !== void 0 && E[cb] && Array.isArray(L) ? L.forEach(function(j) {
            F(O, j);
          }) : F(O, L);
        }
      });
    }
  }), !o)
    p = "{".concat(p, "}");
  else if (c && TE()) {
    var S = c.split(","), $ = S[S.length - 1].trim();
    p = "@layer ".concat($, " {").concat(p, "}"), S.length > 1 && (p = "@layer ".concat(c, "{%%%:%}").concat(p));
  }
  return [p, g];
};
function ub(e, t) {
  return rs("".concat(e.join("%")).concat(t));
}
function O1() {
  return null;
}
var db = "style";
function Au(e, t) {
  var n = e.token, r = e.path, o = e.hashId, a = e.layer, i = e.nonce, l = e.clientOnly, c = e.order, u = c === void 0 ? 0 : c, d = s.useContext(Rs), f = d.autoClear, m = d.mock, v = d.defaultCache, h = d.hashPriority, p = d.container, g = d.ssrInline, b = d.transformers, y = d.linters, C = d.cache, S = n._tokenKey, $ = [S].concat(be(r)), x = Du;
  process.env.NODE_ENV !== "production" && m !== void 0 && (x = m === "client");
  var w = af(
    db,
    $,
    // Create cache if needed
    function() {
      var k = $.join("|");
      if (S1(k)) {
        var M = x1(k), P = Q(M, 2), _ = P[0], D = P[1];
        if (_)
          return [_, S, D, {}, l, u];
      }
      var R = t(), T = E1(R, {
        hashId: o,
        hashPriority: h,
        layer: a,
        path: r.join("-"),
        transformers: b,
        linters: y
      }), L = Q(T, 2), F = L[0], j = L[1], A = zu(F), B = ub($, A);
      return [A, S, B, j, l, u];
    },
    // Remove cache if no need
    function(k, M) {
      var P = Q(k, 3), _ = P[2];
      (M || f) && Du && Si(_, {
        mark: br
      });
    },
    // Effect: Inject style here
    function(k) {
      var M = Q(k, 4), P = M[0];
      M[1];
      var _ = M[2], D = M[3];
      if (x && P !== ib) {
        var R = {
          mark: br,
          prepend: "queue",
          attachTo: p,
          priority: u
        }, T = typeof i == "function" ? i() : i;
        T && (R.csp = {
          nonce: T
        });
        var L = ao(P, _, R);
        L[eo] = C.instanceId, L.setAttribute(ha, S), process.env.NODE_ENV !== "production" && L.setAttribute(OE, $.join("|")), Object.keys(D).forEach(function(F) {
          ao(zu(D[F]), "_effect-".concat(F), R);
        });
      }
    }
  ), N = Q(w, 3), O = N[0], E = N[1], I = N[2];
  return function(k) {
    var M;
    if (!g || x || !v)
      M = /* @__PURE__ */ s.createElement(O1, null);
    else {
      var P;
      M = /* @__PURE__ */ s.createElement("style", fe({}, (P = {}, z(P, ha, E), z(P, br, I), P), {
        dangerouslySetInnerHTML: {
          __html: O
        }
      }));
    }
    return /* @__PURE__ */ s.createElement(s.Fragment, null, M, k);
  };
}
var N1 = function(t, n, r) {
  var o = Q(t, 6), a = o[0], i = o[1], l = o[2], c = o[3], u = o[4], d = o[5], f = r || {}, m = f.plain;
  if (u)
    return null;
  var v = a, h = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  };
  return v = os(a, i, l, h, m), c && Object.keys(c).forEach(function(p) {
    if (!n[p]) {
      n[p] = !0;
      var g = zu(c[p]);
      v += os(g, i, "_effect-".concat(p), h, m);
    }
  }), [d, l, v];
}, fb = "cssVar", I1 = function(t, n) {
  var r = t.key, o = t.prefix, a = t.unitless, i = t.ignore, l = t.token, c = t.scope, u = c === void 0 ? "" : c, d = qt(Rs), f = d.cache.instanceId, m = d.container, v = l._tokenKey, h = [].concat(be(t.path), [r, u, v]), p = af(fb, h, function() {
    var g = n(), b = Qh(g, r, {
      prefix: o,
      unitless: a,
      ignore: i,
      scope: u
    }), y = Q(b, 2), C = y[0], S = y[1], $ = ub(h, S);
    return [C, S, $, r];
  }, function(g) {
    var b = Q(g, 3), y = b[2];
    Du && Si(y, {
      mark: br
    });
  }, function(g) {
    var b = Q(g, 3), y = b[1], C = b[2];
    if (y) {
      var S = ao(y, C, {
        mark: br,
        prepend: "queue",
        attachTo: m,
        priority: -999
      });
      S[eo] = f, S.setAttribute(ha, r);
    }
  });
  return p;
}, P1 = function(t, n, r) {
  var o = Q(t, 4), a = o[1], i = o[2], l = o[3], c = r || {}, u = c.plain;
  if (!a)
    return null;
  var d = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, m = os(a, l, i, f, u);
  return [d, i, m];
}, Ba;
Ba = {}, z(Ba, db, N1), z(Ba, Jh, e1), z(Ba, fb, P1);
var kt = /* @__PURE__ */ function() {
  function e(t, n) {
    $n(this, e), z(this, "name", void 0), z(this, "style", void 0), z(this, "_keyframe", !0), this.name = t, this.style = n;
  }
  return wn(e, [{
    key: "getName",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return n ? "".concat(n, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function Uo(e) {
  return e.notSplit = !0, e;
}
Uo(["borderTop", "borderBottom"]), Uo(["borderTop"]), Uo(["borderBottom"]), Uo(["borderLeft", "borderRight"]), Uo(["borderLeft"]), Uo(["borderRight"]);
var R1 = /* @__PURE__ */ uo({});
const cf = R1;
function mb(e) {
  return Hh(e) || jh(e) || rf(e) || Vh();
}
function nr(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function vb(e, t, n, r) {
  if (!t.length)
    return n;
  var o = mb(t), a = o[0], i = o.slice(1), l;
  return !e && typeof a == "number" ? l = [] : Array.isArray(e) ? l = be(e) : l = V({}, e), r && n === void 0 && i.length === 1 ? delete l[a][i[0]] : l[a] = vb(l[a], i, n, r), l;
}
function gr(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !nr(e, t.slice(0, -1)) ? e : vb(e, t, n, r);
}
function M1(e) {
  return mt(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function dv(e) {
  return Array.isArray(e) ? [] : {};
}
var T1 = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function ca() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = dv(t[0]);
  return t.forEach(function(o) {
    function a(i, l) {
      var c = new Set(l), u = nr(o, i), d = Array.isArray(u);
      if (d || M1(u)) {
        if (!c.has(u)) {
          c.add(u);
          var f = nr(r, i);
          d ? r = gr(r, i, []) : (!f || mt(f) !== "object") && (r = gr(r, i, dv(u))), T1(u).forEach(function(m) {
            a([].concat(be(i), [m]), c);
          });
        }
      } else
        r = gr(r, i, u);
    }
    a([]);
  }), r;
}
function gb() {
}
let kr = null;
function _1() {
  kr = null, Nh();
}
let uf = gb;
process.env.NODE_ENV !== "production" && (uf = (e, t, n) => {
  tt(e, `[antd: ${t}] ${n}`), process.env.NODE_ENV === "test" && _1();
});
const pb = /* @__PURE__ */ s.createContext({}), Rt = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = s.useContext(pb), n = (r, o, a) => {
    if (!r)
      if (t === !1 && o === "deprecated") {
        const i = kr;
        kr || (kr = {}), kr[e] = kr[e] || [], kr[e].includes(a || "") || kr[e].push(a || ""), i || console.warn("[antd] There exists deprecated usage in your code:", kr);
      } else
        process.env.NODE_ENV !== "production" && uf(r, e, a);
  };
  return n.deprecated = (r, o, a, i) => {
    n(r, "deprecated", `\`${o}\` is deprecated. Please use \`${a}\` instead.${i ? ` ${i}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = gb, e;
}, jo = uf, hb = /* @__PURE__ */ uo(void 0);
var bb = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, D1 = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
const k1 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, yb = k1, L1 = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, D1),
  timePickerLocale: Object.assign({}, yb)
}, wi = L1, Qn = "${label} is not a valid ${type}", F1 = {
  locale: "en",
  Pagination: bb,
  DatePicker: wi,
  TimePicker: yb,
  Calendar: wi,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: Qn,
        method: Qn,
        array: Qn,
        object: Qn,
        number: Qn,
        date: Qn,
        boolean: Qn,
        integer: Qn,
        float: Qn,
        regexp: Qn,
        email: Qn,
        url: Qn,
        hex: Qn
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
}, xr = F1;
let Bl = Object.assign({}, xr.Modal), Hl = [];
const fv = () => Hl.reduce((e, t) => Object.assign(Object.assign({}, e), t), xr.Modal);
function j1(e) {
  if (e) {
    const t = Object.assign({}, e);
    return Hl.push(t), Bl = fv(), () => {
      Hl = Hl.filter((n) => n !== t), Bl = fv();
    };
  }
  Bl = Object.assign({}, xr.Modal);
}
function Cb() {
  return Bl;
}
const z1 = /* @__PURE__ */ uo(void 0), df = z1, A1 = (e, t) => {
  const n = s.useContext(df), r = s.useMemo(() => {
    var a;
    const i = t || xr[e], l = (a = n == null ? void 0 : n[e]) !== null && a !== void 0 ? a : {};
    return Object.assign(Object.assign({}, typeof i == "function" ? i() : i), l || {});
  }, [e, t, n]), o = s.useMemo(() => {
    const a = n == null ? void 0 : n.locale;
    return n != null && n.exist && !a ? xr.locale : a;
  }, [n]);
  return [r, o];
}, ur = A1, Sb = "internalMark", xb = (e) => {
  const {
    locale: t = {},
    children: n,
    _ANT_MARK__: r
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const a = Rt("LocaleProvider");
    process.env.NODE_ENV !== "production" && a(r === Sb, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  s.useEffect(() => j1(t && t.Modal), [t]);
  const o = s.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ s.createElement(df.Provider, {
    value: o
  }, n);
};
process.env.NODE_ENV !== "production" && (xb.displayName = "LocaleProvider");
const B1 = xb;
function Ln(e, t) {
  H1(e) && (e = "100%");
  var n = V1(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function ul(e) {
  return Math.min(1, Math.max(0, e));
}
function H1(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function V1(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function $b(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function dl(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function wo(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function W1(e, t, n) {
  return {
    r: Ln(e, 255) * 255,
    g: Ln(t, 255) * 255,
    b: Ln(n, 255) * 255
  };
}
function mv(e, t, n) {
  e = Ln(e, 255), t = Ln(t, 255), n = Ln(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, i = 0, l = (r + o) / 2;
  if (r === o)
    i = 0, a = 0;
  else {
    var c = r - o;
    switch (i = l > 0.5 ? c / (2 - r - o) : c / (r + o), r) {
      case e:
        a = (t - n) / c + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / c + 2;
        break;
      case n:
        a = (e - t) / c + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: i, l };
}
function Mc(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function K1(e, t, n) {
  var r, o, a;
  if (e = Ln(e, 360), t = Ln(t, 100), n = Ln(n, 100), t === 0)
    o = n, a = n, r = n;
  else {
    var i = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - i;
    r = Mc(l, i, e + 1 / 3), o = Mc(l, i, e), a = Mc(l, i, e - 1 / 3);
  }
  return { r: r * 255, g: o * 255, b: a * 255 };
}
function Bu(e, t, n) {
  e = Ln(e, 255), t = Ln(t, 255), n = Ln(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, i = r, l = r - o, c = r === 0 ? 0 : l / r;
  if (r === o)
    a = 0;
  else {
    switch (r) {
      case e:
        a = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / l + 2;
        break;
      case n:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: c, v: i };
}
function q1(e, t, n) {
  e = Ln(e, 360) * 6, t = Ln(t, 100), n = Ln(n, 100);
  var r = Math.floor(e), o = e - r, a = n * (1 - t), i = n * (1 - o * t), l = n * (1 - (1 - o) * t), c = r % 6, u = [n, i, a, a, l, n][c], d = [l, n, n, i, a, a][c], f = [a, a, l, n, n, i][c];
  return { r: u * 255, g: d * 255, b: f * 255 };
}
function Hu(e, t, n, r) {
  var o = [
    wo(Math.round(e).toString(16)),
    wo(Math.round(t).toString(16)),
    wo(Math.round(n).toString(16))
  ];
  return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function G1(e, t, n, r, o) {
  var a = [
    wo(Math.round(e).toString(16)),
    wo(Math.round(t).toString(16)),
    wo(Math.round(n).toString(16)),
    wo(U1(r))
  ];
  return o && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function U1(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function vv(e) {
  return er(e) / 255;
}
function er(e) {
  return parseInt(e, 16);
}
function Y1(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var Vu = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function ia(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, o = null, a = null, i = !1, l = !1;
  return typeof e == "string" && (e = J1(e)), typeof e == "object" && (_r(e.r) && _r(e.g) && _r(e.b) ? (t = W1(e.r, e.g, e.b), i = !0, l = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : _r(e.h) && _r(e.s) && _r(e.v) ? (r = dl(e.s), o = dl(e.v), t = q1(e.h, r, o), i = !0, l = "hsv") : _r(e.h) && _r(e.s) && _r(e.l) && (r = dl(e.s), a = dl(e.l), t = K1(e.h, r, a), i = !0, l = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = $b(n), {
    ok: i,
    format: e.format || l,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var X1 = "[-\\+]?\\d+%?", Q1 = "[-\\+]?\\d*\\.\\d+%?", to = "(?:".concat(Q1, ")|(?:").concat(X1, ")"), Tc = "[\\s|\\(]+(".concat(to, ")[,|\\s]+(").concat(to, ")[,|\\s]+(").concat(to, ")\\s*\\)?"), _c = "[\\s|\\(]+(".concat(to, ")[,|\\s]+(").concat(to, ")[,|\\s]+(").concat(to, ")[,|\\s]+(").concat(to, ")\\s*\\)?"), vr = {
  CSS_UNIT: new RegExp(to),
  rgb: new RegExp("rgb" + Tc),
  rgba: new RegExp("rgba" + _c),
  hsl: new RegExp("hsl" + Tc),
  hsla: new RegExp("hsla" + _c),
  hsv: new RegExp("hsv" + Tc),
  hsva: new RegExp("hsva" + _c),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function J1(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (Vu[e])
    e = Vu[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = vr.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = vr.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = vr.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = vr.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = vr.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = vr.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = vr.hex8.exec(e), n ? {
    r: er(n[1]),
    g: er(n[2]),
    b: er(n[3]),
    a: vv(n[4]),
    format: t ? "name" : "hex8"
  } : (n = vr.hex6.exec(e), n ? {
    r: er(n[1]),
    g: er(n[2]),
    b: er(n[3]),
    format: t ? "name" : "hex"
  } : (n = vr.hex4.exec(e), n ? {
    r: er(n[1] + n[1]),
    g: er(n[2] + n[2]),
    b: er(n[3] + n[3]),
    a: vv(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = vr.hex3.exec(e), n ? {
    r: er(n[1] + n[1]),
    g: er(n[2] + n[2]),
    b: er(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function _r(e) {
  return !!vr.CSS_UNIT.exec(String(e));
}
var Zt = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = Y1(t)), this.originalInput = t;
      var o = ia(t);
      this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : o.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, o, a = t.r / 255, i = t.g / 255, l = t.b / 255;
      return a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? o = l / 12.92 : o = Math.pow((l + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * o;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = $b(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = Bu(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = Bu(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = mv(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = mv(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), Hu(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), G1(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(Ln(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(Ln(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + Hu(this.r, this.g, this.b, !1), n = 0, r = Object.entries(Vu); n < r.length; n++) {
        var o = r[n], a = o[0], i = o[1];
        if (t === i)
          return a;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, o = this.a < 1 && this.a >= 0, a = !n && o && (t.startsWith("hex") || t === "name");
      return a ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = ul(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = ul(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = ul(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = ul(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), o = new e(t).toRgb(), a = n / 100, i = {
        r: (o.r - r.r) * a + r.r,
        g: (o.g - r.g) * a + r.g,
        b: (o.b - r.b) * a + r.b,
        a: (o.a - r.a) * a + r.a
      };
      return new e(i);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), o = 360 / n, a = [this];
      for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + o) % 360, a.push(new e(r));
      return a;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, o = n.s, a = n.v, i = [], l = 1 / t; t--; )
        i.push(new e({ h: r, s: o, v: a })), a = (a + l) % 1;
      return i;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), o = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / o,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / o,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / o,
        a: o
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, o = [this], a = 360 / t, i = 1; i < t; i++)
        o.push(new e({ h: (r + i * a) % 360, s: n.s, l: n.l }));
      return o;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
), fl = 2, gv = 0.16, Z1 = 0.05, eO = 0.05, tO = 0.15, wb = 5, Eb = 4, nO = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function pv(e) {
  var t = e.r, n = e.g, r = e.b, o = Bu(t, n, r);
  return {
    h: o.h * 360,
    s: o.s,
    v: o.v
  };
}
function ml(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(Hu(t, n, r, !1));
}
function rO(e, t, n) {
  var r = n / 100, o = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return o;
}
function hv(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - fl * t : Math.round(e.h) + fl * t : r = n ? Math.round(e.h) + fl * t : Math.round(e.h) - fl * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function bv(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - gv * t : t === Eb ? r = e.s + gv : r = e.s + Z1 * t, r > 1 && (r = 1), n && t === wb && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function yv(e, t, n) {
  var r;
  return n ? r = e.v + eO * t : r = e.v - tO * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function Ro(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = ia(e), o = wb; o > 0; o -= 1) {
    var a = pv(r), i = ml(ia({
      h: hv(a, o, !0),
      s: bv(a, o, !0),
      v: yv(a, o, !0)
    }));
    n.push(i);
  }
  n.push(ml(r));
  for (var l = 1; l <= Eb; l += 1) {
    var c = pv(r), u = ml(ia({
      h: hv(c, l),
      s: bv(c, l),
      v: yv(c, l)
    }));
    n.push(u);
  }
  return t.theme === "dark" ? nO.map(function(d) {
    var f = d.index, m = d.opacity, v = ml(rO(ia(t.backgroundColor || "#141414"), ia(n[f]), m * 100));
    return v;
  }) : n;
}
var fa = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, ci = {}, Dc = {};
Object.keys(fa).forEach(function(e) {
  ci[e] = Ro(fa[e]), ci[e].primary = ci[e][5], Dc[e] = Ro(fa[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), Dc[e].primary = Dc[e][5];
});
var oO = ci.gold, Wu = ci.blue;
const aO = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
}, iO = aO;
function lO(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
const Ob = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, sO = Object.assign(Object.assign({}, Ob), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), Ei = sO;
function cO(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: o,
    colorWarning: a,
    colorError: i,
    colorInfo: l,
    colorPrimary: c,
    colorBgBase: u,
    colorTextBase: d
  } = e, f = n(c), m = n(o), v = n(a), h = n(i), p = n(l), g = r(u, d), b = e.colorLink || e.colorInfo, y = n(b);
  return Object.assign(Object.assign({}, g), {
    colorPrimaryBg: f[1],
    colorPrimaryBgHover: f[2],
    colorPrimaryBorder: f[3],
    colorPrimaryBorderHover: f[4],
    colorPrimaryHover: f[5],
    colorPrimary: f[6],
    colorPrimaryActive: f[7],
    colorPrimaryTextHover: f[8],
    colorPrimaryText: f[9],
    colorPrimaryTextActive: f[10],
    colorSuccessBg: m[1],
    colorSuccessBgHover: m[2],
    colorSuccessBorder: m[3],
    colorSuccessBorderHover: m[4],
    colorSuccessHover: m[4],
    colorSuccess: m[6],
    colorSuccessActive: m[7],
    colorSuccessTextHover: m[8],
    colorSuccessText: m[9],
    colorSuccessTextActive: m[10],
    colorErrorBg: h[1],
    colorErrorBgHover: h[2],
    colorErrorBorder: h[3],
    colorErrorBorderHover: h[4],
    colorErrorHover: h[5],
    colorError: h[6],
    colorErrorActive: h[7],
    colorErrorTextHover: h[8],
    colorErrorText: h[9],
    colorErrorTextActive: h[10],
    colorWarningBg: v[1],
    colorWarningBgHover: v[2],
    colorWarningBorder: v[3],
    colorWarningBorderHover: v[4],
    colorWarningHover: v[4],
    colorWarning: v[6],
    colorWarningActive: v[7],
    colorWarningTextHover: v[8],
    colorWarningText: v[9],
    colorWarningTextActive: v[10],
    colorInfoBg: p[1],
    colorInfoBgHover: p[2],
    colorInfoBorder: p[3],
    colorInfoBorderHover: p[4],
    colorInfoHover: p[4],
    colorInfo: p[6],
    colorInfoActive: p[7],
    colorInfoTextHover: p[8],
    colorInfoText: p[9],
    colorInfoTextActive: p[10],
    colorLinkHover: y[4],
    colorLink: y[6],
    colorLinkActive: y[7],
    colorBgMask: new Zt("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const uO = (e) => {
  let t = e, n = e, r = e, o = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? o = 4 : e >= 8 && (o = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: o
  };
}, dO = uO;
function fO(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: o
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: o + 1
  }, dO(r));
}
const Dr = (e, t) => new Zt(e).setAlpha(t).toRgbString(), Ha = (e, t) => new Zt(e).darken(t).toHexString(), mO = (e) => {
  const t = Ro(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, vO = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: Dr(r, 0.88),
    colorTextSecondary: Dr(r, 0.65),
    colorTextTertiary: Dr(r, 0.45),
    colorTextQuaternary: Dr(r, 0.25),
    colorFill: Dr(r, 0.15),
    colorFillSecondary: Dr(r, 0.06),
    colorFillTertiary: Dr(r, 0.04),
    colorFillQuaternary: Dr(r, 0.02),
    colorBgLayout: Ha(n, 4),
    colorBgContainer: Ha(n, 0),
    colorBgElevated: Ha(n, 0),
    colorBgSpotlight: Dr(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: Ha(n, 15),
    colorBorderSecondary: Ha(n, 6)
  };
};
function Vl(e) {
  return (e + 8) / e;
}
function gO(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const o = r - 1, a = e * Math.pow(2.71828, o / 5), i = r > 1 ? Math.floor(a) : Math.ceil(a);
    return Math.floor(i / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: Vl(n)
  }));
}
const pO = (e) => {
  const t = gO(e), n = t.map((d) => d.size), r = t.map((d) => d.lineHeight), o = n[1], a = n[0], i = n[2], l = r[1], c = r[0], u = r[2];
  return {
    fontSizeSM: a,
    fontSize: o,
    fontSizeLG: i,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: l,
    lineHeightLG: u,
    lineHeightSM: c,
    fontHeight: Math.round(l * o),
    fontHeightLG: Math.round(u * i),
    fontHeightSM: Math.round(c * a),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
}, hO = pO;
function bO(e) {
  const t = Object.keys(Ob).map((n) => {
    const r = Ro(e[n]);
    return new Array(10).fill(1).reduce((o, a, i) => (o[`${n}-${i + 1}`] = r[i], o[`${n}${i + 1}`] = r[i], o), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), cO(e, {
    generateColorPalettes: mO,
    generateNeutralColorPalettes: vO
  })), hO(e.fontSize)), lO(e)), iO(e)), fO(e));
}
const Nb = _u(bO), Ib = {
  token: Ei,
  override: {
    override: Ei
  },
  hashed: !0
}, Pb = /* @__PURE__ */ le.createContext(Ib), ff = "anticon", yO = (e, t) => t || (e ? `ant-${e}` : "ant"), lt = /* @__PURE__ */ s.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: yO,
  iconPrefixCls: ff
}), CO = `-ant-${Date.now()}-${Math.random()}`;
function SO(e, t) {
  const n = {}, r = (i, l) => {
    let c = i.clone();
    return c = (l == null ? void 0 : l(c)) || c, c.toRgbString();
  }, o = (i, l) => {
    const c = new Zt(i), u = Ro(c.toRgbString());
    n[`${l}-color`] = r(c), n[`${l}-color-disabled`] = u[1], n[`${l}-color-hover`] = u[4], n[`${l}-color-active`] = u[6], n[`${l}-color-outline`] = c.clone().setAlpha(0.2).toRgbString(), n[`${l}-color-deprecated-bg`] = u[0], n[`${l}-color-deprecated-border`] = u[2];
  };
  if (t.primaryColor) {
    o(t.primaryColor, "primary");
    const i = new Zt(t.primaryColor), l = Ro(i.toRgbString());
    l.forEach((u, d) => {
      n[`primary-${d + 1}`] = u;
    }), n["primary-color-deprecated-l-35"] = r(i, (u) => u.lighten(35)), n["primary-color-deprecated-l-20"] = r(i, (u) => u.lighten(20)), n["primary-color-deprecated-t-20"] = r(i, (u) => u.tint(20)), n["primary-color-deprecated-t-50"] = r(i, (u) => u.tint(50)), n["primary-color-deprecated-f-12"] = r(i, (u) => u.setAlpha(u.getAlpha() * 0.12));
    const c = new Zt(l[0]);
    n["primary-color-active-deprecated-f-30"] = r(c, (u) => u.setAlpha(u.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(c, (u) => u.darken(2));
  }
  return t.successColor && o(t.successColor, "success"), t.warningColor && o(t.warningColor, "warning"), t.errorColor && o(t.errorColor, "error"), t.infoColor && o(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((i) => `--${e}-${i}: ${n[i]};`).join(`
`)}
  }
  `.trim();
}
function xO(e, t) {
  const n = SO(e, t);
  pn() ? ao(n, `${CO}-dynamic-theme`) : process.env.NODE_ENV !== "production" && jo(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const Ku = /* @__PURE__ */ s.createContext(!1), mf = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = s.useContext(Ku);
  return /* @__PURE__ */ s.createElement(Ku.Provider, {
    value: n ?? r
  }, t);
}, dr = Ku, qu = /* @__PURE__ */ s.createContext(void 0), $O = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = s.useContext(qu);
  return /* @__PURE__ */ s.createElement(qu.Provider, {
    value: n || r
  }, t);
}, ki = qu;
function wO() {
  const e = qt(dr), t = qt(ki);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
const Oi = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], EO = "5.14.0";
function kc(e) {
  return e >= 0 && e <= 255;
}
function vl(e, t) {
  const {
    r: n,
    g: r,
    b: o,
    a
  } = new Zt(e).toRgb();
  if (a < 1)
    return e;
  const {
    r: i,
    g: l,
    b: c
  } = new Zt(t).toRgb();
  for (let u = 0.01; u <= 1; u += 0.01) {
    const d = Math.round((n - i * (1 - u)) / u), f = Math.round((r - l * (1 - u)) / u), m = Math.round((o - c * (1 - u)) / u);
    if (kc(d) && kc(f) && kc(m))
      return new Zt({
        r: d,
        g: f,
        b: m,
        a: Math.round(u * 100) / 100
      }).toRgbString();
  }
  return new Zt({
    r: n,
    g: r,
    b: o,
    a: 1
  }).toRgbString();
}
var OO = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Rb(e) {
  const {
    override: t
  } = e, n = OO(e, ["override"]), r = Object.assign({}, t);
  Object.keys(Ei).forEach((m) => {
    delete r[m];
  });
  const o = Object.assign(Object.assign({}, n), r), a = 480, i = 576, l = 768, c = 992, u = 1200, d = 1600;
  if (o.motion === !1) {
    const m = "0s";
    o.motionDurationFast = m, o.motionDurationMid = m, o.motionDurationSlow = m;
  }
  return Object.assign(Object.assign(Object.assign({}, o), {
    // ============== Background ============== //
    colorFillContent: o.colorFillSecondary,
    colorFillContentHover: o.colorFill,
    colorFillAlter: o.colorFillQuaternary,
    colorBgContainerDisabled: o.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: o.colorBgContainer,
    colorSplit: vl(o.colorBorderSecondary, o.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: o.colorTextQuaternary,
    colorTextDisabled: o.colorTextQuaternary,
    colorTextHeading: o.colorText,
    colorTextLabel: o.colorTextSecondary,
    colorTextDescription: o.colorTextTertiary,
    colorTextLightSolid: o.colorWhite,
    colorHighlight: o.colorError,
    colorBgTextHover: o.colorFillSecondary,
    colorBgTextActive: o.colorFill,
    colorIcon: o.colorTextTertiary,
    colorIconHover: o.colorText,
    colorErrorOutline: vl(o.colorErrorBg, o.colorBgContainer),
    colorWarningOutline: vl(o.colorWarningBg, o.colorBgContainer),
    // Font
    fontSizeIcon: o.fontSizeSM,
    // Line
    lineWidthFocus: o.lineWidth * 4,
    // Control
    lineWidth: o.lineWidth,
    controlOutlineWidth: o.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: o.controlHeight / 2,
    controlItemBgHover: o.colorFillTertiary,
    controlItemBgActive: o.colorPrimaryBg,
    controlItemBgActiveHover: o.colorPrimaryBgHover,
    controlItemBgActiveDisabled: o.colorFill,
    controlTmpOutline: o.colorFillQuaternary,
    controlOutline: vl(o.colorPrimaryBg, o.colorBgContainer),
    lineType: o.lineType,
    borderRadius: o.borderRadius,
    borderRadiusXS: o.borderRadiusXS,
    borderRadiusSM: o.borderRadiusSM,
    borderRadiusLG: o.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: o.sizeXXS,
    paddingXS: o.sizeXS,
    paddingSM: o.sizeSM,
    padding: o.size,
    paddingMD: o.sizeMD,
    paddingLG: o.sizeLG,
    paddingXL: o.sizeXL,
    paddingContentHorizontalLG: o.sizeLG,
    paddingContentVerticalLG: o.sizeMS,
    paddingContentHorizontal: o.sizeMS,
    paddingContentVertical: o.sizeSM,
    paddingContentHorizontalSM: o.size,
    paddingContentVerticalSM: o.sizeXS,
    marginXXS: o.sizeXXS,
    marginXS: o.sizeXS,
    marginSM: o.sizeSM,
    margin: o.size,
    marginMD: o.sizeMD,
    marginLG: o.sizeLG,
    marginXL: o.sizeXL,
    marginXXL: o.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: a,
    screenXSMin: a,
    screenXSMax: i - 1,
    screenSM: i,
    screenSMMin: i,
    screenSMMax: l - 1,
    screenMD: l,
    screenMDMin: l,
    screenMDMax: c - 1,
    screenLG: c,
    screenLGMin: c,
    screenLGMax: u - 1,
    screenXL: u,
    screenXLMin: u,
    screenXLMax: d - 1,
    screenXXL: d,
    screenXXLMin: d,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new Zt("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new Zt("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new Zt("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var Cv = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Mb = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0
}, Tb = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, NO = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, _b = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: o
  } = t, a = Cv(t, ["override"]);
  let i = Object.assign(Object.assign({}, r), {
    override: o
  });
  return i = Rb(i), a && Object.entries(a).forEach((l) => {
    let [c, u] = l;
    const {
      theme: d
    } = u, f = Cv(u, ["theme"]);
    let m = f;
    d && (m = _b(Object.assign(Object.assign({}, i), f), {
      override: f
    }, d)), i[c] = m;
  }), i;
};
function Sn() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: o
  } = le.useContext(Pb), a = `${EO}-${t || ""}`, i = n || Nb, [l, c, u] = ZE(i, [Ei, e], {
    salt: a,
    override: r,
    getComputedToken: _b,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: Rb,
    cssVar: o && {
      prefix: o.prefix,
      key: o.key,
      unitless: Mb,
      ignore: Tb,
      preserve: NO
    }
  });
  return [i, u, t ? c : "", l, o];
}
function Lt(e) {
  var t = s.useRef();
  t.current = e;
  var n = s.useCallback(function() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(a));
  }, []);
  return n;
}
function no(e) {
  var t = s.useRef(!1), n = s.useState(e), r = Q(n, 2), o = r[0], a = r[1];
  s.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function i(l, c) {
    c && t.current || a(l);
  }
  return [o, i];
}
function Lc(e) {
  return e !== void 0;
}
function Vt(e, t) {
  var n = t || {}, r = n.defaultValue, o = n.value, a = n.onChange, i = n.postState, l = no(function() {
    return Lc(o) ? o : Lc(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), c = Q(l, 2), u = c[0], d = c[1], f = o !== void 0 ? o : u, m = i ? i(f) : f, v = Lt(a), h = no([f]), p = Q(h, 2), g = p[0], b = p[1];
  as(function() {
    var C = g[0];
    u !== C && v(u, C);
  }, [g]), as(function() {
    Lc(o) || d(o);
  }, [o]);
  var y = Lt(function(C, S) {
    d(C, S), b([f], S);
  });
  return [m, y];
}
const vf = (e) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${e.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
}), Vr = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, Gt = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, Li = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), Mo = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), IO = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    [`&:active,
  &:hover`]: {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), PO = (e, t, n) => {
  const {
    fontFamily: r,
    fontSize: o
  } = e, a = `[class^="${t}"], [class*=" ${t}"]`;
  return {
    [n ? `.${n}` : a]: {
      fontFamily: r,
      fontSize: o,
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      },
      [a]: {
        boxSizing: "border-box",
        "&::before, &::after": {
          boxSizing: "border-box"
        }
      }
    }
  };
}, io = (e) => ({
  outline: `${q(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), lo = (e) => ({
  "&:focus-visible": Object.assign({}, io(e))
});
let RO = /* @__PURE__ */ wn(function e() {
  $n(this, e);
});
const Db = RO;
function MO(e, t, n) {
  return t = oo(t), nf(e, Ns() ? Reflect.construct(t, n || [], oo(e).constructor) : t.apply(e, n));
}
let TO = /* @__PURE__ */ function(e) {
  wr(t, e);
  function t(n) {
    var r;
    return $n(this, t), r = MO(this, t), r.result = 0, n instanceof t ? r.result = n.result : typeof n == "number" && (r.result = n), r;
  }
  return wn(t, [{
    key: "add",
    value: function(r) {
      return r instanceof t ? this.result += r.result : typeof r == "number" && (this.result += r), this;
    }
  }, {
    key: "sub",
    value: function(r) {
      return r instanceof t ? this.result -= r.result : typeof r == "number" && (this.result -= r), this;
    }
  }, {
    key: "mul",
    value: function(r) {
      return r instanceof t ? this.result *= r.result : typeof r == "number" && (this.result *= r), this;
    }
  }, {
    key: "div",
    value: function(r) {
      return r instanceof t ? this.result /= r.result : typeof r == "number" && (this.result /= r), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), t;
}(Db);
function _O(e, t, n) {
  return t = oo(t), nf(e, Ns() ? Reflect.construct(t, n || [], oo(e).constructor) : t.apply(e, n));
}
const kb = "CALC_UNIT";
function Fc(e) {
  return typeof e == "number" ? `${e}${kb}` : e;
}
let DO = /* @__PURE__ */ function(e) {
  wr(t, e);
  function t(n) {
    var r;
    return $n(this, t), r = _O(this, t), r.result = "", n instanceof t ? r.result = `(${n.result})` : typeof n == "number" ? r.result = Fc(n) : typeof n == "string" && (r.result = n), r;
  }
  return wn(t, [{
    key: "add",
    value: function(r) {
      return r instanceof t ? this.result = `${this.result} + ${r.getResult()}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} + ${Fc(r)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(r) {
      return r instanceof t ? this.result = `${this.result} - ${r.getResult()}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} - ${Fc(r)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(r) {
      return this.lowPriority && (this.result = `(${this.result})`), r instanceof t ? this.result = `${this.result} * ${r.getResult(!0)}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} * ${r}`), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(r) {
      return this.lowPriority && (this.result = `(${this.result})`), r instanceof t ? this.result = `${this.result} / ${r.getResult(!0)}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} / ${r}`), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(r) {
      return this.lowPriority || r ? `(${this.result})` : this.result;
    }
  }, {
    key: "equal",
    value: function(r) {
      const {
        unit: o = !0
      } = r || {}, a = new RegExp(`${kb}`, "g");
      return this.result = this.result.replace(a, o ? "px" : ""), typeof this.lowPriority < "u" ? `calc(${this.result})` : this.result;
    }
  }]), t;
}(Db);
const kO = (e) => {
  const t = e === "css" ? DO : TO;
  return (n) => new t(n);
}, LO = kO;
function FO(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return `max(${n.map((o) => q(o)).join(",")})`;
    },
    min: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return `min(${n.map((o) => q(o)).join(",")})`;
    }
  };
}
const Lb = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u";
let Gu = !0;
function Dt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!Lb)
    return Object.assign.apply(Object, [{}].concat(t));
  Gu = !1;
  const r = {};
  return t.forEach((o) => {
    Object.keys(o).forEach((i) => {
      Object.defineProperty(r, i, {
        configurable: !0,
        enumerable: !0,
        get: () => o[i]
      });
    });
  }), Gu = !0, r;
}
const Sv = {};
function jO() {
}
const zO = (e) => {
  let t, n = e, r = jO;
  return Lb && typeof Proxy < "u" && (t = /* @__PURE__ */ new Set(), n = new Proxy(e, {
    get(o, a) {
      return Gu && t.add(a), o[a];
    }
  }), r = (o, a) => {
    var i;
    Sv[o] = {
      global: Array.from(t),
      component: Object.assign(Object.assign({}, (i = Sv[o]) === null || i === void 0 ? void 0 : i.component), a)
    };
  }), {
    token: n,
    keys: t,
    flush: r
  };
}, AO = (e, t) => {
  const [n, r] = Sn();
  return Au({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, Li()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, Fb = AO, jb = (e, t, n) => {
  var r;
  return typeof n == "function" ? n(Dt(t, (r = t[e]) !== null && r !== void 0 ? r : {})) : n ?? {};
}, zb = (e, t, n, r) => {
  const o = Object.assign({}, t[e]);
  if (r != null && r.deprecatedTokens) {
    const {
      deprecatedTokens: i
    } = r;
    i.forEach((l) => {
      let [c, u] = l;
      var d;
      process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && tt(!(o != null && o[c]), `Component Token \`${String(c)}\` of ${e} is deprecated. Please use \`${String(u)}\` instead.`), (o != null && o[c] || o != null && o[u]) && ((d = o[u]) !== null && d !== void 0 || (o[u] = o == null ? void 0 : o[c]));
    });
  }
  const a = Object.assign(Object.assign({}, n), o);
  return Object.keys(a).forEach((i) => {
    a[i] === t[i] && delete a[i];
  }), a;
}, BO = (e, t) => `${[t, e.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function gf(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const o = Array.isArray(e) ? e : [e, e], [a] = o, i = o.join("-");
  return function(l) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
    const [u, d, f, m, v] = Sn(), {
      getPrefixCls: h,
      iconPrefixCls: p,
      csp: g
    } = qt(lt), b = h(), y = v ? "css" : "js", C = LO(y), {
      max: S,
      min: $
    } = FO(y), x = {
      theme: u,
      token: m,
      hashId: f,
      nonce: () => g == null ? void 0 : g.nonce,
      clientOnly: r.clientOnly,
      // antd is always at top of styles
      order: r.order || -999
    };
    return Au(Object.assign(Object.assign({}, x), {
      clientOnly: !1,
      path: ["Shared", b]
    }), () => [{
      // Link
      "&": IO(m)
    }]), Fb(p, g), [Au(Object.assign(Object.assign({}, x), {
      path: [i, l, p]
    }), () => {
      if (r.injectStyle === !1)
        return [];
      const {
        token: N,
        flush: O
      } = zO(m), E = jb(a, d, n), I = `.${l}`, k = zb(a, d, E, {
        deprecatedTokens: r.deprecatedTokens
      });
      v && Object.keys(E).forEach((_) => {
        E[_] = `var(${Xh(_, BO(a, v.prefix))})`;
      });
      const M = Dt(N, {
        componentCls: I,
        prefixCls: l,
        iconCls: `.${p}`,
        antCls: `.${b}`,
        calc: C,
        max: S,
        min: $
      }, v ? E : k), P = t(M, {
        hashId: f,
        prefixCls: l,
        rootPrefixCls: b,
        iconPrefixCls: p
      });
      return O(a, k), [r.resetStyle === !1 ? null : PO(M, l, c), P];
    }), f];
  };
}
const zo = (e, t, n, r) => {
  const o = gf(e, t, n, Object.assign({
    resetStyle: !1,
    // Sub Style should default after root one
    order: -998
  }, r)), a = (i) => {
    let {
      prefixCls: l,
      rootCls: c = l
    } = i;
    return o(l, c), null;
  };
  return process.env.NODE_ENV !== "production" && (a.displayName = `SubStyle_${Array.isArray(e) ? e.join(".") : e}`), a;
}, HO = (e, t, n) => {
  function r(u) {
    return `${e}${u.slice(0, 1).toUpperCase()}${u.slice(1)}`;
  }
  const {
    unitless: o = {},
    injectStyle: a = !0
  } = n ?? {}, i = {
    [r("zIndexPopup")]: !0
  };
  Object.keys(o).forEach((u) => {
    i[r(u)] = o[u];
  });
  const l = (u) => {
    let {
      rootCls: d,
      cssVar: f
    } = u;
    const [, m] = Sn();
    return I1({
      path: [e],
      prefix: f.prefix,
      key: f == null ? void 0 : f.key,
      unitless: Object.assign(Object.assign({}, Mb), i),
      ignore: Tb,
      token: m,
      scope: d
    }, () => {
      const v = jb(e, m, t), h = zb(e, m, v, {
        deprecatedTokens: n == null ? void 0 : n.deprecatedTokens
      });
      return Object.keys(v).forEach((p) => {
        h[r(p)] = h[p], delete h[p];
      }), h;
    }), null;
  };
  return (u) => {
    const [, , , , d] = Sn();
    return [(f) => a && d ? /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.createElement(l, {
      rootCls: u,
      cssVar: d,
      component: e
    }), f) : f, d == null ? void 0 : d.key];
  };
}, Xt = (e, t, n, r) => {
  const o = gf(e, t, n, r), a = HO(Array.isArray(e) ? e[0] : e, n, r);
  return function(i) {
    let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i;
    const [, c] = o(i, l), [u, d] = a(l);
    return [u, c, d];
  };
};
function Ab(e, t) {
  return Oi.reduce((n, r) => {
    const o = e[`${r}1`], a = e[`${r}3`], i = e[`${r}6`], l = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: o,
      lightBorderColor: a,
      darkColor: i,
      textColor: l
    }));
  }, {});
}
const VO = Object.assign({}, s), {
  useId: xv
} = VO, WO = () => "", KO = typeof xv > "u" ? WO : xv, qO = KO;
function GO(e, t) {
  var n;
  const r = Rt("ConfigProvider"), o = e || {}, a = o.inherit === !1 || !t ? Ib : t, i = qO();
  if (process.env.NODE_ENV !== "production") {
    const l = o.cssVar || a.cssVar, c = !!(typeof o.cssVar == "object" && (!((n = o.cssVar) === null || n === void 0) && n.key) || i);
    process.env.NODE_ENV !== "production" && r(!l || c, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return Fo(() => {
    var l, c;
    if (!e)
      return t;
    const u = Object.assign({}, a.components);
    Object.keys(e.components || {}).forEach((m) => {
      u[m] = Object.assign(Object.assign({}, u[m]), e.components[m]);
    });
    const d = `css-var-${i.replace(/:/g, "")}`, f = ((l = o.cssVar) !== null && l !== void 0 ? l : a.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: "ant"
    }, typeof a.cssVar == "object" ? a.cssVar : {}), typeof o.cssVar == "object" ? o.cssVar : {}), {
      key: typeof o.cssVar == "object" && ((c = o.cssVar) === null || c === void 0 ? void 0 : c.key) || d
    });
    return Object.assign(Object.assign(Object.assign({}, a), o), {
      token: Object.assign(Object.assign({}, a.token), o.token),
      components: u,
      cssVar: f
    });
  }, [o, a], (l, c) => l.some((u, d) => {
    const f = c[d];
    return !Hr(u, f, !0);
  }));
}
var UO = ["children"], Bb = /* @__PURE__ */ s.createContext({});
function YO(e) {
  var t = e.children, n = vt(e, UO);
  return /* @__PURE__ */ s.createElement(Bb.Provider, {
    value: n
  }, t);
}
var XO = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n() {
    return $n(this, n), t.apply(this, arguments);
  }
  return wn(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(s.Component), Co = "none", gl = "appear", pl = "enter", hl = "leave", $v = "none", pr = "prepare", ua = "start", da = "active", pf = "end", Hb = "prepared";
function wv(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function QO(e, t) {
  var n = {
    animationend: wv("Animation", "AnimationEnd"),
    transitionend: wv("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var JO = QO(pn(), typeof window < "u" ? window : {}), Vb = {};
if (pn()) {
  var ZO = document.createElement("div");
  Vb = ZO.style;
}
var bl = {};
function Wb(e) {
  if (bl[e])
    return bl[e];
  var t = JO[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, o = 0; o < r; o += 1) {
      var a = n[o];
      if (Object.prototype.hasOwnProperty.call(t, a) && a in Vb)
        return bl[e] = t[a], bl[e];
    }
  return "";
}
var Kb = Wb("animationend"), qb = Wb("transitionend"), Gb = !!(Kb && qb), Ev = Kb || "animationend", Ov = qb || "transitionend";
function Nv(e, t) {
  if (!e)
    return null;
  if (mt(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const eN = function(e) {
  var t = Xe(), n = Xe(e);
  n.current = e;
  var r = s.useCallback(function(i) {
    n.current(i);
  }, []);
  function o(i) {
    i && (i.removeEventListener(Ov, r), i.removeEventListener(Ev, r));
  }
  function a(i) {
    t.current && t.current !== i && o(t.current), i && i !== t.current && (i.addEventListener(Ov, r), i.addEventListener(Ev, r), t.current = i);
  }
  return s.useEffect(function() {
    return function() {
      o(t.current);
    };
  }, []), [a, o];
};
var Ub = pn() ? Iw : Bt;
const tN = function() {
  var e = s.useRef(null);
  function t() {
    _t.cancel(e.current);
  }
  function n(r) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var a = _t(function() {
      o <= 1 ? r({
        isCanceled: function() {
          return a !== e.current;
        }
      }) : n(r, o - 1);
    });
    e.current = a;
  }
  return s.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var nN = [pr, ua, da, pf], rN = [pr, Hb], Yb = !1, oN = !0;
function Xb(e) {
  return e === da || e === pf;
}
const aN = function(e, t, n) {
  var r = no($v), o = Q(r, 2), a = o[0], i = o[1], l = tN(), c = Q(l, 2), u = c[0], d = c[1];
  function f() {
    i(pr, !0);
  }
  var m = t ? rN : nN;
  return Ub(function() {
    if (a !== $v && a !== pf) {
      var v = m.indexOf(a), h = m[v + 1], p = n(a);
      p === Yb ? i(h, !0) : h && u(function(g) {
        function b() {
          g.isCanceled() || i(h, !0);
        }
        p === !0 ? b() : Promise.resolve(p).then(b);
      });
    }
  }, [e, a]), s.useEffect(function() {
    return function() {
      d();
    };
  }, []), [f, a];
};
function iN(e, t, n, r) {
  var o = r.motionEnter, a = o === void 0 ? !0 : o, i = r.motionAppear, l = i === void 0 ? !0 : i, c = r.motionLeave, u = c === void 0 ? !0 : c, d = r.motionDeadline, f = r.motionLeaveImmediately, m = r.onAppearPrepare, v = r.onEnterPrepare, h = r.onLeavePrepare, p = r.onAppearStart, g = r.onEnterStart, b = r.onLeaveStart, y = r.onAppearActive, C = r.onEnterActive, S = r.onLeaveActive, $ = r.onAppearEnd, x = r.onEnterEnd, w = r.onLeaveEnd, N = r.onVisibleChanged, O = no(), E = Q(O, 2), I = E[0], k = E[1], M = no(Co), P = Q(M, 2), _ = P[0], D = P[1], R = no(null), T = Q(R, 2), L = T[0], F = T[1], j = Xe(!1), A = Xe(null);
  function B() {
    return n();
  }
  var K = Xe(!1);
  function Y() {
    D(Co, !0), F(null, !0);
  }
  function G(se) {
    var ie = B();
    if (!(se && !se.deadline && se.target !== ie)) {
      var me = K.current, Se;
      _ === gl && me ? Se = $ == null ? void 0 : $(ie, se) : _ === pl && me ? Se = x == null ? void 0 : x(ie, se) : _ === hl && me && (Se = w == null ? void 0 : w(ie, se)), _ !== Co && me && Se !== !1 && Y();
    }
  }
  var te = eN(G), ee = Q(te, 1), oe = ee[0], X = function(ie) {
    var me, Se, ve;
    switch (ie) {
      case gl:
        return me = {}, z(me, pr, m), z(me, ua, p), z(me, da, y), me;
      case pl:
        return Se = {}, z(Se, pr, v), z(Se, ua, g), z(Se, da, C), Se;
      case hl:
        return ve = {}, z(ve, pr, h), z(ve, ua, b), z(ve, da, S), ve;
      default:
        return {};
    }
  }, W = s.useMemo(function() {
    return X(_);
  }, [_]), re = aN(_, !e, function(se) {
    if (se === pr) {
      var ie = W[pr];
      return ie ? ie(B()) : Yb;
    }
    if (U in W) {
      var me;
      F(((me = W[U]) === null || me === void 0 ? void 0 : me.call(W, B(), null)) || null);
    }
    return U === da && (oe(B()), d > 0 && (clearTimeout(A.current), A.current = setTimeout(function() {
      G({
        deadline: !0
      });
    }, d))), U === Hb && Y(), oN;
  }), Z = Q(re, 2), H = Z[0], U = Z[1], ae = Xb(U);
  K.current = ae, Ub(function() {
    k(t);
    var se = j.current;
    j.current = !0;
    var ie;
    !se && t && l && (ie = gl), se && t && a && (ie = pl), (se && !t && u || !se && f && !t && u) && (ie = hl);
    var me = X(ie);
    ie && (e || me[pr]) ? (D(ie), H()) : D(Co);
  }, [t]), Bt(function() {
    // Cancel appear
    (_ === gl && !l || // Cancel enter
    _ === pl && !a || // Cancel leave
    _ === hl && !u) && D(Co);
  }, [l, a, u]), Bt(function() {
    return function() {
      j.current = !1, clearTimeout(A.current);
    };
  }, []);
  var ue = s.useRef(!1);
  Bt(function() {
    I && (ue.current = !0), I !== void 0 && _ === Co && ((ue.current || I) && (N == null || N(I)), ue.current = !0);
  }, [I, _]);
  var de = L;
  return W[pr] && U === ua && (de = V({
    transition: "none"
  }, de)), [_, U, de, I ?? t];
}
function lN(e) {
  var t = e;
  mt(e) === "object" && (t = e.transitionSupport);
  function n(o, a) {
    return !!(o.motionName && t && a !== !1);
  }
  var r = /* @__PURE__ */ s.forwardRef(function(o, a) {
    var i = o.visible, l = i === void 0 ? !0 : i, c = o.removeOnLeave, u = c === void 0 ? !0 : c, d = o.forceRender, f = o.children, m = o.motionName, v = o.leavedClassName, h = o.eventProps, p = s.useContext(Bb), g = p.motion, b = n(o, g), y = Xe(), C = Xe();
    function S() {
      try {
        return y.current instanceof HTMLElement ? y.current : ii(C.current);
      } catch {
        return null;
      }
    }
    var $ = iN(b, l, S, o), x = Q($, 4), w = x[0], N = x[1], O = x[2], E = x[3], I = s.useRef(E);
    E && (I.current = !0);
    var k = s.useCallback(function(F) {
      y.current = F, Ci(a, F);
    }, [a]), M, P = V(V({}, h), {}, {
      visible: l
    });
    if (!f)
      M = null;
    else if (w === Co)
      E ? M = f(V({}, P), k) : !u && I.current && v ? M = f(V(V({}, P), {}, {
        className: v
      }), k) : d || !u && !v ? M = f(V(V({}, P), {}, {
        style: {
          display: "none"
        }
      }), k) : M = null;
    else {
      var _, D;
      N === pr ? D = "prepare" : Xb(N) ? D = "active" : N === ua && (D = "start");
      var R = Nv(m, "".concat(w, "-").concat(D));
      M = f(V(V({}, P), {}, {
        className: J(Nv(m, w), (_ = {}, z(_, R, R && D), z(_, m, typeof m == "string"), _)),
        style: O
      }), k);
    }
    if (/* @__PURE__ */ s.isValidElement(M) && Sr(M)) {
      var T = M, L = T.ref;
      L || (M = /* @__PURE__ */ s.cloneElement(M, {
        ref: k
      }));
    }
    return /* @__PURE__ */ s.createElement(XO, {
      ref: C
    }, M);
  });
  return r.displayName = "CSSMotion", r;
}
const An = lN(Gb);
var Uu = "add", Yu = "keep", Xu = "remove", jc = "removed";
function sN(e) {
  var t;
  return e && mt(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, V(V({}, t), {}, {
    key: String(t.key)
  });
}
function Qu() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(sN);
}
function cN() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, o = t.length, a = Qu(e), i = Qu(t);
  a.forEach(function(u) {
    for (var d = !1, f = r; f < o; f += 1) {
      var m = i[f];
      if (m.key === u.key) {
        r < f && (n = n.concat(i.slice(r, f).map(function(v) {
          return V(V({}, v), {}, {
            status: Uu
          });
        })), r = f), n.push(V(V({}, m), {}, {
          status: Yu
        })), r += 1, d = !0;
        break;
      }
    }
    d || n.push(V(V({}, u), {}, {
      status: Xu
    }));
  }), r < o && (n = n.concat(i.slice(r).map(function(u) {
    return V(V({}, u), {}, {
      status: Uu
    });
  })));
  var l = {};
  n.forEach(function(u) {
    var d = u.key;
    l[d] = (l[d] || 0) + 1;
  });
  var c = Object.keys(l).filter(function(u) {
    return l[u] > 1;
  });
  return c.forEach(function(u) {
    n = n.filter(function(d) {
      var f = d.key, m = d.status;
      return f !== u || m !== Xu;
    }), n.forEach(function(d) {
      d.key === u && (d.status = Yu);
    });
  }), n;
}
var uN = ["component", "children", "onVisibleChanged", "onAllRemoved"], dN = ["status"], fN = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function mN(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : An, n = /* @__PURE__ */ function(r) {
    wr(a, r);
    var o = Ur(a);
    function a() {
      var i;
      $n(this, a);
      for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      return i = o.call.apply(o, [this].concat(c)), z(Me(i), "state", {
        keyEntities: []
      }), z(Me(i), "removeKey", function(d) {
        var f = i.state.keyEntities, m = f.map(function(v) {
          return v.key !== d ? v : V(V({}, v), {}, {
            status: jc
          });
        });
        return i.setState({
          keyEntities: m
        }), m.filter(function(v) {
          var h = v.status;
          return h !== jc;
        }).length;
      }), i;
    }
    return wn(a, [{
      key: "render",
      value: function() {
        var l = this, c = this.state.keyEntities, u = this.props, d = u.component, f = u.children, m = u.onVisibleChanged, v = u.onAllRemoved, h = vt(u, uN), p = d || s.Fragment, g = {};
        return fN.forEach(function(b) {
          g[b] = h[b], delete h[b];
        }), delete h.keys, /* @__PURE__ */ s.createElement(p, h, c.map(function(b, y) {
          var C = b.status, S = vt(b, dN), $ = C === Uu || C === Yu;
          return /* @__PURE__ */ s.createElement(t, fe({}, g, {
            key: S.key,
            visible: $,
            eventProps: S,
            onVisibleChanged: function(w) {
              if (m == null || m(w, {
                key: S.key
              }), !w) {
                var N = l.removeKey(S.key);
                N === 0 && v && v();
              }
            }
          }), function(x, w) {
            return f(V(V({}, x), {}, {
              index: y
            }), w);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(l, c) {
        var u = l.keys, d = c.keyEntities, f = Qu(u), m = cN(d, f);
        return {
          keyEntities: m.filter(function(v) {
            var h = d.find(function(p) {
              var g = p.key;
              return v.key === g;
            });
            return !(h && h.status === jc && v.status === Xu);
          })
        };
      }
    }]), a;
  }(s.Component);
  return z(n, "defaultProps", {
    component: "div"
  }), n;
}
const hf = mN(Gb);
function vN(e) {
  const {
    children: t
  } = e, [, n] = Sn(), {
    motion: r
  } = n, o = s.useRef(!1);
  return o.current = o.current || r === !1, o.current ? /* @__PURE__ */ s.createElement(YO, {
    motion: r
  }, t) : t;
}
const Qb = /* @__PURE__ */ s.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return Rt("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (Qb.displayName = "PropWarning");
const gN = process.env.NODE_ENV !== "production" ? Qb : () => null;
var pN = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let Ju = !1;
const Jb = process.env.NODE_ENV !== "production" ? (e) => {
  process.env.NODE_ENV !== "production" && jo(!Ju, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), hN = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"], bN = "ant";
let is, Zb, e0, t0;
function Wl() {
  return is || bN;
}
function yN() {
  return Zb || ff;
}
function CN(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const SN = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: n,
    theme: r,
    holderRender: o
  } = e;
  t !== void 0 && (is = t), n !== void 0 && (Zb = n), "holderRender" in e && (t0 = o), r && (CN(r) ? (process.env.NODE_ENV !== "production" && jo(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), xO(Wl(), r)) : e0 = r);
}, bf = () => ({
  getPrefixCls: (e, t) => t || (e ? `${Wl()}-${e}` : Wl()),
  getIconPrefixCls: yN,
  getRootPrefixCls: () => is || Wl(),
  getTheme: () => e0,
  holderRender: t0
}), xN = (e) => {
  const {
    children: t,
    csp: n,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: a,
    form: i,
    locale: l,
    componentSize: c,
    direction: u,
    space: d,
    virtual: f,
    dropdownMatchSelectWidth: m,
    popupMatchSelectWidth: v,
    popupOverflow: h,
    legacyLocale: p,
    parentContext: g,
    iconPrefixCls: b,
    theme: y,
    componentDisabled: C,
    segmented: S,
    statistic: $,
    spin: x,
    calendar: w,
    carousel: N,
    cascader: O,
    collapse: E,
    typography: I,
    checkbox: k,
    descriptions: M,
    divider: P,
    drawer: _,
    skeleton: D,
    steps: R,
    image: T,
    layout: L,
    list: F,
    mentions: j,
    modal: A,
    progress: B,
    result: K,
    slider: Y,
    breadcrumb: G,
    menu: te,
    pagination: ee,
    input: oe,
    empty: X,
    badge: W,
    radio: re,
    rate: Z,
    switch: H,
    transfer: U,
    avatar: ae,
    message: ue,
    tag: de,
    table: se,
    card: ie,
    tabs: me,
    timeline: Se,
    timePicker: ve,
    upload: ge,
    notification: $e,
    tree: we,
    colorPicker: _e,
    datePicker: ze,
    rangePicker: Te,
    flex: ke,
    wave: Le,
    dropdown: Ee,
    warning: xe,
    tour: he
  } = e, pe = s.useCallback((Ge, Ae) => {
    const {
      prefixCls: qe
    } = e;
    if (Ae)
      return Ae;
    const Je = qe || g.getPrefixCls("");
    return Ge ? `${Je}-${Ge}` : Je;
  }, [g.getPrefixCls, e.prefixCls]), Pe = b || g.iconPrefixCls || ff, Re = n || g.csp;
  Fb(Pe, Re);
  const at = GO(y, g.theme);
  process.env.NODE_ENV !== "production" && (Ju = Ju || !!at);
  const Ze = {
    csp: Re,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: a,
    locale: l || p,
    direction: u,
    space: d,
    virtual: f,
    popupMatchSelectWidth: v ?? m,
    popupOverflow: h,
    getPrefixCls: pe,
    iconPrefixCls: Pe,
    theme: at,
    segmented: S,
    statistic: $,
    spin: x,
    calendar: w,
    carousel: N,
    cascader: O,
    collapse: E,
    typography: I,
    checkbox: k,
    descriptions: M,
    divider: P,
    drawer: _,
    skeleton: D,
    steps: R,
    image: T,
    input: oe,
    layout: L,
    list: F,
    mentions: j,
    modal: A,
    progress: B,
    result: K,
    slider: Y,
    breadcrumb: G,
    menu: te,
    pagination: ee,
    empty: X,
    badge: W,
    radio: re,
    rate: Z,
    switch: H,
    transfer: U,
    avatar: ae,
    message: ue,
    tag: de,
    table: se,
    card: ie,
    tabs: me,
    timeline: Se,
    timePicker: ve,
    upload: ge,
    notification: $e,
    tree: we,
    colorPicker: _e,
    datePicker: ze,
    rangePicker: Te,
    flex: ke,
    wave: Le,
    dropdown: Ee,
    warning: xe,
    tour: he
  }, Ie = Object.assign({}, g);
  Object.keys(Ze).forEach((Ge) => {
    Ze[Ge] !== void 0 && (Ie[Ge] = Ze[Ge]);
  }), hN.forEach((Ge) => {
    const Ae = e[Ge];
    Ae && (Ie[Ge] = Ae);
  });
  const Be = Fo(() => Ie, Ie, (Ge, Ae) => {
    const qe = Object.keys(Ge), Je = Object.keys(Ae);
    return qe.length !== Je.length || qe.some((Ke) => Ge[Ke] !== Ae[Ke]);
  }), bt = s.useMemo(() => ({
    prefixCls: Pe,
    csp: Re
  }), [Pe, Re]);
  let He = /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(gN, {
    dropdownMatchSelectWidth: m
  }), t);
  const nt = s.useMemo(() => {
    var Ge, Ae, qe, Je;
    return ca(((Ge = xr.Form) === null || Ge === void 0 ? void 0 : Ge.defaultValidateMessages) || {}, ((qe = (Ae = Be.locale) === null || Ae === void 0 ? void 0 : Ae.Form) === null || qe === void 0 ? void 0 : qe.defaultValidateMessages) || {}, ((Je = Be.form) === null || Je === void 0 ? void 0 : Je.validateMessages) || {}, (i == null ? void 0 : i.validateMessages) || {});
  }, [Be, i == null ? void 0 : i.validateMessages]);
  Object.keys(nt).length > 0 && (He = /* @__PURE__ */ s.createElement(hb.Provider, {
    value: nt
  }, He)), l && (He = /* @__PURE__ */ s.createElement(B1, {
    locale: l,
    _ANT_MARK__: Sb
  }, He)), (Pe || Re) && (He = /* @__PURE__ */ s.createElement(cf.Provider, {
    value: bt
  }, He)), c && (He = /* @__PURE__ */ s.createElement($O, {
    size: c
  }, He)), He = /* @__PURE__ */ s.createElement(vN, null, He);
  const et = s.useMemo(() => {
    const Ge = at || {}, {
      algorithm: Ae,
      token: qe,
      components: Je,
      cssVar: Ke
    } = Ge, Ye = pN(Ge, ["algorithm", "token", "components", "cssVar"]), Ve = Ae && (!Array.isArray(Ae) || Ae.length > 0) ? _u(Ae) : Nb, Qe = {};
    Object.entries(Je || {}).forEach((yt) => {
      let [Tt, ne] = yt;
      const ye = Object.assign({}, ne);
      "algorithm" in ye && (ye.algorithm === !0 ? ye.theme = Ve : (Array.isArray(ye.algorithm) || typeof ye.algorithm == "function") && (ye.theme = _u(ye.algorithm)), delete ye.algorithm), Qe[Tt] = ye;
    });
    const it = Object.assign(Object.assign({}, Ei), qe);
    return Object.assign(Object.assign({}, Ye), {
      theme: Ve,
      token: it,
      components: Qe,
      override: Object.assign({
        override: it
      }, Qe),
      cssVar: Ke
    });
  }, [at]);
  return y && (He = /* @__PURE__ */ s.createElement(Pb.Provider, {
    value: et
  }, He)), Be.warning && (He = /* @__PURE__ */ s.createElement(pb.Provider, {
    value: Be.warning
  }, He)), C !== void 0 && (He = /* @__PURE__ */ s.createElement(mf, {
    disabled: C
  }, He)), /* @__PURE__ */ s.createElement(lt.Provider, {
    value: Be
  }, He);
}, Ao = (e) => {
  const t = s.useContext(lt), n = s.useContext(df);
  return /* @__PURE__ */ s.createElement(xN, Object.assign({
    parentContext: t,
    legacyLocale: n
  }, e));
};
Ao.ConfigContext = lt;
Ao.SizeContext = ki;
Ao.config = SN;
Ao.useConfig = wO;
Object.defineProperty(Ao, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && jo(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), ki)
});
process.env.NODE_ENV !== "production" && (Ao.displayName = "ConfigProvider");
const $t = Ao;
var $N = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const wN = $N;
function n0(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function EN(e) {
  return n0(e) instanceof ShadowRoot;
}
function ls(e) {
  return EN(e) ? n0(e) : null;
}
function ON(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function NN(e, t) {
  tt(e, "[@ant-design/icons] ".concat(t));
}
function Iv(e) {
  return mt(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (mt(e.icon) === "object" || typeof e.icon == "function");
}
function Pv() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[ON(n)] = r;
    }
    return t;
  }, {});
}
function Zu(e, t, n) {
  return n ? /* @__PURE__ */ le.createElement(e.tag, V(V({
    key: t
  }, Pv(e.attrs)), n), (e.children || []).map(function(r, o) {
    return Zu(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  })) : /* @__PURE__ */ le.createElement(e.tag, V({
    key: t
  }, Pv(e.attrs)), (e.children || []).map(function(r, o) {
    return Zu(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  }));
}
function r0(e) {
  return Ro(e)[0];
}
function o0(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var IN = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, PN = function(t) {
  var n = qt(cf), r = n.csp, o = n.prefixCls, a = IN;
  o && (a = a.replace(/anticon/g, o)), Bt(function() {
    var i = t.current, l = ls(i);
    ao(a, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: l
    });
  }, []);
}, RN = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], ui = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function MN(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  ui.primaryColor = t, ui.secondaryColor = n || r0(t), ui.calculated = !!n;
}
function TN() {
  return V({}, ui);
}
var _s = function(t) {
  var n = t.icon, r = t.className, o = t.onClick, a = t.style, i = t.primaryColor, l = t.secondaryColor, c = vt(t, RN), u = s.useRef(), d = ui;
  if (i && (d = {
    primaryColor: i,
    secondaryColor: l || r0(i)
  }), PN(u), NN(Iv(n), "icon should be icon definiton, but got ".concat(n)), !Iv(n))
    return null;
  var f = n;
  return f && typeof f.icon == "function" && (f = V(V({}, f), {}, {
    icon: f.icon(d.primaryColor, d.secondaryColor)
  })), Zu(f.icon, "svg-".concat(f.name), V(V({
    className: r,
    onClick: o,
    style: a,
    "data-icon": f.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, c), {}, {
    ref: u
  }));
};
_s.displayName = "IconReact";
_s.getTwoToneColors = TN;
_s.setTwoToneColors = MN;
const yf = _s;
function a0(e) {
  var t = o0(e), n = Q(t, 2), r = n[0], o = n[1];
  return yf.setTwoToneColors({
    primaryColor: r,
    secondaryColor: o
  });
}
function _N() {
  var e = yf.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var DN = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
a0(Wu.primary);
var Ds = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, o = e.spin, a = e.rotate, i = e.tabIndex, l = e.onClick, c = e.twoToneColor, u = vt(e, DN), d = s.useContext(cf), f = d.prefixCls, m = f === void 0 ? "anticon" : f, v = d.rootClassName, h = J(v, m, z(z({}, "".concat(m, "-").concat(r.name), !!r.name), "".concat(m, "-spin"), !!o || r.name === "loading"), n), p = i;
  p === void 0 && l && (p = -1);
  var g = a ? {
    msTransform: "rotate(".concat(a, "deg)"),
    transform: "rotate(".concat(a, "deg)")
  } : void 0, b = o0(c), y = Q(b, 2), C = y[0], S = y[1];
  return /* @__PURE__ */ s.createElement("span", fe({
    role: "img",
    "aria-label": r.name
  }, u, {
    ref: t,
    tabIndex: p,
    onClick: l,
    className: h
  }), /* @__PURE__ */ s.createElement(yf, {
    icon: r,
    primaryColor: C,
    secondaryColor: S,
    style: g
  }));
});
Ds.displayName = "AntdIcon";
Ds.getTwoToneColor = _N;
Ds.setTwoToneColor = a0;
const Ft = Ds;
var i0 = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: wN
  }));
};
process.env.NODE_ENV !== "production" && (i0.displayName = "CheckCircleFilled");
const ks = /* @__PURE__ */ s.forwardRef(i0);
var kN = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const LN = kN;
var l0 = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: LN
  }));
};
process.env.NODE_ENV !== "production" && (l0.displayName = "CloseCircleFilled");
const Bo = /* @__PURE__ */ s.forwardRef(l0);
var FN = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const jN = FN;
var s0 = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: jN
  }));
};
process.env.NODE_ENV !== "production" && (s0.displayName = "CloseOutlined");
const mo = /* @__PURE__ */ s.forwardRef(s0);
var zN = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const AN = zN;
var c0 = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: AN
  }));
};
process.env.NODE_ENV !== "production" && (c0.displayName = "ExclamationCircleFilled");
const Fi = /* @__PURE__ */ s.forwardRef(c0);
var BN = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const HN = BN;
var u0 = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: HN
  }));
};
process.env.NODE_ENV !== "production" && (u0.displayName = "InfoCircleFilled");
const d0 = /* @__PURE__ */ s.forwardRef(u0);
var VN = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, WN = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, KN = "".concat(VN, " ").concat(WN).split(/[\s\n]+/), qN = "aria-", GN = "data-";
function Rv(e, t) {
  return e.indexOf(t) === 0;
}
function Bn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = V({}, t);
  var r = {};
  return Object.keys(e).forEach(function(o) {
    // Aria
    (n.aria && (o === "role" || Rv(o, qN)) || // Data
    n.data && Rv(o, GN) || // Attr
    n.attr && KN.includes(o)) && (r[o] = e[o]);
  }), r;
}
const {
  isValidElement: Kn
} = s;
function f0(e) {
  return e && Kn(e) && e.type === s.Fragment;
}
function UN(e, t, n) {
  return Kn(e) ? /* @__PURE__ */ s.cloneElement(e, typeof n == "function" ? n(e.props || {}) : n) : t;
}
function xn(e, t) {
  return UN(e, e, t);
}
const Mv = (e) => typeof e == "object" && e != null && e.nodeType === 1, Tv = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", zc = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return Tv(n.overflowY, t) || Tv(n.overflowX, t) || ((r) => {
      const o = ((a) => {
        if (!a.ownerDocument || !a.ownerDocument.defaultView)
          return null;
        try {
          return a.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, yl = (e, t, n, r, o, a, i, l) => a < e && i > t || a > e && i < t ? 0 : a <= e && l <= n || i >= t && l >= n ? a - e - r : i > t && l < n || a < e && l > n ? i - t + o : 0, YN = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, _v = (e, t) => {
  var n, r, o, a;
  if (typeof document > "u")
    return [];
  const { scrollMode: i, block: l, inline: c, boundary: u, skipOverflowHiddenElements: d } = t, f = typeof u == "function" ? u : (D) => D !== u;
  if (!Mv(e))
    throw new TypeError("Invalid target");
  const m = document.scrollingElement || document.documentElement, v = [];
  let h = e;
  for (; Mv(h) && f(h); ) {
    if (h = YN(h), h === m) {
      v.push(h);
      break;
    }
    h != null && h === document.body && zc(h) && !zc(document.documentElement) || h != null && zc(h, d) && v.push(h);
  }
  const p = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, g = (a = (o = window.visualViewport) == null ? void 0 : o.height) != null ? a : innerHeight, { scrollX: b, scrollY: y } = window, { height: C, width: S, top: $, right: x, bottom: w, left: N } = e.getBoundingClientRect(), { top: O, right: E, bottom: I, left: k } = ((D) => {
    const R = window.getComputedStyle(D);
    return { top: parseFloat(R.scrollMarginTop) || 0, right: parseFloat(R.scrollMarginRight) || 0, bottom: parseFloat(R.scrollMarginBottom) || 0, left: parseFloat(R.scrollMarginLeft) || 0 };
  })(e);
  let M = l === "start" || l === "nearest" ? $ - O : l === "end" ? w + I : $ + C / 2 - O + I, P = c === "center" ? N + S / 2 - k + E : c === "end" ? x + E : N - k;
  const _ = [];
  for (let D = 0; D < v.length; D++) {
    const R = v[D], { height: T, width: L, top: F, right: j, bottom: A, left: B } = R.getBoundingClientRect();
    if (i === "if-needed" && $ >= 0 && N >= 0 && w <= g && x <= p && $ >= F && w <= A && N >= B && x <= j)
      return _;
    const K = getComputedStyle(R), Y = parseInt(K.borderLeftWidth, 10), G = parseInt(K.borderTopWidth, 10), te = parseInt(K.borderRightWidth, 10), ee = parseInt(K.borderBottomWidth, 10);
    let oe = 0, X = 0;
    const W = "offsetWidth" in R ? R.offsetWidth - R.clientWidth - Y - te : 0, re = "offsetHeight" in R ? R.offsetHeight - R.clientHeight - G - ee : 0, Z = "offsetWidth" in R ? R.offsetWidth === 0 ? 0 : L / R.offsetWidth : 0, H = "offsetHeight" in R ? R.offsetHeight === 0 ? 0 : T / R.offsetHeight : 0;
    if (m === R)
      oe = l === "start" ? M : l === "end" ? M - g : l === "nearest" ? yl(y, y + g, g, G, ee, y + M, y + M + C, C) : M - g / 2, X = c === "start" ? P : c === "center" ? P - p / 2 : c === "end" ? P - p : yl(b, b + p, p, Y, te, b + P, b + P + S, S), oe = Math.max(0, oe + y), X = Math.max(0, X + b);
    else {
      oe = l === "start" ? M - F - G : l === "end" ? M - A + ee + re : l === "nearest" ? yl(F, A, T, G, ee + re, M, M + C, C) : M - (F + T / 2) + re / 2, X = c === "start" ? P - B - Y : c === "center" ? P - (B + L / 2) + W / 2 : c === "end" ? P - j + te + W : yl(B, j, L, Y, te + W, P, P + S, S);
      const { scrollLeft: U, scrollTop: ae } = R;
      oe = H === 0 ? 0 : Math.max(0, Math.min(ae + oe / H, R.scrollHeight - T / H + re)), X = Z === 0 ? 0 : Math.max(0, Math.min(U + X / Z, R.scrollWidth - L / Z + W)), M += ae - oe, P += U - X;
    }
    _.push({ el: R, top: oe, left: X });
  }
  return _;
}, XN = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function QN(e, t) {
  if (!e.isConnected || !((o) => {
    let a = o;
    for (; a && a.parentNode; ) {
      if (a.parentNode === document)
        return !0;
      a = a.parentNode instanceof ShadowRoot ? a.parentNode.host : a.parentNode;
    }
    return !1;
  })(e))
    return;
  const n = ((o) => {
    const a = window.getComputedStyle(o);
    return { top: parseFloat(a.scrollMarginTop) || 0, right: parseFloat(a.scrollMarginRight) || 0, bottom: parseFloat(a.scrollMarginBottom) || 0, left: parseFloat(a.scrollMarginLeft) || 0 };
  })(e);
  if (((o) => typeof o == "object" && typeof o.behavior == "function")(t))
    return t.behavior(_v(e, t));
  const r = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: o, top: a, left: i } of _v(e, XN(t))) {
    const l = a - n.top + n.bottom, c = i - n.left + n.right;
    o.scroll({ top: l, left: c, behavior: r });
  }
}
function ed(e) {
  return e != null && e === e.window;
}
function JN(e, t) {
  var n, r;
  if (typeof window > "u")
    return 0;
  const o = t ? "scrollTop" : "scrollLeft";
  let a = 0;
  return ed(e) ? a = e[t ? "pageYOffset" : "pageXOffset"] : e instanceof Document ? a = e.documentElement[o] : (e instanceof HTMLElement || e) && (a = e[o]), e && !ed(e) && typeof a != "number" && (a = (r = ((n = e.ownerDocument) !== null && n !== void 0 ? n : e).documentElement) === null || r === void 0 ? void 0 : r[o]), a;
}
function ZN(e, t, n, r) {
  const o = n - t;
  return e /= r / 2, e < 1 ? o / 2 * e * e * e + t : o / 2 * ((e -= 2) * e * e + 2) + t;
}
function eI(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    getContainer: n = () => window,
    callback: r,
    duration: o = 450
  } = t, a = n(), i = JN(a, !0), l = Date.now(), c = () => {
    const d = Date.now() - l, f = ZN(d > o ? o : d, i, e, o);
    ed(a) ? a.scrollTo(window.pageXOffset, f) : a instanceof Document || a.constructor.name === "HTMLDocument" ? a.documentElement.scrollTop = f : a.scrollTop = f, d < o ? _t(c) : typeof r == "function" && r();
  };
  _t(c);
}
const tI = (e) => {
  const [, , , , t] = Sn();
  return t ? `${e}-css-var` : "";
}, En = tI;
var Oe = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Oe.F1 && n <= Oe.F12)
      return !1;
    switch (n) {
      case Oe.ALT:
      case Oe.CAPS_LOCK:
      case Oe.CONTEXT_MENU:
      case Oe.CTRL:
      case Oe.DOWN:
      case Oe.END:
      case Oe.ESC:
      case Oe.HOME:
      case Oe.INSERT:
      case Oe.LEFT:
      case Oe.MAC_FF_META:
      case Oe.META:
      case Oe.NUMLOCK:
      case Oe.NUM_CENTER:
      case Oe.PAGE_DOWN:
      case Oe.PAGE_UP:
      case Oe.PAUSE:
      case Oe.PRINT_SCREEN:
      case Oe.RIGHT:
      case Oe.SHIFT:
      case Oe.UP:
      case Oe.WIN_KEY:
      case Oe.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Oe.ZERO && t <= Oe.NINE || t >= Oe.NUM_ZERO && t <= Oe.NUM_MULTIPLY || t >= Oe.A && t <= Oe.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Oe.SPACE:
      case Oe.QUESTION_MARK:
      case Oe.NUM_PLUS:
      case Oe.NUM_MINUS:
      case Oe.NUM_PERIOD:
      case Oe.NUM_DIVISION:
      case Oe.SEMICOLON:
      case Oe.DASH:
      case Oe.EQUALS:
      case Oe.COMMA:
      case Oe.PERIOD:
      case Oe.SLASH:
      case Oe.APOSTROPHE:
      case Oe.SINGLE_QUOTE:
      case Oe.OPEN_SQUARE_BRACKET:
      case Oe.BACKSLASH:
      case Oe.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, m0 = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, o = e.className, a = e.duration, i = a === void 0 ? 4.5 : a, l = e.eventKey, c = e.content, u = e.closable, d = e.closeIcon, f = d === void 0 ? "x" : d, m = e.props, v = e.onClick, h = e.onNoticeClose, p = e.times, g = e.hovering, b = s.useState(!1), y = Q(b, 2), C = y[0], S = y[1], $ = g || C, x = function() {
    h(l);
  }, w = function(E) {
    (E.key === "Enter" || E.code === "Enter" || E.keyCode === Oe.ENTER) && x();
  };
  s.useEffect(function() {
    if (!$ && i > 0) {
      var O = setTimeout(function() {
        x();
      }, i * 1e3);
      return function() {
        clearTimeout(O);
      };
    }
  }, [i, $, p]);
  var N = "".concat(n, "-notice");
  return /* @__PURE__ */ s.createElement("div", fe({}, m, {
    ref: t,
    className: J(N, o, z({}, "".concat(N, "-closable"), u)),
    style: r,
    onMouseEnter: function(E) {
      var I;
      S(!0), m == null || (I = m.onMouseEnter) === null || I === void 0 || I.call(m, E);
    },
    onMouseLeave: function(E) {
      var I;
      S(!1), m == null || (I = m.onMouseLeave) === null || I === void 0 || I.call(m, E);
    },
    onClick: v
  }), /* @__PURE__ */ s.createElement("div", {
    className: "".concat(N, "-content")
  }, c), u && /* @__PURE__ */ s.createElement("a", {
    tabIndex: 0,
    className: "".concat(N, "-close"),
    onKeyDown: w,
    onClick: function(E) {
      E.preventDefault(), E.stopPropagation(), x();
    }
  }, f));
}), v0 = /* @__PURE__ */ le.createContext({}), nI = function(t) {
  var n = t.children, r = t.classNames;
  return /* @__PURE__ */ le.createElement(v0.Provider, {
    value: {
      classNames: r
    }
  }, n);
}, Dv = 8, kv = 3, Lv = 16, rI = function(t) {
  var n = {
    offset: Dv,
    threshold: kv,
    gap: Lv
  };
  if (t && mt(t) === "object") {
    var r, o, a;
    n.offset = (r = t.offset) !== null && r !== void 0 ? r : Dv, n.threshold = (o = t.threshold) !== null && o !== void 0 ? o : kv, n.gap = (a = t.gap) !== null && a !== void 0 ? a : Lv;
  }
  return [!!t, n];
}, oI = ["className", "style", "classNames", "styles"], g0 = function(t) {
  var n, r = t.configList, o = t.placement, a = t.prefixCls, i = t.className, l = t.style, c = t.motion, u = t.onAllNoticeRemoved, d = t.onNoticeClose, f = t.stack, m = qt(v0), v = m.classNames, h = Xe({}), p = Ht(null), g = Q(p, 2), b = g[0], y = g[1], C = Ht([]), S = Q(C, 2), $ = S[0], x = S[1], w = r.map(function(R) {
    return {
      config: R,
      key: String(R.key)
    };
  }), N = rI(f), O = Q(N, 2), E = O[0], I = O[1], k = I.offset, M = I.threshold, P = I.gap, _ = E && ($.length > 0 || w.length <= M), D = typeof c == "function" ? c(o) : c;
  return Bt(function() {
    E && $.length > 1 && x(function(R) {
      return R.filter(function(T) {
        return w.some(function(L) {
          var F = L.key;
          return T === F;
        });
      });
    });
  }, [$, w, E]), Bt(function() {
    var R;
    if (E && h.current[(R = w[w.length - 1]) === null || R === void 0 ? void 0 : R.key]) {
      var T;
      y(h.current[(T = w[w.length - 1]) === null || T === void 0 ? void 0 : T.key]);
    }
  }, [w, E]), /* @__PURE__ */ le.createElement(hf, fe({
    key: o,
    className: J(a, "".concat(a, "-").concat(o), v == null ? void 0 : v.list, i, (n = {}, z(n, "".concat(a, "-stack"), !!E), z(n, "".concat(a, "-stack-expanded"), _), n)),
    style: l,
    keys: w,
    motionAppear: !0
  }, D, {
    onAllRemoved: function() {
      u(o);
    }
  }), function(R, T) {
    var L = R.config, F = R.className, j = R.style, A = R.index, B = L, K = B.key, Y = B.times, G = String(K), te = L, ee = te.className, oe = te.style, X = te.classNames, W = te.styles, re = vt(te, oI), Z = w.findIndex(function($e) {
      return $e.key === G;
    }), H = {};
    if (E) {
      var U = w.length - 1 - (Z > -1 ? Z : A - 1), ae = o === "top" || o === "bottom" ? "-50%" : "0";
      if (U > 0) {
        var ue, de, se;
        H.height = _ ? (ue = h.current[G]) === null || ue === void 0 ? void 0 : ue.offsetHeight : b == null ? void 0 : b.offsetHeight;
        for (var ie = 0, me = 0; me < U; me++) {
          var Se;
          ie += ((Se = h.current[w[w.length - 1 - me].key]) === null || Se === void 0 ? void 0 : Se.offsetHeight) + P;
        }
        var ve = (_ ? ie : U * k) * (o.startsWith("top") ? 1 : -1), ge = !_ && b !== null && b !== void 0 && b.offsetWidth && (de = h.current[G]) !== null && de !== void 0 && de.offsetWidth ? ((b == null ? void 0 : b.offsetWidth) - k * 2 * (U < 3 ? U : 3)) / ((se = h.current[G]) === null || se === void 0 ? void 0 : se.offsetWidth) : 1;
        H.transform = "translate3d(".concat(ae, ", ").concat(ve, "px, 0) scaleX(").concat(ge, ")");
      } else
        H.transform = "translate3d(".concat(ae, ", 0, 0)");
    }
    return /* @__PURE__ */ le.createElement("div", {
      ref: T,
      className: J("".concat(a, "-notice-wrapper"), F, X == null ? void 0 : X.wrapper),
      style: V(V(V({}, j), H), W == null ? void 0 : W.wrapper),
      onMouseEnter: function() {
        return x(function(we) {
          return we.includes(G) ? we : [].concat(be(we), [G]);
        });
      },
      onMouseLeave: function() {
        return x(function(we) {
          return we.filter(function(_e) {
            return _e !== G;
          });
        });
      }
    }, /* @__PURE__ */ le.createElement(m0, fe({}, re, {
      ref: function(we) {
        Z > -1 ? h.current[G] = we : delete h.current[G];
      },
      prefixCls: a,
      classNames: X,
      styles: W,
      className: J(ee, v == null ? void 0 : v.notice),
      style: oe,
      times: Y,
      key: K,
      eventKey: K,
      onNoticeClose: d,
      hovering: E && $.length > 0
    })));
  });
};
process.env.NODE_ENV !== "production" && (g0.displayName = "NoticeList");
var p0 = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-notification" : n, o = e.container, a = e.motion, i = e.maxCount, l = e.className, c = e.style, u = e.onAllRemoved, d = e.stack, f = e.renderNotifications, m = s.useState([]), v = Q(m, 2), h = v[0], p = v[1], g = function(O) {
    var E, I = h.find(function(k) {
      return k.key === O;
    });
    I == null || (E = I.onClose) === null || E === void 0 || E.call(I), p(function(k) {
      return k.filter(function(M) {
        return M.key !== O;
      });
    });
  };
  s.useImperativeHandle(t, function() {
    return {
      open: function(O) {
        p(function(E) {
          var I = be(E), k = I.findIndex(function(_) {
            return _.key === O.key;
          }), M = V({}, O);
          if (k >= 0) {
            var P;
            M.times = (((P = E[k]) === null || P === void 0 ? void 0 : P.times) || 0) + 1, I[k] = M;
          } else
            M.times = 0, I.push(M);
          return i > 0 && I.length > i && (I = I.slice(-i)), I;
        });
      },
      close: function(O) {
        g(O);
      },
      destroy: function() {
        p([]);
      }
    };
  });
  var b = s.useState({}), y = Q(b, 2), C = y[0], S = y[1];
  s.useEffect(function() {
    var N = {};
    h.forEach(function(O) {
      var E = O.placement, I = E === void 0 ? "topRight" : E;
      I && (N[I] = N[I] || [], N[I].push(O));
    }), Object.keys(C).forEach(function(O) {
      N[O] = N[O] || [];
    }), S(N);
  }, [h]);
  var $ = function(O) {
    S(function(E) {
      var I = V({}, E), k = I[O] || [];
      return k.length || delete I[O], I;
    });
  }, x = s.useRef(!1);
  if (s.useEffect(function() {
    Object.keys(C).length > 0 ? x.current = !0 : x.current && (u == null || u(), x.current = !1);
  }, [C]), !o)
    return null;
  var w = Object.keys(C);
  return /* @__PURE__ */ Eh(/* @__PURE__ */ s.createElement(s.Fragment, null, w.map(function(N) {
    var O = C[N], E = /* @__PURE__ */ s.createElement(g0, {
      key: N,
      configList: O,
      placement: N,
      prefixCls: r,
      className: l == null ? void 0 : l(N),
      style: c == null ? void 0 : c(N),
      motion: a,
      onNoticeClose: g,
      onAllNoticeRemoved: $,
      stack: d
    });
    return f ? f(E, {
      prefixCls: r,
      key: N
    }) : E;
  })), o);
});
process.env.NODE_ENV !== "production" && (p0.displayName = "Notifications");
var aI = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], iI = function() {
  return document.body;
}, Fv = 0;
function lI() {
  for (var e = {}, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach(function(o) {
    o && Object.keys(o).forEach(function(a) {
      var i = o[a];
      i !== void 0 && (e[a] = i);
    });
  }), e;
}
function sI() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.getContainer, n = t === void 0 ? iI : t, r = e.motion, o = e.prefixCls, a = e.maxCount, i = e.className, l = e.style, c = e.onAllRemoved, u = e.stack, d = e.renderNotifications, f = vt(e, aI), m = s.useState(), v = Q(m, 2), h = v[0], p = v[1], g = s.useRef(), b = /* @__PURE__ */ s.createElement(p0, {
    container: h,
    ref: g,
    prefixCls: o,
    motion: r,
    maxCount: a,
    className: i,
    style: l,
    onAllRemoved: c,
    stack: u,
    renderNotifications: d
  }), y = s.useState([]), C = Q(y, 2), S = C[0], $ = C[1], x = s.useMemo(function() {
    return {
      open: function(N) {
        var O = lI(f, N);
        (O.key === null || O.key === void 0) && (O.key = "rc-notification-".concat(Fv), Fv += 1), $(function(E) {
          return [].concat(be(E), [{
            type: "open",
            config: O
          }]);
        });
      },
      close: function(N) {
        $(function(O) {
          return [].concat(be(O), [{
            type: "close",
            key: N
          }]);
        });
      },
      destroy: function() {
        $(function(N) {
          return [].concat(be(N), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return s.useEffect(function() {
    p(n());
  }), s.useEffect(function() {
    g.current && S.length && (S.forEach(function(w) {
      switch (w.type) {
        case "open":
          g.current.open(w.config);
          break;
        case "close":
          g.current.close(w.key);
          break;
        case "destroy":
          g.current.destroy();
          break;
      }
    }), $(function(w) {
      return w.filter(function(N) {
        return !S.includes(N);
      });
    }));
  }, [S]), [x, b];
}
var cI = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const uI = cI;
var h0 = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: uI
  }));
};
process.env.NODE_ENV !== "production" && (h0.displayName = "LoadingOutlined");
const To = /* @__PURE__ */ s.forwardRef(h0), b0 = /* @__PURE__ */ le.createContext(void 0);
process.env.NODE_ENV !== "production" && (b0.displayName = "zIndexContext");
const ji = b0, So = 100, dI = 10, Cf = So * dI, y0 = {
  Modal: So,
  Drawer: So,
  Popover: So,
  Popconfirm: So,
  Tooltip: So,
  Tour: So
}, fI = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function mI(e) {
  return e in y0;
}
function vo(e, t) {
  const [, n] = Sn(), r = le.useContext(ji), o = mI(e);
  if (t !== void 0)
    return [t, t];
  let a = r ?? 0;
  return o ? (a += // Use preset token zIndex by default but not stack when has parent container
  (r ? 0 : n.zIndexPopupBase) + // Container offset
  y0[e], a = Math.min(a, n.zIndexPopupBase + Cf)) : a += fI[e], [r === void 0 ? t : a, a];
}
function vI() {
  const [e, t] = s.useState([]), n = s.useCallback((r) => (t((o) => [].concat(be(o), [r])), () => {
    t((o) => o.filter((a) => a !== r));
  }), []);
  return [e, n];
}
function Fn() {
  Fn = function() {
    return t;
  };
  var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(D, R, T) {
    D[R] = T.value;
  }, a = typeof Symbol == "function" ? Symbol : {}, i = a.iterator || "@@iterator", l = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
  function u(D, R, T) {
    return Object.defineProperty(D, R, {
      value: T,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), D[R];
  }
  try {
    u({}, "");
  } catch {
    u = function(T, L, F) {
      return T[L] = F;
    };
  }
  function d(D, R, T, L) {
    var F = R && R.prototype instanceof b ? R : b, j = Object.create(F.prototype), A = new P(L || []);
    return o(j, "_invoke", {
      value: E(D, T, A)
    }), j;
  }
  function f(D, R, T) {
    try {
      return {
        type: "normal",
        arg: D.call(R, T)
      };
    } catch (L) {
      return {
        type: "throw",
        arg: L
      };
    }
  }
  t.wrap = d;
  var m = "suspendedStart", v = "suspendedYield", h = "executing", p = "completed", g = {};
  function b() {
  }
  function y() {
  }
  function C() {
  }
  var S = {};
  u(S, i, function() {
    return this;
  });
  var $ = Object.getPrototypeOf, x = $ && $($(_([])));
  x && x !== n && r.call(x, i) && (S = x);
  var w = C.prototype = b.prototype = Object.create(S);
  function N(D) {
    ["next", "throw", "return"].forEach(function(R) {
      u(D, R, function(T) {
        return this._invoke(R, T);
      });
    });
  }
  function O(D, R) {
    function T(F, j, A, B) {
      var K = f(D[F], D, j);
      if (K.type !== "throw") {
        var Y = K.arg, G = Y.value;
        return G && mt(G) == "object" && r.call(G, "__await") ? R.resolve(G.__await).then(function(te) {
          T("next", te, A, B);
        }, function(te) {
          T("throw", te, A, B);
        }) : R.resolve(G).then(function(te) {
          Y.value = te, A(Y);
        }, function(te) {
          return T("throw", te, A, B);
        });
      }
      B(K.arg);
    }
    var L;
    o(this, "_invoke", {
      value: function(j, A) {
        function B() {
          return new R(function(K, Y) {
            T(j, A, K, Y);
          });
        }
        return L = L ? L.then(B, B) : B();
      }
    });
  }
  function E(D, R, T) {
    var L = m;
    return function(F, j) {
      if (L === h)
        throw new Error("Generator is already running");
      if (L === p) {
        if (F === "throw")
          throw j;
        return {
          value: e,
          done: !0
        };
      }
      for (T.method = F, T.arg = j; ; ) {
        var A = T.delegate;
        if (A) {
          var B = I(A, T);
          if (B) {
            if (B === g)
              continue;
            return B;
          }
        }
        if (T.method === "next")
          T.sent = T._sent = T.arg;
        else if (T.method === "throw") {
          if (L === m)
            throw L = p, T.arg;
          T.dispatchException(T.arg);
        } else
          T.method === "return" && T.abrupt("return", T.arg);
        L = h;
        var K = f(D, R, T);
        if (K.type === "normal") {
          if (L = T.done ? p : v, K.arg === g)
            continue;
          return {
            value: K.arg,
            done: T.done
          };
        }
        K.type === "throw" && (L = p, T.method = "throw", T.arg = K.arg);
      }
    };
  }
  function I(D, R) {
    var T = R.method, L = D.iterator[T];
    if (L === e)
      return R.delegate = null, T === "throw" && D.iterator.return && (R.method = "return", R.arg = e, I(D, R), R.method === "throw") || T !== "return" && (R.method = "throw", R.arg = new TypeError("The iterator does not provide a '" + T + "' method")), g;
    var F = f(L, D.iterator, R.arg);
    if (F.type === "throw")
      return R.method = "throw", R.arg = F.arg, R.delegate = null, g;
    var j = F.arg;
    return j ? j.done ? (R[D.resultName] = j.value, R.next = D.nextLoc, R.method !== "return" && (R.method = "next", R.arg = e), R.delegate = null, g) : j : (R.method = "throw", R.arg = new TypeError("iterator result is not an object"), R.delegate = null, g);
  }
  function k(D) {
    var R = {
      tryLoc: D[0]
    };
    1 in D && (R.catchLoc = D[1]), 2 in D && (R.finallyLoc = D[2], R.afterLoc = D[3]), this.tryEntries.push(R);
  }
  function M(D) {
    var R = D.completion || {};
    R.type = "normal", delete R.arg, D.completion = R;
  }
  function P(D) {
    this.tryEntries = [{
      tryLoc: "root"
    }], D.forEach(k, this), this.reset(!0);
  }
  function _(D) {
    if (D || D === "") {
      var R = D[i];
      if (R)
        return R.call(D);
      if (typeof D.next == "function")
        return D;
      if (!isNaN(D.length)) {
        var T = -1, L = function F() {
          for (; ++T < D.length; )
            if (r.call(D, T))
              return F.value = D[T], F.done = !1, F;
          return F.value = e, F.done = !0, F;
        };
        return L.next = L;
      }
    }
    throw new TypeError(mt(D) + " is not iterable");
  }
  return y.prototype = C, o(w, "constructor", {
    value: C,
    configurable: !0
  }), o(C, "constructor", {
    value: y,
    configurable: !0
  }), y.displayName = u(C, c, "GeneratorFunction"), t.isGeneratorFunction = function(D) {
    var R = typeof D == "function" && D.constructor;
    return !!R && (R === y || (R.displayName || R.name) === "GeneratorFunction");
  }, t.mark = function(D) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(D, C) : (D.__proto__ = C, u(D, c, "GeneratorFunction")), D.prototype = Object.create(w), D;
  }, t.awrap = function(D) {
    return {
      __await: D
    };
  }, N(O.prototype), u(O.prototype, l, function() {
    return this;
  }), t.AsyncIterator = O, t.async = function(D, R, T, L, F) {
    F === void 0 && (F = Promise);
    var j = new O(d(D, R, T, L), F);
    return t.isGeneratorFunction(R) ? j : j.next().then(function(A) {
      return A.done ? A.value : j.next();
    });
  }, N(w), u(w, c, "Generator"), u(w, i, function() {
    return this;
  }), u(w, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(D) {
    var R = Object(D), T = [];
    for (var L in R)
      T.push(L);
    return T.reverse(), function F() {
      for (; T.length; ) {
        var j = T.pop();
        if (j in R)
          return F.value = j, F.done = !1, F;
      }
      return F.done = !0, F;
    };
  }, t.values = _, P.prototype = {
    constructor: P,
    reset: function(R) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(M), !R)
        for (var T in this)
          T.charAt(0) === "t" && r.call(this, T) && !isNaN(+T.slice(1)) && (this[T] = e);
    },
    stop: function() {
      this.done = !0;
      var R = this.tryEntries[0].completion;
      if (R.type === "throw")
        throw R.arg;
      return this.rval;
    },
    dispatchException: function(R) {
      if (this.done)
        throw R;
      var T = this;
      function L(Y, G) {
        return A.type = "throw", A.arg = R, T.next = Y, G && (T.method = "next", T.arg = e), !!G;
      }
      for (var F = this.tryEntries.length - 1; F >= 0; --F) {
        var j = this.tryEntries[F], A = j.completion;
        if (j.tryLoc === "root")
          return L("end");
        if (j.tryLoc <= this.prev) {
          var B = r.call(j, "catchLoc"), K = r.call(j, "finallyLoc");
          if (B && K) {
            if (this.prev < j.catchLoc)
              return L(j.catchLoc, !0);
            if (this.prev < j.finallyLoc)
              return L(j.finallyLoc);
          } else if (B) {
            if (this.prev < j.catchLoc)
              return L(j.catchLoc, !0);
          } else {
            if (!K)
              throw new Error("try statement without catch or finally");
            if (this.prev < j.finallyLoc)
              return L(j.finallyLoc);
          }
        }
      }
    },
    abrupt: function(R, T) {
      for (var L = this.tryEntries.length - 1; L >= 0; --L) {
        var F = this.tryEntries[L];
        if (F.tryLoc <= this.prev && r.call(F, "finallyLoc") && this.prev < F.finallyLoc) {
          var j = F;
          break;
        }
      }
      j && (R === "break" || R === "continue") && j.tryLoc <= T && T <= j.finallyLoc && (j = null);
      var A = j ? j.completion : {};
      return A.type = R, A.arg = T, j ? (this.method = "next", this.next = j.finallyLoc, g) : this.complete(A);
    },
    complete: function(R, T) {
      if (R.type === "throw")
        throw R.arg;
      return R.type === "break" || R.type === "continue" ? this.next = R.arg : R.type === "return" ? (this.rval = this.arg = R.arg, this.method = "return", this.next = "end") : R.type === "normal" && T && (this.next = T), g;
    },
    finish: function(R) {
      for (var T = this.tryEntries.length - 1; T >= 0; --T) {
        var L = this.tryEntries[T];
        if (L.finallyLoc === R)
          return this.complete(L.completion, L.afterLoc), M(L), g;
      }
    },
    catch: function(R) {
      for (var T = this.tryEntries.length - 1; T >= 0; --T) {
        var L = this.tryEntries[T];
        if (L.tryLoc === R) {
          var F = L.completion;
          if (F.type === "throw") {
            var j = F.arg;
            M(L);
          }
          return j;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(R, T, L) {
      return this.delegate = {
        iterator: _(R),
        resultName: T,
        nextLoc: L
      }, this.method === "next" && (this.arg = e), g;
    }
  }, t;
}
function jv(e, t, n, r, o, a, i) {
  try {
    var l = e[a](i), c = l.value;
  } catch (u) {
    n(u);
    return;
  }
  l.done ? t(c) : Promise.resolve(c).then(r, o);
}
function go(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, o) {
      var a = e.apply(t, n);
      function i(c) {
        jv(a, r, o, i, l, "next", c);
      }
      function l(c) {
        jv(a, r, o, i, l, "throw", c);
      }
      i(void 0);
    });
  };
}
var zi = V({}, Tw), gI = zi.version, pI = zi.render, hI = zi.unmountComponentAtNode, Ls;
try {
  var bI = Number((gI || "").split(".")[0]);
  bI >= 18 && (Ls = zi.createRoot);
} catch {
}
function zv(e) {
  var t = zi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && mt(t) === "object" && (t.usingClientEntryPoint = e);
}
var ss = "__rc_react_root__";
function yI(e, t) {
  zv(!0);
  var n = t[ss] || Ls(t);
  zv(!1), n.render(e), t[ss] = n;
}
function CI(e, t) {
  pI(e, t);
}
function Sf(e, t) {
  if (Ls) {
    yI(e, t);
    return;
  }
  CI(e, t);
}
function SI(e) {
  return td.apply(this, arguments);
}
function td() {
  return td = go(/* @__PURE__ */ Fn().mark(function e(t) {
    return Fn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var o;
              (o = t[ss]) === null || o === void 0 || o.unmount(), delete t[ss];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), td.apply(this, arguments);
}
function xI(e) {
  hI(e);
}
function C0(e) {
  return nd.apply(this, arguments);
}
function nd() {
  return nd = go(/* @__PURE__ */ Fn().mark(function e(t) {
    return Fn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (Ls === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", SI(t));
          case 2:
            xI(t);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), nd.apply(this, arguments);
}
const Ac = () => ({
  height: 0,
  opacity: 0
}), Av = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, $I = (e) => ({
  height: e ? e.offsetHeight : 0
}), Bc = (e, t) => (t == null ? void 0 : t.deadline) === !0 || t.propertyName === "height", wI = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: Ac,
    onEnterStart: Ac,
    onAppearActive: Av,
    onEnterActive: Av,
    onLeaveStart: $I,
    onLeaveActive: Ac,
    onAppearEnd: Bc,
    onEnterEnd: Bc,
    onLeaveEnd: Bc,
    motionDeadline: 500
  };
}, Pr = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, ya = wI, Ai = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect(), a = o.width, i = o.height;
      if (a || i)
        return !0;
    }
  }
  return !1;
}, EI = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow 0.3s ${e.motionEaseInOut}`, `opacity 0.35s ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, OI = gf("Wave", (e) => [EI(e)]);
function NI(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function Hc(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && NI(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function II(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return Hc(t) ? t : Hc(n) ? n : Hc(r) ? r : null;
}
const Fs = "ant-wave-target";
function Vc(e) {
  return Number.isNaN(e) ? 0 : e;
}
const PI = (e) => {
  const {
    className: t,
    target: n,
    component: r
  } = e, o = s.useRef(null), [a, i] = s.useState(null), [l, c] = s.useState([]), [u, d] = s.useState(0), [f, m] = s.useState(0), [v, h] = s.useState(0), [p, g] = s.useState(0), [b, y] = s.useState(!1), C = {
    left: u,
    top: f,
    width: v,
    height: p,
    borderRadius: l.map((x) => `${x}px`).join(" ")
  };
  a && (C["--wave-color"] = a);
  function S() {
    const x = getComputedStyle(n);
    i(II(n));
    const w = x.position === "static", {
      borderLeftWidth: N,
      borderTopWidth: O
    } = x;
    d(w ? n.offsetLeft : Vc(-parseFloat(N))), m(w ? n.offsetTop : Vc(-parseFloat(O))), h(n.offsetWidth), g(n.offsetHeight);
    const {
      borderTopLeftRadius: E,
      borderTopRightRadius: I,
      borderBottomLeftRadius: k,
      borderBottomRightRadius: M
    } = x;
    c([E, I, M, k].map((P) => Vc(parseFloat(P))));
  }
  if (s.useEffect(() => {
    if (n) {
      const x = _t(() => {
        S(), y(!0);
      });
      let w;
      return typeof ResizeObserver < "u" && (w = new ResizeObserver(S), w.observe(n)), () => {
        _t.cancel(x), w == null || w.disconnect();
      };
    }
  }, []), !b)
    return null;
  const $ = (r === "Checkbox" || r === "Radio") && (n == null ? void 0 : n.classList.contains(Fs));
  return /* @__PURE__ */ s.createElement(An, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (x, w) => {
      var N;
      if (w.deadline || w.propertyName === "opacity") {
        const O = (N = o.current) === null || N === void 0 ? void 0 : N.parentElement;
        C0(O).then(() => {
          O == null || O.remove();
        });
      }
      return !1;
    }
  }, (x) => {
    let {
      className: w
    } = x;
    return /* @__PURE__ */ s.createElement("div", {
      ref: o,
      className: J(t, {
        "wave-quick": $
      }, w),
      style: C
    });
  });
}, RI = (e, t) => {
  var n;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((n = e.querySelector("input")) === null || n === void 0) && n.checked))
    return;
  const o = document.createElement("div");
  o.style.position = "absolute", o.style.left = "0px", o.style.top = "0px", e == null || e.insertBefore(o, e == null ? void 0 : e.firstChild), Sf(/* @__PURE__ */ s.createElement(PI, Object.assign({}, t, {
    target: e
  })), o);
}, MI = RI;
function TI(e, t, n) {
  const {
    wave: r
  } = s.useContext(lt), [, o, a] = Sn(), i = Lt((u) => {
    const d = e.current;
    if (r != null && r.disabled || !d)
      return;
    const f = d.querySelector(`.${Fs}`) || d, {
      showEffect: m
    } = r || {};
    (m || MI)(f, {
      className: t,
      token: o,
      component: n,
      event: u,
      hashId: a
    });
  }), l = s.useRef();
  return (u) => {
    _t.cancel(l.current), l.current = _t(() => {
      i(u);
    });
  };
}
const S0 = (e) => {
  const {
    children: t,
    disabled: n,
    component: r
  } = e, {
    getPrefixCls: o
  } = qt(lt), a = Xe(null), i = o("wave"), [, l] = OI(i), c = TI(a, J(i, l), r);
  if (le.useEffect(() => {
    const d = a.current;
    if (!d || d.nodeType !== 1 || n)
      return;
    const f = (m) => {
      !Ai(m.target) || // No need wave
      !d.getAttribute || d.getAttribute("disabled") || d.disabled || d.className.includes("disabled") || d.className.includes("-leave") || c(m);
    };
    return d.addEventListener("click", f, !0), () => {
      d.removeEventListener("click", f, !0);
    };
  }, [n]), !/* @__PURE__ */ le.isValidElement(t))
    return t ?? null;
  const u = Sr(t) ? Un(t.ref, a) : a;
  return xn(t, {
    ref: u
  });
};
process.env.NODE_ENV !== "production" && (S0.displayName = "Wave");
const Bi = S0, _I = (e) => {
  const t = le.useContext(ki);
  return le.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, qn = _I, DI = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, kI = DI, LI = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      }
    }
  };
}, FI = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, x0 = Xt("Space", (e) => {
  const t = Dt(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [LI(t), FI(t), kI(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var $0 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const js = /* @__PURE__ */ s.createContext(null), Ho = (e, t) => {
  const n = s.useContext(js), r = s.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: o,
      isFirstItem: a,
      isLastItem: i
    } = n, l = o === "vertical" ? "-vertical-" : "-";
    return J(`${e}-compact${l}item`, {
      [`${e}-compact${l}first-item`]: a,
      [`${e}-compact${l}last-item`]: i,
      [`${e}-compact${l}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
}, so = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ s.createElement(js.Provider, {
    value: null
  }, t);
}, jI = (e) => {
  var {
    children: t
  } = e, n = $0(e, ["children"]);
  return /* @__PURE__ */ s.createElement(js.Provider, {
    value: n
  }, t);
}, zI = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = s.useContext(lt), {
    size: r,
    direction: o,
    block: a,
    prefixCls: i,
    className: l,
    rootClassName: c,
    children: u
  } = e, d = $0(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), f = qn((C) => r ?? C), m = t("space-compact", i), [v, h] = x0(m), p = J(m, h, {
    [`${m}-rtl`]: n === "rtl",
    [`${m}-block`]: a,
    [`${m}-vertical`]: o === "vertical"
  }, l, c), g = s.useContext(js), b = Pn(u), y = s.useMemo(() => b.map((C, S) => {
    const $ = C && C.key || `${m}-item-${S}`;
    return /* @__PURE__ */ s.createElement(jI, {
      key: $,
      compactSize: f,
      compactDirection: o,
      isFirstItem: S === 0 && (!g || (g == null ? void 0 : g.isFirstItem)),
      isLastItem: S === b.length - 1 && (!g || (g == null ? void 0 : g.isLastItem))
    }, C);
  }), [r, b, g]);
  return b.length === 0 ? null : v(/* @__PURE__ */ s.createElement("div", Object.assign({
    className: p
  }, d), y));
}, AI = zI;
var BI = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const w0 = /* @__PURE__ */ s.createContext(void 0), HI = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = s.useContext(lt), {
    prefixCls: r,
    size: o,
    className: a
  } = e, i = BI(e, ["prefixCls", "size", "className"]), l = t("btn-group", r), [, , c] = Sn();
  let u = "";
  switch (o) {
    case "large":
      u = "lg";
      break;
    case "small":
      u = "sm";
      break;
  }
  if (process.env.NODE_ENV !== "production") {
    const f = Rt("Button.Group");
    process.env.NODE_ENV !== "production" && f(!o || ["large", "small", "middle"].includes(o), "usage", "Invalid prop `size`.");
  }
  const d = J(l, {
    [`${l}-${u}`]: u,
    [`${l}-rtl`]: n === "rtl"
  }, a, c);
  return /* @__PURE__ */ s.createElement(w0.Provider, {
    value: o
  }, /* @__PURE__ */ s.createElement("div", Object.assign({}, i, {
    className: d
  })));
}, VI = HI, Bv = /^[\u4e00-\u9fa5]{2}$/, rd = Bv.test.bind(Bv);
function xf(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
function Hv(e) {
  return typeof e == "string";
}
function Cl(e) {
  return e === "text" || e === "link";
}
function WI(e, t) {
  if (e == null)
    return;
  const n = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && Hv(e.type) && rd(e.props.children) ? xn(e, {
    children: e.props.children.split("").join(n)
  }) : Hv(e) ? rd(e) ? /* @__PURE__ */ le.createElement("span", null, e.split("").join(n)) : /* @__PURE__ */ le.createElement("span", null, e) : f0(e) ? /* @__PURE__ */ le.createElement("span", null, e) : e;
}
function KI(e, t) {
  let n = !1;
  const r = [];
  return le.Children.forEach(e, (o) => {
    const a = typeof o, i = a === "string" || a === "number";
    if (n && i) {
      const l = r.length - 1, c = r[l];
      r[l] = `${c}${o}`;
    } else
      r.push(o);
    n = i;
  }), le.Children.map(r, (o) => WI(o, t));
}
const qI = /* @__PURE__ */ ar((e, t) => {
  const {
    className: n,
    style: r,
    children: o,
    prefixCls: a
  } = e, i = J(`${a}-icon`, n);
  return /* @__PURE__ */ le.createElement("span", {
    ref: t,
    className: i,
    style: r
  }, o);
}), E0 = qI, Vv = /* @__PURE__ */ ar((e, t) => {
  let {
    prefixCls: n,
    className: r,
    style: o,
    iconClassName: a
  } = e;
  const i = J(`${n}-loading-icon`, r);
  return /* @__PURE__ */ le.createElement(E0, {
    prefixCls: n,
    className: i,
    style: o,
    ref: t
  }, /* @__PURE__ */ le.createElement(To, {
    className: a
  }));
}), Wc = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), Kc = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), GI = (e) => {
  const {
    prefixCls: t,
    loading: n,
    existIcon: r,
    className: o,
    style: a
  } = e, i = !!n;
  return r ? /* @__PURE__ */ le.createElement(Vv, {
    prefixCls: t,
    className: o,
    style: a
  }) : /* @__PURE__ */ le.createElement(An, {
    visible: i,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: i,
    removeOnLeave: !0,
    onAppearStart: Wc,
    onAppearActive: Kc,
    onEnterStart: Wc,
    onEnterActive: Kc,
    onLeaveStart: Kc,
    onLeaveActive: Wc
  }, (l, c) => {
    let {
      className: u,
      style: d
    } = l;
    return /* @__PURE__ */ le.createElement(Vv, {
      prefixCls: t,
      className: o,
      style: Object.assign(Object.assign({}, a), d),
      ref: c,
      iconClassName: u
    });
  });
}, UI = GI, Wv = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), YI = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    groupBorderColor: o,
    colorErrorHover: a
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          [`&:hover,
          &:focus,
          &:active`]: {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      Wv(`${t}-primary`, o),
      Wv(`${t}-danger`, a)
    ]
  };
}, XI = YI, O0 = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: n,
    paddingBlock: r
  } = e;
  return Dt(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: r,
    buttonIconOnlyFontSize: n
  });
}, N0 = (e) => {
  var t, n, r, o, a, i;
  const l = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, c = (n = e.contentFontSizeSM) !== null && n !== void 0 ? n : e.fontSize, u = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, d = (o = e.contentLineHeight) !== null && o !== void 0 ? o : Vl(l), f = (a = e.contentLineHeightSM) !== null && a !== void 0 ? a : Vl(c), m = (i = e.contentLineHeightLG) !== null && i !== void 0 ? i : Vl(u);
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: e.colorBgTextHover,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    contentFontSize: l,
    contentFontSizeSM: c,
    contentFontSizeLG: u,
    contentLineHeight: d,
    contentLineHeightSM: f,
    contentLineHeightLG: m,
    paddingBlock: Math.max((e.controlHeight - l * d) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - c * f) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - u * m) / 2 - e.lineWidth, 0)
  };
}, QI = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontWeight: r
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-block",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${q(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 0
      },
      // Leave a space between icon and text.
      [`> ${n} + span, > span + ${n}`]: {
        marginInlineStart: e.marginXS
      },
      [`&:not(${t}-icon-only) > ${t}-icon`]: {
        [`&${t}-loading-icon, &:not(:last-child)`]: {
          marginInlineEnd: e.marginXS
        }
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, lo(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${n})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // make `btn-icon-only` not too narrow
      [`&-icon-only${t}-compact-item`]: {
        flex: "none"
      }
    }
  };
}, Wr = (e, t, n) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": n
  }
}), JI = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), ZI = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), eP = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), Ni = (e, t, n, r, o, a, i, l) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: n || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, Wr(e, Object.assign({
    background: t
  }, i), Object.assign({
    background: t
  }, l))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: o || void 0,
      borderColor: a || void 0
    }
  })
}), $f = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, eP(e))
}), I0 = (e) => Object.assign({}, $f(e)), cs = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), P0 = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, I0(e)), {
  background: e.defaultBg,
  borderColor: e.defaultBorderColor,
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}), Wr(e.componentCls, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), Ni(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: e.colorError,
    borderColor: e.colorError
  }, Wr(e.componentCls, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorBorderHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), Ni(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder)), $f(e))
}), tP = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, I0(e)), {
  color: e.primaryColor,
  background: e.colorPrimary,
  boxShadow: e.primaryShadow
}), Wr(e.componentCls, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryHover
}, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryActive
})), Ni(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: e.colorError,
    boxShadow: e.dangerShadow,
    color: e.dangerColor
  }, Wr(e.componentCls, {
    background: e.colorErrorHover
  }, {
    background: e.colorErrorActive
  })), Ni(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), $f(e))
}), nP = (e) => Object.assign(Object.assign({}, P0(e)), {
  borderStyle: "dashed"
}), rP = (e) => Object.assign(Object.assign(Object.assign({
  color: e.colorLink
}, Wr(e.componentCls, {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), cs(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, Wr(e.componentCls, {
    color: e.colorErrorHover
  }, {
    color: e.colorErrorActive
  })), cs(e))
}), oP = (e) => Object.assign(Object.assign(Object.assign({}, Wr(e.componentCls, {
  color: e.colorText,
  background: e.textHoverBg
}, {
  color: e.colorText,
  background: e.colorBgTextActive
})), cs(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, cs(e)), Wr(e.componentCls, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }))
}), aP = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-default`]: P0(e),
    [`${t}-primary`]: tP(e),
    [`${t}-dashed`]: nP(e),
    [`${t}-link`]: rP(e),
    [`${t}-text`]: oP(e),
    [`${t}-ghost`]: Ni(e.componentCls, e.ghostBg, e.colorBgContainer, e.colorBgContainer, e.colorTextDisabled, e.colorBorder)
  };
}, wf = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    controlHeight: r,
    fontSize: o,
    lineHeight: a,
    borderRadius: i,
    buttonPaddingHorizontal: l,
    iconCls: c,
    buttonPaddingVertical: u
  } = e, d = `${n}-icon-only`;
  return [
    {
      [`${t}`]: {
        fontSize: o,
        lineHeight: a,
        height: r,
        padding: `${q(u)} ${q(l)}`,
        borderRadius: i,
        [`&${d}`]: {
          width: r,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
          [`&${n}-round`]: {
            width: "auto"
          },
          [c]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${n}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${n}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: JI(e)
    },
    {
      [`${n}${n}-round${t}`]: ZI(e)
    }
  ];
}, iP = (e) => {
  const t = Dt(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return wf(t, e.componentCls);
}, lP = (e) => {
  const t = Dt(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return wf(t, `${e.componentCls}-sm`);
}, sP = (e) => {
  const t = Dt(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return wf(t, `${e.componentCls}-lg`);
}, cP = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, uP = Xt("Button", (e) => {
  const t = O0(e);
  return [
    // Shared
    QI(t),
    // Size
    iP(t),
    lP(t),
    sP(t),
    // Block
    cP(t),
    // Group (type, ghost, danger, loading)
    aP(t),
    // Button Group
    XI(t)
  ];
}, N0, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function dP(e, t, n) {
  const {
    focusElCls: r,
    focus: o,
    borderElCls: a
  } = n, i = a ? "> *" : "", l = ["hover", o ? "focus" : null, "active"].filter(Boolean).map((c) => `&:${c} ${i}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [l]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${i}`]: {
        zIndex: 0
      }
    })
  };
}
function fP(e, t, n) {
  const {
    borderElCls: r
  } = n, o = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${o}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function zs(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, dP(e, r, t)), fP(n, r, t))
  };
}
function mP(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function vP(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function gP(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, mP(e, t)), vP(e.componentCls, t))
  };
}
const pP = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: n(e.lineWidth).mul(-1).equal(),
            insetInlineStart: n(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${q(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: n(e.lineWidth).mul(-1).equal(),
              insetInlineStart: n(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${q(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, hP = zo(["Button", "compact"], (e) => {
  const t = O0(e);
  return [
    // Space Compact
    zs(t),
    gP(t),
    pP(t)
  ];
}, N0);
var bP = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function yP(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const CP = (e, t) => {
  var n, r;
  const {
    loading: o = !1,
    prefixCls: a,
    type: i = "default",
    danger: l,
    shape: c = "default",
    size: u,
    styles: d,
    disabled: f,
    className: m,
    rootClassName: v,
    children: h,
    icon: p,
    ghost: g = !1,
    block: b = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: y = "button",
    classNames: C,
    style: S = {}
  } = e, $ = bP(e, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "ghost", "block", "htmlType", "classNames", "style"]), {
    getPrefixCls: x,
    autoInsertSpaceInButton: w,
    direction: N,
    button: O
  } = qt(lt), E = x("btn", a), [I, k, M] = uP(E), P = qt(dr), _ = f ?? P, D = qt(w0), R = nn(() => yP(o), [o]), [T, L] = Ht(R.loading), [F, j] = Ht(!1), B = Un(t, /* @__PURE__ */ Rw()), K = Pw.count(h) === 1 && !p && !Cl(i);
  Bt(() => {
    let me = null;
    R.delay > 0 ? me = setTimeout(() => {
      me = null, L(!0);
    }, R.delay) : L(R.loading);
    function Se() {
      me && (clearTimeout(me), me = null);
    }
    return Se;
  }, [R]), Bt(() => {
    if (!B || !B.current || w === !1)
      return;
    const me = B.current.textContent;
    K && rd(me) ? F || j(!0) : F && j(!1);
  }, [B]);
  const Y = (me) => {
    const {
      onClick: Se
    } = e;
    if (T || _) {
      me.preventDefault();
      return;
    }
    Se == null || Se(me);
  };
  if (process.env.NODE_ENV !== "production") {
    const me = Rt("Button");
    process.env.NODE_ENV !== "production" && me(!(typeof p == "string" && p.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${p}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && me(!(g && Cl(i)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const G = w !== !1, {
    compactSize: te,
    compactItemClassnames: ee
  } = Ho(E, N), oe = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, X = qn((me) => {
    var Se, ve;
    return (ve = (Se = u ?? te) !== null && Se !== void 0 ? Se : D) !== null && ve !== void 0 ? ve : me;
  }), W = X && oe[X] || "", re = T ? "loading" : p, Z = an($, ["navigate"]), H = J(E, k, M, {
    [`${E}-${c}`]: c !== "default" && c,
    [`${E}-${i}`]: i,
    [`${E}-${W}`]: W,
    [`${E}-icon-only`]: !h && h !== 0 && !!re,
    [`${E}-background-ghost`]: g && !Cl(i),
    [`${E}-loading`]: T,
    [`${E}-two-chinese-chars`]: F && G && !T,
    [`${E}-block`]: b,
    [`${E}-dangerous`]: !!l,
    [`${E}-rtl`]: N === "rtl"
  }, ee, m, v, O == null ? void 0 : O.className), U = Object.assign(Object.assign({}, O == null ? void 0 : O.style), S), ae = J(C == null ? void 0 : C.icon, (n = O == null ? void 0 : O.classNames) === null || n === void 0 ? void 0 : n.icon), ue = Object.assign(Object.assign({}, (d == null ? void 0 : d.icon) || {}), ((r = O == null ? void 0 : O.styles) === null || r === void 0 ? void 0 : r.icon) || {}), de = p && !T ? /* @__PURE__ */ le.createElement(E0, {
    prefixCls: E,
    className: ae,
    style: ue
  }, p) : /* @__PURE__ */ le.createElement(UI, {
    existIcon: !!p,
    prefixCls: E,
    loading: !!T
  }), se = h || h === 0 ? KI(h, K && G) : null;
  if (Z.href !== void 0)
    return I(/* @__PURE__ */ le.createElement("a", Object.assign({}, Z, {
      className: J(H, {
        [`${E}-disabled`]: _
      }),
      href: _ ? void 0 : Z.href,
      style: U,
      onClick: Y,
      ref: B,
      tabIndex: _ ? -1 : 0
    }), de, se));
  let ie = /* @__PURE__ */ le.createElement("button", Object.assign({}, $, {
    type: y,
    className: H,
    style: U,
    onClick: Y,
    disabled: _,
    ref: B
  }), de, se, !!ee && /* @__PURE__ */ le.createElement(hP, {
    key: "compact",
    prefixCls: E
  }));
  return Cl(i) || (ie = /* @__PURE__ */ le.createElement(Bi, {
    component: "Button",
    disabled: !!T
  }, ie)), I(ie);
}, As = /* @__PURE__ */ ar(CP);
process.env.NODE_ENV !== "production" && (As.displayName = "Button");
As.Group = VI;
As.__ANT_BUTTON = !0;
const or = As;
function Kv(e) {
  return !!(e && e.then);
}
const SP = (e) => {
  const {
    type: t,
    children: n,
    prefixCls: r,
    buttonProps: o,
    close: a,
    autoFocus: i,
    emitEvent: l,
    isSilent: c,
    quitOnNullishReturnValue: u,
    actionFn: d
  } = e, f = s.useRef(!1), m = s.useRef(null), [v, h] = no(!1), p = function() {
    a == null || a.apply(void 0, arguments);
  };
  s.useEffect(() => {
    let y = null;
    return i && (y = setTimeout(() => {
      var C;
      (C = m.current) === null || C === void 0 || C.focus();
    })), () => {
      y && clearTimeout(y);
    };
  }, []);
  const g = (y) => {
    Kv(y) && (h(!0), y.then(function() {
      h(!1, !0), p.apply(void 0, arguments), f.current = !1;
    }, (C) => {
      if (h(!1, !0), f.current = !1, !(c != null && c()))
        return Promise.reject(C);
    }));
  }, b = (y) => {
    if (f.current)
      return;
    if (f.current = !0, !d) {
      p();
      return;
    }
    let C;
    if (l) {
      if (C = d(y), u && !Kv(C)) {
        f.current = !1, p(y);
        return;
      }
    } else if (d.length)
      C = d(a), f.current = !1;
    else if (C = d(), !C) {
      p();
      return;
    }
    g(C);
  };
  return /* @__PURE__ */ s.createElement(or, Object.assign({}, xf(t), {
    onClick: b,
    loading: v,
    prefixCls: r
  }, o, {
    ref: m
  }), n);
}, Ef = SP, Hi = /* @__PURE__ */ le.createContext({}), {
  Provider: R0
} = Hi, xP = () => {
  const {
    autoFocusButton: e,
    cancelButtonProps: t,
    cancelTextLocale: n,
    isSilent: r,
    mergedOkCancel: o,
    rootPrefixCls: a,
    close: i,
    onCancel: l,
    onConfirm: c
  } = qt(Hi);
  return o ? /* @__PURE__ */ le.createElement(Ef, {
    isSilent: r,
    actionFn: l,
    close: function() {
      i == null || i.apply(void 0, arguments), c == null || c(!1);
    },
    autoFocus: e === "cancel",
    buttonProps: t,
    prefixCls: `${a}-btn`
  }, n) : null;
}, qv = xP, $P = () => {
  const {
    autoFocusButton: e,
    close: t,
    isSilent: n,
    okButtonProps: r,
    rootPrefixCls: o,
    okTextLocale: a,
    okType: i,
    onConfirm: l,
    onOk: c
  } = qt(Hi);
  return /* @__PURE__ */ le.createElement(Ef, {
    isSilent: n,
    type: i || "primary",
    actionFn: c,
    close: function() {
      t == null || t.apply(void 0, arguments), l == null || l(!0);
    },
    autoFocus: e === "ok",
    buttonProps: r,
    prefixCls: `${o}-btn`
  }, a);
}, Gv = $P;
var M0 = /* @__PURE__ */ s.createContext(null), Uv = [];
function wP(e, t) {
  var n = s.useState(function() {
    if (!pn())
      return null;
    var h = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && h.setAttribute("data-debug", t), h;
  }), r = Q(n, 1), o = r[0], a = s.useRef(!1), i = s.useContext(M0), l = s.useState(Uv), c = Q(l, 2), u = c[0], d = c[1], f = i || (a.current ? void 0 : function(h) {
    d(function(p) {
      var g = [h].concat(be(p));
      return g;
    });
  });
  function m() {
    o.parentElement || document.body.appendChild(o), a.current = !0;
  }
  function v() {
    var h;
    (h = o.parentElement) === null || h === void 0 || h.removeChild(o), a.current = !1;
  }
  return Pt(function() {
    return e ? i ? i(m) : m() : v(), v;
  }, [e]), Pt(function() {
    u.length && (u.forEach(function(h) {
      return h();
    }), d(Uv));
  }, [u]), [o, f];
}
var qc;
function od(e) {
  if (typeof document > "u")
    return 0;
  if (e || qc === void 0) {
    var t = document.createElement("div");
    t.style.width = "100%", t.style.height = "200px";
    var n = document.createElement("div"), r = n.style;
    r.position = "absolute", r.top = "0", r.left = "0", r.pointerEvents = "none", r.visibility = "hidden", r.width = "200px", r.height = "150px", r.overflow = "hidden", n.appendChild(t), document.body.appendChild(n);
    var o = t.offsetWidth;
    n.style.overflow = "scroll";
    var a = t.offsetWidth;
    o === a && (a = n.clientWidth), document.body.removeChild(n), qc = o - a;
  }
  return qc;
}
function Yv(e) {
  var t = e.match(/^(.*)px$/), n = Number(t == null ? void 0 : t[1]);
  return Number.isNaN(n) ? od() : n;
}
function ad(e) {
  if (typeof document > "u" || !e || !(e instanceof Element))
    return {
      width: 0,
      height: 0
    };
  var t = getComputedStyle(e, "::-webkit-scrollbar"), n = t.width, r = t.height;
  return {
    width: Yv(n),
    height: Yv(r)
  };
}
function EP() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var OP = "rc-util-locker-".concat(Date.now()), Xv = 0;
function NP(e) {
  var t = !!e, n = s.useState(function() {
    return Xv += 1, "".concat(OP, "_").concat(Xv);
  }), r = Q(n, 1), o = r[0];
  Pt(function() {
    if (t) {
      var a = ad(document.body).width, i = EP();
      ao(`
html body {
  overflow-y: hidden;
  `.concat(i ? "width: calc(100% - ".concat(a, "px);") : "", `
}`), o);
    } else
      Si(o);
    return function() {
      Si(o);
    };
  }, [t, o]);
}
var Qv = !1;
function IP(e) {
  return typeof e == "boolean" && (Qv = e), Qv;
}
var Jv = function(t) {
  return t === !1 ? !1 : !pn() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, Vi = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, o = e.getContainer, a = e.debug, i = e.autoDestroy, l = i === void 0 ? !0 : i, c = e.children, u = s.useState(n), d = Q(u, 2), f = d[0], m = d[1], v = f || n;
  process.env.NODE_ENV !== "production" && tt(pn() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), s.useEffect(function() {
    (l || n) && m(n);
  }, [n, l]);
  var h = s.useState(function() {
    return Jv(o);
  }), p = Q(h, 2), g = p[0], b = p[1];
  s.useEffect(function() {
    var k = Jv(o);
    b(k ?? null);
  });
  var y = wP(v && !g, a), C = Q(y, 2), S = C[0], $ = C[1], x = g ?? S;
  NP(r && n && pn() && (x === S || x === document.body));
  var w = null;
  if (c && Sr(c) && t) {
    var N = c;
    w = N.ref;
  }
  var O = Gr(w, t);
  if (!v || !pn() || g === void 0)
    return null;
  var E = x === !1 || IP(), I = c;
  return t && (I = /* @__PURE__ */ s.cloneElement(c, {
    ref: O
  })), /* @__PURE__ */ s.createElement(M0.Provider, {
    value: $
  }, E ? I : /* @__PURE__ */ Eh(I, x));
});
process.env.NODE_ENV !== "production" && (Vi.displayName = "Portal");
var T0 = /* @__PURE__ */ s.createContext({});
function PP() {
  var e = V({}, s);
  return e.useId;
}
var Zv = 0, eg = PP();
const _0 = eg ? (
  // Use React `useId`
  function(t) {
    var n = eg();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = s.useState("ssr-id"), r = Q(n, 2), o = r[0], a = r[1];
    return s.useEffect(function() {
      var i = Zv;
      Zv += 1, a("rc_unique_".concat(i));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : o);
  }
);
function tg(e, t, n) {
  var r = t;
  return !r && n && (r = "".concat(e, "-").concat(n)), r;
}
function ng(e, t) {
  var n = e["page".concat(t ? "Y" : "X", "Offset")], r = "scroll".concat(t ? "Top" : "Left");
  if (typeof n != "number") {
    var o = e.document;
    n = o.documentElement[r], typeof n != "number" && (n = o.body[r]);
  }
  return n;
}
function RP(e) {
  var t = e.getBoundingClientRect(), n = {
    left: t.left,
    top: t.top
  }, r = e.ownerDocument, o = r.defaultView || r.parentWindow;
  return n.left += ng(o), n.top += ng(o, !0), n;
}
const MP = /* @__PURE__ */ s.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  var n = t.shouldUpdate;
  return !n;
});
var rg = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, Of = /* @__PURE__ */ le.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.className, o = e.style, a = e.title, i = e.ariaId, l = e.footer, c = e.closable, u = e.closeIcon, d = e.onClose, f = e.children, m = e.bodyStyle, v = e.bodyProps, h = e.modalRender, p = e.onMouseDown, g = e.onMouseUp, b = e.holderRef, y = e.visible, C = e.forceRender, S = e.width, $ = e.height, x = e.classNames, w = e.styles, N = le.useContext(T0), O = N.panel, E = Gr(b, O), I = Xe(), k = Xe();
  le.useImperativeHandle(t, function() {
    return {
      focus: function() {
        var L;
        (L = I.current) === null || L === void 0 || L.focus();
      },
      changeActive: function(L) {
        var F = document, j = F.activeElement;
        L && j === k.current ? I.current.focus() : !L && j === I.current && k.current.focus();
      }
    };
  });
  var M = {};
  S !== void 0 && (M.width = S), $ !== void 0 && (M.height = $);
  var P;
  l && (P = /* @__PURE__ */ le.createElement("div", {
    className: J("".concat(n, "-footer"), x == null ? void 0 : x.footer),
    style: V({}, w == null ? void 0 : w.footer)
  }, l));
  var _;
  a && (_ = /* @__PURE__ */ le.createElement("div", {
    className: J("".concat(n, "-header"), x == null ? void 0 : x.header),
    style: V({}, w == null ? void 0 : w.header)
  }, /* @__PURE__ */ le.createElement("div", {
    className: "".concat(n, "-title"),
    id: i
  }, a)));
  var D;
  c && (D = /* @__PURE__ */ le.createElement("button", {
    type: "button",
    onClick: d,
    "aria-label": "Close",
    className: "".concat(n, "-close")
  }, u || /* @__PURE__ */ le.createElement("span", {
    className: "".concat(n, "-close-x")
  })));
  var R = /* @__PURE__ */ le.createElement("div", {
    className: J("".concat(n, "-content"), x == null ? void 0 : x.content),
    style: w == null ? void 0 : w.content
  }, D, _, /* @__PURE__ */ le.createElement("div", fe({
    className: J("".concat(n, "-body"), x == null ? void 0 : x.body),
    style: V(V({}, m), w == null ? void 0 : w.body)
  }, v), f), P);
  return /* @__PURE__ */ le.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": a ? i : null,
    "aria-modal": "true",
    ref: E,
    style: V(V({}, o), M),
    className: J(n, r),
    onMouseDown: p,
    onMouseUp: g
  }, /* @__PURE__ */ le.createElement("div", {
    tabIndex: 0,
    ref: I,
    style: rg,
    "aria-hidden": "true"
  }), /* @__PURE__ */ le.createElement(MP, {
    shouldUpdate: y || C
  }, h ? h(R) : R), /* @__PURE__ */ le.createElement("div", {
    tabIndex: 0,
    ref: k,
    style: rg,
    "aria-hidden": "true"
  }));
});
process.env.NODE_ENV !== "production" && (Of.displayName = "Panel");
var D0 = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.title, o = e.style, a = e.className, i = e.visible, l = e.forceRender, c = e.destroyOnClose, u = e.motionName, d = e.ariaId, f = e.onVisibleChanged, m = e.mousePosition, v = Xe(), h = s.useState(), p = Q(h, 2), g = p[0], b = p[1], y = {};
  g && (y.transformOrigin = g);
  function C() {
    var S = RP(v.current);
    b(m ? "".concat(m.x - S.left, "px ").concat(m.y - S.top, "px") : "");
  }
  return /* @__PURE__ */ s.createElement(An, {
    visible: i,
    onVisibleChanged: f,
    onAppearPrepare: C,
    onEnterPrepare: C,
    forceRender: l,
    motionName: u,
    removeOnLeave: c,
    ref: v
  }, function(S, $) {
    var x = S.className, w = S.style;
    return /* @__PURE__ */ s.createElement(Of, fe({}, e, {
      ref: t,
      title: r,
      ariaId: d,
      prefixCls: n,
      holderRef: $,
      style: V(V(V({}, w), o), y),
      className: J(a, x)
    }));
  });
});
D0.displayName = "Content";
function TP(e) {
  var t = e.prefixCls, n = e.style, r = e.visible, o = e.maskProps, a = e.motionName, i = e.className;
  return /* @__PURE__ */ s.createElement(An, {
    key: "mask",
    visible: r,
    motionName: a,
    leavedClassName: "".concat(t, "-mask-hidden")
  }, function(l, c) {
    var u = l.className, d = l.style;
    return /* @__PURE__ */ s.createElement("div", fe({
      ref: c,
      style: V(V({}, d), n),
      className: J("".concat(t, "-mask"), u, i)
    }, o));
  });
}
function _P(e) {
  var t = e.prefixCls, n = t === void 0 ? "rc-dialog" : t, r = e.zIndex, o = e.visible, a = o === void 0 ? !1 : o, i = e.keyboard, l = i === void 0 ? !0 : i, c = e.focusTriggerAfterClose, u = c === void 0 ? !0 : c, d = e.wrapStyle, f = e.wrapClassName, m = e.wrapProps, v = e.onClose, h = e.afterOpenChange, p = e.afterClose, g = e.transitionName, b = e.animation, y = e.closable, C = y === void 0 ? !0 : y, S = e.mask, $ = S === void 0 ? !0 : S, x = e.maskTransitionName, w = e.maskAnimation, N = e.maskClosable, O = N === void 0 ? !0 : N, E = e.maskStyle, I = e.maskProps, k = e.rootClassName, M = e.classNames, P = e.styles;
  process.env.NODE_ENV !== "production" && (["wrapStyle", "bodyStyle", "maskStyle"].forEach(function(Z) {
    Br(!(Z in e), "".concat(Z, " is deprecated, please use styles instead."));
  }), "wrapClassName" in e && Br(!1, "wrapClassName is deprecated, please use classNames instead."));
  var _ = Xe(), D = Xe(), R = Xe(), T = s.useState(a), L = Q(T, 2), F = L[0], j = L[1], A = _0();
  function B() {
    Ru(D.current, document.activeElement) || (_.current = document.activeElement);
  }
  function K() {
    if (!Ru(D.current, document.activeElement)) {
      var Z;
      (Z = R.current) === null || Z === void 0 || Z.focus();
    }
  }
  function Y(Z) {
    if (Z)
      K();
    else {
      if (j(!1), $ && _.current && u) {
        try {
          _.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        _.current = null;
      }
      F && (p == null || p());
    }
    h == null || h(Z);
  }
  function G(Z) {
    v == null || v(Z);
  }
  var te = Xe(!1), ee = Xe(), oe = function() {
    clearTimeout(ee.current), te.current = !0;
  }, X = function() {
    ee.current = setTimeout(function() {
      te.current = !1;
    });
  }, W = null;
  O && (W = function(H) {
    te.current ? te.current = !1 : D.current === H.target && G(H);
  });
  function re(Z) {
    if (l && Z.keyCode === Oe.ESC) {
      Z.stopPropagation(), G(Z);
      return;
    }
    a && Z.keyCode === Oe.TAB && R.current.changeActive(!Z.shiftKey);
  }
  return Bt(function() {
    a && (j(!0), B());
  }, [a]), Bt(function() {
    return function() {
      clearTimeout(ee.current);
    };
  }, []), /* @__PURE__ */ s.createElement("div", fe({
    className: J("".concat(n, "-root"), k)
  }, Bn(e, {
    data: !0
  })), /* @__PURE__ */ s.createElement(TP, {
    prefixCls: n,
    visible: $ && a,
    motionName: tg(n, x, w),
    style: V(V({
      zIndex: r
    }, E), P == null ? void 0 : P.mask),
    maskProps: I,
    className: M == null ? void 0 : M.mask
  }), /* @__PURE__ */ s.createElement("div", fe({
    tabIndex: -1,
    onKeyDown: re,
    className: J("".concat(n, "-wrap"), f, M == null ? void 0 : M.wrapper),
    ref: D,
    onClick: W,
    style: V(V(V({
      zIndex: r
    }, d), P == null ? void 0 : P.wrapper), {}, {
      display: F ? null : "none"
    })
  }, m), /* @__PURE__ */ s.createElement(D0, fe({}, e, {
    onMouseDown: oe,
    onMouseUp: X,
    ref: R,
    closable: C,
    ariaId: A,
    prefixCls: n,
    visible: a && F,
    onClose: G,
    onVisibleChanged: Y,
    motionName: tg(n, g, b)
  }))));
}
var k0 = function(t) {
  var n = t.visible, r = t.getContainer, o = t.forceRender, a = t.destroyOnClose, i = a === void 0 ? !1 : a, l = t.afterClose, c = t.panelRef, u = s.useState(n), d = Q(u, 2), f = d[0], m = d[1], v = s.useMemo(function() {
    return {
      panel: c
    };
  }, [c]);
  return s.useEffect(function() {
    n && m(!0);
  }, [n]), !o && i && !f ? null : /* @__PURE__ */ s.createElement(T0.Provider, {
    value: v
  }, /* @__PURE__ */ s.createElement(Vi, {
    open: n || o || f,
    autoDestroy: !1,
    getContainer: r,
    autoLock: n || f
  }, /* @__PURE__ */ s.createElement(_P, fe({}, t, {
    destroyOnClose: i,
    afterClose: function() {
      l == null || l(), m(!1);
    }
  }))));
};
k0.displayName = "Dialog";
function DP(e, t, n) {
  return typeof e == "boolean" ? e : t === void 0 ? !!n : t !== !1 && t !== null;
}
function Nf(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : /* @__PURE__ */ le.createElement(mo, null), o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (!DP(e, t, o))
    return [!1, null];
  const i = typeof t == "boolean" || t === void 0 || t === null ? r : t;
  return [!0, n ? n(i) : i];
}
var L0 = function(t) {
  if (pn() && window.document.documentElement) {
    var n = Array.isArray(t) ? t : [t], r = window.document.documentElement;
    return n.some(function(o) {
      return o in r.style;
    });
  }
  return !1;
}, kP = function(t, n) {
  if (!L0(t))
    return !1;
  var r = document.createElement("div"), o = r.style[t];
  return r.style[t] = n, r.style[t] !== o;
};
function id(e, t) {
  return !Array.isArray(e) && t !== void 0 ? kP(e, t) : L0(e);
}
const LP = () => pn() && window.document.documentElement;
var Eo = "RC_FORM_INTERNAL_HOOKS", tn = function() {
  tt(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, _o = /* @__PURE__ */ s.createContext({
  getFieldValue: tn,
  getFieldsValue: tn,
  getFieldError: tn,
  getFieldWarning: tn,
  getFieldsError: tn,
  isFieldsTouched: tn,
  isFieldTouched: tn,
  isFieldValidating: tn,
  isFieldsValidating: tn,
  resetFields: tn,
  setFields: tn,
  setFieldValue: tn,
  setFieldsValue: tn,
  validateFields: tn,
  submit: tn,
  getInternalHooks: function() {
    return tn(), {
      dispatch: tn,
      initEntityValue: tn,
      registerField: tn,
      useSubscribe: tn,
      setInitialValues: tn,
      destroyForm: tn,
      setCallbacks: tn,
      registerWatch: tn,
      getFields: tn,
      setValidateMessages: tn,
      setPreserve: tn,
      getInitialValue: tn
    };
  }
}), Ii = /* @__PURE__ */ s.createContext(null);
function ld(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function FP(e) {
  return e && !!e._init;
}
function Oo() {
  return Oo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oo.apply(this, arguments);
}
function jP(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Pi(e, t);
}
function sd(e) {
  return sd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, sd(e);
}
function Pi(e, t) {
  return Pi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Pi(e, t);
}
function zP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Kl(e, t, n) {
  return zP() ? Kl = Reflect.construct.bind() : Kl = function(o, a, i) {
    var l = [null];
    l.push.apply(l, a);
    var c = Function.bind.apply(o, l), u = new c();
    return i && Pi(u, i.prototype), u;
  }, Kl.apply(null, arguments);
}
function AP(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function cd(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return cd = function(r) {
    if (r === null || !AP(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, o);
    }
    function o() {
      return Kl(r, arguments, sd(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Pi(o, r);
  }, cd(e);
}
var BP = /%[sdj%]/g, F0 = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (F0 = function(t, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function ud(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function rr(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var o = 0, a = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var i = e.replace(BP, function(l) {
      if (l === "%%")
        return "%";
      if (o >= a)
        return l;
      switch (l) {
        case "%s":
          return String(n[o++]);
        case "%d":
          return Number(n[o++]);
        case "%j":
          try {
            return JSON.stringify(n[o++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return l;
      }
    });
    return i;
  }
  return e;
}
function HP(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Rn(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || HP(t) && typeof e == "string" && !e);
}
function VP(e, t, n) {
  var r = [], o = 0, a = e.length;
  function i(l) {
    r.push.apply(r, l || []), o++, o === a && n(r);
  }
  e.forEach(function(l) {
    t(l, i);
  });
}
function og(e, t, n) {
  var r = 0, o = e.length;
  function a(i) {
    if (i && i.length) {
      n(i);
      return;
    }
    var l = r;
    r = r + 1, l < o ? t(e[l], a) : n([]);
  }
  a([]);
}
function WP(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, e[n] || []);
  }), t;
}
var ag = /* @__PURE__ */ function(e) {
  jP(t, e);
  function t(n, r) {
    var o;
    return o = e.call(this, "Async Validation Error") || this, o.errors = n, o.fields = r, o;
  }
  return t;
}(/* @__PURE__ */ cd(Error));
function KP(e, t, n, r, o) {
  if (t.first) {
    var a = new Promise(function(m, v) {
      var h = function(b) {
        return r(b), b.length ? v(new ag(b, ud(b))) : m(o);
      }, p = WP(e);
      og(p, n, h);
    });
    return a.catch(function(m) {
      return m;
    }), a;
  }
  var i = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], l = Object.keys(e), c = l.length, u = 0, d = [], f = new Promise(function(m, v) {
    var h = function(g) {
      if (d.push.apply(d, g), u++, u === c)
        return r(d), d.length ? v(new ag(d, ud(d))) : m(o);
    };
    l.length || (r(d), m(o)), l.forEach(function(p) {
      var g = e[p];
      i.indexOf(p) !== -1 ? og(g, n, h) : VP(g, n, h);
    });
  });
  return f.catch(function(m) {
    return m;
  }), f;
}
function qP(e) {
  return !!(e && e.message !== void 0);
}
function GP(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function ig(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = GP(t, e.fullFields) : r = t[n.field || e.fullField], qP(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function lg(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        typeof r == "object" && typeof e[n] == "object" ? e[n] = Oo({}, e[n], r) : e[n] = r;
      }
  }
  return e;
}
var j0 = function(t, n, r, o, a, i) {
  t.required && (!r.hasOwnProperty(t.field) || Rn(n, i || t.type)) && o.push(rr(a.messages.required, t.fullField));
}, UP = function(t, n, r, o, a) {
  (/^\s+$/.test(n) || n === "") && o.push(rr(a.messages.whitespace, t.fullField));
}, Sl, YP = function() {
  if (Sl)
    return Sl;
  var e = "[a-fA-F\\d:]", t = function(S) {
    return S && S.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", o = (`
(?:
(?:` + r + ":){7}(?:" + r + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + r + ":){6}(?:" + n + "|:" + r + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + r + ":){5}(?::" + n + "|(?::" + r + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + r + ":){4}(?:(?::" + r + "){0,1}:" + n + "|(?::" + r + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + r + ":){3}(?:(?::" + r + "){0,2}:" + n + "|(?::" + r + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + r + ":){2}(?:(?::" + r + "){0,3}:" + n + "|(?::" + r + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + r + ":){1}(?:(?::" + r + "){0,4}:" + n + "|(?::" + r + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + r + "){0,5}:" + n + "|(?::" + r + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), a = new RegExp("(?:^" + n + "$)|(?:^" + o + "$)"), i = new RegExp("^" + n + "$"), l = new RegExp("^" + o + "$"), c = function(S) {
    return S && S.exact ? a : new RegExp("(?:" + t(S) + n + t(S) + ")|(?:" + t(S) + o + t(S) + ")", "g");
  };
  c.v4 = function(C) {
    return C && C.exact ? i : new RegExp("" + t(C) + n + t(C), "g");
  }, c.v6 = function(C) {
    return C && C.exact ? l : new RegExp("" + t(C) + o + t(C), "g");
  };
  var u = "(?:(?:[a-z]+:)?//)", d = "(?:\\S+(?::\\S*)?@)?", f = c.v4().source, m = c.v6().source, v = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", h = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", p = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", g = "(?::\\d{2,5})?", b = '(?:[/?#][^\\s"]*)?', y = "(?:" + u + "|www\\.)" + d + "(?:localhost|" + f + "|" + m + "|" + v + h + p + ")" + g + b;
  return Sl = new RegExp("(?:^" + y + "$)", "i"), Sl;
}, sg = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, ei = {
  integer: function(t) {
    return ei.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return ei.number(t) && !ei.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !ei.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(sg.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(YP());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(sg.hex);
  }
}, XP = function(t, n, r, o, a) {
  if (t.required && n === void 0) {
    j0(t, n, r, o, a);
    return;
  }
  var i = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], l = t.type;
  i.indexOf(l) > -1 ? ei[l](n) || o.push(rr(a.messages.types[l], t.fullField, t.type)) : l && typeof n !== t.type && o.push(rr(a.messages.types[l], t.fullField, t.type));
}, QP = function(t, n, r, o, a) {
  var i = typeof t.len == "number", l = typeof t.min == "number", c = typeof t.max == "number", u = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, d = n, f = null, m = typeof n == "number", v = typeof n == "string", h = Array.isArray(n);
  if (m ? f = "number" : v ? f = "string" : h && (f = "array"), !f)
    return !1;
  h && (d = n.length), v && (d = n.replace(u, "_").length), i ? d !== t.len && o.push(rr(a.messages[f].len, t.fullField, t.len)) : l && !c && d < t.min ? o.push(rr(a.messages[f].min, t.fullField, t.min)) : c && !l && d > t.max ? o.push(rr(a.messages[f].max, t.fullField, t.max)) : l && c && (d < t.min || d > t.max) && o.push(rr(a.messages[f].range, t.fullField, t.min, t.max));
}, Yo = "enum", JP = function(t, n, r, o, a) {
  t[Yo] = Array.isArray(t[Yo]) ? t[Yo] : [], t[Yo].indexOf(n) === -1 && o.push(rr(a.messages[Yo], t.fullField, t[Yo].join(", ")));
}, ZP = function(t, n, r, o, a) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || o.push(rr(a.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var i = new RegExp(t.pattern);
      i.test(n) || o.push(rr(a.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, Kt = {
  required: j0,
  whitespace: UP,
  type: XP,
  range: QP,
  enum: JP,
  pattern: ZP
}, eR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n, "string") && !t.required)
      return r();
    Kt.required(t, n, o, i, a, "string"), Rn(n, "string") || (Kt.type(t, n, o, i, a), Kt.range(t, n, o, i, a), Kt.pattern(t, n, o, i, a), t.whitespace === !0 && Kt.whitespace(t, n, o, i, a));
  }
  r(i);
}, tR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), n !== void 0 && Kt.type(t, n, o, i, a);
  }
  r(i);
}, nR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (n === "" && (n = void 0), Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), n !== void 0 && (Kt.type(t, n, o, i, a), Kt.range(t, n, o, i, a));
  }
  r(i);
}, rR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), n !== void 0 && Kt.type(t, n, o, i, a);
  }
  r(i);
}, oR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), Rn(n) || Kt.type(t, n, o, i, a);
  }
  r(i);
}, aR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), n !== void 0 && (Kt.type(t, n, o, i, a), Kt.range(t, n, o, i, a));
  }
  r(i);
}, iR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), n !== void 0 && (Kt.type(t, n, o, i, a), Kt.range(t, n, o, i, a));
  }
  r(i);
}, lR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (n == null && !t.required)
      return r();
    Kt.required(t, n, o, i, a, "array"), n != null && (Kt.type(t, n, o, i, a), Kt.range(t, n, o, i, a));
  }
  r(i);
}, sR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), n !== void 0 && Kt.type(t, n, o, i, a);
  }
  r(i);
}, cR = "enum", uR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a), n !== void 0 && Kt[cR](t, n, o, i, a);
  }
  r(i);
}, dR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n, "string") && !t.required)
      return r();
    Kt.required(t, n, o, i, a), Rn(n, "string") || Kt.pattern(t, n, o, i, a);
  }
  r(i);
}, fR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n, "date") && !t.required)
      return r();
    if (Kt.required(t, n, o, i, a), !Rn(n, "date")) {
      var c;
      n instanceof Date ? c = n : c = new Date(n), Kt.type(t, c, o, i, a), c && Kt.range(t, c.getTime(), o, i, a);
    }
  }
  r(i);
}, mR = function(t, n, r, o, a) {
  var i = [], l = Array.isArray(n) ? "array" : typeof n;
  Kt.required(t, n, o, i, a, l), r(i);
}, Gc = function(t, n, r, o, a) {
  var i = t.type, l = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Rn(n, i) && !t.required)
      return r();
    Kt.required(t, n, o, l, a, i), Rn(n, i) || Kt.type(t, n, o, l, a);
  }
  r(l);
}, vR = function(t, n, r, o, a) {
  var i = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Rn(n) && !t.required)
      return r();
    Kt.required(t, n, o, i, a);
  }
  r(i);
}, di = {
  string: eR,
  method: tR,
  number: nR,
  boolean: rR,
  regexp: oR,
  integer: aR,
  float: iR,
  array: lR,
  object: sR,
  enum: uR,
  pattern: dR,
  date: fR,
  url: Gc,
  hex: Gc,
  email: Gc,
  required: mR,
  any: vR
};
function dd() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var fd = dd(), Wi = /* @__PURE__ */ function() {
  function e(n) {
    this.rules = null, this._messages = fd, this.define(n);
  }
  var t = e.prototype;
  return t.define = function(r) {
    var o = this;
    if (!r)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof r != "object" || Array.isArray(r))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(r).forEach(function(a) {
      var i = r[a];
      o.rules[a] = Array.isArray(i) ? i : [i];
    });
  }, t.messages = function(r) {
    return r && (this._messages = lg(dd(), r)), this._messages;
  }, t.validate = function(r, o, a) {
    var i = this;
    o === void 0 && (o = {}), a === void 0 && (a = function() {
    });
    var l = r, c = o, u = a;
    if (typeof c == "function" && (u = c, c = {}), !this.rules || Object.keys(this.rules).length === 0)
      return u && u(null, l), Promise.resolve(l);
    function d(p) {
      var g = [], b = {};
      function y(S) {
        if (Array.isArray(S)) {
          var $;
          g = ($ = g).concat.apply($, S);
        } else
          g.push(S);
      }
      for (var C = 0; C < p.length; C++)
        y(p[C]);
      g.length ? (b = ud(g), u(g, b)) : u(null, l);
    }
    if (c.messages) {
      var f = this.messages();
      f === fd && (f = dd()), lg(f, c.messages), c.messages = f;
    } else
      c.messages = this.messages();
    var m = {}, v = c.keys || Object.keys(this.rules);
    v.forEach(function(p) {
      var g = i.rules[p], b = l[p];
      g.forEach(function(y) {
        var C = y;
        typeof C.transform == "function" && (l === r && (l = Oo({}, l)), b = l[p] = C.transform(b)), typeof C == "function" ? C = {
          validator: C
        } : C = Oo({}, C), C.validator = i.getValidationMethod(C), C.validator && (C.field = p, C.fullField = C.fullField || p, C.type = i.getType(C), m[p] = m[p] || [], m[p].push({
          rule: C,
          value: b,
          source: l,
          field: p
        }));
      });
    });
    var h = {};
    return KP(m, c, function(p, g) {
      var b = p.rule, y = (b.type === "object" || b.type === "array") && (typeof b.fields == "object" || typeof b.defaultField == "object");
      y = y && (b.required || !b.required && p.value), b.field = p.field;
      function C(x, w) {
        return Oo({}, w, {
          fullField: b.fullField + "." + x,
          fullFields: b.fullFields ? [].concat(b.fullFields, [x]) : [x]
        });
      }
      function S(x) {
        x === void 0 && (x = []);
        var w = Array.isArray(x) ? x : [x];
        !c.suppressWarning && w.length && e.warning("async-validator:", w), w.length && b.message !== void 0 && (w = [].concat(b.message));
        var N = w.map(ig(b, l));
        if (c.first && N.length)
          return h[b.field] = 1, g(N);
        if (!y)
          g(N);
        else {
          if (b.required && !p.value)
            return b.message !== void 0 ? N = [].concat(b.message).map(ig(b, l)) : c.error && (N = [c.error(b, rr(c.messages.required, b.field))]), g(N);
          var O = {};
          b.defaultField && Object.keys(p.value).map(function(k) {
            O[k] = b.defaultField;
          }), O = Oo({}, O, p.rule.fields);
          var E = {};
          Object.keys(O).forEach(function(k) {
            var M = O[k], P = Array.isArray(M) ? M : [M];
            E[k] = P.map(C.bind(null, k));
          });
          var I = new e(E);
          I.messages(c.messages), p.rule.options && (p.rule.options.messages = c.messages, p.rule.options.error = c.error), I.validate(p.value, p.rule.options || c, function(k) {
            var M = [];
            N && N.length && M.push.apply(M, N), k && k.length && M.push.apply(M, k), g(M.length ? M : null);
          });
        }
      }
      var $;
      if (b.asyncValidator)
        $ = b.asyncValidator(b, p.value, S, p.source, c);
      else if (b.validator) {
        try {
          $ = b.validator(b, p.value, S, p.source, c);
        } catch (x) {
          console.error == null || console.error(x), c.suppressValidatorError || setTimeout(function() {
            throw x;
          }, 0), S(x.message);
        }
        $ === !0 ? S() : $ === !1 ? S(typeof b.message == "function" ? b.message(b.fullField || b.field) : b.message || (b.fullField || b.field) + " fails") : $ instanceof Array ? S($) : $ instanceof Error && S($.message);
      }
      $ && $.then && $.then(function() {
        return S();
      }, function(x) {
        return S(x);
      });
    }, function(p) {
      d(p);
    }, l);
  }, t.getType = function(r) {
    if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !di.hasOwnProperty(r.type))
      throw new Error(rr("Unknown rule type %s", r.type));
    return r.type || "string";
  }, t.getValidationMethod = function(r) {
    if (typeof r.validator == "function")
      return r.validator;
    var o = Object.keys(r), a = o.indexOf("message");
    return a !== -1 && o.splice(a, 1), o.length === 1 && o[0] === "required" ? di.required : di[this.getType(r)] || void 0;
  }, e;
}();
Wi.register = function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  di[t] = n;
};
Wi.warning = F0;
Wi.messages = fd;
Wi.validators = di;
var Jn = "'${name}' is not a valid ${type}", z0 = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: Jn,
    method: Jn,
    array: Jn,
    object: Jn,
    number: Jn,
    date: Jn,
    boolean: Jn,
    integer: Jn,
    float: Jn,
    regexp: Jn,
    email: Jn,
    url: Jn,
    hex: Jn
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, cg = Wi;
function gR(e, t) {
  return e.replace(/\$\{\w+\}/g, function(n) {
    var r = n.slice(2, -1);
    return t[r];
  });
}
var ug = "CODE_LOGIC_ERROR";
function md(e, t, n, r, o) {
  return vd.apply(this, arguments);
}
function vd() {
  return vd = go(/* @__PURE__ */ Fn().mark(function e(t, n, r, o, a) {
    var i, l, c, u, d, f, m, v, h;
    return Fn().wrap(function(g) {
      for (; ; )
        switch (g.prev = g.next) {
          case 0:
            return i = V({}, r), delete i.ruleIndex, cg.warning = function() {
            }, i.validator && (l = i.validator, i.validator = function() {
              try {
                return l.apply(void 0, arguments);
              } catch (b) {
                return console.error(b), Promise.reject(ug);
              }
            }), c = null, i && i.type === "array" && i.defaultField && (c = i.defaultField, delete i.defaultField), u = new cg(z({}, t, [i])), d = ca(z0, o.validateMessages), u.messages(d), f = [], g.prev = 10, g.next = 13, Promise.resolve(u.validate(z({}, t, n), V({}, o)));
          case 13:
            g.next = 18;
            break;
          case 15:
            g.prev = 15, g.t0 = g.catch(10), g.t0.errors && (f = g.t0.errors.map(function(b, y) {
              var C = b.message, S = C === ug ? d.default : C;
              return /* @__PURE__ */ s.isValidElement(S) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ s.cloneElement(S, {
                  key: "error_".concat(y)
                })
              ) : S;
            }));
          case 18:
            if (!(!f.length && c)) {
              g.next = 23;
              break;
            }
            return g.next = 21, Promise.all(n.map(function(b, y) {
              return md("".concat(t, ".").concat(y), b, c, o, a);
            }));
          case 21:
            return m = g.sent, g.abrupt("return", m.reduce(function(b, y) {
              return [].concat(be(b), be(y));
            }, []));
          case 23:
            return v = V(V({}, r), {}, {
              name: t,
              enum: (r.enum || []).join(", ")
            }, a), h = f.map(function(b) {
              return typeof b == "string" ? gR(b, v) : b;
            }), g.abrupt("return", h);
          case 26:
          case "end":
            return g.stop();
        }
    }, e, null, [[10, 15]]);
  })), vd.apply(this, arguments);
}
function pR(e, t, n, r, o, a) {
  var i = e.join("."), l = n.map(function(d, f) {
    var m = d.validator, v = V(V({}, d), {}, {
      ruleIndex: f
    });
    return m && (v.validator = function(h, p, g) {
      var b = !1, y = function() {
        for (var $ = arguments.length, x = new Array($), w = 0; w < $; w++)
          x[w] = arguments[w];
        Promise.resolve().then(function() {
          tt(!b, "Your validator function has already return a promise. `callback` will be ignored."), b || g.apply(void 0, x);
        });
      }, C = m(h, p, y);
      b = C && typeof C.then == "function" && typeof C.catch == "function", tt(b, "`callback` is deprecated. Please return a promise instead."), b && C.then(function() {
        g();
      }).catch(function(S) {
        g(S || " ");
      });
    }), v;
  }).sort(function(d, f) {
    var m = d.warningOnly, v = d.ruleIndex, h = f.warningOnly, p = f.ruleIndex;
    return !!m == !!h ? v - p : m ? 1 : -1;
  }), c;
  if (o === !0)
    c = new Promise(/* @__PURE__ */ function() {
      var d = go(/* @__PURE__ */ Fn().mark(function f(m, v) {
        var h, p, g;
        return Fn().wrap(function(y) {
          for (; ; )
            switch (y.prev = y.next) {
              case 0:
                h = 0;
              case 1:
                if (!(h < l.length)) {
                  y.next = 12;
                  break;
                }
                return p = l[h], y.next = 5, md(i, t, p, r, a);
              case 5:
                if (g = y.sent, !g.length) {
                  y.next = 9;
                  break;
                }
                return v([{
                  errors: g,
                  rule: p
                }]), y.abrupt("return");
              case 9:
                h += 1, y.next = 1;
                break;
              case 12:
                m([]);
              case 13:
              case "end":
                return y.stop();
            }
        }, f);
      }));
      return function(f, m) {
        return d.apply(this, arguments);
      };
    }());
  else {
    var u = l.map(function(d) {
      return md(i, t, d, r, a).then(function(f) {
        return {
          errors: f,
          rule: d
        };
      });
    });
    c = (o ? bR(u) : hR(u)).then(function(d) {
      return Promise.reject(d);
    });
  }
  return c.catch(function(d) {
    return d;
  }), c;
}
function hR(e) {
  return gd.apply(this, arguments);
}
function gd() {
  return gd = go(/* @__PURE__ */ Fn().mark(function e(t) {
    return Fn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(t).then(function(o) {
              var a, i = (a = []).concat.apply(a, be(o));
              return i;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), gd.apply(this, arguments);
}
function bR(e) {
  return pd.apply(this, arguments);
}
function pd() {
  return pd = go(/* @__PURE__ */ Fn().mark(function e(t) {
    var n;
    return Fn().wrap(function(o) {
      for (; ; )
        switch (o.prev = o.next) {
          case 0:
            return n = 0, o.abrupt("return", new Promise(function(a) {
              t.forEach(function(i) {
                i.then(function(l) {
                  l.errors.length && a([l]), n += 1, n === t.length && a([]);
                });
              });
            }));
          case 2:
          case "end":
            return o.stop();
        }
    }, e);
  })), pd.apply(this, arguments);
}
function gn(e) {
  return ld(e);
}
function dg(e, t) {
  var n = {};
  return t.forEach(function(r) {
    var o = nr(e, r);
    n = gr(n, r, o);
  }), n;
}
function ma(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(r) {
    return A0(t, r, n);
  });
}
function A0(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !n && e.length !== t.length ? !1 : t.every(function(r, o) {
    return e[o] === r;
  });
}
function yR(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || mt(e) !== "object" || mt(t) !== "object")
    return !1;
  var n = Object.keys(e), r = Object.keys(t), o = new Set([].concat(n, r));
  return be(o).every(function(a) {
    var i = e[a], l = t[a];
    return typeof i == "function" && typeof l == "function" ? !0 : i === l;
  });
}
function CR(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && mt(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function fg(e, t, n) {
  var r = e.length;
  if (t < 0 || t >= r || n < 0 || n >= r)
    return e;
  var o = e[t], a = t - n;
  return a > 0 ? [].concat(be(e.slice(0, n)), [o], be(e.slice(n, t)), be(e.slice(t + 1, r))) : a < 0 ? [].concat(be(e.slice(0, t)), be(e.slice(t + 1, n + 1)), [o], be(e.slice(n + 1, r))) : e;
}
var SR = ["name"], ir = [];
function mg(e, t, n, r, o, a) {
  return typeof e == "function" ? e(t, n, "source" in a ? {
    source: a.source
  } : {}) : r !== o;
}
var If = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n(r) {
    var o;
    if ($n(this, n), o = t.call(this, r), z(Me(o), "state", {
      resetCount: 0
    }), z(Me(o), "cancelRegisterFunc", null), z(Me(o), "mounted", !1), z(Me(o), "touched", !1), z(Me(o), "dirty", !1), z(Me(o), "validatePromise", void 0), z(Me(o), "prevValidating", void 0), z(Me(o), "errors", ir), z(Me(o), "warnings", ir), z(Me(o), "cancelRegister", function() {
      var c = o.props, u = c.preserve, d = c.isListField, f = c.name;
      o.cancelRegisterFunc && o.cancelRegisterFunc(d, u, gn(f)), o.cancelRegisterFunc = null;
    }), z(Me(o), "getNamePath", function() {
      var c = o.props, u = c.name, d = c.fieldContext, f = d.prefixName, m = f === void 0 ? [] : f;
      return u !== void 0 ? [].concat(be(m), be(u)) : [];
    }), z(Me(o), "getRules", function() {
      var c = o.props, u = c.rules, d = u === void 0 ? [] : u, f = c.fieldContext;
      return d.map(function(m) {
        return typeof m == "function" ? m(f) : m;
      });
    }), z(Me(o), "refresh", function() {
      o.mounted && o.setState(function(c) {
        var u = c.resetCount;
        return {
          resetCount: u + 1
        };
      });
    }), z(Me(o), "metaCache", null), z(Me(o), "triggerMetaEvent", function(c) {
      var u = o.props.onMetaChange;
      if (u) {
        var d = V(V({}, o.getMeta()), {}, {
          destroy: c
        });
        Hr(o.metaCache, d) || u(d), o.metaCache = d;
      } else
        o.metaCache = null;
    }), z(Me(o), "onStoreChange", function(c, u, d) {
      var f = o.props, m = f.shouldUpdate, v = f.dependencies, h = v === void 0 ? [] : v, p = f.onReset, g = d.store, b = o.getNamePath(), y = o.getValue(c), C = o.getValue(g), S = u && ma(u, b);
      switch (d.type === "valueUpdate" && d.source === "external" && y !== C && (o.touched = !0, o.dirty = !0, o.validatePromise = null, o.errors = ir, o.warnings = ir, o.triggerMetaEvent()), d.type) {
        case "reset":
          if (!u || S) {
            o.touched = !1, o.dirty = !1, o.validatePromise = void 0, o.errors = ir, o.warnings = ir, o.triggerMetaEvent(), p == null || p(), o.refresh();
            return;
          }
          break;
        case "remove": {
          if (m) {
            o.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var $ = d.data;
          if (S) {
            "touched" in $ && (o.touched = $.touched), "validating" in $ && !("originRCField" in $) && (o.validatePromise = $.validating ? Promise.resolve([]) : null), "errors" in $ && (o.errors = $.errors || ir), "warnings" in $ && (o.warnings = $.warnings || ir), o.dirty = !0, o.triggerMetaEvent(), o.reRender();
            return;
          } else if ("value" in $ && ma(u, b, !0)) {
            o.reRender();
            return;
          }
          if (m && !b.length && mg(m, c, g, y, C, d)) {
            o.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var x = h.map(gn);
          if (x.some(function(w) {
            return ma(d.relatedFields, w);
          })) {
            o.reRender();
            return;
          }
          break;
        }
        default:
          if (S || (!h.length || b.length || m) && mg(m, c, g, y, C, d)) {
            o.reRender();
            return;
          }
          break;
      }
      m === !0 && o.reRender();
    }), z(Me(o), "validateRules", function(c) {
      var u = o.getNamePath(), d = o.getValue(), f = c || {}, m = f.triggerName, v = f.validateOnly, h = v === void 0 ? !1 : v, p = Promise.resolve().then(/* @__PURE__ */ go(/* @__PURE__ */ Fn().mark(function g() {
        var b, y, C, S, $, x, w;
        return Fn().wrap(function(O) {
          for (; ; )
            switch (O.prev = O.next) {
              case 0:
                if (o.mounted) {
                  O.next = 2;
                  break;
                }
                return O.abrupt("return", []);
              case 2:
                if (b = o.props, y = b.validateFirst, C = y === void 0 ? !1 : y, S = b.messageVariables, $ = b.validateDebounce, x = o.getRules(), m && (x = x.filter(function(E) {
                  return E;
                }).filter(function(E) {
                  var I = E.validateTrigger;
                  if (!I)
                    return !0;
                  var k = ld(I);
                  return k.includes(m);
                })), !($ && m)) {
                  O.next = 10;
                  break;
                }
                return O.next = 8, new Promise(function(E) {
                  setTimeout(E, $);
                });
              case 8:
                if (o.validatePromise === p) {
                  O.next = 10;
                  break;
                }
                return O.abrupt("return", []);
              case 10:
                return w = pR(u, d, x, c, C, S), w.catch(function(E) {
                  return E;
                }).then(function() {
                  var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ir;
                  if (o.validatePromise === p) {
                    var I;
                    o.validatePromise = null;
                    var k = [], M = [];
                    (I = E.forEach) === null || I === void 0 || I.call(E, function(P) {
                      var _ = P.rule.warningOnly, D = P.errors, R = D === void 0 ? ir : D;
                      _ ? M.push.apply(M, be(R)) : k.push.apply(k, be(R));
                    }), o.errors = k, o.warnings = M, o.triggerMetaEvent(), o.reRender();
                  }
                }), O.abrupt("return", w);
              case 13:
              case "end":
                return O.stop();
            }
        }, g);
      })));
      return h || (o.validatePromise = p, o.dirty = !0, o.errors = ir, o.warnings = ir, o.triggerMetaEvent(), o.reRender()), p;
    }), z(Me(o), "isFieldValidating", function() {
      return !!o.validatePromise;
    }), z(Me(o), "isFieldTouched", function() {
      return o.touched;
    }), z(Me(o), "isFieldDirty", function() {
      if (o.dirty || o.props.initialValue !== void 0)
        return !0;
      var c = o.props.fieldContext, u = c.getInternalHooks(Eo), d = u.getInitialValue;
      return d(o.getNamePath()) !== void 0;
    }), z(Me(o), "getErrors", function() {
      return o.errors;
    }), z(Me(o), "getWarnings", function() {
      return o.warnings;
    }), z(Me(o), "isListField", function() {
      return o.props.isListField;
    }), z(Me(o), "isList", function() {
      return o.props.isList;
    }), z(Me(o), "isPreserve", function() {
      return o.props.preserve;
    }), z(Me(o), "getMeta", function() {
      o.prevValidating = o.isFieldValidating();
      var c = {
        touched: o.isFieldTouched(),
        validating: o.prevValidating,
        errors: o.errors,
        warnings: o.warnings,
        name: o.getNamePath(),
        validated: o.validatePromise === null
      };
      return c;
    }), z(Me(o), "getOnlyChild", function(c) {
      if (typeof c == "function") {
        var u = o.getMeta();
        return V(V({}, o.getOnlyChild(c(o.getControlled(), u, o.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var d = Pn(c);
      return d.length !== 1 || !/* @__PURE__ */ s.isValidElement(d[0]) ? {
        child: d,
        isFunction: !1
      } : {
        child: d[0],
        isFunction: !1
      };
    }), z(Me(o), "getValue", function(c) {
      var u = o.props.fieldContext.getFieldsValue, d = o.getNamePath();
      return nr(c || u(!0), d);
    }), z(Me(o), "getControlled", function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = o.props, d = u.trigger, f = u.validateTrigger, m = u.getValueFromEvent, v = u.normalize, h = u.valuePropName, p = u.getValueProps, g = u.fieldContext, b = f !== void 0 ? f : g.validateTrigger, y = o.getNamePath(), C = g.getInternalHooks, S = g.getFieldsValue, $ = C(Eo), x = $.dispatch, w = o.getValue(), N = p || function(k) {
        return z({}, h, k);
      }, O = c[d], E = V(V({}, c), N(w));
      E[d] = function() {
        o.touched = !0, o.dirty = !0, o.triggerMetaEvent();
        for (var k, M = arguments.length, P = new Array(M), _ = 0; _ < M; _++)
          P[_] = arguments[_];
        m ? k = m.apply(void 0, P) : k = CR.apply(void 0, [h].concat(P)), v && (k = v(k, w, S(!0))), x({
          type: "updateValue",
          namePath: y,
          value: k
        }), O && O.apply(void 0, P);
      };
      var I = ld(b || []);
      return I.forEach(function(k) {
        var M = E[k];
        E[k] = function() {
          M && M.apply(void 0, arguments);
          var P = o.props.rules;
          P && P.length && x({
            type: "validateField",
            namePath: y,
            triggerName: k
          });
        };
      }), E;
    }), r.fieldContext) {
      var a = r.fieldContext.getInternalHooks, i = a(Eo), l = i.initEntityValue;
      l(Me(o));
    }
    return o;
  }
  return wn(n, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props, a = o.shouldUpdate, i = o.fieldContext;
      if (this.mounted = !0, i) {
        var l = i.getInternalHooks, c = l(Eo), u = c.registerField;
        this.cancelRegisterFunc = u(this);
      }
      a === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state.resetCount, a = this.props.children, i = this.getOnlyChild(a), l = i.child, c = i.isFunction, u;
      return c ? u = l : /* @__PURE__ */ s.isValidElement(l) ? u = /* @__PURE__ */ s.cloneElement(l, this.getControlled(l.props)) : (tt(!l, "`children` of Field is not validate ReactElement."), u = l), /* @__PURE__ */ s.createElement(s.Fragment, {
        key: o
      }, u);
    }
  }]), n;
}(s.Component);
z(If, "contextType", _o);
z(If, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function Pf(e) {
  var t = e.name, n = vt(e, SR), r = s.useContext(_o), o = s.useContext(Ii), a = t !== void 0 ? gn(t) : void 0, i = "keep";
  return n.isListField || (i = "_".concat((a || []).join("_"))), process.env.NODE_ENV !== "production" && n.preserve === !1 && n.isListField && a.length <= 1 && tt(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ s.createElement(If, fe({
    key: i,
    name: a,
    isListField: !!o
  }, n, {
    fieldContext: r
  }));
}
function B0(e) {
  var t = e.name, n = e.initialValue, r = e.children, o = e.rules, a = e.validateTrigger, i = e.isListField, l = s.useContext(_o), c = s.useContext(Ii), u = s.useRef({
    keys: [],
    id: 0
  }), d = u.current, f = s.useMemo(function() {
    var p = gn(l.prefixName) || [];
    return [].concat(be(p), be(gn(t)));
  }, [l.prefixName, t]), m = s.useMemo(function() {
    return V(V({}, l), {}, {
      prefixName: f
    });
  }, [l, f]), v = s.useMemo(function() {
    return {
      getKey: function(g) {
        var b = f.length, y = g[b];
        return [d.keys[y], g.slice(b + 1)];
      }
    };
  }, [f]);
  if (typeof r != "function")
    return tt(!1, "Form.List only accepts function as children."), null;
  var h = function(g, b, y) {
    var C = y.source;
    return C === "internal" ? !1 : g !== b;
  };
  return /* @__PURE__ */ s.createElement(Ii.Provider, {
    value: v
  }, /* @__PURE__ */ s.createElement(_o.Provider, {
    value: m
  }, /* @__PURE__ */ s.createElement(Pf, {
    name: [],
    shouldUpdate: h,
    rules: o,
    validateTrigger: a,
    initialValue: n,
    isList: !0,
    isListField: i ?? !!c
  }, function(p, g) {
    var b = p.value, y = b === void 0 ? [] : b, C = p.onChange, S = l.getFieldValue, $ = function() {
      var O = S(f || []);
      return O || [];
    }, x = {
      add: function(O, E) {
        var I = $();
        E >= 0 && E <= I.length ? (d.keys = [].concat(be(d.keys.slice(0, E)), [d.id], be(d.keys.slice(E))), C([].concat(be(I.slice(0, E)), [O], be(I.slice(E))))) : (process.env.NODE_ENV !== "production" && (E < 0 || E > I.length) && tt(!1, "The second parameter of the add function should be a valid positive number."), d.keys = [].concat(be(d.keys), [d.id]), C([].concat(be(I), [O]))), d.id += 1;
      },
      remove: function(O) {
        var E = $(), I = new Set(Array.isArray(O) ? O : [O]);
        I.size <= 0 || (d.keys = d.keys.filter(function(k, M) {
          return !I.has(M);
        }), C(E.filter(function(k, M) {
          return !I.has(M);
        })));
      },
      move: function(O, E) {
        if (O !== E) {
          var I = $();
          O < 0 || O >= I.length || E < 0 || E >= I.length || (d.keys = fg(d.keys, O, E), C(fg(I, O, E)));
        }
      }
    }, w = y || [];
    return Array.isArray(w) || (w = [], process.env.NODE_ENV !== "production" && tt(!1, "Current value of '".concat(f.join(" > "), "' is not an array type."))), r(w.map(function(N, O) {
      var E = d.keys[O];
      return E === void 0 && (d.keys[O] = d.id, E = d.keys[O], d.id += 1), {
        name: O,
        key: E,
        isListField: !0
      };
    }), x, g);
  })));
}
function xR(e) {
  var t = !1, n = e.length, r = [];
  return e.length ? new Promise(function(o, a) {
    e.forEach(function(i, l) {
      i.catch(function(c) {
        return t = !0, c;
      }).then(function(c) {
        n -= 1, r[l] = c, !(n > 0) && (t && a(r), o(r));
      });
    });
  }) : Promise.resolve([]);
}
var H0 = "__@field_split__";
function Uc(e) {
  return e.map(function(t) {
    return "".concat(mt(t), ":").concat(t);
  }).join(H0);
}
var Xo = /* @__PURE__ */ function() {
  function e() {
    $n(this, e), z(this, "kvs", /* @__PURE__ */ new Map());
  }
  return wn(e, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(Uc(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(Uc(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var o = this.get(n), a = r(o);
      a ? this.set(n, a) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(Uc(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return be(this.kvs.entries()).map(function(r) {
        var o = Q(r, 2), a = o[0], i = o[1], l = a.split(H0);
        return n({
          key: l.map(function(c) {
            var u = c.match(/^([^:]*):(.*)$/), d = Q(u, 3), f = d[1], m = d[2];
            return f === "number" ? Number(m) : m;
          }),
          value: i
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var o = r.key, a = r.value;
        return n[o.join(".")] = a, null;
      }), n;
    }
  }]), e;
}(), $R = ["name"], wR = /* @__PURE__ */ wn(function e(t) {
  var n = this;
  $n(this, e), z(this, "formHooked", !1), z(this, "forceRootUpdate", void 0), z(this, "subscribable", !0), z(this, "store", {}), z(this, "fieldEntities", []), z(this, "initialValues", {}), z(this, "callbacks", {}), z(this, "validateMessages", null), z(this, "preserve", null), z(this, "lastValidatePromise", null), z(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), z(this, "getInternalHooks", function(r) {
    return r === Eo ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (tt(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), z(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), z(this, "prevWithoutPreserves", null), z(this, "setInitialValues", function(r, o) {
    if (n.initialValues = r || {}, o) {
      var a, i = ca(r, n.store);
      (a = n.prevWithoutPreserves) === null || a === void 0 || a.map(function(l) {
        var c = l.key;
        i = gr(i, c, nr(r, c));
      }), n.prevWithoutPreserves = null, n.updateStore(i);
    }
  }), z(this, "destroyForm", function() {
    var r = new Xo();
    n.getFieldEntities(!0).forEach(function(o) {
      n.isMergedPreserve(o.isPreserve()) || r.set(o.getNamePath(), !0);
    }), n.prevWithoutPreserves = r;
  }), z(this, "getInitialValue", function(r) {
    var o = nr(n.initialValues, r);
    return r.length ? ca(o) : o;
  }), z(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), z(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), z(this, "setPreserve", function(r) {
    n.preserve = r;
  }), z(this, "watchList", []), z(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(o) {
        return o !== r;
      });
    };
  }), z(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var o = n.getFieldsValue(), a = n.getFieldsValue(!0);
      n.watchList.forEach(function(i) {
        i(o, a, r);
      });
    }
  }), z(this, "timeoutId", null), z(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !n.timeoutId && typeof window < "u" && (n.timeoutId = setTimeout(function() {
      n.timeoutId = null, n.formHooked || tt(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), z(this, "updateStore", function(r) {
    n.store = r;
  }), z(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(o) {
      return o.getNamePath().length;
    }) : n.fieldEntities;
  }), z(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, o = new Xo();
    return n.getFieldEntities(r).forEach(function(a) {
      var i = a.getNamePath();
      o.set(i, a);
    }), o;
  }), z(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var o = n.getFieldsMap(!0);
    return r.map(function(a) {
      var i = gn(a);
      return o.get(i) || {
        INVALIDATE_NAME_PATH: gn(a)
      };
    });
  }), z(this, "getFieldsValue", function(r, o) {
    n.warningUnhooked();
    var a, i, l;
    if (r === !0 || Array.isArray(r) ? (a = r, i = o) : r && mt(r) === "object" && (l = r.strict, i = r.filter), a === !0 && !i)
      return n.store;
    var c = n.getFieldEntitiesForNamePathList(Array.isArray(a) ? a : null), u = [];
    return c.forEach(function(d) {
      var f, m, v = "INVALIDATE_NAME_PATH" in d ? d.INVALIDATE_NAME_PATH : d.getNamePath();
      if (l) {
        var h, p;
        if ((h = (p = d).isList) !== null && h !== void 0 && h.call(p))
          return;
      } else if (!a && (f = (m = d).isListField) !== null && f !== void 0 && f.call(m))
        return;
      if (!i)
        u.push(v);
      else {
        var g = "getMeta" in d ? d.getMeta() : null;
        i(g) && u.push(v);
      }
    }), dg(n.store, u.map(gn));
  }), z(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var o = gn(r);
    return nr(n.store, o);
  }), z(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntitiesForNamePathList(r);
    return o.map(function(a, i) {
      return a && !("INVALIDATE_NAME_PATH" in a) ? {
        name: a.getNamePath(),
        errors: a.getErrors(),
        warnings: a.getWarnings()
      } : {
        name: gn(r[i]),
        errors: [],
        warnings: []
      };
    });
  }), z(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var o = gn(r), a = n.getFieldsError([o])[0];
    return a.errors;
  }), z(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var o = gn(r), a = n.getFieldsError([o])[0];
    return a.warnings;
  }), z(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
      o[a] = arguments[a];
    var i = o[0], l = o[1], c, u = !1;
    o.length === 0 ? c = null : o.length === 1 ? Array.isArray(i) ? (c = i.map(gn), u = !1) : (c = null, u = i) : (c = i.map(gn), u = l);
    var d = n.getFieldEntities(!0), f = function(g) {
      return g.isFieldTouched();
    };
    if (!c)
      return u ? d.every(f) : d.some(f);
    var m = new Xo();
    c.forEach(function(p) {
      m.set(p, []);
    }), d.forEach(function(p) {
      var g = p.getNamePath();
      c.forEach(function(b) {
        b.every(function(y, C) {
          return g[C] === y;
        }) && m.update(b, function(y) {
          return [].concat(be(y), [p]);
        });
      });
    });
    var v = function(g) {
      return g.some(f);
    }, h = m.map(function(p) {
      var g = p.value;
      return g;
    });
    return u ? h.every(v) : h.some(v);
  }), z(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), z(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntities();
    if (!r)
      return o.some(function(i) {
        return i.isFieldValidating();
      });
    var a = r.map(gn);
    return o.some(function(i) {
      var l = i.getNamePath();
      return ma(a, l) && i.isFieldValidating();
    });
  }), z(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), z(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = new Xo(), a = n.getFieldEntities(!0);
    a.forEach(function(c) {
      var u = c.props.initialValue, d = c.getNamePath();
      if (u !== void 0) {
        var f = o.get(d) || /* @__PURE__ */ new Set();
        f.add({
          entity: c,
          value: u
        }), o.set(d, f);
      }
    });
    var i = function(u) {
      u.forEach(function(d) {
        var f = d.props.initialValue;
        if (f !== void 0) {
          var m = d.getNamePath(), v = n.getInitialValue(m);
          if (v !== void 0)
            tt(!1, "Form already set 'initialValues' with path '".concat(m.join("."), "'. Field can not overwrite it."));
          else {
            var h = o.get(m);
            if (h && h.size > 1)
              tt(!1, "Multiple Field with path '".concat(m.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (h) {
              var p = n.getFieldValue(m), g = d.isListField();
              !g && (!r.skipExist || p === void 0) && n.updateStore(gr(n.store, m, be(h)[0].value));
            }
          }
        }
      });
    }, l;
    r.entities ? l = r.entities : r.namePathList ? (l = [], r.namePathList.forEach(function(c) {
      var u = o.get(c);
      if (u) {
        var d;
        (d = l).push.apply(d, be(be(u).map(function(f) {
          return f.entity;
        })));
      }
    })) : l = a, i(l);
  }), z(this, "resetFields", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (!r) {
      n.updateStore(ca(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(o, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var a = r.map(gn);
    a.forEach(function(i) {
      var l = n.getInitialValue(i);
      n.updateStore(gr(n.store, i, l));
    }), n.resetWithFieldInitialValue({
      namePathList: a
    }), n.notifyObservers(o, a, {
      type: "reset"
    }), n.notifyWatch(a);
  }), z(this, "setFields", function(r) {
    n.warningUnhooked();
    var o = n.store, a = [];
    r.forEach(function(i) {
      var l = i.name, c = vt(i, $R), u = gn(l);
      a.push(u), "value" in c && n.updateStore(gr(n.store, u, c.value)), n.notifyObservers(o, [u], {
        type: "setField",
        data: i
      });
    }), n.notifyWatch(a);
  }), z(this, "getFields", function() {
    var r = n.getFieldEntities(!0), o = r.map(function(a) {
      var i = a.getNamePath(), l = a.getMeta(), c = V(V({}, l), {}, {
        name: i,
        value: n.getFieldValue(i)
      });
      return Object.defineProperty(c, "originRCField", {
        value: !0
      }), c;
    });
    return o;
  }), z(this, "initEntityValue", function(r) {
    var o = r.props.initialValue;
    if (o !== void 0) {
      var a = r.getNamePath(), i = nr(n.store, a);
      i === void 0 && n.updateStore(gr(n.store, a, o));
    }
  }), z(this, "isMergedPreserve", function(r) {
    var o = r !== void 0 ? r : n.preserve;
    return o ?? !0;
  }), z(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var o = r.getNamePath();
    if (n.notifyWatch([o]), r.props.initialValue !== void 0) {
      var a = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(a, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(i, l) {
      var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(f) {
        return f !== r;
      }), !n.isMergedPreserve(l) && (!i || c.length > 1)) {
        var u = i ? void 0 : n.getInitialValue(o);
        if (o.length && n.getFieldValue(o) !== u && n.fieldEntities.every(function(f) {
          return (
            // Only reset when no namePath exist
            !A0(f.getNamePath(), o)
          );
        })) {
          var d = n.store;
          n.updateStore(gr(d, o, u, !0)), n.notifyObservers(d, [o], {
            type: "remove"
          }), n.triggerDependenciesUpdate(d, o);
        }
      }
      n.notifyWatch([o]);
    };
  }), z(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var o = r.namePath, a = r.value;
        n.updateValue(o, a);
        break;
      }
      case "validateField": {
        var i = r.namePath, l = r.triggerName;
        n.validateFields([i], {
          triggerName: l
        });
        break;
      }
    }
  }), z(this, "notifyObservers", function(r, o, a) {
    if (n.subscribable) {
      var i = V(V({}, a), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(l) {
        var c = l.onStoreChange;
        c(r, o, i);
      });
    } else
      n.forceRootUpdate();
  }), z(this, "triggerDependenciesUpdate", function(r, o) {
    var a = n.getDependencyChildrenFields(o);
    return a.length && n.validateFields(a), n.notifyObservers(r, a, {
      type: "dependenciesUpdate",
      relatedFields: [o].concat(be(a))
    }), a;
  }), z(this, "updateValue", function(r, o) {
    var a = gn(r), i = n.store;
    n.updateStore(gr(n.store, a, o)), n.notifyObservers(i, [a], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([a]);
    var l = n.triggerDependenciesUpdate(i, a), c = n.callbacks.onValuesChange;
    if (c) {
      var u = dg(n.store, [a]);
      c(u, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([a].concat(be(l)));
  }), z(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (r) {
      var a = ca(n.store, r);
      n.updateStore(a);
    }
    n.notifyObservers(o, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), z(this, "setFieldValue", function(r, o) {
    n.setFields([{
      name: r,
      value: o
    }]);
  }), z(this, "getDependencyChildrenFields", function(r) {
    var o = /* @__PURE__ */ new Set(), a = [], i = new Xo();
    n.getFieldEntities().forEach(function(c) {
      var u = c.props.dependencies;
      (u || []).forEach(function(d) {
        var f = gn(d);
        i.update(f, function() {
          var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return m.add(c), m;
        });
      });
    });
    var l = function c(u) {
      var d = i.get(u) || /* @__PURE__ */ new Set();
      d.forEach(function(f) {
        if (!o.has(f)) {
          o.add(f);
          var m = f.getNamePath();
          f.isFieldDirty() && m.length && (a.push(m), c(m));
        }
      });
    };
    return l(r), a;
  }), z(this, "triggerOnFieldsChange", function(r, o) {
    var a = n.callbacks.onFieldsChange;
    if (a) {
      var i = n.getFields();
      if (o) {
        var l = new Xo();
        o.forEach(function(u) {
          var d = u.name, f = u.errors;
          l.set(d, f);
        }), i.forEach(function(u) {
          u.errors = l.get(u.name) || u.errors;
        });
      }
      var c = i.filter(function(u) {
        var d = u.name;
        return ma(r, d);
      });
      c.length && a(c, i);
    }
  }), z(this, "validateFields", function(r, o) {
    n.warningUnhooked();
    var a, i;
    Array.isArray(r) || typeof r == "string" || typeof o == "string" ? (a = r, i = o) : i = r;
    var l = !!a, c = l ? a.map(gn) : [], u = [], d = String(Date.now()), f = /* @__PURE__ */ new Set(), m = i || {}, v = m.recursive, h = m.dirty;
    n.getFieldEntities(!0).forEach(function(y) {
      if (l || c.push(y.getNamePath()), !(!y.props.rules || !y.props.rules.length) && !(h && !y.isFieldDirty())) {
        var C = y.getNamePath();
        if (f.add(C.join(d)), !l || ma(c, C, v)) {
          var S = y.validateRules(V({
            validateMessages: V(V({}, z0), n.validateMessages)
          }, i));
          u.push(S.then(function() {
            return {
              name: C,
              errors: [],
              warnings: []
            };
          }).catch(function($) {
            var x, w = [], N = [];
            return (x = $.forEach) === null || x === void 0 || x.call($, function(O) {
              var E = O.rule.warningOnly, I = O.errors;
              E ? N.push.apply(N, be(I)) : w.push.apply(w, be(I));
            }), w.length ? Promise.reject({
              name: C,
              errors: w,
              warnings: N
            }) : {
              name: C,
              errors: w,
              warnings: N
            };
          }));
        }
      }
    });
    var p = xR(u);
    n.lastValidatePromise = p, p.catch(function(y) {
      return y;
    }).then(function(y) {
      var C = y.map(function(S) {
        var $ = S.name;
        return $;
      });
      n.notifyObservers(n.store, C, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(C, y);
    });
    var g = p.then(function() {
      return n.lastValidatePromise === p ? Promise.resolve(n.getFieldsValue(c)) : Promise.reject([]);
    }).catch(function(y) {
      var C = y.filter(function(S) {
        return S && S.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(c),
        errorFields: C,
        outOfDate: n.lastValidatePromise !== p
      });
    });
    g.catch(function(y) {
      return y;
    });
    var b = c.filter(function(y) {
      return f.has(y.join(d));
    });
    return n.triggerOnFieldsChange(b), g;
  }), z(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var o = n.callbacks.onFinish;
      if (o)
        try {
          o(r);
        } catch (a) {
          console.error(a);
        }
    }).catch(function(r) {
      var o = n.callbacks.onFinishFailed;
      o && o(r);
    });
  }), this.forceRootUpdate = t;
});
function Rf(e) {
  var t = s.useRef(), n = s.useState({}), r = Q(n, 2), o = r[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var a = function() {
        o({});
      }, i = new wR(a);
      t.current = i.getForm();
    }
  return [t.current];
}
var hd = /* @__PURE__ */ s.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), V0 = function(t) {
  var n = t.validateMessages, r = t.onFormChange, o = t.onFormFinish, a = t.children, i = s.useContext(hd), l = s.useRef({});
  return /* @__PURE__ */ s.createElement(hd.Provider, {
    value: V(V({}, i), {}, {
      validateMessages: V(V({}, i.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(u, d) {
        r && r(u, {
          changedFields: d,
          forms: l.current
        }), i.triggerFormChange(u, d);
      },
      triggerFormFinish: function(u, d) {
        o && o(u, {
          values: d,
          forms: l.current
        }), i.triggerFormFinish(u, d);
      },
      registerForm: function(u, d) {
        u && (l.current = V(V({}, l.current), {}, z({}, u, d))), i.registerForm(u, d);
      },
      unregisterForm: function(u) {
        var d = V({}, l.current);
        delete d[u], l.current = d, i.unregisterForm(u);
      }
    })
  }, a);
}, ER = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"], OR = function(t, n) {
  var r = t.name, o = t.initialValues, a = t.fields, i = t.form, l = t.preserve, c = t.children, u = t.component, d = u === void 0 ? "form" : u, f = t.validateMessages, m = t.validateTrigger, v = m === void 0 ? "onChange" : m, h = t.onValuesChange, p = t.onFieldsChange, g = t.onFinish, b = t.onFinishFailed, y = vt(t, ER), C = s.useContext(hd), S = Rf(i), $ = Q(S, 1), x = $[0], w = x.getInternalHooks(Eo), N = w.useSubscribe, O = w.setInitialValues, E = w.setCallbacks, I = w.setValidateMessages, k = w.setPreserve, M = w.destroyForm;
  s.useImperativeHandle(n, function() {
    return x;
  }), s.useEffect(function() {
    return C.registerForm(r, x), function() {
      C.unregisterForm(r);
    };
  }, [C, x, r]), I(V(V({}, C.validateMessages), f)), E({
    onValuesChange: h,
    onFieldsChange: function(A) {
      if (C.triggerFormChange(r, A), p) {
        for (var B = arguments.length, K = new Array(B > 1 ? B - 1 : 0), Y = 1; Y < B; Y++)
          K[Y - 1] = arguments[Y];
        p.apply(void 0, [A].concat(K));
      }
    },
    onFinish: function(A) {
      C.triggerFormFinish(r, A), g && g(A);
    },
    onFinishFailed: b
  }), k(l);
  var P = s.useRef(null);
  O(o, !P.current), P.current || (P.current = !0), s.useEffect(
    function() {
      return M;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var _, D = typeof c == "function";
  if (D) {
    var R = x.getFieldsValue(!0);
    _ = c(R, x);
  } else
    _ = c;
  N(!D);
  var T = s.useRef();
  s.useEffect(function() {
    yR(T.current || [], a || []) || x.setFields(a || []), T.current = a;
  }, [a, x]);
  var L = s.useMemo(function() {
    return V(V({}, x), {}, {
      validateTrigger: v
    });
  }, [x, v]), F = /* @__PURE__ */ s.createElement(Ii.Provider, {
    value: null
  }, /* @__PURE__ */ s.createElement(_o.Provider, {
    value: L
  }, _));
  return d === !1 ? F : /* @__PURE__ */ s.createElement(d, fe({}, y, {
    onSubmit: function(A) {
      A.preventDefault(), A.stopPropagation(), x.submit();
    },
    onReset: function(A) {
      var B;
      A.preventDefault(), x.resetFields(), (B = y.onReset) === null || B === void 0 || B.call(y, A);
    }
  }), F);
};
function vg(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var NR = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), n = Xe(t);
  tt(n.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function Mf() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], o = t[1], a = o === void 0 ? {} : o, i = FP(a) ? {
    form: a
  } : a, l = i.form, c = Ht(), u = Q(c, 2), d = u[0], f = u[1], m = nn(function() {
    return vg(d);
  }, [d]), v = Xe(m);
  v.current = m;
  var h = qt(_o), p = l || h, g = p && p._init;
  process.env.NODE_ENV !== "production" && tt(t.length === 2 ? l ? g : !0 : g, "useWatch requires a form instance since it can not auto detect from context.");
  var b = gn(r), y = Xe(b);
  return y.current = b, NR(b), Bt(
    function() {
      if (g) {
        var C = p.getFieldsValue, S = p.getInternalHooks, $ = S(Eo), x = $.registerWatch, w = function(I, k) {
          var M = i.preserve ? k : I;
          return typeof r == "function" ? r(M) : nr(M, y.current);
        }, N = x(function(E, I) {
          var k = w(E, I), M = vg(k);
          v.current !== M && (v.current = M, f(k));
        }), O = w(C(), C(!0));
        return d !== O && f(O), N;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), d;
}
var IR = /* @__PURE__ */ s.forwardRef(OR), Ia = IR;
Ia.FormProvider = V0;
Ia.Field = Pf;
Ia.List = B0;
Ia.useForm = Rf;
Ia.useWatch = Mf;
const Kr = /* @__PURE__ */ s.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
}), W0 = /* @__PURE__ */ s.createContext(null), K0 = (e) => {
  const t = an(e, ["prefixCls"]);
  return /* @__PURE__ */ s.createElement(V0, Object.assign({}, t));
}, Tf = /* @__PURE__ */ s.createContext({
  prefixCls: ""
}), Tn = /* @__PURE__ */ s.createContext({});
process.env.NODE_ENV !== "production" && (Tn.displayName = "FormItemInputContext");
const us = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const o = qt(Tn), a = nn(() => {
    const i = Object.assign({}, o);
    return r && delete i.isFormItemInput, n && (delete i.status, delete i.hasFeedback, delete i.feedbackIcon), i;
  }, [n, r, o]);
  return /* @__PURE__ */ s.createElement(Tn.Provider, {
    value: a
  }, t);
}, q0 = /* @__PURE__ */ uo(void 0);
function gg() {
}
const PR = /* @__PURE__ */ s.createContext({
  add: gg,
  remove: gg
});
function G0(e) {
  const t = s.useContext(PR), n = s.useRef();
  return Lt((o) => {
    if (o) {
      const a = e ? o.querySelector(e) : o;
      t.add(a), n.current = a;
    } else
      t.remove(n.current);
  });
}
const RR = () => {
  const {
    cancelButtonProps: e,
    cancelTextLocale: t,
    onCancel: n
  } = qt(Hi);
  return /* @__PURE__ */ le.createElement(or, Object.assign({
    onClick: n
  }, e), t);
}, pg = RR, MR = () => {
  const {
    confirmLoading: e,
    okButtonProps: t,
    okType: n,
    okTextLocale: r,
    onOk: o
  } = qt(Hi);
  return /* @__PURE__ */ le.createElement(or, Object.assign({}, xf(n), {
    loading: e,
    onClick: o
  }, t), r);
}, hg = MR;
function U0(e, t) {
  return /* @__PURE__ */ le.createElement("span", {
    className: `${e}-close-x`
  }, t || /* @__PURE__ */ le.createElement(mo, {
    className: `${e}-close-icon`
  }));
}
const Y0 = (e) => {
  const {
    okText: t,
    okType: n = "primary",
    cancelText: r,
    confirmLoading: o,
    onOk: a,
    onCancel: i,
    okButtonProps: l,
    cancelButtonProps: c,
    footer: u
  } = e, [d] = ur("Modal", Cb()), f = t || (d == null ? void 0 : d.okText), m = r || (d == null ? void 0 : d.cancelText), v = {
    confirmLoading: o,
    okButtonProps: l,
    cancelButtonProps: c,
    okTextLocale: f,
    cancelTextLocale: m,
    okType: n,
    onOk: a,
    onCancel: i
  }, h = le.useMemo(() => v, be(Object.values(v)));
  let p;
  return typeof u == "function" || typeof u > "u" ? (p = /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.createElement(pg, null), /* @__PURE__ */ le.createElement(hg, null)), typeof u == "function" && (p = u(p, {
    OkBtn: hg,
    CancelBtn: pg
  })), p = /* @__PURE__ */ le.createElement(R0, {
    value: h
  }, p)) : p = u, /* @__PURE__ */ le.createElement(mf, {
    disabled: !1
  }, p);
}, TR = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), _R = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), Bs = function(e, t, n, r) {
  const a = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${a}${e}-enter,
      ${a}${e}-appear
    `]: Object.assign(Object.assign({}, TR(r)), {
      animationPlayState: "paused"
    }),
    [`${a}${e}-leave`]: Object.assign(Object.assign({}, _R(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${a}${e}-enter${e}-enter-active,
      ${a}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${a}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, DR = new kt("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), kR = new kt("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), X0 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: n
  } = e, r = `${n}-fade`, o = t ? "&" : "";
  return [Bs(r, DR, kR, e.motionDurationMid, t), {
    [`
        ${o}${r}-enter,
        ${o}${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${o}${r}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, LR = new kt("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), FR = new kt("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), jR = new kt("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), zR = new kt("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), AR = new kt("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), BR = new kt("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), HR = new kt("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), VR = new kt("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), WR = {
  "move-up": {
    inKeyframes: HR,
    outKeyframes: VR
  },
  "move-down": {
    inKeyframes: LR,
    outKeyframes: FR
  },
  "move-left": {
    inKeyframes: jR,
    outKeyframes: zR
  },
  "move-right": {
    inKeyframes: AR,
    outKeyframes: BR
  }
}, Ca = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = WR[t];
  return [Bs(r, o, a, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, Hs = new kt("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), Vs = new kt("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), Ws = new kt("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), Ks = new kt("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), KR = new kt("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), qR = new kt("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), GR = new kt("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), UR = new kt("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), YR = {
  "slide-up": {
    inKeyframes: Hs,
    outKeyframes: Vs
  },
  "slide-down": {
    inKeyframes: Ws,
    outKeyframes: Ks
  },
  "slide-left": {
    inKeyframes: KR,
    outKeyframes: qR
  },
  "slide-right": {
    inKeyframes: GR,
    outKeyframes: UR
  }
}, Rr = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = YR[t];
  return [Bs(r, o, a, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      ["&-prepare"]: {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, _f = new kt("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), XR = new kt("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), bg = new kt("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), yg = new kt("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), QR = new kt("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), JR = new kt("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), ZR = new kt("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), e2 = new kt("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), t2 = new kt("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), n2 = new kt("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), r2 = new kt("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), o2 = new kt("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), a2 = {
  zoom: {
    inKeyframes: _f,
    outKeyframes: XR
  },
  "zoom-big": {
    inKeyframes: bg,
    outKeyframes: yg
  },
  "zoom-big-fast": {
    inKeyframes: bg,
    outKeyframes: yg
  },
  "zoom-left": {
    inKeyframes: ZR,
    outKeyframes: e2
  },
  "zoom-right": {
    inKeyframes: t2,
    outKeyframes: n2
  },
  "zoom-up": {
    inKeyframes: QR,
    outKeyframes: JR
  },
  "zoom-down": {
    inKeyframes: r2,
    outKeyframes: o2
  }
}, Ki = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = a2[t];
  return [Bs(r, o, a, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, i2 = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), qi = i2;
function Cg(e) {
  return {
    position: e,
    inset: 0
  };
}
const l2 = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return [{
    [`${t}-root`]: {
      [`${t}${n}-zoom-enter, ${t}${n}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: e.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${t}${n}-zoom-leave ${t}-content`]: {
        pointerEvents: "none"
      },
      [`${t}-mask`]: Object.assign(Object.assign({}, Cg("fixed")), {
        zIndex: e.zIndexPopupBase,
        height: "100%",
        backgroundColor: e.colorBgMask,
        pointerEvents: "none",
        [`${t}-hidden`]: {
          display: "none"
        }
      }),
      [`${t}-wrap`]: Object.assign(Object.assign({}, Cg("fixed")), {
        zIndex: e.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch",
        // Note: Firefox not support `:has` yet
        [`&:has(${t}${n}-zoom-enter), &:has(${t}${n}-zoom-appear)`]: {
          pointerEvents: "none"
        }
      })
    }
  }, {
    [`${t}-root`]: X0(e)
  }];
}, s2 = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    // ======================== Root =========================
    {
      [`${t}-root`]: {
        [`${t}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${t}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [t]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${e.screenSMMax}px)`]: {
          [t]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${q(e.marginXS)} auto`
          },
          [`${t}-centered`]: {
            [t]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [t]: Object.assign(Object.assign({}, Gt(e)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${q(e.calc(e.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: e.paddingLG,
        [`${t}-title`]: {
          margin: 0,
          color: e.titleColor,
          fontWeight: e.fontWeightStrong,
          fontSize: e.titleFontSize,
          lineHeight: e.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${t}-content`]: {
          position: "relative",
          backgroundColor: e.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: e.borderRadiusLG,
          boxShadow: e.boxShadow,
          pointerEvents: "auto",
          padding: e.contentPadding
        },
        [`${t}-close`]: Object.assign({
          position: "absolute",
          top: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          zIndex: e.calc(e.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: e.modalCloseIconColor,
          fontWeight: e.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: e.borderRadiusSM,
          width: e.modalCloseBtnSize,
          height: e.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${e.motionDurationMid}, background-color ${e.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: e.fontSizeLG,
            fontStyle: "normal",
            lineHeight: `${q(e.modalCloseBtnSize)}`,
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:hover": {
            color: e.modalIconHoverColor,
            backgroundColor: e.closeBtnHoverBg,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: e.closeBtnActiveBg
          }
        }, lo(e)),
        [`${t}-header`]: {
          color: e.colorText,
          background: e.headerBg,
          borderRadius: `${q(e.borderRadiusLG)} ${q(e.borderRadiusLG)} 0 0`,
          marginBottom: e.headerMarginBottom,
          padding: e.headerPadding,
          borderBottom: e.headerBorderBottom
        },
        [`${t}-body`]: {
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          wordWrap: "break-word",
          padding: e.bodyPadding
        },
        [`${t}-footer`]: {
          textAlign: "end",
          background: e.footerBg,
          marginTop: e.footerMarginTop,
          padding: e.footerPadding,
          borderTop: e.footerBorderTop,
          borderRadius: e.footerBorderRadius,
          [`> ${e.antCls}-btn + ${e.antCls}-btn`]: {
            marginInlineStart: e.marginXS
          }
        },
        [`${t}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${t}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${t}-content,
          ${t}-body,
          ${t}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${t}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, c2 = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-root`]: {
      [`${t}-wrap-rtl`]: {
        direction: "rtl",
        [`${t}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, Q0 = (e) => {
  const t = e.padding, n = e.fontSizeHeading5, r = e.lineHeightHeading5;
  return Dt(e, {
    modalHeaderHeight: e.calc(e.calc(r).mul(n).equal()).add(e.calc(t).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: e.colorSplit,
    modalFooterBorderStyle: e.lineType,
    modalFooterBorderWidth: e.lineWidth,
    modalIconHoverColor: e.colorIconHover,
    modalCloseIconColor: e.colorIcon,
    modalCloseBtnSize: e.fontHeight,
    modalConfirmIconSize: e.fontHeight,
    modalTitleHeight: e.calc(e.titleFontSize).mul(e.titleLineHeight).equal()
  });
}, J0 = (e) => ({
  footerBg: "transparent",
  headerBg: e.colorBgElevated,
  titleLineHeight: e.lineHeightHeading5,
  titleFontSize: e.fontSizeHeading5,
  contentBg: e.colorBgElevated,
  titleColor: e.colorTextHeading,
  // internal
  closeBtnHoverBg: e.wireframe ? "transparent" : e.colorFillContent,
  closeBtnActiveBg: e.wireframe ? "transparent" : e.colorFillContentHover,
  contentPadding: e.wireframe ? 0 : `${q(e.paddingMD)} ${q(e.paddingContentHorizontalLG)}`,
  headerPadding: e.wireframe ? `${q(e.padding)} ${q(e.paddingLG)}` : 0,
  headerBorderBottom: e.wireframe ? `${q(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  headerMarginBottom: e.wireframe ? 0 : e.marginXS,
  bodyPadding: e.wireframe ? e.paddingLG : 0,
  footerPadding: e.wireframe ? `${q(e.paddingXS)} ${q(e.padding)}` : 0,
  footerBorderTop: e.wireframe ? `${q(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  footerBorderRadius: e.wireframe ? `0 0 ${q(e.borderRadiusLG)} ${q(e.borderRadiusLG)}` : 0,
  footerMarginTop: e.wireframe ? 0 : e.marginSM,
  confirmBodyPadding: e.wireframe ? `${q(e.padding * 2)} ${q(e.padding * 2)} ${q(e.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: e.wireframe ? e.margin : e.marginSM,
  confirmBtnsMarginTop: e.wireframe ? e.marginLG : e.marginSM
}), Z0 = Xt("Modal", (e) => {
  const t = Q0(e);
  return [s2(t), c2(t), l2(t), Ki(t, "zoom")];
}, J0, {
  unitless: {
    titleLineHeight: !0
  }
});
var u2 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let bd;
const d2 = (e) => {
  bd = {
    x: e.pageX,
    y: e.pageY
  }, setTimeout(() => {
    bd = null;
  }, 100);
};
LP() && document.documentElement.addEventListener("click", d2, !0);
const f2 = (e) => {
  var t;
  const {
    getPopupContainer: n,
    getPrefixCls: r,
    direction: o,
    modal: a
  } = s.useContext(lt), i = (A) => {
    const {
      onCancel: B
    } = e;
    B == null || B(A);
  }, l = (A) => {
    const {
      onOk: B
    } = e;
    B == null || B(A);
  };
  if (process.env.NODE_ENV !== "production") {
    const A = Rt("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((B) => {
      let [K, Y] = B;
      A.deprecated(!(K in e), K, Y);
    });
  }
  const {
    prefixCls: c,
    className: u,
    rootClassName: d,
    open: f,
    wrapClassName: m,
    centered: v,
    getContainer: h,
    closeIcon: p,
    closable: g,
    focusTriggerAfterClose: b = !0,
    style: y,
    // Deprecated
    visible: C,
    width: S = 520,
    footer: $,
    classNames: x,
    styles: w
  } = e, N = u2(e, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "closeIcon", "closable", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles"]), O = r("modal", c), E = r(), I = En(O), [k, M, P] = Z0(O, I), _ = J(m, {
    [`${O}-centered`]: !!v,
    [`${O}-wrap-rtl`]: o === "rtl"
  }), D = $ !== null && /* @__PURE__ */ s.createElement(Y0, Object.assign({}, e, {
    onOk: l,
    onCancel: i
  })), [R, T] = Nf(g, typeof p < "u" ? p : a == null ? void 0 : a.closeIcon, (A) => U0(O, A), /* @__PURE__ */ s.createElement(mo, {
    className: `${O}-close-icon`
  }), !0), L = G0(`.${O}-content`), [F, j] = vo("Modal", N.zIndex);
  return k(/* @__PURE__ */ s.createElement(so, null, /* @__PURE__ */ s.createElement(us, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ s.createElement(ji.Provider, {
    value: j
  }, /* @__PURE__ */ s.createElement(k0, Object.assign({
    width: S
  }, N, {
    zIndex: F,
    getContainer: h === void 0 ? n : h,
    prefixCls: O,
    rootClassName: J(M, d, P, I),
    footer: D,
    visible: f ?? C,
    mousePosition: (t = N.mousePosition) !== null && t !== void 0 ? t : bd,
    onClose: i,
    closable: R,
    closeIcon: T,
    focusTriggerAfterClose: b,
    transitionName: Pr(E, "zoom", e.transitionName),
    maskTransitionName: Pr(E, "fade", e.maskTransitionName),
    className: J(M, u, a == null ? void 0 : a.className),
    style: Object.assign(Object.assign({}, a == null ? void 0 : a.style), y),
    classNames: Object.assign(Object.assign(Object.assign({}, a == null ? void 0 : a.classNames), x), {
      wrapper: J(_, x == null ? void 0 : x.wrapper)
    }),
    styles: Object.assign(Object.assign({}, a == null ? void 0 : a.styles), w),
    panelRef: L
  }))))));
}, ey = f2, m2 = (e) => {
  const {
    componentCls: t,
    titleFontSize: n,
    titleLineHeight: r,
    modalConfirmIconSize: o,
    fontSize: a,
    lineHeight: i,
    modalTitleHeight: l,
    fontHeight: c,
    confirmBodyPadding: u
  } = e, d = `${t}-confirm`;
  return {
    [d]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${e.antCls}-modal-header`]: {
        display: "none"
      },
      [`${d}-body-wrapper`]: Object.assign({}, Mo()),
      [`&${t} ${t}-body`]: {
        padding: u
      },
      // ====================== Body ======================
      [`${d}-body`]: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${e.iconCls}`]: {
          flex: "none",
          fontSize: o,
          marginInlineEnd: e.confirmIconMarginInlineEnd,
          marginTop: e.calc(e.calc(c).sub(o).equal()).div(2).equal()
        },
        [`&-has-title > ${e.iconCls}`]: {
          marginTop: e.calc(e.calc(l).sub(o).equal()).div(2).equal()
        }
      },
      [`${d}-paragraph`]: {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: e.marginXS,
        maxWidth: `calc(100% - ${q(e.calc(e.modalConfirmIconSize).add(e.marginSM).equal())})`
      },
      [`${d}-title`]: {
        color: e.colorTextHeading,
        fontWeight: e.fontWeightStrong,
        fontSize: n,
        lineHeight: r
      },
      [`${d}-content`]: {
        color: e.colorText,
        fontSize: a,
        lineHeight: i
      },
      // ===================== Footer =====================
      [`${d}-btns`]: {
        textAlign: "end",
        marginTop: e.confirmBtnsMarginTop,
        [`${e.antCls}-btn + ${e.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: e.marginXS
        }
      }
    },
    [`${d}-error ${d}-body > ${e.iconCls}`]: {
      color: e.colorError
    },
    [`${d}-warning ${d}-body > ${e.iconCls},
        ${d}-confirm ${d}-body > ${e.iconCls}`]: {
      color: e.colorWarning
    },
    [`${d}-info ${d}-body > ${e.iconCls}`]: {
      color: e.colorInfo
    },
    [`${d}-success ${d}-body > ${e.iconCls}`]: {
      color: e.colorSuccess
    }
  };
}, v2 = zo(["Modal", "confirm"], (e) => {
  const t = Q0(e);
  return [m2(t)];
}, J0, {
  // confirm is weak than modal since no conflict here
  order: -1e3
});
var g2 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function ty(e) {
  const {
    prefixCls: t,
    icon: n,
    okText: r,
    cancelText: o,
    confirmPrefixCls: a,
    type: i,
    okCancel: l,
    footer: c,
    // Legacy for static function usage
    locale: u
  } = e, d = g2(e, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (process.env.NODE_ENV !== "production") {
    const w = Rt("Modal");
    process.env.NODE_ENV !== "production" && w(!(typeof n == "string" && n.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${n}\` at https://ant.design/components/icon`);
  }
  let f = n;
  if (!n && n !== null)
    switch (i) {
      case "info":
        f = /* @__PURE__ */ s.createElement(d0, null);
        break;
      case "success":
        f = /* @__PURE__ */ s.createElement(ks, null);
        break;
      case "error":
        f = /* @__PURE__ */ s.createElement(Bo, null);
        break;
      default:
        f = /* @__PURE__ */ s.createElement(Fi, null);
    }
  const m = l ?? i === "confirm", v = e.autoFocusButton === null ? !1 : e.autoFocusButton || "ok", [h] = ur("Modal"), p = u || h, g = r || (m ? p == null ? void 0 : p.okText : p == null ? void 0 : p.justOkText), b = o || (p == null ? void 0 : p.cancelText), y = Object.assign({
    autoFocusButton: v,
    cancelTextLocale: b,
    okTextLocale: g,
    mergedOkCancel: m
  }, d), C = s.useMemo(() => y, be(Object.values(y))), S = /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(qv, null), /* @__PURE__ */ s.createElement(Gv, null)), $ = e.title !== void 0 && e.title !== null, x = `${a}-body`;
  return /* @__PURE__ */ s.createElement("div", {
    className: `${a}-body-wrapper`
  }, /* @__PURE__ */ s.createElement("div", {
    className: J(x, {
      [`${x}-has-title`]: $
    })
  }, f, /* @__PURE__ */ s.createElement("div", {
    className: `${a}-paragraph`
  }, $ && /* @__PURE__ */ s.createElement("span", {
    className: `${a}-title`
  }, e.title), /* @__PURE__ */ s.createElement("div", {
    className: `${a}-content`
  }, e.content))), c === void 0 || typeof c == "function" ? /* @__PURE__ */ s.createElement(R0, {
    value: C
  }, /* @__PURE__ */ s.createElement("div", {
    className: `${a}-btns`
  }, typeof c == "function" ? c(S, {
    OkBtn: Gv,
    CancelBtn: qv
  }) : S)) : c, /* @__PURE__ */ s.createElement(v2, {
    prefixCls: t
  }));
}
const ny = (e) => {
  const {
    close: t,
    zIndex: n,
    afterClose: r,
    open: o,
    keyboard: a,
    centered: i,
    getContainer: l,
    maskStyle: c,
    direction: u,
    prefixCls: d,
    wrapClassName: f,
    rootPrefixCls: m,
    bodyStyle: v,
    closable: h = !1,
    closeIcon: p,
    modalRender: g,
    focusTriggerAfterClose: b,
    onConfirm: y,
    styles: C
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const k = Rt("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((M) => {
      let [P, _] = M;
      k.deprecated(!(P in e), P, _);
    });
  }
  const S = `${d}-confirm`, $ = e.width || 416, x = e.style || {}, w = e.mask === void 0 ? !0 : e.mask, N = e.maskClosable === void 0 ? !1 : e.maskClosable, O = J(S, `${S}-${e.type}`, {
    [`${S}-rtl`]: u === "rtl"
  }, e.className), [, E] = Sn(), I = s.useMemo(() => n !== void 0 ? n : E.zIndexPopupBase + Cf, [n, E]);
  return /* @__PURE__ */ s.createElement(ey, {
    prefixCls: d,
    className: O,
    wrapClassName: J({
      [`${S}-centered`]: !!e.centered
    }, f),
    onCancel: () => {
      t == null || t({
        triggerCancel: !0
      }), y == null || y(!1);
    },
    open: o,
    title: "",
    footer: null,
    transitionName: Pr(m || "", "zoom", e.transitionName),
    maskTransitionName: Pr(m || "", "fade", e.maskTransitionName),
    mask: w,
    maskClosable: N,
    style: x,
    styles: Object.assign({
      body: v,
      mask: c
    }, C),
    width: $,
    zIndex: I,
    afterClose: r,
    keyboard: a,
    centered: i,
    getContainer: l,
    closable: h,
    closeIcon: p,
    modalRender: g,
    focusTriggerAfterClose: b
  }, /* @__PURE__ */ s.createElement(ty, Object.assign({}, e, {
    confirmPrefixCls: S
  })));
}, Df = (e) => {
  const {
    rootPrefixCls: t,
    iconPrefixCls: n,
    direction: r,
    theme: o
  } = e;
  return /* @__PURE__ */ s.createElement($t, {
    prefixCls: t,
    iconPrefixCls: n,
    direction: r,
    theme: o
  }, /* @__PURE__ */ s.createElement(ny, Object.assign({}, e)));
};
process.env.NODE_ENV !== "production" && (ny.displayName = "ConfirmDialog", Df.displayName = "ConfirmDialogWrapper");
const p2 = [], No = p2;
let ry = "";
function oy() {
  return ry;
}
const h2 = (e) => {
  var t, n;
  const {
    prefixCls: r,
    getContainer: o,
    direction: a
  } = e, i = Cb(), l = qt(lt), c = oy() || l.getPrefixCls(), u = r || `${c}-modal`;
  let d = o;
  return d === !1 && (d = void 0, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && jo(!1, "Modal", "Static method not support `getContainer` to be `false` since it do not have context env.")), /* @__PURE__ */ le.createElement(Df, Object.assign({}, e, {
    rootPrefixCls: c,
    prefixCls: u,
    iconPrefixCls: l.iconPrefixCls,
    theme: l.theme,
    direction: a ?? l.direction,
    locale: (n = (t = l.locale) === null || t === void 0 ? void 0 : t.Modal) !== null && n !== void 0 ? n : i,
    getContainer: d
  }));
};
function Gi(e) {
  const t = bf();
  process.env.NODE_ENV !== "production" && !t.holderRender && Jb("Modal");
  const n = document.createDocumentFragment();
  let r = Object.assign(Object.assign({}, e), {
    close: l,
    open: !0
  }), o;
  function a() {
    for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
      d[f] = arguments[f];
    const m = d.some((v) => v && v.triggerCancel);
    e.onCancel && m && e.onCancel.apply(e, [() => {
    }].concat(be(d.slice(1))));
    for (let v = 0; v < No.length; v++)
      if (No[v] === l) {
        No.splice(v, 1);
        break;
      }
    C0(n);
  }
  function i(u) {
    clearTimeout(o), o = setTimeout(() => {
      const d = t.getPrefixCls(void 0, oy()), f = t.getIconPrefixCls(), m = t.getTheme(), v = /* @__PURE__ */ le.createElement(h2, Object.assign({}, u));
      Sf(/* @__PURE__ */ le.createElement($t, {
        prefixCls: d,
        iconPrefixCls: f,
        theme: m
      }, t.holderRender ? t.holderRender(v) : v), n);
    });
  }
  function l() {
    for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
      d[f] = arguments[f];
    r = Object.assign(Object.assign({}, r), {
      open: !1,
      afterClose: () => {
        typeof e.afterClose == "function" && e.afterClose(), a.apply(this, d);
      }
    }), r.visible && delete r.visible, i(r);
  }
  function c(u) {
    typeof u == "function" ? r = u(r) : r = Object.assign(Object.assign({}, r), u), i(r);
  }
  return i(r), No.push(l), {
    destroy: l,
    update: c
  };
}
function ay(e) {
  return Object.assign(Object.assign({}, e), {
    type: "warning"
  });
}
function iy(e) {
  return Object.assign(Object.assign({}, e), {
    type: "info"
  });
}
function ly(e) {
  return Object.assign(Object.assign({}, e), {
    type: "success"
  });
}
function sy(e) {
  return Object.assign(Object.assign({}, e), {
    type: "error"
  });
}
function cy(e) {
  return Object.assign(Object.assign({}, e), {
    type: "confirm"
  });
}
function b2(e) {
  let {
    rootPrefixCls: t
  } = e;
  process.env.NODE_ENV !== "production" && jo(!1, "Modal", "Modal.config is deprecated. Please use ConfigProvider.config instead."), ry = t;
}
var y2 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const C2 = (e, t) => {
  var n, {
    afterClose: r,
    config: o
  } = e, a = y2(e, ["afterClose", "config"]);
  const [i, l] = s.useState(!0), [c, u] = s.useState(o), {
    direction: d,
    getPrefixCls: f
  } = s.useContext(lt), m = f("modal"), v = f(), h = () => {
    var y;
    r(), (y = c.afterClose) === null || y === void 0 || y.call(c);
  }, p = function() {
    l(!1);
    for (var y = arguments.length, C = new Array(y), S = 0; S < y; S++)
      C[S] = arguments[S];
    const $ = C.some((x) => x && x.triggerCancel);
    c.onCancel && $ && c.onCancel.apply(c, [() => {
    }].concat(be(C.slice(1))));
  };
  s.useImperativeHandle(t, () => ({
    destroy: p,
    update: (y) => {
      u((C) => Object.assign(Object.assign({}, C), y));
    }
  }));
  const g = (n = c.okCancel) !== null && n !== void 0 ? n : c.type === "confirm", [b] = ur("Modal", xr.Modal);
  return /* @__PURE__ */ s.createElement(Df, Object.assign({
    prefixCls: m,
    rootPrefixCls: v
  }, c, {
    close: p,
    open: i,
    afterClose: h,
    okText: c.okText || (g ? b == null ? void 0 : b.okText : b == null ? void 0 : b.justOkText),
    direction: c.direction || d,
    cancelText: c.cancelText || (b == null ? void 0 : b.cancelText)
  }, a));
}, S2 = /* @__PURE__ */ s.forwardRef(C2);
let Sg = 0;
const x2 = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef((e, t) => {
  const [n, r] = vI();
  return s.useImperativeHandle(t, () => ({
    patchElement: r
  }), []), /* @__PURE__ */ s.createElement(s.Fragment, null, n);
}));
function $2() {
  const e = s.useRef(null), [t, n] = s.useState([]);
  s.useEffect(() => {
    t.length && (be(t).forEach((i) => {
      i();
    }), n([]));
  }, [t]);
  const r = s.useCallback((a) => function(l) {
    var c;
    Sg += 1;
    const u = /* @__PURE__ */ s.createRef();
    let d;
    const f = new Promise((g) => {
      d = g;
    });
    let m = !1, v;
    const h = /* @__PURE__ */ s.createElement(S2, {
      key: `modal-${Sg}`,
      config: a(l),
      ref: u,
      afterClose: () => {
        v == null || v();
      },
      isSilent: () => m,
      onConfirm: (g) => {
        d(g);
      }
    });
    return v = (c = e.current) === null || c === void 0 ? void 0 : c.patchElement(h), v && No.push(v), {
      destroy: () => {
        function g() {
          var b;
          (b = u.current) === null || b === void 0 || b.destroy();
        }
        u.current ? g() : n((b) => [].concat(be(b), [g]));
      },
      update: (g) => {
        function b() {
          var y;
          (y = u.current) === null || y === void 0 || y.update(g);
        }
        u.current ? b() : n((y) => [].concat(be(y), [b]));
      },
      then: (g) => (m = !0, f.then(g))
    };
  }, []);
  return [s.useMemo(() => ({
    info: r(iy),
    success: r(ly),
    error: r(sy),
    warning: r(ay),
    confirm: r(cy)
  }), []), /* @__PURE__ */ s.createElement(x2, {
    key: "modal-holder",
    ref: e
  })];
}
const w2 = (e) => {
  const {
    componentCls: t,
    notificationMarginEdge: n,
    animationMaxHeight: r
  } = e, o = `${t}-notice`, a = new kt("antNotificationFadeIn", {
    "0%": {
      transform: "translate3d(100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  }), i = new kt("antNotificationTopFadeIn", {
    "0%": {
      top: -r,
      opacity: 0
    },
    "100%": {
      top: 0,
      opacity: 1
    }
  }), l = new kt("antNotificationBottomFadeIn", {
    "0%": {
      bottom: e.calc(r).mul(-1).equal(),
      opacity: 0
    },
    "100%": {
      bottom: 0,
      opacity: 1
    }
  }), c = new kt("antNotificationLeftFadeIn", {
    "0%": {
      transform: "translate3d(-100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  });
  return {
    [t]: {
      [`&${t}-top, &${t}-bottom`]: {
        marginInline: 0,
        [o]: {
          marginInline: "auto auto"
        }
      },
      [`&${t}-top`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: i
        }
      },
      [`&${t}-bottom`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: l
        }
      },
      [`&${t}-topRight, &${t}-bottomRight`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: a
        }
      },
      [`&${t}-topLeft, &${t}-bottomLeft`]: {
        marginRight: {
          value: 0,
          _skip_check_: !0
        },
        marginLeft: {
          value: n,
          _skip_check_: !0
        },
        [o]: {
          marginInlineEnd: "auto",
          marginInlineStart: 0
        },
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: c
        }
      }
    }
  };
}, E2 = w2, O2 = ["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"], N2 = {
  topLeft: "left",
  topRight: "right",
  bottomLeft: "left",
  bottomRight: "right",
  top: "left",
  bottom: "left"
}, I2 = (e, t) => {
  const {
    componentCls: n
  } = e;
  return {
    [`${n}-${t}`]: {
      [`&${n}-stack > ${n}-notice-wrapper`]: {
        [t.startsWith("top") ? "top" : "bottom"]: 0,
        [N2[t]]: {
          value: 0,
          _skip_check_: !0
        }
      }
    }
  };
}, P2 = (e) => {
  const t = {};
  for (let n = 1; n < e.notificationStackLayer; n++)
    t[`&:nth-last-child(${n + 1})`] = {
      overflow: "hidden",
      [`& > ${e.componentCls}-notice`]: {
        opacity: 0,
        transition: `opacity ${e.motionDurationMid}`
      }
    };
  return Object.assign({
    [`&:not(:nth-last-child(-n+${e.notificationStackLayer}))`]: {
      opacity: 0,
      overflow: "hidden",
      color: "transparent",
      pointerEvents: "none"
    }
  }, t);
}, R2 = (e) => {
  const t = {};
  for (let n = 1; n < e.notificationStackLayer; n++)
    t[`&:nth-last-child(${n + 1})`] = {
      background: e.colorBgBlur,
      backdropFilter: "blur(10px)",
      "-webkit-backdrop-filter": "blur(10px)"
    };
  return Object.assign({}, t);
}, M2 = (e) => {
  const {
    componentCls: t
  } = e;
  return Object.assign({
    [`${t}-stack`]: {
      [`& > ${t}-notice-wrapper`]: Object.assign({
        transition: `all ${e.motionDurationSlow}, backdrop-filter 0s`,
        position: "absolute"
      }, P2(e))
    },
    [`${t}-stack:not(${t}-stack-expanded)`]: {
      [`& > ${t}-notice-wrapper`]: Object.assign({}, R2(e))
    },
    [`${t}-stack${t}-stack-expanded`]: {
      [`& > ${t}-notice-wrapper`]: {
        "&:not(:nth-last-child(-n + 1))": {
          opacity: 1,
          overflow: "unset",
          color: "inherit",
          pointerEvents: "auto",
          [`& > ${e.componentCls}-notice`]: {
            opacity: 1
          }
        },
        "&:after": {
          content: '""',
          position: "absolute",
          height: e.margin,
          width: "100%",
          insetInline: 0,
          bottom: e.calc(e.margin).mul(-1).equal(),
          background: "transparent",
          pointerEvents: "auto"
        }
      }
    }
  }, O2.map((n) => I2(e, n)).reduce((n, r) => Object.assign(Object.assign({}, n), r), {}));
}, T2 = M2, uy = (e) => {
  const {
    iconCls: t,
    componentCls: n,
    // .ant-notification
    boxShadow: r,
    fontSizeLG: o,
    notificationMarginBottom: a,
    borderRadiusLG: i,
    colorSuccess: l,
    colorInfo: c,
    colorWarning: u,
    colorError: d,
    colorTextHeading: f,
    notificationBg: m,
    notificationPadding: v,
    notificationMarginEdge: h,
    fontSize: p,
    lineHeight: g,
    width: b,
    notificationIconSize: y,
    colorText: C
  } = e, S = `${n}-notice`;
  return {
    position: "relative",
    marginBottom: a,
    marginInlineStart: "auto",
    background: m,
    borderRadius: i,
    boxShadow: r,
    [S]: {
      padding: v,
      width: b,
      maxWidth: `calc(100vw - ${q(e.calc(h).mul(2).equal())})`,
      overflow: "hidden",
      lineHeight: g,
      wordWrap: "break-word"
    },
    [`${n}-close-icon`]: {
      fontSize: p,
      cursor: "pointer"
    },
    [`${S}-message`]: {
      marginBottom: e.marginXS,
      color: f,
      fontSize: o,
      lineHeight: e.lineHeightLG
    },
    [`${S}-description`]: {
      fontSize: p,
      color: C
    },
    [`${S}-closable ${S}-message`]: {
      paddingInlineEnd: e.paddingLG
    },
    [`${S}-with-icon ${S}-message`]: {
      marginBottom: e.marginXS,
      marginInlineStart: e.calc(e.marginSM).add(y).equal(),
      fontSize: o
    },
    [`${S}-with-icon ${S}-description`]: {
      marginInlineStart: e.calc(e.marginSM).add(y).equal(),
      fontSize: p
    },
    // Icon & color style in different selector level
    // https://github.com/ant-design/ant-design/issues/16503
    // https://github.com/ant-design/ant-design/issues/15512
    [`${S}-icon`]: {
      position: "absolute",
      fontSize: y,
      lineHeight: 1,
      // icon-font
      [`&-success${t}`]: {
        color: l
      },
      [`&-info${t}`]: {
        color: c
      },
      [`&-warning${t}`]: {
        color: u
      },
      [`&-error${t}`]: {
        color: d
      }
    },
    [`${S}-close`]: {
      position: "absolute",
      top: e.notificationPaddingVertical,
      insetInlineEnd: e.notificationPaddingHorizontal,
      color: e.colorIcon,
      outline: "none",
      width: e.notificationCloseButtonSize,
      height: e.notificationCloseButtonSize,
      borderRadius: e.borderRadiusSM,
      transition: `background-color ${e.motionDurationMid}, color ${e.motionDurationMid}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        color: e.colorIconHover,
        backgroundColor: e.closeBtnHoverBg
      }
    },
    [`${S}-btn`]: {
      float: "right",
      marginTop: e.marginSM
    }
  };
}, _2 = (e) => {
  const {
    componentCls: t,
    // .ant-notification
    notificationMarginBottom: n,
    notificationMarginEdge: r,
    motionDurationMid: o,
    motionEaseInOut: a
  } = e, i = `${t}-notice`, l = new kt("antNotificationFadeOut", {
    "0%": {
      maxHeight: e.animationMaxHeight,
      marginBottom: n
    },
    "100%": {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [t]: Object.assign(Object.assign({}, Gt(e)), {
        position: "fixed",
        zIndex: e.zIndexPopup,
        marginRight: {
          value: r,
          _skip_check_: !0
        },
        [`${t}-hook-holder`]: {
          position: "relative"
        },
        //  animation
        [`${t}-fade-appear-prepare`]: {
          opacity: "0 !important"
        },
        [`${t}-fade-enter, ${t}-fade-appear`]: {
          animationDuration: e.motionDurationMid,
          animationTimingFunction: a,
          animationFillMode: "both",
          opacity: 0,
          animationPlayState: "paused"
        },
        [`${t}-fade-leave`]: {
          animationTimingFunction: a,
          animationFillMode: "both",
          animationDuration: o,
          animationPlayState: "paused"
        },
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationPlayState: "running"
        },
        [`${t}-fade-leave${t}-fade-leave-active`]: {
          animationName: l,
          animationPlayState: "running"
        },
        // RTL
        "&-rtl": {
          direction: "rtl",
          [`${i}-btn`]: {
            float: "left"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [t]: {
        [`${i}-wrapper`]: Object.assign({}, uy(e))
      }
    }
  ];
}, dy = (e) => ({
  zIndexPopup: e.zIndexPopupBase + Cf + 50,
  width: 384,
  closeBtnHoverBg: e.wireframe ? "transparent" : e.colorFillContent
}), fy = (e) => {
  const t = e.paddingMD, n = e.paddingLG;
  return Dt(e, {
    notificationBg: e.colorBgElevated,
    notificationPaddingVertical: t,
    notificationPaddingHorizontal: n,
    notificationIconSize: e.calc(e.fontSizeLG).mul(e.lineHeightLG).equal(),
    notificationCloseButtonSize: e.calc(e.controlHeightLG).mul(0.55).equal(),
    notificationMarginBottom: e.margin,
    notificationPadding: `${q(e.paddingMD)} ${q(e.paddingContentHorizontalLG)}`,
    notificationMarginEdge: e.marginLG,
    animationMaxHeight: 150,
    notificationStackLayer: 3
  });
}, my = Xt("Notification", (e) => {
  const t = fy(e);
  return [_2(t), E2(t), T2(t)];
}, dy), D2 = zo(["Notification", "PurePanel"], (e) => {
  const t = `${e.componentCls}-notice`, n = fy(e);
  return {
    [`${t}-pure-panel`]: Object.assign(Object.assign({}, uy(n)), {
      width: n.width,
      maxWidth: `calc(100vw - ${q(e.calc(n.notificationMarginEdge).mul(2).equal())})`,
      margin: 0
    })
  };
}, dy);
var k2 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function kf(e, t) {
  return t === null || t === !1 ? null : t || /* @__PURE__ */ s.createElement("span", {
    className: `${e}-close-x`
  }, /* @__PURE__ */ s.createElement(mo, {
    className: `${e}-close-icon`
  }));
}
const L2 = {
  success: ks,
  info: d0,
  error: Bo,
  warning: Fi
}, vy = (e) => {
  const {
    prefixCls: t,
    icon: n,
    type: r,
    message: o,
    description: a,
    btn: i,
    role: l = "alert"
  } = e;
  let c = null;
  return n ? c = /* @__PURE__ */ s.createElement("span", {
    className: `${t}-icon`
  }, n) : r && (c = /* @__PURE__ */ s.createElement(L2[r] || null, {
    className: J(`${t}-icon`, `${t}-icon-${r}`)
  })), /* @__PURE__ */ s.createElement("div", {
    className: J({
      [`${t}-with-icon`]: c
    }),
    role: l
  }, c, /* @__PURE__ */ s.createElement("div", {
    className: `${t}-message`
  }, o), /* @__PURE__ */ s.createElement("div", {
    className: `${t}-description`
  }, a), i && /* @__PURE__ */ s.createElement("div", {
    className: `${t}-btn`
  }, i));
}, F2 = (e) => {
  const {
    prefixCls: t,
    className: n,
    icon: r,
    type: o,
    message: a,
    description: i,
    btn: l,
    closable: c = !0,
    closeIcon: u,
    className: d
  } = e, f = k2(e, ["prefixCls", "className", "icon", "type", "message", "description", "btn", "closable", "closeIcon", "className"]), {
    getPrefixCls: m
  } = s.useContext(lt), v = t || m("notification"), h = `${v}-notice`, p = En(v), [g, b, y] = my(v, p);
  return g(/* @__PURE__ */ s.createElement("div", {
    className: J(`${h}-pure-panel`, b, n, y, p)
  }, /* @__PURE__ */ s.createElement(D2, {
    prefixCls: v
  }), /* @__PURE__ */ s.createElement(m0, Object.assign({}, f, {
    prefixCls: v,
    eventKey: "pure",
    duration: null,
    closable: c,
    className: J({
      notificationClassName: d
    }),
    closeIcon: kf(v, u),
    content: /* @__PURE__ */ s.createElement(vy, {
      prefixCls: h,
      icon: r,
      type: o,
      message: a,
      description: i,
      btn: l
    })
  }))));
}, j2 = F2;
function z2(e, t, n) {
  let r;
  switch (e) {
    case "top":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: t,
        bottom: "auto"
      };
      break;
    case "topLeft":
      r = {
        left: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "topRight":
      r = {
        right: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "bottom":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom: n
      };
      break;
    case "bottomLeft":
      r = {
        left: 0,
        top: "auto",
        bottom: n
      };
      break;
    default:
      r = {
        right: 0,
        top: "auto",
        bottom: n
      };
      break;
  }
  return r;
}
function A2(e) {
  return {
    motionName: `${e}-fade`
  };
}
var B2 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const xg = 24, H2 = 4.5, V2 = "topRight", W2 = (e) => {
  let {
    children: t,
    prefixCls: n
  } = e;
  const r = En(n), [o, a, i] = my(n, r);
  return o(/* @__PURE__ */ le.createElement(nI, {
    classNames: {
      list: J(a, i, r)
    }
  }, t));
}, K2 = (e, t) => {
  let {
    prefixCls: n,
    key: r
  } = t;
  return /* @__PURE__ */ le.createElement(W2, {
    prefixCls: n,
    key: r
  }, e);
}, q2 = /* @__PURE__ */ le.forwardRef((e, t) => {
  const {
    top: n,
    bottom: r,
    prefixCls: o,
    getContainer: a,
    maxCount: i,
    rtl: l,
    onAllRemoved: c,
    stack: u,
    duration: d
  } = e, {
    getPrefixCls: f,
    getPopupContainer: m,
    notification: v,
    direction: h
  } = qt(lt), [, p] = Sn(), g = o || f("notification"), b = (x) => z2(x, n ?? xg, r ?? xg), y = () => J({
    [`${g}-rtl`]: l ?? h === "rtl"
  }), C = () => A2(g), [S, $] = sI({
    prefixCls: g,
    style: b,
    className: y,
    motion: C,
    closable: !0,
    closeIcon: kf(g),
    duration: d ?? H2,
    getContainer: () => (a == null ? void 0 : a()) || (m == null ? void 0 : m()) || document.body,
    maxCount: i,
    onAllRemoved: c,
    renderNotifications: K2,
    stack: u === !1 ? !1 : {
      threshold: typeof u == "object" ? u == null ? void 0 : u.threshold : void 0,
      offset: 8,
      gap: p.margin
    }
  });
  return le.useImperativeHandle(t, () => Object.assign(Object.assign({}, S), {
    prefixCls: g,
    notification: v
  })), $;
});
function gy(e) {
  const t = le.useRef(null), n = Rt("Notification");
  return [le.useMemo(() => {
    const o = (c) => {
      var u;
      if (!t.current) {
        process.env.NODE_ENV !== "production" && n(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        return;
      }
      const {
        open: d,
        prefixCls: f,
        notification: m
      } = t.current, v = `${f}-notice`, {
        message: h,
        description: p,
        icon: g,
        type: b,
        btn: y,
        className: C,
        style: S,
        role: $ = "alert",
        closeIcon: x
      } = c, w = B2(c, ["message", "description", "icon", "type", "btn", "className", "style", "role", "closeIcon"]), N = kf(v, typeof x < "u" ? x : m == null ? void 0 : m.closeIcon);
      return d(Object.assign(Object.assign({
        // use placement from props instead of hard-coding "topRight"
        placement: (u = e == null ? void 0 : e.placement) !== null && u !== void 0 ? u : V2
      }, w), {
        content: /* @__PURE__ */ le.createElement(vy, {
          prefixCls: v,
          icon: g,
          type: b,
          message: h,
          description: p,
          btn: y,
          role: $
        }),
        className: J(b && `${v}-${b}`, C, m == null ? void 0 : m.className),
        style: Object.assign(Object.assign({}, m == null ? void 0 : m.style), S),
        closeIcon: N,
        closable: !!N
      }));
    }, i = {
      open: o,
      destroy: (c) => {
        var u, d;
        c !== void 0 ? (u = t.current) === null || u === void 0 || u.close(c) : (d = t.current) === null || d === void 0 || d.destroy();
      }
    };
    return ["success", "info", "warning", "error"].forEach((c) => {
      i[c] = (u) => o(Object.assign(Object.assign({}, u), {
        type: c
      }));
    }), i;
  }, []), /* @__PURE__ */ le.createElement(q2, Object.assign({
    key: "notification-holder"
  }, e, {
    ref: t
  }))];
}
function G2(e) {
  return gy(e);
}
const U2 = /* @__PURE__ */ le.createContext({});
function py(e) {
  return (t) => /* @__PURE__ */ s.createElement($t, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ s.createElement(e, Object.assign({}, t)));
}
const Y2 = (e, t, n, r) => py((a) => {
  const {
    prefixCls: i,
    style: l
  } = a, c = s.useRef(null), [u, d] = s.useState(0), [f, m] = s.useState(0), [v, h] = Vt(!1, {
    value: a.open
  }), {
    getPrefixCls: p
  } = s.useContext(lt), g = p(t || "select", i);
  s.useEffect(() => {
    if (h(!0), typeof ResizeObserver < "u") {
      const C = new ResizeObserver(($) => {
        const x = $[0].target;
        d(x.offsetHeight + 8), m(x.offsetWidth);
      }), S = setInterval(() => {
        var $;
        const x = n ? `.${n(g)}` : `.${g}-dropdown`, w = ($ = c.current) === null || $ === void 0 ? void 0 : $.querySelector(x);
        w && (clearInterval(S), C.observe(w));
      }, 10);
      return () => {
        clearInterval(S), C.disconnect();
      };
    }
  }, []);
  let b = Object.assign(Object.assign({}, a), {
    style: Object.assign(Object.assign({}, l), {
      margin: 0
    }),
    open: v,
    visible: v,
    getPopupContainer: () => c.current
  });
  r && (b = r(b));
  const y = {
    paddingBottom: u,
    position: "relative",
    minWidth: f
  };
  return /* @__PURE__ */ s.createElement("div", {
    ref: c,
    style: y
  }, /* @__PURE__ */ s.createElement(e, Object.assign({}, b)));
}), qs = Y2, Lf = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
var Gs = function(t) {
  var n = t.className, r = t.customizeIcon, o = t.customizeIconProps, a = t.children, i = t.onMouseDown, l = t.onClick, c = typeof r == "function" ? r(o) : r;
  return /* @__PURE__ */ s.createElement("span", {
    className: n,
    onMouseDown: function(d) {
      d.preventDefault(), i == null || i(d);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: l,
    "aria-hidden": !0
  }, c !== void 0 ? c : /* @__PURE__ */ s.createElement("span", {
    className: J(n.split(/\s+/).map(function(u) {
      return "".concat(u, "-icon");
    }))
  }, a));
}, X2 = function(t, n, r, o, a) {
  var i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, l = arguments.length > 6 ? arguments[6] : void 0, c = arguments.length > 7 ? arguments[7] : void 0, u = le.useMemo(function() {
    if (mt(o) === "object")
      return o.clearIcon;
    if (a)
      return a;
  }, [o, a]), d = le.useMemo(function() {
    return !!(!i && o && (r.length || l) && !(c === "combobox" && l === ""));
  }, [o, i, r.length, l, c]);
  return {
    allowClear: d,
    clearIcon: /* @__PURE__ */ le.createElement(Gs, {
      className: "".concat(t, "-clear"),
      onMouseDown: n,
      customizeIcon: u
    }, "×")
  };
}, hy = /* @__PURE__ */ s.createContext(null);
function Q2() {
  return s.useContext(hy);
}
function J2() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = s.useState(!1), n = Q(t, 2), r = n[0], o = n[1], a = s.useRef(null), i = function() {
    window.clearTimeout(a.current);
  };
  s.useEffect(function() {
    return i;
  }, []);
  var l = function(u, d) {
    i(), a.current = window.setTimeout(function() {
      o(u), d && d();
    }, e);
  };
  return [r, l, i];
}
function by() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = s.useRef(null), n = s.useRef(null);
  s.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function r(o) {
    (o || t.current === null) && (t.current = o), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, r];
}
function Z2(e, t, n, r) {
  var o = s.useRef(null);
  o.current = {
    open: t,
    triggerOpen: n,
    customizedTrigger: r
  }, s.useEffect(function() {
    function a(i) {
      var l;
      if (!((l = o.current) !== null && l !== void 0 && l.customizedTrigger)) {
        var c = i.target;
        c.shadowRoot && i.composed && (c = i.composedPath()[0] || c), o.current.open && e().filter(function(u) {
          return u;
        }).every(function(u) {
          return !u.contains(c) && u !== c;
        }) && o.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", a), function() {
      return window.removeEventListener("mousedown", a);
    };
  }, []);
}
var eM = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], Qo = void 0;
function tM(e, t) {
  var n = e.prefixCls, r = e.invalidate, o = e.item, a = e.renderItem, i = e.responsive, l = e.responsiveDisabled, c = e.registerSize, u = e.itemKey, d = e.className, f = e.style, m = e.children, v = e.display, h = e.order, p = e.component, g = p === void 0 ? "div" : p, b = vt(e, eM), y = i && !v;
  function C(N) {
    c(u, N);
  }
  s.useEffect(function() {
    return function() {
      C(null);
    };
  }, []);
  var S = a && o !== Qo ? a(o) : m, $;
  r || ($ = {
    opacity: y ? 0 : 1,
    height: y ? 0 : Qo,
    overflowY: y ? "hidden" : Qo,
    order: i ? h : Qo,
    pointerEvents: y ? "none" : Qo,
    position: y ? "absolute" : Qo
  });
  var x = {};
  y && (x["aria-hidden"] = !0);
  var w = /* @__PURE__ */ s.createElement(g, fe({
    className: J(!r && n, d),
    style: V(V({}, $), f)
  }, x, b, {
    ref: t
  }), S);
  return i && (w = /* @__PURE__ */ s.createElement(Mn, {
    onResize: function(O) {
      var E = O.offsetWidth;
      C(E);
    },
    disabled: l
  }, w)), w;
}
var fi = /* @__PURE__ */ s.forwardRef(tM);
fi.displayName = "Item";
function nM(e) {
  if (typeof MessageChannel > "u")
    _t(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function rM() {
  var e = s.useRef(null), t = function(r) {
    e.current || (e.current = [], nM(function() {
      Oh(function() {
        e.current.forEach(function(o) {
          o();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return t;
}
function Va(e, t) {
  var n = s.useState(t), r = Q(n, 2), o = r[0], a = r[1], i = Lt(function(l) {
    e(function() {
      a(l);
    });
  });
  return [o, i];
}
var ds = /* @__PURE__ */ le.createContext(null), oM = ["component"], aM = ["className"], iM = ["className"], lM = function(t, n) {
  var r = s.useContext(ds);
  if (!r) {
    var o = t.component, a = o === void 0 ? "div" : o, i = vt(t, oM);
    return /* @__PURE__ */ s.createElement(a, fe({}, i, {
      ref: n
    }));
  }
  var l = r.className, c = vt(r, aM), u = t.className, d = vt(t, iM);
  return /* @__PURE__ */ s.createElement(ds.Provider, {
    value: null
  }, /* @__PURE__ */ s.createElement(fi, fe({
    ref: n,
    className: J(l, u)
  }, c, d)));
}, yy = /* @__PURE__ */ s.forwardRef(lM);
yy.displayName = "RawItem";
var sM = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], Cy = "responsive", Sy = "invalidate";
function cM(e) {
  return "+ ".concat(e.length, " ...");
}
function uM(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-overflow" : n, o = e.data, a = o === void 0 ? [] : o, i = e.renderItem, l = e.renderRawItem, c = e.itemKey, u = e.itemWidth, d = u === void 0 ? 10 : u, f = e.ssr, m = e.style, v = e.className, h = e.maxCount, p = e.renderRest, g = e.renderRawRest, b = e.suffix, y = e.component, C = y === void 0 ? "div" : y, S = e.itemComponent, $ = e.onVisibleChange, x = vt(e, sM), w = f === "full", N = rM(), O = Va(N, null), E = Q(O, 2), I = E[0], k = E[1], M = I || 0, P = Va(N, /* @__PURE__ */ new Map()), _ = Q(P, 2), D = _[0], R = _[1], T = Va(N, 0), L = Q(T, 2), F = L[0], j = L[1], A = Va(N, 0), B = Q(A, 2), K = B[0], Y = B[1], G = Va(N, 0), te = Q(G, 2), ee = te[0], oe = te[1], X = Ht(null), W = Q(X, 2), re = W[0], Z = W[1], H = Ht(null), U = Q(H, 2), ae = U[0], ue = U[1], de = s.useMemo(function() {
    return ae === null && w ? Number.MAX_SAFE_INTEGER : ae || 0;
  }, [ae, I]), se = Ht(!1), ie = Q(se, 2), me = ie[0], Se = ie[1], ve = "".concat(r, "-item"), ge = Math.max(F, K), $e = h === Cy, we = a.length && $e, _e = h === Sy, ze = we || typeof h == "number" && a.length > h, Te = nn(function() {
    var Ae = a;
    return we ? I === null && w ? Ae = a : Ae = a.slice(0, Math.min(a.length, M / d)) : typeof h == "number" && (Ae = a.slice(0, h)), Ae;
  }, [a, d, I, h, we]), ke = nn(function() {
    return we ? a.slice(de + 1) : a.slice(Te.length);
  }, [a, Te, we, de]), Le = Wn(function(Ae, qe) {
    var Je;
    return typeof c == "function" ? c(Ae) : (Je = c && (Ae == null ? void 0 : Ae[c])) !== null && Je !== void 0 ? Je : qe;
  }, [c]), Ee = Wn(i || function(Ae) {
    return Ae;
  }, [i]);
  function xe(Ae, qe, Je) {
    ae === Ae && (qe === void 0 || qe === re) || (ue(Ae), Je || (Se(Ae < a.length - 1), $ == null || $(Ae)), qe !== void 0 && Z(qe));
  }
  function he(Ae, qe) {
    k(qe.clientWidth);
  }
  function pe(Ae, qe) {
    R(function(Je) {
      var Ke = new Map(Je);
      return qe === null ? Ke.delete(Ae) : Ke.set(Ae, qe), Ke;
    });
  }
  function Pe(Ae, qe) {
    Y(qe), j(K);
  }
  function Re(Ae, qe) {
    oe(qe);
  }
  function at(Ae) {
    return D.get(Le(Te[Ae], Ae));
  }
  Pt(function() {
    if (M && typeof ge == "number" && Te) {
      var Ae = ee, qe = Te.length, Je = qe - 1;
      if (!qe) {
        xe(0, null);
        return;
      }
      for (var Ke = 0; Ke < qe; Ke += 1) {
        var Ye = at(Ke);
        if (w && (Ye = Ye || 0), Ye === void 0) {
          xe(Ke - 1, void 0, !0);
          break;
        }
        if (Ae += Ye, // Only one means `totalWidth` is the final width
        Je === 0 && Ae <= M || // Last two width will be the final width
        Ke === Je - 1 && Ae + at(Je) <= M) {
          xe(Je, null);
          break;
        } else if (Ae + ge > M) {
          xe(Ke - 1, Ae - Ye - ee + K);
          break;
        }
      }
      b && at(0) + ee > M && Z(null);
    }
  }, [M, D, K, ee, Le, Te]);
  var Ze = me && !!ke.length, Ie = {};
  re !== null && we && (Ie = {
    position: "absolute",
    left: re,
    top: 0
  });
  var Be = {
    prefixCls: ve,
    responsive: we,
    component: S,
    invalidate: _e
  }, bt = l ? function(Ae, qe) {
    var Je = Le(Ae, qe);
    return /* @__PURE__ */ s.createElement(ds.Provider, {
      key: Je,
      value: V(V({}, Be), {}, {
        order: qe,
        item: Ae,
        itemKey: Je,
        registerSize: pe,
        display: qe <= de
      })
    }, l(Ae, qe));
  } : function(Ae, qe) {
    var Je = Le(Ae, qe);
    return /* @__PURE__ */ s.createElement(fi, fe({}, Be, {
      order: qe,
      key: Je,
      item: Ae,
      renderItem: Ee,
      itemKey: Je,
      registerSize: pe,
      display: qe <= de
    }));
  }, He, nt = {
    order: Ze ? de : Number.MAX_SAFE_INTEGER,
    className: "".concat(ve, "-rest"),
    registerSize: Pe,
    display: Ze
  };
  if (g)
    g && (He = /* @__PURE__ */ s.createElement(ds.Provider, {
      value: V(V({}, Be), nt)
    }, g(ke)));
  else {
    var et = p || cM;
    He = /* @__PURE__ */ s.createElement(fi, fe({}, Be, nt), typeof et == "function" ? et(ke) : et);
  }
  var Ge = /* @__PURE__ */ s.createElement(C, fe({
    className: J(!_e && r, v),
    style: m,
    ref: t
  }, x), Te.map(bt), ze ? He : null, b && /* @__PURE__ */ s.createElement(fi, fe({}, Be, {
    responsive: $e,
    responsiveDisabled: !we,
    order: de,
    className: "".concat(ve, "-suffix"),
    registerSize: Re,
    display: !0,
    style: Ie
  }), b));
  return $e && (Ge = /* @__PURE__ */ s.createElement(Mn, {
    onResize: he,
    disabled: !we
  }, Ge)), Ge;
}
var Cr = /* @__PURE__ */ s.forwardRef(uM);
Cr.displayName = "Overflow";
Cr.Item = yy;
Cr.RESPONSIVE = Cy;
Cr.INVALIDATE = Sy;
var dM = function(t, n) {
  var r, o = t.prefixCls, a = t.id, i = t.inputElement, l = t.disabled, c = t.tabIndex, u = t.autoFocus, d = t.autoComplete, f = t.editable, m = t.activeDescendantId, v = t.value, h = t.maxLength, p = t.onKeyDown, g = t.onMouseDown, b = t.onChange, y = t.onPaste, C = t.onCompositionStart, S = t.onCompositionEnd, $ = t.open, x = t.attrs, w = i || /* @__PURE__ */ s.createElement("input", null), N = w, O = N.ref, E = N.props, I = E.onKeyDown, k = E.onChange, M = E.onMouseDown, P = E.onCompositionStart, _ = E.onCompositionEnd, D = E.style;
  return Br(!("maxLength" in w.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), w = /* @__PURE__ */ s.cloneElement(w, V(V(V({
    type: "search"
  }, E), {}, {
    // Override over origin props
    id: a,
    ref: Un(n, O),
    disabled: l,
    tabIndex: c,
    autoComplete: d || "off",
    autoFocus: u,
    className: J("".concat(o, "-selection-search-input"), (r = w) === null || r === void 0 || (r = r.props) === null || r === void 0 ? void 0 : r.className),
    role: "combobox",
    "aria-expanded": $ || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(a, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(a, "_list"),
    "aria-activedescendant": $ ? m : void 0
  }, x), {}, {
    value: f ? v : "",
    maxLength: h,
    readOnly: !f,
    unselectable: f ? null : "on",
    style: V(V({}, D), {}, {
      opacity: f ? null : 0
    }),
    onKeyDown: function(T) {
      p(T), I && I(T);
    },
    onMouseDown: function(T) {
      g(T), M && M(T);
    },
    onChange: function(T) {
      b(T), k && k(T);
    },
    onCompositionStart: function(T) {
      C(T), P && P(T);
    },
    onCompositionEnd: function(T) {
      S(T), _ && _(T);
    },
    onPaste: y
  })), w;
}, Ff = /* @__PURE__ */ s.forwardRef(dM);
process.env.NODE_ENV !== "production" && (Ff.displayName = "Input");
function jf(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var fM = typeof window < "u" && window.document && window.document.documentElement, mM = process.env.NODE_ENV !== "test" && fM;
function vM(e) {
  return e != null;
}
function gM(e) {
  return !e && e !== 0;
}
function $g(e) {
  return ["string", "number"].includes(mt(e));
}
function xy(e) {
  var t = void 0;
  return e && ($g(e.title) ? t = e.title.toString() : $g(e.label) && (t = e.label.toString())), t;
}
function pM(e, t) {
  mM ? s.useLayoutEffect(e, t) : s.useEffect(e, t);
}
function hM(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var wg = function(t) {
  t.preventDefault(), t.stopPropagation();
}, bM = function(t) {
  var n = t.id, r = t.prefixCls, o = t.values, a = t.open, i = t.searchValue, l = t.autoClearSearchValue, c = t.inputRef, u = t.placeholder, d = t.disabled, f = t.mode, m = t.showSearch, v = t.autoFocus, h = t.autoComplete, p = t.activeDescendantId, g = t.tabIndex, b = t.removeIcon, y = t.maxTagCount, C = t.maxTagTextLength, S = t.maxTagPlaceholder, $ = S === void 0 ? function(Z) {
    return "+ ".concat(Z.length, " ...");
  } : S, x = t.tagRender, w = t.onToggleOpen, N = t.onRemove, O = t.onInputChange, E = t.onInputPaste, I = t.onInputKeyDown, k = t.onInputMouseDown, M = t.onInputCompositionStart, P = t.onInputCompositionEnd, _ = s.useRef(null), D = Ht(0), R = Q(D, 2), T = R[0], L = R[1], F = Ht(!1), j = Q(F, 2), A = j[0], B = j[1], K = "".concat(r, "-selection"), Y = a || f === "multiple" && l === !1 || f === "tags" ? i : "", G = f === "tags" || f === "multiple" && l === !1 || m && (a || A);
  pM(function() {
    L(_.current.scrollWidth);
  }, [Y]);
  var te = function(H, U, ae, ue, de) {
    return /* @__PURE__ */ s.createElement("span", {
      title: xy(H),
      className: J("".concat(K, "-item"), z({}, "".concat(K, "-item-disabled"), ae))
    }, /* @__PURE__ */ s.createElement("span", {
      className: "".concat(K, "-item-content")
    }, U), ue && /* @__PURE__ */ s.createElement(Gs, {
      className: "".concat(K, "-item-remove"),
      onMouseDown: wg,
      onClick: de,
      customizeIcon: b
    }, "×"));
  }, ee = function(H, U, ae, ue, de) {
    var se = function(me) {
      wg(me), w(!a);
    };
    return /* @__PURE__ */ s.createElement("span", {
      onMouseDown: se
    }, x({
      label: U,
      value: H,
      disabled: ae,
      closable: ue,
      onClose: de
    }));
  }, oe = function(H) {
    var U = H.disabled, ae = H.label, ue = H.value, de = !d && !U, se = ae;
    if (typeof C == "number" && (typeof ae == "string" || typeof ae == "number")) {
      var ie = String(se);
      ie.length > C && (se = "".concat(ie.slice(0, C), "..."));
    }
    var me = function(ve) {
      ve && ve.stopPropagation(), N(H);
    };
    return typeof x == "function" ? ee(ue, se, U, de, me) : te(H, se, U, de, me);
  }, X = function(H) {
    var U = typeof $ == "function" ? $(H) : $;
    return te({
      title: U
    }, U, !1);
  }, W = /* @__PURE__ */ s.createElement("div", {
    className: "".concat(K, "-search"),
    style: {
      width: T
    },
    onFocus: function() {
      B(!0);
    },
    onBlur: function() {
      B(!1);
    }
  }, /* @__PURE__ */ s.createElement(Ff, {
    ref: c,
    open: a,
    prefixCls: r,
    id: n,
    inputElement: null,
    disabled: d,
    autoFocus: v,
    autoComplete: h,
    editable: G,
    activeDescendantId: p,
    value: Y,
    onKeyDown: I,
    onMouseDown: k,
    onChange: O,
    onPaste: E,
    onCompositionStart: M,
    onCompositionEnd: P,
    tabIndex: g,
    attrs: Bn(t, !0)
  }), /* @__PURE__ */ s.createElement("span", {
    ref: _,
    className: "".concat(K, "-search-mirror"),
    "aria-hidden": !0
  }, Y, " ")), re = /* @__PURE__ */ s.createElement(Cr, {
    prefixCls: "".concat(K, "-overflow"),
    data: o,
    renderItem: oe,
    renderRest: X,
    suffix: W,
    itemKey: hM,
    maxCount: y
  });
  return /* @__PURE__ */ s.createElement(s.Fragment, null, re, !o.length && !Y && /* @__PURE__ */ s.createElement("span", {
    className: "".concat(K, "-placeholder")
  }, u));
}, yM = function(t) {
  var n = t.inputElement, r = t.prefixCls, o = t.id, a = t.inputRef, i = t.disabled, l = t.autoFocus, c = t.autoComplete, u = t.activeDescendantId, d = t.mode, f = t.open, m = t.values, v = t.placeholder, h = t.tabIndex, p = t.showSearch, g = t.searchValue, b = t.activeValue, y = t.maxLength, C = t.onInputKeyDown, S = t.onInputMouseDown, $ = t.onInputChange, x = t.onInputPaste, w = t.onInputCompositionStart, N = t.onInputCompositionEnd, O = t.title, E = s.useState(!1), I = Q(E, 2), k = I[0], M = I[1], P = d === "combobox", _ = P || p, D = m[0], R = g || "";
  P && b && !k && (R = b), s.useEffect(function() {
    P && M(!1);
  }, [P, b]);
  var T = d !== "combobox" && !f && !p ? !1 : !!R, L = O === void 0 ? xy(D) : O, F = s.useMemo(function() {
    return D ? null : /* @__PURE__ */ s.createElement("span", {
      className: "".concat(r, "-selection-placeholder"),
      style: T ? {
        visibility: "hidden"
      } : void 0
    }, v);
  }, [D, T, v, r]);
  return /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement("span", {
    className: "".concat(r, "-selection-search")
  }, /* @__PURE__ */ s.createElement(Ff, {
    ref: a,
    prefixCls: r,
    id: o,
    open: f,
    inputElement: n,
    disabled: i,
    autoFocus: l,
    autoComplete: c,
    editable: _,
    activeDescendantId: u,
    value: R,
    onKeyDown: C,
    onMouseDown: S,
    onChange: function(A) {
      M(!0), $(A);
    },
    onPaste: x,
    onCompositionStart: w,
    onCompositionEnd: N,
    tabIndex: h,
    attrs: Bn(t, !0),
    maxLength: P ? y : void 0
  })), !P && D ? /* @__PURE__ */ s.createElement("span", {
    className: "".concat(r, "-selection-item"),
    title: L,
    style: T ? {
      visibility: "hidden"
    } : void 0
  }, D.label) : null, F);
};
function CM(e) {
  return ![
    // System function button
    Oe.ESC,
    Oe.SHIFT,
    Oe.BACKSPACE,
    Oe.TAB,
    Oe.WIN_KEY,
    Oe.ALT,
    Oe.META,
    Oe.WIN_KEY_RIGHT,
    Oe.CTRL,
    Oe.SEMICOLON,
    Oe.EQUALS,
    Oe.CAPS_LOCK,
    Oe.CONTEXT_MENU,
    // F1-F12
    Oe.F1,
    Oe.F2,
    Oe.F3,
    Oe.F4,
    Oe.F5,
    Oe.F6,
    Oe.F7,
    Oe.F8,
    Oe.F9,
    Oe.F10,
    Oe.F11,
    Oe.F12
  ].includes(e);
}
var SM = function(t, n) {
  var r = Xe(null), o = Xe(!1), a = t.prefixCls, i = t.open, l = t.mode, c = t.showSearch, u = t.tokenWithEnter, d = t.autoClearSearchValue, f = t.onSearch, m = t.onSearchSubmit, v = t.onToggleOpen, h = t.onInputKeyDown, p = t.domRef;
  s.useImperativeHandle(n, function() {
    return {
      focus: function() {
        r.current.focus();
      },
      blur: function() {
        r.current.blur();
      }
    };
  });
  var g = by(0), b = Q(g, 2), y = b[0], C = b[1], S = function(R) {
    var T = R.which;
    (T === Oe.UP || T === Oe.DOWN) && R.preventDefault(), h && h(R), T === Oe.ENTER && l === "tags" && !o.current && !i && (m == null || m(R.target.value)), CM(T) && v(!0);
  }, $ = function() {
    C(!0);
  }, x = Xe(null), w = function(R) {
    f(R, !0, o.current) !== !1 && v(!0);
  }, N = function() {
    o.current = !0;
  }, O = function(R) {
    o.current = !1, l !== "combobox" && w(R.target.value);
  }, E = function(R) {
    var T = R.target.value;
    if (u && x.current && /[\r\n]/.test(x.current)) {
      var L = x.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      T = T.replace(L, x.current);
    }
    x.current = null, w(T);
  }, I = function(R) {
    var T = R.clipboardData, L = T == null ? void 0 : T.getData("text");
    x.current = L || "";
  }, k = function(R) {
    var T = R.target;
    if (T !== r.current) {
      var L = document.body.style.msTouchAction !== void 0;
      L ? setTimeout(function() {
        r.current.focus();
      }) : r.current.focus();
    }
  }, M = function(R) {
    var T = y();
    R.target !== r.current && !T && l !== "combobox" && R.preventDefault(), (l !== "combobox" && (!c || !T) || !i) && (i && d !== !1 && f("", !0, !1), v());
  }, P = {
    inputRef: r,
    onInputKeyDown: S,
    onInputMouseDown: $,
    onInputChange: E,
    onInputPaste: I,
    onInputCompositionStart: N,
    onInputCompositionEnd: O
  }, _ = l === "multiple" || l === "tags" ? /* @__PURE__ */ s.createElement(bM, fe({}, t, P)) : /* @__PURE__ */ s.createElement(yM, fe({}, t, P));
  return /* @__PURE__ */ s.createElement("div", {
    ref: p,
    className: "".concat(a, "-selector"),
    onClick: k,
    onMouseDown: M
  }, _);
}, $y = /* @__PURE__ */ s.forwardRef(SM);
process.env.NODE_ENV !== "production" && ($y.displayName = "Selector");
function xM(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, o = e.arrowPos, a = r || {}, i = a.className, l = a.content, c = o.x, u = c === void 0 ? 0 : c, d = o.y, f = d === void 0 ? 0 : d, m = s.useRef();
  if (!n || !n.points)
    return null;
  var v = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var h = n.points[0], p = n.points[1], g = h[0], b = h[1], y = p[0], C = p[1];
    g === y || !["t", "b"].includes(g) ? v.top = f : g === "t" ? v.top = 0 : v.bottom = 0, b === C || !["l", "r"].includes(b) ? v.left = u : b === "l" ? v.left = 0 : v.right = 0;
  }
  return /* @__PURE__ */ s.createElement("div", {
    ref: m,
    className: J("".concat(t, "-arrow"), i),
    style: v
  }, l);
}
function $M(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, o = e.mask, a = e.motion;
  return o ? /* @__PURE__ */ s.createElement(An, fe({}, a, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(i) {
    var l = i.className;
    return /* @__PURE__ */ s.createElement("div", {
      style: {
        zIndex: r
      },
      className: J("".concat(t, "-mask"), l)
    });
  }) : null;
}
var wy = /* @__PURE__ */ s.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (wy.displayName = "PopupContent");
var Ey = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, o = e.prefixCls, a = e.style, i = e.target, l = e.onVisibleChanged, c = e.open, u = e.keepDom, d = e.fresh, f = e.onClick, m = e.mask, v = e.arrow, h = e.arrowPos, p = e.align, g = e.motion, b = e.maskMotion, y = e.forceRender, C = e.getPopupContainer, S = e.autoDestroy, $ = e.portal, x = e.zIndex, w = e.onMouseEnter, N = e.onMouseLeave, O = e.onPointerEnter, E = e.ready, I = e.offsetX, k = e.offsetY, M = e.offsetR, P = e.offsetB, _ = e.onAlign, D = e.onPrepare, R = e.stretch, T = e.targetWidth, L = e.targetHeight, F = typeof n == "function" ? n() : n, j = c || u, A = (C == null ? void 0 : C.length) > 0, B = s.useState(!C || !A), K = Q(B, 2), Y = K[0], G = K[1];
  if (Pt(function() {
    !Y && A && i && G(!0);
  }, [Y, A, i]), !Y)
    return null;
  var te = "auto", ee = {
    left: "-1000vw",
    top: "-1000vh",
    right: te,
    bottom: te
  };
  if (E || !c) {
    var oe, X = p.points, W = p.dynamicInset || ((oe = p._experimental) === null || oe === void 0 ? void 0 : oe.dynamicInset), re = W && X[0][1] === "r", Z = W && X[0][0] === "b";
    re ? (ee.right = M, ee.left = te) : (ee.left = I, ee.right = te), Z ? (ee.bottom = P, ee.top = te) : (ee.top = k, ee.bottom = te);
  }
  var H = {};
  return R && (R.includes("height") && L ? H.height = L : R.includes("minHeight") && L && (H.minHeight = L), R.includes("width") && T ? H.width = T : R.includes("minWidth") && T && (H.minWidth = T)), c || (H.pointerEvents = "none"), /* @__PURE__ */ s.createElement($, {
    open: y || j,
    getContainer: C && function() {
      return C(i);
    },
    autoDestroy: S
  }, /* @__PURE__ */ s.createElement($M, {
    prefixCls: o,
    open: c,
    zIndex: x,
    mask: m,
    motion: b
  }), /* @__PURE__ */ s.createElement(Mn, {
    onResize: _,
    disabled: !c
  }, function(U) {
    return /* @__PURE__ */ s.createElement(An, fe({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: y,
      leavedClassName: "".concat(o, "-hidden")
    }, g, {
      onAppearPrepare: D,
      onEnterPrepare: D,
      visible: c,
      onVisibleChanged: function(ue) {
        var de;
        g == null || (de = g.onVisibleChanged) === null || de === void 0 || de.call(g, ue), l(ue);
      }
    }), function(ae, ue) {
      var de = ae.className, se = ae.style, ie = J(o, de, r);
      return /* @__PURE__ */ s.createElement("div", {
        ref: Un(U, t, ue),
        className: ie,
        style: V(V(V(V({
          "--arrow-x": "".concat(h.x || 0, "px"),
          "--arrow-y": "".concat(h.y || 0, "px")
        }, ee), H), se), {}, {
          boxSizing: "border-box",
          zIndex: x
        }, a),
        onMouseEnter: w,
        onMouseLeave: N,
        onPointerEnter: O,
        onClick: f
      }, v && /* @__PURE__ */ s.createElement(xM, {
        prefixCls: o,
        arrow: v,
        arrowPos: h,
        align: p
      }), /* @__PURE__ */ s.createElement(wy, {
        cache: !c && !d
      }, F));
    });
  }));
});
process.env.NODE_ENV !== "production" && (Ey.displayName = "Popup");
var Oy = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, o = Sr(n), a = s.useCallback(function(l) {
    Ci(t, r ? r(l) : l);
  }, [r]), i = Gr(a, n.ref);
  return o ? /* @__PURE__ */ s.cloneElement(n, {
    ref: i
  }) : n;
});
process.env.NODE_ENV !== "production" && (Oy.displayName = "TriggerWrapper");
var Eg = /* @__PURE__ */ s.createContext(null);
function Og(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function wM(e, t, n, r) {
  return s.useMemo(function() {
    var o = Og(n ?? t), a = Og(r ?? t), i = new Set(o), l = new Set(a);
    return e && (i.has("hover") && (i.delete("hover"), i.add("click")), l.has("hover") && (l.delete("hover"), l.add("click"))), [i, l];
  }, [e, t, n, r]);
}
function EM() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function OM(e, t, n, r) {
  for (var o = n.points, a = Object.keys(e), i = 0; i < a.length; i += 1) {
    var l, c = a[i];
    if (EM((l = e[c]) === null || l === void 0 ? void 0 : l.points, o, r))
      return "".concat(t, "-placement-").concat(c);
  }
  return "";
}
function Ng(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function Ui(e) {
  return e.ownerDocument.defaultView;
}
function yd(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var o = Ui(n).getComputedStyle(n), a = o.overflowX, i = o.overflowY, l = o.overflow;
    [a, i, l].some(function(c) {
      return r.includes(c);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function Ri(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Wa(e) {
  return Ri(parseFloat(e), 0);
}
function Ig(e, t) {
  var n = V({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var o = Ui(r).getComputedStyle(r), a = o.overflow, i = o.overflowClipMargin, l = o.borderTopWidth, c = o.borderBottomWidth, u = o.borderLeftWidth, d = o.borderRightWidth, f = r.getBoundingClientRect(), m = r.offsetHeight, v = r.clientHeight, h = r.offsetWidth, p = r.clientWidth, g = Wa(l), b = Wa(c), y = Wa(u), C = Wa(d), S = Ri(Math.round(f.width / h * 1e3) / 1e3), $ = Ri(Math.round(f.height / m * 1e3) / 1e3), x = (h - p - y - C) * S, w = (m - v - g - b) * $, N = g * $, O = b * $, E = y * S, I = C * S, k = 0, M = 0;
      if (a === "clip") {
        var P = Wa(i);
        k = P * S, M = P * $;
      }
      var _ = f.x + E - k, D = f.y + N - M, R = _ + f.width + 2 * k - E - I - x, T = D + f.height + 2 * M - N - O - w;
      n.left = Math.max(n.left, _), n.top = Math.max(n.top, D), n.right = Math.min(n.right, R), n.bottom = Math.min(n.bottom, T);
    }
  }), n;
}
function Pg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function Rg(e, t) {
  var n = t || [], r = Q(n, 2), o = r[0], a = r[1];
  return [Pg(e.width, o), Pg(e.height, a)];
}
function Mg() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function Jo(e, t) {
  var n = t[0], r = t[1], o, a;
  return n === "t" ? a = e.y : n === "b" ? a = e.y + e.height : a = e.y + e.height / 2, r === "l" ? o = e.x : r === "r" ? o = e.x + e.width : o = e.x + e.width / 2, {
    x: o,
    y: a
  };
}
function Qr(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, o) {
    return o === t ? n[r] || "c" : r;
  }).join("");
}
function NM(e, t, n, r, o, a, i) {
  var l = s.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[r] || {}
  }), c = Q(l, 2), u = c[0], d = c[1], f = s.useRef(0), m = s.useMemo(function() {
    return t ? yd(t) : [];
  }, [t]), v = s.useRef({}), h = function() {
    v.current = {};
  };
  e || h();
  var p = Lt(function() {
    if (t && n && e) {
      let Ue = function(gt, At) {
        var bn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ie, Gn = F.x + gt, Xn = F.y + At, mr = Gn + oe, Xr = Xn + ee, Sc = Math.max(Gn, bn.left), xc = Math.max(Xn, bn.top), $c = Math.min(mr, bn.right), wc = Math.min(Xr, bn.bottom);
        return Math.max(0, ($c - Sc) * (wc - xc));
      }, st = function() {
        ye = F.y + et, ce = ye + ee, Ce = F.x + nt, je = Ce + oe;
      };
      var y, C, S = t, $ = S.ownerDocument, x = Ui(S), w = x.getComputedStyle(S), N = w.width, O = w.height, E = w.position, I = S.style.left, k = S.style.top, M = S.style.right, P = S.style.bottom, _ = S.style.overflow, D = V(V({}, o[r]), a), R = $.createElement("div");
      (y = S.parentElement) === null || y === void 0 || y.appendChild(R), R.style.left = "".concat(S.offsetLeft, "px"), R.style.top = "".concat(S.offsetTop, "px"), R.style.position = E, R.style.height = "".concat(S.offsetHeight, "px"), R.style.width = "".concat(S.offsetWidth, "px"), S.style.left = "0", S.style.top = "0", S.style.right = "auto", S.style.bottom = "auto", S.style.overflow = "hidden";
      var T;
      if (Array.isArray(n))
        T = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var L = n.getBoundingClientRect();
        T = {
          x: L.x,
          y: L.y,
          width: L.width,
          height: L.height
        };
      }
      var F = S.getBoundingClientRect(), j = $.documentElement, A = j.clientWidth, B = j.clientHeight, K = j.scrollWidth, Y = j.scrollHeight, G = j.scrollTop, te = j.scrollLeft, ee = F.height, oe = F.width, X = T.height, W = T.width, re = {
        left: 0,
        top: 0,
        right: A,
        bottom: B
      }, Z = {
        left: -te,
        top: -G,
        right: K - te,
        bottom: Y - G
      }, H = D.htmlRegion, U = "visible", ae = "visibleFirst";
      H !== "scroll" && H !== ae && (H = U);
      var ue = H === ae, de = Ig(Z, m), se = Ig(re, m), ie = H === U ? se : de, me = ue ? se : ie;
      S.style.left = "auto", S.style.top = "auto", S.style.right = "0", S.style.bottom = "0";
      var Se = S.getBoundingClientRect();
      S.style.left = I, S.style.top = k, S.style.right = M, S.style.bottom = P, S.style.overflow = _, (C = S.parentElement) === null || C === void 0 || C.removeChild(R);
      var ve = Ri(Math.round(oe / parseFloat(N) * 1e3) / 1e3), ge = Ri(Math.round(ee / parseFloat(O) * 1e3) / 1e3);
      if (ve === 0 || ge === 0 || es(n) && !Ai(n))
        return;
      var $e = D.offset, we = D.targetOffset, _e = Rg(F, $e), ze = Q(_e, 2), Te = ze[0], ke = ze[1], Le = Rg(T, we), Ee = Q(Le, 2), xe = Ee[0], he = Ee[1];
      T.x -= xe, T.y -= he;
      var pe = D.points || [], Pe = Q(pe, 2), Re = Pe[0], at = Pe[1], Ze = Mg(at), Ie = Mg(Re), Be = Jo(T, Ze), bt = Jo(F, Ie), He = V({}, D), nt = Be.x - bt.x + Te, et = Be.y - bt.y + ke, Ge = Ue(nt, et), Ae = Ue(nt, et, se), qe = Jo(T, ["t", "l"]), Je = Jo(F, ["t", "l"]), Ke = Jo(T, ["b", "r"]), Ye = Jo(F, ["b", "r"]), Ve = D.overflow || {}, Qe = Ve.adjustX, it = Ve.adjustY, yt = Ve.shiftX, Tt = Ve.shiftY, ne = function(At) {
        return typeof At == "boolean" ? At : At >= 0;
      }, ye, ce, Ce, je;
      st();
      var Ne = ne(it), De = Ie[0] === Ze[0];
      if (Ne && Ie[0] === "t" && (ce > me.bottom || v.current.bt)) {
        var Fe = et;
        De ? Fe -= ee - X : Fe = qe.y - Ye.y - ke;
        var ot = Ue(nt, Fe), pt = Ue(nt, Fe, se);
        // Of course use larger one
        ot > Ge || ot === Ge && (!ue || // Choose recommend one
        pt >= Ae) ? (v.current.bt = !0, et = Fe, ke = -ke, He.points = [Qr(Ie, 0), Qr(Ze, 0)]) : v.current.bt = !1;
      }
      if (Ne && Ie[0] === "b" && (ye < me.top || v.current.tb)) {
        var St = et;
        De ? St += ee - X : St = Ke.y - Je.y - ke;
        var Ot = Ue(nt, St), Wt = Ue(nt, St, se);
        // Of course use larger one
        Ot > Ge || Ot === Ge && (!ue || // Choose recommend one
        Wt >= Ae) ? (v.current.tb = !0, et = St, ke = -ke, He.points = [Qr(Ie, 0), Qr(Ze, 0)]) : v.current.tb = !1;
      }
      var rn = ne(Qe), Nt = Ie[1] === Ze[1];
      if (rn && Ie[1] === "l" && (je > me.right || v.current.rl)) {
        var Ut = nt;
        Nt ? Ut -= oe - W : Ut = qe.x - Ye.x - Te;
        var fn = Ue(Ut, et), sn = Ue(Ut, et, se);
        // Of course use larger one
        fn > Ge || fn === Ge && (!ue || // Choose recommend one
        sn >= Ae) ? (v.current.rl = !0, nt = Ut, Te = -Te, He.points = [Qr(Ie, 1), Qr(Ze, 1)]) : v.current.rl = !1;
      }
      if (rn && Ie[1] === "r" && (Ce < me.left || v.current.lr)) {
        var ln = nt;
        Nt ? ln += oe - W : ln = Ke.x - Je.x - Te;
        var _n = Ue(ln, et), ut = Ue(ln, et, se);
        // Of course use larger one
        _n > Ge || _n === Ge && (!ue || // Choose recommend one
        ut >= Ae) ? (v.current.lr = !0, nt = ln, Te = -Te, He.points = [Qr(Ie, 1), Qr(Ze, 1)]) : v.current.lr = !1;
      }
      st();
      var xt = yt === !0 ? 0 : yt;
      typeof xt == "number" && (Ce < se.left && (nt -= Ce - se.left - Te, T.x + W < se.left + xt && (nt += T.x - se.left + W - xt)), je > se.right && (nt -= je - se.right - Te, T.x > se.right - xt && (nt += T.x - se.right + xt)));
      var jt = Tt === !0 ? 0 : Tt;
      typeof jt == "number" && (ye < se.top && (et -= ye - se.top - ke, T.y + X < se.top + jt && (et += T.y - se.top + X - jt)), ce > se.bottom && (et -= ce - se.bottom - ke, T.y > se.bottom - jt && (et += T.y - se.bottom + jt)));
      var on = F.x + nt, cn = on + oe, hn = F.y + et, Dn = hn + ee, On = T.x, mn = On + W, kn = T.y, dt = kn + X, rt = Math.max(on, On), wt = Math.min(cn, mn), zt = (rt + wt) / 2, Mt = zt - on, ct = Math.max(hn, kn), ft = Math.min(Dn, dt), Yt = (ct + ft) / 2, en = Yt - hn;
      i == null || i(t, He);
      var vn = Se.right - F.x - (nt + F.width), Ct = Se.bottom - F.y - (et + F.height);
      d({
        ready: !0,
        offsetX: nt / ve,
        offsetY: et / ge,
        offsetR: vn / ve,
        offsetB: Ct / ge,
        arrowX: Mt / ve,
        arrowY: en / ge,
        scaleX: ve,
        scaleY: ge,
        align: He
      });
    }
  }), g = function() {
    f.current += 1;
    var C = f.current;
    Promise.resolve().then(function() {
      f.current === C && p();
    });
  }, b = function() {
    d(function(C) {
      return V(V({}, C), {}, {
        ready: !1
      });
    });
  };
  return Pt(b, [r]), Pt(function() {
    e || b();
  }, [e]), [u.ready, u.offsetX, u.offsetY, u.offsetR, u.offsetB, u.arrowX, u.arrowY, u.scaleX, u.scaleY, u.align, g];
}
function IM(e, t, n, r, o) {
  Pt(function() {
    if (e && t && n) {
      let f = function() {
        r(), o();
      };
      var a = t, i = n, l = yd(a), c = yd(i), u = Ui(i), d = new Set([u].concat(be(l), be(c)));
      return d.forEach(function(m) {
        m.addEventListener("scroll", f, {
          passive: !0
        });
      }), u.addEventListener("resize", f, {
        passive: !0
      }), r(), function() {
        d.forEach(function(m) {
          m.removeEventListener("scroll", f), u.removeEventListener("resize", f);
        });
      };
    }
  }, [e, t, n]);
}
function PM(e, t, n, r, o, a, i, l) {
  var c = s.useRef(e), u = s.useRef(!1);
  c.current !== e && (u.current = !0, c.current = e), s.useEffect(function() {
    var d = _t(function() {
      u.current = !1;
    });
    return function() {
      _t.cancel(d);
    };
  }, [e]), s.useEffect(function() {
    if (t && r && (!o || a)) {
      var d = function() {
        var E = !1, I = function(P) {
          var _ = P.target;
          E = i(_);
        }, k = function(P) {
          var _ = P.target;
          !u.current && c.current && !E && !i(_) && l(!1);
        };
        return [I, k];
      }, f = d(), m = Q(f, 2), v = m[0], h = m[1], p = d(), g = Q(p, 2), b = g[0], y = g[1], C = Ui(r);
      C.addEventListener("mousedown", v, !0), C.addEventListener("click", h, !0), C.addEventListener("contextmenu", h, !0);
      var S = ls(n);
      if (S && (S.addEventListener("mousedown", b, !0), S.addEventListener("click", y, !0), S.addEventListener("contextmenu", y, !0)), process.env.NODE_ENV !== "production") {
        var $, x, w = n == null || ($ = n.getRootNode) === null || $ === void 0 ? void 0 : $.call(n), N = (x = r.getRootNode) === null || x === void 0 ? void 0 : x.call(r);
        Br(w === N, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        C.removeEventListener("mousedown", v, !0), C.removeEventListener("click", h, !0), C.removeEventListener("contextmenu", h, !0), S && (S.removeEventListener("mousedown", b, !0), S.removeEventListener("click", y, !0), S.removeEventListener("contextmenu", y, !0));
      };
    }
  }, [t, n, r, o, a]);
}
var RM = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function MM() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Vi, t = /* @__PURE__ */ s.forwardRef(function(n, r) {
    var o = n.prefixCls, a = o === void 0 ? "rc-trigger-popup" : o, i = n.children, l = n.action, c = l === void 0 ? "hover" : l, u = n.showAction, d = n.hideAction, f = n.popupVisible, m = n.defaultPopupVisible, v = n.onPopupVisibleChange, h = n.afterPopupVisibleChange, p = n.mouseEnterDelay, g = n.mouseLeaveDelay, b = g === void 0 ? 0.1 : g, y = n.focusDelay, C = n.blurDelay, S = n.mask, $ = n.maskClosable, x = $ === void 0 ? !0 : $, w = n.getPopupContainer, N = n.forceRender, O = n.autoDestroy, E = n.destroyPopupOnHide, I = n.popup, k = n.popupClassName, M = n.popupStyle, P = n.popupPlacement, _ = n.builtinPlacements, D = _ === void 0 ? {} : _, R = n.popupAlign, T = n.zIndex, L = n.stretch, F = n.getPopupClassNameFromAlign, j = n.fresh, A = n.alignPoint, B = n.onPopupClick, K = n.onPopupAlign, Y = n.arrow, G = n.popupMotion, te = n.maskMotion, ee = n.popupTransitionName, oe = n.popupAnimation, X = n.maskTransitionName, W = n.maskAnimation, re = n.className, Z = n.getTriggerDOMNode, H = vt(n, RM), U = O || E || !1, ae = s.useState(!1), ue = Q(ae, 2), de = ue[0], se = ue[1];
    Pt(function() {
      se(Lf());
    }, []);
    var ie = s.useRef({}), me = s.useContext(Eg), Se = s.useMemo(function() {
      return {
        registerSubPopup: function(It, un) {
          ie.current[It] = un, me == null || me.registerSubPopup(It, un);
        }
      };
    }, [me]), ve = _0(), ge = s.useState(null), $e = Q(ge, 2), we = $e[0], _e = $e[1], ze = Lt(function(ht) {
      es(ht) && we !== ht && _e(ht), me == null || me.registerSubPopup(ve, ht);
    }), Te = s.useState(null), ke = Q(Te, 2), Le = ke[0], Ee = ke[1], xe = s.useRef(null), he = Lt(function(ht) {
      es(ht) && Le !== ht && (Ee(ht), xe.current = ht);
    }), pe = s.Children.only(i), Pe = (pe == null ? void 0 : pe.props) || {}, Re = {}, at = Lt(function(ht) {
      var It, un, Nn = Le;
      return (Nn == null ? void 0 : Nn.contains(ht)) || ((It = ls(Nn)) === null || It === void 0 ? void 0 : It.host) === ht || ht === Nn || (we == null ? void 0 : we.contains(ht)) || ((un = ls(we)) === null || un === void 0 ? void 0 : un.host) === ht || ht === we || Object.values(ie.current).some(function(dn) {
        return (dn == null ? void 0 : dn.contains(ht)) || ht === dn;
      });
    }), Ze = Ng(a, G, oe, ee), Ie = Ng(a, te, W, X), Be = s.useState(m || !1), bt = Q(Be, 2), He = bt[0], nt = bt[1], et = f ?? He, Ge = Lt(function(ht) {
      f === void 0 && nt(ht);
    });
    Pt(function() {
      nt(f || !1);
    }, [f]);
    var Ae = s.useRef(et);
    Ae.current = et;
    var qe = s.useRef([]);
    qe.current = [];
    var Je = Lt(function(ht) {
      var It;
      Ge(ht), ((It = qe.current[qe.current.length - 1]) !== null && It !== void 0 ? It : et) !== ht && (qe.current.push(ht), v == null || v(ht));
    }), Ke = s.useRef(), Ye = function() {
      clearTimeout(Ke.current);
    }, Ve = function(It) {
      var un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Ye(), un === 0 ? Je(It) : Ke.current = setTimeout(function() {
        Je(It);
      }, un * 1e3);
    };
    s.useEffect(function() {
      return Ye;
    }, []);
    var Qe = s.useState(!1), it = Q(Qe, 2), yt = it[0], Tt = it[1];
    Pt(function(ht) {
      (!ht || et) && Tt(!0);
    }, [et]);
    var ne = s.useState(null), ye = Q(ne, 2), ce = ye[0], Ce = ye[1], je = s.useState([0, 0]), Ne = Q(je, 2), De = Ne[0], Fe = Ne[1], ot = function(It) {
      Fe([It.clientX, It.clientY]);
    }, pt = NM(et, we, A ? De : Le, P, D, R, K), St = Q(pt, 11), Ot = St[0], Wt = St[1], rn = St[2], Nt = St[3], Ut = St[4], fn = St[5], sn = St[6], ln = St[7], _n = St[8], ut = St[9], xt = St[10], jt = wM(de, c, u, d), on = Q(jt, 2), cn = on[0], hn = on[1], Dn = cn.has("click"), On = hn.has("click") || hn.has("contextMenu"), mn = Lt(function() {
      yt || xt();
    }), kn = function() {
      Ae.current && A && On && Ve(!1);
    };
    IM(et, Le, we, mn, kn), Pt(function() {
      mn();
    }, [De, P]), Pt(function() {
      et && !(D != null && D[P]) && mn();
    }, [JSON.stringify(R)]);
    var dt = s.useMemo(function() {
      var ht = OM(D, a, ut, A);
      return J(ht, F == null ? void 0 : F(ut));
    }, [ut, F, D, a, A]);
    s.useImperativeHandle(r, function() {
      return {
        nativeElement: xe.current,
        forceAlign: mn
      };
    });
    var rt = s.useState(0), wt = Q(rt, 2), zt = wt[0], Mt = wt[1], ct = s.useState(0), ft = Q(ct, 2), Yt = ft[0], en = ft[1], vn = function() {
      if (L && Le) {
        var It = Le.getBoundingClientRect();
        Mt(It.width), en(It.height);
      }
    }, Ct = function() {
      vn(), mn();
    }, Ue = function(It) {
      Tt(!1), xt(), h == null || h(It);
    }, st = function() {
      return new Promise(function(It) {
        vn(), Ce(function() {
          return It;
        });
      });
    };
    Pt(function() {
      ce && (xt(), ce(), Ce(null));
    }, [ce]);
    function gt(ht, It, un, Nn) {
      Re[ht] = function(dn) {
        var ll;
        Nn == null || Nn(dn), Ve(It, un);
        for (var Ec = arguments.length, qm = new Array(Ec > 1 ? Ec - 1 : 0), sl = 1; sl < Ec; sl++)
          qm[sl - 1] = arguments[sl];
        (ll = Pe[ht]) === null || ll === void 0 || ll.call.apply(ll, [Pe, dn].concat(qm));
      };
    }
    (Dn || On) && (Re.onClick = function(ht) {
      var It;
      Ae.current && On ? Ve(!1) : !Ae.current && Dn && (ot(ht), Ve(!0));
      for (var un = arguments.length, Nn = new Array(un > 1 ? un - 1 : 0), dn = 1; dn < un; dn++)
        Nn[dn - 1] = arguments[dn];
      (It = Pe.onClick) === null || It === void 0 || It.call.apply(It, [Pe, ht].concat(Nn));
    }), PM(et, On, Le, we, S, x, at, Ve);
    var At = cn.has("hover"), bn = hn.has("hover"), Gn, Xn;
    At && (gt("onMouseEnter", !0, p, function(ht) {
      ot(ht);
    }), gt("onPointerEnter", !0, p, function(ht) {
      ot(ht);
    }), Gn = function(It) {
      (et || yt) && we !== null && we !== void 0 && we.contains(It.target) && Ve(!0, p);
    }, A && (Re.onMouseMove = function(ht) {
      var It;
      (It = Pe.onMouseMove) === null || It === void 0 || It.call(Pe, ht);
    })), bn && (gt("onMouseLeave", !1, b), gt("onPointerLeave", !1, b), Xn = function() {
      Ve(!1, b);
    }), cn.has("focus") && gt("onFocus", !0, y), hn.has("focus") && gt("onBlur", !1, C), cn.has("contextMenu") && (Re.onContextMenu = function(ht) {
      var It;
      Ae.current && hn.has("contextMenu") ? Ve(!1) : (ot(ht), Ve(!0)), ht.preventDefault();
      for (var un = arguments.length, Nn = new Array(un > 1 ? un - 1 : 0), dn = 1; dn < un; dn++)
        Nn[dn - 1] = arguments[dn];
      (It = Pe.onContextMenu) === null || It === void 0 || It.call.apply(It, [Pe, ht].concat(Nn));
    }), re && (Re.className = J(Pe.className, re));
    var mr = V(V({}, Pe), Re), Xr = {}, Sc = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Sc.forEach(function(ht) {
      H[ht] && (Xr[ht] = function() {
        for (var It, un = arguments.length, Nn = new Array(un), dn = 0; dn < un; dn++)
          Nn[dn] = arguments[dn];
        (It = mr[ht]) === null || It === void 0 || It.call.apply(It, [mr].concat(Nn)), H[ht].apply(H, Nn);
      });
    });
    var xc = /* @__PURE__ */ s.cloneElement(pe, V(V({}, mr), Xr)), $c = {
      x: fn,
      y: sn
    }, wc = Y ? V({}, Y !== !0 ? Y : {}) : null;
    return /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(Mn, {
      disabled: !et,
      ref: he,
      onResize: Ct
    }, /* @__PURE__ */ s.createElement(Oy, {
      getTriggerDOMNode: Z
    }, xc)), /* @__PURE__ */ s.createElement(Eg.Provider, {
      value: Se
    }, /* @__PURE__ */ s.createElement(Ey, {
      portal: e,
      ref: ze,
      prefixCls: a,
      popup: I,
      className: J(k, dt),
      style: M,
      target: Le,
      onMouseEnter: Gn,
      onMouseLeave: Xn,
      onPointerEnter: Gn,
      zIndex: T,
      open: et,
      keepDom: yt,
      fresh: j,
      onClick: B,
      mask: S,
      motion: Ze,
      maskMotion: Ie,
      onVisibleChanged: Ue,
      onPrepare: st,
      forceRender: N,
      autoDestroy: U,
      getPopupContainer: w,
      align: ut,
      arrow: wc,
      arrowPos: $c,
      ready: Ot,
      offsetX: Wt,
      offsetY: rn,
      offsetR: Nt,
      offsetB: Ut,
      onAlign: mn,
      stretch: L,
      targetWidth: zt / ln,
      targetHeight: Yt / _n
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const Yi = MM(Vi);
var TM = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], _M = function(t) {
  var n = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, DM = function(t, n) {
  var r = t.prefixCls;
  t.disabled;
  var o = t.visible, a = t.children, i = t.popupElement, l = t.animation, c = t.transitionName, u = t.dropdownStyle, d = t.dropdownClassName, f = t.direction, m = f === void 0 ? "ltr" : f, v = t.placement, h = t.builtinPlacements, p = t.dropdownMatchSelectWidth, g = t.dropdownRender, b = t.dropdownAlign, y = t.getPopupContainer, C = t.empty, S = t.getTriggerDOMNode, $ = t.onPopupVisibleChange, x = t.onPopupMouseEnter, w = vt(t, TM), N = "".concat(r, "-dropdown"), O = i;
  g && (O = g(i));
  var E = s.useMemo(function() {
    return h || _M(p);
  }, [h, p]), I = l ? "".concat(N, "-").concat(l) : c, k = typeof p == "number", M = s.useMemo(function() {
    return k ? null : p === !1 ? "minWidth" : "width";
  }, [p, k]), P = u;
  k && (P = V(V({}, P), {}, {
    width: p
  }));
  var _ = s.useRef(null);
  return s.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        return _.current;
      }
    };
  }), /* @__PURE__ */ s.createElement(Yi, fe({}, w, {
    showAction: $ ? ["click"] : [],
    hideAction: $ ? ["click"] : [],
    popupPlacement: v || (m === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: E,
    prefixCls: N,
    popupTransitionName: I,
    popup: /* @__PURE__ */ s.createElement("div", {
      ref: _,
      onMouseEnter: x
    }, O),
    stretch: M,
    popupAlign: b,
    popupVisible: o,
    getPopupContainer: y,
    popupClassName: J(d, z({}, "".concat(N, "-empty"), C)),
    popupStyle: P,
    getTriggerDOMNode: S,
    onPopupVisibleChange: $
  }), a);
}, Ny = /* @__PURE__ */ s.forwardRef(DM);
process.env.NODE_ENV !== "production" && (Ny.displayName = "SelectTrigger");
function Tg(e, t) {
  var n = e.key, r;
  return "value" in e && (r = e.value), n ?? (r !== void 0 ? r : "rc-index-key-".concat(t));
}
function Iy(e, t) {
  var n = e || {}, r = n.label, o = n.value, a = n.options, i = n.groupLabel, l = r || (t ? "children" : "label");
  return {
    label: l,
    value: o || "value",
    options: a || "options",
    groupLabel: i || l
  };
}
function kM(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.fieldNames, r = t.childrenAsData, o = [], a = Iy(n, !1), i = a.label, l = a.value, c = a.options, u = a.groupLabel;
  function d(f, m) {
    Array.isArray(f) && f.forEach(function(v) {
      if (m || !(c in v)) {
        var h = v[l];
        o.push({
          key: Tg(v, o.length),
          groupOption: m,
          data: v,
          label: v[i],
          value: h
        });
      } else {
        var p = v[u];
        p === void 0 && r && (p = v.label), o.push({
          key: Tg(v, o.length),
          group: !0,
          data: v,
          label: p
        }), d(v[c], !0);
      }
    });
  }
  return d(e, !1), o;
}
function Cd(e) {
  var t = V({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return tt(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var LM = function(t, n, r) {
  if (!n || !n.length)
    return null;
  var o = !1, a = function l(c, u) {
    var d = mb(u), f = d[0], m = d.slice(1);
    if (!f)
      return [c];
    var v = c.split(f);
    return o = o || v.length > 1, v.reduce(function(h, p) {
      return [].concat(be(h), be(l(p, m)));
    }, []).filter(Boolean);
  }, i = a(t, n);
  return o ? typeof r < "u" ? i.slice(0, r) : i : null;
}, zf = /* @__PURE__ */ s.createContext(null), FM = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], jM = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], fs = function(t) {
  return t === "tags" || t === "multiple";
}, Py = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n, r, o = e.id, a = e.prefixCls, i = e.className, l = e.showSearch, c = e.tagRender, u = e.direction, d = e.omitDomProps, f = e.displayValues, m = e.onDisplayValuesChange, v = e.emptyOptions, h = e.notFoundContent, p = h === void 0 ? "Not Found" : h, g = e.onClear, b = e.mode, y = e.disabled, C = e.loading, S = e.getInputElement, $ = e.getRawInputElement, x = e.open, w = e.defaultOpen, N = e.onDropdownVisibleChange, O = e.activeValue, E = e.onActiveValueChange, I = e.activeDescendantId, k = e.searchValue, M = e.autoClearSearchValue, P = e.onSearch, _ = e.onSearchSplit, D = e.tokenSeparators, R = e.allowClear, T = e.suffixIcon, L = e.clearIcon, F = e.OptionList, j = e.animation, A = e.transitionName, B = e.dropdownStyle, K = e.dropdownClassName, Y = e.dropdownMatchSelectWidth, G = e.dropdownRender, te = e.dropdownAlign, ee = e.placement, oe = e.builtinPlacements, X = e.getPopupContainer, W = e.showAction, re = W === void 0 ? [] : W, Z = e.onFocus, H = e.onBlur, U = e.onKeyUp, ae = e.onKeyDown, ue = e.onMouseDown, de = vt(e, FM), se = fs(b), ie = (l !== void 0 ? l : se) || b === "combobox", me = V({}, de);
  jM.forEach(function(dt) {
    delete me[dt];
  }), d == null || d.forEach(function(dt) {
    delete me[dt];
  });
  var Se = s.useState(!1), ve = Q(Se, 2), ge = ve[0], $e = ve[1];
  s.useEffect(function() {
    $e(Lf());
  }, []);
  var we = s.useRef(null), _e = s.useRef(null), ze = s.useRef(null), Te = s.useRef(null), ke = s.useRef(null), Le = s.useRef(!1), Ee = J2(), xe = Q(Ee, 3), he = xe[0], pe = xe[1], Pe = xe[2];
  s.useImperativeHandle(t, function() {
    var dt, rt;
    return {
      focus: (dt = Te.current) === null || dt === void 0 ? void 0 : dt.focus,
      blur: (rt = Te.current) === null || rt === void 0 ? void 0 : rt.blur,
      scrollTo: function(zt) {
        var Mt;
        return (Mt = ke.current) === null || Mt === void 0 ? void 0 : Mt.scrollTo(zt);
      }
    };
  });
  var Re = s.useMemo(function() {
    var dt;
    if (b !== "combobox")
      return k;
    var rt = (dt = f[0]) === null || dt === void 0 ? void 0 : dt.value;
    return typeof rt == "string" || typeof rt == "number" ? String(rt) : "";
  }, [k, b, f]), at = b === "combobox" && typeof S == "function" && S() || null, Ze = typeof $ == "function" && $(), Ie = Gr(_e, Ze == null || (n = Ze.props) === null || n === void 0 ? void 0 : n.ref), Be = s.useState(!1), bt = Q(Be, 2), He = bt[0], nt = bt[1];
  Pt(function() {
    nt(!0);
  }, []);
  var et = Vt(!1, {
    defaultValue: w,
    value: x
  }), Ge = Q(et, 2), Ae = Ge[0], qe = Ge[1], Je = He ? Ae : !1, Ke = !p && v;
  (y || Ke && Je && b === "combobox") && (Je = !1);
  var Ye = Ke ? !1 : Je, Ve = s.useCallback(function(dt) {
    var rt = dt !== void 0 ? dt : !Je;
    y || (qe(rt), Je !== rt && (N == null || N(rt)));
  }, [y, Je, qe, N]), Qe = s.useMemo(function() {
    return (D || []).some(function(dt) {
      return [`
`, `\r
`].includes(dt);
    });
  }, [D]), it = s.useContext(zf) || {}, yt = it.maxCount, Tt = it.rawValues, ne = function(rt, wt, zt) {
    if (!((Tt == null ? void 0 : Tt.size) >= yt)) {
      var Mt = !0, ct = rt;
      E == null || E(null);
      var ft = LM(rt, D, yt && yt - Tt.size), Yt = zt ? null : ft;
      return b !== "combobox" && Yt && (ct = "", _ == null || _(Yt), Ve(!1), Mt = !1), P && Re !== ct && P(ct, {
        source: wt ? "typing" : "effect"
      }), Mt;
    }
  }, ye = function(rt) {
    !rt || !rt.trim() || P(rt, {
      source: "submit"
    });
  };
  s.useEffect(function() {
    !Je && !se && b !== "combobox" && ne("", !1, !1);
  }, [Je]), s.useEffect(function() {
    Ae && y && qe(!1), y && !Le.current && pe(!1);
  }, [y]);
  var ce = by(), Ce = Q(ce, 2), je = Ce[0], Ne = Ce[1], De = function(rt) {
    var wt = je(), zt = rt.which;
    if (zt === Oe.ENTER && (b !== "combobox" && rt.preventDefault(), Je || Ve(!0)), Ne(!!Re), zt === Oe.BACKSPACE && !wt && se && !Re && f.length) {
      for (var Mt = be(f), ct = null, ft = Mt.length - 1; ft >= 0; ft -= 1) {
        var Yt = Mt[ft];
        if (!Yt.disabled) {
          Mt.splice(ft, 1), ct = Yt;
          break;
        }
      }
      ct && m(Mt, {
        type: "remove",
        values: [ct]
      });
    }
    for (var en = arguments.length, vn = new Array(en > 1 ? en - 1 : 0), Ct = 1; Ct < en; Ct++)
      vn[Ct - 1] = arguments[Ct];
    if (Je) {
      var Ue;
      (Ue = ke.current) === null || Ue === void 0 || Ue.onKeyDown.apply(Ue, [rt].concat(vn));
    }
    ae == null || ae.apply(void 0, [rt].concat(vn));
  }, Fe = function(rt) {
    for (var wt = arguments.length, zt = new Array(wt > 1 ? wt - 1 : 0), Mt = 1; Mt < wt; Mt++)
      zt[Mt - 1] = arguments[Mt];
    if (Je) {
      var ct;
      (ct = ke.current) === null || ct === void 0 || ct.onKeyUp.apply(ct, [rt].concat(zt));
    }
    U == null || U.apply(void 0, [rt].concat(zt));
  }, ot = function(rt) {
    var wt = f.filter(function(zt) {
      return zt !== rt;
    });
    m(wt, {
      type: "remove",
      values: [rt]
    });
  }, pt = s.useRef(!1), St = function() {
    pe(!0), y || (Z && !pt.current && Z.apply(void 0, arguments), re.includes("focus") && Ve(!0)), pt.current = !0;
  }, Ot = function() {
    Le.current = !0, pe(!1, function() {
      pt.current = !1, Le.current = !1, Ve(!1);
    }), !y && (Re && (b === "tags" ? P(Re, {
      source: "submit"
    }) : b === "multiple" && P("", {
      source: "blur"
    })), H && H.apply(void 0, arguments));
  }, Wt = [];
  s.useEffect(function() {
    return function() {
      Wt.forEach(function(dt) {
        return clearTimeout(dt);
      }), Wt.splice(0, Wt.length);
    };
  }, []);
  var rn = function(rt) {
    var wt, zt = rt.target, Mt = (wt = ze.current) === null || wt === void 0 ? void 0 : wt.getPopupElement();
    if (Mt && Mt.contains(zt)) {
      var ct = setTimeout(function() {
        var vn = Wt.indexOf(ct);
        if (vn !== -1 && Wt.splice(vn, 1), Pe(), !ge && !Mt.contains(document.activeElement)) {
          var Ct;
          (Ct = Te.current) === null || Ct === void 0 || Ct.focus();
        }
      });
      Wt.push(ct);
    }
    for (var ft = arguments.length, Yt = new Array(ft > 1 ? ft - 1 : 0), en = 1; en < ft; en++)
      Yt[en - 1] = arguments[en];
    ue == null || ue.apply(void 0, [rt].concat(Yt));
  }, Nt = s.useState({}), Ut = Q(Nt, 2), fn = Ut[1];
  function sn() {
    fn({});
  }
  var ln;
  Ze && (ln = function(rt) {
    Ve(rt);
  }), Z2(function() {
    var dt;
    return [we.current, (dt = ze.current) === null || dt === void 0 ? void 0 : dt.getPopupElement()];
  }, Ye, Ve, !!Ze);
  var _n = s.useMemo(function() {
    return V(V({}, e), {}, {
      notFoundContent: p,
      open: Je,
      triggerOpen: Ye,
      id: o,
      showSearch: ie,
      multiple: se,
      toggleOpen: Ve
    });
  }, [e, p, Ye, Je, o, ie, se, Ve]), ut = !!T || C, xt;
  ut && (xt = /* @__PURE__ */ s.createElement(Gs, {
    className: J("".concat(a, "-arrow"), z({}, "".concat(a, "-arrow-loading"), C)),
    customizeIcon: T,
    customizeIconProps: {
      loading: C,
      searchValue: Re,
      open: Je,
      focused: he,
      showSearch: ie
    }
  }));
  var jt = function() {
    var rt;
    g == null || g(), (rt = Te.current) === null || rt === void 0 || rt.focus(), m([], {
      type: "clear",
      values: f
    }), ne("", !1, !1);
  }, on = X2(a, jt, f, R, L, y, Re, b), cn = on.allowClear, hn = on.clearIcon, Dn = /* @__PURE__ */ s.createElement(F, {
    ref: ke
  }), On = J(a, i, (r = {}, z(r, "".concat(a, "-focused"), he), z(r, "".concat(a, "-multiple"), se), z(r, "".concat(a, "-single"), !se), z(r, "".concat(a, "-allow-clear"), R), z(r, "".concat(a, "-show-arrow"), ut), z(r, "".concat(a, "-disabled"), y), z(r, "".concat(a, "-loading"), C), z(r, "".concat(a, "-open"), Je), z(r, "".concat(a, "-customize-input"), at), z(r, "".concat(a, "-show-search"), ie), r)), mn = /* @__PURE__ */ s.createElement(Ny, {
    ref: ze,
    disabled: y,
    prefixCls: a,
    visible: Ye,
    popupElement: Dn,
    animation: j,
    transitionName: A,
    dropdownStyle: B,
    dropdownClassName: K,
    direction: u,
    dropdownMatchSelectWidth: Y,
    dropdownRender: G,
    dropdownAlign: te,
    placement: ee,
    builtinPlacements: oe,
    getPopupContainer: X,
    empty: v,
    getTriggerDOMNode: function() {
      return _e.current;
    },
    onPopupVisibleChange: ln,
    onPopupMouseEnter: sn
  }, Ze ? /* @__PURE__ */ s.cloneElement(Ze, {
    ref: Ie
  }) : /* @__PURE__ */ s.createElement($y, fe({}, e, {
    domRef: _e,
    prefixCls: a,
    inputElement: at,
    ref: Te,
    id: o,
    showSearch: ie,
    autoClearSearchValue: M,
    mode: b,
    activeDescendantId: I,
    tagRender: c,
    values: f,
    open: Je,
    onToggleOpen: Ve,
    activeValue: O,
    searchValue: Re,
    onSearch: ne,
    onSearchSubmit: ye,
    onRemove: ot,
    tokenWithEnter: Qe
  }))), kn;
  return Ze ? kn = mn : kn = /* @__PURE__ */ s.createElement("div", fe({
    className: On
  }, me, {
    ref: we,
    onMouseDown: rn,
    onKeyDown: De,
    onKeyUp: Fe,
    onFocus: St,
    onBlur: Ot
  }), he && !Je && /* @__PURE__ */ s.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(f.map(function(dt) {
    var rt = dt.label, wt = dt.value;
    return ["number", "string"].includes(mt(rt)) ? rt : wt;
  }).join(", "))), mn, xt, cn && hn), /* @__PURE__ */ s.createElement(hy.Provider, {
    value: _n
  }, kn);
});
process.env.NODE_ENV !== "production" && (Py.displayName = "BaseSelect");
var Af = function() {
  return null;
};
Af.isSelectOptGroup = !0;
var Bf = function() {
  return null;
};
Bf.isSelectOption = !0;
var Ry = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.height, r = e.offsetY, o = e.offsetX, a = e.children, i = e.prefixCls, l = e.onInnerResize, c = e.innerProps, u = e.rtl, d = e.extra, f = {}, m = {
    display: "flex",
    flexDirection: "column"
  };
  return r !== void 0 && (f = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, m = V(V({}, m), {}, z(z(z(z(z({
    transform: "translateY(".concat(r, "px)")
  }, u ? "marginRight" : "marginLeft", -o), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ s.createElement("div", {
    style: f
  }, /* @__PURE__ */ s.createElement(Mn, {
    onResize: function(h) {
      var p = h.offsetHeight;
      p && l && l();
    }
  }, /* @__PURE__ */ s.createElement("div", fe({
    style: m,
    className: J(z({}, "".concat(i, "-holder-inner"), i)),
    ref: t
  }, c), a, d)));
});
Ry.displayName = "Filler";
function _g(e, t) {
  var n = "touches" in e ? e.touches[0] : e;
  return n[t ? "pageX" : "pageY"];
}
var Sd = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.rtl, o = e.scrollOffset, a = e.scrollRange, i = e.onStartMove, l = e.onStopMove, c = e.onScroll, u = e.horizontal, d = e.spinSize, f = e.containerSize, m = e.style, v = e.thumbStyle, h = s.useState(!1), p = Q(h, 2), g = p[0], b = p[1], y = s.useState(null), C = Q(y, 2), S = C[0], $ = C[1], x = s.useState(null), w = Q(x, 2), N = w[0], O = w[1], E = !r, I = s.useRef(), k = s.useRef(), M = s.useState(!1), P = Q(M, 2), _ = P[0], D = P[1], R = s.useRef(), T = function() {
    clearTimeout(R.current), D(!0), R.current = setTimeout(function() {
      D(!1);
    }, 3e3);
  }, L = a - f || 0, F = f - d || 0, j = s.useMemo(function() {
    if (o === 0 || L === 0)
      return 0;
    var X = o / L;
    return X * F;
  }, [o, L, F]), A = function(W) {
    W.stopPropagation(), W.preventDefault();
  }, B = s.useRef({
    top: j,
    dragging: g,
    pageY: S,
    startTop: N
  });
  B.current = {
    top: j,
    dragging: g,
    pageY: S,
    startTop: N
  };
  var K = function(W) {
    b(!0), $(_g(W, u)), O(B.current.top), i(), W.stopPropagation(), W.preventDefault();
  };
  s.useEffect(function() {
    var X = function(H) {
      H.preventDefault();
    }, W = I.current, re = k.current;
    return W.addEventListener("touchstart", X), re.addEventListener("touchstart", K), function() {
      W.removeEventListener("touchstart", X), re.removeEventListener("touchstart", K);
    };
  }, []);
  var Y = s.useRef();
  Y.current = L;
  var G = s.useRef();
  G.current = F, s.useEffect(function() {
    if (g) {
      var X, W = function(H) {
        var U = B.current, ae = U.dragging, ue = U.pageY, de = U.startTop;
        if (_t.cancel(X), ae) {
          var se = _g(H, u) - ue, ie = de;
          !E && u ? ie -= se : ie += se;
          var me = Y.current, Se = G.current, ve = Se ? ie / Se : 0, ge = Math.ceil(ve * me);
          ge = Math.max(ge, 0), ge = Math.min(ge, me), X = _t(function() {
            c(ge, u);
          });
        }
      }, re = function() {
        b(!1), l();
      };
      return window.addEventListener("mousemove", W), window.addEventListener("touchmove", W), window.addEventListener("mouseup", re), window.addEventListener("touchend", re), function() {
        window.removeEventListener("mousemove", W), window.removeEventListener("touchmove", W), window.removeEventListener("mouseup", re), window.removeEventListener("touchend", re), _t.cancel(X);
      };
    }
  }, [g]), s.useEffect(function() {
    T();
  }, [o]), s.useImperativeHandle(t, function() {
    return {
      delayHidden: T
    };
  });
  var te = "".concat(n, "-scrollbar"), ee = {
    position: "absolute",
    visibility: _ ? null : "hidden"
  }, oe = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return u ? (ee.height = 8, ee.left = 0, ee.right = 0, ee.bottom = 0, oe.height = "100%", oe.width = d, E ? oe.left = j : oe.right = j) : (ee.width = 8, ee.top = 0, ee.bottom = 0, E ? ee.right = 0 : ee.left = 0, oe.width = "100%", oe.height = d, oe.top = j), /* @__PURE__ */ s.createElement("div", {
    ref: I,
    className: J(te, z(z(z({}, "".concat(te, "-horizontal"), u), "".concat(te, "-vertical"), !u), "".concat(te, "-visible"), _)),
    style: V(V({}, ee), m),
    onMouseDown: A,
    onMouseMove: T
  }, /* @__PURE__ */ s.createElement("div", {
    ref: k,
    className: J("".concat(te, "-thumb"), z({}, "".concat(te, "-thumb-moving"), g)),
    style: V(V({}, oe), v),
    onMouseDown: K
  }));
});
process.env.NODE_ENV !== "production" && (Sd.displayName = "ScrollBar");
function zM(e) {
  var t = e.children, n = e.setRef, r = s.useCallback(function(o) {
    n(o);
  }, []);
  return /* @__PURE__ */ s.cloneElement(t, {
    ref: r
  });
}
function AM(e, t, n, r, o, a, i) {
  var l = i.getKey;
  return e.slice(t, n + 1).map(function(c, u) {
    var d = t + u, f = a(c, d, {
      style: {
        width: r
      }
    }), m = l(c);
    return /* @__PURE__ */ s.createElement(zM, {
      key: m,
      setRef: function(h) {
        return o(c, h);
      }
    }, f);
  });
}
var BM = /* @__PURE__ */ function() {
  function e() {
    $n(this, e), z(this, "maps", void 0), z(this, "id", 0), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return wn(e, [{
    key: "set",
    value: function(n, r) {
      this.maps[n] = r, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
  }]), e;
}();
function HM(e, t, n) {
  var r = s.useState(0), o = Q(r, 2), a = o[0], i = o[1], l = Xe(/* @__PURE__ */ new Map()), c = Xe(new BM()), u = Xe();
  function d() {
    _t.cancel(u.current);
  }
  function f() {
    var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    d();
    var h = function() {
      l.current.forEach(function(g, b) {
        if (g && g.offsetParent) {
          var y = ii(g), C = y.offsetHeight;
          c.current.get(b) !== C && c.current.set(b, y.offsetHeight);
        }
      }), i(function(g) {
        return g + 1;
      });
    };
    v ? h() : u.current = _t(h);
  }
  function m(v, h) {
    var p = e(v), g = l.current.get(p);
    h ? (l.current.set(p, h), f()) : l.current.delete(p), !g != !h && (h ? t == null || t(v) : n == null || n(v));
  }
  return Bt(function() {
    return d;
  }, []), [m, f, c.current, a];
}
var Dg = 10;
function VM(e, t, n, r, o, a, i, l) {
  var c = s.useRef(), u = s.useState(null), d = Q(u, 2), f = d[0], m = d[1];
  return Pt(function() {
    if (f && f.times < Dg) {
      if (!e.current) {
        m(function(L) {
          return V({}, L);
        });
        return;
      }
      a();
      var v = f.targetAlign, h = f.originAlign, p = f.index, g = f.offset, b = e.current.clientHeight, y = !1, C = v, S = null;
      if (b) {
        for (var $ = v || h, x = 0, w = 0, N = 0, O = Math.min(t.length - 1, p), E = 0; E <= O; E += 1) {
          var I = o(t[E]);
          w = x;
          var k = n.get(I);
          N = w + (k === void 0 ? r : k), x = N;
        }
        for (var M = $ === "top" ? g : b - g, P = O; P >= 0; P -= 1) {
          var _ = o(t[P]), D = n.get(_);
          if (D === void 0) {
            y = !0;
            break;
          }
          if (M -= D, M <= 0)
            break;
        }
        switch ($) {
          case "top":
            S = w - g;
            break;
          case "bottom":
            S = N - b + g;
            break;
          default: {
            var R = e.current.scrollTop, T = R + b;
            w < R ? C = "top" : N > T && (C = "bottom");
          }
        }
        S !== null && i(S), S !== f.lastTop && (y = !0);
      }
      y && m(V(V({}, f), {}, {
        times: f.times + 1,
        targetAlign: C,
        lastTop: S
      }));
    } else
      process.env.NODE_ENV !== "production" && (f == null ? void 0 : f.times) === Dg && tt(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [f, e.current]), function(v) {
    if (v == null) {
      l();
      return;
    }
    if (_t.cancel(c.current), typeof v == "number")
      i(v);
    else if (v && mt(v) === "object") {
      var h, p = v.align;
      "index" in v ? h = v.index : h = t.findIndex(function(y) {
        return o(y) === v.key;
      });
      var g = v.offset, b = g === void 0 ? 0 : g;
      m({
        times: 0,
        index: h,
        offset: b,
        originAlign: p
      });
    }
  };
}
function WM(e, t, n) {
  var r = e.length, o = t.length, a, i;
  if (r === 0 && o === 0)
    return null;
  r < o ? (a = e, i = t) : (a = t, i = e);
  var l = {
    __EMPTY_ITEM__: !0
  };
  function c(h) {
    return h !== void 0 ? n(h) : l;
  }
  for (var u = null, d = Math.abs(r - o) !== 1, f = 0; f < i.length; f += 1) {
    var m = c(a[f]), v = c(i[f]);
    if (m !== v) {
      u = f, d = d || m !== c(i[f + 1]);
      break;
    }
  }
  return u === null ? null : {
    index: u,
    multiple: d
  };
}
function KM(e, t, n) {
  var r = s.useState(e), o = Q(r, 2), a = o[0], i = o[1], l = s.useState(null), c = Q(l, 2), u = c[0], d = c[1];
  return s.useEffect(function() {
    var f = WM(a || [], e || [], t);
    (f == null ? void 0 : f.index) !== void 0 && (n == null || n(f.index), d(e[f.index])), i(e);
  }, [e]), [u];
}
var kg = (typeof navigator > "u" ? "undefined" : mt(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const My = function(e, t) {
  var n = Xe(!1), r = Xe(null);
  function o() {
    clearTimeout(r.current), n.current = !0, r.current = setTimeout(function() {
      n.current = !1;
    }, 50);
  }
  var a = Xe({
    top: e,
    bottom: t
  });
  return a.current.top = e, a.current.bottom = t, function(i) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = (
      // Pass origin wheel when on the top
      i < 0 && a.current.top || // Pass origin wheel when on the bottom
      i > 0 && a.current.bottom
    );
    return l && c ? (clearTimeout(r.current), n.current = !1) : (!c || n.current) && o(), !n.current && c;
  };
};
function qM(e, t, n, r, o) {
  var a = Xe(0), i = Xe(null), l = Xe(null), c = Xe(!1), u = My(t, n);
  function d(g, b) {
    _t.cancel(i.current), a.current += b, l.current = b, !u(b) && (kg || g.preventDefault(), i.current = _t(function() {
      var y = c.current ? 10 : 1;
      o(a.current * y), a.current = 0;
    }));
  }
  function f(g, b) {
    o(b, !0), kg || g.preventDefault();
  }
  var m = Xe(null), v = Xe(null);
  function h(g) {
    if (e) {
      _t.cancel(v.current), v.current = _t(function() {
        m.current = null;
      }, 2);
      var b = g.deltaX, y = g.deltaY, C = g.shiftKey, S = b, $ = y;
      (m.current === "sx" || !m.current && C && y && !b) && (S = y, $ = 0, m.current = "sx");
      var x = Math.abs(S), w = Math.abs($);
      m.current === null && (m.current = r && x > w ? "x" : "y"), m.current === "y" ? d(g, $) : f(g, S);
    }
  }
  function p(g) {
    e && (c.current = g.detail === l.current);
  }
  return [h, p];
}
var GM = 14 / 15;
function UM(e, t, n) {
  var r = Xe(!1), o = Xe(0), a = Xe(null), i = Xe(null), l, c = function(m) {
    if (r.current) {
      var v = Math.ceil(m.touches[0].pageY), h = o.current - v;
      o.current = v, n(h) && m.preventDefault(), clearInterval(i.current), i.current = setInterval(function() {
        h *= GM, (!n(h, !0) || Math.abs(h) <= 0.1) && clearInterval(i.current);
      }, 16);
    }
  }, u = function() {
    r.current = !1, l();
  }, d = function(m) {
    l(), m.touches.length === 1 && !r.current && (r.current = !0, o.current = Math.ceil(m.touches[0].pageY), a.current = m.target, a.current.addEventListener("touchmove", c), a.current.addEventListener("touchend", u));
  };
  l = function() {
    a.current && (a.current.removeEventListener("touchmove", c), a.current.removeEventListener("touchend", u));
  }, Pt(function() {
    return e && t.current.addEventListener("touchstart", d), function() {
      var f;
      (f = t.current) === null || f === void 0 || f.removeEventListener("touchstart", d), l(), clearInterval(i.current);
    };
  }, [e]);
}
var YM = 20;
function Lg() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = e / t * e;
  return isNaN(n) && (n = 0), n = Math.max(n, YM), Math.floor(n);
}
function XM(e, t, n, r) {
  var o = s.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, n.id, r]), a = Q(o, 2), i = a[0], l = a[1], c = function(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d, m = i.get(d), v = i.get(f);
    if (m === void 0 || v === void 0)
      for (var h = e.length, p = l.length; p < h; p += 1) {
        var g, b = e[p], y = t(b);
        i.set(y, p);
        var C = (g = n.get(y)) !== null && g !== void 0 ? g : r;
        if (l[p] = (l[p - 1] || 0) + C, y === d && (m = p), y === f && (v = p), m !== void 0 && v !== void 0)
          break;
      }
    return {
      top: l[m - 1] || 0,
      bottom: l[v]
    };
  };
  return c;
}
var QM = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], JM = [], ZM = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function eT(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-virtual-list" : n, o = e.className, a = e.height, i = e.itemHeight, l = e.fullHeight, c = l === void 0 ? !0 : l, u = e.style, d = e.data, f = e.children, m = e.itemKey, v = e.virtual, h = e.direction, p = e.scrollWidth, g = e.component, b = g === void 0 ? "div" : g, y = e.onScroll, C = e.onVirtualScroll, S = e.onVisibleChange, $ = e.innerProps, x = e.extraRender, w = e.styles, N = vt(e, QM), O = !!(v !== !1 && a && i), E = O && d && (i * d.length > a || !!p), I = h === "rtl", k = J(r, z({}, "".concat(r, "-rtl"), I), o), M = d || JM, P = Xe(), _ = Xe(), D = Ht(0), R = Q(D, 2), T = R[0], L = R[1], F = Ht(0), j = Q(F, 2), A = j[0], B = j[1], K = Ht(!1), Y = Q(K, 2), G = Y[0], te = Y[1], ee = function() {
    te(!0);
  }, oe = function() {
    te(!1);
  }, X = s.useCallback(function(Ne) {
    return typeof m == "function" ? m(Ne) : Ne == null ? void 0 : Ne[m];
  }, [m]), W = {
    getKey: X
  };
  function re(Ne) {
    L(function(De) {
      var Fe;
      typeof Ne == "function" ? Fe = Ne(De) : Fe = Ne;
      var ot = Ie(Fe);
      return P.current.scrollTop = ot, ot;
    });
  }
  var Z = Xe({
    start: 0,
    end: M.length
  }), H = Xe(), U = KM(M, X), ae = Q(U, 1), ue = ae[0];
  H.current = ue;
  var de = HM(X, null, null), se = Q(de, 4), ie = se[0], me = se[1], Se = se[2], ve = se[3], ge = s.useMemo(function() {
    if (!O)
      return {
        scrollHeight: void 0,
        start: 0,
        end: M.length - 1,
        offset: void 0
      };
    if (!E) {
      var Ne;
      return {
        scrollHeight: ((Ne = _.current) === null || Ne === void 0 ? void 0 : Ne.offsetHeight) || 0,
        start: 0,
        end: M.length - 1,
        offset: void 0
      };
    }
    for (var De = 0, Fe, ot, pt, St = M.length, Ot = 0; Ot < St; Ot += 1) {
      var Wt = M[Ot], rn = X(Wt), Nt = Se.get(rn), Ut = De + (Nt === void 0 ? i : Nt);
      Ut >= T && Fe === void 0 && (Fe = Ot, ot = De), Ut > T + a && pt === void 0 && (pt = Ot), De = Ut;
    }
    return Fe === void 0 && (Fe = 0, ot = 0, pt = Math.ceil(a / i)), pt === void 0 && (pt = M.length - 1), pt = Math.min(pt + 1, M.length - 1), {
      scrollHeight: De,
      start: Fe,
      end: pt,
      offset: ot
    };
  }, [E, O, T, M, ve, a]), $e = ge.scrollHeight, we = ge.start, _e = ge.end, ze = ge.offset;
  Z.current.start = we, Z.current.end = _e;
  var Te = s.useState({
    width: 0,
    height: a
  }), ke = Q(Te, 2), Le = ke[0], Ee = ke[1], xe = function(De) {
    Ee({
      width: De.width || De.offsetWidth,
      height: De.height || De.offsetHeight
    });
  }, he = Xe(), pe = Xe(), Pe = s.useMemo(function() {
    return Lg(Le.width, p);
  }, [Le.width, p]), Re = s.useMemo(function() {
    return Lg(Le.height, $e);
  }, [Le.height, $e]), at = $e - a, Ze = Xe(at);
  Ze.current = at;
  function Ie(Ne) {
    var De = Ne;
    return Number.isNaN(Ze.current) || (De = Math.min(De, Ze.current)), De = Math.max(De, 0), De;
  }
  var Be = T <= 0, bt = T >= at, He = My(Be, bt), nt = function() {
    return {
      x: I ? -A : A,
      y: T
    };
  }, et = Xe(nt()), Ge = Lt(function() {
    if (C) {
      var Ne = nt();
      (et.current.x !== Ne.x || et.current.y !== Ne.y) && (C(Ne), et.current = Ne);
    }
  });
  function Ae(Ne, De) {
    var Fe = Ne;
    De ? (bi(function() {
      B(Fe);
    }), Ge()) : re(Fe);
  }
  function qe(Ne) {
    var De = Ne.currentTarget.scrollTop;
    De !== T && re(De), y == null || y(Ne), Ge();
  }
  var Je = function(De) {
    var Fe = De, ot = p - Le.width;
    return Fe = Math.max(Fe, 0), Fe = Math.min(Fe, ot), Fe;
  }, Ke = Lt(function(Ne, De) {
    De ? (bi(function() {
      B(function(Fe) {
        var ot = Fe + (I ? -Ne : Ne);
        return Je(ot);
      });
    }), Ge()) : re(function(Fe) {
      var ot = Fe + Ne;
      return ot;
    });
  }), Ye = qM(O, Be, bt, !!p, Ke), Ve = Q(Ye, 2), Qe = Ve[0], it = Ve[1];
  UM(O, P, function(Ne, De) {
    return He(Ne, De) ? !1 : (Qe({
      preventDefault: function() {
      },
      deltaY: Ne
    }), !0);
  }), Pt(function() {
    function Ne(Fe) {
      O && Fe.preventDefault();
    }
    var De = P.current;
    return De.addEventListener("wheel", Qe), De.addEventListener("DOMMouseScroll", it), De.addEventListener("MozMousePixelScroll", Ne), function() {
      De.removeEventListener("wheel", Qe), De.removeEventListener("DOMMouseScroll", it), De.removeEventListener("MozMousePixelScroll", Ne);
    };
  }, [O]), Pt(function() {
    p && B(function(Ne) {
      return Je(Ne);
    });
  }, [Le.width, p]);
  var yt = function() {
    var De, Fe;
    (De = he.current) === null || De === void 0 || De.delayHidden(), (Fe = pe.current) === null || Fe === void 0 || Fe.delayHidden();
  }, Tt = VM(P, M, Se, i, X, function() {
    return me(!0);
  }, re, yt);
  s.useImperativeHandle(t, function() {
    return {
      getScrollInfo: nt,
      scrollTo: function(De) {
        function Fe(ot) {
          return ot && mt(ot) === "object" && ("left" in ot || "top" in ot);
        }
        Fe(De) ? (De.left !== void 0 && B(Je(De.left)), Tt(De.top)) : Tt(De);
      }
    };
  }), Pt(function() {
    if (S) {
      var Ne = M.slice(we, _e + 1);
      S(Ne, M);
    }
  }, [we, _e, M]);
  var ne = XM(M, X, Se, i), ye = x == null ? void 0 : x({
    start: we,
    end: _e,
    virtual: E,
    offsetX: A,
    offsetY: ze,
    rtl: I,
    getSize: ne
  }), ce = AM(M, we, _e, p, ie, f, W), Ce = null;
  a && (Ce = V(z({}, c ? "height" : "maxHeight", a), ZM), O && (Ce.overflowY = "hidden", p && (Ce.overflowX = "hidden"), G && (Ce.pointerEvents = "none")));
  var je = {};
  return I && (je.dir = "rtl"), /* @__PURE__ */ s.createElement("div", fe({
    style: V(V({}, u), {}, {
      position: "relative"
    }),
    className: k
  }, je, N), /* @__PURE__ */ s.createElement(Mn, {
    onResize: xe
  }, /* @__PURE__ */ s.createElement(b, {
    className: "".concat(r, "-holder"),
    style: Ce,
    ref: P,
    onScroll: qe,
    onMouseEnter: yt
  }, /* @__PURE__ */ s.createElement(Ry, {
    prefixCls: r,
    height: $e,
    offsetX: A,
    offsetY: ze,
    scrollWidth: p,
    onInnerResize: me,
    ref: _,
    innerProps: $,
    rtl: I,
    extra: ye
  }, ce))), E && $e > a && /* @__PURE__ */ s.createElement(Sd, {
    ref: he,
    prefixCls: r,
    scrollOffset: T,
    scrollRange: $e,
    rtl: I,
    onScroll: Ae,
    onStartMove: ee,
    onStopMove: oe,
    spinSize: Re,
    containerSize: Le.height,
    style: w == null ? void 0 : w.verticalScrollBar,
    thumbStyle: w == null ? void 0 : w.verticalScrollBarThumb
  }), E && p > Le.width && /* @__PURE__ */ s.createElement(Sd, {
    ref: pe,
    prefixCls: r,
    scrollOffset: A,
    scrollRange: p,
    rtl: I,
    onScroll: Ae,
    onStartMove: ee,
    onStopMove: oe,
    spinSize: Pe,
    containerSize: Le.width,
    horizontal: !0,
    style: w == null ? void 0 : w.horizontalScrollBar,
    thumbStyle: w == null ? void 0 : w.horizontalScrollBarThumb
  }));
}
var Us = /* @__PURE__ */ s.forwardRef(eT);
Us.displayName = "List";
function tT() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var nT = ["disabled", "title", "children", "style", "className"];
function Fg(e) {
  return typeof e == "string" || typeof e == "number";
}
var rT = function(t, n) {
  var r = Q2(), o = r.prefixCls, a = r.id, i = r.open, l = r.multiple, c = r.mode, u = r.searchValue, d = r.toggleOpen, f = r.notFoundContent, m = r.onPopupScroll, v = s.useContext(zf), h = v.maxCount, p = v.flattenOptions, g = v.onActiveValue, b = v.defaultActiveFirstOption, y = v.onSelect, C = v.menuItemSelectedIcon, S = v.rawValues, $ = v.fieldNames, x = v.virtual, w = v.direction, N = v.listHeight, O = v.listItemHeight, E = v.optionRender, I = "".concat(o, "-item"), k = Fo(function() {
    return p;
  }, [i, p], function(X, W) {
    return W[0] && X[1] !== W[1];
  }), M = s.useRef(null), P = s.useMemo(function() {
    return l && typeof h < "u" && (S == null ? void 0 : S.size) >= h;
  }, [l, h, S == null ? void 0 : S.size]), _ = function(W) {
    W.preventDefault();
  }, D = function(W) {
    var re;
    (re = M.current) === null || re === void 0 || re.scrollTo(typeof W == "number" ? {
      index: W
    } : W);
  }, R = function(W) {
    for (var re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, Z = k.length, H = 0; H < Z; H += 1) {
      var U = (W + H * re + Z) % Z, ae = k[U] || {}, ue = ae.group, de = ae.data;
      if (!ue && !(de != null && de.disabled) && !P)
        return U;
    }
    return -1;
  }, T = s.useState(function() {
    return R(0);
  }), L = Q(T, 2), F = L[0], j = L[1], A = function(W) {
    var re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    j(W);
    var Z = {
      source: re ? "keyboard" : "mouse"
    }, H = k[W];
    if (!H) {
      g(null, -1, Z);
      return;
    }
    g(H.value, W, Z);
  };
  Bt(function() {
    A(b !== !1 ? R(0) : -1);
  }, [k.length, u]);
  var B = s.useCallback(function(X) {
    return S.has(X) && c !== "combobox";
  }, [c, be(S).toString(), S.size]);
  Bt(function() {
    var X = setTimeout(function() {
      if (!l && i && S.size === 1) {
        var re = Array.from(S)[0], Z = k.findIndex(function(H) {
          var U = H.data;
          return U.value === re;
        });
        Z !== -1 && (A(Z), D(Z));
      }
    });
    if (i) {
      var W;
      (W = M.current) === null || W === void 0 || W.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(X);
    };
  }, [i, u]);
  var K = function(W) {
    W !== void 0 && y(W, {
      selected: !S.has(W)
    }), l || d(!1);
  };
  if (s.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(W) {
        var re = W.which, Z = W.ctrlKey;
        switch (re) {
          case Oe.N:
          case Oe.P:
          case Oe.UP:
          case Oe.DOWN: {
            var H = 0;
            if (re === Oe.UP ? H = -1 : re === Oe.DOWN ? H = 1 : tT() && Z && (re === Oe.N ? H = 1 : re === Oe.P && (H = -1)), H !== 0) {
              var U = R(F + H, H);
              D(U), A(U, !0);
            }
            break;
          }
          case Oe.ENTER: {
            var ae, ue = k[F];
            ue && !(ue != null && (ae = ue.data) !== null && ae !== void 0 && ae.disabled) && !P ? K(ue.value) : K(void 0), i && W.preventDefault();
            break;
          }
          case Oe.ESC:
            d(!1), i && W.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(W) {
        D(W);
      }
    };
  }), k.length === 0)
    return /* @__PURE__ */ s.createElement("div", {
      role: "listbox",
      id: "".concat(a, "_list"),
      className: "".concat(I, "-empty"),
      onMouseDown: _
    }, f);
  var Y = Object.keys($).map(function(X) {
    return $[X];
  }), G = function(W) {
    return W.label;
  };
  function te(X, W) {
    var re = X.group;
    return {
      role: re ? "presentation" : "option",
      id: "".concat(a, "_list_").concat(W)
    };
  }
  var ee = function(W) {
    var re = k[W];
    if (!re)
      return null;
    var Z = re.data || {}, H = Z.value, U = re.group, ae = Bn(Z, !0), ue = G(re);
    return re ? /* @__PURE__ */ s.createElement("div", fe({
      "aria-label": typeof ue == "string" && !U ? ue : null
    }, ae, {
      key: W
    }, te(re, W), {
      "aria-selected": B(H)
    }), H) : null;
  }, oe = {
    role: "listbox",
    id: "".concat(a, "_list")
  };
  return /* @__PURE__ */ s.createElement(s.Fragment, null, x && /* @__PURE__ */ s.createElement("div", fe({}, oe, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), ee(F - 1), ee(F), ee(F + 1)), /* @__PURE__ */ s.createElement(Us, {
    itemKey: "key",
    ref: M,
    data: k,
    height: N,
    itemHeight: O,
    fullHeight: !1,
    onMouseDown: _,
    onScroll: m,
    virtual: x,
    direction: w,
    innerProps: x ? null : oe
  }, function(X, W) {
    var re, Z = X.group, H = X.groupOption, U = X.data, ae = X.label, ue = X.value, de = U.key;
    if (Z) {
      var se, ie = (se = U.title) !== null && se !== void 0 ? se : Fg(ae) ? ae.toString() : void 0;
      return /* @__PURE__ */ s.createElement("div", {
        className: J(I, "".concat(I, "-group")),
        title: ie
      }, ae !== void 0 ? ae : de);
    }
    var me = U.disabled, Se = U.title;
    U.children;
    var ve = U.style, ge = U.className, $e = vt(U, nT), we = an($e, Y), _e = B(ue), ze = me || !_e && P, Te = "".concat(I, "-option"), ke = J(I, Te, ge, (re = {}, z(re, "".concat(Te, "-grouped"), H), z(re, "".concat(Te, "-active"), F === W && !ze), z(re, "".concat(Te, "-disabled"), ze), z(re, "".concat(Te, "-selected"), _e), re)), Le = G(X), Ee = !C || typeof C == "function" || _e, xe = typeof Le == "number" ? Le : Le || ue, he = Fg(xe) ? xe.toString() : void 0;
    return Se !== void 0 && (he = Se), /* @__PURE__ */ s.createElement("div", fe({}, Bn(we), x ? {} : te(X, W), {
      "aria-selected": _e,
      className: ke,
      title: he,
      onMouseMove: function() {
        F === W || ze || A(W);
      },
      onClick: function() {
        ze || K(ue);
      },
      style: ve
    }), /* @__PURE__ */ s.createElement("div", {
      className: "".concat(Te, "-content")
    }, typeof E == "function" ? E(X, {
      index: W
    }) : xe), /* @__PURE__ */ s.isValidElement(C) || _e, Ee && /* @__PURE__ */ s.createElement(Gs, {
      className: "".concat(I, "-option-state"),
      customizeIcon: C,
      customizeIconProps: {
        value: ue,
        disabled: ze,
        isSelected: _e
      }
    }, _e ? "✓" : null));
  }));
}, Ty = /* @__PURE__ */ s.forwardRef(rT);
process.env.NODE_ENV !== "production" && (Ty.displayName = "OptionList");
const oT = function(e, t) {
  var n = s.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), r = s.useMemo(function() {
    var a = n.current, i = a.values, l = a.options, c = e.map(function(f) {
      if (f.label === void 0) {
        var m;
        return V(V({}, f), {}, {
          label: (m = i.get(f.value)) === null || m === void 0 ? void 0 : m.label
        });
      }
      return f;
    }), u = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
    return c.forEach(function(f) {
      u.set(f.value, f), d.set(f.value, t.get(f.value) || l.get(f.value));
    }), n.current.values = u, n.current.options = d, c;
  }, [e, t]), o = s.useCallback(function(a) {
    return t.get(a) || n.current.options.get(a);
  }, [t]);
  return [r, o];
};
function Yc(e, t) {
  return jf(e).join("").toUpperCase().includes(t);
}
const aT = function(e, t, n, r, o) {
  return s.useMemo(function() {
    if (!n || r === !1)
      return e;
    var a = t.options, i = t.label, l = t.value, c = [], u = typeof r == "function", d = n.toUpperCase(), f = u ? r : function(v, h) {
      return o ? Yc(h[o], d) : h[a] ? Yc(h[i !== "children" ? i : "label"], d) : Yc(h[l], d);
    }, m = u ? function(v) {
      return Cd(v);
    } : function(v) {
      return v;
    };
    return e.forEach(function(v) {
      if (v[a]) {
        var h = f(n, m(v));
        if (h)
          c.push(v);
        else {
          var p = v[a].filter(function(g) {
            return f(n, m(g));
          });
          p.length && c.push(V(V({}, v), {}, z({}, a, p)));
        }
        return;
      }
      f(n, m(v)) && c.push(v);
    }), c;
  }, [e, r, o, n, t]);
};
var jg = 0, iT = process.env.NODE_ENV !== "test" && pn();
function lT() {
  var e;
  return iT ? (e = jg, jg += 1) : e = "TEST_OR_SSR", e;
}
function sT(e) {
  var t = s.useState(), n = Q(t, 2), r = n[0], o = n[1];
  return s.useEffect(function() {
    o("rc_select_".concat(lT()));
  }, []), e || r;
}
var cT = ["children", "value"], uT = ["children"];
function dT(e) {
  var t = e, n = t.key, r = t.props, o = r.children, a = r.value, i = vt(r, cT);
  return V({
    key: n,
    value: a !== void 0 ? a : n,
    children: o
  }, i);
}
function Hf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return Pn(e).map(function(n, r) {
    if (!/* @__PURE__ */ s.isValidElement(n) || !n.type)
      return null;
    var o = n, a = o.type.isSelectOptGroup, i = o.key, l = o.props, c = l.children, u = vt(l, uT);
    return t || !a ? dT(n) : V(V({
      key: "__RC_SELECT_GRP__".concat(i === null ? r : i, "__"),
      label: i
    }, u), {}, {
      options: Hf(c)
    });
  }).filter(function(n) {
    return n;
  });
}
var fT = function(t, n, r, o, a) {
  return s.useMemo(function() {
    var i = t, l = !t;
    l && (i = Hf(n));
    var c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), d = function(v, h, p) {
      p && typeof p == "string" && v.set(h[p], h);
    }, f = function m(v) {
      for (var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, p = 0; p < v.length; p += 1) {
        var g = v[p];
        !g[r.options] || h ? (c.set(g[r.value], g), d(u, g, r.label), d(u, g, o), d(u, g, a)) : m(g[r.options], !0);
      }
    };
    return f(i), {
      options: i,
      valueOptions: c,
      labelOptions: u
    };
  }, [t, n, r, o, a]);
};
function zg(e) {
  var t = s.useRef();
  t.current = e;
  var n = s.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return n;
}
function mT(e) {
  var t = e.mode, n = e.options, r = e.children, o = e.backfill, a = e.allowClear, i = e.placeholder, l = e.getInputElement, c = e.showSearch, u = e.onSearch, d = e.defaultOpen, f = e.autoFocus, m = e.labelInValue, v = e.value, h = e.inputValue, p = e.optionLabelProp, g = fs(t), b = c !== void 0 ? c : g || t === "combobox", y = n || Hf(r);
  if (tt(t !== "tags" || y.every(function(x) {
    return !x.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var C = y.some(function(x) {
      return x.options ? x.options.some(function(w) {
        return typeof ("value" in w ? w.value : w.key) == "number";
      }) : typeof ("value" in x ? x.value : x.key) == "number";
    });
    tt(!C, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (tt(t !== "combobox" || !p, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), tt(t === "combobox" || !o, "`backfill` only works with `combobox` mode."), tt(t === "combobox" || !l, "`getInputElement` only work with `combobox` mode."), Zl(t !== "combobox" || !l || !a || !i, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), u && !b && t !== "combobox" && t !== "tags" && tt(!1, "`onSearch` should work with `showSearch` instead of use alone."), Zl(!d || f, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), v != null) {
    var S = jf(v);
    tt(!m || S.every(function(x) {
      return mt(x) === "object" && ("key" in x || "value" in x);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), tt(!g || Array.isArray(v), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (r) {
    var $ = null;
    Pn(r).some(function(x) {
      if (!/* @__PURE__ */ s.isValidElement(x) || !x.type)
        return !1;
      var w = x, N = w.type;
      if (N.isSelectOption)
        return !1;
      if (N.isSelectOptGroup) {
        var O = Pn(x.props.children).every(function(E) {
          return !/* @__PURE__ */ s.isValidElement(E) || !x.type || E.type.isSelectOption ? !0 : ($ = E.type, !1);
        });
        return !O;
      }
      return $ = N, !0;
    }), $ && tt(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat($.displayName || $.name || $, "`.")), tt(h === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function vT(e, t) {
  if (e) {
    var n = function r(o) {
      for (var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = 0; i < o.length; i++) {
        var l = o[i];
        if (l[t == null ? void 0 : t.value] === null)
          return tt(!1, "`value` in Select options should not be `null`."), !0;
        if (!a && Array.isArray(l[t == null ? void 0 : t.options]) && r(l[t == null ? void 0 : t.options], !0))
          break;
      }
    };
    n(e);
  }
}
var gT = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], pT = ["inputValue"];
function hT(e) {
  return !e || mt(e) !== "object";
}
var _y = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.id, r = e.mode, o = e.prefixCls, a = o === void 0 ? "rc-select" : o, i = e.backfill, l = e.fieldNames, c = e.inputValue, u = e.searchValue, d = e.onSearch, f = e.autoClearSearchValue, m = f === void 0 ? !0 : f, v = e.onSelect, h = e.onDeselect, p = e.dropdownMatchSelectWidth, g = p === void 0 ? !0 : p, b = e.filterOption, y = e.filterSort, C = e.optionFilterProp, S = e.optionLabelProp, $ = e.options, x = e.optionRender, w = e.children, N = e.defaultActiveFirstOption, O = e.menuItemSelectedIcon, E = e.virtual, I = e.direction, k = e.listHeight, M = k === void 0 ? 200 : k, P = e.listItemHeight, _ = P === void 0 ? 20 : P, D = e.value, R = e.defaultValue, T = e.labelInValue, L = e.onChange, F = e.maxCount, j = vt(e, gT), A = sT(n), B = fs(r), K = !!(!$ && w), Y = s.useMemo(function() {
    return b === void 0 && r === "combobox" ? !1 : b;
  }, [b, r]), G = s.useMemo(
    function() {
      return Iy(l, K);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(l),
      K
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), te = Vt("", {
    value: u !== void 0 ? u : c,
    postState: function(Ye) {
      return Ye || "";
    }
  }), ee = Q(te, 2), oe = ee[0], X = ee[1], W = fT($, w, G, C, S), re = W.valueOptions, Z = W.labelOptions, H = W.options, U = s.useCallback(function(Ke) {
    var Ye = jf(Ke);
    return Ye.map(function(Ve) {
      var Qe, it, yt, Tt, ne;
      if (hT(Ve))
        Qe = Ve;
      else {
        var ye;
        yt = Ve.key, it = Ve.label, Qe = (ye = Ve.value) !== null && ye !== void 0 ? ye : yt;
      }
      var ce = re.get(Qe);
      if (ce) {
        var Ce;
        if (it === void 0 && (it = ce == null ? void 0 : ce[S || G.label]), yt === void 0 && (yt = (Ce = ce == null ? void 0 : ce.key) !== null && Ce !== void 0 ? Ce : Qe), Tt = ce == null ? void 0 : ce.disabled, ne = ce == null ? void 0 : ce.title, process.env.NODE_ENV !== "production" && !S) {
          var je = ce == null ? void 0 : ce[G.label];
          je !== void 0 && !/* @__PURE__ */ s.isValidElement(je) && !/* @__PURE__ */ s.isValidElement(it) && je !== it && tt(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: it,
        value: Qe,
        key: yt,
        disabled: Tt,
        title: ne
      };
    });
  }, [G, S, re]), ae = Vt(R, {
    value: D
  }), ue = Q(ae, 2), de = ue[0], se = ue[1], ie = s.useMemo(function() {
    var Ke, Ye = B && de === null ? [] : de, Ve = U(Ye);
    return r === "combobox" && gM((Ke = Ve[0]) === null || Ke === void 0 ? void 0 : Ke.value) ? [] : Ve;
  }, [de, U, r, B]), me = oT(ie, re), Se = Q(me, 2), ve = Se[0], ge = Se[1], $e = s.useMemo(function() {
    if (!r && ve.length === 1) {
      var Ke = ve[0];
      if (Ke.value === null && (Ke.label === null || Ke.label === void 0))
        return [];
    }
    return ve.map(function(Ye) {
      var Ve;
      return V(V({}, Ye), {}, {
        label: (Ve = Ye.label) !== null && Ve !== void 0 ? Ve : Ye.value
      });
    });
  }, [r, ve]), we = s.useMemo(function() {
    return new Set(ve.map(function(Ke) {
      return Ke.value;
    }));
  }, [ve]);
  s.useEffect(function() {
    if (r === "combobox") {
      var Ke, Ye = (Ke = ve[0]) === null || Ke === void 0 ? void 0 : Ke.value;
      X(vM(Ye) ? String(Ye) : "");
    }
  }, [ve]);
  var _e = zg(function(Ke, Ye) {
    var Ve, Qe = Ye ?? Ke;
    return Ve = {}, z(Ve, G.value, Ke), z(Ve, G.label, Qe), Ve;
  }), ze = s.useMemo(function() {
    if (r !== "tags")
      return H;
    var Ke = be(H), Ye = function(Qe) {
      return re.has(Qe);
    };
    return be(ve).sort(function(Ve, Qe) {
      return Ve.value < Qe.value ? -1 : 1;
    }).forEach(function(Ve) {
      var Qe = Ve.value;
      Ye(Qe) || Ke.push(_e(Qe, Ve.label));
    }), Ke;
  }, [_e, H, re, ve, r]), Te = aT(ze, G, oe, Y, C), ke = s.useMemo(function() {
    return r !== "tags" || !oe || Te.some(function(Ke) {
      return Ke[C || "value"] === oe;
    }) || Te.some(function(Ke) {
      return Ke[G.value] === oe;
    }) ? Te : [_e(oe)].concat(be(Te));
  }, [_e, C, r, Te, oe, G]), Le = s.useMemo(function() {
    return y ? be(ke).sort(function(Ke, Ye) {
      return y(Ke, Ye);
    }) : ke;
  }, [ke, y]), Ee = s.useMemo(function() {
    return kM(Le, {
      fieldNames: G,
      childrenAsData: K
    });
  }, [Le, G, K]), xe = function(Ye) {
    var Ve = U(Ye);
    if (se(Ve), L && // Trigger event only when value changed
    (Ve.length !== ve.length || Ve.some(function(yt, Tt) {
      var ne;
      return ((ne = ve[Tt]) === null || ne === void 0 ? void 0 : ne.value) !== (yt == null ? void 0 : yt.value);
    }))) {
      var Qe = T ? Ve : Ve.map(function(yt) {
        return yt.value;
      }), it = Ve.map(function(yt) {
        return Cd(ge(yt.value));
      });
      L(
        // Value
        B ? Qe : Qe[0],
        // Option
        B ? it : it[0]
      );
    }
  }, he = s.useState(null), pe = Q(he, 2), Pe = pe[0], Re = pe[1], at = s.useState(0), Ze = Q(at, 2), Ie = Ze[0], Be = Ze[1], bt = N !== void 0 ? N : r !== "combobox", He = s.useCallback(function(Ke, Ye) {
    var Ve = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Qe = Ve.source, it = Qe === void 0 ? "keyboard" : Qe;
    Be(Ye), i && r === "combobox" && Ke !== null && it === "keyboard" && Re(String(Ke));
  }, [i, r]), nt = function(Ye, Ve, Qe) {
    var it = function() {
      var Fe, ot = ge(Ye);
      return [T ? {
        label: ot == null ? void 0 : ot[G.label],
        value: Ye,
        key: (Fe = ot == null ? void 0 : ot.key) !== null && Fe !== void 0 ? Fe : Ye
      } : Ye, Cd(ot)];
    };
    if (Ve && v) {
      var yt = it(), Tt = Q(yt, 2), ne = Tt[0], ye = Tt[1];
      v(ne, ye);
    } else if (!Ve && h && Qe !== "clear") {
      var ce = it(), Ce = Q(ce, 2), je = Ce[0], Ne = Ce[1];
      h(je, Ne);
    }
  }, et = zg(function(Ke, Ye) {
    var Ve, Qe = B ? Ye.selected : !0;
    Qe ? Ve = B ? [].concat(be(ve), [Ke]) : [Ke] : Ve = ve.filter(function(it) {
      return it.value !== Ke;
    }), xe(Ve), nt(Ke, Qe), r === "combobox" ? Re("") : (!fs || m) && (X(""), Re(""));
  }), Ge = function(Ye, Ve) {
    xe(Ye);
    var Qe = Ve.type, it = Ve.values;
    (Qe === "remove" || Qe === "clear") && it.forEach(function(yt) {
      nt(yt.value, !1, Qe);
    });
  }, Ae = function(Ye, Ve) {
    if (X(Ye), Re(null), Ve.source === "submit") {
      var Qe = (Ye || "").trim();
      if (Qe) {
        var it = Array.from(new Set([].concat(be(we), [Qe])));
        xe(it), nt(Qe, !0), X("");
      }
      return;
    }
    Ve.source !== "blur" && (r === "combobox" && xe(Ye), d == null || d(Ye));
  }, qe = function(Ye) {
    var Ve = Ye;
    r !== "tags" && (Ve = Ye.map(function(it) {
      var yt = Z.get(it);
      return yt == null ? void 0 : yt.value;
    }).filter(function(it) {
      return it !== void 0;
    }));
    var Qe = Array.from(new Set([].concat(be(we), be(Ve))));
    xe(Qe), Qe.forEach(function(it) {
      nt(it, !0);
    });
  }, Je = s.useMemo(function() {
    var Ke = E !== !1 && g !== !1;
    return V(V({}, W), {}, {
      flattenOptions: Ee,
      onActiveValue: He,
      defaultActiveFirstOption: bt,
      onSelect: et,
      menuItemSelectedIcon: O,
      rawValues: we,
      fieldNames: G,
      virtual: Ke,
      direction: I,
      listHeight: M,
      listItemHeight: _,
      childrenAsData: K,
      maxCount: F,
      optionRender: x
    });
  }, [F, W, Ee, He, bt, et, O, we, G, E, g, I, M, _, K, x]);
  return process.env.NODE_ENV !== "production" && (mT(e), vT(H, G)), /* @__PURE__ */ s.createElement(zf.Provider, {
    value: Je
  }, /* @__PURE__ */ s.createElement(Py, fe({}, j, {
    // >>> MISC
    id: A,
    prefixCls: a,
    ref: t,
    omitDomProps: pT,
    mode: r,
    displayValues: $e,
    onDisplayValuesChange: Ge,
    direction: I,
    searchValue: oe,
    onSearch: Ae,
    autoClearSearchValue: m,
    onSearchSplit: qe,
    dropdownMatchSelectWidth: g,
    OptionList: Ty,
    emptyOptions: !Ee.length,
    activeValue: Pe,
    activeDescendantId: "".concat(A, "_list_").concat(Ie)
  })));
});
process.env.NODE_ENV !== "production" && (_y.displayName = "Select");
var Vf = _y;
Vf.Option = Bf;
Vf.OptGroup = Af;
function Sa(e, t, n) {
  return J({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const Xi = (e, t) => t || e, Dy = () => {
  const [, e] = Sn(), n = new Zt(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ s.createElement("svg", {
    style: n,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ s.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ s.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ s.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ s.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ s.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ s.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (Dy.displayName = "EmptyImage");
const bT = Dy, ky = () => {
  const [, e] = Sn(), {
    colorFill: t,
    colorFillTertiary: n,
    colorFillQuaternary: r,
    colorBgContainer: o
  } = e, {
    borderColor: a,
    shadowColor: i,
    contentColor: l
  } = nn(() => ({
    borderColor: new Zt(t).onBackground(o).toHexShortString(),
    shadowColor: new Zt(n).onBackground(o).toHexShortString(),
    contentColor: new Zt(r).onBackground(o).toHexShortString()
  }), [t, n, r, o]);
  return /* @__PURE__ */ s.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ s.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ s.createElement("ellipse", {
    fill: i,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ s.createElement("g", {
    fillRule: "nonzero",
    stroke: a
  }, /* @__PURE__ */ s.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: l
  }))));
};
process.env.NODE_ENV !== "production" && (ky.displayName = "SimpleImage");
const yT = ky, CT = (e) => {
  const {
    componentCls: t,
    margin: n,
    marginXS: r,
    marginXL: o,
    fontSize: a,
    lineHeight: i
  } = e;
  return {
    [t]: {
      marginInline: r,
      fontSize: a,
      lineHeight: i,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: r,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorText
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-footer`]: {
        marginTop: n
      },
      "&-normal": {
        marginBlock: o,
        color: e.colorTextDisabled,
        [`${t}-description`]: {
          color: e.colorTextDisabled
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: r,
        color: e.colorTextDisabled,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, ST = Xt("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    calc: r
  } = e, o = Dt(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: r(n).mul(2.5).equal(),
    emptyImgHeightMD: n,
    emptyImgHeightSM: r(n).mul(0.875).equal()
  });
  return [CT(o)];
});
var xT = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Ly = /* @__PURE__ */ s.createElement(bT, null), Fy = /* @__PURE__ */ s.createElement(yT, null), Ys = (e) => {
  var {
    className: t,
    rootClassName: n,
    prefixCls: r,
    image: o = Ly,
    description: a,
    children: i,
    imageStyle: l,
    style: c
  } = e, u = xT(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls: d,
    direction: f,
    empty: m
  } = s.useContext(lt), v = d("empty", r), [h, p, g] = ST(v), [b] = ur("Empty"), y = typeof a < "u" ? a : b == null ? void 0 : b.description, C = typeof y == "string" ? y : "empty";
  let S = null;
  return typeof o == "string" ? S = /* @__PURE__ */ s.createElement("img", {
    alt: C,
    src: o
  }) : S = o, h(/* @__PURE__ */ s.createElement("div", Object.assign({
    className: J(p, g, v, m == null ? void 0 : m.className, {
      [`${v}-normal`]: o === Fy,
      [`${v}-rtl`]: f === "rtl"
    }, t, n),
    style: Object.assign(Object.assign({}, m == null ? void 0 : m.style), c)
  }, u), /* @__PURE__ */ s.createElement("div", {
    className: `${v}-image`,
    style: l
  }, S), y && /* @__PURE__ */ s.createElement("div", {
    className: `${v}-description`
  }, y), i && /* @__PURE__ */ s.createElement("div", {
    className: `${v}-footer`
  }, i)));
};
Ys.PRESENTED_IMAGE_DEFAULT = Ly;
Ys.PRESENTED_IMAGE_SIMPLE = Fy;
process.env.NODE_ENV !== "production" && (Ys.displayName = "Empty");
const $o = Ys, $T = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: n
  } = qt(lt), r = n("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ le.createElement($o, {
        image: $o.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ le.createElement($o, {
        image: $o.PRESENTED_IMAGE_SIMPLE,
        className: `${r}-small`
      });
    default:
      return /* @__PURE__ */ le.createElement($o, null);
  }
}, jy = $T, wT = ["outlined", "borderless", "filled"], ET = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  const n = qt(q0);
  let r;
  typeof e < "u" ? r = e : t === !1 ? r = "borderless" : r = n ?? "outlined";
  const o = wT.includes(r);
  return [r, o];
}, Qi = ET, OT = (e) => {
  const n = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, n), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, n), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, n), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, n), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function NT(e, t) {
  return e || OT(t);
}
const Ag = (e) => {
  const {
    optionHeight: t,
    optionFontSize: n,
    optionLineHeight: r,
    optionPadding: o
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: o,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: n,
    lineHeight: r,
    boxSizing: "border-box"
  };
}, IT = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e, r = `${n}-item`, o = `&${t}-slide-up-enter${t}-slide-up-enter-active`, a = `&${t}-slide-up-appear${t}-slide-up-appear-active`, i = `&${t}-slide-up-leave${t}-slide-up-leave-active`, l = `${n}-dropdown-placement-`;
  return [
    {
      [`${n}-dropdown`]: Object.assign(Object.assign({}, Gt(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${o}${l}bottomLeft,
          ${a}${l}bottomLeft
        `]: {
          animationName: Hs
        },
        [`
          ${o}${l}topLeft,
          ${a}${l}topLeft,
          ${o}${l}topRight,
          ${a}${l}topRight
        `]: {
          animationName: Ws
        },
        [`${i}${l}bottomLeft`]: {
          animationName: Vs
        },
        [`
          ${i}${l}topLeft,
          ${i}${l}topRight
        `]: {
          animationName: Ks
        },
        "&-hidden": {
          display: "none"
        },
        [`${r}`]: Object.assign(Object.assign({}, Ag(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, Vr),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${r}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${r}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${r}-option-state`]: {
                color: e.colorPrimary
              },
              [`&:has(+ ${r}-option-selected:not(${r}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${r}-option-selected:not(${r}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${r}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, Ag(e)), {
            color: e.colorTextDisabled
          })
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    Rr(e, "slide-up"),
    Rr(e, "slide-down"),
    Ca(e, "move-up"),
    Ca(e, "move-down")
  ];
}, PT = IT, Zo = 2, RT = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: n,
    lineWidth: r
  } = e;
  return e.calc(n).sub(t).div(2).sub(r).equal();
}, Wf = (e, t) => {
  const {
    componentCls: n,
    iconCls: r
  } = e, o = `${n}-selection-overflow`, a = e.multipleSelectItemHeight, i = RT(e), l = t ? `${n}-${t}` : "";
  return {
    [`${n}-multiple${l}`]: {
      /**
       * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
       * may update to redesign with its align logic.
       */
      // =========================== Overflow ===========================
      [o]: {
        position: "relative",
        display: "flex",
        flex: "auto",
        flexWrap: "wrap",
        maxWidth: "100%",
        "&-item": {
          flex: "none",
          alignSelf: "center",
          maxWidth: "100%",
          display: "inline-flex"
        }
      },
      // ========================= Selector =========================
      [`${n}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: e.calc(Zo).mul(2).equal(),
        paddingBlock: e.calc(i).sub(Zo).equal(),
        borderRadius: e.borderRadius,
        [`${n}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${q(Zo)} 0`,
          lineHeight: q(a),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${n}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        height: a,
        marginTop: Zo,
        marginBottom: Zo,
        lineHeight: q(e.calc(a).sub(e.calc(e.lineWidth).mul(2)).equal()),
        borderRadius: e.borderRadiusSM,
        cursor: "default",
        transition: `font-size ${e.motionDurationSlow}, line-height ${e.motionDurationSlow}, height ${e.motionDurationSlow}`,
        marginInlineEnd: e.calc(Zo).mul(2).equal(),
        paddingInlineStart: e.paddingXS,
        paddingInlineEnd: e.calc(e.paddingXS).div(2).equal(),
        [`${n}-disabled&`]: {
          color: e.multipleItemColorDisabled,
          borderColor: e.multipleItemBorderColorDisabled,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(e.paddingXS).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, Li()), {
          display: "inline-flex",
          alignItems: "center",
          color: e.colorIcon,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${r}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: e.colorIconHover
          }
        })
      },
      // ========================== Input ==========================
      [`${o}-item + ${o}-item`]: {
        [`${n}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${o}-item-suffix`]: {
        height: "100%"
      },
      [`${n}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(i).equal(),
        [`
          &-input,
          &-mirror
        `]: {
          height: a,
          fontFamily: e.fontFamily,
          lineHeight: q(a),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    }
  };
};
function Xc(e, t) {
  const {
    componentCls: n
  } = e, r = t ? `${n}-${t}` : "", o = {
    [`${n}-multiple${r}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${n}-selector`]: {
        [`${n}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${n}-show-arrow ${n}-selector,
        &${n}-allow-clear ${n}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [Wf(e, t), o];
}
const MT = (e) => {
  const {
    componentCls: t
  } = e, n = Dt(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.controlHeightXS,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), r = Dt(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    Xc(e),
    // ======================== Small ========================
    Xc(n, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    Xc(r, "lg")
  ];
}, TT = MT;
function Qc(e, t) {
  const {
    componentCls: n,
    inputPaddingHorizontalBase: r,
    borderRadius: o
  } = e, a = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), i = t ? `${n}-${t}` : "";
  return {
    [`${n}-single${i}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${n}-selector`]: Object.assign(Object.assign({}, Gt(e, !0)), {
        display: "flex",
        borderRadius: o,
        [`${n}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: r,
          insetInlineEnd: r,
          bottom: 0,
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${n}-selection-item,
          ${n}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: q(a),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${n}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${n}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${n}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${n}-show-arrow ${n}-selection-item,
        &${n}-show-arrow ${n}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${n}-open ${n}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${n}-customize-input)`]: {
        [`${n}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${q(r)}`,
          [`${n}-selection-search-input`]: {
            height: a
          },
          "&:after": {
            lineHeight: q(a)
          }
        }
      },
      [`&${n}-customize-input`]: {
        [`${n}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${n}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${n}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${q(r)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function _T(e) {
  const {
    componentCls: t
  } = e, n = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    Qc(e),
    // ======================== Small ========================
    // Shared
    Qc(Dt(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selection-search`]: {
            insetInlineStart: n,
            insetInlineEnd: n
          },
          [`${t}-selector`]: {
            padding: `0 ${q(n)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(n).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    Qc(Dt(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const DT = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    controlHeight: r,
    controlPaddingHorizontal: o,
    zIndexPopupBase: a,
    colorText: i,
    fontWeightStrong: l,
    controlItemBgActive: c,
    controlItemBgHover: u,
    colorBgContainer: d,
    colorFillSecondary: f,
    controlHeightLG: m,
    controlHeightSM: v,
    colorBgContainerDisabled: h,
    colorTextDisabled: p
  } = e;
  return {
    zIndexPopup: a + 50,
    optionSelectedColor: i,
    optionSelectedFontWeight: l,
    optionSelectedBg: c,
    optionActiveBg: u,
    optionPadding: `${(r - t * n) / 2}px ${o}px`,
    optionFontSize: t,
    optionLineHeight: n,
    optionHeight: r,
    selectorBg: d,
    clearBg: d,
    singleItemHeightLG: m,
    multipleItemBg: f,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: v,
    multipleItemHeightLG: r,
    multipleSelectorBgDisabled: h,
    multipleItemColorDisabled: p,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25)
  };
}, zy = (e, t) => {
  const {
    componentCls: n,
    antCls: r,
    controlOutlineWidth: o
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      border: `${q(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${n}-focused& ${n}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${q(o)} ${t.activeShadowColor}`,
        outline: 0
      }
    }
  };
}, Bg = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, zy(e, t))
}), kT = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, zy(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.colorPrimaryHover,
    activeBorderColor: e.colorPrimary,
    activeShadowColor: e.controlOutline
  })), Bg(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeShadowColor: e.colorErrorOutline
  })), Bg(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeShadowColor: e.colorWarningOutline
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${q(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), Ay = (e, t) => {
  const {
    componentCls: n,
    antCls: r
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      background: t.bg,
      border: `${q(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        background: t.hoverBg
      },
      [`${n}-focused& ${n}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, Hg = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, Ay(e, t))
}), LT = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, Ay(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary,
    color: e.colorText
  })), Hg(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), Hg(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${q(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), FT = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${q(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  }
}), jT = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, kT(e)), LT(e)), FT(e))
}), zT = jT, AT = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, BT = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, HT = (e) => {
  const {
    antCls: t,
    componentCls: n,
    inputPaddingHorizontalBase: r,
    iconCls: o
  } = e;
  return {
    [n]: Object.assign(Object.assign({}, Gt(e)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${n}-customize-input) ${n}-selector`]: Object.assign(Object.assign({}, AT(e)), BT(e)),
      // ======================== Selection ========================
      [`${n}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, Vr), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: Object.assign(Object.assign({}, Vr), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${n}-arrow`]: Object.assign(Object.assign({}, Li()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [o]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${n}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${n}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${n}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      "&:hover": {
        [`${n}-clear`]: {
          opacity: 1
        },
        // Should use the following selector, but since `:has` has poor compatibility,
        // we use `:not(:last-child)` instead, which may cause some problems in some cases.
        // [`${componentCls}-arrow:has(+ ${componentCls}-clear)`]: {
        [`${n}-arrow:not(:last-child)`]: {
          opacity: 0
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${n}-has-feedback`]: {
      [`${n}-clear`]: {
        insetInlineEnd: e.calc(r).add(e.fontSize).add(e.paddingXS).equal()
      }
    }
  };
}, VT = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    HT(e),
    // Single
    _T(e),
    // Multiple
    TT(e),
    // Dropdown
    PT(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    zs(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, WT = Xt("Select", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = Dt(e, {
    rootPrefixCls: n,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [VT(r), zT(r)];
}, DT, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var KT = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const qT = KT;
var By = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: qT
  }));
};
process.env.NODE_ENV !== "production" && (By.displayName = "CheckOutlined");
const Kf = /* @__PURE__ */ s.forwardRef(By);
var GT = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const UT = GT;
var Hy = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: UT
  }));
};
process.env.NODE_ENV !== "production" && (Hy.displayName = "DownOutlined");
const Vy = /* @__PURE__ */ s.forwardRef(Hy);
var YT = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const XT = YT;
var Wy = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: XT
  }));
};
process.env.NODE_ENV !== "production" && (Wy.displayName = "SearchOutlined");
const qf = /* @__PURE__ */ s.forwardRef(Wy);
function Ky(e) {
  let {
    suffixIcon: t,
    clearIcon: n,
    menuItemSelectedIcon: r,
    removeIcon: o,
    loading: a,
    multiple: i,
    hasFeedback: l,
    prefixCls: c,
    showSuffixIcon: u,
    feedbackIcon: d,
    showArrow: f,
    componentName: m
  } = e;
  process.env.NODE_ENV !== "production" && Rt(m).deprecated(!n, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const v = n ?? /* @__PURE__ */ s.createElement(Bo, null), h = (y) => t === null && !l && !f ? null : /* @__PURE__ */ s.createElement(s.Fragment, null, u !== !1 && y, l && d);
  let p = null;
  if (t !== void 0)
    p = h(t);
  else if (a)
    p = h(/* @__PURE__ */ s.createElement(To, {
      spin: !0
    }));
  else {
    const y = `${c}-suffix`;
    p = (C) => {
      let {
        open: S,
        showSearch: $
      } = C;
      return h(S && $ ? /* @__PURE__ */ s.createElement(qf, {
        className: y
      }) : /* @__PURE__ */ s.createElement(Vy, {
        className: y
      }));
    };
  }
  let g = null;
  r !== void 0 ? g = r : i ? g = /* @__PURE__ */ s.createElement(Kf, null) : g = null;
  let b = null;
  return o !== void 0 ? b = o : b = /* @__PURE__ */ s.createElement(mo, null), {
    clearIcon: v,
    suffixIcon: p,
    itemIcon: g,
    removeIcon: b
  };
}
function QT(e, t) {
  return t !== void 0 ? t : e !== null;
}
var JT = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const qy = "SECRET_COMBOBOX_MODE_DO_NOT_USE", Gy = (e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: o,
    className: a,
    rootClassName: i,
    getPopupContainer: l,
    popupClassName: c,
    dropdownClassName: u,
    listHeight: d = 256,
    placement: f,
    listItemHeight: m,
    size: v,
    disabled: h,
    notFoundContent: p,
    status: g,
    builtinPlacements: b,
    dropdownMatchSelectWidth: y,
    popupMatchSelectWidth: C,
    direction: S,
    style: $,
    allowClear: x,
    variant: w,
    dropdownStyle: N,
    transitionName: O,
    tagRender: E,
    maxCount: I
  } = e, k = JT(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount"]), {
    getPopupContainer: M,
    getPrefixCls: P,
    renderEmpty: _,
    direction: D,
    virtual: R,
    popupMatchSelectWidth: T,
    popupOverflow: L,
    select: F
  } = s.useContext(lt), [, j] = Sn(), A = m ?? (j == null ? void 0 : j.controlHeight), B = P("select", r), K = P(), Y = S ?? D, {
    compactSize: G,
    compactItemClassnames: te
  } = Ho(B, Y), [ee, oe] = Qi(w, o), X = En(B), [W, re, Z] = WT(B, X), H = s.useMemo(() => {
    const {
      mode: Re
    } = e;
    if (Re !== "combobox")
      return Re === qy ? "combobox" : Re;
  }, [e.mode]), U = H === "multiple" || H === "tags", ae = QT(e.suffixIcon, e.showArrow), ue = (n = C ?? y) !== null && n !== void 0 ? n : T, {
    status: de,
    hasFeedback: se,
    isFormItemInput: ie,
    feedbackIcon: me
  } = s.useContext(Tn), Se = Xi(de, g);
  let ve;
  p !== void 0 ? ve = p : H === "combobox" ? ve = null : ve = (_ == null ? void 0 : _("Select")) || /* @__PURE__ */ s.createElement(jy, {
    componentName: "Select"
  });
  const {
    suffixIcon: ge,
    itemIcon: $e,
    removeIcon: we,
    clearIcon: _e
  } = Ky(Object.assign(Object.assign({}, k), {
    multiple: U,
    hasFeedback: se,
    feedbackIcon: me,
    showSuffixIcon: ae,
    prefixCls: B,
    componentName: "Select"
  })), ze = x === !0 ? {
    clearIcon: _e
  } : x, Te = an(k, ["suffixIcon", "itemIcon"]), ke = J(c || u, {
    [`${B}-dropdown-${Y}`]: Y === "rtl"
  }, i, Z, X, re), Le = qn((Re) => {
    var at;
    return (at = v ?? G) !== null && at !== void 0 ? at : Re;
  }), Ee = s.useContext(dr), xe = h ?? Ee, he = J({
    [`${B}-lg`]: Le === "large",
    [`${B}-sm`]: Le === "small",
    [`${B}-rtl`]: Y === "rtl",
    [`${B}-${ee}`]: oe,
    [`${B}-in-form-item`]: ie
  }, Sa(B, Se, se), te, F == null ? void 0 : F.className, a, i, Z, X, re), pe = s.useMemo(() => f !== void 0 ? f : Y === "rtl" ? "bottomRight" : "bottomLeft", [f, Y]);
  if (process.env.NODE_ENV !== "production") {
    const Re = Rt("Select");
    Re.deprecated(!u, "dropdownClassName", "popupClassName"), Re.deprecated(y === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && Re(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), Re.deprecated(!("bordered" in e), "bordered", "variant"), process.env.NODE_ENV !== "production" && Re(!(typeof I < "u" && !U), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [Pe] = vo("SelectLike", N == null ? void 0 : N.zIndex);
  return W(/* @__PURE__ */ s.createElement(Vf, Object.assign({
    ref: t,
    virtual: R,
    showSearch: F == null ? void 0 : F.showSearch
  }, Te, {
    style: Object.assign(Object.assign({}, F == null ? void 0 : F.style), $),
    dropdownMatchSelectWidth: ue,
    transitionName: Pr(K, "slide-up", O),
    builtinPlacements: NT(b, L),
    listHeight: d,
    listItemHeight: A,
    mode: H,
    prefixCls: B,
    placement: pe,
    direction: Y,
    suffixIcon: ge,
    menuItemSelectedIcon: $e,
    removeIcon: we,
    allowClear: ze,
    notFoundContent: ve,
    className: he,
    getPopupContainer: l || M,
    dropdownClassName: ke,
    disabled: xe,
    dropdownStyle: Object.assign(Object.assign({}, N), {
      zIndex: Pe
    }),
    maxCount: U ? I : void 0,
    tagRender: U ? E : void 0
  })));
};
process.env.NODE_ENV !== "production" && (Gy.displayName = "Select");
const Vo = /* @__PURE__ */ s.forwardRef(Gy), ZT = qs(Vo);
Vo.SECRET_COMBOBOX_MODE_DO_NOT_USE = qy;
Vo.Option = Bf;
Vo.OptGroup = Af;
Vo._InternalPanelDoNotUseOrYouWillBeFired = ZT;
process.env.NODE_ENV !== "production" && (Vo.displayName = "Select");
const po = Vo, Mi = ["xxl", "xl", "lg", "md", "sm", "xs"], e_ = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`
}), t_ = (e) => {
  const t = e, n = [].concat(Mi).reverse();
  return n.forEach((r, o) => {
    const a = r.toUpperCase(), i = `screen${a}Min`, l = `screen${a}`;
    if (!(t[i] <= t[l]))
      throw new Error(`${i}<=${l} fails : !(${t[i]}<=${t[l]})`);
    if (o < n.length - 1) {
      const c = `screen${a}Max`;
      if (!(t[l] <= t[c]))
        throw new Error(`${l}<=${c} fails : !(${t[l]}<=${t[c]})`);
      const d = `screen${n[o + 1].toUpperCase()}Min`;
      if (!(t[c] <= t[d]))
        throw new Error(`${c}<=${d} fails : !(${t[c]}<=${t[d]})`);
    }
  }), e;
};
function Uy() {
  const [, e] = Sn(), t = e_(t_(e));
  return le.useMemo(() => {
    const n = /* @__PURE__ */ new Map();
    let r = -1, o = {};
    return {
      matchHandlers: {},
      dispatch(a) {
        return o = a, n.forEach((i) => i(o)), n.size >= 1;
      },
      subscribe(a) {
        return n.size || this.register(), r += 1, n.set(r, a), a(o), r;
      },
      unsubscribe(a) {
        n.delete(a), n.size || this.unregister();
      },
      unregister() {
        Object.keys(t).forEach((a) => {
          const i = t[a], l = this.matchHandlers[i];
          l == null || l.mql.removeListener(l == null ? void 0 : l.listener);
        }), n.clear();
      },
      register() {
        Object.keys(t).forEach((a) => {
          const i = t[a], l = (u) => {
            let {
              matches: d
            } = u;
            this.dispatch(Object.assign(Object.assign({}, o), {
              [a]: d
            }));
          }, c = window.matchMedia(i);
          c.addListener(l), this.matchHandlers[i] = {
            mql: c,
            listener: l
          }, l(c);
        });
      },
      responsiveMap: t
    };
  }, [e]);
}
function Gf() {
  const [, e] = s.useReducer((t) => t + 1, 0);
  return e;
}
function Yy() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  const t = Xe({}), n = Gf(), r = Uy();
  return Pt(() => {
    const o = r.subscribe((a) => {
      t.current = a, e && n();
    });
    return () => r.unsubscribe(o);
  }, []), t.current;
}
const xa = (e) => e ? typeof e == "function" ? e() : e : null;
function Uf(e) {
  var t = e.children, n = e.prefixCls, r = e.id, o = e.overlayInnerStyle, a = e.className, i = e.style;
  return /* @__PURE__ */ s.createElement("div", {
    className: J("".concat(n, "-content"), a),
    style: i
  }, /* @__PURE__ */ s.createElement("div", {
    className: "".concat(n, "-inner"),
    id: r,
    role: "tooltip",
    style: o
  }, typeof t == "function" ? t() : t));
}
var ea = {
  shiftX: 64,
  adjustY: 1
}, ta = {
  adjustX: 1,
  shiftY: !0
}, lr = [0, 0], n_ = {
  left: {
    points: ["cr", "cl"],
    overflow: ta,
    offset: [-4, 0],
    targetOffset: lr
  },
  right: {
    points: ["cl", "cr"],
    overflow: ta,
    offset: [4, 0],
    targetOffset: lr
  },
  top: {
    points: ["bc", "tc"],
    overflow: ea,
    offset: [0, -4],
    targetOffset: lr
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: ea,
    offset: [0, 4],
    targetOffset: lr
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: ea,
    offset: [0, -4],
    targetOffset: lr
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: ta,
    offset: [-4, 0],
    targetOffset: lr
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ea,
    offset: [0, -4],
    targetOffset: lr
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: ta,
    offset: [4, 0],
    targetOffset: lr
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ea,
    offset: [0, 4],
    targetOffset: lr
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: ta,
    offset: [4, 0],
    targetOffset: lr
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ea,
    offset: [0, 4],
    targetOffset: lr
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: ta,
    offset: [-4, 0],
    targetOffset: lr
  }
}, r_ = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], o_ = function(t, n) {
  var r = t.overlayClassName, o = t.trigger, a = o === void 0 ? ["hover"] : o, i = t.mouseEnterDelay, l = i === void 0 ? 0 : i, c = t.mouseLeaveDelay, u = c === void 0 ? 0.1 : c, d = t.overlayStyle, f = t.prefixCls, m = f === void 0 ? "rc-tooltip" : f, v = t.children, h = t.onVisibleChange, p = t.afterVisibleChange, g = t.transitionName, b = t.animation, y = t.motion, C = t.placement, S = C === void 0 ? "right" : C, $ = t.align, x = $ === void 0 ? {} : $, w = t.destroyTooltipOnHide, N = w === void 0 ? !1 : w, O = t.defaultVisible, E = t.getTooltipContainer, I = t.overlayInnerStyle;
  t.arrowContent;
  var k = t.overlay, M = t.id, P = t.showArrow, _ = P === void 0 ? !0 : P, D = vt(t, r_), R = Xe(null);
  qr(n, function() {
    return R.current;
  });
  var T = V({}, D);
  "visible" in t && (T.popupVisible = t.visible);
  var L = function() {
    return /* @__PURE__ */ s.createElement(Uf, {
      key: "content",
      prefixCls: m,
      id: M,
      overlayInnerStyle: I
    }, k);
  };
  return /* @__PURE__ */ s.createElement(Yi, fe({
    popupClassName: r,
    prefixCls: m,
    popup: L,
    action: a,
    builtinPlacements: n_,
    popupPlacement: S,
    ref: R,
    popupAlign: x,
    getPopupContainer: E,
    onPopupVisibleChange: h,
    afterPopupVisibleChange: p,
    popupTransitionName: g,
    popupAnimation: b,
    popupMotion: y,
    defaultPopupVisible: O,
    autoDestroy: N,
    mouseLeaveDelay: u,
    popupStyle: d,
    mouseEnterDelay: l,
    arrow: _
  }, T), v);
};
const a_ = /* @__PURE__ */ ar(o_);
function Xs(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: n,
    borderRadiusOuter: r
  } = e, o = t / 2, a = 0, i = o, l = r * 1 / Math.sqrt(2), c = o - r * (1 - 1 / Math.sqrt(2)), u = o - n * (1 / Math.sqrt(2)), d = r * (Math.sqrt(2) - 1) + n * (1 / Math.sqrt(2)), f = 2 * o - u, m = d, v = 2 * o - l, h = c, p = 2 * o - a, g = i, b = o * Math.sqrt(2) + r * (Math.sqrt(2) - 2), y = r * (Math.sqrt(2) - 1), C = `polygon(${y}px 100%, 50% ${y}px, ${2 * o - y}px 100%, ${y}px 100%)`, S = `path('M ${a} ${i} A ${r} ${r} 0 0 0 ${l} ${c} L ${u} ${d} A ${n} ${n} 0 0 1 ${f} ${m} L ${v} ${h} A ${r} ${r} 0 0 0 ${p} ${g} Z')`;
  return {
    arrowShadowWidth: b,
    arrowPath: S,
    arrowPolygon: C
  };
}
const Xy = (e, t, n) => {
  const {
    sizePopupArrow: r,
    arrowPolygon: o,
    arrowPath: a,
    arrowShadowWidth: i,
    borderRadiusXS: l,
    calc: c
  } = e;
  return {
    pointerEvents: "none",
    width: r,
    height: r,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: r,
      height: c(r).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [o, a]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: i,
      height: i,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${q(l)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: n,
      zIndex: 0,
      background: "transparent"
    }
  };
}, Qy = 8;
function Qs(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: n
  } = e, r = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: r,
    arrowOffsetVertical: n ? Qy : r
  };
}
function xl(e, t) {
  return e ? t : {};
}
function Yf(e, t, n) {
  const {
    componentCls: r,
    boxShadowPopoverArrow: o,
    arrowOffsetVertical: a,
    arrowOffsetHorizontal: i
  } = e, {
    arrowDistance: l = 0,
    arrowPlacement: c = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = n || {};
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${r}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, Xy(e, t, o)), {
        "&:before": {
          background: t
        }
      })]
    }, xl(!!c.top, {
      [[`&-placement-top > ${r}-arrow`, `&-placement-topLeft > ${r}-arrow`, `&-placement-topRight > ${r}-arrow`].join(",")]: {
        bottom: l,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: i
        }
      },
      [`&-placement-topRight > ${r}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: i
        }
      }
    })), xl(!!c.bottom, {
      [[`&-placement-bottom > ${r}-arrow`, `&-placement-bottomLeft > ${r}-arrow`, `&-placement-bottomRight > ${r}-arrow`].join(",")]: {
        top: l,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: i
        }
      },
      [`&-placement-bottomRight > ${r}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: i
        }
      }
    })), xl(!!c.left, {
      [[`&-placement-left > ${r}-arrow`, `&-placement-leftTop > ${r}-arrow`, `&-placement-leftBottom > ${r}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: l
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${r}-arrow`]: {
        top: a
      },
      [`&-placement-leftBottom > ${r}-arrow`]: {
        bottom: a
      }
    })), xl(!!c.right, {
      [[`&-placement-right > ${r}-arrow`, `&-placement-rightTop > ${r}-arrow`, `&-placement-rightBottom > ${r}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: l
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${r}-arrow`]: {
        top: a
      },
      [`&-placement-rightBottom > ${r}-arrow`]: {
        bottom: a
      }
    }))
  };
}
function i_(e, t, n, r) {
  if (r === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const o = r && typeof r == "object" ? r : {}, a = {};
  switch (e) {
    case "top":
    case "bottom":
      a.shiftX = t.arrowOffsetHorizontal * 2 + n, a.shiftY = !0, a.adjustY = !0;
      break;
    case "left":
    case "right":
      a.shiftY = t.arrowOffsetVertical * 2 + n, a.shiftX = !0, a.adjustX = !0;
      break;
  }
  const i = Object.assign(Object.assign({}, a), o);
  return i.shiftX || (i.adjustX = !0), i.shiftY || (i.adjustY = !0), i;
}
const Vg = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, l_ = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, s_ = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function Jy(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: n,
    arrowPointAtCenter: r,
    offset: o,
    borderRadius: a,
    visibleFirst: i
  } = e, l = t / 2, c = {};
  return Object.keys(Vg).forEach((u) => {
    const d = r && l_[u] || Vg[u], f = Object.assign(Object.assign({}, d), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (c[u] = f, s_.has(u) && (f.autoArrow = !1), u) {
      case "top":
      case "topLeft":
      case "topRight":
        f.offset[1] = -l - o;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        f.offset[1] = l + o;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        f.offset[0] = -l - o;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        f.offset[0] = l + o;
        break;
    }
    const m = Qs({
      contentRadius: a,
      limitVerticalRadius: !0
    });
    if (r)
      switch (u) {
        case "topLeft":
        case "bottomLeft":
          f.offset[0] = -m.arrowOffsetHorizontal - l;
          break;
        case "topRight":
        case "bottomRight":
          f.offset[0] = m.arrowOffsetHorizontal + l;
          break;
        case "leftTop":
        case "rightTop":
          f.offset[1] = -m.arrowOffsetHorizontal - l;
          break;
        case "leftBottom":
        case "rightBottom":
          f.offset[1] = m.arrowOffsetHorizontal + l;
          break;
      }
    f.overflow = i_(u, m, t, n), i && (f.htmlRegion = "visibleFirst");
  }), c;
}
const c_ = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: n,
    tooltipColor: r,
    tooltipBg: o,
    tooltipBorderRadius: a,
    zIndexPopup: i,
    controlHeight: l,
    boxShadowSecondary: c,
    paddingSM: u,
    paddingXS: d
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Gt(e)), {
        position: "absolute",
        zIndex: i,
        display: "block",
        width: "max-content",
        maxWidth: n,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": o,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: l,
          minHeight: l,
          padding: `${q(e.calc(u).div(2).equal())} ${q(d)}`,
          color: r,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: o,
          borderRadius: a,
          boxShadow: c,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(a, Qy)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), Ab(e, (f, m) => {
        let {
          darkColor: v
        } = m;
        return {
          [`&${t}-${f}`]: {
            [`${t}-inner`]: {
              backgroundColor: v
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": v
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    Yf(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, u_ = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, Qs({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), Xs(Dt(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), Zy = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Xt("Tooltip", (r) => {
    const {
      borderRadius: o,
      colorTextLightSolid: a,
      colorBgSpotlight: i
    } = r, l = Dt(r, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: a,
      tooltipBorderRadius: o,
      tooltipBg: i
    });
    return [c_(l), Ki(r, "zoom-big-fast")];
  }, u_, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, d_ = Oi.map((e) => `${e}-inverse`), f_ = ["success", "processing", "error", "default", "warning"];
function eC(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(be(d_), be(Oi)).includes(e) : Oi.includes(e);
}
function m_(e) {
  return f_.includes(e);
}
function tC(e, t) {
  const n = eC(t), r = J({
    [`${e}-${t}`]: t && n
  }), o = {}, a = {};
  return t && !n && (o.background = t, a["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: o,
    arrowStyle: a
  };
}
const v_ = (e) => {
  const {
    prefixCls: t,
    className: n,
    placement: r = "top",
    title: o,
    color: a,
    overlayInnerStyle: i
  } = e, {
    getPrefixCls: l
  } = s.useContext(lt), c = l("tooltip", t), [u, d, f] = Zy(c), m = tC(c, a), v = m.arrowStyle, h = Object.assign(Object.assign({}, i), m.overlayStyle), p = J(d, f, c, `${c}-pure`, `${c}-placement-${r}`, n, m.className);
  return u(/* @__PURE__ */ s.createElement("div", {
    className: p,
    style: v
  }, /* @__PURE__ */ s.createElement("div", {
    className: `${c}-arrow`
  }), /* @__PURE__ */ s.createElement(Uf, Object.assign({}, e, {
    className: d,
    prefixCls: c,
    overlayInnerStyle: h
  }), o)));
}, g_ = v_;
var p_ = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Xf = /* @__PURE__ */ s.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: o,
    openClassName: a,
    getTooltipContainer: i,
    overlayClassName: l,
    color: c,
    overlayInnerStyle: u,
    children: d,
    afterOpenChange: f,
    afterVisibleChange: m,
    destroyTooltipOnHide: v,
    arrow: h = !0,
    title: p,
    overlay: g,
    builtinPlacements: b,
    arrowPointAtCenter: y = !1,
    autoAdjustOverflow: C = !0
  } = e, S = !!h, [, $] = Sn(), {
    getPopupContainer: x,
    getPrefixCls: w,
    direction: N
  } = s.useContext(lt), O = Rt("Tooltip"), E = s.useRef(null), I = () => {
    var ve;
    (ve = E.current) === null || ve === void 0 || ve.forceAlign();
  };
  s.useImperativeHandle(t, () => ({
    forceAlign: I,
    forcePopupAlign: () => {
      O.deprecated(!1, "forcePopupAlign", "forceAlign"), I();
    }
  })), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((ve) => {
    let [ge, $e] = ve;
    O.deprecated(!(ge in e), ge, $e);
  }), process.env.NODE_ENV !== "production" && O(!v || typeof v == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && O(!h || typeof h == "boolean" || !("arrowPointAtCenter" in h), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [k, M] = Vt(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), P = !p && !g && p !== 0, _ = (ve) => {
    var ge, $e;
    M(P ? !1 : ve), P || ((ge = e.onOpenChange) === null || ge === void 0 || ge.call(e, ve), ($e = e.onVisibleChange) === null || $e === void 0 || $e.call(e, ve));
  }, D = s.useMemo(() => {
    var ve, ge;
    let $e = y;
    return typeof h == "object" && ($e = (ge = (ve = h.pointAtCenter) !== null && ve !== void 0 ? ve : h.arrowPointAtCenter) !== null && ge !== void 0 ? ge : y), b || Jy({
      arrowPointAtCenter: $e,
      autoAdjustOverflow: C,
      arrowWidth: S ? $.sizePopupArrow : 0,
      borderRadius: $.borderRadius,
      offset: $.marginXXS,
      visibleFirst: !0
    });
  }, [y, h, b, $]), R = s.useMemo(() => p === 0 ? p : g || p || "", [g, p]), T = /* @__PURE__ */ s.createElement(so, null, typeof R == "function" ? R() : R), {
    getPopupContainer: L,
    placement: F = "top",
    mouseEnterDelay: j = 0.1,
    mouseLeaveDelay: A = 0.1,
    overlayStyle: B,
    rootClassName: K
  } = e, Y = p_(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), G = w("tooltip", o), te = w(), ee = e["data-popover-inject"];
  let oe = k;
  !("open" in e) && !("visible" in e) && P && (oe = !1);
  const X = Kn(d) && !f0(d) ? d : /* @__PURE__ */ s.createElement("span", null, d), W = X.props, re = !W.className || typeof W.className == "string" ? J(W.className, a || `${G}-open`) : W.className, [Z, H, U] = Zy(G, !ee), ae = tC(G, c), ue = ae.arrowStyle, de = Object.assign(Object.assign({}, u), ae.overlayStyle), se = J(l, {
    [`${G}-rtl`]: N === "rtl"
  }, ae.className, K, H, U), [ie, me] = vo("Tooltip", Y.zIndex), Se = /* @__PURE__ */ s.createElement(a_, Object.assign({}, Y, {
    zIndex: ie,
    showArrow: S,
    placement: F,
    mouseEnterDelay: j,
    mouseLeaveDelay: A,
    prefixCls: G,
    overlayClassName: se,
    overlayStyle: Object.assign(Object.assign({}, ue), B),
    getTooltipContainer: L || i || x,
    ref: E,
    builtinPlacements: D,
    overlay: T,
    visible: oe,
    onVisibleChange: _,
    afterVisibleChange: f ?? m,
    overlayInnerStyle: de,
    arrowContent: /* @__PURE__ */ s.createElement("span", {
      className: `${G}-arrow-content`
    }),
    motion: {
      motionName: Pr(te, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!v
  }), oe ? xn(X, {
    className: re
  }) : X);
  return Z(/* @__PURE__ */ s.createElement(ji.Provider, {
    value: me
  }, Se));
});
process.env.NODE_ENV !== "production" && (Xf.displayName = "Tooltip");
Xf._InternalPanelDoNotUseOrYouWillBeFired = g_;
const Mr = Xf, h_ = (e) => {
  const {
    componentCls: t,
    popoverColor: n,
    titleMinWidth: r,
    fontWeightStrong: o,
    innerPadding: a,
    boxShadowSecondary: i,
    colorTextHeading: l,
    borderRadiusLG: c,
    zIndexPopup: u,
    titleMarginBottom: d,
    colorBgElevated: f,
    popoverBg: m,
    titleBorderBottom: v,
    innerContentPadding: h,
    titlePadding: p
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Gt(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: u,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "--antd-arrow-background-color": f,
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${t}-content`]: {
          position: "relative"
        },
        [`${t}-inner`]: {
          backgroundColor: m,
          backgroundClip: "padding-box",
          borderRadius: c,
          boxShadow: i,
          padding: a
        },
        [`${t}-title`]: {
          minWidth: r,
          marginBottom: d,
          color: l,
          fontWeight: o,
          borderBottom: v,
          padding: p
        },
        [`${t}-inner-content`]: {
          color: n,
          padding: h
        }
      })
    },
    // Arrow Style
    Yf(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${t}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, b_ = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Oi.map((n) => {
      const r = e[`${n}6`];
      return {
        [`&${t}-${n}`]: {
          "--antd-arrow-background-color": r,
          [`${t}-inner`]: {
            backgroundColor: r
          },
          [`${t}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, y_ = (e) => {
  const {
    lineWidth: t,
    controlHeight: n,
    fontHeight: r,
    padding: o,
    wireframe: a,
    zIndexPopupBase: i,
    borderRadiusLG: l,
    marginXS: c,
    lineType: u,
    colorSplit: d,
    paddingSM: f
  } = e, m = n - r, v = m / 2, h = m / 2 - t, p = o;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: i + 30
  }, Xs(e)), Qs({
    contentRadius: l,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: a ? 0 : 12,
    titleMarginBottom: a ? 0 : c,
    titlePadding: a ? `${v}px ${p}px ${h}px` : 0,
    titleBorderBottom: a ? `${t}px ${u} ${d}` : "none",
    innerContentPadding: a ? `${f}px ${p}px` : 0
  });
}, nC = Xt("Popover", (e) => {
  const {
    colorBgElevated: t,
    colorText: n
  } = e, r = Dt(e, {
    popoverBg: t,
    popoverColor: n
  });
  return [h_(r), b_(r), Ki(r, "zoom-big")];
}, y_, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var C_ = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const S_ = (e, t, n) => !t && !n ? null : /* @__PURE__ */ s.createElement(s.Fragment, null, t && /* @__PURE__ */ s.createElement("div", {
  className: `${e}-title`
}, xa(t)), /* @__PURE__ */ s.createElement("div", {
  className: `${e}-inner-content`
}, xa(n))), x_ = (e) => {
  const {
    hashId: t,
    prefixCls: n,
    className: r,
    style: o,
    placement: a = "top",
    title: i,
    content: l,
    children: c
  } = e;
  return /* @__PURE__ */ s.createElement("div", {
    className: J(t, n, `${n}-pure`, `${n}-placement-${a}`, r),
    style: o
  }, /* @__PURE__ */ s.createElement("div", {
    className: `${n}-arrow`
  }), /* @__PURE__ */ s.createElement(Uf, Object.assign({}, e, {
    className: t,
    prefixCls: n
  }), c || S_(n, i, l)));
}, $_ = (e) => {
  const {
    prefixCls: t,
    className: n
  } = e, r = C_(e, ["prefixCls", "className"]), {
    getPrefixCls: o
  } = s.useContext(lt), a = o("popover", t), [i, l, c] = nC(a);
  return i(/* @__PURE__ */ s.createElement(x_, Object.assign({}, r, {
    prefixCls: a,
    hashId: l,
    className: J(n, c)
  })));
}, rC = $_;
var w_ = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const E_ = (e) => {
  let {
    title: t,
    content: n,
    prefixCls: r
  } = e;
  return /* @__PURE__ */ s.createElement(s.Fragment, null, t && /* @__PURE__ */ s.createElement("div", {
    className: `${r}-title`
  }, xa(t)), /* @__PURE__ */ s.createElement("div", {
    className: `${r}-inner-content`
  }, xa(n)));
}, Qf = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    title: r,
    content: o,
    overlayClassName: a,
    placement: i = "top",
    trigger: l = "hover",
    mouseEnterDelay: c = 0.1,
    mouseLeaveDelay: u = 0.1,
    overlayStyle: d = {}
  } = e, f = w_(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle"]), {
    getPrefixCls: m
  } = s.useContext(lt), v = m("popover", n), [h, p, g] = nC(v), b = m(), y = J(a, p, g);
  return h(/* @__PURE__ */ s.createElement(Mr, Object.assign({
    placement: i,
    trigger: l,
    mouseEnterDelay: c,
    mouseLeaveDelay: u,
    overlayStyle: d
  }, f, {
    prefixCls: v,
    overlayClassName: y,
    ref: t,
    overlay: r || o ? /* @__PURE__ */ s.createElement(E_, {
      prefixCls: v,
      title: r,
      content: o
    }) : null,
    transitionName: Pr(b, "zoom-big", f.transitionName),
    "data-popover-inject": !0
  })));
});
process.env.NODE_ENV !== "production" && (Qf.displayName = "Popover");
Qf._InternalPanelDoNotUseOrYouWillBeFired = rC;
const oC = Qf;
var O_ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const N_ = O_;
var aC = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: N_
  }));
};
process.env.NODE_ENV !== "production" && (aC.displayName = "RightOutlined");
const $a = /* @__PURE__ */ s.forwardRef(aC);
var I_ = Oe.ESC, P_ = Oe.TAB;
function R_(e) {
  var t = e.visible, n = e.triggerRef, r = e.onVisibleChange, o = e.autoFocus, a = e.overlayRef, i = s.useRef(!1), l = function() {
    if (t) {
      var f, m;
      (f = n.current) === null || f === void 0 || (m = f.focus) === null || m === void 0 || m.call(f), r == null || r(!1);
    }
  }, c = function() {
    var f;
    return (f = a.current) !== null && f !== void 0 && f.focus ? (a.current.focus(), i.current = !0, !0) : !1;
  }, u = function(f) {
    switch (f.keyCode) {
      case I_:
        l();
        break;
      case P_: {
        var m = !1;
        i.current || (m = c()), m ? f.preventDefault() : l();
        break;
      }
    }
  };
  s.useEffect(function() {
    return t ? (window.addEventListener("keydown", u), o && _t(c, 3), function() {
      window.removeEventListener("keydown", u), i.current = !1;
    }) : function() {
      i.current = !1;
    };
  }, [t]);
}
var M_ = /* @__PURE__ */ ar(function(e, t) {
  var n = e.overlay, r = e.arrow, o = e.prefixCls, a = nn(function() {
    var l;
    return typeof n == "function" ? l = n() : l = n, l;
  }, [n]), i = Un(t, a == null ? void 0 : a.ref);
  return /* @__PURE__ */ le.createElement(le.Fragment, null, r && /* @__PURE__ */ le.createElement("div", {
    className: "".concat(o, "-arrow")
  }), /* @__PURE__ */ le.cloneElement(a, {
    ref: Sr(a) ? i : void 0
  }));
}), na = {
  adjustX: 1,
  adjustY: 1
}, ra = [0, 0], T_ = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: na,
    offset: [0, -4],
    targetOffset: ra
  },
  top: {
    points: ["bc", "tc"],
    overflow: na,
    offset: [0, -4],
    targetOffset: ra
  },
  topRight: {
    points: ["br", "tr"],
    overflow: na,
    offset: [0, -4],
    targetOffset: ra
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: na,
    offset: [0, 4],
    targetOffset: ra
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: na,
    offset: [0, 4],
    targetOffset: ra
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: na,
    offset: [0, 4],
    targetOffset: ra
  }
}, __ = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function D_(e, t) {
  var n, r = e.arrow, o = r === void 0 ? !1 : r, a = e.prefixCls, i = a === void 0 ? "rc-dropdown" : a, l = e.transitionName, c = e.animation, u = e.align, d = e.placement, f = d === void 0 ? "bottomLeft" : d, m = e.placements, v = m === void 0 ? T_ : m, h = e.getPopupContainer, p = e.showAction, g = e.hideAction, b = e.overlayClassName, y = e.overlayStyle, C = e.visible, S = e.trigger, $ = S === void 0 ? ["hover"] : S, x = e.autoFocus, w = e.overlay, N = e.children, O = e.onVisibleChange, E = vt(e, __), I = le.useState(), k = Q(I, 2), M = k[0], P = k[1], _ = "visible" in e ? C : M, D = le.useRef(null), R = le.useRef(null), T = le.useRef(null);
  le.useImperativeHandle(t, function() {
    return D.current;
  });
  var L = function(ee) {
    P(ee), O == null || O(ee);
  };
  R_({
    visible: _,
    triggerRef: T,
    onVisibleChange: L,
    autoFocus: x,
    overlayRef: R
  });
  var F = function(ee) {
    var oe = e.onOverlayClick;
    P(!1), oe && oe(ee);
  }, j = function() {
    return /* @__PURE__ */ le.createElement(M_, {
      ref: R,
      overlay: w,
      prefixCls: i,
      arrow: o
    });
  }, A = function() {
    return typeof w == "function" ? j : j();
  }, B = function() {
    var ee = e.minOverlayWidthMatchTrigger, oe = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? ee : !oe;
  }, K = function() {
    var ee = e.openClassName;
    return ee !== void 0 ? ee : "".concat(i, "-open");
  }, Y = /* @__PURE__ */ le.cloneElement(N, {
    className: J((n = N.props) === null || n === void 0 ? void 0 : n.className, _ && K()),
    ref: Sr(N) ? Un(T, N.ref) : void 0
  }), G = g;
  return !G && $.indexOf("contextMenu") !== -1 && (G = ["click"]), /* @__PURE__ */ le.createElement(Yi, fe({
    builtinPlacements: v
  }, E, {
    prefixCls: i,
    ref: D,
    popupClassName: J(b, z({}, "".concat(i, "-show-arrow"), o)),
    popupStyle: y,
    action: $,
    showAction: p,
    hideAction: G,
    popupPlacement: f,
    popupAlign: u,
    popupTransitionName: l,
    popupAnimation: c,
    popupVisible: _,
    stretch: B() ? "minWidth" : "",
    popup: A(),
    onPopupVisibleChange: L,
    onPopupClick: F,
    getPopupContainer: h
  }), Y);
}
const iC = /* @__PURE__ */ le.forwardRef(D_);
var lC = /* @__PURE__ */ s.createContext(null);
function sC(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function cC(e) {
  var t = s.useContext(lC);
  return sC(t, e);
}
var k_ = ["children", "locked"], $r = /* @__PURE__ */ s.createContext(null);
function L_(e, t) {
  var n = V({}, e);
  return Object.keys(t).forEach(function(r) {
    var o = t[r];
    o !== void 0 && (n[r] = o);
  }), n;
}
function Ti(e) {
  var t = e.children, n = e.locked, r = vt(e, k_), o = s.useContext($r), a = Fo(function() {
    return L_(o, r);
  }, [o, r], function(i, l) {
    return !n && (i[0] !== l[0] || !Hr(i[1], l[1], !0));
  });
  return /* @__PURE__ */ s.createElement($r.Provider, {
    value: a
  }, t);
}
var F_ = [], uC = /* @__PURE__ */ s.createContext(null);
function Js() {
  return s.useContext(uC);
}
var dC = /* @__PURE__ */ s.createContext(F_);
function Pa(e) {
  var t = s.useContext(dC);
  return s.useMemo(function() {
    return e !== void 0 ? [].concat(be(t), [e]) : t;
  }, [t, e]);
}
var fC = /* @__PURE__ */ s.createContext(null), Jf = /* @__PURE__ */ s.createContext({});
function Wg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (Ai(e)) {
    var n = e.nodeName.toLowerCase(), r = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(n) || // Editable element
      e.isContentEditable || // Anchor with href element
      n === "a" && !!e.getAttribute("href")
    ), o = e.getAttribute("tabindex"), a = Number(o), i = null;
    return o && !Number.isNaN(a) ? i = a : r && i === null && (i = 0), r && e.disabled && (i = null), i !== null && (i >= 0 || t && i < 0);
  }
  return !1;
}
function j_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = be(e.querySelectorAll("*")).filter(function(r) {
    return Wg(r, t);
  });
  return Wg(e, t) && n.unshift(e), n;
}
var xd = Oe.LEFT, $d = Oe.RIGHT, wd = Oe.UP, ql = Oe.DOWN, Gl = Oe.ENTER, mC = Oe.ESC, Ka = Oe.HOME, qa = Oe.END, Kg = [wd, ql, xd, $d];
function z_(e, t, n, r) {
  var o, a, i, l, c = "prev", u = "next", d = "children", f = "parent";
  if (e === "inline" && r === Gl)
    return {
      inlineTrigger: !0
    };
  var m = (o = {}, z(o, wd, c), z(o, ql, u), o), v = (a = {}, z(a, xd, n ? u : c), z(a, $d, n ? c : u), z(a, ql, d), z(a, Gl, d), a), h = (i = {}, z(i, wd, c), z(i, ql, u), z(i, Gl, d), z(i, mC, f), z(i, xd, n ? d : f), z(i, $d, n ? f : d), i), p = {
    inline: m,
    horizontal: v,
    vertical: h,
    inlineSub: m,
    horizontalSub: h,
    verticalSub: h
  }, g = (l = p["".concat(e).concat(t ? "" : "Sub")]) === null || l === void 0 ? void 0 : l[r];
  switch (g) {
    case c:
      return {
        offset: -1,
        sibling: !0
      };
    case u:
      return {
        offset: 1,
        sibling: !0
      };
    case f:
      return {
        offset: -1,
        sibling: !1
      };
    case d:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function A_(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function B_(e, t) {
  for (var n = e || document.activeElement; n; ) {
    if (t.has(n))
      return n;
    n = n.parentElement;
  }
  return null;
}
function Zf(e, t) {
  var n = j_(e, !0);
  return n.filter(function(r) {
    return t.has(r);
  });
}
function qg(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var o = Zf(e, t), a = o.length, i = o.findIndex(function(l) {
    return n === l;
  });
  return r < 0 ? i === -1 ? i = a - 1 : i -= 1 : r > 0 && (i += 1), i = (i + a) % a, o[i];
}
var Ed = function(t, n) {
  var r = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  return t.forEach(function(i) {
    var l = document.querySelector("[data-menu-id='".concat(sC(n, i), "']"));
    l && (r.add(l), a.set(l, i), o.set(i, l));
  }), {
    elements: r,
    key2element: o,
    element2key: a
  };
};
function H_(e, t, n, r, o, a, i, l, c, u) {
  var d = s.useRef(), f = s.useRef();
  f.current = t;
  var m = function() {
    _t.cancel(d.current);
  };
  return s.useEffect(function() {
    return function() {
      m();
    };
  }, []), function(v) {
    var h = v.which;
    if ([].concat(Kg, [Gl, mC, Ka, qa]).includes(h)) {
      var p = a(), g = Ed(p, r), b = g, y = b.elements, C = b.key2element, S = b.element2key, $ = C.get(t), x = B_($, y), w = S.get(x), N = z_(e, i(w, !0).length === 1, n, h);
      if (!N && h !== Ka && h !== qa)
        return;
      (Kg.includes(h) || [Ka, qa].includes(h)) && v.preventDefault();
      var O = function(R) {
        if (R) {
          var T = R, L = R.querySelector("a");
          L != null && L.getAttribute("href") && (T = L);
          var F = S.get(R);
          l(F), m(), d.current = _t(function() {
            f.current === F && T.focus();
          });
        }
      };
      if ([Ka, qa].includes(h) || N.sibling || !x) {
        var E;
        !x || e === "inline" ? E = o.current : E = A_(x);
        var I, k = Zf(E, y);
        h === Ka ? I = k[0] : h === qa ? I = k[k.length - 1] : I = qg(E, y, x, N.offset), O(I);
      } else if (N.inlineTrigger)
        c(w);
      else if (N.offset > 0)
        c(w, !0), m(), d.current = _t(function() {
          g = Ed(p, r);
          var D = x.getAttribute("aria-controls"), R = document.getElementById(D), T = qg(R, g.elements);
          O(T);
        }, 5);
      else if (N.offset < 0) {
        var M = i(w, !0), P = M[M.length - 2], _ = C.get(P);
        c(P, !1), O(_);
      }
    }
    u == null || u(v);
  };
}
function V_(e) {
  Promise.resolve().then(e);
}
var em = "__RC_UTIL_PATH_SPLIT__", Gg = function(t) {
  return t.join(em);
}, W_ = function(t) {
  return t.split(em);
}, Od = "rc-menu-more";
function K_() {
  var e = s.useState({}), t = Q(e, 2), n = t[1], r = Xe(/* @__PURE__ */ new Map()), o = Xe(/* @__PURE__ */ new Map()), a = s.useState([]), i = Q(a, 2), l = i[0], c = i[1], u = Xe(0), d = Xe(!1), f = function() {
    d.current || n({});
  }, m = Wn(function(C, S) {
    process.env.NODE_ENV !== "production" && tt(!r.current.has(C), "Duplicated key '".concat(C, "' used in Menu by path [").concat(S.join(" > "), "]"));
    var $ = Gg(S);
    o.current.set($, C), r.current.set(C, $), u.current += 1;
    var x = u.current;
    V_(function() {
      x === u.current && f();
    });
  }, []), v = Wn(function(C, S) {
    var $ = Gg(S);
    o.current.delete($), r.current.delete(C);
  }, []), h = Wn(function(C) {
    c(C);
  }, []), p = Wn(function(C, S) {
    var $ = r.current.get(C) || "", x = W_($);
    return S && l.includes(x[0]) && x.unshift(Od), x;
  }, [l]), g = Wn(function(C, S) {
    return C.some(function($) {
      var x = p($, !0);
      return x.includes(S);
    });
  }, [p]), b = function() {
    var S = be(r.current.keys());
    return l.length && S.push(Od), S;
  }, y = Wn(function(C) {
    var S = "".concat(r.current.get(C)).concat(em), $ = /* @__PURE__ */ new Set();
    return be(o.current.keys()).forEach(function(x) {
      x.startsWith(S) && $.add(o.current.get(x));
    }), $;
  }, []);
  return s.useEffect(function() {
    return function() {
      d.current = !0;
    };
  }, []), {
    // Register
    registerPath: m,
    unregisterPath: v,
    refreshOverflowKeys: h,
    // Util
    isSubPathKey: g,
    getKeyPath: p,
    getKeys: b,
    getSubPathKeys: y
  };
}
function ti(e) {
  var t = s.useRef(e);
  t.current = e;
  var n = s.useCallback(function() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(a));
  }, []);
  return e ? n : void 0;
}
var q_ = Math.random().toFixed(5).toString().slice(2), Ug = 0;
function G_(e) {
  var t = Vt(e, {
    value: e
  }), n = Q(t, 2), r = n[0], o = n[1];
  return s.useEffect(function() {
    Ug += 1;
    var a = process.env.NODE_ENV === "test" ? "test" : "".concat(q_, "-").concat(Ug);
    o("rc-menu-uuid-".concat(a));
  }, []), r;
}
function vC(e, t, n, r) {
  var o = s.useContext($r), a = o.activeKey, i = o.onActive, l = o.onInactive, c = {
    active: a === e
  };
  return t || (c.onMouseEnter = function(u) {
    n == null || n({
      key: e,
      domEvent: u
    }), i(e);
  }, c.onMouseLeave = function(u) {
    r == null || r({
      key: e,
      domEvent: u
    }), l(e);
  }), c;
}
function gC(e) {
  var t = s.useContext($r), n = t.mode, r = t.rtl, o = t.inlineIndent;
  if (n !== "inline")
    return null;
  var a = e;
  return r ? {
    paddingRight: a * o
  } : {
    paddingLeft: a * o
  };
}
function pC(e) {
  var t = e.icon, n = e.props, r = e.children, o;
  return t === null || t === !1 ? null : (typeof t == "function" ? o = /* @__PURE__ */ s.createElement(t, V({}, n)) : typeof t != "boolean" && (o = t), o || r || null);
}
var U_ = ["item"];
function ms(e) {
  var t = e.item, n = vt(e, U_);
  return Object.defineProperty(n, "item", {
    get: function() {
      return tt(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), n;
}
var Y_ = ["title", "attribute", "elementRef"], X_ = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], Q_ = ["active"], J_ = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n() {
    return $n(this, n), t.apply(this, arguments);
  }
  return wn(n, [{
    key: "render",
    value: function() {
      var o = this.props, a = o.title, i = o.attribute, l = o.elementRef, c = vt(o, Y_), u = an(c, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return tt(!i, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ s.createElement(Cr.Item, fe({}, i, {
        title: typeof a == "string" ? a : void 0
      }, u, {
        ref: l
      }));
    }
  }]), n;
}(s.Component), Z_ = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n, r = e.style, o = e.className, a = e.eventKey, i = e.warnKey, l = e.disabled, c = e.itemIcon, u = e.children, d = e.role, f = e.onMouseEnter, m = e.onMouseLeave, v = e.onClick, h = e.onKeyDown, p = e.onFocus, g = vt(e, X_), b = cC(a), y = s.useContext($r), C = y.prefixCls, S = y.onItemClick, $ = y.disabled, x = y.overflowDisabled, w = y.itemIcon, N = y.selectedKeys, O = y.onActive, E = s.useContext(Jf), I = E._internalRenderMenuItem, k = "".concat(C, "-item"), M = s.useRef(), P = s.useRef(), _ = $ || l, D = Gr(t, P), R = Pa(a);
  process.env.NODE_ENV !== "production" && i && tt(!1, "MenuItem should not leave undefined `key`.");
  var T = function(W) {
    return {
      key: a,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: be(R).reverse(),
      item: M.current,
      domEvent: W
    };
  }, L = c || w, F = vC(a, _, f, m), j = F.active, A = vt(F, Q_), B = N.includes(a), K = gC(R.length), Y = function(W) {
    if (!_) {
      var re = T(W);
      v == null || v(ms(re)), S(re);
    }
  }, G = function(W) {
    if (h == null || h(W), W.which === Oe.ENTER) {
      var re = T(W);
      v == null || v(ms(re)), S(re);
    }
  }, te = function(W) {
    O(a), p == null || p(W);
  }, ee = {};
  e.role === "option" && (ee["aria-selected"] = B);
  var oe = /* @__PURE__ */ s.createElement(J_, fe({
    ref: M,
    elementRef: D,
    role: d === null ? "none" : d || "menuitem",
    tabIndex: l ? null : -1,
    "data-menu-id": x && b ? null : b
  }, g, A, ee, {
    component: "li",
    "aria-disabled": l,
    style: V(V({}, K), r),
    className: J(k, (n = {}, z(n, "".concat(k, "-active"), j), z(n, "".concat(k, "-selected"), B), z(n, "".concat(k, "-disabled"), _), n), o),
    onClick: Y,
    onKeyDown: G,
    onFocus: te
  }), u, /* @__PURE__ */ s.createElement(pC, {
    props: V(V({}, e), {}, {
      isSelected: B
    }),
    icon: L
  }));
  return I && (oe = I(oe, e, {
    selected: B
  })), oe;
});
function eD(e, t) {
  var n = e.eventKey, r = Js(), o = Pa(n);
  return s.useEffect(function() {
    if (r)
      return r.registerPath(n, o), function() {
        r.unregisterPath(n, o);
      };
  }, [o]), r ? null : /* @__PURE__ */ s.createElement(Z_, fe({}, e, {
    ref: t
  }));
}
const Ji = /* @__PURE__ */ s.forwardRef(eD);
var tD = ["className", "children"], nD = function(t, n) {
  var r = t.className, o = t.children, a = vt(t, tD), i = s.useContext($r), l = i.prefixCls, c = i.mode, u = i.rtl;
  return /* @__PURE__ */ s.createElement("ul", fe({
    className: J(l, u && "".concat(l, "-rtl"), "".concat(l, "-sub"), "".concat(l, "-").concat(c === "inline" ? "inline" : "vertical"), r),
    role: "menu"
  }, a, {
    "data-menu-list": !0,
    ref: n
  }), o);
}, tm = /* @__PURE__ */ s.forwardRef(nD);
tm.displayName = "SubMenuList";
function nm(e, t) {
  return Pn(e).map(function(n, r) {
    if (/* @__PURE__ */ s.isValidElement(n)) {
      var o, a, i = n.key, l = (o = (a = n.props) === null || a === void 0 ? void 0 : a.eventKey) !== null && o !== void 0 ? o : i, c = l == null;
      c && (l = "tmp_key-".concat([].concat(be(t), [r]).join("-")));
      var u = {
        key: l,
        eventKey: l
      };
      return process.env.NODE_ENV !== "production" && c && (u.warnKey = !0), /* @__PURE__ */ s.cloneElement(n, u);
    }
    return n;
  });
}
var jn = {
  adjustX: 1,
  adjustY: 1
}, rD = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: jn
  },
  topRight: {
    points: ["br", "tr"],
    overflow: jn
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: jn
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: jn
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: jn
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: jn
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: jn
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: jn
  }
}, oD = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: jn
  },
  topRight: {
    points: ["br", "tr"],
    overflow: jn
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: jn
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: jn
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: jn
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: jn
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: jn
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: jn
  }
};
function hC(e, t, n) {
  if (t)
    return t;
  if (n)
    return n[e] || n.other;
}
var aD = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function iD(e) {
  var t = e.prefixCls, n = e.visible, r = e.children, o = e.popup, a = e.popupStyle, i = e.popupClassName, l = e.popupOffset, c = e.disabled, u = e.mode, d = e.onVisibleChange, f = s.useContext($r), m = f.getPopupContainer, v = f.rtl, h = f.subMenuOpenDelay, p = f.subMenuCloseDelay, g = f.builtinPlacements, b = f.triggerSubMenuAction, y = f.forceSubMenuRender, C = f.rootClassName, S = f.motion, $ = f.defaultMotions, x = s.useState(!1), w = Q(x, 2), N = w[0], O = w[1], E = V(v ? V({}, oD) : V({}, rD), g), I = aD[u], k = hC(u, S, $), M = s.useRef(k);
  u !== "inline" && (M.current = k);
  var P = V(V({}, M.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), _ = s.useRef();
  return s.useEffect(function() {
    return _.current = _t(function() {
      O(n);
    }), function() {
      _t.cancel(_.current);
    };
  }, [n]), /* @__PURE__ */ s.createElement(Yi, {
    prefixCls: t,
    popupClassName: J("".concat(t, "-popup"), z({}, "".concat(t, "-rtl"), v), i, C),
    stretch: u === "horizontal" ? "minWidth" : null,
    getPopupContainer: m,
    builtinPlacements: E,
    popupPlacement: I,
    popupVisible: N,
    popup: o,
    popupStyle: a,
    popupAlign: l && {
      offset: l
    },
    action: c ? [] : [b],
    mouseEnterDelay: h,
    mouseLeaveDelay: p,
    onPopupVisibleChange: d,
    forceRender: y,
    popupMotion: P,
    fresh: !0
  }, r);
}
function lD(e) {
  var t = e.id, n = e.open, r = e.keyPath, o = e.children, a = "inline", i = s.useContext($r), l = i.prefixCls, c = i.forceSubMenuRender, u = i.motion, d = i.defaultMotions, f = i.mode, m = s.useRef(!1);
  m.current = f === a;
  var v = s.useState(!m.current), h = Q(v, 2), p = h[0], g = h[1], b = m.current ? n : !1;
  s.useEffect(function() {
    m.current && g(!1);
  }, [f]);
  var y = V({}, hC(a, u, d));
  r.length > 1 && (y.motionAppear = !1);
  var C = y.onVisibleChanged;
  return y.onVisibleChanged = function(S) {
    return !m.current && !S && g(!0), C == null ? void 0 : C(S);
  }, p ? null : /* @__PURE__ */ s.createElement(Ti, {
    mode: a,
    locked: !m.current
  }, /* @__PURE__ */ s.createElement(An, fe({
    visible: b
  }, y, {
    forceRender: c,
    removeOnLeave: !1,
    leavedClassName: "".concat(l, "-hidden")
  }), function(S) {
    var $ = S.className, x = S.style;
    return /* @__PURE__ */ s.createElement(tm, {
      id: t,
      className: $,
      style: x
    }, o);
  }));
}
var sD = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], cD = ["active"], uD = function(t) {
  var n, r = t.style, o = t.className, a = t.title, i = t.eventKey, l = t.warnKey, c = t.disabled, u = t.internalPopupClose, d = t.children, f = t.itemIcon, m = t.expandIcon, v = t.popupClassName, h = t.popupOffset, p = t.popupStyle, g = t.onClick, b = t.onMouseEnter, y = t.onMouseLeave, C = t.onTitleClick, S = t.onTitleMouseEnter, $ = t.onTitleMouseLeave, x = vt(t, sD), w = cC(i), N = s.useContext($r), O = N.prefixCls, E = N.mode, I = N.openKeys, k = N.disabled, M = N.overflowDisabled, P = N.activeKey, _ = N.selectedKeys, D = N.itemIcon, R = N.expandIcon, T = N.onItemClick, L = N.onOpenChange, F = N.onActive, j = s.useContext(Jf), A = j._internalRenderSubMenuItem, B = s.useContext(fC), K = B.isSubPathKey, Y = Pa(), G = "".concat(O, "-submenu"), te = k || c, ee = s.useRef(), oe = s.useRef();
  process.env.NODE_ENV !== "production" && l && tt(!1, "SubMenu should not leave undefined `key`.");
  var X = f ?? D, W = m ?? R, re = I.includes(i), Z = !M && re, H = K(_, i), U = vC(i, te, S, $), ae = U.active, ue = vt(U, cD), de = s.useState(!1), se = Q(de, 2), ie = se[0], me = se[1], Se = function(Re) {
    te || me(Re);
  }, ve = function(Re) {
    Se(!0), b == null || b({
      key: i,
      domEvent: Re
    });
  }, ge = function(Re) {
    Se(!1), y == null || y({
      key: i,
      domEvent: Re
    });
  }, $e = s.useMemo(function() {
    return ae || (E !== "inline" ? ie || K([P], i) : !1);
  }, [E, ae, P, ie, i, K]), we = gC(Y.length), _e = function(Re) {
    te || (C == null || C({
      key: i,
      domEvent: Re
    }), E === "inline" && L(i, !re));
  }, ze = ti(function(Pe) {
    g == null || g(ms(Pe)), T(Pe);
  }), Te = function(Re) {
    E !== "inline" && L(i, Re);
  }, ke = function() {
    F(i);
  }, Le = w && "".concat(w, "-popup"), Ee = /* @__PURE__ */ s.createElement("div", fe({
    role: "menuitem",
    style: we,
    className: "".concat(G, "-title"),
    tabIndex: te ? null : -1,
    ref: ee,
    title: typeof a == "string" ? a : null,
    "data-menu-id": M && w ? null : w,
    "aria-expanded": Z,
    "aria-haspopup": !0,
    "aria-controls": Le,
    "aria-disabled": te,
    onClick: _e,
    onFocus: ke
  }, ue), a, /* @__PURE__ */ s.createElement(pC, {
    icon: E !== "horizontal" ? W : void 0,
    props: V(V({}, t), {}, {
      isOpen: Z,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ s.createElement("i", {
    className: "".concat(G, "-arrow")
  }))), xe = s.useRef(E);
  if (E !== "inline" && Y.length > 1 ? xe.current = "vertical" : xe.current = E, !M) {
    var he = xe.current;
    Ee = /* @__PURE__ */ s.createElement(iD, {
      mode: he,
      prefixCls: G,
      visible: !u && Z && E !== "inline",
      popupClassName: v,
      popupOffset: h,
      popupStyle: p,
      popup: /* @__PURE__ */ s.createElement(
        Ti,
        {
          mode: he === "horizontal" ? "vertical" : he
        },
        /* @__PURE__ */ s.createElement(tm, {
          id: Le,
          ref: oe
        }, d)
      ),
      disabled: te,
      onVisibleChange: Te
    }, Ee);
  }
  var pe = /* @__PURE__ */ s.createElement(Cr.Item, fe({
    role: "none"
  }, x, {
    component: "li",
    style: r,
    className: J(G, "".concat(G, "-").concat(E), o, (n = {}, z(n, "".concat(G, "-open"), Z), z(n, "".concat(G, "-active"), $e), z(n, "".concat(G, "-selected"), H), z(n, "".concat(G, "-disabled"), te), n)),
    onMouseEnter: ve,
    onMouseLeave: ge
  }), Ee, !M && /* @__PURE__ */ s.createElement(lD, {
    id: Le,
    open: Z,
    keyPath: Y
  }, d));
  return A && (pe = A(pe, t, {
    selected: H,
    active: $e,
    open: Z,
    disabled: te
  })), /* @__PURE__ */ s.createElement(Ti, {
    onItemClick: ze,
    mode: E === "horizontal" ? "vertical" : E,
    itemIcon: X,
    expandIcon: W
  }, pe);
};
function Zs(e) {
  var t = e.eventKey, n = e.children, r = Pa(t), o = nm(n, r), a = Js();
  s.useEffect(function() {
    if (a)
      return a.registerPath(t, r), function() {
        a.unregisterPath(t, r);
      };
  }, [r]);
  var i;
  return a ? i = o : i = /* @__PURE__ */ s.createElement(uD, e, o), /* @__PURE__ */ s.createElement(dC.Provider, {
    value: r
  }, i);
}
var dD = ["className", "title", "eventKey", "children"], fD = ["children"], mD = function(t) {
  var n = t.className, r = t.title;
  t.eventKey;
  var o = t.children, a = vt(t, dD), i = s.useContext($r), l = i.prefixCls, c = "".concat(l, "-item-group");
  return /* @__PURE__ */ s.createElement("li", fe({
    role: "presentation"
  }, a, {
    onClick: function(d) {
      return d.stopPropagation();
    },
    className: J(c, n)
  }), /* @__PURE__ */ s.createElement("div", {
    role: "presentation",
    className: "".concat(c, "-title"),
    title: typeof r == "string" ? r : void 0
  }, r), /* @__PURE__ */ s.createElement("ul", {
    role: "group",
    className: "".concat(c, "-list")
  }, o));
};
function ec(e) {
  var t = e.children, n = vt(e, fD), r = Pa(n.eventKey), o = nm(t, r), a = Js();
  return a ? o : /* @__PURE__ */ s.createElement(mD, an(n, ["warnKey"]), o);
}
function rm(e) {
  var t = e.className, n = e.style, r = s.useContext($r), o = r.prefixCls, a = Js();
  return a ? null : /* @__PURE__ */ s.createElement("li", {
    role: "separator",
    className: J("".concat(o, "-item-divider"), t),
    style: n
  });
}
var vD = ["label", "children", "key", "type"];
function Nd(e) {
  return (e || []).map(function(t, n) {
    if (t && mt(t) === "object") {
      var r = t, o = r.label, a = r.children, i = r.key, l = r.type, c = vt(r, vD), u = i ?? "tmp-".concat(n);
      return a || l === "group" ? l === "group" ? /* @__PURE__ */ s.createElement(ec, fe({
        key: u
      }, c, {
        title: o
      }), Nd(a)) : /* @__PURE__ */ s.createElement(Zs, fe({
        key: u
      }, c, {
        title: o
      }), Nd(a)) : l === "divider" ? /* @__PURE__ */ s.createElement(rm, fe({
        key: u
      }, c)) : /* @__PURE__ */ s.createElement(Ji, fe({
        key: u
      }, c), o);
    }
    return null;
  }).filter(function(t) {
    return t;
  });
}
function gD(e, t, n) {
  var r = e;
  return t && (r = Nd(t)), nm(r, n);
}
var pD = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem"], oa = [], hD = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n, r, o = e, a = o.prefixCls, i = a === void 0 ? "rc-menu" : a, l = o.rootClassName, c = o.style, u = o.className, d = o.tabIndex, f = d === void 0 ? 0 : d, m = o.items, v = o.children, h = o.direction, p = o.id, g = o.mode, b = g === void 0 ? "vertical" : g, y = o.inlineCollapsed, C = o.disabled, S = o.disabledOverflow, $ = o.subMenuOpenDelay, x = $ === void 0 ? 0.1 : $, w = o.subMenuCloseDelay, N = w === void 0 ? 0.1 : w, O = o.forceSubMenuRender, E = o.defaultOpenKeys, I = o.openKeys, k = o.activeKey, M = o.defaultActiveFirst, P = o.selectable, _ = P === void 0 ? !0 : P, D = o.multiple, R = D === void 0 ? !1 : D, T = o.defaultSelectedKeys, L = o.selectedKeys, F = o.onSelect, j = o.onDeselect, A = o.inlineIndent, B = A === void 0 ? 24 : A, K = o.motion, Y = o.defaultMotions, G = o.triggerSubMenuAction, te = G === void 0 ? "hover" : G, ee = o.builtinPlacements, oe = o.itemIcon, X = o.expandIcon, W = o.overflowedIndicator, re = W === void 0 ? "..." : W, Z = o.overflowedIndicatorPopupClassName, H = o.getPopupContainer, U = o.onClick, ae = o.onOpenChange, ue = o.onKeyDown, de = o.openAnimation, se = o.openTransitionName, ie = o._internalRenderMenuItem, me = o._internalRenderSubMenuItem, Se = vt(o, pD), ve = s.useMemo(function() {
    return gD(v, m, oa);
  }, [v, m]), ge = s.useState(!1), $e = Q(ge, 2), we = $e[0], _e = $e[1], ze = s.useRef(), Te = G_(p), ke = h === "rtl";
  process.env.NODE_ENV !== "production" && tt(!de && !se, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var Le = Vt(E, {
    value: I,
    postState: function(rt) {
      return rt || oa;
    }
  }), Ee = Q(Le, 2), xe = Ee[0], he = Ee[1], pe = function(rt) {
    var wt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function zt() {
      he(rt), ae == null || ae(rt);
    }
    wt ? bi(zt) : zt();
  }, Pe = s.useState(xe), Re = Q(Pe, 2), at = Re[0], Ze = Re[1], Ie = s.useRef(!1), Be = s.useMemo(function() {
    return (b === "inline" || b === "vertical") && y ? ["vertical", y] : [b, !1];
  }, [b, y]), bt = Q(Be, 2), He = bt[0], nt = bt[1], et = He === "inline", Ge = s.useState(He), Ae = Q(Ge, 2), qe = Ae[0], Je = Ae[1], Ke = s.useState(nt), Ye = Q(Ke, 2), Ve = Ye[0], Qe = Ye[1];
  s.useEffect(function() {
    Je(He), Qe(nt), Ie.current && (et ? he(at) : pe(oa));
  }, [He, nt]);
  var it = s.useState(0), yt = Q(it, 2), Tt = yt[0], ne = yt[1], ye = Tt >= ve.length - 1 || qe !== "horizontal" || S;
  s.useEffect(function() {
    et && Ze(xe);
  }, [xe]), s.useEffect(function() {
    return Ie.current = !0, function() {
      Ie.current = !1;
    };
  }, []);
  var ce = K_(), Ce = ce.registerPath, je = ce.unregisterPath, Ne = ce.refreshOverflowKeys, De = ce.isSubPathKey, Fe = ce.getKeyPath, ot = ce.getKeys, pt = ce.getSubPathKeys, St = s.useMemo(function() {
    return {
      registerPath: Ce,
      unregisterPath: je
    };
  }, [Ce, je]), Ot = s.useMemo(function() {
    return {
      isSubPathKey: De
    };
  }, [De]);
  s.useEffect(function() {
    Ne(ye ? oa : ve.slice(Tt + 1).map(function(dt) {
      return dt.key;
    }));
  }, [Tt, ye]);
  var Wt = Vt(k || M && ((n = ve[0]) === null || n === void 0 ? void 0 : n.key), {
    value: k
  }), rn = Q(Wt, 2), Nt = rn[0], Ut = rn[1], fn = ti(function(dt) {
    Ut(dt);
  }), sn = ti(function() {
    Ut(void 0);
  });
  qr(t, function() {
    return {
      list: ze.current,
      focus: function(rt) {
        var wt, zt = ot(), Mt = Ed(zt, Te), ct = Mt.elements, ft = Mt.key2element, Yt = Mt.element2key, en = Zf(ze.current, ct), vn = Nt ?? (en[0] ? Yt.get(en[0]) : (wt = ve.find(function(st) {
          return !st.props.disabled;
        })) === null || wt === void 0 ? void 0 : wt.key), Ct = ft.get(vn);
        if (vn && Ct) {
          var Ue;
          Ct == null || (Ue = Ct.focus) === null || Ue === void 0 || Ue.call(Ct, rt);
        }
      }
    };
  });
  var ln = Vt(T || [], {
    value: L,
    // Legacy convert key to array
    postState: function(rt) {
      return Array.isArray(rt) ? rt : rt == null ? oa : [rt];
    }
  }), _n = Q(ln, 2), ut = _n[0], xt = _n[1], jt = function(rt) {
    if (_) {
      var wt = rt.key, zt = ut.includes(wt), Mt;
      R ? zt ? Mt = ut.filter(function(ft) {
        return ft !== wt;
      }) : Mt = [].concat(be(ut), [wt]) : Mt = [wt], xt(Mt);
      var ct = V(V({}, rt), {}, {
        selectedKeys: Mt
      });
      zt ? j == null || j(ct) : F == null || F(ct);
    }
    !R && xe.length && qe !== "inline" && pe(oa);
  }, on = ti(function(dt) {
    U == null || U(ms(dt)), jt(dt);
  }), cn = ti(function(dt, rt) {
    var wt = xe.filter(function(Mt) {
      return Mt !== dt;
    });
    if (rt)
      wt.push(dt);
    else if (qe !== "inline") {
      var zt = pt(dt);
      wt = wt.filter(function(Mt) {
        return !zt.has(Mt);
      });
    }
    Hr(xe, wt, !0) || pe(wt, !0);
  }), hn = function(rt, wt) {
    var zt = wt ?? !xe.includes(rt);
    cn(rt, zt);
  }, Dn = H_(qe, Nt, ke, Te, ze, ot, Fe, Ut, hn, ue);
  s.useEffect(function() {
    _e(!0);
  }, []);
  var On = s.useMemo(function() {
    return {
      _internalRenderMenuItem: ie,
      _internalRenderSubMenuItem: me
    };
  }, [ie, me]), mn = qe !== "horizontal" || S ? ve : (
    // Need wrap for overflow dropdown that do not response for open
    ve.map(function(dt, rt) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ s.createElement(Ti, {
          key: dt.key,
          overflowDisabled: rt > Tt
        }, dt)
      );
    })
  ), kn = /* @__PURE__ */ s.createElement(Cr, fe({
    id: p,
    ref: ze,
    prefixCls: "".concat(i, "-overflow"),
    component: "ul",
    itemComponent: Ji,
    className: J(i, "".concat(i, "-root"), "".concat(i, "-").concat(qe), u, (r = {}, z(r, "".concat(i, "-inline-collapsed"), Ve), z(r, "".concat(i, "-rtl"), ke), r), l),
    dir: h,
    style: c,
    role: "menu",
    tabIndex: f,
    data: mn,
    renderRawItem: function(rt) {
      return rt;
    },
    renderRawRest: function(rt) {
      var wt = rt.length, zt = wt ? ve.slice(-wt) : null;
      return /* @__PURE__ */ s.createElement(Zs, {
        eventKey: Od,
        title: re,
        disabled: ye,
        internalPopupClose: wt === 0,
        popupClassName: Z
      }, zt);
    },
    maxCount: qe !== "horizontal" || S ? Cr.INVALIDATE : Cr.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(rt) {
      ne(rt);
    },
    onKeyDown: Dn
  }, Se));
  return /* @__PURE__ */ s.createElement(Jf.Provider, {
    value: On
  }, /* @__PURE__ */ s.createElement(lC.Provider, {
    value: Te
  }, /* @__PURE__ */ s.createElement(Ti, {
    prefixCls: i,
    rootClassName: l,
    mode: qe,
    openKeys: xe,
    rtl: ke,
    disabled: C,
    motion: we ? K : null,
    defaultMotions: we ? Y : null,
    activeKey: Nt,
    onActive: fn,
    onInactive: sn,
    selectedKeys: ut,
    inlineIndent: B,
    subMenuOpenDelay: x,
    subMenuCloseDelay: N,
    forceSubMenuRender: O,
    builtinPlacements: ee,
    triggerSubMenuAction: te,
    getPopupContainer: H,
    itemIcon: oe,
    expandIcon: X,
    onItemClick: on,
    onOpenChange: cn
  }, /* @__PURE__ */ s.createElement(fC.Provider, {
    value: Ot
  }, kn), /* @__PURE__ */ s.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ s.createElement(uC.Provider, {
    value: St
  }, ve)))));
}), Ra = hD;
Ra.Item = Ji;
Ra.SubMenu = Zs;
Ra.ItemGroup = ec;
Ra.Divider = rm;
var bD = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" };
const yD = bD;
var bC = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: yD
  }));
};
process.env.NODE_ENV !== "production" && (bC.displayName = "BarsOutlined");
const CD = /* @__PURE__ */ s.forwardRef(bC);
var SD = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const xD = SD;
var yC = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: xD
  }));
};
process.env.NODE_ENV !== "production" && (yC.displayName = "LeftOutlined");
const vs = /* @__PURE__ */ s.forwardRef(yC), $D = (e) => !isNaN(parseFloat(e)) && isFinite(e), wD = $D, ED = /* @__PURE__ */ s.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
});
var OD = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Yg = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, om = /* @__PURE__ */ s.createContext({}), ND = (() => {
  let e = 0;
  return function() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e += 1, `${t}${e}`;
  };
})(), ID = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: r,
    trigger: o,
    children: a,
    defaultCollapsed: i = !1,
    theme: l = "dark",
    style: c = {},
    collapsible: u = !1,
    reverseArrow: d = !1,
    width: f = 200,
    collapsedWidth: m = 80,
    zeroWidthTriggerStyle: v,
    breakpoint: h,
    onCollapse: p,
    onBreakpoint: g
  } = e, b = OD(e, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), {
    siderHook: y
  } = qt(ED), [C, S] = Ht("collapsed" in e ? e.collapsed : i), [$, x] = Ht(!1);
  Bt(() => {
    "collapsed" in e && S(e.collapsed);
  }, [e.collapsed]);
  const w = (M, P) => {
    "collapsed" in e || S(M), p == null || p(M, P);
  }, N = Xe();
  N.current = (M) => {
    x(M.matches), g == null || g(M.matches), C !== M.matches && w(M.matches, "responsive");
  }, Bt(() => {
    function M(_) {
      return N.current(_);
    }
    let P;
    if (typeof window < "u") {
      const {
        matchMedia: _
      } = window;
      if (_ && h && h in Yg) {
        P = _(`screen and (max-width: ${Yg[h]})`);
        try {
          P.addEventListener("change", M);
        } catch {
          P.addListener(M);
        }
        M(P);
      }
    }
    return () => {
      try {
        P == null || P.removeEventListener("change", M);
      } catch {
        P == null || P.removeListener(M);
      }
    };
  }, [h]), Bt(() => {
    const M = ND("ant-sider-");
    return y.addSider(M), () => y.removeSider(M);
  }, []);
  const O = () => {
    w(!C, "clickTrigger");
  }, {
    getPrefixCls: E
  } = qt(lt), I = () => {
    const M = E("layout-sider", n), P = an(b, ["collapsed"]), _ = C ? m : f, D = wD(_) ? `${_}px` : String(_), R = parseFloat(String(m || 0)) === 0 ? /* @__PURE__ */ s.createElement("span", {
      onClick: O,
      className: J(`${M}-zero-width-trigger`, `${M}-zero-width-trigger-${d ? "right" : "left"}`),
      style: v
    }, o || /* @__PURE__ */ s.createElement(CD, null)) : null, F = {
      expanded: d ? /* @__PURE__ */ s.createElement($a, null) : /* @__PURE__ */ s.createElement(vs, null),
      collapsed: d ? /* @__PURE__ */ s.createElement(vs, null) : /* @__PURE__ */ s.createElement($a, null)
    }[C ? "collapsed" : "expanded"], j = o !== null ? R || /* @__PURE__ */ s.createElement("div", {
      className: `${M}-trigger`,
      onClick: O,
      style: {
        width: D
      }
    }, o || F) : null, A = Object.assign(Object.assign({}, c), {
      flex: `0 0 ${D}`,
      maxWidth: D,
      minWidth: D,
      width: D
    }), B = J(M, `${M}-${l}`, {
      [`${M}-collapsed`]: !!C,
      [`${M}-has-trigger`]: u && o !== null && !R,
      [`${M}-below`]: !!$,
      [`${M}-zero-width`]: parseFloat(D) === 0
    }, r);
    return /* @__PURE__ */ s.createElement("aside", Object.assign({
      className: B
    }, P, {
      style: A,
      ref: t
    }), /* @__PURE__ */ s.createElement("div", {
      className: `${M}-children`
    }, a), u || $ && R ? j : null);
  }, k = s.useMemo(() => ({
    siderCollapsed: C
  }), [C]);
  return /* @__PURE__ */ s.createElement(om.Provider, {
    value: k
  }, I());
});
process.env.NODE_ENV !== "production" && (ID.displayName = "Sider");
var PD = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" };
const RD = PD;
var CC = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: RD
  }));
};
process.env.NODE_ENV !== "production" && (CC.displayName = "EllipsisOutlined");
const am = /* @__PURE__ */ s.forwardRef(CC);
var MD = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const TD = (e) => {
  const {
    prefixCls: t,
    className: n,
    dashed: r
  } = e, o = MD(e, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: a
  } = s.useContext(lt), i = a("menu", t), l = J({
    [`${i}-item-divider-dashed`]: !!r
  }, n);
  return /* @__PURE__ */ s.createElement(rm, Object.assign({
    className: l
  }, o));
}, SC = TD, _D = /* @__PURE__ */ uo({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
}), gs = _D, DD = (e) => {
  var t;
  const {
    className: n,
    children: r,
    icon: o,
    title: a,
    danger: i
  } = e, {
    prefixCls: l,
    firstLevel: c,
    direction: u,
    disableMenuItemTitleTooltip: d,
    inlineCollapsed: f
  } = s.useContext(gs), m = (y) => {
    const C = /* @__PURE__ */ s.createElement("span", {
      className: `${l}-title-content`
    }, r);
    return (!o || Kn(r) && r.type === "span") && r && y && c && typeof r == "string" ? /* @__PURE__ */ s.createElement("div", {
      className: `${l}-inline-collapsed-noicon`
    }, r.charAt(0)) : C;
  }, {
    siderCollapsed: v
  } = s.useContext(om);
  let h = a;
  typeof a > "u" ? h = c ? r : "" : a === !1 && (h = "");
  const p = {
    title: h
  };
  !v && !f && (p.title = null, p.open = !1);
  const g = Pn(r).length;
  let b = /* @__PURE__ */ s.createElement(Ji, Object.assign({}, an(e, ["title", "icon", "danger"]), {
    className: J({
      [`${l}-item-danger`]: i,
      [`${l}-item-only-child`]: (o ? g + 1 : g) === 1
    }, n),
    title: typeof a == "string" ? a : void 0
  }), xn(o, {
    className: J(Kn(o) ? (t = o.props) === null || t === void 0 ? void 0 : t.className : "", `${l}-item-icon`)
  }), m(f));
  return d || (b = /* @__PURE__ */ s.createElement(Mr, Object.assign({}, p, {
    placement: u === "rtl" ? "left" : "right",
    overlayClassName: `${l}-inline-collapsed-tooltip`
  }), b)), b;
}, xC = DD, kD = (e) => {
  var t;
  const {
    popupClassName: n,
    icon: r,
    title: o,
    theme: a
  } = e, i = s.useContext(gs), {
    prefixCls: l,
    inlineCollapsed: c,
    theme: u
  } = i, d = Pa();
  let f;
  if (!r)
    f = c && !d.length && o && typeof o == "string" ? /* @__PURE__ */ s.createElement("div", {
      className: `${l}-inline-collapsed-noicon`
    }, o.charAt(0)) : /* @__PURE__ */ s.createElement("span", {
      className: `${l}-title-content`
    }, o);
  else {
    const h = Kn(o) && o.type === "span";
    f = /* @__PURE__ */ s.createElement(s.Fragment, null, xn(r, {
      className: J(Kn(r) ? (t = r.props) === null || t === void 0 ? void 0 : t.className : "", `${l}-item-icon`)
    }), h ? o : /* @__PURE__ */ s.createElement("span", {
      className: `${l}-title-content`
    }, o));
  }
  const m = s.useMemo(() => Object.assign(Object.assign({}, i), {
    firstLevel: !1
  }), [i]), [v] = vo("Menu");
  return /* @__PURE__ */ s.createElement(gs.Provider, {
    value: m
  }, /* @__PURE__ */ s.createElement(Zs, Object.assign({}, an(e, ["icon"]), {
    title: f,
    popupClassName: J(l, n, `${l}-${a || u}`),
    popupStyle: {
      zIndex: v
    }
  })));
}, $C = kD;
var LD = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Id(e) {
  return (e || []).map((t, n) => {
    if (t && typeof t == "object") {
      const r = t, {
        label: o,
        children: a,
        key: i,
        type: l
      } = r, c = LD(r, ["label", "children", "key", "type"]), u = i ?? `tmp-${n}`;
      return a || l === "group" ? l === "group" ? /* @__PURE__ */ s.createElement(ec, Object.assign({
        key: u
      }, c, {
        title: o
      }), Id(a)) : /* @__PURE__ */ s.createElement($C, Object.assign({
        key: u
      }, c, {
        title: o
      }), Id(a)) : l === "divider" ? /* @__PURE__ */ s.createElement(SC, Object.assign({
        key: u
      }, c)) : /* @__PURE__ */ s.createElement(xC, Object.assign({
        key: u
      }, c), o);
    }
    return null;
  }).filter((t) => t);
}
function FD(e) {
  return s.useMemo(() => e && Id(e), [e]);
}
var jD = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Pd = /* @__PURE__ */ s.createContext(null), wC = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    children: n
  } = e, r = jD(e, ["children"]), o = s.useContext(Pd), a = s.useMemo(() => Object.assign(Object.assign({}, o), r), [
    o,
    r.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    r.mode,
    r.selectable,
    r.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), i = Kw(n), l = Gr(t, i ? n.ref : null);
  return /* @__PURE__ */ s.createElement(Pd.Provider, {
    value: a
  }, /* @__PURE__ */ s.createElement(so, null, i ? /* @__PURE__ */ s.cloneElement(n, {
    ref: l
  }) : n));
}), Xg = Pd, zD = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    horizontalLineHeight: r,
    colorSplit: o,
    lineWidth: a,
    lineType: i,
    itemPaddingInline: l
  } = e;
  return {
    [`${t}-horizontal`]: {
      lineHeight: r,
      border: 0,
      borderBottom: `${q(a)} ${i} ${o}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${t}-item, ${t}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: l
      },
      [`> ${t}-item:hover,
        > ${t}-item-active,
        > ${t}-submenu ${t}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${t}-item, ${t}-submenu-title`]: {
        transition: [`border-color ${n}`, `background ${n}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${t}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, AD = zD, BD = (e) => {
  let {
    componentCls: t,
    menuArrowOffset: n,
    calc: r
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    },
    [`${t}-submenu-rtl`]: {
      transformOrigin: "100% 0"
    },
    // Vertical Arrow
    [`${t}-rtl${t}-vertical,
    ${t}-submenu-rtl ${t}-vertical`]: {
      [`${t}-submenu-arrow`]: {
        "&::before": {
          transform: `rotate(-45deg) translateY(${q(r(n).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(45deg) translateY(${q(n)})`
        }
      }
    }
  };
}, HD = BD, Qg = (e) => Object.assign({}, io(e)), VD = (e, t) => {
  const {
    componentCls: n,
    itemColor: r,
    itemSelectedColor: o,
    groupTitleColor: a,
    itemBg: i,
    subMenuItemBg: l,
    itemSelectedBg: c,
    activeBarHeight: u,
    activeBarWidth: d,
    activeBarBorderWidth: f,
    motionDurationSlow: m,
    motionEaseInOut: v,
    motionEaseOut: h,
    itemPaddingInline: p,
    motionDurationMid: g,
    itemHoverColor: b,
    lineType: y,
    colorSplit: C,
    // Disabled
    itemDisabledColor: S,
    // Danger
    dangerItemColor: $,
    dangerItemHoverColor: x,
    dangerItemSelectedColor: w,
    dangerItemActiveBg: N,
    dangerItemSelectedBg: O,
    // Bg
    popupBg: E,
    itemHoverBg: I,
    itemActiveBg: k,
    menuSubMenuBg: M,
    // Horizontal
    horizontalItemSelectedColor: P,
    horizontalItemSelectedBg: _,
    horizontalItemBorderRadius: D,
    horizontalItemHoverBg: R
  } = e;
  return {
    [`${n}-${t}, ${n}-${t} > ${n}`]: {
      color: r,
      background: i,
      [`&${n}-root:focus-visible`]: Object.assign({}, Qg(e)),
      // ======================== Item ========================
      [`${n}-item-group-title`]: {
        color: a
      },
      [`${n}-submenu-selected`]: {
        [`> ${n}-submenu-title`]: {
          color: o
        }
      },
      [`${n}-item, ${n}-submenu-title`]: {
        color: r,
        [`&:not(${n}-item-disabled):focus-visible`]: Object.assign({}, Qg(e))
      },
      // Disabled
      [`${n}-item-disabled, ${n}-submenu-disabled`]: {
        color: `${S} !important`
      },
      // Hover
      [`${n}-item:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
        [`&:hover, > ${n}-submenu-title:hover`]: {
          color: b
        }
      },
      [`&:not(${n}-horizontal)`]: {
        [`${n}-item:not(${n}-item-selected)`]: {
          "&:hover": {
            backgroundColor: I
          },
          "&:active": {
            backgroundColor: k
          }
        },
        [`${n}-submenu-title`]: {
          "&:hover": {
            backgroundColor: I
          },
          "&:active": {
            backgroundColor: k
          }
        }
      },
      // Danger - only Item has
      [`${n}-item-danger`]: {
        color: $,
        [`&${n}-item:hover`]: {
          [`&:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
            color: x
          }
        },
        [`&${n}-item:active`]: {
          background: N
        }
      },
      [`${n}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${n}-item-selected`]: {
        color: o,
        // Danger
        [`&${n}-item-danger`]: {
          color: w
        },
        ["a, a:hover"]: {
          color: "inherit"
        }
      },
      [`& ${n}-item-selected`]: {
        backgroundColor: c,
        // Danger
        [`&${n}-item-danger`]: {
          backgroundColor: O
        }
      },
      [`&${n}-submenu > ${n}`]: {
        backgroundColor: M
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${n}-popup > ${n}`]: {
        backgroundColor: E
      },
      [`&${n}-submenu-popup > ${n}`]: {
        backgroundColor: E
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${n}-horizontal`]: Object.assign(Object.assign({}, t === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${n}-item, > ${n}-submenu`]: {
          top: f,
          marginTop: e.calc(f).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: D,
          "&::after": {
            position: "absolute",
            insetInline: p,
            bottom: 0,
            borderBottom: `${q(u)} solid transparent`,
            transition: `border-color ${m} ${v}`,
            content: '""'
          },
          ["&:hover, &-active, &-open"]: {
            background: R,
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: P
            }
          },
          ["&-selected"]: {
            color: P,
            backgroundColor: _,
            "&:hover": {
              backgroundColor: _
            },
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: P
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${n}-root`]: {
        [`&${n}-inline, &${n}-vertical`]: {
          borderInlineEnd: `${q(f)} ${y} ${C}`
        }
      },
      // ======================== Inline ========================
      [`&${n}-inline`]: {
        // Sub
        [`${n}-sub${n}-inline`]: {
          background: l
        },
        [`${n}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${q(d)} solid ${o}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${g} ${h}`, `opacity ${g} ${h}`].join(","),
            content: '""'
          },
          // Danger
          [`&${n}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: w
            }
          }
        },
        [`${n}-selected, ${n}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${g} ${v}`, `opacity ${g} ${v}`].join(",")
          }
        }
      }
    }
  };
}, Jg = VD, Zg = (e) => {
  const {
    componentCls: t,
    itemHeight: n,
    itemMarginInline: r,
    padding: o,
    menuArrowSize: a,
    marginXS: i,
    itemMarginBlock: l,
    itemWidth: c
  } = e, u = e.calc(a).add(o).add(i).equal();
  return {
    [`${t}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${t}-item, ${t}-submenu-title`]: {
      height: n,
      lineHeight: q(n),
      paddingInline: o,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: r,
      marginBlock: l,
      width: c
    },
    [`> ${t}-item,
            > ${t}-submenu > ${t}-submenu-title`]: {
      height: n,
      lineHeight: q(n)
    },
    [`${t}-item-group-list ${t}-submenu-title,
            ${t}-submenu-title`]: {
      paddingInlineEnd: u
    }
  };
}, WD = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    itemHeight: r,
    colorTextLightSolid: o,
    dropdownWidth: a,
    controlHeightLG: i,
    motionDurationMid: l,
    motionEaseOut: c,
    paddingXL: u,
    itemMarginInline: d,
    fontSizeLG: f,
    motionDurationSlow: m,
    paddingXS: v,
    boxShadowSecondary: h,
    collapsedWidth: p,
    collapsedIconSize: g
  } = e, b = {
    height: r,
    lineHeight: q(r),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [t]: {
        ["&-inline, &-vertical"]: Object.assign({
          [`&${t}-root`]: {
            boxShadow: "none"
          }
        }, Zg(e))
      },
      [`${t}-submenu-popup`]: {
        [`${t}-vertical`]: Object.assign(Object.assign({}, Zg(e)), {
          boxShadow: h
        })
      }
    },
    // Vertical only
    {
      [`${t}-submenu-popup ${t}-vertical${t}-sub`]: {
        minWidth: a,
        maxHeight: `calc(100vh - ${q(e.calc(i).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${t}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${m}`, `background ${m}`, `padding ${l} ${c}`].join(","),
            [`> ${t}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${t}-sub${t}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${t}-submenu > ${t}-submenu-title`]: b,
          [`& ${t}-item-group-title`]: {
            paddingInlineStart: u
          }
        },
        // >>>>> Item
        [`${t}-item`]: b
      }
    },
    // Inline Collapse Only
    {
      [`${t}-inline-collapsed`]: {
        width: p,
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu ${t}-submenu-title`]: {
            [`> ${t}-inline-collapsed-noicon`]: {
              fontSize: f,
              textAlign: "center"
            }
          }
        },
        [`> ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-submenu > ${t}-submenu-title,
          > ${t}-submenu > ${t}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${q(e.calc(f).div(2).equal())} - ${q(d)})`,
          textOverflow: "clip",
          [`
            ${t}-submenu-arrow,
            ${t}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${t}-item-icon, ${n}`]: {
            margin: 0,
            fontSize: g,
            lineHeight: q(r),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${t}-item-icon, ${n}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${t}-item-icon, ${n}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: o
          }
        },
        [`${t}-item-group-title`]: Object.assign(Object.assign({}, Vr), {
          paddingInline: v
        })
      }
    }
  ];
}, KD = WD, ep = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionDurationMid: r,
    motionEaseInOut: o,
    motionEaseOut: a,
    iconCls: i,
    iconSize: l,
    iconMarginInlineEnd: c
  } = e;
  return {
    // >>>>> Item
    [`${t}-item, ${t}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${n}`, `background ${n}`, `padding ${n} ${o}`].join(","),
      [`${t}-item-icon, ${i}`]: {
        minWidth: l,
        fontSize: l,
        transition: [`font-size ${r} ${a}`, `margin ${n} ${o}`, `color ${n}`].join(","),
        "+ span": {
          marginInlineStart: c,
          opacity: 1,
          transition: [`opacity ${n} ${o}`, `margin ${n}`, `color ${n}`].join(",")
        }
      },
      [`${t}-item-icon`]: Object.assign({}, Li()),
      [`&${t}-item-only-child`]: {
        [`> ${i}, > ${t}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${t}-item-disabled, ${t}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important"
      },
      [`> ${t}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, tp = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionEaseInOut: r,
    borderRadius: o,
    menuArrowSize: a,
    menuArrowOffset: i
  } = e;
  return {
    [`${t}-submenu`]: {
      ["&-expand-icon, &-arrow"]: {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: a,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${n} ${r}, opacity ${n}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: e.calc(a).mul(0.6).equal(),
          height: e.calc(a).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: o,
          transition: [`background ${n} ${r}`, `transform ${n} ${r}`, `top ${n} ${r}`, `color ${n} ${r}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${q(e.calc(i).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${q(i)})`
        }
      }
    }
  };
}, qD = (e) => {
  const {
    antCls: t,
    componentCls: n,
    fontSize: r,
    motionDurationSlow: o,
    motionDurationMid: a,
    motionEaseInOut: i,
    paddingXS: l,
    padding: c,
    colorSplit: u,
    lineWidth: d,
    zIndexPopup: f,
    borderRadiusLG: m,
    subMenuItemBorderRadius: v,
    menuArrowSize: h,
    menuArrowOffset: p,
    lineType: g,
    groupTitleLineHeight: b,
    groupTitleFontSize: y
  } = e;
  return [
    // Misc
    {
      "": {
        [`${n}`]: Object.assign(Object.assign({}, Mo()), {
          // Hidden
          ["&-hidden"]: {
            display: "none"
          }
        })
      },
      [`${n}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [n]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Gt(e)), Mo()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: r,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${o} cubic-bezier(0.2, 0, 0, 1) 0s`,
        ["ul, ol"]: {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        ["&-overflow"]: {
          display: "flex",
          [`${n}-item`]: {
            flex: "none"
          }
        },
        [`${n}-item, ${n}-submenu, ${n}-submenu-title`]: {
          borderRadius: e.itemBorderRadius
        },
        [`${n}-item-group-title`]: {
          padding: `${q(l)} ${q(c)}`,
          fontSize: y,
          lineHeight: b,
          transition: `all ${o}`
        },
        [`&-horizontal ${n}-submenu`]: {
          transition: [`border-color ${o} ${i}`, `background ${o} ${i}`].join(",")
        },
        [`${n}-submenu, ${n}-submenu-inline`]: {
          transition: [`border-color ${o} ${i}`, `background ${o} ${i}`, `padding ${a} ${i}`].join(",")
        },
        [`${n}-submenu ${n}-sub`]: {
          cursor: "initial",
          transition: [`background ${o} ${i}`, `padding ${o} ${i}`].join(",")
        },
        [`${n}-title-content`]: {
          transition: `color ${o}`,
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${t}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          }
        },
        [`${n}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${n}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: u,
          borderStyle: g,
          borderWidth: 0,
          borderTopWidth: d,
          marginBlock: d,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), ep(e)), {
        [`${n}-item-group`]: {
          [`${n}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${n}-item, ${n}-submenu-title`]: {
              paddingInline: `${q(e.calc(r).mul(2).equal())} ${q(c)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: f,
            borderRadius: m,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${n}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${n}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: m
            }, ep(e)), tp(e)), {
              [`${n}-item, ${n}-submenu > ${n}-submenu-title`]: {
                borderRadius: v
              },
              [`${n}-submenu-title::after`]: {
                transition: `transform ${o} ${i}`
              }
            })
          },
          [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
            transformOrigin: "100% 0"
          },
          [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
            transformOrigin: "100% 100%"
          },
          [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
            transformOrigin: "0 100%"
          },
          [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
            transformOrigin: "0 0"
          },
          [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
            paddingInlineEnd: e.paddingXS
          },
          [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
            paddingInlineStart: e.paddingXS
          },
          [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
            paddingBottom: e.paddingXS
          },
          [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
            paddingTop: e.paddingXS
          }
        }
      }), tp(e)), {
        [`&-inline-collapsed ${n}-submenu-arrow,
        &-inline ${n}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${q(p)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${q(e.calc(p).mul(-1).equal())})`
          }
        },
        [`${n}-submenu-open${n}-submenu-inline > ${n}-submenu-title > ${n}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${q(e.calc(h).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${q(e.calc(p).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${q(p)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${t}-layout-header`]: {
        [n]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, GD = (e) => {
  var t, n, r;
  const {
    colorPrimary: o,
    colorError: a,
    colorTextDisabled: i,
    colorErrorBg: l,
    colorText: c,
    colorTextDescription: u,
    colorBgContainer: d,
    colorFillAlter: f,
    colorFillContent: m,
    lineWidth: v,
    lineWidthBold: h,
    controlItemBgActive: p,
    colorBgTextHover: g,
    controlHeightLG: b,
    lineHeight: y,
    colorBgElevated: C,
    marginXXS: S,
    padding: $,
    fontSize: x,
    controlHeightSM: w,
    fontSizeLG: N,
    colorTextLightSolid: O,
    colorErrorHover: E
  } = e, I = (t = e.activeBarWidth) !== null && t !== void 0 ? t : 0, k = (n = e.activeBarBorderWidth) !== null && n !== void 0 ? n : v, M = (r = e.itemMarginInline) !== null && r !== void 0 ? r : e.marginXXS, P = new Zt(O).setAlpha(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: e.zIndexPopupBase + 50,
    radiusItem: e.borderRadiusLG,
    itemBorderRadius: e.borderRadiusLG,
    radiusSubMenuItem: e.borderRadiusSM,
    subMenuItemBorderRadius: e.borderRadiusSM,
    colorItemText: c,
    itemColor: c,
    colorItemTextHover: c,
    itemHoverColor: c,
    colorItemTextHoverHorizontal: o,
    horizontalItemHoverColor: o,
    colorGroupTitle: u,
    groupTitleColor: u,
    colorItemTextSelected: o,
    itemSelectedColor: o,
    colorItemTextSelectedHorizontal: o,
    horizontalItemSelectedColor: o,
    colorItemBg: d,
    itemBg: d,
    colorItemBgHover: g,
    itemHoverBg: g,
    colorItemBgActive: m,
    itemActiveBg: p,
    colorSubItemBg: f,
    subMenuItemBg: f,
    colorItemBgSelected: p,
    itemSelectedBg: p,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: I,
    colorActiveBarHeight: h,
    activeBarHeight: h,
    colorActiveBarBorderSize: v,
    activeBarBorderWidth: k,
    // Disabled
    colorItemTextDisabled: i,
    itemDisabledColor: i,
    // Danger
    colorDangerItemText: a,
    dangerItemColor: a,
    colorDangerItemTextHover: a,
    dangerItemHoverColor: a,
    colorDangerItemTextSelected: a,
    dangerItemSelectedColor: a,
    colorDangerItemBgActive: l,
    dangerItemActiveBg: l,
    colorDangerItemBgSelected: l,
    dangerItemSelectedBg: l,
    itemMarginInline: M,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: b,
    groupTitleLineHeight: y,
    collapsedWidth: b * 2,
    popupBg: C,
    itemMarginBlock: S,
    itemPaddingInline: $,
    horizontalLineHeight: `${b * 1.15}px`,
    iconSize: x,
    iconMarginInlineEnd: w - x,
    collapsedIconSize: N,
    groupTitleFontSize: x,
    // Disabled
    darkItemDisabledColor: new Zt(O).setAlpha(0.25).toRgbString(),
    // Dark
    darkItemColor: P,
    darkDangerItemColor: a,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: O,
    darkItemSelectedBg: o,
    darkDangerItemSelectedBg: a,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: P,
    darkItemHoverColor: O,
    darkDangerItemHoverColor: E,
    darkDangerItemSelectedColor: O,
    darkDangerItemActiveBg: a,
    // internal
    itemWidth: I ? `calc(100% + ${k}px)` : `calc(100% - ${M * 2}px)`
  };
}, UD = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return Xt("Menu", (o) => {
    const {
      colorBgElevated: a,
      colorPrimary: i,
      colorTextLightSolid: l,
      controlHeightLG: c,
      fontSize: u,
      darkItemColor: d,
      darkDangerItemColor: f,
      darkItemBg: m,
      darkSubMenuItemBg: v,
      darkItemSelectedColor: h,
      darkItemSelectedBg: p,
      darkDangerItemSelectedBg: g,
      darkItemHoverBg: b,
      darkGroupTitleColor: y,
      darkItemHoverColor: C,
      darkItemDisabledColor: S,
      darkDangerItemHoverColor: $,
      darkDangerItemSelectedColor: x,
      darkDangerItemActiveBg: w,
      popupBg: N,
      darkPopupBg: O
    } = o, E = o.calc(u).div(7).mul(5).equal(), I = Dt(o, {
      menuArrowSize: E,
      menuHorizontalHeight: o.calc(c).mul(1.15).equal(),
      menuArrowOffset: o.calc(E).mul(0.25).equal(),
      menuSubMenuBg: a,
      calc: o.calc,
      popupBg: N
    }), k = Dt(I, {
      itemColor: d,
      itemHoverColor: C,
      groupTitleColor: y,
      itemSelectedColor: h,
      itemBg: m,
      popupBg: O,
      subMenuItemBg: v,
      itemActiveBg: "transparent",
      itemSelectedBg: p,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: b,
      // Disabled
      itemDisabledColor: S,
      // Danger
      dangerItemColor: f,
      dangerItemHoverColor: $,
      dangerItemSelectedColor: x,
      dangerItemActiveBg: w,
      dangerItemSelectedBg: g,
      menuSubMenuBg: v,
      // Horizontal
      horizontalItemSelectedColor: l,
      horizontalItemSelectedBg: i
    });
    return [
      // Basic
      qD(I),
      // Horizontal
      AD(I),
      // Hard code for some light style
      // Vertical
      KD(I),
      // Hard code for some light style
      // Theme
      Jg(I, "light"),
      Jg(k, "dark"),
      // RTL
      HD(I),
      // Motion
      qi(I),
      Rr(I, "slide-up"),
      Rr(I, "slide-down"),
      Ki(I, "zoom-big")
    ];
  }, GD, {
    deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle: n,
    unitless: {
      groupTitleLineHeight: !0
    }
  })(e, t);
};
var YD = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const XD = /* @__PURE__ */ ar((e, t) => {
  var n, r;
  const o = s.useContext(Xg), a = o || {}, {
    getPrefixCls: i,
    getPopupContainer: l,
    direction: c,
    menu: u
  } = s.useContext(lt), d = i(), {
    prefixCls: f,
    className: m,
    style: v,
    theme: h = "light",
    expandIcon: p,
    _internalDisableMenuItemTitleTooltip: g,
    inlineCollapsed: b,
    siderCollapsed: y,
    items: C,
    children: S,
    rootClassName: $,
    mode: x,
    selectable: w,
    onClick: N,
    overflowedIndicatorPopupClassName: O
  } = e, E = YD(e, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "items", "children", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), I = an(E, ["collapsedWidth"]), k = FD(C) || S;
  if (process.env.NODE_ENV !== "production") {
    const G = Rt("Menu");
    process.env.NODE_ENV !== "production" && G(!("inlineCollapsed" in e && x !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline."), process.env.NODE_ENV !== "production" && G(!(e.siderCollapsed !== void 0 && "inlineCollapsed" in e), "usage", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead."), G.deprecated("items" in e && !S, "children", "items");
  }
  (n = a.validator) === null || n === void 0 || n.call(a, {
    mode: x
  });
  const M = Lt(function() {
    var G;
    N == null || N.apply(void 0, arguments), (G = a.onClick) === null || G === void 0 || G.call(a);
  }), P = a.mode || x, _ = w ?? a.selectable, D = s.useMemo(() => y !== void 0 ? y : b, [b, y]), R = {
    horizontal: {
      motionName: `${d}-slide-up`
    },
    inline: ya(d),
    other: {
      motionName: `${d}-zoom-big`
    }
  }, T = i("menu", f || a.prefixCls), L = En(T), [F, j, A] = UD(T, L, !o), B = J(`${T}-${h}`, u == null ? void 0 : u.className, m);
  let K;
  if (typeof p == "function")
    K = p;
  else if (p === null || p === !1)
    K = null;
  else if (a.expandIcon === null || a.expandIcon === !1)
    K = null;
  else {
    const G = p ?? a.expandIcon;
    K = xn(G, {
      className: J(`${T}-submenu-expand-icon`, Kn(G) ? (r = G.props) === null || r === void 0 ? void 0 : r.className : "")
    });
  }
  const Y = s.useMemo(() => ({
    prefixCls: T,
    inlineCollapsed: D || !1,
    direction: c,
    firstLevel: !0,
    theme: h,
    mode: P,
    disableMenuItemTitleTooltip: g
  }), [T, D, c, g, h]);
  return F(/* @__PURE__ */ s.createElement(Xg.Provider, {
    value: null
  }, /* @__PURE__ */ s.createElement(gs.Provider, {
    value: Y
  }, /* @__PURE__ */ s.createElement(Ra, Object.assign({
    getPopupContainer: l,
    overflowedIndicator: /* @__PURE__ */ s.createElement(am, null),
    overflowedIndicatorPopupClassName: J(T, `${T}-${h}`, O),
    mode: P,
    selectable: _,
    onClick: M
  }, I, {
    inlineCollapsed: D,
    style: Object.assign(Object.assign({}, u == null ? void 0 : u.style), v),
    className: B,
    prefixCls: T,
    direction: c,
    defaultMotions: R,
    expandIcon: K,
    ref: t,
    rootClassName: J($, j, a.rootClassName, A, L)
  }), k))));
}), QD = XD, Ma = /* @__PURE__ */ ar((e, t) => {
  const n = Xe(null), r = s.useContext(om);
  return qr(t, () => ({
    menu: n.current,
    focus: (o) => {
      var a;
      (a = n.current) === null || a === void 0 || a.focus(o);
    }
  })), /* @__PURE__ */ s.createElement(QD, Object.assign({
    ref: n
  }, e, r));
});
Ma.Item = xC;
Ma.SubMenu = $C;
Ma.Divider = SC;
Ma.ItemGroup = ec;
process.env.NODE_ENV !== "production" && (Ma.displayName = "Menu");
const Zi = Ma, JD = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    colorError: r,
    colorTextLightSolid: o
  } = e, a = `${n}-item`;
  return {
    [`${t}, ${t}-menu-submenu`]: {
      [`${n} ${a}`]: {
        [`&${a}-danger:not(${a}-disabled)`]: {
          color: r,
          "&:hover": {
            color: o,
            backgroundColor: r
          }
        }
      }
    }
  };
}, ZD = JD, ek = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    zIndexPopup: r,
    dropdownArrowDistance: o,
    sizePopupArrow: a,
    antCls: i,
    iconCls: l,
    motionDurationMid: c,
    paddingBlock: u,
    fontSize: d,
    dropdownEdgeChildPadding: f,
    colorTextDisabled: m,
    fontSizeIcon: v,
    controlPaddingHorizontal: h,
    colorBgElevated: p
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Gt(e)), {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: r,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: e.calc(a).div(2).sub(o).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        [`&-trigger${i}-btn`]: {
          [`& > ${l}-down, & > ${i}-btn-icon > ${l}-down`]: {
            fontSize: v
          }
        },
        [`${t}-wrap`]: {
          position: "relative",
          [`${i}-btn > ${l}-down`]: {
            fontSize: v
          },
          [`${l}-down::before`]: {
            transition: `transform ${c}`
          }
        },
        [`${t}-wrap-open`]: {
          [`${l}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${i}-slide-down-enter${i}-slide-down-enter-active${t}-placement-bottomLeft,
          &${i}-slide-down-appear${i}-slide-down-appear-active${t}-placement-bottomLeft,
          &${i}-slide-down-enter${i}-slide-down-enter-active${t}-placement-bottom,
          &${i}-slide-down-appear${i}-slide-down-appear-active${t}-placement-bottom,
          &${i}-slide-down-enter${i}-slide-down-enter-active${t}-placement-bottomRight,
          &${i}-slide-down-appear${i}-slide-down-appear-active${t}-placement-bottomRight`]: {
          animationName: Hs
        },
        [`&${i}-slide-up-enter${i}-slide-up-enter-active${t}-placement-topLeft,
          &${i}-slide-up-appear${i}-slide-up-appear-active${t}-placement-topLeft,
          &${i}-slide-up-enter${i}-slide-up-enter-active${t}-placement-top,
          &${i}-slide-up-appear${i}-slide-up-appear-active${t}-placement-top,
          &${i}-slide-up-enter${i}-slide-up-enter-active${t}-placement-topRight,
          &${i}-slide-up-appear${i}-slide-up-appear-active${t}-placement-topRight`]: {
          animationName: Ws
        },
        [`&${i}-slide-down-leave${i}-slide-down-leave-active${t}-placement-bottomLeft,
          &${i}-slide-down-leave${i}-slide-down-leave-active${t}-placement-bottom,
          &${i}-slide-down-leave${i}-slide-down-leave-active${t}-placement-bottomRight`]: {
          animationName: Vs
        },
        [`&${i}-slide-up-leave${i}-slide-up-leave-active${t}-placement-topLeft,
          &${i}-slide-up-leave${i}-slide-up-leave-active${t}-placement-top,
          &${i}-slide-up-leave${i}-slide-up-leave-active${t}-placement-topRight`]: {
          animationName: Ks
        }
      })
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    Yf(e, p, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${t} ${n}`]: {
        position: "relative",
        margin: 0
      },
      [`${n}-submenu-popup`]: {
        position: "absolute",
        zIndex: r,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${t}, ${t}-menu-submenu`]: {
        [n]: Object.assign(Object.assign({
          padding: f,
          listStyleType: "none",
          backgroundColor: p,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, lo(e)), {
          [`${n}-item-group-title`]: {
            padding: `${q(u)} ${q(h)}`,
            color: e.colorTextDescription,
            transition: `all ${c}`
          },
          // ======================= Item Content =======================
          [`${n}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${n}-item-icon`]: {
            minWidth: d,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${n}-title-content`]: {
            flex: "auto",
            "> a": {
              color: "inherit",
              transition: `all ${c}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            }
          },
          // =========================== Item ===========================
          [`${n}-item, ${n}-submenu-title`]: Object.assign(Object.assign({
            clear: "both",
            margin: 0,
            padding: `${q(u)} ${q(h)}`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: d,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${c}`,
            borderRadius: e.borderRadiusSM,
            ["&:hover, &-active"]: {
              backgroundColor: e.controlItemBgHover
            }
          }, lo(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: m,
              cursor: "not-allowed",
              "&:hover": {
                color: m,
                backgroundColor: p,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${q(e.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${t}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${t}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorTextDescription,
                fontSize: v,
                fontStyle: "normal"
              }
            }
          }),
          [`${n}-item-group-list`]: {
            margin: `0 ${q(e.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${n}-submenu-title`]: {
            paddingInlineEnd: e.calc(h).add(e.fontSizeSM).equal()
          },
          [`${n}-submenu-vertical`]: {
            position: "relative"
          },
          [`${n}-submenu${n}-submenu-disabled ${t}-menu-submenu-title`]: {
            [`&, ${t}-menu-submenu-arrow-icon`]: {
              color: m,
              backgroundColor: p,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${n}-submenu-selected ${t}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      }
    },
    // Follow code may reuse in other components
    [Rr(e, "slide-up"), Rr(e, "slide-down"), Ca(e, "move-up"), Ca(e, "move-down"), Ki(e, "zoom-big")]
  ];
}, tk = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 50,
  paddingBlock: (e.controlHeight - e.fontSize * e.lineHeight) / 2
}, Qs({
  contentRadius: e.borderRadiusLG,
  limitVerticalRadius: !0
})), Xs(e)), nk = Xt("Dropdown", (e) => {
  const {
    marginXXS: t,
    sizePopupArrow: n,
    paddingXXS: r,
    componentCls: o
  } = e, a = Dt(e, {
    menuCls: `${o}-menu`,
    dropdownArrowDistance: e.calc(n).div(2).add(t).equal(),
    dropdownEdgeChildPadding: r
  });
  return [ek(a), ZD(a)];
}, tk), tc = (e) => {
  const {
    menu: t,
    arrow: n,
    prefixCls: r,
    children: o,
    trigger: a,
    disabled: i,
    dropdownRender: l,
    getPopupContainer: c,
    overlayClassName: u,
    rootClassName: d,
    overlayStyle: f,
    open: m,
    onOpenChange: v,
    // Deprecated
    visible: h,
    onVisibleChange: p,
    mouseEnterDelay: g = 0.15,
    mouseLeaveDelay: b = 0.1,
    autoAdjustOverflow: y = !0,
    placement: C = "",
    overlay: S,
    transitionName: $
  } = e, {
    getPopupContainer: x,
    getPrefixCls: w,
    direction: N,
    dropdown: O
  } = s.useContext(lt), E = Rt("Dropdown");
  process.env.NODE_ENV !== "production" && ([["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((Z) => {
    let [H, U] = Z;
    E.deprecated(!(H in e), H, U);
  }), E.deprecated(!("overlay" in e), "overlay", "menu"));
  const I = s.useMemo(() => {
    const Z = w();
    return $ !== void 0 ? $ : C.includes("top") ? `${Z}-slide-down` : `${Z}-slide-up`;
  }, [w, C, $]), k = s.useMemo(() => C ? C.includes("Center") ? C.slice(0, C.indexOf("Center")) : C : N === "rtl" ? "bottomRight" : "bottomLeft", [C, N]);
  if (process.env.NODE_ENV !== "production") {
    if (C.includes("Center")) {
      const Z = C.slice(0, C.indexOf("Center"));
      process.env.NODE_ENV !== "production" && E(!C.includes("Center"), "deprecated", `You are using '${C}' placement in Dropdown, which is deprecated. Try to use '${Z}' instead.`);
    }
    [["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((Z) => {
      let [H, U] = Z;
      E.deprecated(!(H in e), H, U);
    });
  }
  const M = w("dropdown", r), P = En(M), [_, D, R] = nk(M, P), [, T] = Sn(), L = s.Children.only(o), F = xn(L, {
    className: J(`${M}-trigger`, {
      [`${M}-rtl`]: N === "rtl"
    }, L.props.className),
    disabled: i
  }), j = i ? [] : a;
  let A;
  j && j.includes("contextMenu") && (A = !0);
  const [B, K] = Vt(!1, {
    value: m ?? h
  }), Y = Lt((Z) => {
    v == null || v(Z, {
      source: "trigger"
    }), p == null || p(Z), K(Z);
  }), G = J(u, d, D, R, P, O == null ? void 0 : O.className, {
    [`${M}-rtl`]: N === "rtl"
  }), te = Jy({
    arrowPointAtCenter: typeof n == "object" && n.pointAtCenter,
    autoAdjustOverflow: y,
    offset: T.marginXXS,
    arrowWidth: n ? T.sizePopupArrow : 0,
    borderRadius: T.borderRadius
  }), ee = s.useCallback(() => {
    t != null && t.selectable && (t != null && t.multiple) || (v == null || v(!1, {
      source: "menu"
    }), K(!1));
  }, [t == null ? void 0 : t.selectable, t == null ? void 0 : t.multiple]), oe = () => {
    let Z;
    return t != null && t.items ? Z = /* @__PURE__ */ s.createElement(Zi, Object.assign({}, t)) : typeof S == "function" ? Z = S() : Z = S, l && (Z = l(Z)), Z = s.Children.only(typeof Z == "string" ? /* @__PURE__ */ s.createElement("span", null, Z) : Z), /* @__PURE__ */ s.createElement(wC, {
      prefixCls: `${M}-menu`,
      rootClassName: J(R, P),
      expandIcon: /* @__PURE__ */ s.createElement("span", {
        className: `${M}-menu-submenu-arrow`
      }, /* @__PURE__ */ s.createElement($a, {
        className: `${M}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: ee,
      validator: (H) => {
        let {
          mode: U
        } = H;
        process.env.NODE_ENV !== "production" && E(!U || U === "vertical", "usage", `mode="${U}" is not supported for Dropdown's Menu.`);
      }
    }, Z);
  }, [X, W] = vo("Dropdown", f == null ? void 0 : f.zIndex);
  let re = /* @__PURE__ */ s.createElement(iC, Object.assign({
    alignPoint: A
  }, an(e, ["rootClassName"]), {
    mouseEnterDelay: g,
    mouseLeaveDelay: b,
    visible: B,
    builtinPlacements: te,
    arrow: !!n,
    overlayClassName: G,
    prefixCls: M,
    getPopupContainer: c || x,
    transitionName: I,
    trigger: j,
    overlay: oe,
    placement: k,
    onVisibleChange: Y,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, O == null ? void 0 : O.style), f), {
      zIndex: X
    })
  }), F);
  return X && (re = /* @__PURE__ */ s.createElement(ji.Provider, {
    value: W
  }, re)), _(re);
};
function rk(e) {
  return Object.assign(Object.assign({}, e), {
    align: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
}
const ok = qs(tc, "dropdown", (e) => e, rk), ak = (e) => /* @__PURE__ */ s.createElement(ok, Object.assign({}, e), /* @__PURE__ */ s.createElement("span", null));
tc._InternalPanelDoNotUseOrYouWillBeFired = ak;
process.env.NODE_ENV !== "production" && (tc.displayName = "Dropdown");
const EC = tc;
var ps = {}, ik = {
  get exports() {
    return ps;
  },
  set exports(e) {
    ps = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(fo, function() {
    var n = 1e3, r = 6e4, o = 36e5, a = "millisecond", i = "second", l = "minute", c = "hour", u = "day", d = "week", f = "month", m = "quarter", v = "year", h = "date", p = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(P) {
      var _ = ["th", "st", "nd", "rd"], D = P % 100;
      return "[" + P + (_[(D - 20) % 10] || _[D] || _[0]) + "]";
    } }, C = function(P, _, D) {
      var R = String(P);
      return !R || R.length >= _ ? P : "" + Array(_ + 1 - R.length).join(D) + P;
    }, S = { s: C, z: function(P) {
      var _ = -P.utcOffset(), D = Math.abs(_), R = Math.floor(D / 60), T = D % 60;
      return (_ <= 0 ? "+" : "-") + C(R, 2, "0") + ":" + C(T, 2, "0");
    }, m: function P(_, D) {
      if (_.date() < D.date())
        return -P(D, _);
      var R = 12 * (D.year() - _.year()) + (D.month() - _.month()), T = _.clone().add(R, f), L = D - T < 0, F = _.clone().add(R + (L ? -1 : 1), f);
      return +(-(R + (D - T) / (L ? T - F : F - T)) || 0);
    }, a: function(P) {
      return P < 0 ? Math.ceil(P) || 0 : Math.floor(P);
    }, p: function(P) {
      return { M: f, y: v, w: d, d: u, D: h, h: c, m: l, s: i, ms: a, Q: m }[P] || String(P || "").toLowerCase().replace(/s$/, "");
    }, u: function(P) {
      return P === void 0;
    } }, $ = "en", x = {};
    x[$] = y;
    var w = "$isDayjsObject", N = function(P) {
      return P instanceof k || !(!P || !P[w]);
    }, O = function P(_, D, R) {
      var T;
      if (!_)
        return $;
      if (typeof _ == "string") {
        var L = _.toLowerCase();
        x[L] && (T = L), D && (x[L] = D, T = L);
        var F = _.split("-");
        if (!T && F.length > 1)
          return P(F[0]);
      } else {
        var j = _.name;
        x[j] = _, T = j;
      }
      return !R && T && ($ = T), T || !R && $;
    }, E = function(P, _) {
      if (N(P))
        return P.clone();
      var D = typeof _ == "object" ? _ : {};
      return D.date = P, D.args = arguments, new k(D);
    }, I = S;
    I.l = O, I.i = N, I.w = function(P, _) {
      return E(P, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
    };
    var k = function() {
      function P(D) {
        this.$L = O(D.locale, null, !0), this.parse(D), this.$x = this.$x || D.x || {}, this[w] = !0;
      }
      var _ = P.prototype;
      return _.parse = function(D) {
        this.$d = function(R) {
          var T = R.date, L = R.utc;
          if (T === null)
            return /* @__PURE__ */ new Date(NaN);
          if (I.u(T))
            return /* @__PURE__ */ new Date();
          if (T instanceof Date)
            return new Date(T);
          if (typeof T == "string" && !/Z$/i.test(T)) {
            var F = T.match(g);
            if (F) {
              var j = F[2] - 1 || 0, A = (F[7] || "0").substring(0, 3);
              return L ? new Date(Date.UTC(F[1], j, F[3] || 1, F[4] || 0, F[5] || 0, F[6] || 0, A)) : new Date(F[1], j, F[3] || 1, F[4] || 0, F[5] || 0, F[6] || 0, A);
            }
          }
          return new Date(T);
        }(D), this.init();
      }, _.init = function() {
        var D = this.$d;
        this.$y = D.getFullYear(), this.$M = D.getMonth(), this.$D = D.getDate(), this.$W = D.getDay(), this.$H = D.getHours(), this.$m = D.getMinutes(), this.$s = D.getSeconds(), this.$ms = D.getMilliseconds();
      }, _.$utils = function() {
        return I;
      }, _.isValid = function() {
        return this.$d.toString() !== p;
      }, _.isSame = function(D, R) {
        var T = E(D);
        return this.startOf(R) <= T && T <= this.endOf(R);
      }, _.isAfter = function(D, R) {
        return E(D) < this.startOf(R);
      }, _.isBefore = function(D, R) {
        return this.endOf(R) < E(D);
      }, _.$g = function(D, R, T) {
        return I.u(D) ? this[R] : this.set(T, D);
      }, _.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, _.valueOf = function() {
        return this.$d.getTime();
      }, _.startOf = function(D, R) {
        var T = this, L = !!I.u(R) || R, F = I.p(D), j = function(oe, X) {
          var W = I.w(T.$u ? Date.UTC(T.$y, X, oe) : new Date(T.$y, X, oe), T);
          return L ? W : W.endOf(u);
        }, A = function(oe, X) {
          return I.w(T.toDate()[oe].apply(T.toDate("s"), (L ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(X)), T);
        }, B = this.$W, K = this.$M, Y = this.$D, G = "set" + (this.$u ? "UTC" : "");
        switch (F) {
          case v:
            return L ? j(1, 0) : j(31, 11);
          case f:
            return L ? j(1, K) : j(0, K + 1);
          case d:
            var te = this.$locale().weekStart || 0, ee = (B < te ? B + 7 : B) - te;
            return j(L ? Y - ee : Y + (6 - ee), K);
          case u:
          case h:
            return A(G + "Hours", 0);
          case c:
            return A(G + "Minutes", 1);
          case l:
            return A(G + "Seconds", 2);
          case i:
            return A(G + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, _.endOf = function(D) {
        return this.startOf(D, !1);
      }, _.$set = function(D, R) {
        var T, L = I.p(D), F = "set" + (this.$u ? "UTC" : ""), j = (T = {}, T[u] = F + "Date", T[h] = F + "Date", T[f] = F + "Month", T[v] = F + "FullYear", T[c] = F + "Hours", T[l] = F + "Minutes", T[i] = F + "Seconds", T[a] = F + "Milliseconds", T)[L], A = L === u ? this.$D + (R - this.$W) : R;
        if (L === f || L === v) {
          var B = this.clone().set(h, 1);
          B.$d[j](A), B.init(), this.$d = B.set(h, Math.min(this.$D, B.daysInMonth())).$d;
        } else
          j && this.$d[j](A);
        return this.init(), this;
      }, _.set = function(D, R) {
        return this.clone().$set(D, R);
      }, _.get = function(D) {
        return this[I.p(D)]();
      }, _.add = function(D, R) {
        var T, L = this;
        D = Number(D);
        var F = I.p(R), j = function(K) {
          var Y = E(L);
          return I.w(Y.date(Y.date() + Math.round(K * D)), L);
        };
        if (F === f)
          return this.set(f, this.$M + D);
        if (F === v)
          return this.set(v, this.$y + D);
        if (F === u)
          return j(1);
        if (F === d)
          return j(7);
        var A = (T = {}, T[l] = r, T[c] = o, T[i] = n, T)[F] || 1, B = this.$d.getTime() + D * A;
        return I.w(B, this);
      }, _.subtract = function(D, R) {
        return this.add(-1 * D, R);
      }, _.format = function(D) {
        var R = this, T = this.$locale();
        if (!this.isValid())
          return T.invalidDate || p;
        var L = D || "YYYY-MM-DDTHH:mm:ssZ", F = I.z(this), j = this.$H, A = this.$m, B = this.$M, K = T.weekdays, Y = T.months, G = T.meridiem, te = function(X, W, re, Z) {
          return X && (X[W] || X(R, L)) || re[W].slice(0, Z);
        }, ee = function(X) {
          return I.s(j % 12 || 12, X, "0");
        }, oe = G || function(X, W, re) {
          var Z = X < 12 ? "AM" : "PM";
          return re ? Z.toLowerCase() : Z;
        };
        return L.replace(b, function(X, W) {
          return W || function(re) {
            switch (re) {
              case "YY":
                return String(R.$y).slice(-2);
              case "YYYY":
                return I.s(R.$y, 4, "0");
              case "M":
                return B + 1;
              case "MM":
                return I.s(B + 1, 2, "0");
              case "MMM":
                return te(T.monthsShort, B, Y, 3);
              case "MMMM":
                return te(Y, B);
              case "D":
                return R.$D;
              case "DD":
                return I.s(R.$D, 2, "0");
              case "d":
                return String(R.$W);
              case "dd":
                return te(T.weekdaysMin, R.$W, K, 2);
              case "ddd":
                return te(T.weekdaysShort, R.$W, K, 3);
              case "dddd":
                return K[R.$W];
              case "H":
                return String(j);
              case "HH":
                return I.s(j, 2, "0");
              case "h":
                return ee(1);
              case "hh":
                return ee(2);
              case "a":
                return oe(j, A, !0);
              case "A":
                return oe(j, A, !1);
              case "m":
                return String(A);
              case "mm":
                return I.s(A, 2, "0");
              case "s":
                return String(R.$s);
              case "ss":
                return I.s(R.$s, 2, "0");
              case "SSS":
                return I.s(R.$ms, 3, "0");
              case "Z":
                return F;
            }
            return null;
          }(X) || F.replace(":", "");
        });
      }, _.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, _.diff = function(D, R, T) {
        var L, F = this, j = I.p(R), A = E(D), B = (A.utcOffset() - this.utcOffset()) * r, K = this - A, Y = function() {
          return I.m(F, A);
        };
        switch (j) {
          case v:
            L = Y() / 12;
            break;
          case f:
            L = Y();
            break;
          case m:
            L = Y() / 3;
            break;
          case d:
            L = (K - B) / 6048e5;
            break;
          case u:
            L = (K - B) / 864e5;
            break;
          case c:
            L = K / o;
            break;
          case l:
            L = K / r;
            break;
          case i:
            L = K / n;
            break;
          default:
            L = K;
        }
        return T ? L : I.a(L);
      }, _.daysInMonth = function() {
        return this.endOf(f).$D;
      }, _.$locale = function() {
        return x[this.$L];
      }, _.locale = function(D, R) {
        if (!D)
          return this.$L;
        var T = this.clone(), L = O(D, R, !0);
        return L && (T.$L = L), T;
      }, _.clone = function() {
        return I.w(this.$d, this);
      }, _.toDate = function() {
        return new Date(this.valueOf());
      }, _.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, _.toISOString = function() {
        return this.$d.toISOString();
      }, _.toString = function() {
        return this.$d.toUTCString();
      }, P;
    }(), M = k.prototype;
    return E.prototype = M, [["$ms", a], ["$s", i], ["$m", l], ["$H", c], ["$W", u], ["$M", f], ["$y", v], ["$D", h]].forEach(function(P) {
      M[P[1]] = function(_) {
        return this.$g(_, P[0], P[1]);
      };
    }), E.extend = function(P, _) {
      return P.$i || (P(_, k, E), P.$i = !0), E;
    }, E.locale = O, E.isDayjs = N, E.unix = function(P) {
      return E(1e3 * P);
    }, E.en = x[$], E.Ls = x, E.p = {}, E;
  });
})(ik);
const Vn = ps;
var Rd = {}, lk = {
  get exports() {
    return Rd;
  },
  set exports(e) {
    Rd = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(fo, function() {
    return function(n, r) {
      r.prototype.weekday = function(o) {
        var a = this.$locale().weekStart || 0, i = this.$W, l = (i < a ? i + 7 : i) - a;
        return this.$utils().u(o) ? l : this.subtract(l, "day").add(o, "day");
      };
    };
  });
})(lk);
const sk = Rd;
var Md = {}, ck = {
  get exports() {
    return Md;
  },
  set exports(e) {
    Md = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(fo, function() {
    return function(n, r, o) {
      var a = r.prototype, i = function(f) {
        return f && (f.indexOf ? f : f.s);
      }, l = function(f, m, v, h, p) {
        var g = f.name ? f : f.$locale(), b = i(g[m]), y = i(g[v]), C = b || y.map(function($) {
          return $.slice(0, h);
        });
        if (!p)
          return C;
        var S = g.weekStart;
        return C.map(function($, x) {
          return C[(x + (S || 0)) % 7];
        });
      }, c = function() {
        return o.Ls[o.locale()];
      }, u = function(f, m) {
        return f.formats[m] || function(v) {
          return v.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(h, p, g) {
            return p || g.slice(1);
          });
        }(f.formats[m.toUpperCase()]);
      }, d = function() {
        var f = this;
        return { months: function(m) {
          return m ? m.format("MMMM") : l(f, "months");
        }, monthsShort: function(m) {
          return m ? m.format("MMM") : l(f, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return f.$locale().weekStart || 0;
        }, weekdays: function(m) {
          return m ? m.format("dddd") : l(f, "weekdays");
        }, weekdaysMin: function(m) {
          return m ? m.format("dd") : l(f, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(m) {
          return m ? m.format("ddd") : l(f, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(m) {
          return u(f.$locale(), m);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      a.localeData = function() {
        return d.bind(this)();
      }, o.localeData = function() {
        var f = c();
        return { firstDayOfWeek: function() {
          return f.weekStart || 0;
        }, weekdays: function() {
          return o.weekdays();
        }, weekdaysShort: function() {
          return o.weekdaysShort();
        }, weekdaysMin: function() {
          return o.weekdaysMin();
        }, months: function() {
          return o.months();
        }, monthsShort: function() {
          return o.monthsShort();
        }, longDateFormat: function(m) {
          return u(f, m);
        }, meridiem: f.meridiem, ordinal: f.ordinal };
      }, o.months = function() {
        return l(c(), "months");
      }, o.monthsShort = function() {
        return l(c(), "monthsShort", "months", 3);
      }, o.weekdays = function(f) {
        return l(c(), "weekdays", null, null, f);
      }, o.weekdaysShort = function(f) {
        return l(c(), "weekdaysShort", "weekdays", 3, f);
      }, o.weekdaysMin = function(f) {
        return l(c(), "weekdaysMin", "weekdays", 2, f);
      };
    };
  });
})(ck);
const uk = Md;
var Td = {}, dk = {
  get exports() {
    return Td;
  },
  set exports(e) {
    Td = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(fo, function() {
    var n = "week", r = "year";
    return function(o, a, i) {
      var l = a.prototype;
      l.week = function(c) {
        if (c === void 0 && (c = null), c !== null)
          return this.add(7 * (c - this.week()), "day");
        var u = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var d = i(this).startOf(r).add(1, r).date(u), f = i(this).endOf(n);
          if (d.isBefore(f))
            return 1;
        }
        var m = i(this).startOf(r).date(u).startOf(n).subtract(1, "millisecond"), v = this.diff(m, n, !0);
        return v < 0 ? i(this).startOf("week").week() : Math.ceil(v);
      }, l.weeks = function(c) {
        return c === void 0 && (c = null), this.week(c);
      };
    };
  });
})(dk);
const fk = Td;
var _d = {}, mk = {
  get exports() {
    return _d;
  },
  set exports(e) {
    _d = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(fo, function() {
    return function(n, r) {
      r.prototype.weekYear = function() {
        var o = this.month(), a = this.week(), i = this.year();
        return a === 1 && o === 11 ? i + 1 : o === 0 && a >= 52 ? i - 1 : i;
      };
    };
  });
})(mk);
const vk = _d;
var Dd = {}, gk = {
  get exports() {
    return Dd;
  },
  set exports(e) {
    Dd = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(fo, function() {
    return function(n, r) {
      var o = r.prototype, a = o.format;
      o.format = function(i) {
        var l = this, c = this.$locale();
        if (!this.isValid())
          return a.bind(this)(i);
        var u = this.$utils(), d = (i || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(f) {
          switch (f) {
            case "Q":
              return Math.ceil((l.$M + 1) / 3);
            case "Do":
              return c.ordinal(l.$D);
            case "gggg":
              return l.weekYear();
            case "GGGG":
              return l.isoWeekYear();
            case "wo":
              return c.ordinal(l.week(), "W");
            case "w":
            case "ww":
              return u.s(l.week(), f === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return u.s(l.isoWeek(), f === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return u.s(String(l.$H === 0 ? 24 : l.$H), f === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(l.$d.getTime() / 1e3);
            case "x":
              return l.$d.getTime();
            case "z":
              return "[" + l.offsetName() + "]";
            case "zzz":
              return "[" + l.offsetName("long") + "]";
            default:
              return f;
          }
        });
        return a.bind(this)(d);
      };
    };
  });
})(gk);
const pk = Dd;
var kd = {}, hk = {
  get exports() {
    return kd;
  },
  set exports(e) {
    kd = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(fo, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, o = /\d\d/, a = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, l = {}, c = function(p) {
      return (p = +p) + (p > 68 ? 1900 : 2e3);
    }, u = function(p) {
      return function(g) {
        this[p] = +g;
      };
    }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(p) {
      (this.zone || (this.zone = {})).offset = function(g) {
        if (!g || g === "Z")
          return 0;
        var b = g.match(/([+-]|\d\d)/g), y = 60 * b[1] + (+b[2] || 0);
        return y === 0 ? 0 : b[0] === "+" ? -y : y;
      }(p);
    }], f = function(p) {
      var g = l[p];
      return g && (g.indexOf ? g : g.s.concat(g.f));
    }, m = function(p, g) {
      var b, y = l.meridiem;
      if (y) {
        for (var C = 1; C <= 24; C += 1)
          if (p.indexOf(y(C, 0, g)) > -1) {
            b = C > 12;
            break;
          }
      } else
        b = p === (g ? "pm" : "PM");
      return b;
    }, v = { A: [i, function(p) {
      this.afternoon = m(p, !1);
    }], a: [i, function(p) {
      this.afternoon = m(p, !0);
    }], S: [/\d/, function(p) {
      this.milliseconds = 100 * +p;
    }], SS: [o, function(p) {
      this.milliseconds = 10 * +p;
    }], SSS: [/\d{3}/, function(p) {
      this.milliseconds = +p;
    }], s: [a, u("seconds")], ss: [a, u("seconds")], m: [a, u("minutes")], mm: [a, u("minutes")], H: [a, u("hours")], h: [a, u("hours")], HH: [a, u("hours")], hh: [a, u("hours")], D: [a, u("day")], DD: [o, u("day")], Do: [i, function(p) {
      var g = l.ordinal, b = p.match(/\d+/);
      if (this.day = b[0], g)
        for (var y = 1; y <= 31; y += 1)
          g(y).replace(/\[|\]/g, "") === p && (this.day = y);
    }], M: [a, u("month")], MM: [o, u("month")], MMM: [i, function(p) {
      var g = f("months"), b = (f("monthsShort") || g.map(function(y) {
        return y.slice(0, 3);
      })).indexOf(p) + 1;
      if (b < 1)
        throw new Error();
      this.month = b % 12 || b;
    }], MMMM: [i, function(p) {
      var g = f("months").indexOf(p) + 1;
      if (g < 1)
        throw new Error();
      this.month = g % 12 || g;
    }], Y: [/[+-]?\d+/, u("year")], YY: [o, function(p) {
      this.year = c(p);
    }], YYYY: [/\d{4}/, u("year")], Z: d, ZZ: d };
    function h(p) {
      var g, b;
      g = p, b = l && l.formats;
      for (var y = (p = g.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(O, E, I) {
        var k = I && I.toUpperCase();
        return E || b[I] || n[I] || b[k].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(M, P, _) {
          return P || _.slice(1);
        });
      })).match(r), C = y.length, S = 0; S < C; S += 1) {
        var $ = y[S], x = v[$], w = x && x[0], N = x && x[1];
        y[S] = N ? { regex: w, parser: N } : $.replace(/^\[|\]$/g, "");
      }
      return function(O) {
        for (var E = {}, I = 0, k = 0; I < C; I += 1) {
          var M = y[I];
          if (typeof M == "string")
            k += M.length;
          else {
            var P = M.regex, _ = M.parser, D = O.slice(k), R = P.exec(D)[0];
            _.call(E, R), O = O.replace(R, "");
          }
        }
        return function(T) {
          var L = T.afternoon;
          if (L !== void 0) {
            var F = T.hours;
            L ? F < 12 && (T.hours += 12) : F === 12 && (T.hours = 0), delete T.afternoon;
          }
        }(E), E;
      };
    }
    return function(p, g, b) {
      b.p.customParseFormat = !0, p && p.parseTwoDigitYear && (c = p.parseTwoDigitYear);
      var y = g.prototype, C = y.parse;
      y.parse = function(S) {
        var $ = S.date, x = S.utc, w = S.args;
        this.$u = x;
        var N = w[1];
        if (typeof N == "string") {
          var O = w[2] === !0, E = w[3] === !0, I = O || E, k = w[2];
          E && (k = w[2]), l = this.$locale(), !O && k && (l = b.Ls[k]), this.$d = function(D, R, T) {
            try {
              if (["x", "X"].indexOf(R) > -1)
                return new Date((R === "X" ? 1e3 : 1) * D);
              var L = h(R)(D), F = L.year, j = L.month, A = L.day, B = L.hours, K = L.minutes, Y = L.seconds, G = L.milliseconds, te = L.zone, ee = /* @__PURE__ */ new Date(), oe = A || (F || j ? 1 : ee.getDate()), X = F || ee.getFullYear(), W = 0;
              F && !j || (W = j > 0 ? j - 1 : ee.getMonth());
              var re = B || 0, Z = K || 0, H = Y || 0, U = G || 0;
              return te ? new Date(Date.UTC(X, W, oe, re, Z, H, U + 60 * te.offset * 1e3)) : T ? new Date(Date.UTC(X, W, oe, re, Z, H, U)) : new Date(X, W, oe, re, Z, H, U);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }($, N, x), this.init(), k && k !== !0 && (this.$L = this.locale(k).$L), I && $ != this.format(N) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
        } else if (N instanceof Array)
          for (var M = N.length, P = 1; P <= M; P += 1) {
            w[1] = N[P - 1];
            var _ = b.apply(this, w);
            if (_.isValid()) {
              this.$d = _.$d, this.$L = _.$L, this.init();
              break;
            }
            P === M && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          C.call(this, S);
      };
    };
  });
})(hk);
const bk = kd;
Vn.extend(bk);
Vn.extend(pk);
Vn.extend(sk);
Vn.extend(uk);
Vn.extend(fk);
Vn.extend(vk);
Vn.extend(function(e, t) {
  var n = t.prototype, r = n.format;
  n.format = function(a) {
    var i = (a || "").replace("Wo", "wo");
    return r.bind(this)(i);
  };
});
var yk = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, bo = function(t) {
  var n = yk[t];
  return n || t.split("_")[0];
}, np = function() {
  Zl(!1, "Not match any format. Please help to fire a issue about this.");
}, OC = {
  // get
  getNow: function() {
    return Vn();
  },
  getFixedDate: function(t) {
    return Vn(t, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function(t) {
    return t.endOf("month");
  },
  getWeekDay: function(t) {
    var n = t.locale("en");
    return n.weekday() + n.localeData().firstDayOfWeek();
  },
  getYear: function(t) {
    return t.year();
  },
  getMonth: function(t) {
    return t.month();
  },
  getDate: function(t) {
    return t.date();
  },
  getHour: function(t) {
    return t.hour();
  },
  getMinute: function(t) {
    return t.minute();
  },
  getSecond: function(t) {
    return t.second();
  },
  getMillisecond: function(t) {
    return t.millisecond();
  },
  // set
  addYear: function(t, n) {
    return t.add(n, "year");
  },
  addMonth: function(t, n) {
    return t.add(n, "month");
  },
  addDate: function(t, n) {
    return t.add(n, "day");
  },
  setYear: function(t, n) {
    return t.year(n);
  },
  setMonth: function(t, n) {
    return t.month(n);
  },
  setDate: function(t, n) {
    return t.date(n);
  },
  setHour: function(t, n) {
    return t.hour(n);
  },
  setMinute: function(t, n) {
    return t.minute(n);
  },
  setSecond: function(t, n) {
    return t.second(n);
  },
  setMillisecond: function(t, n) {
    return t.millisecond(n);
  },
  // Compare
  isAfter: function(t, n) {
    return t.isAfter(n);
  },
  isValidate: function(t) {
    return t.isValid();
  },
  locale: {
    getWeekFirstDay: function(t) {
      return Vn().locale(bo(t)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function(t, n) {
      return n.locale(bo(t)).weekday(0);
    },
    getWeek: function(t, n) {
      return n.locale(bo(t)).week();
    },
    getShortWeekDays: function(t) {
      return Vn().locale(bo(t)).localeData().weekdaysMin();
    },
    getShortMonths: function(t) {
      return Vn().locale(bo(t)).localeData().monthsShort();
    },
    format: function(t, n, r) {
      return n.locale(bo(t)).format(r);
    },
    parse: function(t, n, r) {
      for (var o = bo(t), a = 0; a < r.length; a += 1) {
        var i = r[a], l = n;
        if (i.includes("wo") || i.includes("Wo")) {
          for (var c = l.split("-")[0], u = l.split("-")[1], d = Vn(c, "YYYY").startOf("year").locale(o), f = 0; f <= 52; f += 1) {
            var m = d.add(f, "week");
            if (m.format("Wo") === u)
              return m;
          }
          return np(), null;
        }
        var v = Vn(l, i, !0).locale(o);
        if (v.isValid())
          return v;
      }
      return n && np(), null;
    }
  }
}, Er = /* @__PURE__ */ s.createContext(null), Ck = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function NC(e) {
  var t = e.popupElement, n = e.popupStyle, r = e.popupClassName, o = e.popupAlign, a = e.transitionName, i = e.getPopupContainer, l = e.children, c = e.range, u = e.placement, d = e.builtinPlacements, f = d === void 0 ? Ck : d, m = e.direction, v = e.visible, h = e.onClose, p = s.useContext(Er), g = p.prefixCls, b = "".concat(g, "-dropdown"), y = s.useMemo(function() {
    return u !== void 0 ? u : m === "rtl" ? "bottomRight" : "bottomLeft";
  }, [u, m]);
  return /* @__PURE__ */ s.createElement(Yi, {
    showAction: [],
    hideAction: ["click"],
    popupPlacement: y,
    builtinPlacements: f,
    prefixCls: b,
    popupTransitionName: a,
    popup: t,
    popupAlign: o,
    popupVisible: v,
    popupClassName: J(r, z(z({}, "".concat(b, "-range"), c), "".concat(b, "-rtl"), m === "rtl")),
    popupStyle: n,
    stretch: "minWidth",
    getPopupContainer: i,
    onPopupVisibleChange: function(S) {
      S || h();
    }
  }, l);
}
function im(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", r = String(e); r.length < t; )
    r = "".concat(n).concat(r);
  return r;
}
function Wo(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function mi(e, t, n) {
  var r = be(e);
  return r[t] = n, r;
}
function nc(e, t) {
  var n = {}, r = t || Object.keys(e);
  return r.forEach(function(o) {
    e[o] !== void 0 && (n[o] = e[o]);
  }), n;
}
function IC(e, t, n) {
  if (n)
    return n;
  switch (e) {
    case "time":
      return t.fieldTimeFormat;
    case "datetime":
      return t.fieldDateTimeFormat;
    case "month":
      return t.fieldMonthFormat;
    case "year":
      return t.fieldYearFormat;
    case "quarter":
      return t.fieldQuarterFormat;
    case "week":
      return t.fieldWeekFormat;
    default:
      return t.fieldDateFormat;
  }
}
function PC(e) {
  return nc(e, ["placement", "builtinPlacements", "popupAlign", "getPopupContainer", "transitionName", "direction"]);
}
function lm(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (tt(!t, "'dateRender' is deprecated. Please use 'cellRender' instead."), tt(!n, "'monthCellRender' is deprecated. Please use 'cellRender' instead."));
  var o = s.useMemo(function() {
    return e || function(i, l) {
      var c = i;
      return t && l.type === "date" ? t(c, l.today) : n && l.type === "month" ? n(c, l.locale) : l.originNode;
    };
  }, [e, n, t]), a = s.useCallback(function(i, l) {
    return o(i, V(V({}, l), {}, {
      range: r
    }));
  }, [o, r]);
  return a;
}
function RC(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = s.useState([!1, !1]), o = Q(r, 2), a = o[0], i = o[1], l = function(d, f) {
    i(function(m) {
      return mi(m, f, d);
    });
  }, c = s.useMemo(function() {
    return a.map(function(u, d) {
      if (u)
        return !0;
      var f = e[d];
      return f ? !!(!n[d] && !f || f && t(f, {
        activeIndex: d
      })) : !1;
    });
  }, [e, a, t, n]);
  return [c, l];
}
function MC(e, t, n, r, o) {
  var a = "", i = [];
  return e && i.push(o ? "hh" : "HH"), t && i.push("mm"), n && i.push("ss"), a = i.join(":"), r && (a += ".SSS"), o && (a += " A"), a;
}
function Sk(e, t, n, r, o, a) {
  var i = e.fieldDateTimeFormat, l = e.fieldDateFormat, c = e.fieldTimeFormat, u = e.fieldMonthFormat, d = e.fieldYearFormat, f = e.fieldWeekFormat, m = e.fieldQuarterFormat, v = e.yearFormat, h = e.cellYearFormat, p = e.cellQuarterFormat, g = e.dayFormat, b = e.cellDateFormat, y = MC(t, n, r, o, a);
  return V(V({}, e), {}, {
    fieldDateTimeFormat: i || "YYYY-MM-DD ".concat(y),
    fieldDateFormat: l || "YYYY-MM-DD",
    fieldTimeFormat: c || y,
    fieldMonthFormat: u || "YYYY-MM",
    fieldYearFormat: d || "YYYY",
    fieldWeekFormat: f || "gggg-wo",
    fieldQuarterFormat: m || "YYYY-[Q]Q",
    yearFormat: v || "YYYY",
    cellYearFormat: h || "YYYY",
    cellQuarterFormat: p || "[Q]Q",
    cellDateFormat: b || g || "D"
  });
}
function TC(e, t) {
  var n = t.showHour, r = t.showMinute, o = t.showSecond, a = t.showMillisecond, i = t.use12Hours;
  return le.useMemo(function() {
    return Sk(e, n, r, o, a, i);
  }, [e, n, r, o, a, i]);
}
function Ga(e, t, n) {
  return n ?? t.some(function(r) {
    return e.includes(r);
  });
}
var xk = [
  // 'format',
  "showNow",
  "showHour",
  "showMinute",
  "showSecond",
  "showMillisecond",
  "use12Hours",
  "hourStep",
  "minuteStep",
  "secondStep",
  "millisecondStep",
  "hideDisabledOptions",
  "defaultValue",
  "disabledHours",
  "disabledMinutes",
  "disabledSeconds",
  "disabledMilliseconds",
  "disabledTime",
  "changeOnScroll",
  "defaultOpenValue"
];
function $k(e) {
  var t = nc(e, xk), n = e.format, r = e.picker, o = null;
  return n && (o = n, Array.isArray(o) && (o = o[0]), o = mt(o) === "object" ? o.format : o), r === "time" && (t.format = o), [t, o];
}
function wk(e) {
  return e && typeof e == "string";
}
function _C(e) {
  var t = e.showTime, n = $k(e), r = Q(n, 2), o = r[0], a = r[1], i = t && mt(t) === "object" ? t : {}, l = V(V({
    defaultOpenValue: i.defaultOpenValue || i.defaultValue
  }, o), i), c = l.showMillisecond, u = l.showHour, d = l.showMinute, f = l.showSecond;
  return !u && !d && !f && !c && (u = !0, d = !0, f = !0), [l, V(V({}, l), {}, {
    showHour: u,
    showMinute: d,
    showSecond: f,
    showMillisecond: c
  }), l.format, a];
}
function DC(e, t, n, r, o) {
  var a = e === "time";
  if (e === "datetime" || a) {
    for (var i = r, l = IC(e, o, null), c = l, u = [t, n], d = 0; d < u.length; d += 1) {
      var f = Wo(u[d])[0];
      if (wk(f)) {
        c = f;
        break;
      }
    }
    var m = i.showHour, v = i.showMinute, h = i.showSecond, p = i.showMillisecond, g = i.use12Hours, b = Ga(c, ["a", "A", "LT", "LLL", "LTS"], g), y = [m, v, h, p].some(function(S) {
      return S !== void 0;
    });
    y || (m = Ga(c, ["H", "h", "k", "LT", "LLL"]), v = Ga(c, ["m", "LT", "LLL"]), h = Ga(c, ["s", "LTS"]), p = Ga(c, ["SSS"])), !y && !m && !v && !h && !p && (m = !0, v = !0, h = !0);
    var C = t || MC(m, v, h, p, b);
    return V(V({}, i), {}, {
      // Format
      format: C,
      // Show Config
      showHour: m,
      showMinute: v,
      showSecond: h,
      showMillisecond: p,
      use12Hours: b
    });
  }
  return null;
}
function Ek(e, t, n) {
  if (process.env.NODE_ENV !== "production" && n && tt(!1, "`clearIcon` will be removed in future. Please use `allowClear` instead."), t === !1)
    return null;
  var r = t && mt(t) === "object" ? t : {};
  return r.clearIcon || n || /* @__PURE__ */ s.createElement("span", {
    className: "".concat(e, "-clear-btn")
  });
}
var Jc = 7;
function ho(e, t, n) {
  return !e && !t || e === t ? !0 : !e || !t ? !1 : n();
}
function Ld(e, t, n) {
  return ho(t, n, function() {
    var r = Math.floor(e.getYear(t) / 10), o = Math.floor(e.getYear(n) / 10);
    return r === o;
  });
}
function Do(e, t, n) {
  return ho(t, n, function() {
    return e.getYear(t) === e.getYear(n);
  });
}
function rp(e, t) {
  var n = Math.floor(e.getMonth(t) / 3);
  return n + 1;
}
function Ok(e, t, n) {
  return ho(t, n, function() {
    return Do(e, t, n) && rp(e, t) === rp(e, n);
  });
}
function sm(e, t, n) {
  return ho(t, n, function() {
    return Do(e, t, n) && e.getMonth(t) === e.getMonth(n);
  });
}
function cm(e, t, n) {
  return ho(t, n, function() {
    return Do(e, t, n) && sm(e, t, n) && e.getDate(t) === e.getDate(n);
  });
}
function kC(e, t, n) {
  return ho(t, n, function() {
    return e.getHour(t) === e.getHour(n) && e.getMinute(t) === e.getMinute(n) && e.getSecond(t) === e.getSecond(n);
  });
}
function LC(e, t, n) {
  return ho(t, n, function() {
    return cm(e, t, n) && kC(e, t, n) && e.getMillisecond(t) === e.getMillisecond(n);
  });
}
function ni(e, t, n, r) {
  return ho(n, r, function() {
    var o = e.locale.getWeekFirstDate(t, n), a = e.locale.getWeekFirstDate(t, r);
    return Do(e, o, a) && e.locale.getWeek(t, n) === e.locale.getWeek(t, r);
  });
}
function zn(e, t, n, r, o) {
  switch (o) {
    case "date":
      return cm(e, n, r);
    case "week":
      return ni(e, t.locale, n, r);
    case "month":
      return sm(e, n, r);
    case "quarter":
      return Ok(e, n, r);
    case "year":
      return Do(e, n, r);
    case "decade":
      return Ld(e, n, r);
    case "time":
      return kC(e, n, r);
    default:
      return LC(e, n, r);
  }
}
function rc(e, t, n, r) {
  return !t || !n || !r ? !1 : e.isAfter(r, t) && e.isAfter(n, r);
}
function $l(e, t, n, r, o) {
  return zn(e, t, n, r, o) ? !0 : e.isAfter(n, r);
}
function Nk(e, t, n) {
  var r = t.locale.getWeekFirstDay(e), o = t.setDate(n, 1), a = t.getWeekDay(o), i = t.addDate(o, r - a);
  return t.getMonth(i) === t.getMonth(n) && t.getDate(i) > 1 && (i = t.addDate(i, -7)), i;
}
function In(e, t) {
  var n = t.generateConfig, r = t.locale, o = t.format;
  return e ? typeof o == "function" ? o(e) : n.locale.format(r.locale, e, o) : "";
}
function hs(e, t, n) {
  var r = t, o = ["getHour", "getMinute", "getSecond", "getMillisecond"], a = ["setHour", "setMinute", "setSecond", "setMillisecond"];
  return a.forEach(function(i, l) {
    n ? r = e[i](r, e[o[l]](n)) : r = e[i](r, 0);
  }), r;
}
function Ik(e, t, n, r, o) {
  var a = Lt(function(i, l) {
    return !!(n && n(i, l) || r && e.isAfter(r, i) && !zn(e, t, r, i, l.type) || o && e.isAfter(i, o) && !zn(e, t, o, i, l.type));
  });
  return a;
}
function Pk(e, t, n) {
  return s.useMemo(function() {
    var r = IC(e, t, n), o = Wo(r), a = o[0], i = mt(a) === "object" && a.type === "mask" ? a.format : null;
    return [
      // Format list
      o.map(function(l) {
        return typeof l == "string" || typeof l == "function" ? l : l.format;
      }),
      // Mask Format
      i
    ];
  }, [e, t, n]);
}
function Rk(e, t, n) {
  return typeof e[0] == "function" || n ? !0 : t;
}
function Mk(e, t, n, r) {
  var o = Lt(function(a, i) {
    var l = V({
      type: t
    }, i);
    if (delete l.activeIndex, // Date object is invalid
    !e.isValidate(a) || // Date is disabled by `disabledDate`
    n && n(a, l))
      return !0;
    if ((t === "date" || t === "time") && r) {
      var c, u = ((c = r.disabledTime) === null || c === void 0 ? void 0 : c.call(r, a, i && i.activeIndex === 1 ? "end" : "start")) || {}, d = u.disabledHours, f = u.disabledMinutes, m = u.disabledSeconds, v = u.disabledMilliseconds, h = r.disabledHours, p = r.disabledMinutes, g = r.disabledSeconds, b = d || h, y = f || p, C = m || g, S = e.getHour(a), $ = e.getMinute(a), x = e.getSecond(a), w = e.getMillisecond(a);
      if (b && b().includes(S) || y && y(S).includes($) || C && C(S, $).includes(x) || v && v(S, $, x).includes(w))
        return !0;
    }
    return !1;
  });
  return o;
}
function wl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = s.useMemo(function() {
    var r = e && Wo(e);
    return t && r && (r[1] = r[1] || r[0]), r;
  }, [e, t]);
  return n;
}
function FC(e, t) {
  var n = e.generateConfig, r = e.locale, o = e.picker, a = o === void 0 ? "date" : o, i = e.prefixCls, l = i === void 0 ? "rc-picker" : i, c = e.styles, u = c === void 0 ? {} : c, d = e.classNames, f = d === void 0 ? {} : d, m = e.order, v = m === void 0 ? !0 : m, h = e.components, p = h === void 0 ? {} : h, g = e.inputRender, b = e.allowClear, y = e.clearIcon, C = e.needConfirm, S = e.multiple, $ = e.format, x = e.inputReadOnly, w = e.disabledDate, N = e.minDate, O = e.maxDate, E = e.showTime, I = e.value, k = e.defaultValue, M = e.pickerValue, P = e.defaultPickerValue, _ = wl(I), D = wl(k), R = wl(M), T = wl(P), L = a === "date" && E ? "datetime" : a, F = L === "time" || L === "datetime", j = F || S, A = C ?? F, B = _C(e), K = Q(B, 4), Y = K[0], G = K[1], te = K[2], ee = K[3], oe = TC(r, G), X = s.useMemo(function() {
    return DC(L, te, ee, Y, oe);
  }, [L, te, ee, Y, oe]);
  process.env.NODE_ENV !== "production" && a === "time" && ["disabledHours", "disabledMinutes", "disabledSeconds"].some(function(ie) {
    return e[ie];
  }) && tt(!1, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
  var W = s.useMemo(function() {
    return V(V({}, e), {}, {
      prefixCls: l,
      locale: oe,
      picker: a,
      styles: u,
      classNames: f,
      order: v,
      components: V({
        input: g
      }, p),
      clearIcon: Ek(l, b, y),
      showTime: X,
      value: _,
      defaultValue: D,
      pickerValue: R,
      defaultPickerValue: T
    }, t == null ? void 0 : t());
  }, [e]), re = Pk(L, oe, $), Z = Q(re, 2), H = Z[0], U = Z[1], ae = Rk(H, x, S), ue = Ik(n, r, w, N, O), de = Mk(n, a, w, X), se = s.useMemo(function() {
    return V(V({}, W), {}, {
      needConfirm: A,
      inputReadOnly: ae,
      disabledDate: ue
    });
  }, [W, A, ae, ue]);
  return [se, L, j, H, U, de];
}
function Tk(e, t, n) {
  var r = Vt(t, {
    value: e
  }), o = Q(r, 2), a = o[0], i = o[1], l = le.useRef(e), c = le.useRef(), u = function() {
    _t.cancel(c.current);
  }, d = Lt(function() {
    i(l.current), n && a !== l.current && n(l.current);
  }), f = Lt(function(m, v) {
    u(), l.current = m, m || v ? d() : c.current = _t(d);
  });
  return le.useEffect(function() {
    return u;
  }, []), [a, f];
}
function jC(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 ? arguments[3] : void 0, o = n.every(function(d) {
    return d;
  }) ? !1 : e, a = Tk(o, t || !1, r), i = Q(a, 2), l = i[0], c = i[1];
  function u(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (!f.inherit || l) && c(d, f.force);
  }
  return [l, u];
}
function zC(e) {
  var t = s.useRef();
  return s.useImperativeHandle(e, function() {
    var n;
    return {
      nativeElement: (n = t.current) === null || n === void 0 ? void 0 : n.nativeElement,
      focus: function() {
        var o;
        (o = t.current) === null || o === void 0 || o.focus();
      },
      blur: function() {
        var o;
        (o = t.current) === null || o === void 0 || o.blur();
      }
    };
  }), t;
}
function AC(e, t) {
  return s.useMemo(function() {
    return e || (t ? (tt(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.entries(t).map(function(n) {
      var r = Q(n, 2), o = r[0], a = r[1];
      return {
        label: o,
        value: a
      };
    })) : []);
  }, [e, t]);
}
function um(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, r = s.useRef(t);
  r.current = t, as(function() {
    if (e)
      r.current(e);
    else {
      var o = _t(function() {
        r.current(e);
      }, n);
      return function() {
        _t.cancel(o);
      };
    }
  }, [e]);
}
function BC(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = s.useState(0), r = Q(n, 2), o = r[0], a = r[1], i = s.useState(!1), l = Q(i, 2), c = l[0], u = l[1], d = s.useRef([]), f = s.useRef(null), m = function(g) {
    u(g);
  }, v = function(g) {
    return g && (f.current = g), f.current;
  }, h = function(g) {
    var b = d.current, y = new Set(b.filter(function(S) {
      return g[S] || t[S];
    })), C = b[b.length - 1] === 0 ? 1 : 0;
    return y.size >= 2 || e[C] ? null : C;
  };
  return um(c, function() {
    c || (d.current = []);
  }), s.useEffect(function() {
    c && d.current.push(o);
  }, [c, o]), [c, m, v, o, a, h, d.current];
}
function _k(e, t, n, r, o, a) {
  var i = n[n.length - 1], l = n.find(function(u) {
    return e[u];
  }), c = function(d, f) {
    var m = Q(e, 2), v = m[0], h = m[1], p = V(V({}, f), {}, {
      from: i !== l ? e[l] : void 0
    });
    return i === 1 && t[0] && v && // Same date isOK
    !zn(r, o, v, d, p.type) && // Before start date
    r.isAfter(v, d) || i === 0 && t[1] && h && // Same date isOK
    !zn(r, o, h, d, p.type) && // After end date
    r.isAfter(d, h) ? !0 : a == null ? void 0 : a(d, p);
  };
  return c;
}
function ri(e, t, n, r) {
  switch (t) {
    case "date":
    case "week":
      return e.addMonth(n, r);
    case "month":
    case "quarter":
      return e.addYear(n, r);
    case "year":
      return e.addYear(n, r * 10);
    case "decade":
      return e.addYear(n, r * 100);
    default:
      return n;
  }
}
var Zc = [];
function HC(e, t, n, r, o, a, i, l) {
  var c = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : Zc, u = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : Zc, d = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : Zc, f = arguments.length > 11 ? arguments[11] : void 0, m = arguments.length > 12 ? arguments[12] : void 0, v = arguments.length > 13 ? arguments[13] : void 0, h = i === "time", p = a || 0, g = function(R) {
    var T = e.getNow();
    return h && (T = hs(e, T)), c[R] || n[R] || T;
  }, b = Q(u, 2), y = b[0], C = b[1], S = Vt(function() {
    return g(0);
  }, {
    value: y
  }), $ = Q(S, 2), x = $[0], w = $[1], N = Vt(function() {
    return g(1);
  }, {
    value: C
  }), O = Q(N, 2), E = O[0], I = O[1], k = s.useMemo(function() {
    var D = [x, E][p];
    return h ? D : hs(e, D, d[p]);
  }, [h, x, E, p, e, d]), M = function(R) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "panel", L = [w, I][p];
    L(R);
    var F = [x, E];
    F[p] = R, f && (!zn(e, t, x, F[0], i) || !zn(e, t, E, F[1], i)) && f(F, {
      source: T,
      range: p === 1 ? "end" : "start",
      mode: r
    });
  }, P = function(R, T) {
    if (l) {
      var L = {
        date: "month",
        week: "month",
        month: "year",
        quarter: "year"
      }, F = L[i];
      if (F && !zn(e, t, R, T, F))
        return ri(e, i, T, -1);
      if (i === "year") {
        var j = Math.floor(e.getYear(R) / 10), A = Math.floor(e.getYear(T) / 10);
        if (j !== A)
          return ri(e, i, T, -1);
      }
    }
    return T;
  }, _ = s.useRef(null);
  return Pt(function() {
    if (o && !c[p]) {
      var D = h ? null : e.getNow();
      if (_.current !== null && _.current !== p ? D = [x, E][p ^ 1] : n[p] ? D = p === 0 ? n[0] : P(n[0], n[1]) : n[p ^ 1] && (D = n[p ^ 1]), D) {
        m && e.isAfter(m, D) && (D = m);
        var R = l ? ri(e, i, D, 1) : D;
        v && e.isAfter(R, v) && (D = ri(e, i, v, -1)), M(D, "reset");
      }
    }
  }, [o, p, n[p]]), s.useEffect(function() {
    o ? _.current = p : _.current = null;
  }, [o, p]), Pt(function() {
    o && c && c[p] && M(c[p], "reset");
  }, [o, p]), [k, M];
}
function VC(e, t) {
  var n = s.useRef(e), r = s.useState({}), o = Q(r, 2), a = o[1], i = function(u) {
    return u && t !== void 0 ? t : n.current;
  }, l = function(u) {
    n.current = u, a({});
  };
  return [i, l, i(!0)];
}
var Dk = [];
function WC(e, t, n) {
  var r = function(i) {
    return i.map(function(l) {
      return In(l, {
        generateConfig: e,
        locale: t,
        format: n[0]
      });
    });
  }, o = function(i, l) {
    for (var c = Math.max(i.length, l.length), u = -1, d = 0; d < c; d += 1) {
      var f = i[d] || null, m = l[d] || null;
      if (f !== m && !LC(e, f, m)) {
        u = d;
        break;
      }
    }
    return [u < 0, u !== 0];
  };
  return [r, o];
}
function KC(e, t) {
  return be(e).sort(function(n, r) {
    return t.isAfter(n, r) ? 1 : -1;
  });
}
function kk(e) {
  var t = VC(e), n = Q(t, 2), r = n[0], o = n[1], a = Lt(function() {
    o(e);
  });
  return s.useEffect(function() {
    a();
  }, [e]), [r, o];
}
function qC(e, t, n, r, o, a, i, l, c) {
  var u = Vt(a, {
    value: i
  }), d = Q(u, 2), f = d[0], m = d[1], v = f || Dk, h = kk(v), p = Q(h, 2), g = p[0], b = p[1], y = WC(e, t, n), C = Q(y, 2), S = C[0], $ = C[1], x = Lt(function(N) {
    var O = be(N);
    if (r)
      for (var E = 0; E < 2; E += 1)
        O[E] = O[E] || null;
    else
      o && (O = KC(O.filter(function(D) {
        return D;
      }), e));
    var I = $(g(), O), k = Q(I, 2), M = k[0], P = k[1];
    if (!M && (b(O), l)) {
      var _ = S(O);
      l(O, _, {
        range: P ? "end" : "start"
      });
    }
  }), w = function() {
    c && c(g());
  };
  return [v, m, g, x, w];
}
function GC(e, t, n, r, o, a, i, l, c, u) {
  var d = e.generateConfig, f = e.locale, m = e.picker, v = e.onChange, h = e.allowEmpty, p = e.order, g = a.some(function(M) {
    return M;
  }) ? !1 : p, b = WC(d, f, i), y = Q(b, 2), C = y[0], S = y[1], $ = VC(t), x = Q($, 2), w = x[0], N = x[1], O = Lt(function() {
    N(t);
  });
  s.useEffect(function() {
    O();
  }, [t]);
  var E = Lt(function(M) {
    var P = M === null, _ = be(M || w());
    if (P)
      for (var D = Math.max(a.length, _.length), R = 0; R < D; R += 1)
        a[R] || (_[R] = null);
    g && _[0] && _[1] && (_ = KC(_, d)), o(_);
    var T = _, L = Q(T, 2), F = L[0], j = L[1], A = !F, B = !j, K = h ? (
      // Validate empty start
      (!A || h[0]) && // Validate empty end
      (!B || h[1])
    ) : !0, Y = !p || A || B || zn(d, f, F, j, m) || d.isAfter(j, F), G = (
      // Validate start
      (!F || !u(F, {
        activeIndex: 0
      })) && // Validate end
      (!j || !u(j, {
        from: F,
        activeIndex: 1
      }))
    ), te = (
      // Null value is from clear button
      P || // Normal check
      K && Y && G
    );
    if (te) {
      n(_);
      var ee = S(_, t), oe = Q(ee, 1), X = oe[0];
      v && !X && v(
        // Return null directly if all date are empty
        P && _.every(function(W) {
          return !W;
        }) ? null : _,
        C(_)
      );
    }
    return te;
  }), I = Lt(function(M, P) {
    var _ = mi(w(), M, r()[M]);
    N(_), P && E();
  }), k = !l && !c;
  return um(!k, function() {
    k && (E(), o(t), O());
  }, 2), [I, E];
}
function UC(e, t, n, r, o) {
  return t !== "date" && t !== "time" ? !1 : n !== void 0 ? n : r !== void 0 ? r : !o && (e === "date" || e === "time");
}
function Lk(e, t, n, r, o, a) {
  var i = e;
  function l(f, m, v) {
    var h = a[f](i), p = v.find(function(C) {
      return C.value === h;
    });
    if (!p || p.disabled) {
      var g = v.filter(function(C) {
        return !C.disabled;
      }), b = be(g).reverse(), y = b.find(function(C) {
        return C.value <= h;
      }) || g[0];
      y && (h = y.value, i = a[m](i, h));
    }
    return h;
  }
  var c = l("getHour", "setHour", t()), u = l("getMinute", "setMinute", n(c)), d = l("getSecond", "setSecond", r(c, u));
  return l("getMillisecond", "setMillisecond", o(c, u, d)), i;
}
function El() {
  return [];
}
function Ol(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2, i = [], l = n >= 1 ? n | 0 : 1, c = e; c <= t; c += l) {
    var u = o.includes(c);
    (!u || !r) && i.push({
      label: im(c, a),
      value: c,
      disabled: u
    });
  }
  return i;
}
function dm(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, r = t || {}, o = r.use12Hours, a = r.hourStep, i = a === void 0 ? 1 : a, l = r.minuteStep, c = l === void 0 ? 1 : l, u = r.secondStep, d = u === void 0 ? 1 : u, f = r.millisecondStep, m = f === void 0 ? 100 : f, v = r.hideDisabledOptions, h = r.disabledTime, p = r.disabledHours, g = r.disabledMinutes, b = r.disabledSeconds, y = s.useMemo(function() {
    return n || e.getNow();
  }, [n, e]);
  if (process.env.NODE_ENV !== "production") {
    var C = 24 % i === 0, S = 60 % c === 0, $ = 60 % d === 0;
    tt(C, "`hourStep` ".concat(i, " is invalid. It should be a factor of 24.")), tt(S, "`minuteStep` ".concat(c, " is invalid. It should be a factor of 60.")), tt($, "`secondStep` ".concat(d, " is invalid. It should be a factor of 60."));
  }
  var x = s.useCallback(function(j) {
    var A = (h == null ? void 0 : h(j)) || {};
    return [A.disabledHours || p || El, A.disabledMinutes || g || El, A.disabledSeconds || b || El, A.disabledMilliseconds || El];
  }, [h, p, g, b]), w = s.useMemo(function() {
    return x(y);
  }, [y, x]), N = Q(w, 4), O = N[0], E = N[1], I = N[2], k = N[3], M = s.useCallback(function(j, A, B, K) {
    var Y = Ol(0, 23, i, v, j()), G = o ? Y.map(function(X) {
      return V(V({}, X), {}, {
        label: im(X.value % 12 || 12, 2)
      });
    }) : Y, te = function(W) {
      return Ol(0, 59, c, v, A(W));
    }, ee = function(W, re) {
      return Ol(0, 59, d, v, B(W, re));
    }, oe = function(W, re, Z) {
      return Ol(0, 999, m, v, K(W, re, Z), 3);
    };
    return [G, te, ee, oe];
  }, [v, i, o, m, c, d]), P = s.useMemo(function() {
    return M(O, E, I, k);
  }, [M, O, E, I, k]), _ = Q(P, 4), D = _[0], R = _[1], T = _[2], L = _[3], F = function(A, B) {
    var K = function() {
      return D;
    }, Y = R, G = T, te = L;
    if (B) {
      var ee = x(B), oe = Q(ee, 4), X = oe[0], W = oe[1], re = oe[2], Z = oe[3], H = M(X, W, re, Z), U = Q(H, 4), ae = U[0], ue = U[1], de = U[2], se = U[3];
      K = function() {
        return ae;
      }, Y = ue, G = de, te = se;
    }
    var ie = Lk(A, K, Y, G, te, e);
    return ie;
  };
  return [
    // getValidTime
    F,
    // Units
    D,
    R,
    T,
    L
  ];
}
function Fk(e) {
  var t = e.mode, n = e.internalMode, r = e.renderExtraFooter, o = e.showNow, a = e.showTime, i = e.onSubmit, l = e.onNow, c = e.invalid, u = e.needConfirm, d = e.generateConfig, f = e.disabledDate, m = s.useContext(Er), v = m.prefixCls, h = m.locale, p = m.button, g = p === void 0 ? "button" : p, b = d.getNow(), y = dm(d, a, b), C = Q(y, 1), S = C[0], $ = r == null ? void 0 : r(t), x = f(b, {
    type: t
  }), w = function() {
    if (!x) {
      var P = S(b);
      l(P);
    }
  }, N = "".concat(v, "-now"), O = "".concat(N, "-btn"), E = o && /* @__PURE__ */ s.createElement("li", {
    className: N
  }, /* @__PURE__ */ s.createElement("a", {
    className: J(O, x && "".concat(O, "-disabled")),
    "aria-disabled": x,
    onClick: w
  }, n === "date" ? h.today : h.now)), I = u && /* @__PURE__ */ s.createElement("li", {
    className: "".concat(v, "-ok")
  }, /* @__PURE__ */ s.createElement(g, {
    disabled: c,
    onClick: i
  }, h.ok)), k = (E || I) && /* @__PURE__ */ s.createElement("ul", {
    className: "".concat(v, "-ranges")
  }, E, I);
  return !$ && !k ? null : /* @__PURE__ */ s.createElement("div", {
    className: "".concat(v, "-footer")
  }, $ && /* @__PURE__ */ s.createElement("div", {
    className: "".concat(v, "-footer-extra")
  }, $), k);
}
function YC(e, t, n) {
  function r(o, a) {
    var i = o.findIndex(function(c) {
      return zn(e, t, c, a, n);
    });
    if (i === -1)
      return [].concat(be(o), [a]);
    var l = be(o);
    return l.splice(i, 1), l;
  }
  return r;
}
var Ko = /* @__PURE__ */ s.createContext(null);
function oc() {
  return s.useContext(Ko);
}
function Ta(e, t) {
  var n = e.prefixCls, r = e.generateConfig, o = e.locale, a = e.disabledDate, i = e.minDate, l = e.maxDate, c = e.cellRender, u = e.hoverValue, d = e.hoverRangeValue, f = e.onHover, m = e.values, v = e.pickerValue, h = e.onSelect, p = e.prevIcon, g = e.nextIcon, b = e.superPrevIcon, y = e.superNextIcon, C = r.getNow(), S = {
    now: C,
    values: m,
    pickerValue: v,
    prefixCls: n,
    disabledDate: a,
    minDate: i,
    maxDate: l,
    cellRender: c,
    hoverValue: u,
    hoverRangeValue: d,
    onHover: f,
    locale: o,
    generateConfig: r,
    onSelect: h,
    panelType: t,
    // Icons
    prevIcon: p,
    nextIcon: g,
    superPrevIcon: b,
    superNextIcon: y
  };
  return [S, C];
}
var Ar = /* @__PURE__ */ s.createContext({});
process.env.NODE_ENV !== "production" && (Ar.displayName = "PickerHackContext");
function el(e) {
  for (var t = e.rowNum, n = e.colNum, r = e.baseDate, o = e.getCellDate, a = e.prefixColumn, i = e.rowClassName, l = e.titleFormat, c = e.getCellText, u = e.getCellClassName, d = e.headerCells, f = e.cellSelection, m = f === void 0 ? !0 : f, v = e.disabledDate, h = oc(), p = h.prefixCls, g = h.panelType, b = h.now, y = h.disabledDate, C = h.cellRender, S = h.onHover, $ = h.hoverValue, x = h.hoverRangeValue, w = h.generateConfig, N = h.values, O = h.locale, E = h.onSelect, I = v || y, k = "".concat(p, "-cell"), M = s.useContext(Ar), P = M.onCellDblClick, _ = function(B) {
    return N.some(function(K) {
      return K && zn(w, O, B, K, g);
    });
  }, D = [], R = 0; R < t; R += 1) {
    for (var T = [], L = void 0, F = function() {
      var B = R * n + j, K = o(r, B), Y = I == null ? void 0 : I(K, {
        type: g
      });
      j === 0 && (L = K, a && T.push(a(L)));
      var G = !1, te = !1, ee = !1;
      if (m && x) {
        var oe = Q(x, 2), X = oe[0], W = oe[1];
        G = rc(w, X, W, K), te = zn(w, O, K, X, g), ee = zn(w, O, K, W, g);
      }
      var re = l ? In(K, {
        locale: O,
        format: l,
        generateConfig: w
      }) : void 0, Z = /* @__PURE__ */ s.createElement("div", {
        className: "".concat(k, "-inner")
      }, c(K));
      T.push(/* @__PURE__ */ s.createElement("td", {
        key: j,
        title: re,
        className: J(k, V(z(z(z(z(z(z({}, "".concat(k, "-disabled"), Y), "".concat(k, "-hover"), ($ || []).some(function(H) {
          return zn(w, O, K, H, g);
        })), "".concat(k, "-in-range"), G && !te && !ee), "".concat(k, "-range-start"), te), "".concat(k, "-range-end"), ee), "".concat(p, "-cell-selected"), !x && // WeekPicker use row instead
        g !== "week" && _(K)), u(K))),
        onClick: function() {
          Y || E(K);
        },
        onDoubleClick: function() {
          !Y && P && P();
        },
        onMouseEnter: function() {
          Y || S == null || S(K);
        },
        onMouseLeave: function() {
          Y || S == null || S(null);
        }
      }, C ? C(K, {
        prefixCls: p,
        originNode: Z,
        today: b,
        type: g,
        locale: O
      }) : Z));
    }, j = 0; j < n; j += 1)
      F();
    D.push(/* @__PURE__ */ s.createElement("tr", {
      key: R,
      className: i == null ? void 0 : i(L)
    }, T));
  }
  return /* @__PURE__ */ s.createElement("div", {
    className: "".concat(p, "-body")
  }, /* @__PURE__ */ s.createElement("table", {
    className: "".concat(p, "-content")
  }, d && /* @__PURE__ */ s.createElement("thead", null, /* @__PURE__ */ s.createElement("tr", null, d)), /* @__PURE__ */ s.createElement("tbody", null, D)));
}
var Nl = {
  visibility: "hidden"
};
function _a(e) {
  var t = e.offset, n = e.superOffset, r = e.onChange, o = e.getStart, a = e.getEnd, i = e.children, l = oc(), c = l.prefixCls, u = l.prevIcon, d = u === void 0 ? "‹" : u, f = l.nextIcon, m = f === void 0 ? "›" : f, v = l.superPrevIcon, h = v === void 0 ? "«" : v, p = l.superNextIcon, g = p === void 0 ? "»" : p, b = l.minDate, y = l.maxDate, C = l.generateConfig, S = l.locale, $ = l.pickerValue, x = l.panelType, w = "".concat(c, "-header"), N = s.useContext(Ar), O = N.hidePrev, E = N.hideNext, I = N.hideHeader, k = s.useMemo(function() {
    if (!b || !t || !a)
      return !1;
    var A = a(t(-1, $));
    return !$l(C, S, A, b, x);
  }, [b, t, $, a, C, S, x]), M = s.useMemo(function() {
    if (!b || !n || !a)
      return !1;
    var A = a(n(-1, $));
    return !$l(C, S, A, b, x);
  }, [b, n, $, a, C, S, x]), P = s.useMemo(function() {
    if (!y || !t || !o)
      return !1;
    var A = o(t(1, $));
    return !$l(C, S, y, A, x);
  }, [y, t, $, o, C, S, x]), _ = s.useMemo(function() {
    if (!y || !n || !o)
      return !1;
    var A = o(n(1, $));
    return !$l(C, S, y, A, x);
  }, [y, n, $, o, C, S, x]), D = function(B) {
    t && r(t(B, $));
  }, R = function(B) {
    n && r(n(B, $));
  };
  if (I)
    return null;
  var T = "".concat(w, "-prev-btn"), L = "".concat(w, "-next-btn"), F = "".concat(w, "-super-prev-btn"), j = "".concat(w, "-super-next-btn");
  return /* @__PURE__ */ s.createElement("div", {
    className: w
  }, n && /* @__PURE__ */ s.createElement("button", {
    type: "button",
    onClick: function() {
      return R(-1);
    },
    tabIndex: -1,
    className: J(F, M && "".concat(F, "-disabled")),
    disabled: M,
    style: O ? Nl : {}
  }, h), t && /* @__PURE__ */ s.createElement("button", {
    type: "button",
    onClick: function() {
      return D(-1);
    },
    tabIndex: -1,
    className: J(T, k && "".concat(T, "-disabled")),
    disabled: k,
    style: O ? Nl : {}
  }, d), /* @__PURE__ */ s.createElement("div", {
    className: "".concat(w, "-view")
  }, i), t && /* @__PURE__ */ s.createElement("button", {
    type: "button",
    onClick: function() {
      return D(1);
    },
    tabIndex: -1,
    className: J(L, P && "".concat(L, "-disabled")),
    disabled: P,
    style: E ? Nl : {}
  }, m), n && /* @__PURE__ */ s.createElement("button", {
    type: "button",
    onClick: function() {
      return R(1);
    },
    tabIndex: -1,
    className: J(j, _ && "".concat(j, "-disabled")),
    disabled: _,
    style: E ? Nl : {}
  }, g));
}
function ac(e) {
  var t = e.prefixCls, n = e.panelName, r = n === void 0 ? "date" : n, o = e.locale, a = e.generateConfig, i = e.pickerValue, l = e.onPickerValueChange, c = e.onModeChange, u = e.mode, d = u === void 0 ? "date" : u, f = e.disabledDate, m = e.onSelect, v = e.onHover, h = e.showWeek, p = "".concat(t, "-").concat(r, "-panel"), g = "".concat(t, "-cell"), b = d === "week", y = Ta(e, d), C = Q(y, 2), S = C[0], $ = C[1], x = a.locale.getWeekFirstDay(o.locale), w = a.setDate(i, 1), N = Nk(o.locale, a, w), O = a.getMonth(i), E = b || h ? function(j) {
    var A = f == null ? void 0 : f(j, {
      type: "week"
    });
    return /* @__PURE__ */ s.createElement("td", {
      key: "week",
      className: J(g, "".concat(g, "-week"), z({}, "".concat(g, "-disabled"), A)),
      onClick: function() {
        A || m(j);
      },
      onMouseEnter: function() {
        A || v == null || v(j);
      },
      onMouseLeave: function() {
        A || v == null || v(null);
      }
    }, /* @__PURE__ */ s.createElement("div", {
      className: "".concat(g, "-inner")
    }, a.locale.getWeek(o.locale, j)));
  } : null, I = [], k = o.shortWeekDays || (a.locale.getShortWeekDays ? a.locale.getShortWeekDays(o.locale) : []);
  E && I.push(/* @__PURE__ */ s.createElement("th", {
    key: "empty",
    "aria-label": "empty cell"
  }));
  for (var M = 0; M < Jc; M += 1)
    I.push(/* @__PURE__ */ s.createElement("th", {
      key: M
    }, k[(M + x) % Jc]));
  var P = function(A, B) {
    return a.addDate(A, B);
  }, _ = function(A) {
    return In(A, {
      locale: o,
      format: o.cellDateFormat,
      generateConfig: a
    });
  }, D = function(A) {
    var B = z(z({}, "".concat(t, "-cell-in-view"), sm(a, A, i)), "".concat(t, "-cell-today"), cm(a, A, $));
    return B;
  }, R = o.shortMonths || (a.locale.getShortMonths ? a.locale.getShortMonths(o.locale) : []), T = /* @__PURE__ */ s.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      c("year", i);
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, In(i, {
    locale: o,
    format: o.yearFormat,
    generateConfig: a
  })), L = /* @__PURE__ */ s.createElement("button", {
    type: "button",
    key: "month",
    onClick: function() {
      c("month", i);
    },
    tabIndex: -1,
    className: "".concat(t, "-month-btn")
  }, o.monthFormat ? In(i, {
    locale: o,
    format: o.monthFormat,
    generateConfig: a
  }) : R[O]), F = o.monthBeforeYear ? [L, T] : [T, L];
  return /* @__PURE__ */ s.createElement(Ko.Provider, {
    value: S
  }, /* @__PURE__ */ s.createElement("div", {
    className: J(p, h && "".concat(p, "-show-week"))
  }, /* @__PURE__ */ s.createElement(_a, {
    offset: function(A) {
      return a.addMonth(i, A);
    },
    superOffset: function(A) {
      return a.addYear(i, A);
    },
    onChange: l,
    getStart: function(A) {
      return a.setDate(A, 1);
    },
    getEnd: function(A) {
      var B = a.setDate(A, 1);
      return B = a.addMonth(B, 1), a.addDate(B, -1);
    }
  }, F), /* @__PURE__ */ s.createElement(el, fe({
    titleFormat: o.fieldDateFormat
  }, e, {
    colNum: Jc,
    rowNum: 6,
    baseDate: N,
    headerCells: I,
    getCellDate: P,
    getCellText: _,
    getCellClassName: D,
    prefixColumn: E,
    cellSelection: !b
  }))));
}
var jk = 1 / 3;
function zk(e, t) {
  var n = s.useRef(!1), r = s.useRef(null), o = s.useRef(null), a = function() {
    return n.current;
  }, i = function() {
    _t.cancel(r.current), n.current = !1;
  }, l = function() {
    var d = e.current;
    if (o.current = null, d) {
      var f = d.querySelector('[data-value="'.concat(t, '"]')), m = d.querySelector("li"), v = function h() {
        i(), n.current = !0;
        var p = d.scrollTop, g = m.offsetTop, b = f.offsetTop, y = b - g;
        if (b === 0 && f !== m) {
          r.current = _t(h);
          return;
        }
        var C = p + (y - p) * jk, S = Math.abs(y - C);
        if (o.current !== null && o.current < S) {
          i();
          return;
        }
        if (o.current = S, S <= 1) {
          d.scrollTop = y, i();
          return;
        }
        d.scrollTop = C, r.current = _t(h);
      };
      f && m && v();
    }
  }, c = Lt(l);
  return [c, i, a];
}
var Ak = 300;
function Ua(e) {
  var t = e.units, n = e.value, r = e.optionalValue, o = e.type, a = e.onChange, i = e.onDblClick, l = e.changeOnScroll, c = oc(), u = c.prefixCls, d = c.cellRender, f = c.now, m = c.locale, v = "".concat(u, "-time-panel"), h = "".concat(u, "-time-panel-cell"), p = s.useRef(null), g = s.useRef(), b = function() {
    clearTimeout(g.current);
  }, y = zk(p, n ?? r), C = Q(y, 3), S = C[0], $ = C[1], x = C[2];
  Pt(function() {
    return S(), b(), function() {
      $(), b();
    };
  }, [n, r, t]);
  var w = function(E) {
    b();
    var I = E.target;
    !x() && l && (g.current = setTimeout(function() {
      var k = p.current, M = k.querySelector("li").offsetTop, P = Array.from(k.querySelectorAll("li")), _ = P.map(function(F) {
        return F.offsetTop - M;
      }), D = _.map(function(F, j) {
        return t[j].disabled ? Number.MAX_SAFE_INTEGER : Math.abs(F - I.scrollTop);
      }), R = Math.min.apply(Math, be(D)), T = D.findIndex(function(F) {
        return F === R;
      }), L = t[T];
      L && !L.disabled && a(L.value);
    }, Ak));
  }, N = "".concat(v, "-column");
  return /* @__PURE__ */ s.createElement("ul", {
    className: N,
    ref: p,
    "data-type": o,
    onScroll: w
  }, t.map(function(O) {
    var E = O.label, I = O.value, k = O.disabled, M = /* @__PURE__ */ s.createElement("div", {
      className: "".concat(h, "-inner")
    }, E);
    return /* @__PURE__ */ s.createElement("li", {
      key: I,
      className: J(h, z(z({}, "".concat(h, "-selected"), n === I), "".concat(h, "-disabled"), k)),
      onClick: function() {
        k || a(I);
      },
      onDoubleClick: function() {
        !k && i && i();
      },
      "data-value": I
    }, d ? d(I, {
      prefixCls: u,
      originNode: M,
      today: f,
      type: "time",
      subType: o,
      locale: m
    }) : M);
  }));
}
function Jr(e) {
  return e < 12;
}
function Bk(e) {
  var t = e.showHour, n = e.showMinute, r = e.showSecond, o = e.showMillisecond, a = e.use12Hours, i = e.changeOnScroll, l = oc(), c = l.prefixCls, u = l.values, d = l.generateConfig, f = l.locale, m = l.onSelect, v = l.pickerValue, h = (u == null ? void 0 : u[0]) || null, p = s.useContext(Ar), g = p.onCellDblClick, b = dm(d, e, h), y = Q(b, 5), C = y[0], S = y[1], $ = y[2], x = y[3], w = y[4], N = function($e) {
    var we = h && d[$e](h), _e = v && d[$e](v);
    return [we, _e];
  }, O = N("getHour"), E = Q(O, 2), I = E[0], k = E[1], M = N("getMinute"), P = Q(M, 2), _ = P[0], D = P[1], R = N("getSecond"), T = Q(R, 2), L = T[0], F = T[1], j = N("getMillisecond"), A = Q(j, 2), B = A[0], K = A[1], Y = I === null ? null : Jr(I) ? "am" : "pm", G = s.useMemo(function() {
    return a ? Jr(I) ? S.filter(function(ge) {
      return Jr(ge.value);
    }) : S.filter(function(ge) {
      return !Jr(ge.value);
    }) : S;
  }, [I, S, a]), te = function($e, we) {
    var _e, ze = $e.filter(function(Te) {
      return !Te.disabled;
    });
    return we ?? // Fallback to enabled value
    (ze == null || (_e = ze[0]) === null || _e === void 0 ? void 0 : _e.value);
  }, ee = te(S, I), oe = s.useMemo(function() {
    return $(ee);
  }, [$, ee]), X = te(oe, _), W = s.useMemo(function() {
    return x(ee, X);
  }, [x, ee, X]), re = te(W, L), Z = s.useMemo(function() {
    return w(ee, X, re);
  }, [w, ee, X, re]), H = te(Z, B), U = s.useMemo(function() {
    if (!a)
      return [];
    var ge = d.getNow(), $e = d.setHour(ge, 6), we = d.setHour(ge, 18), _e = function(Te, ke) {
      var Le = f.cellMeridiemFormat;
      return Le ? In(Te, {
        generateConfig: d,
        locale: f,
        format: Le
      }) : ke;
    };
    return [{
      label: _e($e, "AM"),
      value: "am",
      disabled: S.every(function(ze) {
        return ze.disabled || !Jr(ze.value);
      })
    }, {
      label: _e(we, "PM"),
      value: "pm",
      disabled: S.every(function(ze) {
        return ze.disabled || Jr(ze.value);
      })
    }];
  }, [S, a, d, f]), ae = function($e) {
    var we = C($e);
    m(we);
  }, ue = s.useMemo(function() {
    var ge = v || d.getNow(), $e = function(_e) {
      return _e != null;
    };
    return $e(I) ? (ge = d.setHour(ge, I), ge = d.setMinute(ge, _), ge = d.setSecond(ge, L), ge = d.setMillisecond(ge, B)) : $e(k) ? (ge = d.setHour(ge, k), ge = d.setMinute(ge, D), ge = d.setSecond(ge, F), ge = d.setMillisecond(ge, K)) : $e(ee) && (ge = d.setHour(ge, ee), ge = d.setMinute(ge, X), ge = d.setSecond(ge, re), ge = d.setMillisecond(ge, H)), ge;
  }, [v, I, _, L, B, ee, X, re, H, k, D, F, K, d]), de = function($e) {
    ae(d.setHour(ue, $e));
  }, se = function($e) {
    ae(d.setMinute(ue, $e));
  }, ie = function($e) {
    ae(d.setSecond(ue, $e));
  }, me = function($e) {
    ae(d.setMillisecond(ue, $e));
  }, Se = function($e) {
    $e === "am" && !Jr(I) ? ae(d.setHour(ue, I - 12)) : $e === "pm" && Jr(I) && ae(d.setHour(ue, I + 12));
  }, ve = {
    onDblClick: g,
    changeOnScroll: i
  };
  return /* @__PURE__ */ s.createElement("div", {
    className: "".concat(c, "-content")
  }, t && /* @__PURE__ */ s.createElement(Ua, fe({
    units: G,
    value: I,
    optionalValue: k,
    type: "hour",
    onChange: de
  }, ve)), n && /* @__PURE__ */ s.createElement(Ua, fe({
    units: oe,
    value: _,
    optionalValue: D,
    type: "minute",
    onChange: se
  }, ve)), r && /* @__PURE__ */ s.createElement(Ua, fe({
    units: W,
    value: L,
    optionalValue: F,
    type: "second",
    onChange: ie
  }, ve)), o && /* @__PURE__ */ s.createElement(Ua, fe({
    units: Z,
    value: B,
    optionalValue: K,
    type: "millisecond",
    onChange: me
  }, ve)), a && /* @__PURE__ */ s.createElement(Ua, fe({
    units: U,
    value: Y,
    type: "meridiem",
    onChange: Se
  }, ve)));
}
function XC(e) {
  var t = e.prefixCls, n = e.value, r = e.locale, o = e.generateConfig, a = e.showTime, i = a || {}, l = i.format, c = "".concat(t, "-time-panel"), u = Ta(e, "time"), d = Q(u, 1), f = d[0];
  return /* @__PURE__ */ s.createElement(Ko.Provider, {
    value: f
  }, /* @__PURE__ */ s.createElement("div", {
    className: J(c)
  }, /* @__PURE__ */ s.createElement(_a, null, n ? In(n, {
    locale: r,
    format: l,
    generateConfig: o
  }) : " "), /* @__PURE__ */ s.createElement(Bk, a)));
}
function Hk(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.showTime, o = e.onSelect, a = e.value, i = e.pickerValue, l = e.onHover, c = "".concat(t, "-datetime-panel"), u = dm(n, r), d = Q(u, 1), f = d[0], m = function(g) {
    return a ? hs(n, g, a) : hs(n, g, i);
  }, v = function(g) {
    l(g && m(g));
  }, h = function(g) {
    var b = m(g);
    o(f(b, b));
  };
  return /* @__PURE__ */ s.createElement("div", {
    className: c
  }, /* @__PURE__ */ s.createElement(ac, fe({}, e, {
    onSelect: h,
    onHover: v
  })), /* @__PURE__ */ s.createElement(XC, e));
}
function Vk(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, o = e.pickerValue, a = e.disabledDate, i = e.onPickerValueChange, l = "".concat(t, "-decade-panel"), c = Ta(e, "decade"), u = Q(c, 1), d = u[0], f = function(x) {
    var w = Math.floor(r.getYear(o) / 100) * 100;
    return r.setYear(x, w);
  }, m = function(x) {
    var w = f(x);
    return r.addYear(w, 99);
  }, v = f(o), h = m(o), p = r.addYear(v, -10), g = function(x, w) {
    return r.addYear(x, w * 10);
  }, b = function(x) {
    var w = n.cellYearFormat, N = In(x, {
      locale: n,
      format: w,
      generateConfig: r
    }), O = In(r.addYear(x, 9), {
      locale: n,
      format: w,
      generateConfig: r
    });
    return "".concat(N, "-").concat(O);
  }, y = function(x) {
    return z({}, "".concat(t, "-cell-in-view"), Ld(r, x, v) || Ld(r, x, h) || rc(r, v, h, x));
  }, C = a ? function($, x) {
    var w = r.setDate($, 1), N = r.setMonth(w, 0), O = r.setYear(N, Math.floor(r.getYear(N) / 10) * 10), E = r.addYear(O, 10), I = r.addDate(E, -1);
    return a(O, x) && a(I, x);
  } : null, S = "".concat(In(v, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }), "-").concat(In(h, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ s.createElement(Ko.Provider, {
    value: d
  }, /* @__PURE__ */ s.createElement("div", {
    className: l
  }, /* @__PURE__ */ s.createElement(_a, {
    superOffset: function(x) {
      return r.addYear(o, x * 100);
    },
    onChange: i,
    getStart: f,
    getEnd: m
  }, S), /* @__PURE__ */ s.createElement(el, fe({}, e, {
    disabledDate: C,
    colNum: 3,
    rowNum: 4,
    baseDate: p,
    getCellDate: g,
    getCellText: b,
    getCellClassName: y
  }))));
}
function Wk(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, o = e.pickerValue, a = e.disabledDate, i = e.onPickerValueChange, l = e.onModeChange, c = "".concat(t, "-month-panel"), u = Ta(e, "month"), d = Q(u, 1), f = d[0], m = r.setMonth(o, 0), v = n.shortMonths || (r.locale.getShortMonths ? r.locale.getShortMonths(n.locale) : []), h = function(S, $) {
    return r.addMonth(S, $);
  }, p = function(S) {
    var $ = r.getMonth(S);
    return n.monthFormat ? In(S, {
      locale: n,
      format: n.monthFormat,
      generateConfig: r
    }) : v[$];
  }, g = function() {
    return z({}, "".concat(t, "-cell-in-view"), !0);
  }, b = a ? function(C, S) {
    var $ = r.setDate(C, 1), x = r.setMonth($, r.getMonth($) + 1), w = r.addDate(x, -1);
    return a($, S) && a(w, S);
  } : null, y = /* @__PURE__ */ s.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      l("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, In(o, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ s.createElement(Ko.Provider, {
    value: f
  }, /* @__PURE__ */ s.createElement("div", {
    className: c
  }, /* @__PURE__ */ s.createElement(_a, {
    superOffset: function(S) {
      return r.addYear(o, S);
    },
    onChange: i,
    getStart: function(S) {
      return r.setMonth(S, 0);
    },
    getEnd: function(S) {
      return r.setMonth(S, 11);
    }
  }, y), /* @__PURE__ */ s.createElement(el, fe({}, e, {
    disabledDate: b,
    titleFormat: n.fieldMonthFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: m,
    getCellDate: h,
    getCellText: p,
    getCellClassName: g
  }))));
}
function Kk(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, o = e.pickerValue, a = e.onPickerValueChange, i = e.onModeChange, l = "".concat(t, "-quarter-panel"), c = Ta(e, "quarter"), u = Q(c, 1), d = u[0], f = r.setMonth(o, 0), m = function(b, y) {
    return r.addMonth(b, y * 3);
  }, v = function(b) {
    return In(b, {
      locale: n,
      format: n.cellQuarterFormat,
      generateConfig: r
    });
  }, h = function() {
    return z({}, "".concat(t, "-cell-in-view"), !0);
  }, p = /* @__PURE__ */ s.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      i("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, In(o, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ s.createElement(Ko.Provider, {
    value: d
  }, /* @__PURE__ */ s.createElement("div", {
    className: l
  }, /* @__PURE__ */ s.createElement(_a, {
    superOffset: function(b) {
      return r.addYear(o, b);
    },
    onChange: a,
    getStart: function(b) {
      return r.setMonth(b, 0);
    },
    getEnd: function(b) {
      return r.setMonth(b, 11);
    }
  }, p), /* @__PURE__ */ s.createElement(el, fe({}, e, {
    titleFormat: n.fieldQuarterFormat,
    colNum: 4,
    rowNum: 1,
    baseDate: f,
    getCellDate: m,
    getCellText: v,
    getCellClassName: h
  }))));
}
function qk(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.locale, o = e.value, a = e.hoverValue, i = e.hoverRangeValue, l = r.locale, c = "".concat(t, "-week-panel-row"), u = function(f) {
    var m = {};
    if (i) {
      var v = Q(i, 2), h = v[0], p = v[1], g = ni(n, l, h, f), b = ni(n, l, p, f);
      m["".concat(c, "-range-start")] = g, m["".concat(c, "-range-end")] = b, m["".concat(c, "-range-hover")] = !g && !b && rc(n, h, p, f);
    }
    return a && (m["".concat(c, "-hover")] = a.some(function(y) {
      return ni(n, l, f, y);
    })), J(
      c,
      z({}, "".concat(c, "-selected"), !i && ni(n, l, o, f)),
      // Patch for hover range
      m
    );
  };
  return /* @__PURE__ */ s.createElement(ac, fe({}, e, {
    mode: "week",
    panelName: "week",
    rowClassName: u
  }));
}
function Gk(e) {
  var t = e.prefixCls, n = e.locale, r = e.generateConfig, o = e.pickerValue, a = e.disabledDate, i = e.onPickerValueChange, l = e.onModeChange, c = "".concat(t, "-year-panel"), u = Ta(e, "year"), d = Q(u, 1), f = d[0], m = function(w) {
    var N = Math.floor(r.getYear(o) / 10) * 10;
    return r.setYear(w, N);
  }, v = function(w) {
    var N = m(w);
    return r.addYear(N, 9);
  }, h = m(o), p = v(o), g = r.addYear(h, -1), b = function(w, N) {
    return r.addYear(w, N);
  }, y = function(w) {
    return In(w, {
      locale: n,
      format: n.cellYearFormat,
      generateConfig: r
    });
  }, C = function(w) {
    return z({}, "".concat(t, "-cell-in-view"), Do(r, w, h) || Do(r, w, p) || rc(r, h, p, w));
  }, S = a ? function(x, w) {
    var N = r.setMonth(x, 0), O = r.setDate(N, 1), E = r.setMonth(x, r.getMonth(x) + 1), I = r.addDate(E, -1);
    return a(O, w) && a(I, w);
  } : null, $ = /* @__PURE__ */ s.createElement("button", {
    type: "button",
    key: "year",
    onClick: function() {
      l("decade");
    },
    tabIndex: -1,
    className: "".concat(t, "-decade-btn")
  }, In(h, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }), "-", In(p, {
    locale: n,
    format: n.yearFormat,
    generateConfig: r
  }));
  return /* @__PURE__ */ s.createElement(Ko.Provider, {
    value: f
  }, /* @__PURE__ */ s.createElement("div", {
    className: c
  }, /* @__PURE__ */ s.createElement(_a, {
    superOffset: function(w) {
      return r.addYear(o, w * 10);
    },
    onChange: i,
    getStart: m,
    getEnd: v
  }, $), /* @__PURE__ */ s.createElement(el, fe({}, e, {
    disabledDate: S,
    titleFormat: n.fieldYearFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: g,
    getCellDate: b,
    getCellText: y,
    getCellClassName: C
  }))));
}
var Uk = {
  date: ac,
  datetime: Hk,
  week: qk,
  month: Wk,
  quarter: Kk,
  year: Gk,
  decade: Vk,
  time: XC
};
function Yk(e, t) {
  var n, r = e.locale, o = e.generateConfig, a = e.direction, i = e.prefixCls, l = e.tabIndex, c = l === void 0 ? 0 : l, u = e.multiple, d = e.defaultValue, f = e.value, m = e.onChange, v = e.onSelect, h = e.defaultPickerValue, p = e.pickerValue, g = e.onPickerValueChange, b = e.mode, y = e.onPanelChange, C = e.picker, S = C === void 0 ? "date" : C, $ = e.showTime, x = e.hoverValue, w = e.hoverRangeValue, N = e.cellRender, O = e.dateRender, E = e.monthCellRender, I = e.components, k = I === void 0 ? {} : I, M = e.hideHeader, P = ((n = s.useContext(Er)) === null || n === void 0 ? void 0 : n.prefixCls) || i || "rc-picker", _ = s.useRef();
  s.useImperativeHandle(t, function() {
    return {
      nativeElement: _.current
    };
  });
  var D = _C(e), R = Q(D, 4), T = R[0], L = R[1], F = R[2], j = R[3], A = TC(r, L), B = S === "date" && $ ? "datetime" : S, K = s.useMemo(function() {
    return DC(B, F, j, T, A);
  }, [B, F, j, T, A]), Y = o.getNow(), G = Vt(S, {
    value: b,
    postState: function(pe) {
      return pe || "date";
    }
  }), te = Q(G, 2), ee = te[0], oe = te[1], X = ee === "date" && K ? "datetime" : ee, W = YC(o, r, B), re = Vt(d, {
    value: f
  }), Z = Q(re, 2), H = Z[0], U = Z[1], ae = s.useMemo(function() {
    var he = Wo(H).filter(function(pe) {
      return pe;
    });
    return u ? he : he.slice(0, 1);
  }, [H, u]), ue = Lt(function(he) {
    U(he), m && (he === null || ae.length !== he.length || ae.some(function(pe, Pe) {
      return !zn(o, r, pe, he[Pe], B);
    })) && (m == null || m(u ? he : he[0]));
  }), de = Lt(function(he) {
    if (v == null || v(he), ee === S) {
      var pe = u ? W(ae, he) : [he];
      ue(pe);
    }
  }), se = Vt(h || ae[0] || Y, {
    value: p
  }), ie = Q(se, 2), me = ie[0], Se = ie[1];
  s.useEffect(function() {
    ae[0] && !p && Se(ae[0]);
  }, [ae[0]]);
  var ve = function(pe, Pe) {
    y == null || y(pe || p, Pe || ee);
  }, ge = function(pe) {
    var Pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    Se(pe), g == null || g(pe), Pe && ve(pe);
  }, $e = function(pe, Pe) {
    oe(pe), Pe && ge(Pe), ve(Pe, pe);
  }, we = function(pe) {
    if (de(pe), ge(pe), ee !== S) {
      var Pe = ["decade", "year"], Re = [].concat(Pe, ["month"]), at = {
        quarter: [].concat(Pe, ["quarter"]),
        week: [].concat(be(Re), ["week"]),
        date: [].concat(be(Re), ["date"])
      }, Ze = at[S] || Re, Ie = Ze.indexOf(ee), Be = Ze[Ie + 1];
      Be && $e(Be, pe);
    }
  }, _e = s.useMemo(function() {
    var he, pe;
    if (Array.isArray(w)) {
      var Pe = Q(w, 2);
      he = Pe[0], pe = Pe[1];
    } else
      he = w;
    return !he && !pe ? null : (he = he || pe, pe = pe || he, o.isAfter(he, pe) ? [pe, he] : [he, pe]);
  }, [w, o]), ze = lm(N, O, E), Te = k[X] || Uk[X] || ac, ke = s.useContext(Ar), Le = s.useMemo(function() {
    return V(V({}, ke), {}, {
      hideHeader: M
    });
  }, [ke, M]);
  process.env.NODE_ENV !== "production" && tt(!ae || ae.every(function(he) {
    return o.isValidate(he);
  }), "Invalidate date pass to `value` or `defaultValue`.");
  var Ee = "".concat(P, "-panel"), xe = nc(e, [
    // Week
    "showWeek",
    // Icons
    "prevIcon",
    "nextIcon",
    "superPrevIcon",
    "superNextIcon",
    // Disabled
    "disabledDate",
    "minDate",
    "maxDate",
    // Hover
    "onHover"
  ]);
  return /* @__PURE__ */ s.createElement(Ar.Provider, {
    value: Le
  }, /* @__PURE__ */ s.createElement("div", {
    ref: _,
    tabIndex: c,
    className: J(Ee, z({}, "".concat(Ee, "-rtl"), a === "rtl"))
  }, /* @__PURE__ */ s.createElement(Te, fe({}, xe, {
    // Time
    showTime: K,
    prefixCls: P,
    locale: A,
    generateConfig: o,
    onModeChange: $e,
    pickerValue: me,
    onPickerValueChange: function(pe) {
      ge(pe, !0);
    },
    value: ae[0],
    onSelect: we,
    values: ae,
    cellRender: ze,
    hoverRangeValue: _e,
    hoverValue: x
  }))));
}
var vi = /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(Yk));
process.env.NODE_ENV !== "production" && (vi.displayName = "PanelPicker");
function Xk(e) {
  var t = e.picker, n = e.multiplePanel, r = e.pickerValue, o = e.onPickerValueChange, a = e.onSubmit, i = e.range, l = e.hoverValue, c = s.useContext(Er), u = c.prefixCls, d = c.generateConfig, f = s.useCallback(function(b, y) {
    return ri(d, t, b, y);
  }, [d, t]), m = s.useMemo(function() {
    return f(r, 1);
  }, [r, f]), v = function(y) {
    o(f(y, -1));
  }, h = {
    onCellDblClick: function() {
      a();
    }
  }, p = t === "time", g = V(V({}, e), {}, {
    hoverValue: null,
    hoverRangeValue: null,
    hideHeader: p
  });
  return i ? g.hoverRangeValue = l : g.hoverValue = l, n ? /* @__PURE__ */ s.createElement("div", {
    className: "".concat(u, "-panels")
  }, /* @__PURE__ */ s.createElement(Ar.Provider, {
    value: V(V({}, h), {}, {
      hideNext: !0
    })
  }, /* @__PURE__ */ s.createElement(vi, g)), /* @__PURE__ */ s.createElement(Ar.Provider, {
    value: V(V({}, h), {}, {
      hidePrev: !0
    })
  }, /* @__PURE__ */ s.createElement(vi, fe({}, g, {
    pickerValue: m,
    onPickerValueChange: v
  })))) : /* @__PURE__ */ s.createElement(Ar.Provider, {
    value: V({}, h)
  }, /* @__PURE__ */ s.createElement(vi, g));
}
function op(e) {
  return typeof e == "function" ? e() : e;
}
function Qk(e) {
  var t = e.prefixCls, n = e.presets, r = e.onClick, o = e.onHover;
  return n.length ? /* @__PURE__ */ s.createElement("div", {
    className: "".concat(t, "-presets")
  }, /* @__PURE__ */ s.createElement("ul", null, n.map(function(a, i) {
    var l = a.label, c = a.value;
    return /* @__PURE__ */ s.createElement("li", {
      key: i,
      onClick: function() {
        r(op(c));
      },
      onMouseEnter: function() {
        o(op(c));
      },
      onMouseLeave: function() {
        o(null);
      }
    }, l);
  }))) : null;
}
function QC(e) {
  var t = e.panelRender, n = e.internalMode, r = e.picker, o = e.showNow, a = e.range, i = e.multiple, l = e.activeOffset, c = l === void 0 ? 0 : l, u = e.presets, d = e.onPresetHover, f = e.onPresetSubmit, m = e.onFocus, v = e.onBlur, h = e.direction, p = e.value, g = e.onSelect, b = e.isInvalid, y = e.defaultOpenValue, C = e.onOk, S = e.onSubmit, $ = s.useContext(Er), x = $.prefixCls, w = "".concat(x, "-panel"), N = h === "rtl", O = s.useRef(null), E = s.useState(0), I = Q(E, 2), k = I[0], M = I[1], P = s.useState(0), _ = Q(P, 2), D = _[0], R = _[1], T = function(re) {
    re.offsetWidth && M(re.offsetWidth);
  };
  s.useEffect(function() {
    if (a) {
      var W;
      c + k < ((W = O.current) === null || W === void 0 ? void 0 : W.offsetWidth) ? R(c) : R(0);
    }
  }, [k, c, a]);
  function L(W) {
    return W.filter(function(re) {
      return re;
    });
  }
  var F = s.useMemo(function() {
    return L(Wo(p));
  }, [p]), j = r === "time" && !F.length, A = s.useMemo(function() {
    return j ? L([y]) : F;
  }, [j, F, y]), B = j ? y : F, K = s.useMemo(function() {
    return A.length ? A.some(function(W) {
      return b(W);
    }) : !0;
  }, [A, b]), Y = function() {
    j && g(y), C(), S();
  }, G = /* @__PURE__ */ s.createElement("div", {
    className: "".concat(x, "-panel-layout")
  }, /* @__PURE__ */ s.createElement(Qk, {
    prefixCls: x,
    presets: u,
    onClick: f,
    onHover: d
  }), /* @__PURE__ */ s.createElement("div", null, /* @__PURE__ */ s.createElement(Xk, fe({}, e, {
    value: B
  })), /* @__PURE__ */ s.createElement(Fk, fe({}, e, {
    showNow: i ? !1 : o,
    invalid: K,
    onSubmit: Y
  }))));
  t && (G = t(G));
  var te = "".concat(w, "-container"), ee = "marginLeft", oe = "marginRight", X = /* @__PURE__ */ s.createElement("div", {
    tabIndex: -1,
    className: J(
      te,
      // Used for Today Button style, safe to remove if no need
      "".concat(x, "-").concat(n, "-panel-container")
    ),
    style: z(z({}, N ? oe : ee, D), N ? ee : oe, "auto"),
    onFocus: m,
    onBlur: v
  }, G);
  return a && (X = /* @__PURE__ */ s.createElement("div", {
    ref: O,
    className: J("".concat(x, "-range-wrapper"), "".concat(x, "-").concat(r, "-range-wrapper"))
  }, /* @__PURE__ */ s.createElement("div", {
    className: "".concat(x, "-range-arrow"),
    style: z({}, N ? "right" : "left", c)
  }), /* @__PURE__ */ s.createElement(Mn, {
    onResize: T
  }, X))), X;
}
function JC(e, t) {
  var n = e.format, r = e.maskFormat, o = e.generateConfig, a = e.locale, i = e.preserveInvalidOnBlur, l = e.inputReadOnly, c = e.required, u = e["aria-required"], d = e.onSubmit, f = e.onFocus, m = e.onBlur, v = e.onInputChange, h = e.onInvalid, p = e.open, g = e.onOpenChange, b = e.onKeyDown, y = e.onChange, C = e.activeHelp, S = e.name, $ = e.autoComplete, x = e.id, w = e.value, N = e.invalid, O = e.placeholder, E = e.disabled, I = e.activeIndex, k = e.allHelp, M = e.picker, P = function(A, B) {
    var K = o.locale.parse(a.locale, A, [B]);
    return K && o.isValidate(K) ? K : null;
  }, _ = n[0], D = s.useCallback(function(j) {
    return In(j, {
      locale: a,
      format: _,
      generateConfig: o
    });
  }, [a, o, _]), R = s.useMemo(function() {
    return w.map(D);
  }, [w, D]), T = s.useMemo(function() {
    var j = M === "time" ? 8 : 10, A = typeof _ == "function" ? _(o.getNow()).length : _.length;
    return Math.max(j, A) + 2;
  }, [_, M, o]), L = function(A) {
    for (var B = 0; B < n.length; B += 1) {
      var K = n[B];
      if (typeof K == "string") {
        var Y = P(A, K);
        if (Y)
          return Y;
      }
    }
    return !1;
  }, F = function(A) {
    function B(G) {
      return A !== void 0 ? G[A] : G;
    }
    var K = Bn(e, {
      aria: !0,
      data: !0
    }), Y = V(V({}, K), {}, {
      // ============== Shared ==============
      format: r,
      validateFormat: function(te) {
        return !!L(te);
      },
      preserveInvalidOnBlur: i,
      readOnly: l,
      required: c,
      "aria-required": u,
      name: S,
      autoComplete: $,
      size: T,
      // ============= By Index =============
      id: B(x),
      value: B(R) || "",
      invalid: B(N),
      placeholder: B(O),
      active: I === A,
      helped: k || C && I === A,
      disabled: B(E),
      onFocus: function(te) {
        f(te, A);
      },
      onBlur: function(te) {
        m(te, A);
      },
      onSubmit: d,
      // Get validate text value
      onChange: function(te) {
        v();
        var ee = L(te);
        if (ee) {
          h(!1, A), y(ee, A);
          return;
        }
        h(!!te, A);
      },
      onHelp: function() {
        g(!0, {
          index: A
        });
      },
      onKeyDown: function(te) {
        var ee = !1;
        if (b == null || b(te, function() {
          process.env.NODE_ENV !== "production" && tt(!1, "`preventDefault` callback is deprecated. Please call `event.preventDefault` directly."), ee = !0;
        }), !te.defaultPrevented && !ee)
          switch (te.key) {
            case "Escape":
              g(!1, {
                index: A
              });
              break;
            case "Enter":
              p || g(!0);
              break;
          }
      }
    }, t == null ? void 0 : t({
      valueTexts: R
    }));
    return Object.keys(Y).forEach(function(G) {
      Y[G] === void 0 && delete Y[G];
    }), Y;
  };
  return [F, D];
}
var Jk = ["onMouseEnter", "onMouseLeave"];
function ZC(e) {
  return s.useMemo(function() {
    return nc(e, Jk);
  }, [e]);
}
var Zk = ["icon", "type"], eL = ["onClear"];
function ic(e) {
  var t = e.icon, n = e.type, r = vt(e, Zk), o = s.useContext(Er), a = o.prefixCls;
  return t ? /* @__PURE__ */ s.createElement("span", fe({
    className: "".concat(a, "-").concat(n)
  }, r), t) : null;
}
function Fd(e) {
  var t = e.onClear, n = vt(e, eL);
  return /* @__PURE__ */ s.createElement(ic, fe({}, n, {
    type: "clear",
    role: "button",
    onMouseDown: function(o) {
      o.preventDefault();
    },
    onClick: function(o) {
      o.stopPropagation(), t();
    }
  }));
}
var eu = ["YYYY", "MM", "DD", "HH", "mm", "ss", "SSS"], ap = "顧", tL = /* @__PURE__ */ function() {
  function e(t) {
    $n(this, e), z(this, "format", void 0), z(this, "maskFormat", void 0), z(this, "cells", void 0), z(this, "maskCells", void 0), this.format = t;
    var n = eu.map(function(l) {
      return "(".concat(l, ")");
    }).join("|"), r = new RegExp(n, "g");
    this.maskFormat = t.replace(
      r,
      // Use Chinese character to avoid user use it in format
      function(l) {
        return ap.repeat(l.length);
      }
    );
    var o = new RegExp("(".concat(eu.join("|"), ")")), a = (t.split(o) || []).filter(function(l) {
      return l;
    }), i = 0;
    this.cells = a.map(function(l) {
      var c = eu.includes(l), u = i, d = i + l.length;
      return i = d, {
        text: l,
        mask: c,
        start: u,
        end: d
      };
    }), this.maskCells = this.cells.filter(function(l) {
      return l.mask;
    });
  }
  return wn(e, [{
    key: "getSelection",
    value: function(n) {
      var r = this.maskCells[n] || {}, o = r.start, a = r.end;
      return [o || 0, a || 0];
    }
    /** Check given text match format */
  }, {
    key: "match",
    value: function(n) {
      for (var r = 0; r < this.maskFormat.length; r += 1) {
        var o = this.maskFormat[r], a = n[r];
        if (!a || o !== ap && o !== a)
          return !1;
      }
      return !0;
    }
    /** Get mask cell count */
  }, {
    key: "size",
    value: function() {
      return this.maskCells.length;
    }
  }, {
    key: "getMaskCellIndex",
    value: function(n) {
      for (var r = Number.MAX_SAFE_INTEGER, o = 0, a = 0; a < this.maskCells.length; a += 1) {
        var i = this.maskCells[a], l = i.start, c = i.end;
        if (n >= l && n <= c)
          return a;
        var u = Math.min(Math.abs(n - l), Math.abs(n - c));
        u < r && (r = u, o = a);
      }
      return o;
    }
  }]), e;
}();
function nL(e) {
  var t = {
    YYYY: [0, 9999, (/* @__PURE__ */ new Date()).getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return t[e];
}
var rL = ["active", "showActiveCls", "suffixIcon", "format", "validateFormat", "onChange", "onInput", "helped", "onHelp", "onSubmit", "onKeyDown", "preserveInvalidOnBlur", "invalid", "clearIcon"], bs = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.active, r = e.showActiveCls, o = r === void 0 ? !0 : r, a = e.suffixIcon, i = e.format, l = e.validateFormat, c = e.onChange;
  e.onInput;
  var u = e.helped, d = e.onHelp, f = e.onSubmit, m = e.onKeyDown, v = e.preserveInvalidOnBlur, h = v === void 0 ? !1 : v, p = e.invalid, g = e.clearIcon, b = vt(e, rL), y = e.value, C = e.onFocus, S = e.onBlur, $ = e.onMouseUp, x = s.useContext(Er), w = x.prefixCls, N = x.input, O = N === void 0 ? "input" : N, E = "".concat(w, "-input"), I = s.useState(!1), k = Q(I, 2), M = k[0], P = k[1], _ = s.useState(y), D = Q(_, 2), R = D[0], T = D[1], L = s.useState(""), F = Q(L, 2), j = F[0], A = F[1], B = s.useState(null), K = Q(B, 2), Y = K[0], G = K[1], te = s.useState(null), ee = Q(te, 2), oe = ee[0], X = ee[1], W = R || "";
  s.useEffect(function() {
    T(y);
  }, [y]);
  var re = s.useRef(), Z = s.useRef();
  s.useImperativeHandle(t, function() {
    return {
      nativeElement: re.current,
      inputElement: Z.current,
      focus: function() {
        Z.current.focus();
      },
      blur: function() {
        Z.current.blur();
      }
    };
  });
  var H = s.useMemo(function() {
    return new tL(i || "");
  }, [i]), U = s.useMemo(function() {
    return u ? [0, 0] : H.getSelection(Y);
  }, [H, Y, u]), ae = Q(U, 2), ue = ae[0], de = ae[1], se = function(he) {
    he && he !== i && he !== y && d();
  }, ie = Lt(function(xe) {
    l(xe) && c(xe), T(xe), se(xe);
  }), me = function(he) {
    if (!i) {
      var pe = he.target.value;
      se(pe), T(pe), c(pe);
    }
  }, Se = function(he) {
    var pe = he.clipboardData.getData("text");
    l(pe) && ie(pe);
  }, ve = s.useRef(!1), ge = function() {
    ve.current = !0;
  }, $e = function(he) {
    var pe = he.target, Pe = pe.selectionStart, Re = H.getMaskCellIndex(Pe);
    G(Re), X({}), $ == null || $(he), ve.current = !1;
  }, we = function(he) {
    P(!0), G(0), A(""), C(he);
  }, _e = function(he) {
    S(he);
  }, ze = function(he) {
    P(!1), _e(he);
  };
  um(n, function() {
    !n && !h && T(y);
  });
  var Te = function(he) {
    he.key === "Enter" && l(W) && f(), m == null || m(he);
  }, ke = function(he) {
    Te(he);
    var pe = he.key, Pe = null, Re = null, at = de - ue, Ze = i.slice(ue, de), Ie = function(nt) {
      G(function(et) {
        var Ge = et + nt;
        return Ge = Math.max(Ge, 0), Ge = Math.min(Ge, H.size() - 1), Ge;
      });
    }, Be = function(nt) {
      var et = nL(Ze), Ge = Q(et, 3), Ae = Ge[0], qe = Ge[1], Je = Ge[2], Ke = W.slice(ue, de), Ye = Number(Ke);
      if (isNaN(Ye))
        return String(Je || (nt > 0 ? Ae : qe));
      var Ve = Ye + nt, Qe = qe - Ae + 1;
      return String(Ae + (Qe + Ve - Ae) % Qe);
    };
    switch (pe) {
      case "Backspace":
      case "Delete":
        Pe = "", Re = Ze;
        break;
      case "ArrowLeft":
        Pe = "", Ie(-1);
        break;
      case "ArrowRight":
        Pe = "", Ie(1);
        break;
      case "ArrowUp":
        Pe = "", Re = Be(1);
        break;
      case "ArrowDown":
        Pe = "", Re = Be(-1);
        break;
      default:
        isNaN(Number(pe)) || (Pe = j + pe, Re = Pe);
        break;
    }
    if (Pe !== null && (A(Pe), Pe.length >= at && (Ie(1), A(""))), Re !== null) {
      var bt = (
        // before
        W.slice(0, ue) + // replace
        im(Re, at) + // after
        W.slice(de)
      );
      ie(bt.slice(0, i.length));
    }
    X({});
  }, Le = s.useRef();
  Pt(function() {
    if (!(!M || !i || ve.current)) {
      if (!H.match(W)) {
        ie(i);
        return;
      }
      return Z.current.setSelectionRange(ue, de), Le.current = _t(function() {
        Z.current.setSelectionRange(ue, de);
      }), function() {
        _t.cancel(Le.current);
      };
    }
  }, [H, i, M, W, Y, ue, de, oe, ie]);
  var Ee = i ? {
    onFocus: we,
    onBlur: ze,
    onKeyDown: ke,
    onMouseDown: ge,
    onMouseUp: $e,
    onPaste: Se
  } : {};
  return /* @__PURE__ */ s.createElement("div", {
    ref: re,
    className: J(E, z(z({}, "".concat(E, "-active"), n && o), "".concat(E, "-placeholder"), u))
  }, /* @__PURE__ */ s.createElement(O, fe({
    ref: Z,
    "aria-invalid": p,
    autoComplete: "off"
  }, b, {
    onKeyDown: Te,
    onBlur: _e
    // Replace with format
  }, Ee, {
    // Value
    value: W,
    onChange: me
  })), /* @__PURE__ */ s.createElement(ic, {
    type: "suffix",
    icon: a
  }), g);
});
process.env.NODE_ENV !== "production" && (bs.displayName = "Input");
var oL = ["id", "clearIcon", "suffixIcon", "separator", "activeIndex", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "value", "onChange", "onSubmit", "onInputChange", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onActiveOffset", "onMouseDown", "required", "aria-required", "autoFocus"];
function aL(e, t) {
  var n = e.id, r = e.clearIcon, o = e.suffixIcon, a = e.separator, i = a === void 0 ? "~" : a, l = e.activeIndex;
  e.activeHelp, e.allHelp;
  var c = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown, e.locale, e.generateConfig;
  var u = e.placeholder, d = e.className, f = e.style, m = e.onClick, v = e.onClear, h = e.value;
  e.onChange, e.onSubmit, e.onInputChange, e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var p = e.disabled, g = e.invalid;
  e.inputReadOnly;
  var b = e.direction;
  e.onOpenChange;
  var y = e.onActiveOffset, C = e.onMouseDown;
  e.required, e["aria-required"];
  var S = e.autoFocus, $ = vt(e, oL), x = b === "rtl", w = s.useContext(Er), N = w.prefixCls, O = s.useMemo(function() {
    if (typeof n == "string")
      return [n];
    var ee = n || {};
    return [ee.start, ee.end];
  }, [n]), E = s.useRef(), I = s.useRef(), k = s.useRef(), M = function(oe) {
    var X;
    return (X = [I, k][oe]) === null || X === void 0 ? void 0 : X.current;
  };
  s.useImperativeHandle(t, function() {
    return {
      nativeElement: E.current,
      focus: function() {
        var oe, X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        (oe = M(X)) === null || oe === void 0 || oe.focus();
      },
      blur: function() {
        var oe, X;
        (oe = M(0)) === null || oe === void 0 || oe.blur(), (X = M(1)) === null || X === void 0 || X.blur();
      }
    };
  });
  var P = ZC($), _ = s.useMemo(function() {
    return Array.isArray(u) ? u : [u, u];
  }, [u]), D = JC(V(V({}, e), {}, {
    id: O,
    placeholder: _
  })), R = Q(D, 1), T = R[0], L = x ? "right" : "left", F = s.useState(z({
    position: "absolute",
    width: 0
  }, L, 0)), j = Q(F, 2), A = j[0], B = j[1], K = Lt(function() {
    var ee = M(l);
    if (ee) {
      var oe = ee.nativeElement, X = oe.offsetWidth, W = oe.offsetLeft, re = oe.offsetParent, Z = W;
      if (x) {
        var H = re, U = getComputedStyle(H);
        Z = H.offsetWidth - parseFloat(U.borderRightWidth) - parseFloat(U.borderLeftWidth) - W - X;
      }
      B(function(ae) {
        return V(V({}, ae), {}, z({
          width: X
        }, L, Z));
      }), y(Z);
    }
  });
  s.useEffect(function() {
    K();
  }, [l]);
  var Y = r && (h[0] && !p[0] || h[1] && !p[1]), G = S && !p[0], te = S && !G && !p[1];
  return /* @__PURE__ */ s.createElement(Mn, {
    onResize: K
  }, /* @__PURE__ */ s.createElement("div", fe({}, P, {
    className: J(N, "".concat(N, "-range"), z(z(z(z({}, "".concat(N, "-focused"), c), "".concat(N, "-disabled"), p.every(function(ee) {
      return ee;
    })), "".concat(N, "-invalid"), g.some(function(ee) {
      return ee;
    })), "".concat(N, "-rtl"), x), d),
    style: f,
    ref: E,
    onClick: m,
    onMouseDown: function(oe) {
      var X = oe.target;
      X !== I.current.inputElement && X !== k.current.inputElement && oe.preventDefault(), C == null || C(oe);
    }
  }), /* @__PURE__ */ s.createElement(bs, fe({
    ref: I
  }, T(0), {
    autoFocus: G,
    "date-range": "start"
  })), /* @__PURE__ */ s.createElement("div", {
    className: "".concat(N, "-range-separator")
  }, i), /* @__PURE__ */ s.createElement(bs, fe({
    ref: k
  }, T(1), {
    autoFocus: te,
    "date-range": "end"
  })), /* @__PURE__ */ s.createElement("div", {
    className: "".concat(N, "-active-bar"),
    style: A
  }), /* @__PURE__ */ s.createElement(ic, {
    type: "suffix",
    icon: o
  }), Y && /* @__PURE__ */ s.createElement(Fd, {
    icon: r,
    onClear: v
  })));
}
var eS = /* @__PURE__ */ s.forwardRef(aL);
process.env.NODE_ENV !== "production" && (eS.displayName = "RangeSelector");
function ip(e, t) {
  var n = e ?? t;
  return Array.isArray(n) ? n : [n, n];
}
function Il(e) {
  return e === 1 ? "end" : "start";
}
function iL(e, t) {
  var n = FC(e, function() {
    var Ue = e.disabled, st = e.allowEmpty, gt = ip(Ue, !1), At = ip(st, !1);
    return {
      disabled: gt,
      allowEmpty: At
    };
  }), r = Q(n, 6), o = r[0], a = r[1], i = r[2], l = r[3], c = r[4], u = r[5], d = o.prefixCls, f = o.styles, m = o.classNames, v = o.defaultValue, h = o.value, p = o.needConfirm, g = o.onKeyDown, b = o.disabled, y = o.allowEmpty, C = o.disabledDate, S = o.minDate, $ = o.maxDate, x = o.defaultOpen, w = o.open, N = o.onOpenChange, O = o.locale, E = o.generateConfig, I = o.picker, k = o.showNow, M = o.showToday, P = o.showTime, _ = o.mode, D = o.onPanelChange, R = o.onCalendarChange, T = o.onOk, L = o.defaultPickerValue, F = o.pickerValue, j = o.onPickerValueChange, A = o.inputReadOnly, B = o.suffixIcon, K = o.onFocus, Y = o.onBlur, G = o.presets, te = o.ranges, ee = o.components, oe = o.cellRender, X = o.dateRender, W = o.monthCellRender, re = o.onClick, Z = zC(t), H = jC(w, x, b, N), U = Q(H, 2), ae = U[0], ue = U[1], de = function(st, gt) {
    (b.some(function(At) {
      return !At;
    }) || !st) && ue(st, gt);
  }, se = qC(E, O, l, !0, !1, v, h, R, T), ie = Q(se, 5), me = ie[0], Se = ie[1], ve = ie[2], ge = ie[3], $e = ie[4], we = ve(), _e = BC(b, y), ze = Q(_e, 7), Te = ze[0], ke = ze[1], Le = ze[2], Ee = ze[3], xe = ze[4], he = ze[5], pe = ze[6], Pe = function(st, gt) {
    ke(!0), K == null || K(st, {
      range: Il(gt ?? Ee)
    });
  }, Re = function(st, gt) {
    ke(!1), Y == null || Y(st, {
      range: Il(gt ?? Ee)
    });
  }, at = s.useMemo(function() {
    if (!P)
      return null;
    var Ue = P.disabledTime, st = Ue ? function(gt) {
      var At = Il(Ee);
      return Ue(gt, At);
    } : void 0;
    return V(V({}, P), {}, {
      disabledTime: st
    });
  }, [P, Ee]), Ze = Vt([I, I], {
    value: _
  }), Ie = Q(Ze, 2), Be = Ie[0], bt = Ie[1], He = Be[Ee] || I, nt = He === "date" && at ? "datetime" : He, et = nt === I && nt !== "time", Ge = UC(I, He, k, M, !0), Ae = GC(o, me, Se, ve, ge, b, l, Te, ae, u), qe = Q(Ae, 2), Je = qe[0], Ke = qe[1], Ye = _k(we, b, pe, E, O, C), Ve = RC(we, u, y), Qe = Q(Ve, 2), it = Qe[0], yt = Qe[1], Tt = HC(E, O, we, Be, ae, Ee, a, et, L, F, at == null ? void 0 : at.defaultOpenValue, j, S, $), ne = Q(Tt, 2), ye = ne[0], ce = ne[1], Ce = Lt(function(Ue, st, gt) {
    var At = mi(Be, Ee, st);
    if ((At[0] !== Be[0] || At[1] !== Be[1]) && bt(At), D && gt !== !1) {
      var bn = be(we);
      Ue && (bn[Ee] = Ue), D(bn, At);
    }
  }), je = function(st, gt) {
    return (
      // Trigger change only when date changed
      mi(we, gt, st)
    );
  }, Ne = function(st, gt) {
    var At = we;
    st && (At = je(st, Ee));
    var bn = he(At);
    ge(At), Je(Ee, bn === null), bn === null ? de(!1, {
      force: !0
    }) : gt || Z.current.focus(bn);
  }, De = function(st) {
    if (!Z.current.nativeElement.contains(document.activeElement)) {
      var gt = b.findIndex(function(At) {
        return !At;
      });
      gt >= 0 && Z.current.focus(gt);
    }
    de(!0), re == null || re(st);
  }, Fe = function() {
    Ke(null), de(!1, {
      force: !0
    });
  }, ot = s.useState(null), pt = Q(ot, 2), St = pt[0], Ot = pt[1], Wt = s.useState(null), rn = Q(Wt, 2), Nt = rn[0], Ut = rn[1], fn = s.useMemo(function() {
    return Nt || we;
  }, [we, Nt]);
  s.useEffect(function() {
    ae || Ut(null);
  }, [ae]);
  var sn = s.useState(0), ln = Q(sn, 2), _n = ln[0], ut = ln[1], xt = AC(G, te), jt = function(st) {
    Ut(st), Ot("preset");
  }, on = function(st) {
    var gt = Ke(st);
    gt && de(!1, {
      force: !0
    });
  }, cn = function(st) {
    Ne(st);
  }, hn = function(st) {
    Ut(st ? je(st, Ee) : null), Ot("cell");
  }, Dn = function(st) {
    de(!0), Pe(st);
  }, On = function(st) {
    Le("panel");
    var gt = mi(we, Ee, st);
    ge(gt), !p && !i && a === nt && Ne(st);
  }, mn = function() {
    de(!1);
  }, kn = lm(oe, X, W, Il(Ee)), dt = we[Ee] || null, rt = Lt(function(Ue) {
    return u(Ue, {
      activeIndex: Ee
    });
  }), wt = s.useMemo(function() {
    var Ue = Bn(o, !1), st = an(o, [].concat(be(Object.keys(Ue)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange"]));
    return st;
  }, [o]), zt = /* @__PURE__ */ s.createElement(QC, fe({}, wt, {
    showNow: Ge,
    showTime: at,
    range: !0,
    multiplePanel: et,
    activeOffset: _n,
    disabledDate: Ye,
    onFocus: Dn,
    onBlur: Re,
    picker: I,
    mode: He,
    internalMode: nt,
    onPanelChange: Ce,
    format: c,
    value: dt,
    isInvalid: rt,
    onChange: null,
    onSelect: On,
    pickerValue: ye,
    defaultOpenValue: Wo(P == null ? void 0 : P.defaultOpenValue)[Ee],
    onPickerValueChange: ce,
    hoverValue: fn,
    onHover: hn,
    needConfirm: p,
    onSubmit: Ne,
    onOk: $e,
    presets: xt,
    onPresetHover: jt,
    onPresetSubmit: on,
    onNow: cn,
    cellRender: kn
  })), Mt = function(st, gt) {
    var At = je(st, gt);
    ge(At);
  }, ct = function() {
    Le("input");
  }, ft = function(st, gt) {
    Le("input"), de(!0, {
      inherit: !0
    }), xe(gt), Pe(st, gt);
  }, Yt = function(st, gt) {
    de(!1), Re(st, gt);
  }, en = function(st, gt) {
    st.key === "Tab" && Ne(null, !0), g == null || g(st, gt);
  }, vn = s.useMemo(function() {
    return {
      prefixCls: d,
      locale: O,
      generateConfig: E,
      button: ee.button,
      input: ee.input
    };
  }, [d, O, E, ee.button, ee.input]);
  if (Pt(function() {
    ae && Ee !== void 0 && Ce(null, I, !1);
  }, [ae, Ee, I]), Pt(function() {
    var Ue = Le();
    !ae && Ue === "input" && (de(!1), Ne(null, !0)), !ae && i && !p && Ue === "panel" && (de(!0), Ne());
  }, [ae]), process.env.NODE_ENV !== "production") {
    var Ct = function(st) {
      return (
        // Value is empty
        !(h != null && h[st]) && // DefaultValue is empty
        !(v != null && v[st])
      );
    };
    b.some(function(Ue, st) {
      return Ue && Ct(st) && !y[st];
    }) && tt(!1, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.");
  }
  return /* @__PURE__ */ s.createElement(Er.Provider, {
    value: vn
  }, /* @__PURE__ */ s.createElement(NC, fe({}, PC(o), {
    popupElement: zt,
    popupStyle: f.popup,
    popupClassName: m.popup,
    visible: ae,
    onClose: mn,
    range: !0
  }), /* @__PURE__ */ s.createElement(
    eS,
    fe({}, o, {
      // Ref
      ref: Z,
      suffixIcon: B,
      activeIndex: Te || ae ? Ee : null,
      activeHelp: !!Nt,
      allHelp: !!Nt && St === "preset",
      focused: Te,
      onFocus: ft,
      onBlur: Yt,
      onKeyDown: en,
      onSubmit: Ne,
      value: fn,
      maskFormat: c,
      onChange: Mt,
      onInputChange: ct,
      format: l,
      inputReadOnly: A,
      disabled: b,
      open: ae,
      onOpenChange: de,
      onClick: De,
      onClear: Fe,
      invalid: it,
      onInvalid: yt,
      onActiveOffset: ut
    })
  )));
}
var tS = /* @__PURE__ */ s.forwardRef(iL);
process.env.NODE_ENV !== "production" && (tS.displayName = "RefRangePicker");
function lL(e) {
  var t = e.prefixCls, n = e.value, r = e.onRemove, o = e.removeIcon, a = o === void 0 ? "×" : o, i = e.formatDate, l = e.disabled, c = e.maxTagCount, u = "".concat(t, "-selector"), d = "".concat(t, "-selection"), f = "".concat(d, "-overflow");
  function m(p, g) {
    return /* @__PURE__ */ s.createElement("span", {
      className: J("".concat(d, "-item")),
      title: typeof p == "string" ? p : null
    }, /* @__PURE__ */ s.createElement("span", {
      className: "".concat(d, "-item-content")
    }, p), !l && g && /* @__PURE__ */ s.createElement("span", {
      onMouseDown: function(y) {
        y.preventDefault();
      },
      onClick: g,
      className: "".concat(d, "-item-remove")
    }, a));
  }
  function v(p) {
    var g = i(p), b = function(C) {
      C && C.stopPropagation(), r(p);
    };
    return m(g, b);
  }
  function h(p) {
    var g = "+ ".concat(p.length, " ...");
    return m(g);
  }
  return /* @__PURE__ */ s.createElement("div", {
    className: u
  }, /* @__PURE__ */ s.createElement(Cr, {
    prefixCls: f,
    data: n,
    renderItem: v,
    renderRest: h,
    itemKey: function(g) {
      return i(g);
    },
    maxCount: c
  }));
}
var sL = ["id", "open", "clearIcon", "suffixIcon", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "internalPicker", "value", "onChange", "onSubmit", "onInputChange", "multiple", "maxTagCount", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onMouseDown", "required", "aria-required", "autoFocus", "removeIcon"];
function cL(e, t) {
  e.id;
  var n = e.open, r = e.clearIcon, o = e.suffixIcon;
  e.activeHelp, e.allHelp;
  var a = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown;
  var i = e.locale, l = e.generateConfig;
  e.placeholder;
  var c = e.className, u = e.style, d = e.onClick, f = e.onClear, m = e.internalPicker, v = e.value, h = e.onChange, p = e.onSubmit;
  e.onInputChange;
  var g = e.multiple, b = e.maxTagCount;
  e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var y = e.disabled, C = e.invalid;
  e.inputReadOnly;
  var S = e.direction;
  e.onOpenChange;
  var $ = e.onMouseDown;
  e.required, e["aria-required"];
  var x = e.autoFocus, w = e.removeIcon, N = vt(e, sL), O = S === "rtl", E = s.useContext(Er), I = E.prefixCls, k = s.useRef(), M = s.useRef();
  s.useImperativeHandle(t, function() {
    return {
      nativeElement: k.current,
      focus: function() {
        var K;
        (K = M.current) === null || K === void 0 || K.focus();
      },
      blur: function() {
        var K;
        (K = M.current) === null || K === void 0 || K.blur();
      }
    };
  });
  var P = ZC(N), _ = function(K) {
    h([K]);
  }, D = function(K) {
    var Y = v.filter(function(G) {
      return G && !zn(l, i, G, K, m);
    });
    h(Y), n || p();
  }, R = JC(V(V({}, e), {}, {
    onChange: _
  }), function(B) {
    var K = B.valueTexts;
    return {
      value: K[0] || "",
      active: a
    };
  }), T = Q(R, 2), L = T[0], F = T[1], j = !!(r && v.length && !y), A = g ? /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(lL, {
    prefixCls: I,
    value: v,
    onRemove: D,
    formatDate: F,
    maxTagCount: b,
    disabled: y,
    removeIcon: w
  }), /* @__PURE__ */ s.createElement("input", {
    className: "".concat(I, "-multiple-input"),
    value: v.map(F).join(","),
    ref: M,
    readOnly: !0,
    autoFocus: x
  }), /* @__PURE__ */ s.createElement(ic, {
    type: "suffix",
    icon: o
  }), j && /* @__PURE__ */ s.createElement(Fd, {
    icon: r,
    onClear: f
  })) : /* @__PURE__ */ s.createElement(bs, fe({
    ref: M
  }, L(), {
    autoFocus: x,
    suffixIcon: o,
    clearIcon: j && /* @__PURE__ */ s.createElement(Fd, {
      icon: r,
      onClear: f
    }),
    showActiveCls: !1
  }));
  return /* @__PURE__ */ s.createElement("div", fe({}, P, {
    className: J(I, z(z(z(z(z({}, "".concat(I, "-multiple"), g), "".concat(I, "-focused"), a), "".concat(I, "-disabled"), y), "".concat(I, "-invalid"), C), "".concat(I, "-rtl"), O), c),
    style: u,
    ref: k,
    onClick: d,
    onMouseDown: function(K) {
      var Y, G = K.target;
      G !== ((Y = M.current) === null || Y === void 0 ? void 0 : Y.inputElement) && K.preventDefault(), $ == null || $(K);
    }
  }), A);
}
var nS = /* @__PURE__ */ s.forwardRef(cL);
process.env.NODE_ENV !== "production" && (nS.displayName = "SingleSelector");
function uL(e, t) {
  var n = FC(e), r = Q(n, 6), o = r[0], a = r[1], i = r[2], l = r[3], c = r[4], u = r[5], d = o, f = d.prefixCls, m = d.styles, v = d.classNames, h = d.order, p = d.defaultValue, g = d.value, b = d.needConfirm, y = d.onChange, C = d.onKeyDown, S = d.disabled, $ = d.disabledDate, x = d.minDate, w = d.maxDate, N = d.defaultOpen, O = d.open, E = d.onOpenChange, I = d.locale, k = d.generateConfig, M = d.picker, P = d.showNow, _ = d.showToday, D = d.showTime, R = d.mode, T = d.onPanelChange, L = d.onCalendarChange, F = d.onOk, j = d.multiple, A = d.defaultPickerValue, B = d.pickerValue, K = d.onPickerValueChange, Y = d.inputReadOnly, G = d.suffixIcon, te = d.removeIcon, ee = d.onFocus, oe = d.onBlur, X = d.presets, W = d.components, re = d.cellRender, Z = d.dateRender, H = d.monthCellRender, U = d.onClick, ae = zC(t);
  function ue(ct) {
    return ct === null ? null : j ? ct : ct[0];
  }
  var de = YC(k, I, a), se = jC(O, N, [S], E), ie = Q(se, 2), me = ie[0], Se = ie[1], ve = function(ft, Yt, en) {
    if (L) {
      var vn = V({}, en);
      delete vn.range, L(ue(ft), ue(Yt), vn);
    }
  }, ge = function(ft) {
    F == null || F(ue(ft));
  }, $e = qC(k, I, l, !1, h, p, g, ve, ge), we = Q($e, 5), _e = we[0], ze = we[1], Te = we[2], ke = we[3], Le = we[4], Ee = Te(), xe = BC([S]), he = Q(xe, 4), pe = he[0], Pe = he[1], Re = he[2], at = he[3], Ze = function(ft) {
    Pe(!0), ee == null || ee(ft, {});
  }, Ie = function(ft) {
    Pe(!1), oe == null || oe(ft, {});
  }, Be = Vt(M, {
    value: R
  }), bt = Q(Be, 2), He = bt[0], nt = bt[1], et = He === "date" && D ? "datetime" : He, Ge = UC(M, He, P, _), Ae = y && function(ct, ft) {
    y(ue(ct), ue(ft));
  }, qe = GC(
    V(V({}, o), {}, {
      onChange: Ae
    }),
    _e,
    ze,
    Te,
    ke,
    [],
    //disabled,
    l,
    pe,
    me,
    u
  ), Je = Q(qe, 2), Ke = Je[1], Ye = RC(Ee, u), Ve = Q(Ye, 2), Qe = Ve[0], it = Ve[1], yt = s.useMemo(function() {
    return Qe.some(function(ct) {
      return ct;
    });
  }, [Qe]), Tt = function(ft, Yt) {
    if (K) {
      var en = V(V({}, Yt), {}, {
        mode: Yt.mode[0]
      });
      delete en.range, K(ft[0], en);
    }
  }, ne = HC(
    k,
    I,
    Ee,
    [He],
    me,
    at,
    a,
    !1,
    // multiplePanel,
    A,
    B,
    Wo(D == null ? void 0 : D.defaultOpenValue),
    Tt,
    x,
    w
  ), ye = Q(ne, 2), ce = ye[0], Ce = ye[1], je = Lt(function(ct, ft, Yt) {
    if (nt(ft), T && Yt !== !1) {
      var en = ct || Ee[Ee.length - 1];
      T(en, ft);
    }
  }), Ne = function() {
    Ke(Te()), Se(!1, {
      force: !0
    });
  }, De = function(ft) {
    !S && !ae.current.nativeElement.contains(document.activeElement) && ae.current.focus(), Se(!0), U == null || U(ft);
  }, Fe = function() {
    Ke(null), Se(!1, {
      force: !0
    });
  }, ot = s.useState(null), pt = Q(ot, 2), St = pt[0], Ot = pt[1], Wt = s.useState(null), rn = Q(Wt, 2), Nt = rn[0], Ut = rn[1], fn = s.useMemo(function() {
    var ct = [Nt].concat(be(Ee)).filter(function(ft) {
      return ft;
    });
    return j ? ct : ct.slice(0, 1);
  }, [Ee, Nt, j]), sn = s.useMemo(function() {
    return !j && Nt ? [Nt] : Ee.filter(function(ct) {
      return ct;
    });
  }, [Ee, Nt, j]);
  s.useEffect(function() {
    me || Ut(null);
  }, [me]);
  var ln = AC(X), _n = function(ft) {
    Ut(ft), Ot("preset");
  }, ut = function(ft) {
    var Yt = j ? de(Te(), ft) : [ft], en = Ke(Yt);
    en && !j && Se(!1, {
      force: !0
    });
  }, xt = function(ft) {
    ut(ft);
  }, jt = function(ft) {
    Ut(ft), Ot("cell");
  }, on = function(ft) {
    Se(!0), Ze(ft);
  }, cn = function(ft) {
    Re("panel");
    var Yt = j ? de(Te(), ft) : [ft];
    ke(Yt), !b && !i && a === et && Ne();
  }, hn = function() {
    Se(!1);
  }, Dn = lm(re, Z, H), On = s.useMemo(function() {
    var ct = Bn(o, !1), ft = an(o, [].concat(be(Object.keys(ct)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange"]));
    return V(V({}, ft), {}, {
      multiple: o.multiple
    });
  }, [o]), mn = /* @__PURE__ */ s.createElement(QC, fe({}, On, {
    showNow: Ge,
    showTime: D,
    disabledDate: $,
    onFocus: on,
    onBlur: Ie,
    picker: M,
    mode: He,
    internalMode: et,
    onPanelChange: je,
    format: c,
    value: Ee,
    isInvalid: u,
    onChange: null,
    onSelect: cn,
    pickerValue: ce,
    defaultOpenValue: D == null ? void 0 : D.defaultOpenValue,
    onPickerValueChange: Ce,
    hoverValue: fn,
    onHover: jt,
    needConfirm: b,
    onSubmit: Ne,
    onOk: Le,
    presets: ln,
    onPresetHover: _n,
    onPresetSubmit: ut,
    onNow: xt,
    cellRender: Dn
  })), kn = function(ft) {
    ke(ft);
  }, dt = function() {
    Re("input");
  }, rt = function(ft) {
    Re("input"), Se(!0, {
      inherit: !0
    }), Ze(ft);
  }, wt = function(ft) {
    Se(!1), Ie(ft);
  }, zt = function(ft, Yt) {
    ft.key === "Tab" && Ne(), C == null || C(ft, Yt);
  }, Mt = s.useMemo(function() {
    return {
      prefixCls: f,
      locale: I,
      generateConfig: k,
      button: W.button,
      input: W.input
    };
  }, [f, I, k, W.button, W.input]);
  return Pt(function() {
    me && at !== void 0 && je(null, M, !1);
  }, [me, at, M]), Pt(function() {
    var ct = Re();
    !me && ct === "input" && (Se(!1), Ne()), !me && i && !b && ct === "panel" && (Se(!0), Ne());
  }, [me]), /* @__PURE__ */ s.createElement(Er.Provider, {
    value: Mt
  }, /* @__PURE__ */ s.createElement(NC, fe({}, PC(o), {
    popupElement: mn,
    popupStyle: m.popup,
    popupClassName: v.popup,
    visible: me,
    onClose: hn
  }), /* @__PURE__ */ s.createElement(
    nS,
    fe({}, o, {
      // Ref
      ref: ae,
      suffixIcon: G,
      removeIcon: te,
      activeHelp: !!Nt,
      allHelp: !!Nt && St === "preset",
      focused: pe,
      onFocus: rt,
      onBlur: wt,
      onKeyDown: zt,
      onSubmit: Ne,
      value: sn,
      maskFormat: c,
      onChange: kn,
      onInputChange: dt,
      internalPicker: a,
      format: l,
      inputReadOnly: Y,
      disabled: S,
      open: me,
      onOpenChange: Se,
      onClick: De,
      onClear: Fe,
      invalid: yt,
      onInvalid: function(ft) {
        it(ft, 0);
      }
    })
  )));
}
var rS = /* @__PURE__ */ s.forwardRef(uL);
process.env.NODE_ENV !== "production" && (rS.displayName = "RefPicker");
const oS = /* @__PURE__ */ s.createContext(null), dL = oS.Provider, aS = /* @__PURE__ */ s.createContext(null), fL = aS.Provider;
var mL = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], iS = /* @__PURE__ */ ar(function(e, t) {
  var n, r = e.prefixCls, o = r === void 0 ? "rc-checkbox" : r, a = e.className, i = e.style, l = e.checked, c = e.disabled, u = e.defaultChecked, d = u === void 0 ? !1 : u, f = e.type, m = f === void 0 ? "checkbox" : f, v = e.title, h = e.onChange, p = vt(e, mL), g = Xe(null), b = Vt(d, {
    value: l
  }), y = Q(b, 2), C = y[0], S = y[1];
  qr(t, function() {
    return {
      focus: function() {
        var N;
        (N = g.current) === null || N === void 0 || N.focus();
      },
      blur: function() {
        var N;
        (N = g.current) === null || N === void 0 || N.blur();
      },
      input: g.current
    };
  });
  var $ = J(o, a, (n = {}, z(n, "".concat(o, "-checked"), C), z(n, "".concat(o, "-disabled"), c), n)), x = function(N) {
    c || ("checked" in e || S(N.target.checked), h == null || h({
      target: V(V({}, e), {}, {
        type: m,
        checked: N.target.checked
      }),
      stopPropagation: function() {
        N.stopPropagation();
      },
      preventDefault: function() {
        N.preventDefault();
      },
      nativeEvent: N.nativeEvent
    }));
  };
  return /* @__PURE__ */ s.createElement("span", {
    className: $,
    title: v,
    style: i
  }, /* @__PURE__ */ s.createElement("input", fe({}, p, {
    className: "".concat(o, "-input"),
    ref: g,
    onChange: x,
    disabled: c,
    checked: !!C,
    type: m
  })), /* @__PURE__ */ s.createElement("span", {
    className: "".concat(o, "-inner")
  }));
});
const vL = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-group`;
  return {
    [r]: Object.assign(Object.assign({}, Gt(e)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${r}-rtl`]: {
        direction: "rtl"
      },
      [`${n}-badge ${n}-badge-count`]: {
        zIndex: 1
      },
      [`> ${n}-badge:not(:first-child) > ${n}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, gL = (e) => {
  const {
    componentCls: t,
    wrapperMarginInlineEnd: n,
    colorPrimary: r,
    radioSize: o,
    motionDurationSlow: a,
    motionDurationMid: i,
    motionEaseInOutCirc: l,
    colorBgContainer: c,
    colorBorder: u,
    lineWidth: d,
    colorBgContainerDisabled: f,
    colorTextDisabled: m,
    paddingXS: v,
    dotColorDisabled: h,
    lineType: p,
    radioColor: g,
    radioBgColor: b,
    calc: y
  } = e, C = `${t}-inner`, S = 4, $ = y(o).sub(y(S).mul(2)), x = y(1).mul(o).equal();
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, Gt(e)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: n,
      cursor: "pointer",
      // RTL
      [`&${t}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: e.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      // hashId 在 wrapper 上，只能铺平
      [`${t}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${q(d)} ${p} ${r}`,
        borderRadius: "50%",
        visibility: "hidden",
        content: '""'
      },
      [t]: Object.assign(Object.assign({}, Gt(e)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${t}-wrapper:hover &,
        &:hover ${C}`]: {
        borderColor: r
      },
      [`${t}-input:focus-visible + ${C}`]: Object.assign({}, io(e)),
      [`${t}:hover::after, ${t}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${t}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: x,
          height: x,
          marginBlockStart: y(1).mul(o).div(-2).equal(),
          marginInlineStart: y(1).mul(o).div(-2).equal(),
          backgroundColor: g,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: x,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${a} ${l}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: x,
        height: x,
        backgroundColor: c,
        borderColor: u,
        borderStyle: "solid",
        borderWidth: d,
        borderRadius: "50%",
        transition: `all ${i}`
      },
      [`${t}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${t}-checked`]: {
        [C]: {
          borderColor: r,
          backgroundColor: b,
          "&::after": {
            transform: `scale(${e.calc(e.dotSize).div(o).equal()})`,
            opacity: 1,
            transition: `all ${a} ${l}`
          }
        }
      },
      [`${t}-disabled`]: {
        cursor: "not-allowed",
        [C]: {
          backgroundColor: f,
          borderColor: u,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: h
          }
        },
        [`${t}-input`]: {
          cursor: "not-allowed"
        },
        [`${t}-disabled + span`]: {
          color: m,
          cursor: "not-allowed"
        },
        [`&${t}-checked`]: {
          [C]: {
            "&::after": {
              transform: `scale(${y($).div(o).equal({
                unit: !1
              })})`
            }
          }
        }
      },
      [`span${t} + *`]: {
        paddingInlineStart: v,
        paddingInlineEnd: v
      }
    })
  };
}, pL = (e) => {
  const {
    buttonColor: t,
    controlHeight: n,
    componentCls: r,
    lineWidth: o,
    lineType: a,
    colorBorder: i,
    motionDurationSlow: l,
    motionDurationMid: c,
    buttonPaddingInline: u,
    fontSize: d,
    buttonBg: f,
    fontSizeLG: m,
    controlHeightLG: v,
    controlHeightSM: h,
    paddingXS: p,
    borderRadius: g,
    borderRadiusSM: b,
    borderRadiusLG: y,
    buttonCheckedBg: C,
    buttonSolidCheckedColor: S,
    colorTextDisabled: $,
    colorBgContainerDisabled: x,
    buttonCheckedBgDisabled: w,
    buttonCheckedColorDisabled: N,
    colorPrimary: O,
    colorPrimaryHover: E,
    colorPrimaryActive: I,
    buttonSolidCheckedBg: k,
    buttonSolidCheckedHoverBg: M,
    buttonSolidCheckedActiveBg: P,
    calc: _
  } = e;
  return {
    [`${r}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: n,
      margin: 0,
      paddingInline: u,
      paddingBlock: 0,
      color: t,
      fontSize: d,
      lineHeight: q(_(n).sub(_(o).mul(2)).equal()),
      background: f,
      border: `${q(o)} ${a} ${i}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: _(o).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: o,
      cursor: "pointer",
      transition: [`color ${c}`, `background ${c}`, `box-shadow ${c}`].join(","),
      a: {
        color: t
      },
      [`> ${r}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:first-child)": {
        "&::before": {
          position: "absolute",
          insetBlockStart: _(o).mul(-1).equal(),
          insetInlineStart: _(o).mul(-1).equal(),
          display: "block",
          boxSizing: "content-box",
          width: 1,
          height: "100%",
          paddingBlock: o,
          paddingInline: 0,
          backgroundColor: i,
          transition: `background-color ${l}`,
          content: '""'
        }
      },
      "&:first-child": {
        borderInlineStart: `${q(o)} ${a} ${i}`,
        borderStartStartRadius: g,
        borderEndStartRadius: g
      },
      "&:last-child": {
        borderStartEndRadius: g,
        borderEndEndRadius: g
      },
      "&:first-child:last-child": {
        borderRadius: g
      },
      [`${r}-group-large &`]: {
        height: v,
        fontSize: m,
        lineHeight: q(_(v).sub(_(o).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: y,
          borderEndStartRadius: y
        },
        "&:last-child": {
          borderStartEndRadius: y,
          borderEndEndRadius: y
        }
      },
      [`${r}-group-small &`]: {
        height: h,
        paddingInline: _(p).sub(o).equal(),
        paddingBlock: 0,
        lineHeight: q(_(h).sub(_(o).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: b,
          borderEndStartRadius: b
        },
        "&:last-child": {
          borderStartEndRadius: b,
          borderEndEndRadius: b
        }
      },
      "&:hover": {
        position: "relative",
        color: O
      },
      "&:has(:focus-visible)": Object.assign({}, io(e)),
      [`${r}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${r}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: O,
        background: C,
        borderColor: O,
        "&::before": {
          backgroundColor: O
        },
        "&:first-child": {
          borderColor: O
        },
        "&:hover": {
          color: E,
          borderColor: E,
          "&::before": {
            backgroundColor: E
          }
        },
        "&:active": {
          color: I,
          borderColor: I,
          "&::before": {
            backgroundColor: I
          }
        }
      },
      [`${r}-group-solid &-checked:not(${r}-button-wrapper-disabled)`]: {
        color: S,
        background: k,
        borderColor: k,
        "&:hover": {
          color: S,
          background: M,
          borderColor: M
        },
        "&:active": {
          color: S,
          background: P,
          borderColor: P
        }
      },
      "&-disabled": {
        color: $,
        backgroundColor: x,
        borderColor: i,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: $,
          backgroundColor: x,
          borderColor: i
        }
      },
      [`&-disabled${r}-button-wrapper-checked`]: {
        color: N,
        backgroundColor: w,
        borderColor: i,
        boxShadow: "none"
      }
    }
  };
}, hL = (e) => {
  const {
    wireframe: t,
    padding: n,
    marginXS: r,
    lineWidth: o,
    fontSizeLG: a,
    colorText: i,
    colorBgContainer: l,
    colorTextDisabled: c,
    controlItemBgActiveDisabled: u,
    colorTextLightSolid: d,
    colorPrimary: f,
    colorPrimaryHover: m,
    colorPrimaryActive: v,
    colorWhite: h
  } = e, p = 4, g = a, b = t ? g - p * 2 : g - (p + o) * 2;
  return {
    // Radio
    radioSize: g,
    dotSize: b,
    dotColorDisabled: c,
    // Radio buttons
    buttonSolidCheckedColor: d,
    buttonSolidCheckedBg: f,
    buttonSolidCheckedHoverBg: m,
    buttonSolidCheckedActiveBg: v,
    buttonBg: l,
    buttonCheckedBg: l,
    buttonColor: i,
    buttonCheckedBgDisabled: u,
    buttonCheckedColorDisabled: c,
    buttonPaddingInline: n - o,
    wrapperMarginInlineEnd: r,
    // internal
    radioColor: t ? f : h,
    radioBgColor: t ? l : f
  };
}, lS = Xt("Radio", (e) => {
  const {
    controlOutline: t,
    controlOutlineWidth: n
  } = e, r = `0 0 0 ${q(n)} ${t}`, a = Dt(e, {
    radioFocusShadow: r,
    radioButtonFocusShadow: r
  });
  return [vL(a), gL(a), pL(a)];
}, hL, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var bL = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const yL = (e, t) => {
  var n, r;
  const o = s.useContext(oS), a = s.useContext(aS), {
    getPrefixCls: i,
    direction: l,
    radio: c
  } = s.useContext(lt), u = s.useRef(null), d = Un(t, u), {
    isFormItemInput: f
  } = s.useContext(Tn);
  if (process.env.NODE_ENV !== "production") {
    const P = Rt("Radio");
    process.env.NODE_ENV !== "production" && P(!("optionType" in e), "usage", "`optionType` is only support in Radio.Group.");
  }
  const m = (P) => {
    var _, D;
    (_ = e.onChange) === null || _ === void 0 || _.call(e, P), (D = o == null ? void 0 : o.onChange) === null || D === void 0 || D.call(o, P);
  }, {
    prefixCls: v,
    className: h,
    rootClassName: p,
    children: g,
    style: b,
    title: y
  } = e, C = bL(e, ["prefixCls", "className", "rootClassName", "children", "style", "title"]), S = i("radio", v), $ = ((o == null ? void 0 : o.optionType) || a) === "button", x = $ ? `${S}-button` : S, w = En(S), [N, O, E] = lS(S, w), I = Object.assign({}, C), k = s.useContext(dr);
  o && (I.name = o.name, I.onChange = m, I.checked = e.value === o.value, I.disabled = (n = I.disabled) !== null && n !== void 0 ? n : o.disabled), I.disabled = (r = I.disabled) !== null && r !== void 0 ? r : k;
  const M = J(`${x}-wrapper`, {
    [`${x}-wrapper-checked`]: I.checked,
    [`${x}-wrapper-disabled`]: I.disabled,
    [`${x}-wrapper-rtl`]: l === "rtl",
    [`${x}-wrapper-in-form-item`]: f
  }, c == null ? void 0 : c.className, h, p, O, E, w);
  return N(/* @__PURE__ */ s.createElement(Bi, {
    component: "Radio",
    disabled: I.disabled
  }, /* @__PURE__ */ s.createElement("label", {
    className: M,
    style: Object.assign(Object.assign({}, c == null ? void 0 : c.style), b),
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    title: y
  }, /* @__PURE__ */ s.createElement(iS, Object.assign({}, I, {
    className: J(I.className, !$ && Fs),
    type: "radio",
    prefixCls: x,
    ref: d
  })), g !== void 0 ? /* @__PURE__ */ s.createElement("span", null, g) : null)));
}, sS = /* @__PURE__ */ s.forwardRef(yL);
process.env.NODE_ENV !== "production" && (sS.displayName = "Radio");
const ys = sS, CL = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r
  } = s.useContext(lt), [o, a] = Vt(e.defaultValue, {
    value: e.value
  }), i = (P) => {
    const _ = o, D = P.target.value;
    "value" in e || a(D);
    const {
      onChange: R
    } = e;
    R && D !== _ && R(P);
  }, {
    prefixCls: l,
    className: c,
    rootClassName: u,
    options: d,
    buttonStyle: f = "outline",
    disabled: m,
    children: v,
    size: h,
    style: p,
    id: g,
    onMouseEnter: b,
    onMouseLeave: y,
    onFocus: C,
    onBlur: S
  } = e, $ = n("radio", l), x = `${$}-group`, w = En($), [N, O, E] = lS($, w);
  let I = v;
  d && d.length > 0 && (I = d.map((P) => typeof P == "string" || typeof P == "number" ? /* @__PURE__ */ s.createElement(ys, {
    key: P.toString(),
    prefixCls: $,
    disabled: m,
    value: P,
    checked: o === P
  }, P) : /* @__PURE__ */ s.createElement(ys, {
    key: `radio-group-value-options-${P.value}`,
    prefixCls: $,
    disabled: P.disabled || m,
    value: P.value,
    checked: o === P.value,
    title: P.title,
    style: P.style,
    id: P.id,
    required: P.required
  }, P.label)));
  const k = qn(h), M = J(x, `${x}-${f}`, {
    [`${x}-${k}`]: k,
    [`${x}-rtl`]: r === "rtl"
  }, c, u, O, E, w);
  return N(/* @__PURE__ */ s.createElement("div", Object.assign({}, Bn(e, {
    aria: !0,
    data: !0
  }), {
    className: M,
    style: p,
    onMouseEnter: b,
    onMouseLeave: y,
    onFocus: C,
    onBlur: S,
    id: g,
    ref: t
  }), /* @__PURE__ */ s.createElement(dL, {
    value: {
      onChange: i,
      value: o,
      disabled: e.disabled,
      name: e.name,
      optionType: e.optionType
    }
  }, I)));
}), cS = /* @__PURE__ */ s.memo(CL);
var SL = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const xL = (e, t) => {
  const {
    getPrefixCls: n
  } = s.useContext(lt), {
    prefixCls: r
  } = e, o = SL(e, ["prefixCls"]), a = n("radio", r);
  return /* @__PURE__ */ s.createElement(fL, {
    value: "button"
  }, /* @__PURE__ */ s.createElement(ys, Object.assign({
    prefixCls: a
  }, o, {
    type: "radio",
    ref: t
  })));
}, jd = /* @__PURE__ */ s.forwardRef(xL), lc = ys;
lc.Button = jd;
lc.Group = cS;
lc.__ANT_RADIO = !0;
const tl = lc, $L = 10, wL = 20;
function EL(e) {
  const {
    fullscreen: t,
    validRange: n,
    generateConfig: r,
    locale: o,
    prefixCls: a,
    value: i,
    onChange: l,
    divRef: c
  } = e, u = r.getYear(i || r.getNow());
  let d = u - $L, f = d + wL;
  n && (d = r.getYear(n[0]), f = r.getYear(n[1]) + 1);
  const m = o && o.year === "年" ? "年" : "", v = [];
  for (let h = d; h < f; h++)
    v.push({
      label: `${h}${m}`,
      value: h
    });
  return /* @__PURE__ */ s.createElement(po, {
    size: t ? void 0 : "small",
    options: v,
    value: u,
    className: `${a}-year-select`,
    onChange: (h) => {
      let p = r.setYear(i, h);
      if (n) {
        const [g, b] = n, y = r.getYear(p), C = r.getMonth(p);
        y === r.getYear(b) && C > r.getMonth(b) && (p = r.setMonth(p, r.getMonth(b))), y === r.getYear(g) && C < r.getMonth(g) && (p = r.setMonth(p, r.getMonth(g)));
      }
      l(p);
    },
    getPopupContainer: () => c.current
  });
}
function OL(e) {
  const {
    prefixCls: t,
    fullscreen: n,
    validRange: r,
    value: o,
    generateConfig: a,
    locale: i,
    onChange: l,
    divRef: c
  } = e, u = a.getMonth(o || a.getNow());
  let d = 0, f = 11;
  if (r) {
    const [h, p] = r, g = a.getYear(o);
    a.getYear(p) === g && (f = a.getMonth(p)), a.getYear(h) === g && (d = a.getMonth(h));
  }
  const m = i.shortMonths || a.locale.getShortMonths(i.locale), v = [];
  for (let h = d; h <= f; h += 1)
    v.push({
      label: m[h],
      value: h
    });
  return /* @__PURE__ */ s.createElement(po, {
    size: n ? void 0 : "small",
    className: `${t}-month-select`,
    value: u,
    options: v,
    onChange: (h) => {
      l(a.setMonth(o, h));
    },
    getPopupContainer: () => c.current
  });
}
function NL(e) {
  const {
    prefixCls: t,
    locale: n,
    mode: r,
    fullscreen: o,
    onModeChange: a
  } = e;
  return /* @__PURE__ */ s.createElement(cS, {
    onChange: (i) => {
      let {
        target: {
          value: l
        }
      } = i;
      a(l);
    },
    value: r,
    size: o ? void 0 : "small",
    className: `${t}-mode-switch`
  }, /* @__PURE__ */ s.createElement(jd, {
    value: "month"
  }, n.month), /* @__PURE__ */ s.createElement(jd, {
    value: "year"
  }, n.year));
}
function IL(e) {
  const {
    prefixCls: t,
    fullscreen: n,
    mode: r,
    onChange: o,
    onModeChange: a
  } = e, i = s.useRef(null), l = qt(Tn), c = nn(() => Object.assign(Object.assign({}, l), {
    isFormItemInput: !1
  }), [l]), u = Object.assign(Object.assign({}, e), {
    fullscreen: n,
    divRef: i
  });
  return /* @__PURE__ */ s.createElement("div", {
    className: `${t}-header`,
    ref: i
  }, /* @__PURE__ */ s.createElement(Tn.Provider, {
    value: c
  }, /* @__PURE__ */ s.createElement(EL, Object.assign({}, u, {
    onChange: (d) => {
      o(d, "year");
    }
  })), r === "month" && /* @__PURE__ */ s.createElement(OL, Object.assign({}, u, {
    onChange: (d) => {
      o(d, "month");
    }
  }))), /* @__PURE__ */ s.createElement(NL, Object.assign({}, u, {
    onModeChange: a
  })));
}
function fm(e) {
  return Dt(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const mm = (e) => {
  const {
    controlHeight: t,
    fontSize: n,
    lineHeight: r,
    lineWidth: o,
    controlHeightSM: a,
    controlHeightLG: i,
    fontSizeLG: l,
    lineHeightLG: c,
    paddingSM: u,
    controlPaddingHorizontalSM: d,
    controlPaddingHorizontal: f,
    colorFillAlter: m,
    colorPrimaryHover: v,
    colorPrimary: h,
    controlOutlineWidth: p,
    controlOutline: g,
    colorErrorOutline: b,
    colorWarningOutline: y,
    colorBgContainer: C
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - n * r) / 2 * 10) / 10 - o, 0),
    paddingBlockSM: Math.max(Math.round((a - n * r) / 2 * 10) / 10 - o, 0),
    paddingBlockLG: Math.ceil((i - l * c) / 2 * 10) / 10 - o,
    paddingInline: u - o,
    paddingInlineSM: d - o,
    paddingInlineLG: f - o,
    addonBg: m,
    activeBorderColor: h,
    hoverBorderColor: v,
    activeShadow: `0 0 0 ${p}px ${g}`,
    errorActiveShadow: `0 0 0 ${p}px ${b}`,
    warningActiveShadow: `0 0 0 ${p}px ${y}`,
    hoverBg: C,
    activeBg: C,
    inputFontSize: n,
    inputFontSizeLG: l,
    inputFontSizeSM: n
  };
}, PL = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), sc = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, PL(Dt(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), vm = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), lp = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, vm(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), uS = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, vm(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, sc(e))
  }), lp(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), lp(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), sp = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), RL = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, sp(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), sp(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, sc(e))
    }
  })
}), dS = (e, t) => ({
  "&-borderless": Object.assign({
    background: "transparent",
    border: "none",
    "&:focus, &:focus-within": {
      outline: "none"
    },
    [`&${e.componentCls}-disabled, &[disabled]`]: {
      color: e.colorTextDisabled
    }
  }, t)
}), fS = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  ["input&, & input, textarea&, & textarea"]: {
    color: t == null ? void 0 : t.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), cp = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, fS(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), mS = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, fS(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, sc(e))
  }), cp(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), cp(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), up = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), ML = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${q(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${q(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, up(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), up(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), vS = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), gS = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: n,
    borderRadiusLG: r,
    paddingInlineLG: o
  } = e;
  return {
    padding: `${q(t)} ${q(o)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: n,
    borderRadius: r
  };
}, gm = (e) => ({
  padding: `${q(e.paddingBlockSM)} ${q(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), pm = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${q(e.paddingBlock)} ${q(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, vS(e.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, gS(e)),
  "&-sm": Object.assign({}, gm(e)),
  // RTL
  "&-rtl": {
    direction: "rtl"
  },
  "&-textarea-rtl": {
    direction: "rtl"
  }
}), TL = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    ["&[class*='col-']"]: {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, gS(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, gm(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      ["&-addon, &-wrap"]: {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${q(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${n}-select`]: {
          margin: `${q(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${q(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${n}-select-single:not(${n}-select-customize-input):not(${n}-pagination-size-changer)`]: {
            [`${n}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${q(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${n}-select-selector`]: {
              color: e.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${n}-cascader-picker`]: {
          margin: `-9px ${q(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${n}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [`${t}`]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, Mo()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover": {
            zIndex: 1
          },
          "&:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${n}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${t}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${n}-select > ${n}-select-selector,
      & > ${n}-select-auto-complete ${t},
      & > ${n}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover": {
          zIndex: 1
        },
        "&:focus": {
          zIndex: 1
        }
      },
      [`& > ${n}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${n}-select > ${n}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${n}-select:first-child > ${n}-select-selector,
      & > ${n}-select-auto-complete:first-child ${t},
      & > ${n}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${n}-select:last-child > ${n}-select-selector,
      & > ${n}-cascader-picker:last-child ${t},
      & > ${n}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${n}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, _L = (e) => {
  const {
    componentCls: t,
    controlHeightSM: n,
    lineWidth: r,
    calc: o
  } = e, a = 16, i = o(n).sub(o(r).mul(2)).sub(a).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Gt(e)), pm(e)), uS(e)), mS(e)), dS(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: n,
          paddingTop: i,
          paddingBottom: i
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, DL = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${q(e.inputAffixPadding)}`
      }
    }
  };
}, kL = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: n,
    colorTextDescription: r,
    motionDurationSlow: o,
    colorIcon: a,
    colorIconHover: i,
    iconCls: l
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign(Object.assign(Object.assign({}, pm(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: r
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: n
        },
        "&-suffix": {
          marginInlineStart: n
        }
      }
    }), DL(e)), {
      // password
      [`${l}${t}-password-icon`]: {
        color: a,
        cursor: "pointer",
        transition: `all ${o}`,
        "&:hover": {
          color: i
        }
      }
    })
  };
}, LL = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: n,
    borderRadiusSM: r
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, Gt(e)), TL(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: n,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: r
          }
        }
      }, RL(e)), ML(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      })
    })
  };
}, FL = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-search`;
  return {
    [r]: {
      [`${t}`]: {
        "&:hover, &:focus": {
          borderColor: e.colorPrimaryHover,
          [`+ ${t}-group-addon ${r}-button:not(${n}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal({
          unit: !1
        })
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${r}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: e.borderRadius,
            borderEndEndRadius: e.borderRadius,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${r}-button:not(${n}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${n}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${r}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${r}-button`]: {
        height: e.controlHeightLG
      },
      [`&-small ${r}-button`]: {
        height: e.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover,&:focus,&:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, jL = (e) => {
  const {
    componentCls: t,
    paddingLG: n
  } = e, r = `${t}-textarea`;
  return {
    [r]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        [`${t}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      "&-allow-clear": {
        [`> ${t}`]: {
          paddingInlineEnd: n
        }
      },
      [`&-affix-wrapper${r}-has-feedback`]: {
        [`${t}`]: {
          paddingInlineEnd: n
        }
      },
      [`&-affix-wrapper${t}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${t}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${t}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${t}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingXS,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${r}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      }
    }
  };
}, zL = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, hm = Xt("Input", (e) => {
  const t = Dt(e, fm(e));
  return [
    _L(t),
    jL(t),
    kL(t),
    LL(t),
    FL(t),
    zL(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    zs(t)
  ];
}, mm), tu = (e, t) => {
  const {
    componentCls: n,
    selectHeight: r,
    fontHeight: o,
    lineWidth: a,
    calc: i
  } = e, l = t ? `${n}-${t}` : "", c = e.calc(o).add(2).equal(), u = () => i(r).sub(c).sub(i(a).mul(2)), d = e.max(u().div(2).equal(), 0), f = e.max(u().sub(d).equal(), 0);
  return [Wf(e, t), {
    [`${n}-multiple${l}`]: {
      paddingTop: d,
      paddingBottom: f,
      paddingInlineStart: d
    }
  }];
}, AL = (e) => {
  const {
    componentCls: t,
    calc: n,
    lineWidth: r
  } = e, o = Dt(e, {
    fontHeight: e.fontSize,
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.controlHeightXS,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), a = Dt(e, {
    fontHeight: n(e.multipleItemHeightLG).sub(n(r).mul(2).equal()).equal(),
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    // ======================== Size ========================
    tu(o, "small"),
    tu(e),
    tu(a, "large"),
    // ====================== Selection ======================
    Wf(e),
    {
      [`${t}${t}-multiple`]: {
        width: "100%",
        // ==================== Selector =====================
        [`${t}-selector`]: {
          flex: "auto",
          padding: 0,
          "&:after": {
            margin: 0
          }
        },
        // ==================== Selection ====================
        [`${t}-selection-item`]: {
          marginBlock: 0
        },
        // ====================== Input ======================
        // Input is `readonly`, which is used for a11y only
        [`${t}-multiple-input`]: {
          width: 0,
          height: 0,
          border: 0,
          visibility: "hidden",
          position: "absolute",
          zIndex: -1
        }
      }
    }
  ];
}, BL = AL, HL = (e) => {
  const {
    pickerCellCls: t,
    pickerCellInnerCls: n,
    cellHeight: r,
    borderRadiusSM: o,
    motionDurationMid: a,
    cellHoverBg: i,
    lineWidth: l,
    lineType: c,
    colorPrimary: u,
    cellActiveWithRangeBg: d,
    colorTextLightSolid: f,
    colorTextDisabled: m,
    cellBgDisabled: v,
    colorFillSecondary: h
  } = e;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: r,
      transform: "translateY(-50%)",
      content: '""'
    },
    // >>> Default
    [n]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: r,
      height: r,
      lineHeight: q(r),
      borderRadius: o,
      transition: `background ${a}`
    },
    // >>> Hover
    [`&:hover:not(${t}-in-view),
    &:hover:not(${t}-selected):not(${t}-range-start):not(${t}-range-end)`]: {
      [n]: {
        background: i
      }
    },
    // >>> Today
    [`&-in-view${t}-today ${n}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${q(l)} ${c} ${u}`,
        borderRadius: o,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${t}-in-range,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      position: "relative",
      [`&:not(${t}-disabled):before`]: {
        background: d
      }
    },
    // >>> Selected
    [`&-in-view${t}-selected,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      [`&:not(${t}-disabled) ${n}`]: {
        color: f,
        background: u
      },
      [`&${t}-disabled ${n}`]: {
        background: h
      }
    },
    [`&-in-view${t}-range-start:not(${t}-disabled):before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${t}-range-end:not(${t}-disabled):before`]: {
      insetInlineEnd: "50%"
    },
    // range start border-radius
    [`&-in-view${t}-range-start:not(${t}-range-end) ${n}`]: {
      borderStartStartRadius: o,
      borderEndStartRadius: o,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${t}-range-end:not(${t}-range-start) ${n}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: o,
      borderEndEndRadius: o
    },
    // >>> Disabled
    "&-disabled": {
      color: m,
      pointerEvents: "none",
      [n]: {
        background: "transparent"
      },
      "&::before": {
        background: v
      }
    },
    [`&-disabled${t}-today ${n}::before`]: {
      borderColor: m
    }
  };
}, pS = (e) => {
  const {
    componentCls: t,
    pickerCellCls: n,
    pickerCellInnerCls: r,
    pickerYearMonthCellWidth: o,
    pickerControlIconSize: a,
    cellWidth: i,
    paddingSM: l,
    paddingXS: c,
    paddingXXS: u,
    colorBgContainer: d,
    lineWidth: f,
    lineType: m,
    borderRadiusLG: v,
    colorPrimary: h,
    colorTextHeading: p,
    colorSplit: g,
    pickerControlIconBorderWidth: b,
    colorIcon: y,
    textHeight: C,
    motionDurationMid: S,
    colorIconHover: $,
    fontWeightStrong: x,
    cellHeight: w,
    pickerCellPaddingVertical: N,
    colorTextDisabled: O,
    colorText: E,
    fontSize: I,
    motionDurationSlow: k,
    withoutTimeCellHeight: M,
    pickerQuarterPanelContentHeight: P,
    borderRadiusSM: _,
    colorTextLightSolid: D,
    cellHoverBg: R,
    timeColumnHeight: T,
    timeColumnWidth: L,
    timeCellHeight: F,
    controlItemBgActive: j,
    marginXXS: A,
    pickerDatePanelPaddingHorizontal: B,
    pickerControlIconMargin: K
  } = e, Y = e.calc(i).mul(7).add(e.calc(B).mul(2)).equal();
  return {
    [t]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: d,
        borderRadius: v,
        outline: "none",
        "&-focused": {
          borderColor: h
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-prev-icon,
              ${t}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${t}-next-icon,
              ${t}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel,
        &-week-panel,
        &-date-panel,
        &-time-panel`]: {
        display: "flex",
        flexDirection: "column",
        width: Y
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${q(c)}`,
        color: p,
        borderBottom: `${q(f)} ${m} ${g}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: y,
          lineHeight: q(C),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${S}`,
          fontSize: "inherit"
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: I,
          "&:hover": {
            color: $
          },
          "&:disabled": {
            opacity: 0.25,
            pointerEvents: "none"
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: x,
          lineHeight: q(C),
          button: {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: c
            },
            "&:hover": {
              color: h
            }
          }
        }
      },
      // Arrow button
      [`&-prev-icon,
        &-next-icon,
        &-super-prev-icon,
        &-super-next-icon`]: {
        position: "relative",
        display: "inline-block",
        width: a,
        height: a,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          display: "inline-block",
          width: a,
          height: a,
          border: "0 solid currentcolor",
          borderBlockStartWidth: b,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: b,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      [`&-super-prev-icon,
        &-super-next-icon`]: {
        "&::after": {
          position: "absolute",
          top: K,
          insetInlineStart: K,
          display: "inline-block",
          width: a,
          height: a,
          border: "0 solid currentcolor",
          borderBlockStartWidth: b,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: b,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      [`&-prev-icon,
        &-super-prev-icon`]: {
        transform: "rotate(-45deg)"
      },
      [`&-next-icon,
        &-super-next-icon`]: {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: w,
          fontWeight: "normal"
        },
        th: {
          height: e.calc(w).add(e.calc(N).mul(2)).equal(),
          color: E,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${q(N)} 0`,
        color: O,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: E
        }
      }, HL(e)),
      [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
        [`${t}-content`]: {
          height: e.calc(M).mul(4).equal()
        },
        [r]: {
          padding: `0 ${q(c)}`
        }
      },
      "&-quarter-panel": {
        [`${t}-content`]: {
          height: P
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [r]: {
          padding: `0 ${q(e.calc(c).div(2).equal())}`
        },
        [`${t}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      [`&-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
        [`${t}-body`]: {
          padding: `0 ${q(c)}`
        },
        [r]: {
          width: o
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${t}-body`]: {
          padding: `${q(c)} ${q(B)}`
        },
        [`${t}-content th`]: {
          boxSizing: "border-box",
          padding: 0
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel": {
        // Clear cell style
        [`${t}-cell`]: {
          [`&:hover ${r},
            &-selected ${r},
            ${r}`]: {
            background: "transparent !important"
          }
        },
        "&-row": {
          td: {
            "&:before": {
              transition: `background ${S}`
            },
            "&:first-child:before": {
              borderStartStartRadius: _,
              borderEndStartRadius: _
            },
            "&:last-child:before": {
              borderStartEndRadius: _,
              borderEndEndRadius: _
            }
          },
          ["&:hover td"]: {
            "&:before": {
              background: R
            }
          },
          [`&-range-start td,
            &-range-end td,
            &-selected td`]: {
            // Rise priority to override hover style
            [`&${n}`]: {
              "&:before": {
                background: h
              },
              [`&${t}-cell-week`]: {
                color: new Zt(D).setAlpha(0.5).toHexString()
              },
              [r]: {
                color: D
              }
            }
          },
          ["&-range-hover td:before"]: {
            background: j
          }
        }
      },
      // >>> ShowWeek
      ["&-week-panel, &-date-panel-show-week"]: {
        [`${t}-body`]: {
          padding: `${q(c)} ${q(l)}`
        },
        [`${t}-content th`]: {
          width: "auto"
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${t}-time-panel`]: {
          borderInlineStart: `${q(f)} ${m} ${g}`
        },
        [`${t}-date-panel,
          ${t}-time-panel`]: {
          transition: `opacity ${k}`
        },
        // Keyboard
        "&-active": {
          [`${t}-date-panel,
            ${t}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        direction: "ltr",
        [`${t}-content`]: {
          display: "flex",
          flex: "auto",
          height: T
        },
        "&-column": {
          flex: "1 0 auto",
          width: L,
          margin: `${q(u)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${S}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: e.colorTextTertiary,
            borderRadius: 4
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${e.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: e.calc(T).sub(F).equal(),
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${q(f)} ${m} ${g}`
          },
          "&-active": {
            background: new Zt(j).setAlpha(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${t}-time-panel-cell`]: {
              marginInline: A,
              [`${t}-time-panel-cell-inner`]: {
                display: "block",
                width: e.calc(L).sub(e.calc(A).mul(2)).equal(),
                height: F,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: e.calc(L).sub(F).div(2).equal(),
                color: E,
                lineHeight: q(F),
                borderRadius: _,
                cursor: "pointer",
                transition: `background ${S}`,
                "&:hover": {
                  background: R
                }
              },
              "&-selected": {
                [`${t}-time-panel-cell-inner`]: {
                  background: j
                }
              },
              "&-disabled": {
                [`${t}-time-panel-cell-inner`]: {
                  color: O,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/39227
      [`&-datetime-panel ${t}-time-panel-column:after`]: {
        height: e.calc(T).sub(F).add(e.calc(u).mul(2)).equal()
      }
    }
  };
}, VL = (e) => {
  const {
    componentCls: t,
    textHeight: n,
    lineWidth: r,
    paddingSM: o,
    antCls: a,
    colorPrimary: i,
    cellActiveWithRangeBg: l,
    colorPrimaryBorder: c,
    lineType: u,
    colorSplit: d
  } = e;
  return {
    [`${t}-dropdown`]: {
      // ======================== Footer ========================
      [`${t}-footer`]: {
        borderTop: `${q(r)} ${u} ${d}`,
        "&-extra": {
          padding: `0 ${q(o)}`,
          lineHeight: q(e.calc(n).sub(e.calc(r).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${q(r)} ${u} ${d}`
          }
        }
      },
      // ==================== Footer > Ranges ===================
      [`${t}-panels + ${t}-footer ${t}-ranges`]: {
        justifyContent: "space-between"
      },
      [`${t}-ranges`]: {
        marginBlock: 0,
        paddingInline: q(o),
        overflow: "hidden",
        textAlign: "start",
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "> li": {
          lineHeight: q(e.calc(n).sub(e.calc(r).mul(2)).equal()),
          display: "inline-block"
        },
        [`${t}-now-btn-disabled`]: {
          pointerEvents: "none",
          color: e.colorTextDisabled
        },
        // https://github.com/ant-design/ant-design/issues/23687
        [`${t}-preset > ${a}-tag-blue`]: {
          color: i,
          background: l,
          borderColor: c,
          cursor: "pointer"
        },
        [`${t}-ok`]: {
          paddingBlock: e.calc(r).mul(2).equal(),
          marginInlineStart: "auto"
        }
      }
    }
  };
}, WL = VL, hS = (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    paddingXXS: r,
    padding: o
  } = e;
  return {
    pickerCellCls: `${t}-cell`,
    pickerCellInnerCls: `${t}-cell-inner`,
    pickerYearMonthCellWidth: e.calc(n).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: e.calc(n).mul(1.4).equal(),
    pickerCellPaddingVertical: e.calc(r).add(e.calc(r).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: e.calc(o).add(e.calc(r).div(2)).equal()
    // 18 in normal
  };
}, bS = (e) => {
  const {
    colorBgContainerDisabled: t,
    controlHeightSM: n,
    controlHeightLG: r
  } = e;
  return {
    cellHoverBg: e.controlItemBgHover,
    cellActiveWithRangeBg: e.controlItemBgActive,
    cellHoverWithRangeBg: new Zt(e.colorPrimary).lighten(35).toHexString(),
    cellRangeBorderColor: new Zt(e.colorPrimary).lighten(20).toHexString(),
    cellBgDisabled: t,
    timeColumnWidth: r * 1.4,
    timeColumnHeight: 28 * 8,
    timeCellHeight: 28,
    cellWidth: n * 1.5,
    cellHeight: n,
    textHeight: r,
    withoutTimeCellHeight: r * 1.65,
    multipleItemBg: e.colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: n,
    multipleItemHeightLG: e.controlHeight,
    multipleSelectorBgDisabled: t,
    multipleItemColorDisabled: e.colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent"
  };
}, KL = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, mm(e)), bS(e)), Xs(e)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: e.zIndexPopupBase + 50
}), qL = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: [
      Object.assign(Object.assign(Object.assign({}, uS(e)), mS(e)), dS(e)),
      // ========================= Multiple =========================
      {
        "&-outlined": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${q(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        },
        "&-filled": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.colorBgContainer,
            border: `${q(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
          }
        },
        "&-borderless": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${q(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        }
      }
    ]
  };
}, GL = qL, nu = (e, t, n, r) => {
  const o = e.calc(n).add(2).equal(), a = e.max(e.calc(t).sub(o).div(2).equal(), 0), i = e.max(e.calc(t).sub(o).sub(a).equal(), 0);
  return {
    padding: `${q(a)} ${q(r)} ${q(i)}`
  };
}, UL = (e) => {
  const {
    componentCls: t,
    colorError: n,
    colorWarning: r
  } = e;
  return {
    [`${t}:not(${t}-disabled):not([disabled])`]: {
      [`&${t}-status-error`]: {
        [`${t}-active-bar`]: {
          background: n
        }
      },
      [`&${t}-status-warning`]: {
        [`${t}-active-bar`]: {
          background: r
        }
      }
    }
  };
}, YL = (e) => {
  const {
    componentCls: t,
    antCls: n,
    controlHeight: r,
    paddingInline: o,
    lineWidth: a,
    lineType: i,
    colorBorder: l,
    borderRadius: c,
    motionDurationMid: u,
    colorTextDisabled: d,
    colorTextPlaceholder: f,
    controlHeightLG: m,
    fontSizeLG: v,
    controlHeightSM: h,
    paddingInlineSM: p,
    paddingXS: g,
    marginXS: b,
    colorTextDescription: y,
    lineWidthBold: C,
    colorPrimary: S,
    motionDurationSlow: $,
    zIndexPopup: x,
    paddingXXS: w,
    sizePopupArrow: N,
    colorBgElevated: O,
    borderRadiusLG: E,
    boxShadowSecondary: I,
    borderRadiusSM: k,
    colorSplit: M,
    cellHoverBg: P,
    presetsWidth: _,
    presetsMaxWidth: D,
    boxShadowPopoverArrow: R,
    fontHeight: T,
    fontHeightLG: L,
    lineHeightLG: F
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign({}, Gt(e)), nu(e, r, T, o)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        borderRadius: c,
        transition: `border ${u}, box-shadow ${u}, background ${u}`,
        // ======================== Input =========================
        [`${t}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({
            position: "relative",
            display: "inline-block",
            width: "100%",
            color: "inherit",
            fontSize: e.fontSize,
            lineHeight: e.lineHeight,
            transition: `all ${u}`
          }, vS(f)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none",
              outline: 0
            },
            "&[disabled]": {
              background: "transparent",
              color: d,
              cursor: "not-allowed"
            }
          }),
          "&-placeholder": {
            "> input": {
              color: f
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, nu(e, m, L, o)), {
          [`${t}-input > input`]: {
            fontSize: v,
            lineHeight: F
          }
        }),
        "&-small": Object.assign({}, nu(e, h, T, p)),
        [`${t}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: e.calc(g).div(2).equal(),
          color: d,
          lineHeight: 1,
          pointerEvents: "none",
          transition: `opacity ${u}, color ${u}`,
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: b
            }
          }
        },
        [`${t}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: d,
          lineHeight: 1,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${u}, color ${u}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: y
          }
        },
        "&:hover": {
          [`${t}-clear`]: {
            opacity: 1
          },
          // Should use the following selector, but since `:has` has poor compatibility,
          // we use `:not(:last-child)` instead, which may cause some problems in some cases.
          // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
          [`${t}-suffix:not(:last-child)`]: {
            opacity: 0
          }
        },
        [`${t}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: v,
          color: d,
          fontSize: v,
          verticalAlign: "top",
          cursor: "default",
          [`${t}-focused &`]: {
            color: y
          },
          [`${t}-range-separator &`]: {
            [`${t}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Active bar
          [`${t}-active-bar`]: {
            bottom: e.calc(a).mul(-1).equal(),
            height: C,
            background: S,
            opacity: 0,
            transition: `all ${$} ease-out`,
            pointerEvents: "none"
          },
          [`&${t}-focused`]: {
            [`${t}-active-bar`]: {
              opacity: 1
            }
          },
          [`${t}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${q(g)}`,
            lineHeight: 1
          }
        },
        // ======================== Clear =========================
        "&-range, &-multiple": {
          // Clear
          [`${t}-clear`]: {
            insetInlineEnd: o
          },
          [`&${t}-small`]: {
            [`${t}-clear`]: {
              insetInlineEnd: p
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, Gt(e)), pS(e)), {
          pointerEvents: "none",
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: x,
          [`&${t}-dropdown-hidden`]: {
            display: "none"
          },
          [`&${t}-dropdown-placement-bottomLeft`]: {
            [`${t}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${t}-dropdown-placement-topLeft`]: {
            [`${t}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topRight`]: {
            animationName: Ws
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomRight`]: {
            animationName: Hs
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topRight`]: {
            animationName: Ks
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomRight`]: {
            animationName: Vs
          },
          // Time picker with additional style
          [`${t}-panel > ${t}-time-panel`]: {
            paddingTop: w
          },
          // ======================== Ranges ========================
          [`${t}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${t}-range-arrow`]: Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            marginInlineStart: e.calc(o).mul(1.5).equal(),
            transition: `left ${$} ease-out`
          }, Xy(e, O, R)),
          [`${t}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: O,
            borderRadius: E,
            boxShadow: I,
            transition: `margin ${$}`,
            display: "inline-block",
            pointerEvents: "auto",
            // ======================== Layout ========================
            [`${t}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${t}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: _,
              maxWidth: D,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: g,
                borderInlineEnd: `${q(a)} ${i} ${M}`,
                li: Object.assign(Object.assign({}, Vr), {
                  borderRadius: k,
                  paddingInline: g,
                  paddingBlock: e.calc(h).sub(T).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${$}`,
                  "+ li": {
                    marginTop: b
                  },
                  "&:hover": {
                    background: P
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${t}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              direction: "ltr",
              // [`${componentCls}-panel`]: {
              //   borderWidth: `0 0 ${unit(lineWidth)}`,
              // },
              "&:last-child": {
                [`${t}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${t}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${t}-content,
            table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: l
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${q(e.calc(N).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-separator`]: {
            transform: "rotate(180deg)"
          },
          [`${t}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    Rr(e, "slide-up"),
    Rr(e, "slide-down"),
    Ca(e, "move-up"),
    Ca(e, "move-down")
  ];
}, yS = Xt("DatePicker", (e) => {
  const t = Dt(fm(e), hS(e), {
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [
    WL(t),
    YL(t),
    GL(t),
    UL(t),
    BL(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    zs(e, {
      focusElCls: `${e.componentCls}-focused`
    })
  ];
}, KL), XL = (e) => {
  const {
    calendarCls: t,
    componentCls: n,
    fullBg: r,
    fullPanelBg: o,
    itemActiveBg: a
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign({}, pS(e)), Gt(e)), {
      background: r,
      "&-rtl": {
        direction: "rtl"
      },
      [`${t}-header`]: {
        display: "flex",
        justifyContent: "flex-end",
        padding: `${q(e.paddingSM)} 0`,
        [`${t}-year-select`]: {
          minWidth: e.yearControlWidth
        },
        [`${t}-month-select`]: {
          minWidth: e.monthControlWidth,
          marginInlineStart: e.marginXS
        },
        [`${t}-mode-switch`]: {
          marginInlineStart: e.marginXS
        }
      }
    }),
    [`${t} ${n}-panel`]: {
      background: o,
      border: 0,
      borderTop: `${q(e.lineWidth)} ${e.lineType} ${e.colorSplit}`,
      borderRadius: 0,
      [`${n}-month-panel, ${n}-date-panel`]: {
        width: "auto"
      },
      [`${n}-body`]: {
        padding: `${q(e.paddingXS)} 0`
      },
      [`${n}-content`]: {
        width: "100%"
      }
    },
    [`${t}-mini`]: {
      borderRadius: e.borderRadiusLG,
      [`${t}-header`]: {
        paddingInlineEnd: e.paddingXS,
        paddingInlineStart: e.paddingXS
      },
      [`${n}-panel`]: {
        borderRadius: `0 0 ${q(e.borderRadiusLG)} ${q(e.borderRadiusLG)}`
      },
      [`${n}-content`]: {
        height: e.miniContentHeight,
        th: {
          height: "auto",
          padding: 0,
          lineHeight: `${q(e.weekHeight)}`
        }
      },
      [`${n}-cell::before`]: {
        pointerEvents: "none"
      }
    },
    [`${t}${t}-full`]: {
      [`${n}-panel`]: {
        display: "block",
        width: "100%",
        textAlign: "end",
        background: r,
        border: 0,
        [`${n}-body`]: {
          "th, td": {
            padding: 0
          },
          th: {
            height: "auto",
            paddingInlineEnd: e.paddingSM,
            paddingBottom: e.paddingXXS,
            lineHeight: `${q(e.weekHeight)}`
          }
        }
      },
      [`${n}-cell`]: {
        "&::before": {
          display: "none"
        },
        "&:hover": {
          [`${t}-date`]: {
            background: e.controlItemBgHover
          }
        },
        [`${t}-date-today::before`]: {
          display: "none"
        },
        // >>> Selected
        [`&-in-view${n}-cell-selected`]: {
          [`${t}-date, ${t}-date-today`]: {
            background: a
          }
        },
        "&-selected, &-selected:hover": {
          [`${t}-date, ${t}-date-today`]: {
            [`${t}-date-value`]: {
              color: e.colorPrimary
            }
          }
        }
      },
      [`${t}-date`]: {
        display: "block",
        width: "auto",
        height: "auto",
        margin: `0 ${q(e.calc(e.marginXS).div(2).equal())}`,
        padding: `${q(e.calc(e.paddingXS).div(2).equal())} ${q(e.paddingXS)} 0`,
        border: 0,
        borderTop: `${q(e.lineWidthBold)} ${e.lineType} ${e.colorSplit}`,
        borderRadius: 0,
        transition: `background ${e.motionDurationSlow}`,
        "&-value": {
          lineHeight: `${q(e.dateValueHeight)}`,
          transition: `color ${e.motionDurationSlow}`
        },
        "&-content": {
          position: "static",
          width: "auto",
          height: e.dateContentHeight,
          overflowY: "auto",
          color: e.colorText,
          lineHeight: e.lineHeight,
          textAlign: "start"
        },
        "&-today": {
          borderColor: e.colorPrimary,
          [`${t}-date-value`]: {
            color: e.colorText
          }
        }
      }
    },
    [`@media only screen and (max-width: ${q(e.screenXS)}) `]: {
      [`${t}`]: {
        [`${t}-header`]: {
          display: "block",
          [`${t}-year-select`]: {
            width: "50%"
          },
          [`${t}-month-select`]: {
            width: `calc(50% - ${q(e.paddingXS)})`
          },
          [`${t}-mode-switch`]: {
            width: "100%",
            marginTop: e.marginXS,
            marginInlineStart: 0,
            "> label": {
              width: "50%",
              textAlign: "center"
            }
          }
        }
      }
    }
  };
}, QL = (e) => Object.assign({
  fullBg: e.colorBgContainer,
  fullPanelBg: e.colorBgContainer,
  itemActiveBg: e.controlItemBgActive,
  yearControlWidth: 80,
  monthControlWidth: 70,
  miniContentHeight: 256
}, bS(e)), JL = Xt("Calendar", (e) => {
  const t = `${e.componentCls}-calendar`, n = Dt(e, hS(e), {
    calendarCls: t,
    pickerCellInnerCls: `${e.componentCls}-cell-inner`,
    dateValueHeight: e.controlHeightSM,
    weekHeight: e.calc(e.controlHeightSM).mul(0.75).equal(),
    dateContentHeight: e.calc(e.calc(e.fontHeightSM).add(e.marginXS)).mul(3).add(e.calc(e.lineWidth).mul(2)).equal()
  });
  return [XL(n)];
}, QL);
function CS(e) {
  function t(a, i) {
    return a && i && e.getYear(a) === e.getYear(i);
  }
  function n(a, i) {
    return t(a, i) && e.getMonth(a) === e.getMonth(i);
  }
  function r(a, i) {
    return n(a, i) && e.getDate(a) === e.getDate(i);
  }
  const o = (a) => {
    const {
      prefixCls: i,
      className: l,
      rootClassName: c,
      style: u,
      dateFullCellRender: d,
      dateCellRender: f,
      monthFullCellRender: m,
      monthCellRender: v,
      cellRender: h,
      fullCellRender: p,
      headerRender: g,
      value: b,
      defaultValue: y,
      disabledDate: C,
      mode: S,
      validRange: $,
      fullscreen: x = !0,
      onChange: w,
      onPanelChange: N,
      onSelect: O
    } = a, {
      getPrefixCls: E,
      direction: I,
      calendar: k
    } = s.useContext(lt), M = E("picker", i), P = `${M}-calendar`, [_, D, R] = JL(M, P), T = e.getNow();
    if (process.env.NODE_ENV !== "production") {
      const H = Rt("Calendar");
      H.deprecated(!d, "dateFullCellRender", "fullCellRender"), H.deprecated(!f, "dateCellRender", "cellRender"), H.deprecated(!m, "monthFullCellRender", "fullCellRender"), H.deprecated(!v, "monthCellRender", "cellRender");
    }
    const [L, F] = Vt(() => b || e.getNow(), {
      defaultValue: y,
      value: b
    }), [j, A] = Vt("month", {
      value: S
    }), B = s.useMemo(() => j === "year" ? "month" : "date", [j]), K = s.useCallback((H) => ($ ? e.isAfter($[0], H) || e.isAfter(H, $[1]) : !1) || !!(C != null && C(H)), [C, $]), Y = (H, U) => {
      N == null || N(H, U);
    }, G = (H) => {
      F(H), r(H, L) || ((B === "date" && !n(H, L) || B === "month" && !t(H, L)) && Y(H, j), w == null || w(H));
    }, te = (H) => {
      A(H), Y(L, H);
    }, ee = (H, U) => {
      G(H), O == null || O(H, {
        source: U
      });
    }, oe = () => {
      const {
        locale: H
      } = a, U = Object.assign(Object.assign({}, wi), H);
      return U.lang = Object.assign(Object.assign({}, U.lang), (H || {}).lang), U;
    }, X = s.useCallback((H, U) => p ? p(H, U) : d ? d(H) : /* @__PURE__ */ s.createElement("div", {
      className: J(`${M}-cell-inner`, `${P}-date`, {
        [`${P}-date-today`]: r(T, H)
      })
    }, /* @__PURE__ */ s.createElement("div", {
      className: `${P}-date-value`
    }, String(e.getDate(H)).padStart(2, "0")), /* @__PURE__ */ s.createElement("div", {
      className: `${P}-date-content`
    }, h ? h(H, U) : f && f(H))), [d, f, h, p]), W = s.useCallback((H, U) => {
      if (p)
        return p(H, U);
      if (m)
        return m(H);
      const ae = U.locale.shortMonths || e.locale.getShortMonths(U.locale.locale);
      return /* @__PURE__ */ s.createElement("div", {
        className: J(`${M}-cell-inner`, `${P}-date`, {
          [`${P}-date-today`]: n(T, H)
        })
      }, /* @__PURE__ */ s.createElement("div", {
        className: `${P}-date-value`
      }, ae[e.getMonth(H)]), /* @__PURE__ */ s.createElement("div", {
        className: `${P}-date-content`
      }, h ? h(H, U) : v && v(H)));
    }, [m, v, h, p]), [re] = ur("Calendar", oe), Z = (H, U) => {
      if (U.type === "date")
        return X(H, U);
      if (U.type === "month")
        return W(H, Object.assign(Object.assign({}, U), {
          locale: re == null ? void 0 : re.lang
        }));
    };
    return _(/* @__PURE__ */ s.createElement("div", {
      className: J(P, {
        [`${P}-full`]: x,
        [`${P}-mini`]: !x,
        [`${P}-rtl`]: I === "rtl"
      }, k == null ? void 0 : k.className, l, c, D, R),
      style: Object.assign(Object.assign({}, k == null ? void 0 : k.style), u)
    }, g ? g({
      value: L,
      type: j,
      onChange: (H) => {
        ee(H, "customize");
      },
      onTypeChange: te
    }) : /* @__PURE__ */ s.createElement(IL, {
      prefixCls: P,
      value: L,
      generateConfig: e,
      mode: j,
      fullscreen: x,
      locale: re == null ? void 0 : re.lang,
      validRange: $,
      onChange: ee,
      onModeChange: te
    }), /* @__PURE__ */ s.createElement(vi, {
      value: L,
      prefixCls: M,
      locale: re == null ? void 0 : re.lang,
      generateConfig: e,
      cellRender: Z,
      onSelect: (H) => {
        ee(H, B);
      },
      mode: B,
      picker: B,
      disabledDate: K,
      hideHeader: !0
    })));
  };
  return process.env.NODE_ENV !== "production" && (o.displayName = "Calendar"), o;
}
const SS = CS(OC);
SS.generateCalendar = CS;
const ZL = SS;
var eF = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
const tF = eF;
var xS = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: tF
  }));
};
process.env.NODE_ENV !== "production" && (xS.displayName = "PlusOutlined");
const nF = /* @__PURE__ */ s.forwardRef(xS), cc = /* @__PURE__ */ uo(null);
var rF = function(t) {
  var n = t.activeTabOffset, r = t.horizontal, o = t.rtl, a = t.indicator, i = a === void 0 ? {} : a, l = i.size, c = i.align, u = c === void 0 ? "center" : c, d = Ht(), f = Q(d, 2), m = f[0], v = f[1], h = Xe(), p = le.useCallback(function(b) {
    return typeof l == "function" ? l(b) : typeof l == "number" ? l : b;
  }, [l]);
  function g() {
    _t.cancel(h.current);
  }
  return Bt(function() {
    var b = {};
    if (n)
      if (r) {
        b.width = p(n.width);
        var y = o ? "right" : "left";
        u === "start" && (b[y] = n[y]), u === "center" && (b[y] = n[y] + n.width / 2, b.transform = o ? "translateX(50%)" : "translateX(-50%)"), u === "end" && (b[y] = n[y] + n.width, b.transform = "translateX(-100%)");
      } else
        b.height = p(n.height), u === "start" && (b.top = n.top), u === "center" && (b.top = n.top + n.height / 2, b.transform = "translateY(-50%)"), u === "end" && (b.top = n.top + n.height, b.transform = "translateY(-100%)");
    return g(), h.current = _t(function() {
      v(b);
    }), g;
  }, [n, r, o, u, p]), {
    style: m
  };
}, dp = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function oF(e, t, n) {
  return nn(function() {
    for (var r, o = /* @__PURE__ */ new Map(), a = t.get((r = e[0]) === null || r === void 0 ? void 0 : r.key) || dp, i = a.left + a.width, l = 0; l < e.length; l += 1) {
      var c = e[l].key, u = t.get(c);
      if (!u) {
        var d;
        u = t.get((d = e[l - 1]) === null || d === void 0 ? void 0 : d.key) || dp;
      }
      var f = o.get(c) || V({}, u);
      f.right = i - f.left - f.width, o.set(c, f);
    }
    return o;
  }, [e.map(function(r) {
    return r.key;
  }).join("_"), t, n]);
}
function fp(e, t) {
  var n = s.useRef(e), r = s.useState({}), o = Q(r, 2), a = o[1];
  function i(l) {
    var c = typeof l == "function" ? l(n.current) : l;
    c !== n.current && t(c, n.current), n.current = c, a({});
  }
  return [n.current, i];
}
var aF = 0.1, mp = 0.01, Ul = 20, vp = Math.pow(0.995, Ul);
function iF(e, t) {
  var n = Ht(), r = Q(n, 2), o = r[0], a = r[1], i = Ht(0), l = Q(i, 2), c = l[0], u = l[1], d = Ht(0), f = Q(d, 2), m = f[0], v = f[1], h = Ht(), p = Q(h, 2), g = p[0], b = p[1], y = Xe();
  function C(O) {
    var E = O.touches[0], I = E.screenX, k = E.screenY;
    a({
      x: I,
      y: k
    }), window.clearInterval(y.current);
  }
  function S(O) {
    if (o) {
      O.preventDefault();
      var E = O.touches[0], I = E.screenX, k = E.screenY;
      a({
        x: I,
        y: k
      });
      var M = I - o.x, P = k - o.y;
      t(M, P);
      var _ = Date.now();
      u(_), v(_ - c), b({
        x: M,
        y: P
      });
    }
  }
  function $() {
    if (o && (a(null), b(null), g)) {
      var O = g.x / m, E = g.y / m, I = Math.abs(O), k = Math.abs(E);
      if (Math.max(I, k) < aF)
        return;
      var M = O, P = E;
      y.current = window.setInterval(function() {
        if (Math.abs(M) < mp && Math.abs(P) < mp) {
          window.clearInterval(y.current);
          return;
        }
        M *= vp, P *= vp, t(M * Ul, P * Ul);
      }, Ul);
    }
  }
  var x = Xe();
  function w(O) {
    var E = O.deltaX, I = O.deltaY, k = 0, M = Math.abs(E), P = Math.abs(I);
    M === P ? k = x.current === "x" ? E : I : M > P ? (k = E, x.current = "x") : (k = I, x.current = "y"), t(-k, -k) && O.preventDefault();
  }
  var N = Xe(null);
  N.current = {
    onTouchStart: C,
    onTouchMove: S,
    onTouchEnd: $,
    onWheel: w
  }, s.useEffect(function() {
    function O(M) {
      N.current.onTouchStart(M);
    }
    function E(M) {
      N.current.onTouchMove(M);
    }
    function I(M) {
      N.current.onTouchEnd(M);
    }
    function k(M) {
      N.current.onWheel(M);
    }
    return document.addEventListener("touchmove", E, {
      passive: !1
    }), document.addEventListener("touchend", I, {
      passive: !1
    }), e.current.addEventListener("touchstart", O, {
      passive: !1
    }), e.current.addEventListener("wheel", k), function() {
      document.removeEventListener("touchmove", E), document.removeEventListener("touchend", I);
    };
  }, []);
}
function $S(e) {
  var t = Ht(0), n = Q(t, 2), r = n[0], o = n[1], a = Xe(0), i = Xe();
  return i.current = e, as(function() {
    var l;
    (l = i.current) === null || l === void 0 || l.call(i);
  }, [r]), function() {
    a.current === r && (a.current += 1, o(a.current));
  };
}
function lF(e) {
  var t = Xe([]), n = Ht({}), r = Q(n, 2), o = r[1], a = Xe(typeof e == "function" ? e() : e), i = $S(function() {
    var c = a.current;
    t.current.forEach(function(u) {
      c = u(c);
    }), t.current = [], a.current = c, o({});
  });
  function l(c) {
    t.current.push(c), i();
  }
  return [a.current, l];
}
var gp = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function sF(e, t, n, r, o, a, i) {
  var l = i.tabs, c = i.tabPosition, u = i.rtl, d, f, m;
  return ["top", "bottom"].includes(c) ? (d = "width", f = u ? "right" : "left", m = Math.abs(n)) : (d = "height", f = "top", m = -n), nn(function() {
    if (!l.length)
      return [0, 0];
    for (var v = l.length, h = v, p = 0; p < v; p += 1) {
      var g = e.get(l[p].key) || gp;
      if (g[f] + g[d] > m + t) {
        h = p - 1;
        break;
      }
    }
    for (var b = 0, y = v - 1; y >= 0; y -= 1) {
      var C = e.get(l[y].key) || gp;
      if (C[f] < m) {
        b = y + 1;
        break;
      }
    }
    return b >= h ? [0, 0] : [b, h];
  }, [e, t, r, o, a, m, c, l.map(function(v) {
    return v.key;
  }).join("_"), u]);
}
function pp(e) {
  var t;
  return e instanceof Map ? (t = {}, e.forEach(function(n, r) {
    t[r] = n;
  })) : t = e, JSON.stringify(t);
}
var cF = "TABS_DQ";
function wS(e) {
  return String(e).replace(/"/g, cF);
}
function ES(e, t, n, r) {
  return (
    // Only editable tabs can be removed
    !(!n || // Tabs cannot be removed when disabled
    r || // closable is false
    e === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    e === void 0 && (t === !1 || t === null))
  );
}
var OS = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.editable, o = e.locale, a = e.style;
  return !r || r.showAdd === !1 ? null : /* @__PURE__ */ s.createElement("button", {
    ref: t,
    type: "button",
    className: "".concat(n, "-nav-add"),
    style: a,
    "aria-label": (o == null ? void 0 : o.addAriaLabel) || "Add tab",
    onClick: function(l) {
      r.onEdit("add", {
        event: l
      });
    }
  }, r.addIcon || "+");
}), zd = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.position, r = e.prefixCls, o = e.extra;
  if (!o)
    return null;
  var a, i = {};
  return mt(o) === "object" && !/* @__PURE__ */ s.isValidElement(o) ? i = o : i.right = o, n === "right" && (a = i.right), n === "left" && (a = i.left), a ? /* @__PURE__ */ s.createElement("div", {
    className: "".concat(r, "-extra-content"),
    ref: t
  }, a) : null;
});
process.env.NODE_ENV !== "production" && (zd.displayName = "ExtraContent");
var uF = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.id, o = e.tabs, a = e.locale, i = e.mobile, l = e.moreIcon, c = l === void 0 ? "More" : l, u = e.moreTransitionName, d = e.style, f = e.className, m = e.editable, v = e.tabBarGutter, h = e.rtl, p = e.removeAriaLabel, g = e.onTabClick, b = e.getPopupContainer, y = e.popupClassName, C = Ht(!1), S = Q(C, 2), $ = S[0], x = S[1], w = Ht(null), N = Q(w, 2), O = N[0], E = N[1], I = "".concat(r, "-more-popup"), k = "".concat(n, "-dropdown"), M = O !== null ? "".concat(I, "-").concat(O) : null, P = a == null ? void 0 : a.dropdownAriaLabel;
  function _(A, B) {
    A.preventDefault(), A.stopPropagation(), m.onEdit("remove", {
      key: B,
      event: A
    });
  }
  var D = /* @__PURE__ */ s.createElement(Ra, {
    onClick: function(B) {
      var K = B.key, Y = B.domEvent;
      g(K, Y), x(!1);
    },
    prefixCls: "".concat(k, "-menu"),
    id: I,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": M,
    selectedKeys: [O],
    "aria-label": P !== void 0 ? P : "expanded dropdown"
  }, o.map(function(A) {
    var B = A.closable, K = A.disabled, Y = A.closeIcon, G = A.key, te = A.label, ee = ES(B, Y, m, K);
    return /* @__PURE__ */ s.createElement(Ji, {
      key: G,
      id: "".concat(I, "-").concat(G),
      role: "option",
      "aria-controls": r && "".concat(r, "-panel-").concat(G),
      disabled: K
    }, /* @__PURE__ */ s.createElement("span", null, te), ee && /* @__PURE__ */ s.createElement("button", {
      type: "button",
      "aria-label": p || "remove",
      tabIndex: 0,
      className: "".concat(k, "-menu-item-remove"),
      onClick: function(X) {
        X.stopPropagation(), _(X, G);
      }
    }, Y || m.removeIcon || "×"));
  }));
  function R(A) {
    for (var B = o.filter(function(ee) {
      return !ee.disabled;
    }), K = B.findIndex(function(ee) {
      return ee.key === O;
    }) || 0, Y = B.length, G = 0; G < Y; G += 1) {
      K = (K + A + Y) % Y;
      var te = B[K];
      if (!te.disabled) {
        E(te.key);
        return;
      }
    }
  }
  function T(A) {
    var B = A.which;
    if (!$) {
      [Oe.DOWN, Oe.SPACE, Oe.ENTER].includes(B) && (x(!0), A.preventDefault());
      return;
    }
    switch (B) {
      case Oe.UP:
        R(-1), A.preventDefault();
        break;
      case Oe.DOWN:
        R(1), A.preventDefault();
        break;
      case Oe.ESC:
        x(!1);
        break;
      case Oe.SPACE:
      case Oe.ENTER:
        O !== null && g(O, A);
        break;
    }
  }
  Bt(function() {
    var A = document.getElementById(M);
    A && A.scrollIntoView && A.scrollIntoView(!1);
  }, [O]), Bt(function() {
    $ || E(null);
  }, [$]);
  var L = z({}, h ? "marginRight" : "marginLeft", v);
  o.length || (L.visibility = "hidden", L.order = 1);
  var F = J(z({}, "".concat(k, "-rtl"), h)), j = i ? null : /* @__PURE__ */ s.createElement(iC, {
    prefixCls: k,
    overlay: D,
    trigger: ["hover"],
    visible: o.length ? $ : !1,
    transitionName: u,
    onVisibleChange: x,
    overlayClassName: J(F, y),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: b
  }, /* @__PURE__ */ s.createElement("button", {
    type: "button",
    className: "".concat(n, "-nav-more"),
    style: L,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": I,
    id: "".concat(r, "-more"),
    "aria-expanded": $,
    onKeyDown: T
  }, c));
  return /* @__PURE__ */ s.createElement("div", {
    className: J("".concat(n, "-nav-operations"), f),
    style: d,
    ref: t
  }, j, /* @__PURE__ */ s.createElement(OS, {
    prefixCls: n,
    locale: a,
    editable: m
  }));
});
const dF = /* @__PURE__ */ s.memo(uF, function(e, t) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    t.tabMoving
  );
});
var fF = function(t) {
  var n = t.prefixCls, r = t.id, o = t.active, a = t.tab, i = a.key, l = a.label, c = a.disabled, u = a.closeIcon, d = a.icon, f = t.closable, m = t.renderWrapper, v = t.removeAriaLabel, h = t.editable, p = t.onClick, g = t.onFocus, b = t.style, y = "".concat(n, "-tab"), C = ES(f, u, h, c);
  function S(N) {
    c || p(N);
  }
  function $(N) {
    N.preventDefault(), N.stopPropagation(), h.onEdit("remove", {
      key: i,
      event: N
    });
  }
  var x = s.useMemo(function() {
    return d && typeof l == "string" ? /* @__PURE__ */ s.createElement("span", null, l) : l;
  }, [l, d]), w = /* @__PURE__ */ s.createElement("div", {
    key: i,
    "data-node-key": wS(i),
    className: J(y, z(z(z({}, "".concat(y, "-with-remove"), C), "".concat(y, "-active"), o), "".concat(y, "-disabled"), c)),
    style: b,
    onClick: S
  }, /* @__PURE__ */ s.createElement("div", {
    role: "tab",
    "aria-selected": o,
    id: r && "".concat(r, "-tab-").concat(i),
    className: "".concat(y, "-btn"),
    "aria-controls": r && "".concat(r, "-panel-").concat(i),
    "aria-disabled": c,
    tabIndex: c ? null : 0,
    onClick: function(O) {
      O.stopPropagation(), S(O);
    },
    onKeyDown: function(O) {
      [Oe.SPACE, Oe.ENTER].includes(O.which) && (O.preventDefault(), S(O));
    },
    onFocus: g
  }, d && /* @__PURE__ */ s.createElement("span", {
    className: "".concat(y, "-icon")
  }, d), l && x), C && /* @__PURE__ */ s.createElement("button", {
    type: "button",
    "aria-label": v || "remove",
    tabIndex: 0,
    className: "".concat(y, "-remove"),
    onClick: function(O) {
      O.stopPropagation(), $(O);
    }
  }, u || h.removeIcon || "×"));
  return m ? m(w) : w;
}, mF = function(t, n) {
  var r = t.offsetWidth, o = t.offsetHeight, a = t.offsetTop, i = t.offsetLeft, l = t.getBoundingClientRect(), c = l.width, u = l.height, d = l.x, f = l.y;
  return Math.abs(c - r) < 1 ? [c, u, d - n.x, f - n.y] : [r, o, i, a];
}, aa = function(t) {
  var n = t.current || {}, r = n.offsetWidth, o = r === void 0 ? 0 : r, a = n.offsetHeight, i = a === void 0 ? 0 : a;
  if (t.current) {
    var l = t.current.getBoundingClientRect(), c = l.width, u = l.height;
    if (Math.abs(c - o) < 1)
      return [c, u];
  }
  return [o, i];
}, Pl = function(t, n) {
  return t[n ? 0 : 1];
}, hp = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.className, r = e.style, o = e.id, a = e.animated, i = e.activeKey, l = e.rtl, c = e.extra, u = e.editable, d = e.locale, f = e.tabPosition, m = e.tabBarGutter, v = e.children, h = e.onTabClick, p = e.onTabScroll, g = e.indicator, b = s.useContext(cc), y = b.prefixCls, C = b.tabs, S = Xe(null), $ = Xe(null), x = Xe(null), w = Xe(null), N = Xe(null), O = Xe(null), E = Xe(null), I = f === "top" || f === "bottom", k = fp(0, function(ce, Ce) {
    I && p && p({
      direction: ce > Ce ? "left" : "right"
    });
  }), M = Q(k, 2), P = M[0], _ = M[1], D = fp(0, function(ce, Ce) {
    !I && p && p({
      direction: ce > Ce ? "top" : "bottom"
    });
  }), R = Q(D, 2), T = R[0], L = R[1], F = Ht([0, 0]), j = Q(F, 2), A = j[0], B = j[1], K = Ht([0, 0]), Y = Q(K, 2), G = Y[0], te = Y[1], ee = Ht([0, 0]), oe = Q(ee, 2), X = oe[0], W = oe[1], re = Ht([0, 0]), Z = Q(re, 2), H = Z[0], U = Z[1], ae = lF(/* @__PURE__ */ new Map()), ue = Q(ae, 2), de = ue[0], se = ue[1], ie = oF(C, de, G[0]), me = Pl(A, I), Se = Pl(G, I), ve = Pl(X, I), ge = Pl(H, I), $e = me < Se + ve, we = $e ? me - ge : me - ve, _e = "".concat(y, "-nav-operations-hidden"), ze = 0, Te = 0;
  I && l ? (ze = 0, Te = Math.max(0, Se - we)) : (ze = Math.min(0, we - Se), Te = 0);
  function ke(ce) {
    return ce < ze ? ze : ce > Te ? Te : ce;
  }
  var Le = Xe(null), Ee = Ht(), xe = Q(Ee, 2), he = xe[0], pe = xe[1];
  function Pe() {
    pe(Date.now());
  }
  function Re() {
    Le.current && clearTimeout(Le.current);
  }
  iF(w, function(ce, Ce) {
    function je(Ne, De) {
      Ne(function(Fe) {
        var ot = ke(Fe + De);
        return ot;
      });
    }
    return $e ? (I ? je(_, ce) : je(L, Ce), Re(), Pe(), !0) : !1;
  }), Bt(function() {
    return Re(), he && (Le.current = setTimeout(function() {
      pe(0);
    }, 100)), Re;
  }, [he]);
  var at = sF(
    ie,
    // Container
    we,
    // Transform
    I ? P : T,
    // Tabs
    Se,
    // Add
    ve,
    // Operation
    ge,
    V(V({}, e), {}, {
      tabs: C
    })
  ), Ze = Q(at, 2), Ie = Ze[0], Be = Ze[1], bt = Lt(function() {
    var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i, Ce = ie.get(ce) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (I) {
      var je = P;
      l ? Ce.right < P ? je = Ce.right : Ce.right + Ce.width > P + we && (je = Ce.right + Ce.width - we) : Ce.left < -P ? je = -Ce.left : Ce.left + Ce.width > -P + we && (je = -(Ce.left + Ce.width - we)), L(0), _(ke(je));
    } else {
      var Ne = T;
      Ce.top < -T ? Ne = -Ce.top : Ce.top + Ce.height > -T + we && (Ne = -(Ce.top + Ce.height - we)), _(0), L(ke(Ne));
    }
  }), He = {};
  f === "top" || f === "bottom" ? He[l ? "marginRight" : "marginLeft"] = m : He.marginTop = m;
  var nt = C.map(function(ce, Ce) {
    var je = ce.key;
    return /* @__PURE__ */ s.createElement(fF, {
      id: o,
      prefixCls: y,
      key: je,
      tab: ce,
      style: Ce === 0 ? void 0 : He,
      closable: ce.closable,
      editable: u,
      active: je === i,
      renderWrapper: v,
      removeAriaLabel: d == null ? void 0 : d.removeAriaLabel,
      onClick: function(De) {
        h(je, De);
      },
      onFocus: function() {
        bt(je), Pe(), w.current && (l || (w.current.scrollLeft = 0), w.current.scrollTop = 0);
      }
    });
  }), et = function() {
    return se(function() {
      var Ce, je = /* @__PURE__ */ new Map(), Ne = (Ce = N.current) === null || Ce === void 0 ? void 0 : Ce.getBoundingClientRect();
      return C.forEach(function(De) {
        var Fe, ot = De.key, pt = (Fe = N.current) === null || Fe === void 0 ? void 0 : Fe.querySelector('[data-node-key="'.concat(wS(ot), '"]'));
        if (pt) {
          var St = mF(pt, Ne), Ot = Q(St, 4), Wt = Ot[0], rn = Ot[1], Nt = Ot[2], Ut = Ot[3];
          je.set(ot, {
            width: Wt,
            height: rn,
            left: Nt,
            top: Ut
          });
        }
      }), je;
    });
  };
  Bt(function() {
    et();
  }, [C.map(function(ce) {
    return ce.key;
  }).join("_")]);
  var Ge = $S(function() {
    var ce = aa(S), Ce = aa($), je = aa(x);
    B([ce[0] - Ce[0] - je[0], ce[1] - Ce[1] - je[1]]);
    var Ne = aa(E);
    W(Ne);
    var De = aa(O);
    U(De);
    var Fe = aa(N);
    te([Fe[0] - Ne[0], Fe[1] - Ne[1]]), et();
  }), Ae = C.slice(0, Ie), qe = C.slice(Be + 1), Je = [].concat(be(Ae), be(qe)), Ke = ie.get(i), Ye = rF({
    activeTabOffset: Ke,
    horizontal: I,
    indicator: g,
    rtl: l
  }), Ve = Ye.style;
  Bt(function() {
    bt();
  }, [i, ze, Te, pp(Ke), pp(ie), I]), Bt(function() {
    Ge();
  }, [l]);
  var Qe = !!Je.length, it = "".concat(y, "-nav-wrap"), yt, Tt, ne, ye;
  return I ? l ? (Tt = P > 0, yt = P !== Te) : (yt = P < 0, Tt = P !== ze) : (ne = T < 0, ye = T !== ze), /* @__PURE__ */ s.createElement(Mn, {
    onResize: Ge
  }, /* @__PURE__ */ s.createElement("div", {
    ref: Gr(t, S),
    role: "tablist",
    className: J("".concat(y, "-nav"), n),
    style: r,
    onKeyDown: function() {
      Pe();
    }
  }, /* @__PURE__ */ s.createElement(zd, {
    ref: $,
    position: "left",
    extra: c,
    prefixCls: y
  }), /* @__PURE__ */ s.createElement(Mn, {
    onResize: Ge
  }, /* @__PURE__ */ s.createElement("div", {
    className: J(it, z(z(z(z({}, "".concat(it, "-ping-left"), yt), "".concat(it, "-ping-right"), Tt), "".concat(it, "-ping-top"), ne), "".concat(it, "-ping-bottom"), ye)),
    ref: w
  }, /* @__PURE__ */ s.createElement(Mn, {
    onResize: Ge
  }, /* @__PURE__ */ s.createElement("div", {
    ref: N,
    className: "".concat(y, "-nav-list"),
    style: {
      transform: "translate(".concat(P, "px, ").concat(T, "px)"),
      transition: he ? "none" : void 0
    }
  }, nt, /* @__PURE__ */ s.createElement(OS, {
    ref: E,
    prefixCls: y,
    locale: d,
    editable: u,
    style: V(V({}, nt.length === 0 ? void 0 : He), {}, {
      visibility: Qe ? "hidden" : null
    })
  }), /* @__PURE__ */ s.createElement("div", {
    className: J("".concat(y, "-ink-bar"), z({}, "".concat(y, "-ink-bar-animated"), a.inkBar)),
    style: Ve
  }))))), /* @__PURE__ */ s.createElement(dF, fe({}, e, {
    removeAriaLabel: d == null ? void 0 : d.removeAriaLabel,
    ref: O,
    prefixCls: y,
    tabs: Je,
    className: !Qe && _e,
    tabMoving: !!he
  })), /* @__PURE__ */ s.createElement(zd, {
    ref: x,
    position: "right",
    extra: c,
    prefixCls: y
  })));
}), bm = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.className, o = e.style, a = e.id, i = e.active, l = e.tabKey, c = e.children;
  return /* @__PURE__ */ s.createElement("div", {
    id: a && "".concat(a, "-panel-").concat(l),
    role: "tabpanel",
    tabIndex: i ? 0 : -1,
    "aria-labelledby": a && "".concat(a, "-tab-").concat(l),
    "aria-hidden": !i,
    style: o,
    className: J(n, i && "".concat(n, "-active"), r),
    ref: t
  }, c);
});
process.env.NODE_ENV !== "production" && (bm.displayName = "TabPane");
var vF = ["renderTabBar"], gF = ["label", "key"], NS = function(t) {
  var n = t.renderTabBar, r = vt(t, vF), o = s.useContext(cc), a = o.tabs;
  if (n) {
    var i = V(V({}, r), {}, {
      // Legacy support. We do not use this actually
      panes: a.map(function(l) {
        var c = l.label, u = l.key, d = vt(l, gF);
        return /* @__PURE__ */ s.createElement(bm, fe({
          tab: c,
          key: u,
          tabKey: u
        }, d));
      })
    });
    return n(i, hp);
  }
  return /* @__PURE__ */ s.createElement(hp, r);
};
process.env.NODE_ENV !== "production" && (NS.displayName = "TabNavListWrapper");
var pF = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], hF = function(t) {
  var n = t.id, r = t.activeKey, o = t.animated, a = t.tabPosition, i = t.destroyInactiveTabPane, l = s.useContext(cc), c = l.prefixCls, u = l.tabs, d = o.tabPane, f = "".concat(c, "-tabpane");
  return /* @__PURE__ */ s.createElement("div", {
    className: J("".concat(c, "-content-holder"))
  }, /* @__PURE__ */ s.createElement("div", {
    className: J("".concat(c, "-content"), "".concat(c, "-content-").concat(a), z({}, "".concat(c, "-content-animated"), d))
  }, u.map(function(m) {
    var v = m.key, h = m.forceRender, p = m.style, g = m.className, b = m.destroyInactiveTabPane, y = vt(m, pF), C = v === r;
    return /* @__PURE__ */ s.createElement(An, fe({
      key: v,
      visible: C,
      forceRender: h,
      removeOnLeave: !!(i || b),
      leavedClassName: "".concat(f, "-hidden")
    }, o.tabPaneMotion), function(S, $) {
      var x = S.style, w = S.className;
      return /* @__PURE__ */ s.createElement(bm, fe({}, y, {
        prefixCls: f,
        id: n,
        tabKey: v,
        animated: d,
        active: C,
        style: V(V({}, p), x),
        className: J(g, w),
        ref: $
      }));
    });
  })));
};
function bF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, t;
  return e === !1 ? t = {
    inkBar: !1,
    tabPane: !1
  } : e === !0 ? t = {
    inkBar: !0,
    tabPane: !1
  } : t = V({
    inkBar: !0
  }, mt(e) === "object" ? e : {}), t.tabPaneMotion && t.tabPane === void 0 && (t.tabPane = !0), !t.tabPaneMotion && t.tabPane && (process.env.NODE_ENV !== "production" && tt(!1, "`animated.tabPane` is true but `animated.tabPaneMotion` is not provided. Motion will not work."), t.tabPane = !1), t;
}
var yF = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "moreIcon", "moreTransitionName", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"], bp = 0, IS = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.id, r = e.prefixCls, o = r === void 0 ? "rc-tabs" : r, a = e.className, i = e.items, l = e.direction, c = e.activeKey, u = e.defaultActiveKey, d = e.editable, f = e.animated, m = e.tabPosition, v = m === void 0 ? "top" : m, h = e.tabBarGutter, p = e.tabBarStyle, g = e.tabBarExtraContent, b = e.locale, y = e.moreIcon, C = e.moreTransitionName, S = e.destroyInactiveTabPane, $ = e.renderTabBar, x = e.onChange, w = e.onTabClick, N = e.onTabScroll, O = e.getPopupContainer, E = e.popupClassName, I = e.indicator, k = vt(e, yF), M = s.useMemo(function() {
    return (i || []).filter(function(U) {
      return U && mt(U) === "object" && "key" in U;
    });
  }, [i]), P = l === "rtl", _ = bF(f), D = Ht(!1), R = Q(D, 2), T = R[0], L = R[1];
  Bt(function() {
    L(Lf());
  }, []);
  var F = Vt(function() {
    var U;
    return (U = M[0]) === null || U === void 0 ? void 0 : U.key;
  }, {
    value: c,
    defaultValue: u
  }), j = Q(F, 2), A = j[0], B = j[1], K = Ht(function() {
    return M.findIndex(function(U) {
      return U.key === A;
    });
  }), Y = Q(K, 2), G = Y[0], te = Y[1];
  Bt(function() {
    var U = M.findIndex(function(ue) {
      return ue.key === A;
    });
    if (U === -1) {
      var ae;
      U = Math.max(0, Math.min(G, M.length - 1)), B((ae = M[U]) === null || ae === void 0 ? void 0 : ae.key);
    }
    te(U);
  }, [M.map(function(U) {
    return U.key;
  }).join("_"), A, G]);
  var ee = Vt(null, {
    value: n
  }), oe = Q(ee, 2), X = oe[0], W = oe[1];
  Bt(function() {
    n || (W("rc-tabs-".concat(process.env.NODE_ENV === "test" ? "test" : bp)), bp += 1);
  }, []);
  function re(U, ae) {
    w == null || w(U, ae);
    var ue = U !== A;
    B(U), ue && (x == null || x(U));
  }
  var Z = {
    id: X,
    activeKey: A,
    animated: _,
    tabPosition: v,
    rtl: P,
    mobile: T
  }, H = V(V({}, Z), {}, {
    editable: d,
    locale: b,
    moreIcon: y,
    moreTransitionName: C,
    tabBarGutter: h,
    onTabClick: re,
    onTabScroll: N,
    extra: g,
    style: p,
    panes: null,
    getPopupContainer: O,
    popupClassName: E,
    indicator: I
  });
  return /* @__PURE__ */ s.createElement(cc.Provider, {
    value: {
      tabs: M,
      prefixCls: o
    }
  }, /* @__PURE__ */ s.createElement("div", fe({
    ref: t,
    id: n,
    className: J(o, "".concat(o, "-").concat(v), z(z(z({}, "".concat(o, "-mobile"), T), "".concat(o, "-editable"), d), "".concat(o, "-rtl"), P), a)
  }, k), /* @__PURE__ */ s.createElement(NS, fe({}, H, {
    renderTabBar: $
  })), /* @__PURE__ */ s.createElement(hF, fe({
    destroyInactiveTabPane: S
  }, Z, {
    animated: _
  }))));
});
process.env.NODE_ENV !== "production" && (IS.displayName = "Tabs");
const CF = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function SF(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inkBar: !0,
    tabPane: !1
  }, n;
  return t === !1 ? n = {
    inkBar: !1,
    tabPane: !1
  } : t === !0 ? n = {
    inkBar: !0,
    tabPane: !0
  } : n = Object.assign({
    inkBar: !0
  }, typeof t == "object" ? t : {}), n.tabPane && (n.tabPaneMotion = Object.assign(Object.assign({}, CF), {
    motionName: Pr(e, "switch")
  })), n;
}
var xF = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function $F(e) {
  return e.filter((t) => t);
}
function wF(e, t) {
  if (process.env.NODE_ENV !== "production" && Rt("Tabs").deprecated(!t, "Tabs.TabPane", "items"), e)
    return e;
  const n = Pn(t).map((r) => {
    if (/* @__PURE__ */ s.isValidElement(r)) {
      const {
        key: o,
        props: a
      } = r, i = a || {}, {
        tab: l
      } = i, c = xF(i, ["tab"]);
      return Object.assign(Object.assign({
        key: String(o)
      }, c), {
        label: l
      });
    }
    return null;
  });
  return $F(n);
}
const EF = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return [
    {
      [t]: {
        [`${t}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${n}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${n}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [Rr(e, "slide-up"), Rr(e, "slide-down")]
  ];
}, OF = EF, NF = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: n,
    cardBg: r,
    cardGutter: o,
    colorBorderSecondary: a,
    itemSelectedColor: i
  } = e;
  return {
    [`${t}-card`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-tab`]: {
          margin: 0,
          padding: n,
          background: r,
          border: `${q(e.lineWidth)} ${e.lineType} ${a}`,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`
        },
        [`${t}-tab-active`]: {
          color: i,
          background: e.colorBgContainer
        },
        [`${t}-ink-bar`]: {
          visibility: "hidden"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${t}-top, &${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: q(o)
            }
          }
        }
      },
      [`&${t}-top`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `${q(e.borderRadiusLG)} ${q(e.borderRadiusLG)} 0 0`
          },
          [`${t}-tab-active`]: {
            borderBottomColor: e.colorBgContainer
          }
        }
      },
      [`&${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `0 0 ${q(e.borderRadiusLG)} ${q(e.borderRadiusLG)}`
          },
          [`${t}-tab-active`]: {
            borderTopColor: e.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${t}-left, &${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginTop: q(o)
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${q(e.borderRadiusLG)} 0 0 ${q(e.borderRadiusLG)}`
            }
          },
          [`${t}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${q(e.borderRadiusLG)} ${q(e.borderRadiusLG)} 0`
            }
          },
          [`${t}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      }
    }
  };
}, IF = (e) => {
  const {
    componentCls: t,
    itemHoverColor: n,
    dropdownEdgeChildVerticalPadding: r
  } = e;
  return {
    [`${t}-dropdown`]: Object.assign(Object.assign({}, Gt(e)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: e.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${t}-dropdown-menu`]: {
        maxHeight: e.tabsDropdownHeight,
        margin: 0,
        padding: `${q(r)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: e.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, Vr), {
          display: "flex",
          alignItems: "center",
          minWidth: e.tabsDropdownWidth,
          margin: 0,
          padding: `${q(e.paddingXXS)} ${q(e.paddingSM)}`,
          color: e.colorText,
          fontWeight: "normal",
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          cursor: "pointer",
          transition: `all ${e.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: e.marginSM
            },
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: n
            }
          },
          "&:hover": {
            background: e.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: e.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, PF = (e) => {
  const {
    componentCls: t,
    margin: n,
    colorBorderSecondary: r,
    horizontalMargin: o,
    verticalItemPadding: a,
    verticalItemMargin: i,
    calc: l
  } = e;
  return {
    // ========================== Top & Bottom ==========================
    [`${t}-top, ${t}-bottom`]: {
      flexDirection: "column",
      [`> ${t}-nav, > div > ${t}-nav`]: {
        margin: o,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${q(e.lineWidth)} ${e.lineType} ${r}`,
          content: "''"
        },
        [`${t}-ink-bar`]: {
          height: e.lineWidthBold,
          "&-animated": {
            transition: `width ${e.motionDurationSlow}, left ${e.motionDurationSlow},
            right ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: e.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowRight
          },
          [`&${t}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${t}-top`]: {
      [`> ${t}-nav,
        > div > ${t}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${t}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${t}-bottom`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        marginTop: n,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${t}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${t}-left, ${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        flexDirection: "column",
        minWidth: l(e.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${t}-tab`]: {
          padding: a,
          textAlign: "center"
        },
        [`${t}-tab + ${t}-tab`]: {
          margin: i
        },
        // >>>>>>>>>>> Nav
        [`${t}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: e.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: e.boxShadowTabsOverflowBottom
          },
          [`&${t}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${t}-ink-bar`]: {
          width: e.lineWidthBold,
          "&-animated": {
            transition: `height ${e.motionDurationSlow}, top ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-list, ${t}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${t}-left`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: q(l(e.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    },
    [`${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        [`${t}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: l(e.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    }
  };
}, RF = (e) => {
  const {
    componentCls: t,
    cardPaddingSM: n,
    cardPaddingLG: r,
    horizontalItemPaddingSM: o,
    horizontalItemPaddingLG: a
  } = e;
  return {
    [t]: {
      "&-small": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: o,
            fontSize: e.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: a,
            fontSize: e.titleFontSizeLG
          }
        }
      }
    },
    [`${t}-card`]: {
      [`&${t}-small`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: n
          }
        },
        [`&${t}-bottom`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `0 0 ${q(e.borderRadius)} ${q(e.borderRadius)}`
          }
        },
        [`&${t}-top`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `${q(e.borderRadius)} ${q(e.borderRadius)} 0 0`
          }
        },
        [`&${t}-right`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${q(e.borderRadius)} ${q(e.borderRadius)} 0`
            }
          }
        },
        [`&${t}-left`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${q(e.borderRadius)} 0 0 ${q(e.borderRadius)}`
            }
          }
        }
      },
      [`&${t}-large`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: r
          }
        }
      }
    }
  };
}, MF = (e) => {
  const {
    componentCls: t,
    itemActiveColor: n,
    itemHoverColor: r,
    iconCls: o,
    tabsHorizontalItemMargin: a,
    horizontalItemPadding: i,
    itemSelectedColor: l,
    itemColor: c
  } = e, u = `${t}-tab`;
  return {
    [u]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: i,
      fontSize: e.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: c,
      "&-btn, &-remove": Object.assign({
        "&:focus:not(:focus-visible), &:active": {
          color: n
        }
      }, lo(e)),
      "&-btn": {
        outline: "none",
        transition: "all 0.3s",
        [`${u}-icon:not(:last-child)`]: {
          marginInlineEnd: e.marginSM
        }
      },
      "&-remove": {
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: e.calc(e.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: e.marginXS
        },
        color: e.colorTextDescription,
        fontSize: e.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      "&:hover": {
        color: r
      },
      [`&${u}-active ${u}-btn`]: {
        color: l,
        textShadow: e.tabsActiveTextShadow
      },
      [`&${u}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${u}-disabled ${u}-btn, &${u}-disabled ${t}-remove`]: {
        "&:focus, &:active": {
          color: e.colorTextDisabled
        }
      },
      [`& ${u}-remove ${o}`]: {
        margin: 0
      },
      [`${o}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: e.marginSM
        }
      }
    },
    [`${u} + ${u}`]: {
      margin: {
        _skip_check_: !0,
        value: a
      }
    }
  };
}, TF = (e) => {
  const {
    componentCls: t,
    tabsHorizontalItemMarginRTL: n,
    iconCls: r,
    cardGutter: o,
    calc: a
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl",
      [`${t}-nav`]: {
        [`${t}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: n
          },
          [`${t}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [r]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: q(e.marginSM)
            }
          },
          [`${t}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: q(e.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: q(a(e.marginXXS).mul(-1).equal())
            },
            [r]: {
              margin: 0
            }
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav`]: {
          order: 1
        },
        [`> ${t}-content-holder`]: {
          order: 0
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav`]: {
          order: 0
        },
        [`> ${t}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${t}-card${t}-top, &${t}-card${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: o
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${t}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${t}-menu-item`]: {
      [`${t}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, _F = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: n,
    cardHeight: r,
    cardGutter: o,
    itemHoverColor: a,
    itemActiveColor: i,
    colorBorderSecondary: l
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Gt(e)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${t}-nav, > div > ${t}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${t}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${e.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${t}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${e.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${t}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${t}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${t}-nav-more`]: {
          position: "relative",
          padding: n,
          background: "transparent",
          border: 0,
          color: e.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.calc(e.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${t}-nav-add`]: Object.assign({
          minWidth: r,
          minHeight: r,
          marginLeft: {
            _skip_check_: !0,
            value: o
          },
          padding: `0 ${q(e.paddingXS)}`,
          background: "transparent",
          border: `${q(e.lineWidth)} ${e.lineType} ${l}`,
          borderRadius: `${q(e.borderRadiusLG)} ${q(e.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: e.colorText,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`,
          "&:hover": {
            color: a
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: i
          }
        }, lo(e))
      },
      [`${t}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${t}-ink-bar`]: {
        position: "absolute",
        background: e.inkBarColor,
        pointerEvents: "none"
      }
    }), MF(e)), {
      // =========================== TabPanes ===========================
      [`${t}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${t}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${t}-tabpane`]: {
        outline: "none",
        "&-hidden": {
          display: "none"
        }
      }
    }),
    [`${t}-centered`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-nav-wrap`]: {
          [`&:not([class*='${t}-nav-wrap-ping'])`]: {
            justifyContent: "center"
          }
        }
      }
    }
  };
}, DF = (e) => {
  const t = e.controlHeightLG;
  return {
    zIndexPopup: e.zIndexPopupBase + 50,
    cardBg: e.colorFillAlter,
    cardHeight: t,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(t - Math.round(e.fontSize * e.lineHeight)) / 2 - e.lineWidth}px ${e.padding}px`,
    cardPaddingSM: `${e.paddingXXS * 1.5}px ${e.padding}px`,
    cardPaddingLG: `${e.paddingXS}px ${e.padding}px ${e.paddingXXS * 1.5}px`,
    titleFontSize: e.fontSize,
    titleFontSizeLG: e.fontSizeLG,
    titleFontSizeSM: e.fontSize,
    inkBarColor: e.colorPrimary,
    horizontalMargin: `0 0 ${e.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${e.paddingSM}px 0`,
    horizontalItemPaddingSM: `${e.paddingXS}px 0`,
    horizontalItemPaddingLG: `${e.padding}px 0`,
    verticalItemPadding: `${e.paddingXS}px ${e.paddingLG}px`,
    verticalItemMargin: `${e.margin}px 0 0 0`,
    itemColor: e.colorText,
    itemSelectedColor: e.colorPrimary,
    itemHoverColor: e.colorPrimaryHover,
    itemActiveColor: e.colorPrimaryActive,
    cardGutter: e.marginXXS / 2
  };
}, kF = Xt("Tabs", (e) => {
  const t = Dt(e, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: e.cardPadding,
    dropdownEdgeChildVerticalPadding: e.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${q(e.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${q(e.horizontalItemGutter)}`
  });
  return [RF(t), TF(t), PF(t), IF(t), NF(t), _F(t), OF(t)];
}, DF), PS = () => null;
process.env.NODE_ENV !== "production" && (PS.displayName = "DeprecatedTabPane");
const LF = PS;
var FF = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const ym = (e) => {
  var t, n, r, o, a, i, l;
  const {
    type: c,
    className: u,
    rootClassName: d,
    size: f,
    onEdit: m,
    hideAdd: v,
    centered: h,
    addIcon: p,
    moreIcon: g,
    popupClassName: b,
    children: y,
    items: C,
    animated: S,
    style: $,
    indicatorSize: x,
    indicator: w
  } = e, N = FF(e, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "moreIcon", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator"]), {
    prefixCls: O
  } = N, {
    direction: E,
    tabs: I,
    getPrefixCls: k,
    getPopupContainer: M
  } = s.useContext(lt), P = k("tabs", O), _ = En(P), [D, R, T] = kF(P, _);
  let L;
  c === "editable-card" && (L = {
    onEdit: (G, te) => {
      let {
        key: ee,
        event: oe
      } = te;
      m == null || m(G === "add" ? oe : ee, G);
    },
    removeIcon: /* @__PURE__ */ s.createElement(mo, null),
    addIcon: (p ?? (I == null ? void 0 : I.addIcon)) || /* @__PURE__ */ s.createElement(nF, null),
    showAdd: v !== !0
  });
  const F = k();
  if (process.env.NODE_ENV !== "production") {
    const G = Rt("Tabs");
    process.env.NODE_ENV !== "production" && G(!("onPrevClick" in e) && !("onNextClick" in e), "breaking", "`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead."), process.env.NODE_ENV !== "production" && G(!(x || I != null && I.indicatorSize), "deprecated", "`indicatorSize` has been deprecated. Please use `indicator={{ size: ... }}` instead.");
  }
  const j = qn(f), A = wF(C, y), B = SF(P, S), K = Object.assign(Object.assign({}, I == null ? void 0 : I.style), $), Y = {
    align: (t = w == null ? void 0 : w.align) !== null && t !== void 0 ? t : (n = I == null ? void 0 : I.indicator) === null || n === void 0 ? void 0 : n.align,
    size: (i = (o = (r = w == null ? void 0 : w.size) !== null && r !== void 0 ? r : x) !== null && o !== void 0 ? o : (a = I == null ? void 0 : I.indicator) === null || a === void 0 ? void 0 : a.size) !== null && i !== void 0 ? i : I == null ? void 0 : I.indicatorSize
  };
  return D(/* @__PURE__ */ s.createElement(IS, Object.assign({
    direction: E,
    getPopupContainer: M,
    moreTransitionName: `${F}-slide-up`
  }, N, {
    items: A,
    className: J({
      [`${P}-${j}`]: j,
      [`${P}-card`]: ["card", "editable-card"].includes(c),
      [`${P}-editable-card`]: c === "editable-card",
      [`${P}-centered`]: h
    }, I == null ? void 0 : I.className, u, d, R, T, _),
    popupClassName: J(b, R, T, _),
    style: K,
    editable: L,
    moreIcon: (l = g ?? (I == null ? void 0 : I.moreIcon)) !== null && l !== void 0 ? l : /* @__PURE__ */ s.createElement(am, null),
    prefixCls: P,
    animated: B,
    indicator: Y
  })));
};
ym.TabPane = LF;
process.env.NODE_ENV !== "production" && (ym.displayName = "Tabs");
const jF = ym;
function zF(e, t, n) {
  var r = n || {}, o = r.noTrailing, a = o === void 0 ? !1 : o, i = r.noLeading, l = i === void 0 ? !1 : i, c = r.debounceMode, u = c === void 0 ? void 0 : c, d, f = !1, m = 0;
  function v() {
    d && clearTimeout(d);
  }
  function h(g) {
    var b = g || {}, y = b.upcomingOnly, C = y === void 0 ? !1 : y;
    v(), f = !C;
  }
  function p() {
    for (var g = arguments.length, b = new Array(g), y = 0; y < g; y++)
      b[y] = arguments[y];
    var C = this, S = Date.now() - m;
    if (f)
      return;
    function $() {
      m = Date.now(), t.apply(C, b);
    }
    function x() {
      d = void 0;
    }
    !l && u && !d && $(), v(), u === void 0 && S > e ? l ? (m = Date.now(), a || (d = setTimeout(u ? x : $, e))) : $() : a !== !0 && (d = setTimeout(u ? x : $, u === void 0 ? e - S : e));
  }
  return p.cancel = h, p;
}
function AF(e, t, n) {
  var r = n || {}, o = r.atBegin, a = o === void 0 ? !1 : o;
  return zF(e, t, {
    debounceMode: a !== !1
  });
}
function tr(e, t) {
  return e[t];
}
var BF = ["children"];
function RS(e, t) {
  return "".concat(e, "-").concat(t);
}
function HF(e) {
  return e && e.type && e.type.isTreeNode;
}
function nl(e, t) {
  return e ?? t;
}
function wa(e) {
  var t = e || {}, n = t.title, r = t._title, o = t.key, a = t.children, i = n || "title";
  return {
    title: i,
    _title: r || [i],
    key: o || "key",
    children: a || "children"
  };
}
function VF(e, t) {
  var n = /* @__PURE__ */ new Map();
  function r(o) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (o || []).forEach(function(i) {
      var l = i[t.key], c = i[t.children];
      tt(l != null, "Tree node must have a certain key: [".concat(a).concat(l, "]"));
      var u = String(l);
      tt(!n.has(u) || l === null || l === void 0, "Same 'key' exist in the Tree: ".concat(u)), n.set(u, !0), r(c, "".concat(a).concat(u, " > "));
    });
  }
  r(e);
}
function MS(e) {
  function t(n) {
    var r = Pn(n);
    return r.map(function(o) {
      if (!HF(o))
        return tt(!o, "Tree/TreeNode can only accept TreeNode as children."), null;
      var a = o.key, i = o.props, l = i.children, c = vt(i, BF), u = V({
        key: a
      }, c), d = t(l);
      return d.length && (u.children = d), u;
    }).filter(function(o) {
      return o;
    });
  }
  return t(e);
}
function ru(e, t, n) {
  var r = wa(n), o = r._title, a = r.key, i = r.children, l = new Set(t === !0 ? [] : t), c = [];
  function u(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return d.map(function(m, v) {
      for (var h = RS(f ? f.pos : "0", v), p = nl(m[a], h), g, b = 0; b < o.length; b += 1) {
        var y = o[b];
        if (m[y] !== void 0) {
          g = m[y];
          break;
        }
      }
      var C = V(V({}, an(m, [].concat(be(o), [a, i]))), {}, {
        title: g,
        key: p,
        parent: f,
        pos: h,
        children: null,
        data: m,
        isStart: [].concat(be(f ? f.isStart : []), [v === 0]),
        isEnd: [].concat(be(f ? f.isEnd : []), [v === d.length - 1])
      });
      return c.push(C), t === !0 || l.has(p) ? C.children = u(m[i] || [], C) : C.children = [], C;
    });
  }
  return u(e), c;
}
function WF(e, t, n) {
  var r = {};
  mt(n) === "object" ? r = n : r = {
    externalGetKey: n
  }, r = r || {};
  var o = r, a = o.childrenPropName, i = o.externalGetKey, l = o.fieldNames, c = wa(l), u = c.key, d = c.children, f = a || d, m;
  i ? typeof i == "string" ? m = function(p) {
    return p[i];
  } : typeof i == "function" && (m = function(p) {
    return i(p);
  }) : m = function(p, g) {
    return nl(p[u], g);
  };
  function v(h, p, g, b) {
    var y = h ? h[f] : e, C = h ? RS(g.pos, p) : "0", S = h ? [].concat(be(b), [h]) : [];
    if (h) {
      var $ = m(h, C), x = {
        node: h,
        index: p,
        pos: C,
        key: $,
        parentPos: g.node ? g.pos : null,
        level: g.level + 1,
        nodes: S
      };
      t(x);
    }
    y && y.forEach(function(w, N) {
      v(w, N, {
        node: h,
        pos: C,
        level: g ? g.level + 1 : -1
      }, S);
    });
  }
  v(null);
}
function Cm(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.initWrapper, r = t.processEntity, o = t.onProcessFinished, a = t.externalGetKey, i = t.childrenPropName, l = t.fieldNames, c = arguments.length > 2 ? arguments[2] : void 0, u = a || c, d = {}, f = {}, m = {
    posEntities: d,
    keyEntities: f
  };
  return n && (m = n(m) || m), WF(e, function(v) {
    var h = v.node, p = v.index, g = v.pos, b = v.key, y = v.parentPos, C = v.level, S = v.nodes, $ = {
      node: h,
      nodes: S,
      index: p,
      key: b,
      pos: g,
      level: C
    }, x = nl(b, g);
    d[g] = $, f[x] = $, $.parent = d[y], $.parent && ($.parent.children = $.parent.children || [], $.parent.children.push($)), r && r($, m);
  }, {
    externalGetKey: u,
    childrenPropName: i,
    fieldNames: l
  }), o && o(m), m;
}
function gi(e, t) {
  var n = t.expandedKeys, r = t.selectedKeys, o = t.loadedKeys, a = t.loadingKeys, i = t.checkedKeys, l = t.halfCheckedKeys, c = t.dragOverNodeKey, u = t.dropPosition, d = t.keyEntities, f = tr(d, e), m = {
    eventKey: e,
    expanded: n.indexOf(e) !== -1,
    selected: r.indexOf(e) !== -1,
    loaded: o.indexOf(e) !== -1,
    loading: a.indexOf(e) !== -1,
    checked: i.indexOf(e) !== -1,
    halfChecked: l.indexOf(e) !== -1,
    pos: String(f ? f.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: c === e && u === 0,
    dragOverGapTop: c === e && u === -1,
    dragOverGapBottom: c === e && u === 1
  };
  return m;
}
function yn(e) {
  var t = e.data, n = e.expanded, r = e.selected, o = e.checked, a = e.loaded, i = e.loading, l = e.halfChecked, c = e.dragOver, u = e.dragOverGapTop, d = e.dragOverGapBottom, f = e.pos, m = e.active, v = e.eventKey, h = V(V({}, t), {}, {
    expanded: n,
    selected: r,
    checked: o,
    loaded: a,
    loading: i,
    halfChecked: l,
    dragOver: c,
    dragOverGapTop: u,
    dragOverGapBottom: d,
    pos: f,
    active: m,
    key: v
  });
  return "props" in h || Object.defineProperty(h, "props", {
    get: function() {
      return tt(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), e;
    }
  }), h;
}
function TS(e, t) {
  var n = /* @__PURE__ */ new Set();
  return e.forEach(function(r) {
    t.has(r) || n.add(r);
  }), n;
}
function KF(e) {
  var t = e || {}, n = t.disabled, r = t.disableCheckbox, o = t.checkable;
  return !!(n || r) || o === !1;
}
function qF(e, t, n, r) {
  for (var o = new Set(e), a = /* @__PURE__ */ new Set(), i = 0; i <= n; i += 1) {
    var l = t.get(i) || /* @__PURE__ */ new Set();
    l.forEach(function(f) {
      var m = f.key, v = f.node, h = f.children, p = h === void 0 ? [] : h;
      o.has(m) && !r(v) && p.filter(function(g) {
        return !r(g.node);
      }).forEach(function(g) {
        o.add(g.key);
      });
    });
  }
  for (var c = /* @__PURE__ */ new Set(), u = n; u >= 0; u -= 1) {
    var d = t.get(u) || /* @__PURE__ */ new Set();
    d.forEach(function(f) {
      var m = f.parent, v = f.node;
      if (!(r(v) || !f.parent || c.has(f.parent.key))) {
        if (r(f.parent.node)) {
          c.add(m.key);
          return;
        }
        var h = !0, p = !1;
        (m.children || []).filter(function(g) {
          return !r(g.node);
        }).forEach(function(g) {
          var b = g.key, y = o.has(b);
          h && !y && (h = !1), !p && (y || a.has(b)) && (p = !0);
        }), h && o.add(m.key), p && a.add(m.key), c.add(m.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(o),
    halfCheckedKeys: Array.from(TS(a, o))
  };
}
function GF(e, t, n, r, o) {
  for (var a = new Set(e), i = new Set(t), l = 0; l <= r; l += 1) {
    var c = n.get(l) || /* @__PURE__ */ new Set();
    c.forEach(function(m) {
      var v = m.key, h = m.node, p = m.children, g = p === void 0 ? [] : p;
      !a.has(v) && !i.has(v) && !o(h) && g.filter(function(b) {
        return !o(b.node);
      }).forEach(function(b) {
        a.delete(b.key);
      });
    });
  }
  i = /* @__PURE__ */ new Set();
  for (var u = /* @__PURE__ */ new Set(), d = r; d >= 0; d -= 1) {
    var f = n.get(d) || /* @__PURE__ */ new Set();
    f.forEach(function(m) {
      var v = m.parent, h = m.node;
      if (!(o(h) || !m.parent || u.has(m.parent.key))) {
        if (o(m.parent.node)) {
          u.add(v.key);
          return;
        }
        var p = !0, g = !1;
        (v.children || []).filter(function(b) {
          return !o(b.node);
        }).forEach(function(b) {
          var y = b.key, C = a.has(y);
          p && !C && (p = !1), !g && (C || i.has(y)) && (g = !0);
        }), p || a.delete(v.key), g && i.add(v.key), u.add(v.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(a),
    halfCheckedKeys: Array.from(TS(i, a))
  };
}
function va(e, t, n, r) {
  var o = [], a;
  r ? a = r : a = KF;
  var i = new Set(e.filter(function(d) {
    var f = !!tr(n, d);
    return f || o.push(d), f;
  })), l = /* @__PURE__ */ new Map(), c = 0;
  Object.keys(n).forEach(function(d) {
    var f = n[d], m = f.level, v = l.get(m);
    v || (v = /* @__PURE__ */ new Set(), l.set(m, v)), v.add(f), c = Math.max(c, m);
  }), tt(!o.length, "Tree missing follow keys: ".concat(o.slice(0, 100).map(function(d) {
    return "'".concat(d, "'");
  }).join(", ")));
  var u;
  return t === !0 ? u = qF(i, l, c, a) : u = GF(i, t.halfCheckedKeys, l, c, a), u;
}
const UF = (e) => {
  const {
    checkboxCls: t
  } = e, n = `${t}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${t}-group`]: Object.assign(Object.assign({}, Gt(e)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: e.marginXS,
        // Group > Grid
        [`> ${e.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [n]: Object.assign(Object.assign({}, Gt(e)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${n}`]: {
          marginInlineStart: 0
        },
        [`&${n}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [t]: Object.assign(Object.assign({}, Gt(e)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: e.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${t}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${t}-inner`]: Object.assign({}, io(e))
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: e.checkboxSize,
          height: e.checkboxSize,
          direction: "ltr",
          backgroundColor: e.colorBgContainer,
          border: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${e.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: e.calc(e.checkboxSize).div(14).mul(5).equal(),
            height: e.calc(e.checkboxSize).div(14).mul(8).equal(),
            border: `${q(e.lineWidthBold)} solid ${e.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${e.motionDurationFast} ${e.motionEaseInBack}, opacity ${e.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: e.paddingXS,
          paddingInlineEnd: e.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${n}:not(${n}-disabled),
        ${t}:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          borderColor: e.colorPrimary
        }
      },
      [`${n}:not(${n}-disabled)`]: {
        [`&:hover ${t}-checked:not(${t}-disabled) ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${t}-checked:not(${t}-disabled):after`]: {
          borderColor: e.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${t}-checked`]: {
        [`${t}-inner`]: {
          backgroundColor: e.colorPrimary,
          borderColor: e.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${e.motionDurationMid} ${e.motionEaseOutBack} ${e.motionDurationFast}`
          }
        }
      },
      [`
        ${n}-checked:not(${n}-disabled),
        ${t}-checked:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [t]: {
        "&-indeterminate": {
          // Wrapper > Checkbox > inner
          [`${t}-inner`]: {
            backgroundColor: e.colorBgContainer,
            borderColor: e.colorBorder,
            "&:after": {
              top: "50%",
              insetInlineStart: "50%",
              width: e.calc(e.fontSizeLG).div(2).equal(),
              height: e.calc(e.fontSizeLG).div(2).equal(),
              backgroundColor: e.colorPrimary,
              border: 0,
              transform: "translate(-50%, -50%) scale(1)",
              opacity: 1,
              content: '""'
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${n}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${t}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${t}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          background: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          "&:after": {
            borderColor: e.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: e.colorTextDisabled
        },
        [`&${t}-indeterminate ${t}-inner::after`]: {
          background: e.colorTextDisabled
        }
      }
    }
  ];
};
function _S(e, t) {
  const n = Dt(t, {
    checkboxCls: `.${e}`,
    checkboxSize: t.controlInteractiveSize
  });
  return [UF(n)];
}
const DS = Xt("Checkbox", (e, t) => {
  let {
    prefixCls: n
  } = t;
  return [_S(n, e)];
}), YF = /* @__PURE__ */ le.createContext(null), kS = YF;
var XF = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const QF = (e, t) => {
  var n;
  const {
    prefixCls: r,
    className: o,
    rootClassName: a,
    children: i,
    indeterminate: l = !1,
    style: c,
    onMouseEnter: u,
    onMouseLeave: d,
    skipGroup: f = !1,
    disabled: m
  } = e, v = XF(e, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: h,
    direction: p,
    checkbox: g
  } = s.useContext(lt), b = s.useContext(kS), {
    isFormItemInput: y
  } = s.useContext(Tn), C = s.useContext(dr), S = (n = (b == null ? void 0 : b.disabled) || m) !== null && n !== void 0 ? n : C, $ = s.useRef(v.value);
  if (process.env.NODE_ENV !== "production") {
    const _ = Rt("Checkbox");
    process.env.NODE_ENV !== "production" && _("checked" in v || !!b || !("value" in v), "usage", "`value` is not a valid prop, do you mean `checked`?");
  }
  s.useEffect(() => {
    b == null || b.registerValue(v.value);
  }, []), s.useEffect(() => {
    if (!f)
      return v.value !== $.current && (b == null || b.cancelValue($.current), b == null || b.registerValue(v.value), $.current = v.value), () => b == null ? void 0 : b.cancelValue(v.value);
  }, [v.value]);
  const x = h("checkbox", r), w = En(x), [N, O, E] = DS(x, w), I = Object.assign({}, v);
  b && !f && (I.onChange = function() {
    v.onChange && v.onChange.apply(v, arguments), b.toggleOption && b.toggleOption({
      label: i,
      value: v.value
    });
  }, I.name = b.name, I.checked = b.value.includes(v.value));
  const k = J(`${x}-wrapper`, {
    [`${x}-rtl`]: p === "rtl",
    [`${x}-wrapper-checked`]: I.checked,
    [`${x}-wrapper-disabled`]: S,
    [`${x}-wrapper-in-form-item`]: y
  }, g == null ? void 0 : g.className, o, a, E, w, O), M = J({
    [`${x}-indeterminate`]: l
  }, Fs, O), P = l ? "mixed" : void 0;
  return N(/* @__PURE__ */ s.createElement(Bi, {
    component: "Checkbox",
    disabled: S
  }, /* @__PURE__ */ s.createElement("label", {
    className: k,
    style: Object.assign(Object.assign({}, g == null ? void 0 : g.style), c),
    onMouseEnter: u,
    onMouseLeave: d
  }, /* @__PURE__ */ s.createElement(iS, Object.assign({
    "aria-checked": P
  }, I, {
    prefixCls: x,
    className: M,
    disabled: S,
    ref: t
  })), i !== void 0 && /* @__PURE__ */ s.createElement("span", null, i))));
}, LS = /* @__PURE__ */ s.forwardRef(QF);
process.env.NODE_ENV !== "production" && (LS.displayName = "Checkbox");
const FS = LS;
var JF = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const ZF = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    defaultValue: n,
    children: r,
    options: o = [],
    prefixCls: a,
    className: i,
    rootClassName: l,
    style: c,
    onChange: u
  } = e, d = JF(e, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: f,
    direction: m
  } = s.useContext(lt), [v, h] = s.useState(d.value || n || []), [p, g] = s.useState([]);
  s.useEffect(() => {
    "value" in d && h(d.value || []);
  }, [d.value]);
  const b = s.useMemo(() => o.map((_) => typeof _ == "string" || typeof _ == "number" ? {
    label: _,
    value: _
  } : _), [o]), y = (_) => {
    g((D) => D.filter((R) => R !== _));
  }, C = (_) => {
    g((D) => [].concat(be(D), [_]));
  }, S = (_) => {
    const D = v.indexOf(_.value), R = be(v);
    D === -1 ? R.push(_.value) : R.splice(D, 1), "value" in d || h(R), u == null || u(R.filter((T) => p.includes(T)).sort((T, L) => {
      const F = b.findIndex((A) => A.value === T), j = b.findIndex((A) => A.value === L);
      return F - j;
    }));
  }, $ = f("checkbox", a), x = `${$}-group`, w = En($), [N, O, E] = DS($, w), I = an(d, ["value", "disabled"]), k = o.length ? b.map((_) => /* @__PURE__ */ s.createElement(FS, {
    prefixCls: $,
    key: _.value.toString(),
    disabled: "disabled" in _ ? _.disabled : d.disabled,
    value: _.value,
    checked: v.includes(_.value),
    onChange: _.onChange,
    className: `${x}-item`,
    style: _.style,
    title: _.title,
    id: _.id,
    required: _.required
  }, _.label)) : r, M = {
    toggleOption: S,
    value: v,
    disabled: d.disabled,
    name: d.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: C,
    cancelValue: y
  }, P = J(x, {
    [`${x}-rtl`]: m === "rtl"
  }, i, l, E, w, O);
  return N(/* @__PURE__ */ s.createElement("div", Object.assign({
    className: P,
    style: c
  }, I, {
    ref: t
  }), /* @__PURE__ */ s.createElement(kS.Provider, {
    value: M
  }, k)));
}), ej = ZF, uc = FS;
uc.Group = ej;
uc.__ANT_CHECKBOX = !0;
process.env.NODE_ENV !== "production" && (uc.displayName = "Checkbox");
const Ea = uc, tj = /* @__PURE__ */ uo({}), jS = tj, nj = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, rj = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, oj = (e, t) => {
  const {
    prefixCls: n,
    componentCls: r,
    gridColumns: o
  } = e, a = {};
  for (let i = o; i >= 0; i--)
    i === 0 ? (a[`${r}${t}-${i}`] = {
      display: "none"
    }, a[`${r}-push-${i}`] = {
      insetInlineStart: "auto"
    }, a[`${r}-pull-${i}`] = {
      insetInlineEnd: "auto"
    }, a[`${r}${t}-push-${i}`] = {
      insetInlineStart: "auto"
    }, a[`${r}${t}-pull-${i}`] = {
      insetInlineEnd: "auto"
    }, a[`${r}${t}-offset-${i}`] = {
      marginInlineStart: 0
    }, a[`${r}${t}-order-${i}`] = {
      order: 0
    }) : (a[`${r}${t}-${i}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        ["--ant-display"]: "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${i / o * 100}%`,
        maxWidth: `${i / o * 100}%`
      }
    ], a[`${r}${t}-push-${i}`] = {
      insetInlineStart: `${i / o * 100}%`
    }, a[`${r}${t}-pull-${i}`] = {
      insetInlineEnd: `${i / o * 100}%`
    }, a[`${r}${t}-offset-${i}`] = {
      marginInlineStart: `${i / o * 100}%`
    }, a[`${r}${t}-order-${i}`] = {
      order: i
    });
  return a[`${r}${t}-flex`] = {
    flex: `var(--${n}${t}-flex)`
  }, a;
}, Ad = (e, t) => oj(e, t), aj = (e, t, n) => ({
  [`@media (min-width: ${q(t)})`]: Object.assign({}, Ad(e, n))
}), ij = () => ({}), lj = () => ({}), sj = Xt("Grid", nj, ij), cj = Xt("Grid", (e) => {
  const t = Dt(e, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), n = {
    "-sm": t.screenSMMin,
    "-md": t.screenMDMin,
    "-lg": t.screenLGMin,
    "-xl": t.screenXLMin,
    "-xxl": t.screenXXLMin
  };
  return [rj(t), Ad(t, ""), Ad(t, "-xs"), Object.keys(n).map((r) => aj(t, n[r], r)).reduce((r, o) => Object.assign(Object.assign({}, r), o), {})];
}, lj);
var uj = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function yp(e) {
  return typeof e == "number" ? `${e} ${e} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(e) ? `0 0 ${e}` : e;
}
const dj = ["xs", "sm", "md", "lg", "xl", "xxl"], zS = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r
  } = s.useContext(lt), {
    gutter: o,
    wrap: a
  } = s.useContext(jS), {
    prefixCls: i,
    span: l,
    order: c,
    offset: u,
    push: d,
    pull: f,
    className: m,
    children: v,
    flex: h,
    style: p
  } = e, g = uj(e, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), b = n("col", i), [y, C, S] = cj(b), $ = {};
  let x = {};
  dj.forEach((O) => {
    let E = {};
    const I = e[O];
    typeof I == "number" ? E.span = I : typeof I == "object" && (E = I || {}), delete g[O], x = Object.assign(Object.assign({}, x), {
      [`${b}-${O}-${E.span}`]: E.span !== void 0,
      [`${b}-${O}-order-${E.order}`]: E.order || E.order === 0,
      [`${b}-${O}-offset-${E.offset}`]: E.offset || E.offset === 0,
      [`${b}-${O}-push-${E.push}`]: E.push || E.push === 0,
      [`${b}-${O}-pull-${E.pull}`]: E.pull || E.pull === 0,
      [`${b}-rtl`]: r === "rtl"
    }), E.flex && (x[`${b}-${O}-flex`] = !0, $[`--${b}-${O}-flex`] = yp(E.flex));
  });
  const w = J(b, {
    [`${b}-${l}`]: l !== void 0,
    [`${b}-order-${c}`]: c,
    [`${b}-offset-${u}`]: u,
    [`${b}-push-${d}`]: d,
    [`${b}-pull-${f}`]: f
  }, m, x, C, S), N = {};
  if (o && o[0] > 0) {
    const O = o[0] / 2;
    N.paddingLeft = O, N.paddingRight = O;
  }
  return h && (N.flex = yp(h), a === !1 && !N.minWidth && (N.minWidth = 0)), y(/* @__PURE__ */ s.createElement("div", Object.assign({}, g, {
    style: Object.assign(Object.assign(Object.assign({}, N), p), $),
    className: w,
    ref: t
  }), v));
});
process.env.NODE_ENV !== "production" && (zS.displayName = "Col");
const Sm = zS;
var fj = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Cp(e, t) {
  const [n, r] = s.useState(typeof e == "string" ? e : ""), o = () => {
    if (typeof e == "string" && r(e), typeof e == "object")
      for (let a = 0; a < Mi.length; a++) {
        const i = Mi[a];
        if (!t[i])
          continue;
        const l = e[i];
        if (l !== void 0) {
          r(l);
          return;
        }
      }
  };
  return s.useEffect(() => {
    o();
  }, [JSON.stringify(e), t]), n;
}
const AS = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    justify: r,
    align: o,
    className: a,
    style: i,
    children: l,
    gutter: c = 0,
    wrap: u
  } = e, d = fj(e, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), {
    getPrefixCls: f,
    direction: m
  } = s.useContext(lt), [v, h] = s.useState({
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  }), [p, g] = s.useState({
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    xxl: !1
  }), b = Cp(o, p), y = Cp(r, p), C = s.useRef(c), S = Uy();
  s.useEffect(() => {
    const R = S.subscribe((T) => {
      g(T);
      const L = C.current || 0;
      (!Array.isArray(L) && typeof L == "object" || Array.isArray(L) && (typeof L[0] == "object" || typeof L[1] == "object")) && h(T);
    });
    return () => S.unsubscribe(R);
  }, []);
  const $ = () => {
    const R = [void 0, void 0];
    return (Array.isArray(c) ? c : [c, void 0]).forEach((L, F) => {
      if (typeof L == "object")
        for (let j = 0; j < Mi.length; j++) {
          const A = Mi[j];
          if (v[A] && L[A] !== void 0) {
            R[F] = L[A];
            break;
          }
        }
      else
        R[F] = L;
    }), R;
  }, x = f("row", n), [w, N, O] = sj(x), E = $(), I = J(x, {
    [`${x}-no-wrap`]: u === !1,
    [`${x}-${y}`]: y,
    [`${x}-${b}`]: b,
    [`${x}-rtl`]: m === "rtl"
  }, a, N, O), k = {}, M = E[0] != null && E[0] > 0 ? E[0] / -2 : void 0;
  M && (k.marginLeft = M, k.marginRight = M), [, k.rowGap] = E;
  const [P, _] = E, D = s.useMemo(() => ({
    gutter: [P, _],
    wrap: u
  }), [P, _, u]);
  return w(/* @__PURE__ */ s.createElement(jS.Provider, {
    value: D
  }, /* @__PURE__ */ s.createElement("div", Object.assign({}, d, {
    className: I,
    style: Object.assign(Object.assign({}, k), i),
    ref: t
  }), l)));
});
process.env.NODE_ENV !== "production" && (AS.displayName = "Row");
const BS = AS;
var HS = /* @__PURE__ */ le.forwardRef(function(e, t) {
  var n, r = e.prefixCls, o = e.forceRender, a = e.className, i = e.style, l = e.children, c = e.isActive, u = e.role, d = le.useState(c || o), f = Q(d, 2), m = f[0], v = f[1];
  return le.useEffect(function() {
    (o || c) && v(!0);
  }, [o, c]), m ? /* @__PURE__ */ le.createElement("div", {
    ref: t,
    className: J("".concat(r, "-content"), (n = {}, z(n, "".concat(r, "-content-active"), c), z(n, "".concat(r, "-content-inactive"), !c), n), a),
    style: i,
    role: u
  }, /* @__PURE__ */ le.createElement("div", {
    className: "".concat(r, "-content-box")
  }, l)) : null;
});
HS.displayName = "PanelContent";
var mj = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"], VS = /* @__PURE__ */ le.forwardRef(function(e, t) {
  var n, r, o = e.showArrow, a = o === void 0 ? !0 : o, i = e.headerClass, l = e.isActive, c = e.onItemClick, u = e.forceRender, d = e.className, f = e.prefixCls, m = e.collapsible, v = e.accordion, h = e.panelKey, p = e.extra, g = e.header, b = e.expandIcon, y = e.openMotion, C = e.destroyInactivePanel, S = e.children, $ = vt(e, mj), x = m === "disabled", w = m === "header", N = m === "icon", O = p != null && typeof p != "boolean", E = function() {
    c == null || c(h);
  }, I = function(R) {
    (R.key === "Enter" || R.keyCode === Oe.ENTER || R.which === Oe.ENTER) && E();
  }, k = typeof b == "function" ? b(e) : /* @__PURE__ */ le.createElement("i", {
    className: "arrow"
  });
  k && (k = /* @__PURE__ */ le.createElement("div", {
    className: "".concat(f, "-expand-icon"),
    onClick: ["header", "icon"].includes(m) ? E : void 0
  }, k));
  var M = J((n = {}, z(n, "".concat(f, "-item"), !0), z(n, "".concat(f, "-item-active"), l), z(n, "".concat(f, "-item-disabled"), x), n), d), P = J(i, (r = {}, z(r, "".concat(f, "-header"), !0), z(r, "".concat(f, "-header-collapsible-only"), w), z(r, "".concat(f, "-icon-collapsible-only"), N), r)), _ = {
    className: P,
    "aria-expanded": l,
    "aria-disabled": x,
    onKeyDown: I
  };
  return !w && !N && (_.onClick = E, _.role = v ? "tab" : "button", _.tabIndex = x ? -1 : 0), /* @__PURE__ */ le.createElement("div", fe({}, $, {
    ref: t,
    className: M
  }), /* @__PURE__ */ le.createElement("div", _, a && k, /* @__PURE__ */ le.createElement("span", {
    className: "".concat(f, "-header-text"),
    onClick: m === "header" ? E : void 0
  }, g), O && /* @__PURE__ */ le.createElement("div", {
    className: "".concat(f, "-extra")
  }, p)), /* @__PURE__ */ le.createElement(An, fe({
    visible: l,
    leavedClassName: "".concat(f, "-content-hidden")
  }, y, {
    forceRender: u,
    removeOnLeave: C
  }), function(D, R) {
    var T = D.className, L = D.style;
    return /* @__PURE__ */ le.createElement(HS, {
      ref: R,
      prefixCls: f,
      className: T,
      style: L,
      isActive: l,
      forceRender: u,
      role: v ? "tabpanel" : void 0
    }, S);
  }));
}), vj = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"], gj = function(t, n) {
  var r = n.prefixCls, o = n.accordion, a = n.collapsible, i = n.destroyInactivePanel, l = n.onItemClick, c = n.activeKey, u = n.openMotion, d = n.expandIcon;
  return t.map(function(f, m) {
    var v = f.children, h = f.label, p = f.key, g = f.collapsible, b = f.onItemClick, y = f.destroyInactivePanel, C = vt(f, vj), S = String(p ?? m), $ = g ?? a, x = y ?? i, w = function(E) {
      $ !== "disabled" && (l(E), b == null || b(E));
    }, N = !1;
    return o ? N = c[0] === S : N = c.indexOf(S) > -1, /* @__PURE__ */ le.createElement(VS, fe({}, C, {
      prefixCls: r,
      key: S,
      panelKey: S,
      isActive: N,
      accordion: o,
      openMotion: u,
      expandIcon: d,
      header: h,
      collapsible: $,
      onItemClick: w,
      destroyInactivePanel: x
    }), v);
  });
}, pj = function(t, n, r) {
  if (!t)
    return null;
  var o = r.prefixCls, a = r.accordion, i = r.collapsible, l = r.destroyInactivePanel, c = r.onItemClick, u = r.activeKey, d = r.openMotion, f = r.expandIcon, m = t.key || String(n), v = t.props, h = v.header, p = v.headerClass, g = v.destroyInactivePanel, b = v.collapsible, y = v.onItemClick, C = !1;
  a ? C = u[0] === m : C = u.indexOf(m) > -1;
  var S = b ?? i, $ = function(N) {
    S !== "disabled" && (c(N), y == null || y(N));
  }, x = {
    key: m,
    panelKey: m,
    header: h,
    headerClass: p,
    isActive: C,
    prefixCls: o,
    destroyInactivePanel: g ?? l,
    openMotion: d,
    accordion: a,
    children: t.props.children,
    onItemClick: $,
    expandIcon: f,
    collapsible: S
  };
  return typeof t.type == "string" ? t : (Object.keys(x).forEach(function(w) {
    typeof x[w] > "u" && delete x[w];
  }), /* @__PURE__ */ le.cloneElement(t, x));
};
function hj(e, t, n) {
  return Array.isArray(e) ? gj(e, n) : Pn(t).map(function(r, o) {
    return pj(r, o, n);
  });
}
function bj(e) {
  var t = e;
  if (!Array.isArray(t)) {
    var n = mt(t);
    t = n === "number" || n === "string" ? [t] : [];
  }
  return t.map(function(r) {
    return String(r);
  });
}
var yj = /* @__PURE__ */ le.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-collapse" : n, o = e.destroyInactivePanel, a = o === void 0 ? !1 : o, i = e.style, l = e.accordion, c = e.className, u = e.children, d = e.collapsible, f = e.openMotion, m = e.expandIcon, v = e.activeKey, h = e.defaultActiveKey, p = e.onChange, g = e.items, b = J(r, c), y = Vt([], {
    value: v,
    onChange: function(O) {
      return p == null ? void 0 : p(O);
    },
    defaultValue: h,
    postState: bj
  }), C = Q(y, 2), S = C[0], $ = C[1], x = function(O) {
    return $(function() {
      if (l)
        return S[0] === O ? [] : [O];
      var E = S.indexOf(O), I = E > -1;
      return I ? S.filter(function(k) {
        return k !== O;
      }) : [].concat(be(S), [O]);
    });
  };
  tt(!u, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
  var w = hj(g, u, {
    prefixCls: r,
    accordion: l,
    openMotion: f,
    expandIcon: m,
    collapsible: d,
    destroyInactivePanel: a,
    onItemClick: x,
    activeKey: S
  });
  return /* @__PURE__ */ le.createElement("div", {
    ref: t,
    className: b,
    style: i,
    role: l ? "tablist" : void 0
  }, w);
});
const xm = Object.assign(yj, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: VS
});
xm.Panel;
const Cj = /* @__PURE__ */ s.forwardRef((e, t) => {
  process.env.NODE_ENV !== "production" && Rt("Collapse.Panel").deprecated(!("disabled" in e), "disabled", 'collapsible="disabled"');
  const {
    getPrefixCls: n
  } = s.useContext(lt), {
    prefixCls: r,
    className: o,
    showArrow: a = !0
  } = e, i = n("collapse", r), l = J({
    [`${i}-no-arrow`]: !a
  }, o);
  return /* @__PURE__ */ s.createElement(xm.Panel, Object.assign({
    ref: t
  }, e, {
    prefixCls: i,
    className: l
  }));
}), Sj = Cj, xj = (e) => {
  const {
    componentCls: t,
    contentBg: n,
    padding: r,
    headerBg: o,
    headerPadding: a,
    collapseHeaderPaddingSM: i,
    collapseHeaderPaddingLG: l,
    collapsePanelBorderRadius: c,
    lineWidth: u,
    lineType: d,
    colorBorder: f,
    colorText: m,
    colorTextHeading: v,
    colorTextDisabled: h,
    fontSizeLG: p,
    lineHeight: g,
    lineHeightLG: b,
    marginSM: y,
    paddingSM: C,
    paddingLG: S,
    paddingXS: $,
    motionDurationSlow: x,
    fontSizeIcon: w,
    contentPadding: N,
    fontHeight: O,
    fontHeightLG: E
  } = e, I = `${q(u)} ${d} ${f}`;
  return {
    [t]: Object.assign(Object.assign({}, Gt(e)), {
      backgroundColor: o,
      border: I,
      borderBottom: 0,
      borderRadius: c,
      ["&-rtl"]: {
        direction: "rtl"
      },
      [`& > ${t}-item`]: {
        borderBottom: I,
        ["&:last-child"]: {
          [`
            &,
            & > ${t}-header`]: {
            borderRadius: `0 0 ${q(c)} ${q(c)}`
          }
        },
        [`> ${t}-header`]: {
          position: "relative",
          // Compatible with old version of antd, should remove in next version
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "flex-start",
          padding: a,
          color: v,
          lineHeight: g,
          cursor: "pointer",
          transition: `all ${x}, visibility 0s`,
          [`> ${t}-header-text`]: {
            flex: "auto"
          },
          "&:focus": {
            outline: "none"
          },
          // >>>>> Arrow
          [`${t}-expand-icon`]: {
            height: O,
            display: "flex",
            alignItems: "center",
            paddingInlineEnd: y
          },
          [`${t}-arrow`]: Object.assign(Object.assign({}, Li()), {
            fontSize: w,
            svg: {
              transition: `transform ${x}`
            }
          }),
          // >>>>> Text
          [`${t}-header-text`]: {
            marginInlineEnd: "auto"
          }
        },
        [`${t}-icon-collapsible-only`]: {
          cursor: "unset",
          [`${t}-expand-icon`]: {
            cursor: "pointer"
          }
        }
      },
      [`${t}-content`]: {
        color: m,
        backgroundColor: n,
        borderTop: I,
        [`& > ${t}-content-box`]: {
          padding: N
        },
        ["&-hidden"]: {
          display: "none"
        }
      },
      ["&-small"]: {
        [`> ${t}-item`]: {
          [`> ${t}-header`]: {
            padding: i,
            paddingInlineStart: $,
            [`> ${t}-expand-icon`]: {
              // Arrow offset
              marginInlineStart: e.calc(C).sub($).equal()
            }
          },
          [`> ${t}-content > ${t}-content-box`]: {
            padding: C
          }
        }
      },
      ["&-large"]: {
        [`> ${t}-item`]: {
          fontSize: p,
          lineHeight: b,
          [`> ${t}-header`]: {
            padding: l,
            paddingInlineStart: r,
            [`> ${t}-expand-icon`]: {
              height: E,
              // Arrow offset
              marginInlineStart: e.calc(S).sub(r).equal()
            }
          },
          [`> ${t}-content > ${t}-content-box`]: {
            padding: S
          }
        }
      },
      [`${t}-item:last-child`]: {
        [`> ${t}-content`]: {
          borderRadius: `0 0 ${q(c)} ${q(c)}`
        }
      },
      [`& ${t}-item-disabled > ${t}-header`]: {
        [`
          &,
          & > .arrow
        `]: {
          color: h,
          cursor: "not-allowed"
        }
      },
      // ========================== Icon Position ==========================
      [`&${t}-icon-position-end`]: {
        [`& > ${t}-item`]: {
          [`> ${t}-header`]: {
            [`${t}-expand-icon`]: {
              order: 1,
              paddingInlineEnd: 0,
              paddingInlineStart: y
            }
          }
        }
      }
    })
  };
}, $j = (e) => {
  const {
    componentCls: t
  } = e, n = `> ${t}-item > ${t}-header ${t}-arrow svg`;
  return {
    [`${t}-rtl`]: {
      [n]: {
        transform: "rotate(180deg)"
      }
    }
  };
}, wj = (e) => {
  const {
    componentCls: t,
    headerBg: n,
    paddingXXS: r,
    colorBorder: o
  } = e;
  return {
    [`${t}-borderless`]: {
      backgroundColor: n,
      border: 0,
      [`> ${t}-item`]: {
        borderBottom: `1px solid ${o}`
      },
      [`
        > ${t}-item:last-child,
        > ${t}-item:last-child ${t}-header
      `]: {
        borderRadius: 0
      },
      [`> ${t}-item:last-child`]: {
        borderBottom: 0
      },
      [`> ${t}-item > ${t}-content`]: {
        backgroundColor: "transparent",
        borderTop: 0
      },
      [`> ${t}-item > ${t}-content > ${t}-content-box`]: {
        paddingTop: r
      }
    }
  };
}, Ej = (e) => {
  const {
    componentCls: t,
    paddingSM: n
  } = e;
  return {
    [`${t}-ghost`]: {
      backgroundColor: "transparent",
      border: 0,
      [`> ${t}-item`]: {
        borderBottom: 0,
        [`> ${t}-content`]: {
          backgroundColor: "transparent",
          border: 0,
          [`> ${t}-content-box`]: {
            paddingBlock: n
          }
        }
      }
    }
  };
}, Oj = (e) => ({
  headerPadding: `${e.paddingSM}px ${e.padding}px`,
  headerBg: e.colorFillAlter,
  contentPadding: `${e.padding}px 16px`,
  // Fixed Value
  contentBg: e.colorBgContainer
}), Nj = Xt("Collapse", (e) => {
  const t = Dt(e, {
    collapseHeaderPaddingSM: `${q(e.paddingXS)} ${q(e.paddingSM)}`,
    collapseHeaderPaddingLG: `${q(e.padding)} ${q(e.paddingLG)}`,
    collapsePanelBorderRadius: e.borderRadiusLG
  });
  return [xj(t), wj(t), Ej(t), $j(t), qi(t)];
}, Oj), WS = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r,
    collapse: o
  } = s.useContext(lt), {
    prefixCls: a,
    className: i,
    rootClassName: l,
    style: c,
    bordered: u = !0,
    ghost: d,
    size: f,
    expandIconPosition: m = "start",
    children: v,
    expandIcon: h
  } = e, p = qn((E) => {
    var I;
    return (I = f ?? E) !== null && I !== void 0 ? I : "middle";
  }), g = n("collapse", a), b = n(), [y, C, S] = Nj(g);
  if (process.env.NODE_ENV !== "production") {
    const E = Rt("Collapse");
    process.env.NODE_ENV !== "production" && E(m !== "left" && m !== "right", "deprecated", "`expandIconPosition` with `left` or `right` is deprecated. Please use `start` or `end` instead.");
  }
  const $ = s.useMemo(() => m === "left" ? "start" : m === "right" ? "end" : m, [m]), x = function() {
    let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const I = h ? h(E) : /* @__PURE__ */ s.createElement($a, {
      rotate: E.isActive ? 90 : void 0
    });
    return xn(I, () => ({
      className: J(I.props.className, `${g}-arrow`)
    }));
  }, w = J(`${g}-icon-position-${$}`, {
    [`${g}-borderless`]: !u,
    [`${g}-rtl`]: r === "rtl",
    [`${g}-ghost`]: !!d,
    [`${g}-${p}`]: p !== "middle"
  }, o == null ? void 0 : o.className, i, l, C, S), N = Object.assign(Object.assign({}, ya(b)), {
    motionAppear: !1,
    leavedClassName: `${g}-content-hidden`
  }), O = s.useMemo(() => v ? Pn(v).map((E, I) => {
    var k, M;
    if (!((k = E.props) === null || k === void 0) && k.disabled) {
      const P = (M = E.key) !== null && M !== void 0 ? M : String(I), {
        disabled: _,
        collapsible: D
      } = E.props, R = Object.assign(Object.assign({}, an(E.props, ["disabled"])), {
        key: P,
        collapsible: D ?? (_ ? "disabled" : void 0)
      });
      return xn(E, R);
    }
    return E;
  }) : null, [v]);
  return y(/* @__PURE__ */ s.createElement(xm, Object.assign({
    ref: t,
    openMotion: N
  }, an(e, ["rootClassName"]), {
    expandIcon: x,
    prefixCls: g,
    className: w,
    style: Object.assign(Object.assign({}, o == null ? void 0 : o.style), c)
  }), O));
});
process.env.NODE_ENV !== "production" && (WS.displayName = "Collapse");
const KS = Object.assign(WS, {
  Panel: Sj
}), Ij = (e) => {
  const {
    componentCls: t,
    sizePaddingEdgeHorizontal: n,
    colorSplit: r,
    lineWidth: o,
    textPaddingInline: a,
    orientationMargin: i,
    verticalMarginInline: l
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Gt(e)), {
      borderBlockStart: `${q(o)} solid ${r}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        marginInline: l,
        marginBlock: 0,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${q(o)} solid ${r}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${q(e.dividerHorizontalGutterMargin)} 0`
      },
      [`&-horizontal${t}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${q(e.dividerHorizontalWithTextGutterMargin)} 0`,
        color: e.colorTextHeading,
        fontWeight: 500,
        fontSize: e.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${r}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${q(o)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${t}-with-text-left`]: {
        "&::before": {
          width: `calc(${i} * 100%)`
        },
        "&::after": {
          width: `calc(100% - ${i} * 100%)`
        }
      },
      [`&-horizontal${t}-with-text-right`]: {
        "&::before": {
          width: `calc(100% - ${i} * 100%)`
        },
        "&::after": {
          width: `calc(${i} * 100%)`
        }
      },
      [`${t}-inner-text`]: {
        display: "inline-block",
        paddingBlock: 0,
        paddingInline: a
      },
      "&-dashed": {
        background: "none",
        borderColor: r,
        borderStyle: "dashed",
        borderWidth: `${q(o)} 0 0`
      },
      [`&-horizontal${t}-with-text${t}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${t}-dashed`]: {
        borderInlineStartWidth: o,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${t}-with-text`]: {
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`&-horizontal${t}-with-text-left${t}-no-default-orientation-margin-left`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${t}-inner-text`]: {
          paddingInlineStart: n
        }
      },
      [`&-horizontal${t}-with-text-right${t}-no-default-orientation-margin-right`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${t}-inner-text`]: {
          paddingInlineEnd: n
        }
      }
    })
  };
}, Pj = (e) => ({
  textPaddingInline: "1em",
  orientationMargin: 0.05,
  verticalMarginInline: e.marginXS
}), Rj = Xt("Divider", (e) => {
  const t = Dt(e, {
    dividerHorizontalWithTextGutterMargin: e.margin,
    dividerHorizontalGutterMargin: e.marginLG,
    sizePaddingEdgeHorizontal: 0
  });
  return [Ij(t)];
}, Pj, {
  unitless: {
    orientationMargin: !0
  }
});
var Mj = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const qS = (e) => {
  const {
    getPrefixCls: t,
    direction: n,
    divider: r
  } = s.useContext(lt), {
    prefixCls: o,
    type: a = "horizontal",
    orientation: i = "center",
    orientationMargin: l,
    className: c,
    rootClassName: u,
    children: d,
    dashed: f,
    plain: m,
    style: v
  } = e, h = Mj(e, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "plain", "style"]), p = t("divider", o), [g, b, y] = Rj(p), C = i.length > 0 ? `-${i}` : i, S = !!d, $ = i === "left" && l != null, x = i === "right" && l != null, w = J(p, r == null ? void 0 : r.className, b, y, `${p}-${a}`, {
    [`${p}-with-text`]: S,
    [`${p}-with-text${C}`]: S,
    [`${p}-dashed`]: !!f,
    [`${p}-plain`]: !!m,
    [`${p}-rtl`]: n === "rtl",
    [`${p}-no-default-orientation-margin-left`]: $,
    [`${p}-no-default-orientation-margin-right`]: x
  }, c, u), N = s.useMemo(() => typeof l == "number" ? l : /^\d+$/.test(l) ? Number(l) : l, [l]), O = Object.assign(Object.assign({}, $ && {
    marginLeft: N
  }), x && {
    marginRight: N
  });
  if (process.env.NODE_ENV !== "production") {
    const E = Rt("Divider");
    process.env.NODE_ENV !== "production" && E(!d || a !== "vertical", "usage", "`children` not working in `vertical` mode.");
  }
  return g(/* @__PURE__ */ s.createElement("div", Object.assign({
    className: w,
    style: Object.assign(Object.assign({}, r == null ? void 0 : r.style), v)
  }, h, {
    role: "separator"
  }), d && a !== "vertical" && /* @__PURE__ */ s.createElement("span", {
    className: `${p}-inner-text`,
    style: O
  }, d)));
};
process.env.NODE_ENV !== "production" && (qS.displayName = "Divider");
const Tj = qS;
function _j(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function Dj(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function Cs(e, t, n, r) {
  if (n) {
    var o = t;
    if (t.type === "click") {
      var a = e.cloneNode(!0);
      o = Object.create(t, {
        target: {
          value: a
        },
        currentTarget: {
          value: a
        }
      }), a.value = "", n(o);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      var i = e.cloneNode(!0);
      o = Object.create(t, {
        target: {
          value: i
        },
        currentTarget: {
          value: i
        }
      }), i.value = r, n(o);
      return;
    }
    n(o);
  }
}
function kj(e, t) {
  if (e) {
    e.focus(t);
    var n = t || {}, r = n.cursor;
    if (r) {
      var o = e.value.length;
      switch (r) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(o, o);
          break;
        default:
          e.setSelectionRange(0, o);
      }
    }
  }
}
var GS = function(t) {
  var n, r, o = t.inputElement, a = t.children, i = t.prefixCls, l = t.prefix, c = t.suffix, u = t.addonBefore, d = t.addonAfter, f = t.className, m = t.style, v = t.disabled, h = t.readOnly, p = t.focused, g = t.triggerFocus, b = t.allowClear, y = t.value, C = t.handleReset, S = t.hidden, $ = t.classes, x = t.classNames, w = t.dataAttrs, N = t.styles, O = t.components, E = a ?? o, I = (O == null ? void 0 : O.affixWrapper) || "span", k = (O == null ? void 0 : O.groupWrapper) || "span", M = (O == null ? void 0 : O.wrapper) || "span", P = (O == null ? void 0 : O.groupAddon) || "span", _ = Xe(null), D = function(H) {
    var U;
    (U = _.current) !== null && U !== void 0 && U.contains(H.target) && (g == null || g());
  }, R = Dj(t), T = /* @__PURE__ */ Mw(E, {
    value: y,
    className: J(E.props.className, !R && (x == null ? void 0 : x.variant)) || null
  });
  if (R) {
    var L, F = null;
    if (b) {
      var j, A = !v && !h && y, B = "".concat(i, "-clear-icon"), K = mt(b) === "object" && b !== null && b !== void 0 && b.clearIcon ? b.clearIcon : "✖";
      F = /* @__PURE__ */ le.createElement("span", {
        onClick: C,
        onMouseDown: function(H) {
          return H.preventDefault();
        },
        className: J(B, (j = {}, z(j, "".concat(B, "-hidden"), !A), z(j, "".concat(B, "-has-suffix"), !!c), j)),
        role: "button",
        tabIndex: -1
      }, K);
    }
    var Y = "".concat(i, "-affix-wrapper"), G = J(Y, (L = {}, z(L, "".concat(i, "-disabled"), v), z(L, "".concat(Y, "-disabled"), v), z(L, "".concat(Y, "-focused"), p), z(L, "".concat(Y, "-readonly"), h), z(L, "".concat(Y, "-input-with-clear-btn"), c && b && y), L), $ == null ? void 0 : $.affixWrapper, x == null ? void 0 : x.affixWrapper, x == null ? void 0 : x.variant), te = (c || b) && /* @__PURE__ */ le.createElement("span", {
      className: J("".concat(i, "-suffix"), x == null ? void 0 : x.suffix),
      style: N == null ? void 0 : N.suffix
    }, F, c);
    T = /* @__PURE__ */ le.createElement(I, fe({
      className: G,
      style: N == null ? void 0 : N.affixWrapper,
      onClick: D
    }, w == null ? void 0 : w.affixWrapper, {
      ref: _
    }), l && /* @__PURE__ */ le.createElement("span", {
      className: J("".concat(i, "-prefix"), x == null ? void 0 : x.prefix),
      style: N == null ? void 0 : N.prefix
    }, l), T, te);
  }
  if (_j(t)) {
    var ee = "".concat(i, "-group"), oe = "".concat(ee, "-addon"), X = "".concat(ee, "-wrapper"), W = J("".concat(i, "-wrapper"), ee, $ == null ? void 0 : $.wrapper, x == null ? void 0 : x.wrapper), re = J(X, z({}, "".concat(X, "-disabled"), v), $ == null ? void 0 : $.group, x == null ? void 0 : x.groupWrapper);
    T = /* @__PURE__ */ le.createElement(k, {
      className: re
    }, /* @__PURE__ */ le.createElement(M, {
      className: W
    }, u && /* @__PURE__ */ le.createElement(P, {
      className: oe
    }, u), T, d && /* @__PURE__ */ le.createElement(P, {
      className: oe
    }, d)));
  }
  return /* @__PURE__ */ le.cloneElement(T, {
    className: J((n = T.props) === null || n === void 0 ? void 0 : n.className, f) || null,
    style: V(V({}, (r = T.props) === null || r === void 0 ? void 0 : r.style), m),
    hidden: S
  });
}, Lj = ["show"];
function US(e, t) {
  return s.useMemo(function() {
    var n = {};
    t && (n.show = mt(t) === "object" && t.formatter ? t.formatter : !!t), n = V(V({}, n), e);
    var r = n, o = r.show, a = vt(r, Lj);
    return V(V({}, a), {}, {
      show: !!o,
      showFormatter: typeof o == "function" ? o : void 0,
      strategy: a.strategy || function(i) {
        return i.length;
      }
    });
  }, [e, t]);
}
var Fj = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], jj = /* @__PURE__ */ ar(function(e, t) {
  var n = e.autoComplete, r = e.onChange, o = e.onFocus, a = e.onBlur, i = e.onPressEnter, l = e.onKeyDown, c = e.prefixCls, u = c === void 0 ? "rc-input" : c, d = e.disabled, f = e.htmlSize, m = e.className, v = e.maxLength, h = e.suffix, p = e.showCount, g = e.count, b = e.type, y = b === void 0 ? "text" : b, C = e.classes, S = e.classNames, $ = e.styles, x = e.onCompositionStart, w = e.onCompositionEnd, N = vt(e, Fj), O = Ht(!1), E = Q(O, 2), I = E[0], k = E[1], M = Xe(!1), P = Xe(null), _ = function(ie) {
    P.current && kj(P.current, ie);
  }, D = Vt(e.defaultValue, {
    value: e.value
  }), R = Q(D, 2), T = R[0], L = R[1], F = T == null ? "" : String(T), j = Ht(null), A = Q(j, 2), B = A[0], K = A[1], Y = US(g, p), G = Y.max || v, te = Y.strategy(F), ee = !!G && te > G;
  qr(t, function() {
    return {
      focus: _,
      blur: function() {
        var ie;
        (ie = P.current) === null || ie === void 0 || ie.blur();
      },
      setSelectionRange: function(ie, me, Se) {
        var ve;
        (ve = P.current) === null || ve === void 0 || ve.setSelectionRange(ie, me, Se);
      },
      select: function() {
        var ie;
        (ie = P.current) === null || ie === void 0 || ie.select();
      },
      input: P.current
    };
  }), Bt(function() {
    k(function(se) {
      return se && d ? !1 : se;
    });
  }, [d]);
  var oe = function(ie, me, Se) {
    var ve = me;
    if (!M.current && Y.exceedFormatter && Y.max && Y.strategy(me) > Y.max) {
      if (ve = Y.exceedFormatter(me, {
        max: Y.max
      }), me !== ve) {
        var ge, $e;
        K([((ge = P.current) === null || ge === void 0 ? void 0 : ge.selectionStart) || 0, (($e = P.current) === null || $e === void 0 ? void 0 : $e.selectionEnd) || 0]);
      }
    } else if (Se.source === "compositionEnd")
      return;
    L(ve), P.current && Cs(P.current, ie, r, ve);
  };
  Bt(function() {
    if (B) {
      var se;
      (se = P.current) === null || se === void 0 || se.setSelectionRange.apply(se, be(B));
    }
  }, [B]);
  var X = function(ie) {
    oe(ie, ie.target.value, {
      source: "change"
    });
  }, W = function(ie) {
    M.current = !1, oe(ie, ie.currentTarget.value, {
      source: "compositionEnd"
    }), w == null || w(ie);
  }, re = function(ie) {
    i && ie.key === "Enter" && i(ie), l == null || l(ie);
  }, Z = function(ie) {
    k(!0), o == null || o(ie);
  }, H = function(ie) {
    k(!1), a == null || a(ie);
  }, U = function(ie) {
    L(""), _(), P.current && Cs(P.current, ie, r);
  }, ae = ee && "".concat(u, "-out-of-range"), ue = function() {
    var ie = an(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames"
    ]);
    return /* @__PURE__ */ le.createElement("input", fe({
      autoComplete: n
    }, ie, {
      onChange: X,
      onFocus: Z,
      onBlur: H,
      onKeyDown: re,
      className: J(u, z({}, "".concat(u, "-disabled"), d), S == null ? void 0 : S.input),
      style: $ == null ? void 0 : $.input,
      ref: P,
      size: f,
      type: y,
      onCompositionStart: function(Se) {
        M.current = !0, x == null || x(Se);
      },
      onCompositionEnd: W
    }));
  }, de = function() {
    var ie = Number(G) > 0;
    if (h || Y.show) {
      var me = Y.showFormatter ? Y.showFormatter({
        value: F,
        count: te,
        maxLength: G
      }) : "".concat(te).concat(ie ? " / ".concat(G) : "");
      return /* @__PURE__ */ le.createElement(le.Fragment, null, Y.show && /* @__PURE__ */ le.createElement("span", {
        className: J("".concat(u, "-show-count-suffix"), z({}, "".concat(u, "-show-count-has-suffix"), !!h), S == null ? void 0 : S.count),
        style: V({}, $ == null ? void 0 : $.count)
      }, me), h);
    }
    return null;
  };
  return /* @__PURE__ */ le.createElement(GS, fe({}, N, {
    prefixCls: u,
    className: J(m, ae),
    handleReset: U,
    value: F,
    focused: I,
    triggerFocus: _,
    suffix: de(),
    disabled: d,
    classes: C,
    classNames: S,
    styles: $
  }), ue());
});
const zj = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = qt(lt), {
    prefixCls: r,
    className: o
  } = e, a = t("input-group", r), i = t("input"), [l, c] = hm(i), u = J(a, {
    [`${a}-lg`]: e.size === "large",
    [`${a}-sm`]: e.size === "small",
    [`${a}-compact`]: e.compact,
    [`${a}-rtl`]: n === "rtl"
  }, c, o), d = qt(Tn), f = nn(() => Object.assign(Object.assign({}, d), {
    isFormItemInput: !1
  }), [d]);
  return process.env.NODE_ENV !== "production" && Rt("Input.Group").deprecated(!1, "Input.Group", "Space.Compact"), l(/* @__PURE__ */ s.createElement("span", {
    className: u,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ s.createElement(Tn.Provider, {
    value: f
  }, e.children)));
}, Aj = zj;
function YS(e, t) {
  const n = Xe([]), r = () => {
    n.current.push(setTimeout(() => {
      var o, a, i, l;
      !((o = e.current) === null || o === void 0) && o.input && ((a = e.current) === null || a === void 0 ? void 0 : a.input.getAttribute("type")) === "password" && (!((i = e.current) === null || i === void 0) && i.input.hasAttribute("value")) && ((l = e.current) === null || l === void 0 || l.input.removeAttribute("value"));
    }));
  };
  return Bt(() => (t && r(), () => n.current.forEach((o) => {
    o && clearTimeout(o);
  })), []), r;
}
function Bj(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
const Hj = (e) => {
  let t;
  return typeof e == "object" && (e != null && e.clearIcon) ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ le.createElement(Bo, null)
  }), t;
}, Vj = Hj;
var Wj = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Kj(e, t) {
  if (!e)
    return;
  e.focus(t);
  const {
    cursor: n
  } = t || {};
  if (n) {
    const r = e.value.length;
    switch (n) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(r, r);
        break;
      default:
        e.setSelectionRange(0, r);
        break;
    }
  }
}
const qj = /* @__PURE__ */ ar((e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: o = !0,
    status: a,
    size: i,
    disabled: l,
    onBlur: c,
    onFocus: u,
    suffix: d,
    allowClear: f,
    addonAfter: m,
    addonBefore: v,
    className: h,
    style: p,
    styles: g,
    rootClassName: b,
    onChange: y,
    classNames: C,
    variant: S
  } = e, $ = Wj(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: H
    } = Rt("Input");
    H(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: x,
    direction: w,
    input: N
  } = le.useContext(lt), O = x("input", r), E = Xe(null), I = En(O), [k, M, P] = hm(O, I), {
    compactSize: _,
    compactItemClassnames: D
  } = Ho(O, w), R = qn((H) => {
    var U;
    return (U = i ?? _) !== null && U !== void 0 ? U : H;
  }), T = le.useContext(dr), L = l ?? T, {
    status: F,
    hasFeedback: j,
    feedbackIcon: A
  } = qt(Tn), B = Xi(F, a), K = Bj(e) || !!j, Y = Xe(K);
  if (process.env.NODE_ENV !== "production") {
    const H = Rt("Input");
    Bt(() => {
      var U;
      K && !Y.current && process.env.NODE_ENV !== "production" && H(document.activeElement === ((U = E.current) === null || U === void 0 ? void 0 : U.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), Y.current = K;
    }, [K]);
  }
  const G = YS(E, !0), te = (H) => {
    G(), c == null || c(H);
  }, ee = (H) => {
    G(), u == null || u(H);
  }, oe = (H) => {
    G(), y == null || y(H);
  }, X = (j || d) && /* @__PURE__ */ le.createElement(le.Fragment, null, d, j && A), W = Vj(f), [re, Z] = Qi(S, o);
  return k(/* @__PURE__ */ le.createElement(jj, Object.assign({
    ref: Un(t, E),
    prefixCls: O,
    autoComplete: N == null ? void 0 : N.autoComplete
  }, $, {
    disabled: L,
    onBlur: te,
    onFocus: ee,
    style: Object.assign(Object.assign({}, N == null ? void 0 : N.style), p),
    styles: Object.assign(Object.assign({}, N == null ? void 0 : N.styles), g),
    suffix: X,
    allowClear: W,
    className: J(h, b, P, I, D, N == null ? void 0 : N.className),
    onChange: oe,
    addonAfter: m && /* @__PURE__ */ le.createElement(so, null, /* @__PURE__ */ le.createElement(us, {
      override: !0,
      status: !0
    }, m)),
    addonBefore: v && /* @__PURE__ */ le.createElement(so, null, /* @__PURE__ */ le.createElement(us, {
      override: !0,
      status: !0
    }, v)),
    classNames: Object.assign(Object.assign(Object.assign({}, C), N == null ? void 0 : N.classNames), {
      input: J({
        [`${O}-sm`]: R === "small",
        [`${O}-lg`]: R === "large",
        [`${O}-rtl`]: w === "rtl"
      }, C == null ? void 0 : C.input, (n = N == null ? void 0 : N.classNames) === null || n === void 0 ? void 0 : n.input, M),
      variant: J({
        [`${O}-${re}`]: Z
      }, Sa(O, B)),
      affixWrapper: J({
        [`${O}-affix-wrapper-sm`]: R === "small",
        [`${O}-affix-wrapper-lg`]: R === "large",
        [`${O}-affix-wrapper-rtl`]: w === "rtl"
      }, M),
      wrapper: J({
        [`${O}-group-rtl`]: w === "rtl"
      }, M),
      groupWrapper: J({
        [`${O}-group-wrapper-sm`]: R === "small",
        [`${O}-group-wrapper-lg`]: R === "large",
        [`${O}-group-wrapper-rtl`]: w === "rtl",
        [`${O}-group-wrapper-${re}`]: Z
      }, Sa(`${O}-group-wrapper`, B, j), M)
    })
  })));
}), $m = qj;
var Gj = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const Uj = Gj;
var XS = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: Uj
  }));
};
process.env.NODE_ENV !== "production" && (XS.displayName = "EyeInvisibleOutlined");
const Yj = /* @__PURE__ */ s.forwardRef(XS);
var Xj = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const Qj = Xj;
var QS = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: Qj
  }));
};
process.env.NODE_ENV !== "production" && (QS.displayName = "EyeOutlined");
const JS = /* @__PURE__ */ s.forwardRef(QS);
var Jj = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Zj = (e) => e ? /* @__PURE__ */ s.createElement(JS, null) : /* @__PURE__ */ s.createElement(Yj, null), ez = {
  click: "onClick",
  hover: "onMouseOver"
}, ZS = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    visibilityToggle: n = !0
  } = e, r = typeof n == "object" && n.visible !== void 0, [o, a] = Ht(() => r ? n.visible : !1), i = Xe(null);
  s.useEffect(() => {
    r && a(n.visible);
  }, [r, n]);
  const l = YS(i), c = () => {
    const {
      disabled: $
    } = e;
    $ || (o && l(), a((x) => {
      var w;
      const N = !x;
      return typeof n == "object" && ((w = n.onVisibleChange) === null || w === void 0 || w.call(n, N)), N;
    }));
  }, u = ($) => {
    const {
      action: x = "click",
      iconRender: w = Zj
    } = e, N = ez[x] || "", O = w(o), E = {
      [N]: c,
      className: `${$}-icon`,
      key: "passwordIcon",
      onMouseDown: (I) => {
        I.preventDefault();
      },
      onMouseUp: (I) => {
        I.preventDefault();
      }
    };
    return /* @__PURE__ */ s.cloneElement(/* @__PURE__ */ s.isValidElement(O) ? O : /* @__PURE__ */ s.createElement("span", null, O), E);
  }, {
    className: d,
    prefixCls: f,
    inputPrefixCls: m,
    size: v
  } = e, h = Jj(e, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: p
  } = s.useContext(lt), g = p("input", m), b = p("input-password", f), y = n && u(b), C = J(b, d, {
    [`${b}-${v}`]: !!v
  }), S = Object.assign(Object.assign({}, an(h, ["suffix", "iconRender", "visibilityToggle"])), {
    type: o ? "text" : "password",
    className: C,
    prefixCls: g,
    suffix: y
  });
  return v && (S.size = v), /* @__PURE__ */ s.createElement($m, Object.assign({
    ref: Un(t, i)
  }, S));
});
process.env.NODE_ENV !== "production" && (ZS.displayName = "Input.Password");
const tz = ZS;
var nz = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const ex = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    inputPrefixCls: r,
    className: o,
    size: a,
    suffix: i,
    enterButton: l = !1,
    addonAfter: c,
    loading: u,
    disabled: d,
    onSearch: f,
    onChange: m,
    onCompositionStart: v,
    onCompositionEnd: h
  } = e, p = nz(e, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: g,
    direction: b
  } = s.useContext(lt), y = s.useRef(!1), C = g("input-search", n), S = g("input", r), {
    compactSize: $
  } = Ho(C, b), x = qn((F) => {
    var j;
    return (j = a ?? $) !== null && j !== void 0 ? j : F;
  }), w = s.useRef(null), N = (F) => {
    F && F.target && F.type === "click" && f && f(F.target.value, F, {
      source: "clear"
    }), m && m(F);
  }, O = (F) => {
    var j;
    document.activeElement === ((j = w.current) === null || j === void 0 ? void 0 : j.input) && F.preventDefault();
  }, E = (F) => {
    var j, A;
    f && f((A = (j = w.current) === null || j === void 0 ? void 0 : j.input) === null || A === void 0 ? void 0 : A.value, F, {
      source: "input"
    });
  }, I = (F) => {
    y.current || u || E(F);
  }, k = typeof l == "boolean" ? /* @__PURE__ */ s.createElement(qf, null) : null, M = `${C}-button`;
  let P;
  const _ = l || {}, D = _.type && _.type.__ANT_BUTTON === !0;
  D || _.type === "button" ? P = xn(_, Object.assign({
    onMouseDown: O,
    onClick: (F) => {
      var j, A;
      (A = (j = _ == null ? void 0 : _.props) === null || j === void 0 ? void 0 : j.onClick) === null || A === void 0 || A.call(j, F), E(F);
    },
    key: "enterButton"
  }, D ? {
    className: M,
    size: x
  } : {})) : P = /* @__PURE__ */ s.createElement(or, {
    className: M,
    type: l ? "primary" : void 0,
    size: x,
    disabled: d,
    key: "enterButton",
    onMouseDown: O,
    onClick: E,
    loading: u,
    icon: k
  }, l), c && (P = [P, xn(c, {
    key: "addonAfter"
  })]);
  const R = J(C, {
    [`${C}-rtl`]: b === "rtl",
    [`${C}-${x}`]: !!x,
    [`${C}-with-button`]: !!l
  }, o), T = (F) => {
    y.current = !0, v == null || v(F);
  }, L = (F) => {
    y.current = !1, h == null || h(F);
  };
  return /* @__PURE__ */ s.createElement($m, Object.assign({
    ref: Un(w, t),
    onPressEnter: I
  }, p, {
    size: x,
    onCompositionStart: T,
    onCompositionEnd: L,
    prefixCls: S,
    addonAfter: P,
    suffix: i,
    onChange: N,
    className: R,
    disabled: d
  }));
});
process.env.NODE_ENV !== "production" && (ex.displayName = "Search");
const rz = ex;
var oz = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, az = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], ou = {}, sr;
function iz(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && ou[n])
    return ou[n];
  var r = window.getComputedStyle(e), o = r.getPropertyValue("box-sizing") || r.getPropertyValue("-moz-box-sizing") || r.getPropertyValue("-webkit-box-sizing"), a = parseFloat(r.getPropertyValue("padding-bottom")) + parseFloat(r.getPropertyValue("padding-top")), i = parseFloat(r.getPropertyValue("border-bottom-width")) + parseFloat(r.getPropertyValue("border-top-width")), l = az.map(function(u) {
    return "".concat(u, ":").concat(r.getPropertyValue(u));
  }).join(";"), c = {
    sizingStyle: l,
    paddingSize: a,
    borderSize: i,
    boxSizing: o
  };
  return t && n && (ou[n] = c), c;
}
function lz(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  sr || (sr = document.createElement("textarea"), sr.setAttribute("tab-index", "-1"), sr.setAttribute("aria-hidden", "true"), document.body.appendChild(sr)), e.getAttribute("wrap") ? sr.setAttribute("wrap", e.getAttribute("wrap")) : sr.removeAttribute("wrap");
  var o = iz(e, t), a = o.paddingSize, i = o.borderSize, l = o.boxSizing, c = o.sizingStyle;
  sr.setAttribute("style", "".concat(c, ";").concat(oz)), sr.value = e.value || e.placeholder || "";
  var u = void 0, d = void 0, f, m = sr.scrollHeight;
  if (l === "border-box" ? m += i : l === "content-box" && (m -= a), n !== null || r !== null) {
    sr.value = " ";
    var v = sr.scrollHeight - a;
    n !== null && (u = v * n, l === "border-box" && (u = u + a + i), m = Math.max(u, m)), r !== null && (d = v * r, l === "border-box" && (d = d + a + i), f = m > d ? "" : "hidden", m = Math.min(d, m));
  }
  var h = {
    height: m,
    overflowY: f,
    resize: "none"
  };
  return u && (h.minHeight = u), d && (h.maxHeight = d), h;
}
var sz = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], au = 0, iu = 1, lu = 2, cz = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e, r = n.prefixCls;
  n.onPressEnter;
  var o = n.defaultValue, a = n.value, i = n.autoSize, l = n.onResize, c = n.className, u = n.style, d = n.disabled, f = n.onChange, m = n.onInternalAutoSize, v = vt(n, sz), h = Vt(o, {
    value: a,
    postState: function(Y) {
      return Y ?? "";
    }
  }), p = Q(h, 2), g = p[0], b = p[1], y = function(Y) {
    b(Y.target.value), f == null || f(Y);
  }, C = s.useRef();
  s.useImperativeHandle(t, function() {
    return {
      textArea: C.current
    };
  });
  var S = s.useMemo(function() {
    return i && mt(i) === "object" ? [i.minRows, i.maxRows] : [];
  }, [i]), $ = Q(S, 2), x = $[0], w = $[1], N = !!i, O = function() {
    try {
      if (document.activeElement === C.current) {
        var Y = C.current, G = Y.selectionStart, te = Y.selectionEnd, ee = Y.scrollTop;
        C.current.setSelectionRange(G, te), C.current.scrollTop = ee;
      }
    } catch {
    }
  }, E = s.useState(lu), I = Q(E, 2), k = I[0], M = I[1], P = s.useState(), _ = Q(P, 2), D = _[0], R = _[1], T = function() {
    M(au), process.env.NODE_ENV === "test" && (m == null || m());
  };
  Pt(function() {
    N && T();
  }, [a, x, w, N]), Pt(function() {
    if (k === au)
      M(iu);
    else if (k === iu) {
      var K = lz(C.current, !1, x, w);
      M(lu), R(K);
    } else
      O();
  }, [k]);
  var L = s.useRef(), F = function() {
    _t.cancel(L.current);
  }, j = function(Y) {
    k === lu && (l == null || l(Y), i && (F(), L.current = _t(function() {
      T();
    })));
  };
  s.useEffect(function() {
    return F;
  }, []);
  var A = N ? D : null, B = V(V({}, u), A);
  return (k === au || k === iu) && (B.overflowY = "hidden", B.overflowX = "hidden"), /* @__PURE__ */ s.createElement(Mn, {
    onResize: j,
    disabled: !(i || l)
  }, /* @__PURE__ */ s.createElement("textarea", fe({}, v, {
    ref: C,
    style: B,
    className: J(r, c, z({}, "".concat(r, "-disabled"), d)),
    disabled: d,
    value: g,
    onChange: y
  })));
}), uz = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize"], dz = /* @__PURE__ */ le.forwardRef(function(e, t) {
  var n, r, o = e.defaultValue, a = e.value, i = e.onFocus, l = e.onBlur, c = e.onChange, u = e.allowClear, d = e.maxLength, f = e.onCompositionStart, m = e.onCompositionEnd, v = e.suffix, h = e.prefixCls, p = h === void 0 ? "rc-textarea" : h, g = e.showCount, b = e.count, y = e.className, C = e.style, S = e.disabled, $ = e.hidden, x = e.classNames, w = e.styles, N = e.onResize, O = vt(e, uz), E = Vt(o, {
    value: a,
    defaultValue: o
  }), I = Q(E, 2), k = I[0], M = I[1], P = k == null ? "" : String(k), _ = le.useState(!1), D = Q(_, 2), R = D[0], T = D[1], L = le.useRef(!1), F = le.useState(null), j = Q(F, 2), A = j[0], B = j[1], K = Xe(null), Y = function() {
    var Te;
    return (Te = K.current) === null || Te === void 0 ? void 0 : Te.textArea;
  }, G = function() {
    Y().focus();
  };
  qr(t, function() {
    return {
      resizableTextArea: K.current,
      focus: G,
      blur: function() {
        Y().blur();
      }
    };
  }), Bt(function() {
    T(function(ze) {
      return !S && ze;
    });
  }, [S]);
  var te = le.useState(null), ee = Q(te, 2), oe = ee[0], X = ee[1];
  le.useEffect(function() {
    if (oe) {
      var ze;
      (ze = Y()).setSelectionRange.apply(ze, be(oe));
    }
  }, [oe]);
  var W = US(b, g), re = (n = W.max) !== null && n !== void 0 ? n : d, Z = Number(re) > 0, H = W.strategy(P), U = !!re && H > re, ae = function(Te, ke) {
    var Le = ke;
    !L.current && W.exceedFormatter && W.max && W.strategy(ke) > W.max && (Le = W.exceedFormatter(ke, {
      max: W.max
    }), ke !== Le && X([Y().selectionStart || 0, Y().selectionEnd || 0])), M(Le), Cs(Te.currentTarget, Te, c, Le);
  }, ue = function(Te) {
    L.current = !0, f == null || f(Te);
  }, de = function(Te) {
    L.current = !1, ae(Te, Te.currentTarget.value), m == null || m(Te);
  }, se = function(Te) {
    ae(Te, Te.target.value);
  }, ie = function(Te) {
    var ke = O.onPressEnter, Le = O.onKeyDown;
    Te.key === "Enter" && ke && ke(Te), Le == null || Le(Te);
  }, me = function(Te) {
    T(!0), i == null || i(Te);
  }, Se = function(Te) {
    T(!1), l == null || l(Te);
  }, ve = function(Te) {
    M(""), G(), Cs(Y(), Te, c);
  }, ge = v, $e;
  W.show && (W.showFormatter ? $e = W.showFormatter({
    value: P,
    count: H,
    maxLength: re
  }) : $e = "".concat(H).concat(Z ? " / ".concat(re) : ""), ge = /* @__PURE__ */ le.createElement(le.Fragment, null, ge, /* @__PURE__ */ le.createElement("span", {
    className: J("".concat(p, "-data-count"), x == null ? void 0 : x.count),
    style: w == null ? void 0 : w.count
  }, $e)));
  var we = function(Te) {
    var ke;
    N == null || N(Te), (ke = Y()) !== null && ke !== void 0 && ke.style.height && B(!0);
  }, _e = !O.autoSize && !g && !u;
  return /* @__PURE__ */ le.createElement(GS, {
    value: P,
    allowClear: u,
    handleReset: ve,
    suffix: ge,
    prefixCls: p,
    classNames: V(V({}, x), {}, {
      affixWrapper: J(x == null ? void 0 : x.affixWrapper, (r = {}, z(r, "".concat(p, "-show-count"), g), z(r, "".concat(p, "-textarea-allow-clear"), u), r))
    }),
    disabled: S,
    focused: R,
    className: J(y, U && "".concat(p, "-out-of-range")),
    style: V(V({}, C), A && !_e ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof $e == "string" ? $e : void 0
      }
    },
    hidden: $
  }, /* @__PURE__ */ le.createElement(cz, fe({}, O, {
    maxLength: d,
    onKeyDown: ie,
    onChange: se,
    onFocus: me,
    onBlur: Se,
    onCompositionStart: ue,
    onCompositionEnd: de,
    className: J(x == null ? void 0 : x.textarea),
    style: V(V({}, w == null ? void 0 : w.textarea), {}, {
      resize: C == null ? void 0 : C.resize
    }),
    disabled: S,
    prefixCls: p,
    onResize: we,
    ref: K
  })));
}), fz = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const mz = /* @__PURE__ */ ar((e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: o = !0,
    size: a,
    disabled: i,
    status: l,
    allowClear: c,
    classNames: u,
    rootClassName: d,
    className: f,
    variant: m
  } = e, v = fz(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: D
    } = Rt("TextArea");
    D(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: h,
    direction: p
  } = s.useContext(lt), g = qn(a), b = s.useContext(dr), y = i ?? b, {
    status: C,
    hasFeedback: S,
    feedbackIcon: $
  } = s.useContext(Tn), x = Xi(C, l), w = s.useRef(null);
  s.useImperativeHandle(t, () => {
    var D;
    return {
      resizableTextArea: (D = w.current) === null || D === void 0 ? void 0 : D.resizableTextArea,
      focus: (R) => {
        var T, L;
        Kj((L = (T = w.current) === null || T === void 0 ? void 0 : T.resizableTextArea) === null || L === void 0 ? void 0 : L.textArea, R);
      },
      blur: () => {
        var R;
        return (R = w.current) === null || R === void 0 ? void 0 : R.blur();
      }
    };
  });
  const N = h("input", r);
  let O;
  typeof c == "object" && (c != null && c.clearIcon) ? O = c : c && (O = {
    clearIcon: /* @__PURE__ */ s.createElement(Bo, null)
  });
  const E = En(N), [I, k, M] = hm(N, E), [P, _] = Qi(m, o);
  return I(/* @__PURE__ */ s.createElement(dz, Object.assign({}, v, {
    disabled: y,
    allowClear: O,
    className: J(M, E, f, d),
    classNames: Object.assign(Object.assign({}, u), {
      textarea: J({
        [`${N}-sm`]: g === "small",
        [`${N}-lg`]: g === "large"
      }, k, u == null ? void 0 : u.textarea),
      variant: J({
        [`${N}-${P}`]: _
      }, Sa(N, x)),
      affixWrapper: J(`${N}-textarea-affix-wrapper`, {
        [`${N}-affix-wrapper-rtl`]: p === "rtl",
        [`${N}-affix-wrapper-sm`]: g === "small",
        [`${N}-affix-wrapper-lg`]: g === "large",
        [`${N}-textarea-show-count`]: e.showCount || ((n = e.count) === null || n === void 0 ? void 0 : n.show)
      }, k)
    }),
    prefixCls: N,
    suffix: S && /* @__PURE__ */ s.createElement("span", {
      className: `${N}-textarea-suffix`
    }, $),
    ref: w
  })));
}), tx = mz, Da = $m;
process.env.NODE_ENV !== "production" && (Da.displayName = "Input");
Da.Group = Aj;
Da.Search = rz;
Da.TextArea = tx;
Da.Password = tz;
const ka = Da;
var vz = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" };
const gz = vz;
var nx = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: gz
  }));
};
process.env.NODE_ENV !== "production" && (nx.displayName = "CalendarOutlined");
const rx = /* @__PURE__ */ s.forwardRef(nx);
var pz = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" };
const hz = pz;
var ox = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: hz
  }));
};
process.env.NODE_ENV !== "production" && (ox.displayName = "ClockCircleOutlined");
const ax = /* @__PURE__ */ s.forwardRef(ox);
var bz = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" };
const yz = bz;
var ix = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: yz
  }));
};
process.env.NODE_ENV !== "production" && (ix.displayName = "SwapRightOutlined");
const Cz = /* @__PURE__ */ s.forwardRef(ix);
function Sz(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.yearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.quarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.monthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.weekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.placeholder : e.lang.placeholder;
}
function xz(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.rangeYearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.rangeQuarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.rangeMonthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.rangeWeekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.rangePlaceholder : e.lang.rangePlaceholder;
}
function wm(e, t) {
  const n = {
    adjustX: 1,
    adjustY: 1
  };
  switch (t) {
    case "bottomLeft":
      return {
        points: ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
    case "bottomRight":
      return {
        points: ["tr", "br"],
        offset: [0, 4],
        overflow: n
      };
    case "topLeft":
      return {
        points: ["bl", "tl"],
        offset: [0, -4],
        overflow: n
      };
    case "topRight":
      return {
        points: ["br", "tr"],
        offset: [0, -4],
        overflow: n
      };
    default:
      return {
        points: e === "rtl" ? ["tr", "br"] : ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
  }
}
function lx(e, t) {
  const {
    allowClear: n = !0
  } = e, {
    clearIcon: r,
    removeIcon: o
  } = Ky(Object.assign(Object.assign({}, e), {
    prefixCls: t,
    componentName: "DatePicker"
  }));
  return [s.useMemo(() => n === !1 ? !1 : Object.assign({
    clearIcon: r
  }, n === !0 ? {} : n), [n, r]), o];
}
function $z(e) {
  return /* @__PURE__ */ s.createElement(or, Object.assign({
    size: "small",
    type: "primary"
  }, e));
}
function sx(e) {
  return nn(() => Object.assign({
    button: $z
  }, e), [e]);
}
var wz = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Ez(e) {
  const t = /* @__PURE__ */ ar((n, r) => {
    var o;
    const {
      prefixCls: a,
      getPopupContainer: i,
      components: l,
      className: c,
      style: u,
      placement: d,
      size: f,
      disabled: m,
      bordered: v = !0,
      placeholder: h,
      popupClassName: p,
      dropdownClassName: g,
      status: b,
      rootClassName: y,
      variant: C
    } = n, S = wz(n, ["prefixCls", "getPopupContainer", "components", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupClassName", "dropdownClassName", "status", "rootClassName", "variant"]), $ = s.useRef(null), {
      getPrefixCls: x,
      direction: w,
      getPopupContainer: N,
      rangePicker: O
    } = qt(lt), E = x("picker", a), {
      compactSize: I,
      compactItemClassnames: k
    } = Ho(E, w), {
      picker: M
    } = n, P = x(), [_, D] = Qi(C, v), R = En(E), [T, L, F] = yS(E, R);
    if (process.env.NODE_ENV !== "production") {
      const H = Rt("DatePicker.RangePicker");
      H.deprecated(!g, "dropdownClassName", "popupClassName"), H.deprecated(!("bordered" in n), "bordered", "variant");
    }
    const [j] = lx(n, E), A = sx(l), B = qn((H) => {
      var U;
      return (U = f ?? I) !== null && U !== void 0 ? U : H;
    }), K = s.useContext(dr), Y = m ?? K, G = qt(Tn), {
      hasFeedback: te,
      status: ee,
      feedbackIcon: oe
    } = G, X = /* @__PURE__ */ s.createElement(s.Fragment, null, M === "time" ? /* @__PURE__ */ s.createElement(ax, null) : /* @__PURE__ */ s.createElement(rx, null), te && oe);
    qr(r, () => $.current);
    const [W] = ur("Calendar", wi), re = Object.assign(Object.assign({}, W), n.locale), [Z] = vo("DatePicker", (o = n.popupStyle) === null || o === void 0 ? void 0 : o.zIndex);
    return T(/* @__PURE__ */ s.createElement(so, null, /* @__PURE__ */ s.createElement(tS, Object.assign({
      separator: /* @__PURE__ */ s.createElement("span", {
        "aria-label": "to",
        className: `${E}-separator`
      }, /* @__PURE__ */ s.createElement(Cz, null)),
      disabled: Y,
      ref: $,
      popupAlign: wm(w, d),
      placeholder: xz(re, M, h),
      suffixIcon: X,
      prevIcon: /* @__PURE__ */ s.createElement("span", {
        className: `${E}-prev-icon`
      }),
      nextIcon: /* @__PURE__ */ s.createElement("span", {
        className: `${E}-next-icon`
      }),
      superPrevIcon: /* @__PURE__ */ s.createElement("span", {
        className: `${E}-super-prev-icon`
      }),
      superNextIcon: /* @__PURE__ */ s.createElement("span", {
        className: `${E}-super-next-icon`
      }),
      transitionName: `${P}-slide-up`
    }, S, {
      className: J({
        [`${E}-${B}`]: B,
        [`${E}-${_}`]: D
      }, Sa(E, Xi(ee, b), te), L, k, c, O == null ? void 0 : O.className, F, R, y),
      style: Object.assign(Object.assign({}, O == null ? void 0 : O.style), u),
      locale: re.lang,
      prefixCls: E,
      getPopupContainer: i || N,
      generateConfig: e,
      components: A,
      direction: w,
      classNames: {
        popup: J(L, p || g, F, R, y)
      },
      styles: {
        popup: Object.assign(Object.assign({}, n.popupStyle), {
          zIndex: Z
        })
      },
      allowClear: j
    }))));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "RangePicker"), t;
}
var Oz = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Nz(e) {
  function t(c, u) {
    const d = u === "TimePicker" ? "timePicker" : "datePicker", f = /* @__PURE__ */ ar((m, v) => {
      var h;
      const {
        prefixCls: p,
        getPopupContainer: g,
        components: b,
        style: y,
        className: C,
        rootClassName: S,
        size: $,
        bordered: x,
        placement: w,
        placeholder: N,
        popupClassName: O,
        dropdownClassName: E,
        disabled: I,
        status: k,
        variant: M
      } = m, P = Oz(m, ["prefixCls", "getPopupContainer", "components", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupClassName", "dropdownClassName", "disabled", "status", "variant"]), {
        getPrefixCls: _,
        direction: D,
        getPopupContainer: R,
        // Consume different styles according to different names
        [d]: T
      } = qt(lt), L = _("picker", p), {
        compactSize: F,
        compactItemClassnames: j
      } = Ho(L, D), A = s.useRef(null), [B, K] = Qi(M, x), Y = En(L), [G, te, ee] = yS(L, Y);
      qr(v, () => A.current);
      const oe = {
        showToday: !0
      }, X = c || m.picker, W = _();
      if (process.env.NODE_ENV !== "production") {
        const we = Rt(u || "DatePicker");
        process.env.NODE_ENV !== "production" && we(c !== "quarter", "deprecated", `DatePicker.${u} is legacy usage. Please use DatePicker[picker='${c}'] directly.`), we.deprecated(!E, "dropdownClassName", "popupClassName"), we.deprecated(!("bordered" in m), "bordered", "variant");
      }
      const [re, Z] = lx(m, L), H = sx(b), U = qn((we) => {
        var _e;
        return (_e = $ ?? F) !== null && _e !== void 0 ? _e : we;
      }), ae = s.useContext(dr), ue = I ?? ae, de = qt(Tn), {
        hasFeedback: se,
        status: ie,
        feedbackIcon: me
      } = de, Se = /* @__PURE__ */ s.createElement(s.Fragment, null, X === "time" ? /* @__PURE__ */ s.createElement(ax, null) : /* @__PURE__ */ s.createElement(rx, null), se && me), [ve] = ur("DatePicker", wi), ge = Object.assign(Object.assign({}, ve), m.locale), [$e] = vo("DatePicker", (h = m.popupStyle) === null || h === void 0 ? void 0 : h.zIndex);
      return G(/* @__PURE__ */ s.createElement(so, null, /* @__PURE__ */ s.createElement(rS, Object.assign({
        ref: A,
        placeholder: Sz(ge, X, N),
        suffixIcon: Se,
        dropdownAlign: wm(D, w),
        prevIcon: /* @__PURE__ */ s.createElement("span", {
          className: `${L}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ s.createElement("span", {
          className: `${L}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ s.createElement("span", {
          className: `${L}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ s.createElement("span", {
          className: `${L}-super-next-icon`
        }),
        transitionName: `${W}-slide-up`,
        picker: c
      }, oe, P, {
        locale: ge.lang,
        className: J({
          [`${L}-${U}`]: U,
          [`${L}-${B}`]: K
        }, Sa(L, Xi(ie, k), se), te, j, T == null ? void 0 : T.className, C, ee, Y, S),
        style: Object.assign(Object.assign({}, T == null ? void 0 : T.style), y),
        prefixCls: L,
        getPopupContainer: g || R,
        generateConfig: e,
        components: H,
        direction: D,
        disabled: ue,
        classNames: {
          popup: J(te, ee, Y, S, O || E)
        },
        styles: {
          popup: Object.assign(Object.assign({}, m.popupStyle), {
            zIndex: $e
          })
        },
        allowClear: re,
        removeIcon: Z
      }))));
    });
    return process.env.NODE_ENV !== "production" && u && (f.displayName = u), f;
  }
  const n = t(), r = t("week", "WeekPicker"), o = t("month", "MonthPicker"), a = t("year", "YearPicker"), i = t("time", "TimePicker"), l = t("quarter", "QuarterPicker");
  return {
    DatePicker: n,
    WeekPicker: r,
    MonthPicker: o,
    YearPicker: a,
    TimePicker: i,
    QuarterPicker: l
  };
}
function cx(e) {
  const {
    DatePicker: t,
    WeekPicker: n,
    MonthPicker: r,
    YearPicker: o,
    TimePicker: a,
    QuarterPicker: i
  } = Nz(e), l = Ez(e), c = t;
  return c.WeekPicker = n, c.MonthPicker = r, c.YearPicker = o, c.RangePicker = l, c.TimePicker = a, c.QuarterPicker = i, process.env.NODE_ENV !== "production" && (c.displayName = "DatePicker"), c;
}
const La = cx(OC);
function ux(e) {
  const t = wm(e.direction, e.placement);
  return t.overflow.adjustY = !1, t.overflow.adjustX = !1, Object.assign(Object.assign({}, e), {
    dropdownAlign: t
  });
}
const Iz = qs(La, "picker", null, ux);
La._InternalPanelDoNotUseOrYouWillBeFired = Iz;
const Pz = qs(La.RangePicker, "picker", null, ux);
La._InternalRangePanelDoNotUseOrYouWillBeFired = Pz;
La.generatePicker = cx;
const dx = La;
var Sp = /* @__PURE__ */ s.createContext(null), fx = /* @__PURE__ */ s.createContext({}), mx = function(t) {
  var n = t.prefixCls, r = t.className, o = t.style, a = t.children, i = t.containerRef, l = t.id, c = t.onMouseEnter, u = t.onMouseOver, d = t.onMouseLeave, f = t.onClick, m = t.onKeyDown, v = t.onKeyUp, h = {
    onMouseEnter: c,
    onMouseOver: u,
    onMouseLeave: d,
    onClick: f,
    onKeyDown: m,
    onKeyUp: v
  }, p = s.useContext(fx), g = p.panel, b = Gr(g, i);
  return /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement("div", fe({
    id: l,
    className: J("".concat(n, "-content"), r),
    style: V({}, o),
    "aria-modal": "true",
    role: "dialog",
    ref: b
  }, h), a));
};
process.env.NODE_ENV !== "production" && (mx.displayName = "DrawerPanel");
function xp(e) {
  return typeof e == "string" && String(Number(e)) === e ? (tt(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(e)) : e;
}
function Rz(e) {
  tt(!("wrapperClassName" in e), "'wrapperClassName' is removed. Please use 'rootClassName' instead."), tt(pn() || !e.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
var $p = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function Mz(e, t) {
  var n, r, o, a = e.prefixCls, i = e.open, l = e.placement, c = e.inline, u = e.push, d = e.forceRender, f = e.autoFocus, m = e.keyboard, v = e.classNames, h = e.rootClassName, p = e.rootStyle, g = e.zIndex, b = e.className, y = e.id, C = e.style, S = e.motion, $ = e.width, x = e.height, w = e.children, N = e.mask, O = e.maskClosable, E = e.maskMotion, I = e.maskClassName, k = e.maskStyle, M = e.afterOpenChange, P = e.onClose, _ = e.onMouseEnter, D = e.onMouseOver, R = e.onMouseLeave, T = e.onClick, L = e.onKeyDown, F = e.onKeyUp, j = e.styles, A = s.useRef(), B = s.useRef(), K = s.useRef();
  s.useImperativeHandle(t, function() {
    return A.current;
  });
  var Y = function(me) {
    var Se = me.keyCode, ve = me.shiftKey;
    switch (Se) {
      case Oe.TAB: {
        if (Se === Oe.TAB) {
          if (!ve && document.activeElement === K.current) {
            var ge;
            (ge = B.current) === null || ge === void 0 || ge.focus({
              preventScroll: !0
            });
          } else if (ve && document.activeElement === B.current) {
            var $e;
            ($e = K.current) === null || $e === void 0 || $e.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      case Oe.ESC: {
        P && m && (me.stopPropagation(), P(me));
        break;
      }
    }
  };
  s.useEffect(function() {
    if (i && f) {
      var ie;
      (ie = A.current) === null || ie === void 0 || ie.focus({
        preventScroll: !0
      });
    }
  }, [i]);
  var G = s.useState(!1), te = Q(G, 2), ee = te[0], oe = te[1], X = s.useContext(Sp), W;
  u === !1 ? W = {
    distance: 0
  } : u === !0 ? W = {} : W = u || {};
  var re = (n = (r = (o = W) === null || o === void 0 ? void 0 : o.distance) !== null && r !== void 0 ? r : X == null ? void 0 : X.pushDistance) !== null && n !== void 0 ? n : 180, Z = s.useMemo(function() {
    return {
      pushDistance: re,
      push: function() {
        oe(!0);
      },
      pull: function() {
        oe(!1);
      }
    };
  }, [re]);
  s.useEffect(function() {
    if (i) {
      var ie;
      X == null || (ie = X.push) === null || ie === void 0 || ie.call(X);
    } else {
      var me;
      X == null || (me = X.pull) === null || me === void 0 || me.call(X);
    }
  }, [i]), s.useEffect(function() {
    return function() {
      var ie;
      X == null || (ie = X.pull) === null || ie === void 0 || ie.call(X);
    };
  }, []);
  var H = N && /* @__PURE__ */ s.createElement(An, fe({
    key: "mask"
  }, E, {
    visible: i
  }), function(ie, me) {
    var Se = ie.className, ve = ie.style;
    return /* @__PURE__ */ s.createElement("div", {
      className: J("".concat(a, "-mask"), Se, v == null ? void 0 : v.mask, I),
      style: V(V(V({}, ve), k), j == null ? void 0 : j.mask),
      onClick: O && i ? P : void 0,
      ref: me
    });
  }), U = typeof S == "function" ? S(l) : S, ae = {};
  if (ee && re)
    switch (l) {
      case "top":
        ae.transform = "translateY(".concat(re, "px)");
        break;
      case "bottom":
        ae.transform = "translateY(".concat(-re, "px)");
        break;
      case "left":
        ae.transform = "translateX(".concat(re, "px)");
        break;
      default:
        ae.transform = "translateX(".concat(-re, "px)");
        break;
    }
  l === "left" || l === "right" ? ae.width = xp($) : ae.height = xp(x);
  var ue = {
    onMouseEnter: _,
    onMouseOver: D,
    onMouseLeave: R,
    onClick: T,
    onKeyDown: L,
    onKeyUp: F
  }, de = /* @__PURE__ */ s.createElement(An, fe({
    key: "panel"
  }, U, {
    visible: i,
    forceRender: d,
    onVisibleChanged: function(me) {
      M == null || M(me);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(a, "-content-wrapper-hidden")
  }), function(ie, me) {
    var Se = ie.className, ve = ie.style;
    return /* @__PURE__ */ s.createElement("div", fe({
      className: J("".concat(a, "-content-wrapper"), v == null ? void 0 : v.wrapper, Se),
      style: V(V(V({}, ae), ve), j == null ? void 0 : j.wrapper)
    }, Bn(e, {
      data: !0
    })), /* @__PURE__ */ s.createElement(mx, fe({
      id: y,
      containerRef: me,
      prefixCls: a,
      className: J(b, v == null ? void 0 : v.content),
      style: V(V({}, C), j == null ? void 0 : j.content)
    }, ue), w));
  }), se = V({}, p);
  return g && (se.zIndex = g), /* @__PURE__ */ s.createElement(Sp.Provider, {
    value: Z
  }, /* @__PURE__ */ s.createElement("div", {
    className: J(a, "".concat(a, "-").concat(l), h, z(z({}, "".concat(a, "-open"), i), "".concat(a, "-inline"), c)),
    style: se,
    tabIndex: -1,
    ref: A,
    onKeyDown: Y
  }, H, /* @__PURE__ */ s.createElement("div", {
    tabIndex: 0,
    ref: B,
    style: $p,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), de, /* @__PURE__ */ s.createElement("div", {
    tabIndex: 0,
    ref: K,
    style: $p,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var vx = /* @__PURE__ */ s.forwardRef(Mz);
process.env.NODE_ENV !== "production" && (vx.displayName = "DrawerPopup");
var gx = function(t) {
  var n = t.open, r = n === void 0 ? !1 : n, o = t.prefixCls, a = o === void 0 ? "rc-drawer" : o, i = t.placement, l = i === void 0 ? "right" : i, c = t.autoFocus, u = c === void 0 ? !0 : c, d = t.keyboard, f = d === void 0 ? !0 : d, m = t.width, v = m === void 0 ? 378 : m, h = t.mask, p = h === void 0 ? !0 : h, g = t.maskClosable, b = g === void 0 ? !0 : g, y = t.getContainer, C = t.forceRender, S = t.afterOpenChange, $ = t.destroyOnClose, x = t.onMouseEnter, w = t.onMouseOver, N = t.onMouseLeave, O = t.onClick, E = t.onKeyDown, I = t.onKeyUp, k = t.panelRef, M = s.useState(!1), P = Q(M, 2), _ = P[0], D = P[1];
  process.env.NODE_ENV !== "production" && Rz(t);
  var R = s.useState(!1), T = Q(R, 2), L = T[0], F = T[1];
  Pt(function() {
    F(!0);
  }, []);
  var j = L ? r : !1, A = s.useRef(), B = s.useRef();
  Pt(function() {
    j && (B.current = document.activeElement);
  }, [j]);
  var K = function(oe) {
    var X;
    if (D(oe), S == null || S(oe), !oe && B.current && !((X = A.current) !== null && X !== void 0 && X.contains(B.current))) {
      var W;
      (W = B.current) === null || W === void 0 || W.focus({
        preventScroll: !0
      });
    }
  }, Y = s.useMemo(function() {
    return {
      panel: k
    };
  }, [k]);
  if (!C && !_ && !j && $)
    return null;
  var G = {
    onMouseEnter: x,
    onMouseOver: w,
    onMouseLeave: N,
    onClick: O,
    onKeyDown: E,
    onKeyUp: I
  }, te = V(V({}, t), {}, {
    open: j,
    prefixCls: a,
    placement: l,
    autoFocus: u,
    keyboard: f,
    width: v,
    mask: p,
    maskClosable: b,
    inline: y === !1,
    afterOpenChange: K,
    ref: A
  }, G);
  return /* @__PURE__ */ s.createElement(fx.Provider, {
    value: Y
  }, /* @__PURE__ */ s.createElement(Vi, {
    open: j || C || _,
    autoDestroy: !1,
    getContainer: y,
    autoLock: p && (j || _)
  }, /* @__PURE__ */ s.createElement(vx, te)));
};
process.env.NODE_ENV !== "production" && (gx.displayName = "Drawer");
const Tz = (e) => {
  var t, n;
  const {
    prefixCls: r,
    title: o,
    footer: a,
    extra: i,
    closeIcon: l,
    closable: c,
    onClose: u,
    headerStyle: d,
    bodyStyle: f,
    footerStyle: m,
    children: v,
    classNames: h,
    styles: p
  } = e, {
    drawer: g
  } = s.useContext(lt), b = s.useCallback((x) => /* @__PURE__ */ s.createElement("button", {
    type: "button",
    onClick: u,
    "aria-label": "Close",
    className: `${r}-close`
  }, x), [u]), [y, C] = Nf(c, typeof l < "u" ? l : g == null ? void 0 : g.closeIcon, b, void 0, !0), S = s.useMemo(() => {
    var x, w;
    return !o && !y ? null : /* @__PURE__ */ s.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (x = g == null ? void 0 : g.styles) === null || x === void 0 ? void 0 : x.header), d), p == null ? void 0 : p.header),
      className: J(`${r}-header`, {
        [`${r}-header-close-only`]: y && !o && !i
      }, (w = g == null ? void 0 : g.classNames) === null || w === void 0 ? void 0 : w.header, h == null ? void 0 : h.header)
    }, /* @__PURE__ */ s.createElement("div", {
      className: `${r}-header-title`
    }, C, o && /* @__PURE__ */ s.createElement("div", {
      className: `${r}-title`
    }, o)), i && /* @__PURE__ */ s.createElement("div", {
      className: `${r}-extra`
    }, i));
  }, [y, C, i, d, r, o]), $ = s.useMemo(() => {
    var x, w;
    if (!a)
      return null;
    const N = `${r}-footer`;
    return /* @__PURE__ */ s.createElement("div", {
      className: J(N, (x = g == null ? void 0 : g.classNames) === null || x === void 0 ? void 0 : x.footer, h == null ? void 0 : h.footer),
      style: Object.assign(Object.assign(Object.assign({}, (w = g == null ? void 0 : g.styles) === null || w === void 0 ? void 0 : w.footer), m), p == null ? void 0 : p.footer)
    }, a);
  }, [a, m, r]);
  return /* @__PURE__ */ s.createElement(s.Fragment, null, S, /* @__PURE__ */ s.createElement("div", {
    className: J(`${r}-body`, h == null ? void 0 : h.body, (t = g == null ? void 0 : g.classNames) === null || t === void 0 ? void 0 : t.body),
    style: Object.assign(Object.assign(Object.assign({}, (n = g == null ? void 0 : g.styles) === null || n === void 0 ? void 0 : n.body), f), p == null ? void 0 : p.body)
  }, v), $);
}, px = Tz, _z = (e) => {
  const t = "100%";
  return {
    left: `translateX(-${t})`,
    right: `translateX(${t})`,
    top: `translateY(-${t})`,
    bottom: `translateY(${t})`
  }[e];
}, hx = (e, t) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, e), {
    "&-active": t
  }),
  "&-leave": Object.assign(Object.assign({}, t), {
    "&-active": e
  })
}), bx = (e, t) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${t}`
    }
  }
}, hx({
  opacity: e
}, {
  opacity: 1
})), Dz = (e, t) => [bx(0.7, t), hx({
  transform: _z(e)
}, {
  transform: "none"
})], kz = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return {
    [t]: {
      // ======================== Mask ========================
      [`${t}-mask-motion`]: bx(0, n),
      // ======================= Panel ========================
      [`${t}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((r, o) => Object.assign(Object.assign({}, r), {
        [`&-${o}`]: Dz(o, n)
      }), {})
    }
  };
}, Lz = kz, Fz = (e) => {
  const {
    componentCls: t,
    zIndexPopup: n,
    colorBgMask: r,
    colorBgElevated: o,
    motionDurationSlow: a,
    motionDurationMid: i,
    padding: l,
    paddingLG: c,
    fontSizeLG: u,
    lineHeightLG: d,
    lineWidth: f,
    lineType: m,
    colorSplit: v,
    marginSM: h,
    colorIcon: p,
    colorIconHover: g,
    colorText: b,
    fontWeightStrong: y,
    footerPaddingBlock: C,
    footerPaddingInline: S
  } = e, $ = `${t}-content-wrapper`;
  return {
    [t]: {
      position: "fixed",
      inset: 0,
      zIndex: n,
      pointerEvents: "none",
      "&-pure": {
        position: "relative",
        background: o,
        display: "flex",
        flexDirection: "column",
        [`&${t}-left`]: {
          boxShadow: e.boxShadowDrawerLeft
        },
        [`&${t}-right`]: {
          boxShadow: e.boxShadowDrawerRight
        },
        [`&${t}-top`]: {
          boxShadow: e.boxShadowDrawerUp
        },
        [`&${t}-bottom`]: {
          boxShadow: e.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${t}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: n,
        background: r,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [$]: {
        position: "absolute",
        zIndex: n,
        maxWidth: "100vw",
        transition: `all ${a}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${$}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: e.boxShadowDrawerLeft
      },
      [`&-right > ${$}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: e.boxShadowDrawerRight
      },
      [`&-top > ${$}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerUp
      },
      [`&-bottom > ${$}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerDown
      },
      [`${t}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: o,
        pointerEvents: "auto"
      },
      // Header
      [`${t}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${q(l)} ${q(c)}`,
        fontSize: u,
        lineHeight: d,
        borderBottom: `${q(f)} ${m} ${v}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${t}-extra`]: {
        flex: "none"
      },
      [`${t}-close`]: {
        display: "inline-block",
        marginInlineEnd: h,
        color: p,
        fontWeight: y,
        fontSize: u,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        outline: 0,
        cursor: "pointer",
        transition: `color ${i}`,
        textRendering: "auto",
        "&:focus, &:hover": {
          color: g,
          textDecoration: "none"
        }
      },
      [`${t}-title`]: {
        flex: 1,
        margin: 0,
        color: b,
        fontWeight: e.fontWeightStrong,
        fontSize: u,
        lineHeight: d
      },
      // Body
      [`${t}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: c,
        overflow: "auto"
      },
      // Footer
      [`${t}-footer`]: {
        flexShrink: 0,
        padding: `${q(C)} ${q(S)}`,
        borderTop: `${q(f)} ${m} ${v}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, jz = (e) => ({
  zIndexPopup: e.zIndexPopupBase,
  footerPaddingBlock: e.paddingXS,
  footerPaddingInline: e.padding
}), yx = Xt("Drawer", (e) => {
  const t = Dt(e, {});
  return [Fz(t), Lz(t)];
}, jz);
var Cx = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const zz = {
  distance: 180
}, Em = (e) => {
  var t, n, r, o, a, i, l, c, u, d, f;
  const {
    rootClassName: m,
    width: v,
    height: h,
    size: p = "default",
    mask: g = !0,
    push: b = zz,
    open: y,
    afterOpenChange: C,
    onClose: S,
    prefixCls: $,
    getContainer: x,
    style: w,
    className: N,
    // Deprecated
    visible: O,
    afterVisibleChange: E,
    maskStyle: I,
    drawerStyle: k,
    contentWrapperStyle: M
  } = e, P = Cx(e, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle"]), {
    getPopupContainer: _,
    getPrefixCls: D,
    direction: R,
    drawer: T
  } = s.useContext(lt), L = D("drawer", $), [F, j, A] = yx(L), B = (
    // 有可能为 false，所以不能直接判断
    x === void 0 && _ ? () => _(document.body) : x
  ), K = J({
    "no-mask": !g,
    [`${L}-rtl`]: R === "rtl"
  }, m, j, A);
  if (process.env.NODE_ENV !== "production") {
    const re = Rt("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"]].forEach((Z) => {
      let [H, U] = Z;
      re.deprecated(!(H in e), H, U);
    }), B !== void 0 && ((t = e.style) === null || t === void 0 ? void 0 : t.position) === "absolute" && process.env.NODE_ENV !== "production" && re(!1, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.");
  }
  const Y = s.useMemo(() => v ?? (p === "large" ? 736 : 378), [v, p]), G = s.useMemo(() => h ?? (p === "large" ? 736 : 378), [h, p]), te = {
    motionName: Pr(L, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, ee = (re) => ({
    motionName: Pr(L, `panel-motion-${re}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), oe = G0(), [X, W] = vo("Drawer", P.zIndex);
  return F(/* @__PURE__ */ s.createElement(so, null, /* @__PURE__ */ s.createElement(us, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ s.createElement(ji.Provider, {
    value: W
  }, /* @__PURE__ */ s.createElement(gx, Object.assign({
    prefixCls: L,
    onClose: S,
    maskMotion: te,
    motion: ee
  }, P, {
    classNames: {
      mask: J((n = P.classNames) === null || n === void 0 ? void 0 : n.mask, (r = T == null ? void 0 : T.classNames) === null || r === void 0 ? void 0 : r.mask),
      content: J((o = P.classNames) === null || o === void 0 ? void 0 : o.content, (a = T == null ? void 0 : T.classNames) === null || a === void 0 ? void 0 : a.content)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, (i = P.styles) === null || i === void 0 ? void 0 : i.mask), I), (l = T == null ? void 0 : T.styles) === null || l === void 0 ? void 0 : l.mask),
      content: Object.assign(Object.assign(Object.assign({}, (c = P.styles) === null || c === void 0 ? void 0 : c.content), k), (u = T == null ? void 0 : T.styles) === null || u === void 0 ? void 0 : u.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, (d = P.styles) === null || d === void 0 ? void 0 : d.wrapper), M), (f = T == null ? void 0 : T.styles) === null || f === void 0 ? void 0 : f.wrapper)
    },
    open: y ?? O,
    mask: g,
    push: b,
    width: Y,
    height: G,
    style: Object.assign(Object.assign({}, T == null ? void 0 : T.style), w),
    className: J(T == null ? void 0 : T.className, N),
    rootClassName: K,
    getContainer: B,
    afterOpenChange: C ?? E,
    panelRef: oe,
    zIndex: X
  }), /* @__PURE__ */ s.createElement(px, Object.assign({
    prefixCls: L
  }, P, {
    onClose: S
  })))))));
}, Az = (e) => {
  const {
    prefixCls: t,
    style: n,
    className: r,
    placement: o = "right"
  } = e, a = Cx(e, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: i
  } = s.useContext(lt), l = i("drawer", t), [c, u, d] = yx(l), f = J(l, `${l}-pure`, `${l}-${o}`, u, d, r);
  return c(/* @__PURE__ */ s.createElement("div", {
    className: f,
    style: n
  }, /* @__PURE__ */ s.createElement(px, Object.assign({
    prefixCls: l
  }, a))));
};
Em._InternalPanelDoNotUseOrYouWillBeFired = Az;
process.env.NODE_ENV !== "production" && (Em.displayName = "Drawer");
const Bz = Em;
function wp(e) {
  return ["small", "middle", "large"].includes(e);
}
function Ep(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const Sx = /* @__PURE__ */ le.createContext({
  latestIndex: 0
}), Hz = Sx.Provider, Vz = (e) => {
  let {
    className: t,
    index: n,
    children: r,
    split: o,
    style: a
  } = e;
  const {
    latestIndex: i
  } = s.useContext(Sx);
  return r == null ? null : /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement("div", {
    className: t,
    style: a
  }, r), n < i && o && /* @__PURE__ */ s.createElement("span", {
    className: `${t}-split`
  }, o));
}, Wz = Vz;
var Kz = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const xx = /* @__PURE__ */ s.forwardRef((e, t) => {
  var n, r;
  const {
    getPrefixCls: o,
    space: a,
    direction: i
  } = s.useContext(lt), {
    size: l = (a == null ? void 0 : a.size) || "small",
    align: c,
    className: u,
    rootClassName: d,
    children: f,
    direction: m = "horizontal",
    prefixCls: v,
    split: h,
    style: p,
    wrap: g = !1,
    classNames: b,
    styles: y
  } = e, C = Kz(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [S, $] = Array.isArray(l) ? l : [l, l], x = wp($), w = wp(S), N = Ep($), O = Ep(S), E = Pn(f, {
    keepEmpty: !0
  }), I = c === void 0 && m === "horizontal" ? "center" : c, k = o("space", v), [M, P, _] = x0(k), D = J(k, a == null ? void 0 : a.className, P, `${k}-${m}`, {
    [`${k}-rtl`]: i === "rtl",
    [`${k}-align-${I}`]: I,
    [`${k}-gap-row-${$}`]: x,
    [`${k}-gap-col-${S}`]: w
  }, u, d, _), R = J(`${k}-item`, (n = b == null ? void 0 : b.item) !== null && n !== void 0 ? n : (r = a == null ? void 0 : a.classNames) === null || r === void 0 ? void 0 : r.item);
  let T = 0;
  const L = E.map((A, B) => {
    var K, Y;
    A != null && (T = B);
    const G = A && A.key || `${R}-${B}`;
    return /* @__PURE__ */ s.createElement(Wz, {
      className: R,
      key: G,
      index: B,
      split: h,
      style: (K = y == null ? void 0 : y.item) !== null && K !== void 0 ? K : (Y = a == null ? void 0 : a.styles) === null || Y === void 0 ? void 0 : Y.item
    }, A);
  }), F = s.useMemo(() => ({
    latestIndex: T
  }), [T]);
  if (E.length === 0)
    return null;
  const j = {};
  return g && (j.flexWrap = "wrap"), !w && O && (j.columnGap = S), !x && N && (j.rowGap = $), M(/* @__PURE__ */ s.createElement("div", Object.assign({
    ref: t,
    className: D,
    style: Object.assign(Object.assign(Object.assign({}, j), a == null ? void 0 : a.style), p)
  }, C), /* @__PURE__ */ s.createElement(Hz, {
    value: F
  }, L)));
});
process.env.NODE_ENV !== "production" && (xx.displayName = "Space");
const $x = xx;
$x.Compact = AI;
const wx = $x;
var qz = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Ex = (e) => {
  const {
    getPopupContainer: t,
    getPrefixCls: n,
    direction: r
  } = s.useContext(lt), {
    prefixCls: o,
    type: a = "default",
    danger: i,
    disabled: l,
    loading: c,
    onClick: u,
    htmlType: d,
    children: f,
    className: m,
    menu: v,
    arrow: h,
    autoFocus: p,
    overlay: g,
    trigger: b,
    align: y,
    open: C,
    onOpenChange: S,
    placement: $,
    getPopupContainer: x,
    href: w,
    icon: N = /* @__PURE__ */ s.createElement(am, null),
    title: O,
    buttonsRender: E = (ee) => ee,
    mouseEnterDelay: I,
    mouseLeaveDelay: k,
    overlayClassName: M,
    overlayStyle: P,
    destroyPopupOnHide: _,
    dropdownRender: D
  } = e, R = qz(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "dropdownRender"]), T = n("dropdown", o), L = `${T}-button`, F = {
    menu: v,
    arrow: h,
    autoFocus: p,
    align: y,
    disabled: l,
    trigger: l ? [] : b,
    onOpenChange: S,
    getPopupContainer: x || t,
    mouseEnterDelay: I,
    mouseLeaveDelay: k,
    overlayClassName: M,
    overlayStyle: P,
    destroyPopupOnHide: _,
    dropdownRender: D
  }, {
    compactSize: j,
    compactItemClassnames: A
  } = Ho(T, r), B = J(L, A, m);
  "overlay" in e && (F.overlay = g), "open" in e && (F.open = C), "placement" in e ? F.placement = $ : F.placement = r === "rtl" ? "bottomLeft" : "bottomRight";
  const K = /* @__PURE__ */ s.createElement(or, {
    type: a,
    danger: i,
    disabled: l,
    loading: c,
    onClick: u,
    htmlType: d,
    href: w,
    title: O
  }, f), Y = /* @__PURE__ */ s.createElement(or, {
    type: a,
    danger: i,
    icon: N
  }), [G, te] = E([K, Y]);
  return /* @__PURE__ */ s.createElement(wx.Compact, Object.assign({
    className: B,
    size: j,
    block: !0
  }, R), G, /* @__PURE__ */ s.createElement(EC, Object.assign({}, F), te));
};
Ex.__ANT_BUTTON = !0;
const Gz = Ex, Ox = EC;
Ox.Button = Gz;
const dc = Ox;
function Ss(e) {
  const [t, n] = s.useState(e);
  return s.useEffect(() => {
    const r = setTimeout(() => {
      n(e);
    }, e.length ? 0 : 10);
    return () => {
      clearTimeout(r);
    };
  }, [e]), t;
}
const Uz = (e) => {
  const {
    componentCls: t
  } = e, n = `${t}-show-help`, r = `${t}-show-help-item`;
  return {
    [n]: {
      // Explain holder
      transition: `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [r]: {
        overflow: "hidden",
        transition: `height ${e.motionDurationSlow} ${e.motionEaseInOut},
                     opacity ${e.motionDurationSlow} ${e.motionEaseInOut},
                     transform ${e.motionDurationSlow} ${e.motionEaseInOut} !important`,
        [`&${r}-appear, &${r}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          ["&-active"]: {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${r}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, Yz = Uz, Xz = (e) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: e.marginLG,
    padding: 0,
    color: e.colorTextDescription,
    fontSize: e.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
    outline: 0,
    boxShadow: `0 0 0 ${q(e.controlOutlineWidth)} ${e.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: e.colorText,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight
  }
}), Op = (e, t) => {
  const {
    formItemCls: n
  } = e;
  return {
    [n]: {
      [`${n}-label > label`]: {
        height: t
      },
      [`${n}-control-input`]: {
        minHeight: t
      }
    }
  };
}, Qz = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [e.componentCls]: Object.assign(Object.assign(Object.assign({}, Gt(e)), Xz(e)), {
      [`${t}-text`]: {
        display: "inline-block",
        paddingInlineEnd: e.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, Op(e, e.controlHeightSM)),
      "&-large": Object.assign({}, Op(e, e.controlHeightLG))
    })
  };
}, Jz = (e) => {
  const {
    formItemCls: t,
    iconCls: n,
    componentCls: r,
    rootPrefixCls: o,
    labelRequiredMarkColor: a,
    labelColor: i,
    labelFontSize: l,
    labelHeight: c,
    labelColonMarginInlineStart: u,
    labelColonMarginInlineEnd: d,
    itemMarginBottom: f
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Gt(e)), {
      marginBottom: f,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden.${o}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${t}-split`]: {
          color: e.colorError
        }
      },
      "&-has-error": {
        [`${t}-split`]: {
          color: e.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${t}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: e.lineHeight,
          whiteSpace: "unset"
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: c,
          color: i,
          fontSize: l,
          [`> ${n}`]: {
            fontSize: e.fontSize,
            verticalAlign: "top"
          },
          // Required mark
          [`&${t}-required:not(${t}-required-mark-optional)::before`]: {
            display: "inline-block",
            marginInlineEnd: e.marginXXS,
            color: a,
            fontSize: e.fontSize,
            fontFamily: "SimSun, sans-serif",
            lineHeight: 1,
            content: '"*"',
            [`${r}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-optional`]: {
            display: "inline-block",
            marginInlineStart: e.marginXXS,
            color: e.colorTextDescription,
            [`${r}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-tooltip`]: {
            color: e.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: e.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: u,
            marginInlineEnd: d
          },
          [`&${t}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${t}-control`]: {
        ["--ant-display"]: "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${o}-col-'"]):not([class*="' ${o}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: e.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [t]: {
        "&-explain, &-extra": {
          clear: "both",
          color: e.colorTextDescription,
          fontSize: e.fontSize,
          lineHeight: e.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: e.controlHeightSM,
          transition: `color ${e.motionDurationMid} ${e.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: e.colorError
          },
          "&-warning": {
            color: e.colorWarning
          }
        }
      },
      [`&-with-help ${t}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${t}-feedback-icon`]: {
        fontSize: e.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: _f,
        animationDuration: e.motionDurationMid,
        animationTimingFunction: e.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: e.colorSuccess
        },
        "&-error": {
          color: e.colorError
        },
        "&-warning": {
          color: e.colorWarning
        },
        "&-validating": {
          color: e.colorPrimary
        }
      }
    })
  };
}, Zz = (e) => {
  const {
    componentCls: t,
    formItemCls: n
  } = e;
  return {
    [`${t}-horizontal`]: {
      [`${n}-label`]: {
        flexGrow: 0
      },
      [`${n}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${n}-label[class$='-24'], ${n}-label[class*='-24 ']`]: {
        [`& + ${n}-control`]: {
          minWidth: "unset"
        }
      }
    }
  };
}, eA = (e) => {
  const {
    componentCls: t,
    formItemCls: n
  } = e;
  return {
    [`${t}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [n]: {
        flex: "none",
        marginInlineEnd: e.margin,
        marginBottom: 0,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${n}-label,
        > ${n}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${n}-label`]: {
          flex: "none"
        },
        [`${t}-text`]: {
          display: "inline-block"
        },
        [`${n}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, la = (e) => ({
  padding: e.verticalLabelPadding,
  margin: e.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
}), tA = (e) => {
  const {
    componentCls: t,
    formItemCls: n,
    rootPrefixCls: r
  } = e;
  return {
    [`${n} ${n}-label`]: la(e),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${t}:not(${t}-inline)`]: {
      [n]: {
        flexWrap: "wrap",
        [`${n}-label, ${n}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${r}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
}, nA = (e) => {
  const {
    componentCls: t,
    formItemCls: n,
    rootPrefixCls: r
  } = e;
  return {
    [`${t}-vertical`]: {
      [n]: {
        "&-row": {
          flexDirection: "column"
        },
        "&-label > label": {
          height: "auto"
        },
        [`${t}-item-control`]: {
          width: "100%"
        }
      }
    },
    [`${t}-vertical ${n}-label,
      .${r}-col-24${n}-label,
      .${r}-col-xl-24${n}-label`]: la(e),
    [`@media (max-width: ${q(e.screenXSMax)})`]: [tA(e), {
      [t]: {
        [`.${r}-col-xs-24${n}-label`]: la(e)
      }
    }],
    [`@media (max-width: ${q(e.screenSMMax)})`]: {
      [t]: {
        [`.${r}-col-sm-24${n}-label`]: la(e)
      }
    },
    [`@media (max-width: ${q(e.screenMDMax)})`]: {
      [t]: {
        [`.${r}-col-md-24${n}-label`]: la(e)
      }
    },
    [`@media (max-width: ${q(e.screenLGMax)})`]: {
      [t]: {
        [`.${r}-col-lg-24${n}-label`]: la(e)
      }
    }
  };
}, rA = (e) => ({
  labelRequiredMarkColor: e.colorError,
  labelColor: e.colorTextHeading,
  labelFontSize: e.fontSize,
  labelHeight: e.controlHeight,
  labelColonMarginInlineStart: e.marginXXS / 2,
  labelColonMarginInlineEnd: e.marginXS,
  itemMarginBottom: e.marginLG,
  verticalLabelPadding: `0 0 ${e.paddingXS}px`,
  verticalLabelMargin: 0
}), Nx = (e, t) => Dt(e, {
  formItemCls: `${e.componentCls}-item`,
  rootPrefixCls: t
}), Om = Xt("Form", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = Nx(e, n);
  return [Qz(r), Jz(r), Yz(r), Zz(r), eA(r), nA(r), qi(r), _f];
}, rA, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
}), Np = [];
function su(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  return {
    key: typeof e == "string" ? e : `${t}-${r}`,
    error: e,
    errorStatus: n
  };
}
const oA = (e) => {
  let {
    help: t,
    helpStatus: n,
    errors: r = Np,
    warnings: o = Np,
    className: a,
    fieldId: i,
    onVisibleChanged: l
  } = e;
  const {
    prefixCls: c
  } = s.useContext(Tf), u = `${c}-item-explain`, d = En(c), [f, m, v] = Om(c, d), h = nn(() => ya(c), [c]), p = Ss(r), g = Ss(o), b = s.useMemo(() => t != null ? [su(t, "help", n)] : [].concat(be(p.map((C, S) => su(C, "error", "error", S))), be(g.map((C, S) => su(C, "warning", "warning", S)))), [t, n, p, g]), y = {};
  return i && (y.id = `${i}_help`), f(/* @__PURE__ */ s.createElement(An, {
    motionDeadline: h.motionDeadline,
    motionName: `${c}-show-help`,
    visible: !!b.length,
    onVisibleChanged: l
  }, (C) => {
    const {
      className: S,
      style: $
    } = C;
    return /* @__PURE__ */ s.createElement("div", Object.assign({}, y, {
      className: J(u, S, v, d, a, m),
      style: $,
      role: "alert"
    }), /* @__PURE__ */ s.createElement(hf, Object.assign({
      keys: b
    }, ya(c), {
      motionName: `${c}-show-help-item`,
      component: !1
    }), (x) => {
      const {
        key: w,
        error: N,
        errorStatus: O,
        className: E,
        style: I
      } = x;
      return /* @__PURE__ */ s.createElement("div", {
        key: w,
        className: J(E, {
          [`${u}-${O}`]: O
        }),
        style: I
      }, N);
    }));
  }));
}, Ix = oA, aA = ["parentNode"], iA = "form_item";
function pi(e) {
  return e === void 0 || e === !1 ? [] : Array.isArray(e) ? e : [e];
}
function Px(e, t) {
  if (!e.length)
    return;
  const n = e.join("_");
  return t ? `${t}_${n}` : aA.includes(n) ? `${iA}_${n}` : n;
}
function Rx(e, t, n, r, o, a) {
  let i = r;
  return a !== void 0 ? i = a : n.validating ? i = "validating" : e.length ? i = "error" : t.length ? i = "warning" : (n.touched || o && n.validated) && (i = "success"), i;
}
function Ip(e) {
  return pi(e).join("_");
}
function Nm(e) {
  const [t] = Rf(), n = s.useRef({}), r = s.useMemo(() => e ?? Object.assign(Object.assign({}, t), {
    __INTERNAL__: {
      itemRef: (o) => (a) => {
        const i = Ip(o);
        a ? n.current[i] = a : delete n.current[i];
      }
    },
    scrollToField: function(o) {
      let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const i = pi(o), l = Px(i, r.__INTERNAL__.name), c = l ? document.getElementById(l) : null;
      c && QN(c, Object.assign({
        scrollMode: "if-needed",
        block: "nearest"
      }, a));
    },
    getFieldInstance: (o) => {
      const a = Ip(o);
      return n.current[a];
    }
  }), [e, t]);
  return [r];
}
const Rl = {};
function lA(e) {
  let {
    name: t
  } = e;
  const n = Rt("Form");
  Bt(() => {
    if (t)
      return Rl[t] = (Rl[t] || 0) + 1, process.env.NODE_ENV !== "production" && n(Rl[t] <= 1, "usage", "There exist multiple Form with same `name`."), () => {
        Rl[t] -= 1;
      };
  }, [t]);
}
var sA = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const cA = (e, t) => {
  const n = s.useContext(dr), {
    getPrefixCls: r,
    direction: o,
    form: a
  } = s.useContext(lt), {
    prefixCls: i,
    className: l,
    rootClassName: c,
    size: u,
    disabled: d = n,
    form: f,
    colon: m,
    labelAlign: v,
    labelWrap: h,
    labelCol: p,
    wrapperCol: g,
    hideRequiredMark: b,
    layout: y = "horizontal",
    scrollToFirstError: C,
    requiredMark: S,
    onFinishFailed: $,
    name: x,
    style: w,
    feedbackIcons: N,
    variant: O
  } = e, E = sA(e, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]), I = qn(u), k = s.useContext(hb);
  process.env.NODE_ENV !== "production" && lA(e);
  const M = nn(() => S !== void 0 ? S : b ? !1 : a && a.requiredMark !== void 0 ? a.requiredMark : !0, [b, S, a]), P = m ?? (a == null ? void 0 : a.colon), _ = r("form", i), D = En(_), [R, T, L] = Om(_, D), F = J(_, `${_}-${y}`, {
    [`${_}-hide-required-mark`]: M === !1,
    [`${_}-rtl`]: o === "rtl",
    [`${_}-${I}`]: I
  }, L, D, T, a == null ? void 0 : a.className, l, c), [j] = Nm(f), {
    __INTERNAL__: A
  } = j;
  A.name = x;
  const B = nn(() => ({
    name: x,
    labelAlign: v,
    labelCol: p,
    labelWrap: h,
    wrapperCol: g,
    vertical: y === "vertical",
    colon: P,
    requiredMark: M,
    itemRef: A.itemRef,
    form: j,
    feedbackIcons: N
  }), [x, v, p, g, y, P, M, j, N]);
  s.useImperativeHandle(t, () => j);
  const K = (G, te) => {
    if (G) {
      let ee = {
        block: "nearest"
      };
      typeof G == "object" && (ee = G), j.scrollToField(te, ee);
    }
  }, Y = (G) => {
    if ($ == null || $(G), G.errorFields.length) {
      const te = G.errorFields[0].name;
      if (C !== void 0) {
        K(C, te);
        return;
      }
      a && a.scrollToFirstError !== void 0 && K(a.scrollToFirstError, te);
    }
  };
  return R(/* @__PURE__ */ s.createElement(q0.Provider, {
    value: O
  }, /* @__PURE__ */ s.createElement(mf, {
    disabled: d
  }, /* @__PURE__ */ s.createElement(ki.Provider, {
    value: I
  }, /* @__PURE__ */ s.createElement(K0, {
    // This is not list in API, we pass with spread
    validateMessages: k
  }, /* @__PURE__ */ s.createElement(Kr.Provider, {
    value: B
  }, /* @__PURE__ */ s.createElement(Ia, Object.assign({
    id: x
  }, E, {
    name: x,
    onFinishFailed: Y,
    form: j,
    style: Object.assign(Object.assign({}, a == null ? void 0 : a.style), w),
    className: F
  }))))))));
}, Mx = /* @__PURE__ */ s.forwardRef(cA);
process.env.NODE_ENV !== "production" && (Mx.displayName = "Form");
function uA(e) {
  if (typeof e == "function")
    return e;
  const t = Pn(e);
  return t.length <= 1 ? t[0] : t;
}
const Tx = () => {
  const {
    status: e,
    errors: t = [],
    warnings: n = []
  } = qt(Tn);
  if (process.env.NODE_ENV !== "production") {
    const r = Rt("Form.Item");
    process.env.NODE_ENV !== "production" && r(e !== void 0, "usage", "Form.Item.useStatus should be used under Form.Item component. For more information: https://u.ant.design/form-item-usestatus");
  }
  return {
    status: e,
    errors: t,
    warnings: n
  };
};
Tx.Context = Tn;
const dA = Tx;
function fA(e) {
  const [t, n] = s.useState(e), r = Xe(null), o = Xe([]), a = Xe(!1);
  s.useEffect(() => (a.current = !1, () => {
    a.current = !0, _t.cancel(r.current), r.current = null;
  }), []);
  function i(l) {
    a.current || (r.current === null && (o.current = [], r.current = _t(() => {
      r.current = null, n((c) => {
        let u = c;
        return o.current.forEach((d) => {
          u = d(u);
        }), u;
      });
    })), o.current.push(l));
  }
  return [t, i];
}
function mA() {
  const {
    itemRef: e
  } = s.useContext(Kr), t = s.useRef({});
  function n(r, o) {
    const a = o && typeof o == "object" && o.ref, i = r.join("_");
    return (t.current.name !== i || t.current.originRef !== a) && (t.current.name = i, t.current.originRef = a, t.current.ref = Un(e(r), a)), t.current.ref;
  }
  return n;
}
const vA = (e) => {
  const {
    formItemCls: t
  } = e;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${t}-control`]: {
        display: "flex"
      }
    }
  };
}, gA = zo(["Form", "item-item"], (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = Nx(e, n);
  return [vA(r)];
}), pA = (e) => {
  const {
    prefixCls: t,
    status: n,
    wrapperCol: r,
    children: o,
    errors: a,
    warnings: i,
    _internalItemRender: l,
    extra: c,
    help: u,
    fieldId: d,
    marginBottom: f,
    onErrorVisibleChanged: m
  } = e, v = `${t}-item`, h = s.useContext(Kr), p = r || h.wrapperCol || {}, g = J(`${v}-control`, p.className), b = s.useMemo(() => Object.assign({}, h), [h]);
  delete b.labelCol, delete b.wrapperCol;
  const y = /* @__PURE__ */ s.createElement("div", {
    className: `${v}-control-input`
  }, /* @__PURE__ */ s.createElement("div", {
    className: `${v}-control-input-content`
  }, o)), C = s.useMemo(() => ({
    prefixCls: t,
    status: n
  }), [t, n]), S = f !== null || a.length || i.length ? /* @__PURE__ */ s.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "nowrap"
    }
  }, /* @__PURE__ */ s.createElement(Tf.Provider, {
    value: C
  }, /* @__PURE__ */ s.createElement(Ix, {
    fieldId: d,
    errors: a,
    warnings: i,
    help: u,
    helpStatus: n,
    className: `${v}-explain-connected`,
    onVisibleChanged: m
  })), !!f && /* @__PURE__ */ s.createElement("div", {
    style: {
      width: 0,
      height: f
    }
  })) : null, $ = {};
  d && ($.id = `${d}_extra`);
  const x = c ? /* @__PURE__ */ s.createElement("div", Object.assign({}, $, {
    className: `${v}-extra`
  }), c) : null, w = l && l.mark === "pro_table_render" && l.render ? l.render(e, {
    input: y,
    errorList: S,
    extra: x
  }) : /* @__PURE__ */ s.createElement(s.Fragment, null, y, S, x);
  return /* @__PURE__ */ s.createElement(Kr.Provider, {
    value: b
  }, /* @__PURE__ */ s.createElement(Sm, Object.assign({}, p, {
    className: g
  }), w), /* @__PURE__ */ s.createElement(gA, {
    prefixCls: t
  }));
}, hA = pA;
var bA = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
const yA = bA;
var _x = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: yA
  }));
};
process.env.NODE_ENV !== "production" && (_x.displayName = "QuestionCircleOutlined");
const CA = /* @__PURE__ */ s.forwardRef(_x);
var SA = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function xA(e) {
  return e ? typeof e == "object" && !/* @__PURE__ */ s.isValidElement(e) ? e : {
    title: e
  } : null;
}
const $A = (e) => {
  let {
    prefixCls: t,
    label: n,
    htmlFor: r,
    labelCol: o,
    labelAlign: a,
    colon: i,
    required: l,
    requiredMark: c,
    tooltip: u
  } = e;
  var d;
  const [f] = ur("Form"), {
    vertical: m,
    labelAlign: v,
    labelCol: h,
    labelWrap: p,
    colon: g
  } = s.useContext(Kr);
  if (!n)
    return null;
  const b = o || h || {}, y = a || v, C = `${t}-item-label`, S = J(C, y === "left" && `${C}-left`, b.className, {
    [`${C}-wrap`]: !!p
  });
  let $ = n;
  const x = i === !0 || g !== !1 && i !== !1;
  x && !m && typeof n == "string" && n.trim() !== "" && ($ = n.replace(/[:|：]\s*$/, ""));
  const N = xA(u);
  if (N) {
    const {
      icon: k = /* @__PURE__ */ s.createElement(CA, null)
    } = N, M = SA(N, ["icon"]), P = /* @__PURE__ */ s.createElement(Mr, Object.assign({}, M), /* @__PURE__ */ s.cloneElement(k, {
      className: `${t}-item-tooltip`,
      title: "",
      onClick: (_) => {
        _.preventDefault();
      },
      tabIndex: null
    }));
    $ = /* @__PURE__ */ s.createElement(s.Fragment, null, $, P);
  }
  const O = c === "optional", E = typeof c == "function";
  E ? $ = c($, {
    required: !!l
  }) : O && !l && ($ = /* @__PURE__ */ s.createElement(s.Fragment, null, $, /* @__PURE__ */ s.createElement("span", {
    className: `${t}-item-optional`,
    title: ""
  }, (f == null ? void 0 : f.optional) || ((d = xr.Form) === null || d === void 0 ? void 0 : d.optional))));
  const I = J({
    [`${t}-item-required`]: l,
    [`${t}-item-required-mark-optional`]: O || E,
    [`${t}-item-no-colon`]: !x
  });
  return /* @__PURE__ */ s.createElement(Sm, Object.assign({}, b, {
    className: S
  }), /* @__PURE__ */ s.createElement("label", {
    htmlFor: r,
    className: I,
    title: typeof n == "string" ? n : ""
  }, $));
}, wA = $A, EA = {
  success: ks,
  warning: Fi,
  error: Bo,
  validating: To
};
function Dx(e) {
  let {
    children: t,
    errors: n,
    warnings: r,
    hasFeedback: o,
    validateStatus: a,
    prefixCls: i,
    meta: l,
    noStyle: c
  } = e;
  const u = `${i}-item`, {
    feedbackIcons: d
  } = s.useContext(Kr), f = Rx(n, r, l, null, !!o, a), {
    isFormItemInput: m,
    status: v,
    hasFeedback: h,
    feedbackIcon: p
  } = s.useContext(Tn), g = s.useMemo(() => {
    var b;
    let y;
    if (o) {
      const S = o !== !0 && o.icons || d, $ = f && ((b = S == null ? void 0 : S({
        status: f,
        errors: n,
        warnings: r
      })) === null || b === void 0 ? void 0 : b[f]), x = f && EA[f];
      y = $ !== !1 && x ? /* @__PURE__ */ s.createElement("span", {
        className: J(`${u}-feedback-icon`, `${u}-feedback-icon-${f}`)
      }, $ || /* @__PURE__ */ s.createElement(x, null)) : null;
    }
    const C = {
      status: f || "",
      errors: n,
      warnings: r,
      hasFeedback: !!o,
      feedbackIcon: y,
      isFormItemInput: !0
    };
    return c && (C.status = (f ?? v) || "", C.isFormItemInput = m, C.hasFeedback = !!(o ?? h), C.feedbackIcon = o !== void 0 ? C.feedbackIcon : p), C;
  }, [f, o, c, m, v]);
  return /* @__PURE__ */ s.createElement(Tn.Provider, {
    value: g
  }, t);
}
var OA = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function NA(e) {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: o,
    help: a,
    errors: i,
    warnings: l,
    validateStatus: c,
    meta: u,
    hasFeedback: d,
    hidden: f,
    children: m,
    fieldId: v,
    required: h,
    isRequired: p,
    onSubItemMetaChange: g
  } = e, b = OA(e, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange"]), y = `${t}-item`, {
    requiredMark: C
  } = s.useContext(Kr), S = s.useRef(null), $ = Ss(i), x = Ss(l), w = a != null, N = !!(w || i.length || l.length), O = !!S.current && Ai(S.current), [E, I] = s.useState(null);
  Pt(() => {
    if (N && S.current) {
      const D = getComputedStyle(S.current);
      I(parseInt(D.marginBottom, 10));
    }
  }, [N, O]);
  const k = (D) => {
    D || I(null);
  }, P = function() {
    let D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const R = D ? $ : u.errors, T = D ? x : u.warnings;
    return Rx(R, T, u, "", !!d, c);
  }(), _ = J(y, n, r, {
    [`${y}-with-help`]: w || $.length || x.length,
    // Status
    [`${y}-has-feedback`]: P && d,
    [`${y}-has-success`]: P === "success",
    [`${y}-has-warning`]: P === "warning",
    [`${y}-has-error`]: P === "error",
    [`${y}-is-validating`]: P === "validating",
    [`${y}-hidden`]: f
  });
  return /* @__PURE__ */ s.createElement("div", {
    className: _,
    style: o,
    ref: S
  }, /* @__PURE__ */ s.createElement(BS, Object.assign({
    className: `${y}-row`
  }, an(b, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ s.createElement(wA, Object.assign({
    htmlFor: v
  }, e, {
    requiredMark: C,
    required: h ?? p,
    prefixCls: t
  })), /* @__PURE__ */ s.createElement(hA, Object.assign({}, e, u, {
    errors: $,
    warnings: x,
    prefixCls: t,
    status: P,
    help: a,
    marginBottom: E,
    onErrorVisibleChanged: k
  }), /* @__PURE__ */ s.createElement(W0.Provider, {
    value: g
  }, /* @__PURE__ */ s.createElement(Dx, {
    prefixCls: t,
    meta: u,
    errors: u.errors,
    warnings: u.warnings,
    hasFeedback: d,
    // Already calculated
    validateStatus: P
  }, m)))), !!E && /* @__PURE__ */ s.createElement("div", {
    className: `${y}-margin-offset`,
    style: {
      marginBottom: -E
    }
  }));
}
const IA = "__SPLIT__";
function PA(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  return n.length === r.length && n.every((o) => {
    const a = e[o], i = t[o];
    return a === i || typeof a == "function" || typeof i == "function";
  });
}
const RA = /* @__PURE__ */ s.memo((e) => {
  let {
    children: t
  } = e;
  return t;
}, (e, t) => PA(e.control, t.control) && e.update === t.update && e.childProps.length === t.childProps.length && e.childProps.every((n, r) => n === t.childProps[r]));
function Pp() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function MA(e) {
  const {
    name: t,
    noStyle: n,
    className: r,
    dependencies: o,
    prefixCls: a,
    shouldUpdate: i,
    rules: l,
    children: c,
    required: u,
    label: d,
    messageVariables: f,
    trigger: m = "onChange",
    validateTrigger: v,
    hidden: h,
    help: p
  } = e, {
    getPrefixCls: g
  } = s.useContext(lt), {
    name: b
  } = s.useContext(Kr), y = uA(c), C = typeof y == "function", S = s.useContext(W0), {
    validateTrigger: $
  } = s.useContext(_o), x = v !== void 0 ? v : $, w = t != null, N = g("form", a), O = En(N), [E, I, k] = Om(N, O), M = Rt("Form.Item");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && M(t !== null, "usage", "`null` is passed as `name` property");
  const P = s.useContext(Ii), _ = s.useRef(), [D, R] = fA({}), [T, L] = no(() => Pp()), F = (te) => {
    const ee = P == null ? void 0 : P.getKey(te.name);
    if (L(te.destroy ? Pp() : te, !0), n && p !== !1 && S) {
      let oe = te.name;
      if (te.destroy)
        oe = _.current || oe;
      else if (ee !== void 0) {
        const [X, W] = ee;
        oe = [X].concat(be(W)), _.current = oe;
      }
      S(te, oe);
    }
  }, j = (te, ee) => {
    R((oe) => {
      const X = Object.assign({}, oe), re = [].concat(be(te.name.slice(0, -1)), be(ee)).join(IA);
      return te.destroy ? delete X[re] : X[re] = te, X;
    });
  }, [A, B] = s.useMemo(() => {
    const te = be(T.errors), ee = be(T.warnings);
    return Object.values(D).forEach((oe) => {
      te.push.apply(te, be(oe.errors || [])), ee.push.apply(ee, be(oe.warnings || []));
    }), [te, ee];
  }, [D, T.errors, T.warnings]), K = mA();
  function Y(te, ee, oe) {
    return n && !h ? /* @__PURE__ */ s.createElement(Dx, {
      prefixCls: N,
      hasFeedback: e.hasFeedback,
      validateStatus: e.validateStatus,
      meta: T,
      errors: A,
      warnings: B,
      noStyle: !0
    }, te) : /* @__PURE__ */ s.createElement(NA, Object.assign({
      key: "row"
    }, e, {
      className: J(r, k, O, I),
      prefixCls: N,
      fieldId: ee,
      isRequired: oe,
      errors: A,
      warnings: B,
      meta: T,
      onSubItemMetaChange: j
    }), te);
  }
  if (!w && !C && !o)
    return E(Y(y));
  let G = {};
  return typeof d == "string" ? G.label = d : t && (G.label = String(t)), f && (G = Object.assign(Object.assign({}, G), f)), E(/* @__PURE__ */ s.createElement(Pf, Object.assign({}, e, {
    messageVariables: G,
    trigger: m,
    validateTrigger: x,
    onMetaChange: F
  }), (te, ee, oe) => {
    const X = pi(t).length && ee ? ee.name : [], W = Px(X, b), re = u !== void 0 ? u : !!(l && l.some((U) => {
      if (U && typeof U == "object" && U.required && !U.warningOnly)
        return !0;
      if (typeof U == "function") {
        const ae = U(oe);
        return ae && ae.required && !ae.warningOnly;
      }
      return !1;
    })), Z = Object.assign({}, te);
    let H = null;
    if (process.env.NODE_ENV !== "production" && M(!(i && o), "usage", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps."), Array.isArray(y) && w)
      process.env.NODE_ENV !== "production" && M(!1, "usage", "A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item."), H = y;
    else if (C && (!(i || o) || w))
      process.env.NODE_ENV !== "production" && M(!!(i || o), "usage", "A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`."), process.env.NODE_ENV !== "production" && M(!w, "usage", "A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.");
    else if (o && !C && !w)
      process.env.NODE_ENV !== "production" && M(!1, "usage", "Must set `name` or use a render function when `dependencies` is set.");
    else if (Kn(y)) {
      process.env.NODE_ENV !== "production" && M(y.props.defaultValue === void 0, "usage", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      const U = Object.assign(Object.assign({}, y.props), Z);
      if (U.id || (U.id = W), p || A.length > 0 || B.length > 0 || e.extra) {
        const de = [];
        (p || A.length > 0) && de.push(`${W}_help`), e.extra && de.push(`${W}_extra`), U["aria-describedby"] = de.join(" ");
      }
      A.length > 0 && (U["aria-invalid"] = "true"), re && (U["aria-required"] = "true"), Sr(y) && (U.ref = K(X, y)), new Set([].concat(be(pi(m)), be(pi(x)))).forEach((de) => {
        U[de] = function() {
          for (var se, ie, me, Se, ve, ge = arguments.length, $e = new Array(ge), we = 0; we < ge; we++)
            $e[we] = arguments[we];
          (me = Z[de]) === null || me === void 0 || (se = me).call.apply(se, [Z].concat($e)), (ve = (Se = y.props)[de]) === null || ve === void 0 || (ie = ve).call.apply(ie, [Se].concat($e));
        };
      });
      const ue = [U["aria-required"], U["aria-invalid"], U["aria-describedby"]];
      H = /* @__PURE__ */ s.createElement(RA, {
        control: Z,
        update: y,
        childProps: ue
      }, xn(y, U));
    } else
      C && (i || o) && !w ? H = y(oe) : (process.env.NODE_ENV !== "production" && M(!X.length, "usage", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead."), H = y);
    return Y(H, W, re);
  }));
}
const kx = MA;
kx.useStatus = dA;
const TA = kx;
var _A = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const DA = (e) => {
  var {
    prefixCls: t,
    children: n
  } = e, r = _A(e, ["prefixCls", "children"]);
  if (process.env.NODE_ENV !== "production") {
    const l = Rt("Form.List");
    process.env.NODE_ENV !== "production" && l(typeof r.name == "number" || (Array.isArray(r.name) ? !!r.name.length : !!r.name), "usage", "Miss `name` prop.");
  }
  const {
    getPrefixCls: o
  } = s.useContext(lt), a = o("form", t), i = s.useMemo(() => ({
    prefixCls: a,
    status: "error"
  }), [a]);
  return /* @__PURE__ */ s.createElement(B0, Object.assign({}, r), (l, c, u) => /* @__PURE__ */ s.createElement(Tf.Provider, {
    value: i
  }, n(l.map((d) => Object.assign(Object.assign({}, d), {
    fieldKey: d.key
  })), c, {
    errors: u.errors,
    warnings: u.warnings
  })));
}, kA = DA;
function Lx() {
  const {
    form: e
  } = qt(Kr);
  return e;
}
const Yr = Mx;
Yr.Item = TA;
Yr.List = kA;
Yr.ErrorList = Ix;
Yr.useForm = Nm;
Yr.useFormInstance = Lx;
Yr.useWatch = Mf;
Yr.Provider = K0;
Yr.create = () => {
  process.env.NODE_ENV !== "production" && jo(!1, "Form", "antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.");
};
const rl = Yr;
function Rp(e) {
  var t = e.getBoundingClientRect(), n = document.documentElement;
  return {
    left: t.left + (window.pageXOffset || n.scrollLeft) - (n.clientLeft || document.body.clientLeft || 0),
    top: t.top + (window.pageYOffset || n.scrollTop) - (n.clientTop || document.body.clientTop || 0)
  };
}
function Ml(e, t, n, r) {
  var o = $u.unstable_batchedUpdates ? function(i) {
    $u.unstable_batchedUpdates(n, i);
  } : n;
  return e != null && e.addEventListener && e.addEventListener(t, o, r), {
    remove: function() {
      e != null && e.removeEventListener && e.removeEventListener(t, o, r);
    }
  };
}
const LA = function() {
  const e = Object.assign({}, arguments.length <= 0 ? void 0 : arguments[0]);
  for (let t = 1; t < arguments.length; t++) {
    const n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    n && Object.keys(n).forEach((r) => {
      const o = n[r];
      o !== void 0 && (e[r] = o);
    });
  }
  return e;
}, FA = LA;
var jA = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" };
const zA = jA;
var Fx = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: zA
  }));
};
process.env.NODE_ENV !== "production" && (Fx.displayName = "DoubleLeftOutlined");
const Mp = /* @__PURE__ */ s.forwardRef(Fx);
var AA = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" };
const BA = AA;
var jx = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: BA
  }));
};
process.env.NODE_ENV !== "production" && (jx.displayName = "DoubleRightOutlined");
const Tp = /* @__PURE__ */ s.forwardRef(jx);
var HA = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, VA = ["10", "20", "50", "100"], zx = function(t) {
  var n = t.pageSizeOptions, r = n === void 0 ? VA : n, o = t.locale, a = t.changeSize, i = t.pageSize, l = t.goButton, c = t.quickGo, u = t.rootPrefixCls, d = t.selectComponentClass, f = t.selectPrefixCls, m = t.disabled, v = t.buildOptionText, h = le.useState(""), p = Q(h, 2), g = p[0], b = p[1], y = function() {
    return !g || Number.isNaN(g) ? void 0 : Number(g);
  }, C = typeof v == "function" ? v : function(P) {
    return "".concat(P, " ").concat(o.items_per_page);
  }, S = function(_) {
    a == null || a(Number(_));
  }, $ = function(_) {
    b(_.target.value);
  }, x = function(_) {
    l || g === "" || (b(""), !(_.relatedTarget && (_.relatedTarget.className.indexOf("".concat(u, "-item-link")) >= 0 || _.relatedTarget.className.indexOf("".concat(u, "-item")) >= 0)) && (c == null || c(y())));
  }, w = function(_) {
    g !== "" && (_.keyCode === Oe.ENTER || _.type === "click") && (b(""), c == null || c(y()));
  }, N = function() {
    return r.some(function(_) {
      return _.toString() === i.toString();
    }) ? r : r.concat([i.toString()]).sort(function(_, D) {
      var R = Number.isNaN(Number(_)) ? 0 : Number(_), T = Number.isNaN(Number(D)) ? 0 : Number(D);
      return R - T;
    });
  }, O = "".concat(u, "-options");
  if (!a && !c)
    return null;
  var E = null, I = null, k = null;
  if (a && d) {
    var M = N().map(function(P, _) {
      return /* @__PURE__ */ le.createElement(d.Option, {
        key: _,
        value: P.toString()
      }, C(P));
    });
    E = /* @__PURE__ */ le.createElement(d, {
      disabled: m,
      prefixCls: f,
      showSearch: !1,
      className: "".concat(O, "-size-changer"),
      optionLabelProp: "children",
      popupMatchSelectWidth: !1,
      value: (i || r[0]).toString(),
      onChange: S,
      getPopupContainer: function(_) {
        return _.parentNode;
      },
      "aria-label": o.page_size,
      defaultOpen: !1
    }, M);
  }
  return c && (l && (k = typeof l == "boolean" ? /* @__PURE__ */ le.createElement("button", {
    type: "button",
    onClick: w,
    onKeyUp: w,
    disabled: m,
    className: "".concat(O, "-quick-jumper-button")
  }, o.jump_to_confirm) : /* @__PURE__ */ le.createElement("span", {
    onClick: w,
    onKeyUp: w
  }, l)), I = /* @__PURE__ */ le.createElement("div", {
    className: "".concat(O, "-quick-jumper")
  }, o.jump_to, /* @__PURE__ */ le.createElement("input", {
    disabled: m,
    type: "text",
    value: g,
    onChange: $,
    onKeyUp: w,
    onBlur: x,
    "aria-label": o.page
  }), o.page, k)), /* @__PURE__ */ le.createElement("li", {
    className: O
  }, E, I);
};
process.env.NODE_ENV !== "production" && (zx.displayName = "Options");
var sa = function(t) {
  var n, r = t.rootPrefixCls, o = t.page, a = t.active, i = t.className, l = t.showTitle, c = t.onClick, u = t.onKeyPress, d = t.itemRender, f = "".concat(r, "-item"), m = J(f, "".concat(f, "-").concat(o), (n = {}, z(n, "".concat(f, "-active"), a), z(n, "".concat(f, "-disabled"), !o), n), i), v = function() {
    c(o);
  }, h = function(b) {
    u(b, c, o);
  }, p = d(o, "page", /* @__PURE__ */ le.createElement("a", {
    rel: "nofollow"
  }, o));
  return p ? /* @__PURE__ */ le.createElement("li", {
    title: l ? String(o) : null,
    className: m,
    onClick: v,
    onKeyDown: h,
    tabIndex: 0
  }, p) : null;
};
process.env.NODE_ENV !== "production" && (sa.displayName = "Pager");
var WA = function(t, n, r) {
  return r;
};
function cu() {
}
function _p(e) {
  var t = Number(e);
  return typeof t == "number" && !Number.isNaN(t) && isFinite(t) && Math.floor(t) === t;
}
function yo(e, t, n) {
  var r = typeof e > "u" ? t : e;
  return Math.floor((n - 1) / r) + 1;
}
var Ax = function(t) {
  var n, r = t.prefixCls, o = r === void 0 ? "rc-pagination" : r, a = t.selectPrefixCls, i = a === void 0 ? "rc-select" : a, l = t.className, c = t.selectComponentClass, u = t.current, d = t.defaultCurrent, f = d === void 0 ? 1 : d, m = t.total, v = m === void 0 ? 0 : m, h = t.pageSize, p = t.defaultPageSize, g = p === void 0 ? 10 : p, b = t.onChange, y = b === void 0 ? cu : b, C = t.hideOnSinglePage, S = t.showPrevNextJumpers, $ = S === void 0 ? !0 : S, x = t.showQuickJumper, w = t.showLessItems, N = t.showTitle, O = N === void 0 ? !0 : N, E = t.onShowSizeChange, I = E === void 0 ? cu : E, k = t.locale, M = k === void 0 ? HA : k, P = t.style, _ = t.totalBoundaryShowSizeChanger, D = _ === void 0 ? 50 : _, R = t.disabled, T = t.simple, L = t.showTotal, F = t.showSizeChanger, j = t.pageSizeOptions, A = t.itemRender, B = A === void 0 ? WA : A, K = t.jumpPrevIcon, Y = t.jumpNextIcon, G = t.prevIcon, te = t.nextIcon, ee = le.useRef(null), oe = Vt(10, {
    value: h,
    defaultValue: g
  }), X = Q(oe, 2), W = X[0], re = X[1], Z = Vt(1, {
    value: u,
    defaultValue: f,
    postState: function(xt) {
      return Math.max(1, Math.min(xt, yo(void 0, W, v)));
    }
  }), H = Q(Z, 2), U = H[0], ae = H[1], ue = le.useState(U), de = Q(ue, 2), se = de[0], ie = de[1];
  Bt(function() {
    ie(U);
  }, [U]);
  var me = y !== cu, Se = "current" in t;
  process.env.NODE_ENV !== "production" && tt(Se ? me : !0, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  var ve = Math.max(1, U - (w ? 3 : 5)), ge = Math.min(yo(void 0, W, v), U + (w ? 3 : 5));
  function $e(ut, xt) {
    var jt = ut || /* @__PURE__ */ le.createElement("button", {
      type: "button",
      "aria-label": xt,
      className: "".concat(o, "-item-link")
    });
    return typeof ut == "function" && (jt = /* @__PURE__ */ le.createElement(ut, V({}, t))), jt;
  }
  function we(ut) {
    var xt = ut.target.value, jt = yo(void 0, W, v), on;
    return xt === "" ? on = xt : Number.isNaN(Number(xt)) ? on = se : xt >= jt ? on = jt : on = Number(xt), on;
  }
  function _e(ut) {
    return _p(ut) && ut !== U && _p(v) && v > 0;
  }
  var ze = v > W ? x : !1;
  function Te(ut) {
    (ut.keyCode === Oe.UP || ut.keyCode === Oe.DOWN) && ut.preventDefault();
  }
  function ke(ut) {
    var xt = we(ut);
    switch (xt !== se && ie(xt), ut.keyCode) {
      case Oe.ENTER:
        xe(xt);
        break;
      case Oe.UP:
        xe(xt - 1);
        break;
      case Oe.DOWN:
        xe(xt + 1);
        break;
    }
  }
  function Le(ut) {
    xe(we(ut));
  }
  function Ee(ut) {
    var xt = yo(ut, W, v), jt = U > xt && xt !== 0 ? xt : U;
    re(ut), ie(jt), I == null || I(U, ut), ae(jt), y == null || y(jt, ut);
  }
  function xe(ut) {
    if (_e(ut) && !R) {
      var xt = yo(void 0, W, v), jt = ut;
      return ut > xt ? jt = xt : ut < 1 && (jt = 1), jt !== se && ie(jt), ae(jt), y == null || y(jt, W), jt;
    }
    return U;
  }
  var he = U > 1, pe = U < yo(void 0, W, v), Pe = F ?? v > D;
  function Re() {
    he && xe(U - 1);
  }
  function at() {
    pe && xe(U + 1);
  }
  function Ze() {
    xe(ve);
  }
  function Ie() {
    xe(ge);
  }
  function Be(ut, xt) {
    if (ut.key === "Enter" || ut.charCode === Oe.ENTER || ut.keyCode === Oe.ENTER) {
      for (var jt = arguments.length, on = new Array(jt > 2 ? jt - 2 : 0), cn = 2; cn < jt; cn++)
        on[cn - 2] = arguments[cn];
      xt.apply(void 0, on);
    }
  }
  function bt(ut) {
    Be(ut, Re);
  }
  function He(ut) {
    Be(ut, at);
  }
  function nt(ut) {
    Be(ut, Ze);
  }
  function et(ut) {
    Be(ut, Ie);
  }
  function Ge(ut) {
    var xt = B(ut, "prev", $e(G, "prev page"));
    return /* @__PURE__ */ le.isValidElement(xt) ? /* @__PURE__ */ le.cloneElement(xt, {
      disabled: !he
    }) : xt;
  }
  function Ae(ut) {
    var xt = B(ut, "next", $e(te, "next page"));
    return /* @__PURE__ */ le.isValidElement(xt) ? /* @__PURE__ */ le.cloneElement(xt, {
      disabled: !pe
    }) : xt;
  }
  function qe(ut) {
    (ut.type === "click" || ut.keyCode === Oe.ENTER) && xe(se);
  }
  var Je = null, Ke = Bn(t, {
    aria: !0,
    data: !0
  }), Ye = L && /* @__PURE__ */ le.createElement("li", {
    className: "".concat(o, "-total-text")
  }, L(v, [v === 0 ? 0 : (U - 1) * W + 1, U * W > v ? v : U * W])), Ve = null, Qe = yo(void 0, W, v);
  if (C && v <= W)
    return null;
  var it = [], yt = {
    rootPrefixCls: o,
    onClick: xe,
    onKeyPress: Be,
    showTitle: O,
    itemRender: B,
    page: -1
  }, Tt = U - 1 > 0 ? U - 1 : 0, ne = U + 1 < Qe ? U + 1 : Qe, ye = x && x.goButton, ce = ye, Ce = null;
  T && (ye && (typeof ye == "boolean" ? ce = /* @__PURE__ */ le.createElement("button", {
    type: "button",
    onClick: qe,
    onKeyUp: qe
  }, M.jump_to_confirm) : ce = /* @__PURE__ */ le.createElement("span", {
    onClick: qe,
    onKeyUp: qe
  }, ye), ce = /* @__PURE__ */ le.createElement("li", {
    title: O ? "".concat(M.jump_to).concat(U, "/").concat(Qe) : null,
    className: "".concat(o, "-simple-pager")
  }, ce)), Ce = /* @__PURE__ */ le.createElement("li", {
    title: O ? "".concat(U, "/").concat(Qe) : null,
    className: "".concat(o, "-simple-pager")
  }, /* @__PURE__ */ le.createElement("input", {
    type: "text",
    value: se,
    disabled: R,
    onKeyDown: Te,
    onKeyUp: ke,
    onChange: ke,
    onBlur: Le,
    size: 3
  }), /* @__PURE__ */ le.createElement("span", {
    className: "".concat(o, "-slash")
  }, "/"), Qe));
  var je = w ? 1 : 2;
  if (Qe <= 3 + je * 2) {
    Qe || it.push(/* @__PURE__ */ le.createElement(sa, fe({}, yt, {
      key: "noPager",
      page: 1,
      className: "".concat(o, "-item-disabled")
    })));
    for (var Ne = 1; Ne <= Qe; Ne += 1)
      it.push(/* @__PURE__ */ le.createElement(sa, fe({}, yt, {
        key: Ne,
        page: Ne,
        active: U === Ne
      })));
  } else {
    var De = w ? M.prev_3 : M.prev_5, Fe = w ? M.next_3 : M.next_5, ot = B(ve, "jump-prev", $e(K, "prev page")), pt = B(ge, "jump-next", $e(Y, "next page"));
    $ && (Je = ot ? /* @__PURE__ */ le.createElement("li", {
      title: O ? De : null,
      key: "prev",
      onClick: Ze,
      tabIndex: 0,
      onKeyDown: nt,
      className: J("".concat(o, "-jump-prev"), z({}, "".concat(o, "-jump-prev-custom-icon"), !!K))
    }, ot) : null, Ve = pt ? /* @__PURE__ */ le.createElement("li", {
      title: O ? Fe : null,
      key: "next",
      onClick: Ie,
      tabIndex: 0,
      onKeyDown: et,
      className: J("".concat(o, "-jump-next"), z({}, "".concat(o, "-jump-next-custom-icon"), !!Y))
    }, pt) : null);
    var St = Math.max(1, U - je), Ot = Math.min(U + je, Qe);
    U - 1 <= je && (Ot = 1 + je * 2), Qe - U <= je && (St = Qe - je * 2);
    for (var Wt = St; Wt <= Ot; Wt += 1)
      it.push(/* @__PURE__ */ le.createElement(sa, fe({}, yt, {
        key: Wt,
        page: Wt,
        active: U === Wt
      })));
    if (U - 1 >= je * 2 && U !== 1 + 2 && (it[0] = /* @__PURE__ */ le.cloneElement(it[0], {
      className: J("".concat(o, "-item-after-jump-prev"), it[0].props.className)
    }), it.unshift(Je)), Qe - U >= je * 2 && U !== Qe - 2) {
      var rn = it[it.length - 1];
      it[it.length - 1] = /* @__PURE__ */ le.cloneElement(rn, {
        className: J("".concat(o, "-item-before-jump-next"), rn.props.className)
      }), it.push(Ve);
    }
    St !== 1 && it.unshift(/* @__PURE__ */ le.createElement(sa, fe({}, yt, {
      key: 1,
      page: 1
    }))), Ot !== Qe && it.push(/* @__PURE__ */ le.createElement(sa, fe({}, yt, {
      key: Qe,
      page: Qe
    })));
  }
  var Nt = Ge(Tt);
  if (Nt) {
    var Ut = !he || !Qe;
    Nt = /* @__PURE__ */ le.createElement("li", {
      title: O ? M.prev_page : null,
      onClick: Re,
      tabIndex: Ut ? null : 0,
      onKeyDown: bt,
      className: J("".concat(o, "-prev"), z({}, "".concat(o, "-disabled"), Ut)),
      "aria-disabled": Ut
    }, Nt);
  }
  var fn = Ae(ne);
  if (fn) {
    var sn, ln;
    T ? (sn = !pe, ln = he ? 0 : null) : (sn = !pe || !Qe, ln = sn ? null : 0), fn = /* @__PURE__ */ le.createElement("li", {
      title: O ? M.next_page : null,
      onClick: at,
      tabIndex: ln,
      onKeyDown: He,
      className: J("".concat(o, "-next"), z({}, "".concat(o, "-disabled"), sn)),
      "aria-disabled": sn
    }, fn);
  }
  var _n = J(o, l, (n = {}, z(n, "".concat(o, "-simple"), T), z(n, "".concat(o, "-disabled"), R), n));
  return /* @__PURE__ */ le.createElement("ul", fe({
    className: _n,
    style: P,
    ref: ee
  }, Ke), Ye, Nt, T ? Ce : it, fn, /* @__PURE__ */ le.createElement(zx, {
    locale: M,
    rootPrefixCls: o,
    disabled: R,
    selectComponentClass: c,
    selectPrefixCls: i,
    changeSize: Pe ? Ee : null,
    pageSize: W,
    pageSizeOptions: j,
    quickGo: ze ? xe : null,
    goButton: ce
  }));
};
process.env.NODE_ENV !== "production" && (Ax.displayName = "Pagination");
const Bx = (e) => /* @__PURE__ */ s.createElement(po, Object.assign({}, e, {
  showSearch: !0,
  size: "small"
})), Hx = (e) => /* @__PURE__ */ s.createElement(po, Object.assign({}, e, {
  showSearch: !0,
  size: "middle"
}));
Bx.Option = po.Option;
Hx.Option = po.Option;
const KA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${t}-disabled`]: {
      cursor: "not-allowed",
      [`${t}-item`]: {
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: e.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: e.colorBorder,
          backgroundColor: e.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: e.itemActiveBgDisabled
          },
          a: {
            color: e.itemActiveColorDisabled
          }
        }
      },
      [`${t}-item-link`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${t}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${t}-simple-pager`]: {
        color: e.colorTextDisabled
      },
      [`${t}-jump-prev, ${t}-jump-next`]: {
        [`${t}-item-link-icon`]: {
          opacity: 0
        },
        [`${t}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${t}-simple`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&${t}-disabled ${t}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, qA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-mini ${t}-total-text, &${t}-mini ${t}-simple-pager`]: {
      height: e.itemSizeSM,
      lineHeight: q(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-item`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: q(e.calc(e.itemSizeSM).sub(2).equal())
    },
    [`&${t}-mini:not(${t}-disabled) ${t}-item:not(${t}-item-active)`]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&:hover": {
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    },
    [`&${t}-mini ${t}-prev, &${t}-mini ${t}-next`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: q(e.itemSizeSM)
    },
    [`&${t}-mini:not(${t}-disabled)`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&:hover ${t}-item-link`]: {
          backgroundColor: e.colorBgTextHover
        },
        [`&:active ${t}-item-link`]: {
          backgroundColor: e.colorBgTextActive
        },
        [`&${t}-disabled:hover ${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${t}-mini ${t}-prev ${t}-item-link,
    &${t}-mini ${t}-next ${t}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: e.itemSizeSM,
        lineHeight: q(e.itemSizeSM)
      }
    },
    [`&${t}-mini ${t}-jump-prev, &${t}-mini ${t}-jump-next`]: {
      height: e.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: q(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-options`]: {
      marginInlineStart: e.paginationMiniOptionsMarginInlineStart,
      ["&-size-changer"]: {
        top: e.miniOptionsSizeChangerTop
      },
      ["&-quick-jumper"]: {
        height: e.itemSizeSM,
        lineHeight: q(e.itemSizeSM),
        input: Object.assign(Object.assign({}, gm(e)), {
          width: e.paginationMiniQuickJumperInputWidth,
          height: e.controlHeightSM
        })
      }
    }
  };
}, GA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`
    &${t}-simple ${t}-prev,
    &${t}-simple ${t}-next
    `]: {
      height: e.itemSizeSM,
      lineHeight: q(e.itemSizeSM),
      verticalAlign: "top",
      [`${t}-item-link`]: {
        height: e.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        },
        "&::after": {
          height: e.itemSizeSM,
          lineHeight: q(e.itemSizeSM)
        }
      }
    },
    [`&${t}-simple ${t}-simple-pager`]: {
      display: "inline-block",
      height: e.itemSizeSM,
      marginInlineEnd: e.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        marginInlineEnd: e.marginXS,
        padding: `0 ${q(e.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: e.itemInputBg,
        border: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `border-color ${e.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: e.colorPrimary
        },
        "&:focus": {
          borderColor: e.colorPrimaryHover,
          boxShadow: `${q(e.inputOutlineOffset)} 0 ${q(e.controlOutlineWidth)} ${e.controlOutline}`
        },
        "&[disabled]": {
          color: e.colorTextDisabled,
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, UA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-jump-prev, ${t}-jump-next`]: {
      outline: 0,
      [`${t}-item-container`]: {
        position: "relative",
        [`${t}-item-link-icon`]: {
          color: e.colorPrimary,
          fontSize: e.fontSizeSM,
          opacity: 0,
          transition: `all ${e.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${t}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: e.colorTextDisabled,
          fontFamily: "Arial, Helvetica, sans-serif",
          letterSpacing: e.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: e.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${e.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${t}-prev,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      marginInlineEnd: e.marginXS
    },
    [`
    ${t}-prev,
    ${t}-next,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      color: e.colorText,
      fontFamily: e.fontFamily,
      lineHeight: `${q(e.itemSize)}`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: e.borderRadius,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`
    },
    [`${t}-prev, ${t}-next`]: {
      fontFamily: "Arial, Helvetica, sans-serif",
      outline: 0,
      button: {
        color: e.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${t}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: e.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${q(e.lineWidth)} ${e.lineType} transparent`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `all ${e.motionDurationMid}`
      },
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover`]: {
        [`${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${t}-slash`]: {
      marginInlineEnd: e.paginationSlashMarginInlineEnd,
      marginInlineStart: e.paginationSlashMarginInlineStart
    },
    [`${t}-options`]: {
      display: "inline-block",
      marginInlineStart: e.margin,
      verticalAlign: "middle",
      "&-size-changer.-select": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: e.controlHeight,
        marginInlineStart: e.marginXS,
        lineHeight: q(e.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, pm(e)), vm(e, {
          borderColor: e.colorBorder,
          hoverBorderColor: e.colorPrimaryHover,
          activeBorderColor: e.colorPrimary,
          activeShadow: e.activeShadow
        })), {
          "&[disabled]": Object.assign({}, sc(e)),
          width: e.calc(e.controlHeightLG).mul(1.25).equal(),
          height: e.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: e.marginXS,
          marginInlineEnd: e.marginXS
        })
      }
    }
  };
}, YA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-item`]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      marginInlineEnd: e.marginXS,
      fontFamily: e.fontFamily,
      lineHeight: q(e.calc(e.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: "transparent",
      border: `${q(e.lineWidth)} ${e.lineType} transparent`,
      borderRadius: e.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${q(e.paginationItemPaddingInline)}`,
        color: e.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${t}-item-active)`]: {
        "&:hover": {
          transition: `all ${e.motionDurationMid}`,
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: e.fontWeightStrong,
        backgroundColor: e.itemActiveBg,
        borderColor: e.colorPrimary,
        a: {
          color: e.colorPrimary
        },
        "&:hover": {
          borderColor: e.colorPrimaryHover
        },
        "&:hover a": {
          color: e.colorPrimaryHover
        }
      }
    }
  };
}, XA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Gt(e)), {
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${t}-total-text`]: {
        display: "inline-block",
        height: e.itemSize,
        marginInlineEnd: e.marginXS,
        lineHeight: q(e.calc(e.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), YA(e)), UA(e)), GA(e)), qA(e)), KA(e)), {
      // media query style
      [`@media only screen and (max-width: ${e.screenLG}px)`]: {
        [`${t}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${e.screenSM}px)`]: {
        [`${t}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${e.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, QA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}:not(${t}-disabled)`]: {
      [`${t}-item`]: Object.assign({}, lo(e)),
      [`${t}-jump-prev, ${t}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${t}-item-link-icon`]: {
            opacity: 1
          },
          [`${t}-item-ellipsis`]: {
            opacity: 0
          }
        }, io(e))
      },
      [`${t}-prev, ${t}-next`]: {
        [`&:focus-visible ${t}-item-link`]: Object.assign({}, io(e))
      }
    }
  };
}, Vx = (e) => Object.assign({
  itemBg: e.colorBgContainer,
  itemSize: e.controlHeight,
  itemSizeSM: e.controlHeightSM,
  itemActiveBg: e.colorBgContainer,
  itemLinkBg: e.colorBgContainer,
  itemActiveColorDisabled: e.colorTextDisabled,
  itemActiveBgDisabled: e.controlItemBgActiveDisabled,
  itemInputBg: e.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, mm(e)), Wx = (e) => Dt(e, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: e.calc(e.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: e.calc(e.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: e.calc(e.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: e.calc(e.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: e.marginXXS,
  paginationSlashMarginInlineEnd: e.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, fm(e)), JA = Xt("Pagination", (e) => {
  const t = Wx(e);
  return [XA(t), QA(t)];
}, Vx), ZA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}${t}-bordered${t}-disabled:not(${t}-mini)`]: {
      "&, &:hover": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      "&:focus-visible": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      [`${t}-item, ${t}-item-link`]: {
        backgroundColor: e.colorBgContainerDisabled,
        borderColor: e.colorBorder,
        [`&:hover:not(${t}-item-active)`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          a: {
            color: e.colorTextDisabled
          }
        },
        [`&${t}-item-active`]: {
          backgroundColor: e.itemActiveBgDisabled
        }
      },
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          color: e.colorTextDisabled
        },
        [`${t}-item-link`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder
        }
      }
    },
    [`${t}${t}-bordered:not(${t}-mini)`]: {
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          borderColor: e.colorPrimaryHover,
          backgroundColor: e.itemBg
        },
        [`${t}-item-link`]: {
          backgroundColor: e.itemLinkBg,
          borderColor: e.colorBorder
        },
        [`&:hover ${t}-item-link`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          color: e.colorPrimary
        },
        [`&${t}-disabled`]: {
          [`${t}-item-link`]: {
            borderColor: e.colorBorder,
            color: e.colorTextDisabled
          }
        }
      },
      [`${t}-item`]: {
        backgroundColor: e.itemBg,
        border: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        [`&:hover:not(${t}-item-active)`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          a: {
            color: e.colorPrimary
          }
        },
        "&-active": {
          borderColor: e.colorPrimary
        }
      }
    }
  };
}, eB = zo(["Pagination", "bordered"], (e) => {
  const t = Wx(e);
  return [ZA(t)];
}, Vx);
var tB = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Kx = (e) => {
  const {
    prefixCls: t,
    selectPrefixCls: n,
    className: r,
    rootClassName: o,
    style: a,
    size: i,
    locale: l,
    selectComponentClass: c,
    responsive: u,
    showSizeChanger: d
  } = e, f = tB(e, ["prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"]), {
    xs: m
  } = Yy(u), [, v] = Sn(), {
    getPrefixCls: h,
    direction: p,
    pagination: g = {}
  } = s.useContext(lt), b = h("pagination", t), [y, C, S] = JA(b), $ = d ?? g.showSizeChanger, x = s.useMemo(() => {
    const P = /* @__PURE__ */ s.createElement("span", {
      className: `${b}-item-ellipsis`
    }, "•••"), _ = /* @__PURE__ */ s.createElement("button", {
      className: `${b}-item-link`,
      type: "button",
      tabIndex: -1
    }, p === "rtl" ? /* @__PURE__ */ s.createElement($a, null) : /* @__PURE__ */ s.createElement(vs, null)), D = /* @__PURE__ */ s.createElement("button", {
      className: `${b}-item-link`,
      type: "button",
      tabIndex: -1
    }, p === "rtl" ? /* @__PURE__ */ s.createElement(vs, null) : /* @__PURE__ */ s.createElement($a, null)), R = /* @__PURE__ */ s.createElement("a", {
      className: `${b}-item-link`
    }, /* @__PURE__ */ s.createElement("div", {
      className: `${b}-item-container`
    }, p === "rtl" ? /* @__PURE__ */ s.createElement(Tp, {
      className: `${b}-item-link-icon`
    }) : /* @__PURE__ */ s.createElement(Mp, {
      className: `${b}-item-link-icon`
    }), P)), T = /* @__PURE__ */ s.createElement("a", {
      className: `${b}-item-link`
    }, /* @__PURE__ */ s.createElement("div", {
      className: `${b}-item-container`
    }, p === "rtl" ? /* @__PURE__ */ s.createElement(Mp, {
      className: `${b}-item-link-icon`
    }) : /* @__PURE__ */ s.createElement(Tp, {
      className: `${b}-item-link-icon`
    }), P));
    return {
      prevIcon: _,
      nextIcon: D,
      jumpPrevIcon: R,
      jumpNextIcon: T
    };
  }, [p, b]), [w] = ur("Pagination", bb), N = Object.assign(Object.assign({}, w), l), O = qn(i), E = O === "small" || !!(m && !O && u), I = h("select", n), k = J({
    [`${b}-mini`]: E,
    [`${b}-rtl`]: p === "rtl",
    [`${b}-bordered`]: v.wireframe
  }, g == null ? void 0 : g.className, r, o, C, S), M = Object.assign(Object.assign({}, g == null ? void 0 : g.style), a);
  return y(/* @__PURE__ */ s.createElement(s.Fragment, null, v.wireframe && /* @__PURE__ */ s.createElement(eB, {
    prefixCls: b
  }), /* @__PURE__ */ s.createElement(Ax, Object.assign({}, x, f, {
    style: M,
    prefixCls: b,
    selectPrefixCls: I,
    className: k,
    selectComponentClass: c || (E ? Bx : Hx),
    locale: N,
    showSizeChanger: $
  }))));
};
process.env.NODE_ENV !== "production" && (Kx.displayName = "Pagination");
const nB = Kx, rB = new kt("antSpinMove", {
  to: {
    opacity: 1
  }
}), oB = new kt("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), aB = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({}, Gt(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "static",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: n(n(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [`${t}-dot ${t}-dot-item`]: {
          backgroundColor: e.colorWhite
        },
        [`${t}-text`]: {
          color: e.colorTextLightSolid
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: n(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: n(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          ["&::after"]: {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      ["&-tip"]: {
        color: e.spinDotDefault
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          height: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          backgroundColor: e.colorPrimary,
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: rB,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: oB,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        fontSize: e.dotSizeSM,
        i: {
          width: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal(),
          height: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        fontSize: e.dotSizeLG,
        i: {
          width: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, iB = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: n
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: n
  };
}, lB = Xt("Spin", (e) => {
  const t = Dt(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [aB(t)];
}, iB);
var sB = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let Yl = null;
function cB(e, t) {
  const {
    indicator: n
  } = t, r = `${e}-dot`;
  return n === null ? null : Kn(n) ? xn(n, {
    className: J(n.props.className, r)
  }) : Kn(Yl) ? xn(Yl, {
    className: J(Yl.props.className, r)
  }) : /* @__PURE__ */ s.createElement("span", {
    className: J(r, `${e}-dot-spin`)
  }, /* @__PURE__ */ s.createElement("i", {
    className: `${e}-dot-item`,
    key: 1
  }), /* @__PURE__ */ s.createElement("i", {
    className: `${e}-dot-item`,
    key: 2
  }), /* @__PURE__ */ s.createElement("i", {
    className: `${e}-dot-item`,
    key: 3
  }), /* @__PURE__ */ s.createElement("i", {
    className: `${e}-dot-item`,
    key: 4
  }));
}
function uB(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const Im = (e) => {
  const {
    prefixCls: t,
    spinning: n = !0,
    delay: r = 0,
    className: o,
    rootClassName: a,
    size: i = "default",
    tip: l,
    wrapperClassName: c,
    style: u,
    children: d,
    fullscreen: f = !1
  } = e, m = sB(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen"]), {
    getPrefixCls: v
  } = s.useContext(lt), h = v("spin", t), [p, g, b] = lB(h), [y, C] = s.useState(() => n && !uB(n, r));
  s.useEffect(() => {
    if (n) {
      const k = AF(r, () => {
        C(!0);
      });
      return k(), () => {
        var M;
        (M = k == null ? void 0 : k.cancel) === null || M === void 0 || M.call(k);
      };
    }
    C(!1);
  }, [r, n]);
  const S = s.useMemo(() => typeof d < "u" && !f, [d, f]);
  if (process.env.NODE_ENV !== "production") {
    const k = Rt("Spin");
    process.env.NODE_ENV !== "production" && k(!l || S || f, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const {
    direction: $,
    spin: x
  } = s.useContext(lt), w = J(h, x == null ? void 0 : x.className, {
    [`${h}-sm`]: i === "small",
    [`${h}-lg`]: i === "large",
    [`${h}-spinning`]: y,
    [`${h}-show-text`]: !!l,
    [`${h}-fullscreen`]: f,
    [`${h}-fullscreen-show`]: f && y,
    [`${h}-rtl`]: $ === "rtl"
  }, o, a, g, b), N = J(`${h}-container`, {
    [`${h}-blur`]: y
  }), O = an(m, ["indicator"]), E = Object.assign(Object.assign({}, x == null ? void 0 : x.style), u), I = /* @__PURE__ */ s.createElement("div", Object.assign({}, O, {
    style: E,
    className: w,
    "aria-live": "polite",
    "aria-busy": y
  }), cB(h, e), l && (S || f) ? /* @__PURE__ */ s.createElement("div", {
    className: `${h}-text`
  }, l) : null);
  return p(S ? /* @__PURE__ */ s.createElement("div", Object.assign({}, O, {
    className: J(`${h}-nested-loading`, c, g, b)
  }), y && /* @__PURE__ */ s.createElement("div", {
    key: "loading"
  }, I), /* @__PURE__ */ s.createElement("div", {
    className: N,
    key: "container"
  }, d)) : I);
};
Im.setDefaultIndicator = (e) => {
  Yl = e;
};
process.env.NODE_ENV !== "production" && (Im.displayName = "Spin");
const qx = Im;
var dB = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const fB = (e) => {
  const {
    prefixCls: t,
    className: n,
    closeIcon: r,
    closable: o,
    type: a,
    title: i,
    children: l,
    footer: c
  } = e, u = dB(e, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]), {
    getPrefixCls: d
  } = s.useContext(lt), f = d(), m = t || d("modal"), v = En(f), [h, p, g] = Z0(m, v), b = `${m}-confirm`;
  let y = {};
  return a ? y = {
    closable: o ?? !1,
    title: "",
    footer: "",
    children: /* @__PURE__ */ s.createElement(ty, Object.assign({}, e, {
      prefixCls: m,
      confirmPrefixCls: b,
      rootPrefixCls: f,
      content: l
    }))
  } : y = {
    closable: o ?? !0,
    title: i,
    footer: c !== null && /* @__PURE__ */ s.createElement(Y0, Object.assign({}, e)),
    children: l
  }, h(/* @__PURE__ */ s.createElement(Of, Object.assign({
    prefixCls: m,
    className: J(p, `${m}-pure-panel`, a && b, a && `${b}-${a}`, n, g, v)
  }, u, {
    closeIcon: U0(m, r),
    closable: o
  }, y)));
}, mB = py(fB);
function Gx(e) {
  return Gi(ay(e));
}
const fr = ey;
fr.useModal = $2;
fr.info = function(t) {
  return Gi(iy(t));
};
fr.success = function(t) {
  return Gi(ly(t));
};
fr.error = function(t) {
  return Gi(sy(t));
};
fr.warning = Gx;
fr.warn = Gx;
fr.confirm = function(t) {
  return Gi(cy(t));
};
fr.destroyAll = function() {
  for (; No.length; ) {
    const t = No.pop();
    t && t();
  }
};
fr.config = b2;
fr._InternalPanelDoNotUseOrYouWillBeFired = mB;
process.env.NODE_ENV !== "production" && (fr.displayName = "Modal");
const vB = fr;
let hr = null, Xl = (e) => e(), xs = [], _i = {};
function Dp() {
  const {
    getContainer: e,
    rtl: t,
    maxCount: n,
    top: r,
    bottom: o
  } = _i, a = (e == null ? void 0 : e()) || document.body;
  return {
    getContainer: () => a,
    rtl: t,
    maxCount: n,
    top: r,
    bottom: o
  };
}
const gB = /* @__PURE__ */ le.forwardRef((e, t) => {
  const {
    notificationConfig: n,
    sync: r
  } = e, {
    getPrefixCls: o
  } = qt(lt), a = _i.prefixCls || o("notification"), i = qt(U2), [l, c] = gy(Object.assign(Object.assign(Object.assign({}, n), {
    prefixCls: a
  }), i.notification));
  return le.useEffect(r, []), le.useImperativeHandle(t, () => {
    const u = Object.assign({}, l);
    return Object.keys(u).forEach((d) => {
      u[d] = function() {
        return r(), l[d].apply(l, arguments);
      };
    }), {
      instance: u,
      sync: r
    };
  }), c;
}), pB = /* @__PURE__ */ le.forwardRef((e, t) => {
  const [n, r] = le.useState(Dp), o = () => {
    r(Dp);
  };
  le.useEffect(o, []);
  const a = bf(), i = a.getRootPrefixCls(), l = a.getIconPrefixCls(), c = a.getTheme(), u = /* @__PURE__ */ le.createElement(gB, {
    ref: t,
    sync: o,
    notificationConfig: n
  });
  return /* @__PURE__ */ le.createElement($t, {
    prefixCls: i,
    iconPrefixCls: l,
    theme: c
  }, a.holderRender ? a.holderRender(u) : u);
});
function Pm() {
  if (!hr) {
    const e = document.createDocumentFragment(), t = {
      fragment: e
    };
    hr = t, Xl(() => {
      Sf(/* @__PURE__ */ le.createElement(pB, {
        ref: (n) => {
          const {
            instance: r,
            sync: o
          } = n || {};
          Promise.resolve().then(() => {
            !t.instance && r && (t.instance = r, t.sync = o, Pm());
          });
        }
      }), e);
    });
    return;
  }
  hr.instance && (xs.forEach((e) => {
    switch (e.type) {
      case "open": {
        Xl(() => {
          hr.instance.open(Object.assign(Object.assign({}, _i), e.config));
        });
        break;
      }
      case "destroy":
        Xl(() => {
          hr == null || hr.instance.destroy(e.key);
        });
        break;
    }
  }), xs = []);
}
function hB(e) {
  _i = Object.assign(Object.assign({}, _i), e), Xl(() => {
    var t;
    (t = hr == null ? void 0 : hr.sync) === null || t === void 0 || t.call(hr);
  });
}
function Ux(e) {
  const t = bf();
  process.env.NODE_ENV !== "production" && !t.holderRender && Jb("notification"), xs.push({
    type: "open",
    config: e
  }), Pm();
}
function bB(e) {
  xs.push({
    type: "destroy",
    key: e
  }), Pm();
}
const yB = ["success", "info", "warning", "error"], CB = {
  open: Ux,
  destroy: bB,
  config: hB,
  useNotification: G2,
  _InternalPanelDoNotUseOrYouWillBeFired: j2
}, Yx = CB;
yB.forEach((e) => {
  Yx[e] = (t) => Ux(Object.assign(Object.assign({}, t), {
    type: e
  }));
});
process.env.NODE_ENV;
process.env.NODE_ENV;
const SB = Yx, xB = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    antCls: r,
    zIndexPopup: o,
    colorText: a,
    colorWarning: i,
    marginXXS: l,
    marginXS: c,
    fontSize: u,
    fontWeightStrong: d,
    colorTextHeading: f
  } = e;
  return {
    [t]: {
      zIndex: o,
      [`&${r}-popover`]: {
        fontSize: u
      },
      [`${t}-message`]: {
        marginBottom: c,
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${t}-message-icon ${n}`]: {
          color: i,
          fontSize: u,
          lineHeight: 1,
          marginInlineEnd: c
        },
        [`${t}-title`]: {
          fontWeight: d,
          color: f,
          "&:only-child": {
            fontWeight: "normal"
          }
        },
        [`${t}-description`]: {
          marginTop: l,
          color: a
        }
      },
      [`${t}-buttons`]: {
        textAlign: "end",
        whiteSpace: "nowrap",
        button: {
          marginInlineStart: c
        }
      }
    }
  };
}, $B = (e) => {
  const {
    zIndexPopupBase: t
  } = e;
  return {
    zIndexPopup: t + 60
  };
}, Xx = Xt("Popconfirm", (e) => xB(e), $B, {
  resetStyle: !1
});
var wB = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Qx = (e) => {
  const {
    prefixCls: t,
    okButtonProps: n,
    cancelButtonProps: r,
    title: o,
    description: a,
    cancelText: i,
    okText: l,
    okType: c = "primary",
    icon: u = /* @__PURE__ */ s.createElement(Fi, null),
    showCancel: d = !0,
    close: f,
    onConfirm: m,
    onCancel: v,
    onPopupClick: h
  } = e, {
    getPrefixCls: p
  } = s.useContext(lt), [g] = ur("Popconfirm", xr.Popconfirm), b = xa(o), y = xa(a);
  return /* @__PURE__ */ s.createElement("div", {
    className: `${t}-inner-content`,
    onClick: h
  }, /* @__PURE__ */ s.createElement("div", {
    className: `${t}-message`
  }, u && /* @__PURE__ */ s.createElement("span", {
    className: `${t}-message-icon`
  }, u), /* @__PURE__ */ s.createElement("div", {
    className: `${t}-message-text`
  }, b && /* @__PURE__ */ s.createElement("div", {
    className: J(`${t}-title`)
  }, b), y && /* @__PURE__ */ s.createElement("div", {
    className: `${t}-description`
  }, y))), /* @__PURE__ */ s.createElement("div", {
    className: `${t}-buttons`
  }, d && /* @__PURE__ */ s.createElement(or, Object.assign({
    onClick: v,
    size: "small"
  }, r), i || (g == null ? void 0 : g.cancelText)), /* @__PURE__ */ s.createElement(Ef, {
    buttonProps: Object.assign(Object.assign({
      size: "small"
    }, xf(c)), n),
    actionFn: m,
    close: f,
    prefixCls: p("btn"),
    quitOnNullishReturnValue: !0,
    emitEvent: !0
  }, l || (g == null ? void 0 : g.okText))));
}, EB = (e) => {
  const {
    prefixCls: t,
    placement: n,
    className: r,
    style: o
  } = e, a = wB(e, ["prefixCls", "placement", "className", "style"]), {
    getPrefixCls: i
  } = s.useContext(lt), l = i("popconfirm", t), [c] = Xx(l);
  return c(/* @__PURE__ */ s.createElement(rC, {
    placement: n,
    className: J(l, r),
    style: o,
    content: /* @__PURE__ */ s.createElement(Qx, Object.assign({
      prefixCls: l
    }, a))
  }));
}, OB = EB;
var NB = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Rm = /* @__PURE__ */ s.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: o,
    placement: a = "top",
    trigger: i = "click",
    okType: l = "primary",
    icon: c = /* @__PURE__ */ s.createElement(Fi, null),
    children: u,
    overlayClassName: d,
    onOpenChange: f,
    onVisibleChange: m
  } = e, v = NB(e, ["prefixCls", "placement", "trigger", "okType", "icon", "children", "overlayClassName", "onOpenChange", "onVisibleChange"]), {
    getPrefixCls: h
  } = s.useContext(lt), [p, g] = Vt(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), b = (E, I) => {
    g(E, !0), m == null || m(E), f == null || f(E, I);
  }, y = (E) => {
    b(!1, E);
  }, C = (E) => {
    var I;
    return (I = e.onConfirm) === null || I === void 0 ? void 0 : I.call(globalThis, E);
  }, S = (E) => {
    var I;
    b(!1, E), (I = e.onCancel) === null || I === void 0 || I.call(globalThis, E);
  }, $ = (E) => {
    E.keyCode === Oe.ESC && p && b(!1, E);
  }, x = (E) => {
    const {
      disabled: I = !1
    } = e;
    I || b(E);
  }, w = h("popconfirm", o), N = J(w, d), [O] = Xx(w);
  return O(/* @__PURE__ */ s.createElement(oC, Object.assign({}, an(v, ["title"]), {
    trigger: i,
    placement: a,
    onOpenChange: x,
    open: p,
    ref: t,
    overlayClassName: N,
    content: /* @__PURE__ */ s.createElement(Qx, Object.assign({
      okType: l,
      icon: c
    }, e, {
      prefixCls: w,
      close: y,
      onConfirm: C,
      onCancel: S
    })),
    "data-popover-inject": !0
  }), xn(u, {
    onKeyDown: (E) => {
      var I, k;
      /* @__PURE__ */ s.isValidElement(u) && ((k = u == null ? void 0 : (I = u.props).onKeyDown) === null || k === void 0 || k.call(I, E)), $(E);
    }
  })));
});
Rm._InternalPanelDoNotUseOrYouWillBeFired = OB;
process.env.NODE_ENV !== "production" && (Rm.displayName = "Popconfirm");
const IB = Rm;
var PB = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
}, RB = function() {
  var t = Xe([]), n = Xe(null);
  return Bt(function() {
    var r = Date.now(), o = !1;
    t.current.forEach(function(a) {
      if (a) {
        o = !0;
        var i = a.style;
        i.transitionDuration = ".3s, .3s, .3s, .06s", n.current && r - n.current < 100 && (i.transitionDuration = "0s, 0s");
      }
    }), o && (n.current = Date.now());
  }), t.current;
};
process.env.NODE_ENV;
var kp = 0, MB = process.env.NODE_ENV !== "test" && pn();
function TB() {
  var e;
  return MB ? (e = kp, kp += 1) : e = "TEST_OR_SSR", e;
}
const _B = function(e) {
  var t = s.useState(), n = Q(t, 2), r = n[0], o = n[1];
  return s.useEffect(function() {
    o("rc_progress_".concat(TB()));
  }, []), e || r;
};
var Lp = function(t) {
  var n = t.bg, r = t.children;
  return /* @__PURE__ */ s.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      background: n
    }
  }, r);
};
function Fp(e, t) {
  return Object.keys(e).map(function(n) {
    var r = parseFloat(n), o = "".concat(Math.floor(r * t), "%");
    return "".concat(e[n], " ").concat(o);
  });
}
var Jx = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.color, o = e.gradientId, a = e.radius, i = e.style, l = e.ptg, c = e.strokeLinecap, u = e.strokeWidth, d = e.size, f = e.gapDegree, m = r && mt(r) === "object", v = m ? "#FFF" : void 0, h = d / 2, p = /* @__PURE__ */ s.createElement("circle", {
    className: "".concat(n, "-circle-path"),
    r: a,
    cx: h,
    cy: h,
    stroke: v,
    strokeLinecap: c,
    strokeWidth: u,
    opacity: l === 0 ? 0 : 1,
    style: i,
    ref: t
  });
  if (!m)
    return p;
  var g = "".concat(o, "-conic"), b = f ? "".concat(180 + f / 2, "deg") : "0deg", y = Fp(r, (360 - f) / 360), C = Fp(r, 1), S = "conic-gradient(from ".concat(b, ", ").concat(y.join(", "), ")"), $ = "linear-gradient(to ".concat(f ? "bottom" : "top", ", ").concat(C.join(", "), ")");
  return /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement("mask", {
    id: g
  }, p), /* @__PURE__ */ s.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: d,
    height: d,
    mask: "url(#".concat(g, ")")
  }, /* @__PURE__ */ s.createElement(Lp, {
    bg: $
  }, /* @__PURE__ */ s.createElement(Lp, {
    bg: S
  }))));
});
process.env.NODE_ENV !== "production" && (Jx.displayName = "PtgCircle");
var oi = 100, uu = function(t, n, r, o, a, i, l, c, u, d) {
  var f = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0, m = r / 100 * 360 * ((360 - i) / 360), v = i === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[l], h = (100 - o) / 100 * n;
  u === "round" && o !== 100 && (h += d / 2, h >= n && (h = n - 0.01));
  var p = oi / 2;
  return {
    stroke: typeof c == "string" ? c : void 0,
    strokeDasharray: "".concat(n, "px ").concat(t),
    strokeDashoffset: h + f,
    transform: "rotate(".concat(a + m + v, "deg)"),
    transformOrigin: "".concat(p, "px ").concat(p, "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
}, DB = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function jp(e) {
  var t = e ?? [];
  return Array.isArray(t) ? t : [t];
}
var Zx = function(t) {
  var n = V(V({}, PB), t), r = n.id, o = n.prefixCls, a = n.steps, i = n.strokeWidth, l = n.trailWidth, c = n.gapDegree, u = c === void 0 ? 0 : c, d = n.gapPosition, f = n.trailColor, m = n.strokeLinecap, v = n.style, h = n.className, p = n.strokeColor, g = n.percent, b = vt(n, DB), y = oi / 2, C = _B(r), S = "".concat(C, "-gradient"), $ = y - i / 2, x = Math.PI * 2 * $, w = u > 0 ? 90 + u / 2 : -90, N = x * ((360 - u) / 360), O = mt(a) === "object" ? a : {
    count: a,
    space: 2
  }, E = O.count, I = O.space, k = jp(g), M = jp(p), P = M.find(function(j) {
    return j && mt(j) === "object";
  }), _ = P && mt(P) === "object", D = _ ? "butt" : m, R = uu(x, N, 0, 100, w, u, d, f, D, i), T = RB(), L = function() {
    var A = 0;
    return k.map(function(B, K) {
      var Y = M[K] || M[M.length - 1], G = uu(x, N, A, B, w, u, d, Y, D, i);
      return A += B, /* @__PURE__ */ s.createElement(Jx, {
        key: K,
        color: Y,
        ptg: B,
        radius: $,
        prefixCls: o,
        gradientId: S,
        style: G,
        strokeLinecap: D,
        strokeWidth: i,
        gapDegree: u,
        ref: function(ee) {
          T[K] = ee;
        },
        size: oi
      });
    }).reverse();
  }, F = function() {
    var A = Math.round(E * (k[0] / 100)), B = 100 / E, K = 0;
    return new Array(E).fill(null).map(function(Y, G) {
      var te = G <= A - 1 ? M[0] : f, ee = te && mt(te) === "object" ? "url(#".concat(S, ")") : void 0, oe = uu(x, N, K, B, w, u, d, te, "butt", i, I);
      return K += (N - oe.strokeDashoffset + I) * 100 / N, /* @__PURE__ */ s.createElement("circle", {
        key: G,
        className: "".concat(o, "-circle-path"),
        r: $,
        cx: y,
        cy: y,
        stroke: ee,
        strokeWidth: i,
        opacity: 1,
        style: oe,
        ref: function(W) {
          T[G] = W;
        }
      });
    });
  };
  return /* @__PURE__ */ s.createElement("svg", fe({
    className: J("".concat(o, "-circle"), h),
    viewBox: "0 0 ".concat(oi, " ").concat(oi),
    style: v,
    id: r,
    role: "presentation"
  }, b), !E && /* @__PURE__ */ s.createElement("circle", {
    className: "".concat(o, "-circle-trail"),
    r: $,
    cx: y,
    cy: y,
    stroke: f,
    strokeLinecap: D,
    strokeWidth: l || i,
    style: R
  }), E ? F() : L());
};
process.env.NODE_ENV !== "production" && (Zx.displayName = "Circle");
function ro(e) {
  return !e || e < 0 ? 0 : e > 100 ? 100 : e;
}
function $s(e) {
  let {
    success: t,
    successPercent: n
  } = e, r = n;
  return t && "progress" in t && (r = t.progress), t && "percent" in t && (r = t.percent), r;
}
const kB = (e) => {
  let {
    percent: t,
    success: n,
    successPercent: r
  } = e;
  const o = ro($s({
    success: n,
    successPercent: r
  }));
  return [o, ro(ro(t) - o)];
}, LB = (e) => {
  let {
    success: t = {},
    strokeColor: n
  } = e;
  const {
    strokeColor: r
  } = t;
  return [r || fa.green, n || null];
}, fc = (e, t, n) => {
  var r, o, a, i;
  let l = -1, c = -1;
  if (t === "step") {
    const u = n.steps, d = n.strokeWidth;
    typeof e == "string" || typeof e > "u" ? (l = e === "small" ? 2 : 14, c = d ?? 8) : typeof e == "number" ? [l, c] = [e, e] : [l = 14, c = 8] = e, l *= u;
  } else if (t === "line") {
    const u = n == null ? void 0 : n.strokeWidth;
    typeof e == "string" || typeof e > "u" ? c = u || (e === "small" ? 6 : 8) : typeof e == "number" ? [l, c] = [e, e] : [l = -1, c = 8] = e;
  } else
    (t === "circle" || t === "dashboard") && (typeof e == "string" || typeof e > "u" ? [l, c] = e === "small" ? [60, 60] : [120, 120] : typeof e == "number" ? [l, c] = [e, e] : (l = (o = (r = e[0]) !== null && r !== void 0 ? r : e[1]) !== null && o !== void 0 ? o : 120, c = (i = (a = e[0]) !== null && a !== void 0 ? a : e[1]) !== null && i !== void 0 ? i : 120));
  return [l, c];
}, FB = 3, jB = (e) => FB / e * 100, zB = (e) => {
  const {
    prefixCls: t,
    trailColor: n = null,
    strokeLinecap: r = "round",
    gapPosition: o,
    gapDegree: a,
    width: i = 120,
    type: l,
    children: c,
    success: u,
    size: d = i
  } = e, [f, m] = fc(d, "circle");
  let {
    strokeWidth: v
  } = e;
  v === void 0 && (v = Math.max(jB(f), 6));
  const h = {
    width: f,
    height: m,
    fontSize: f * 0.15 + 6
  }, p = s.useMemo(() => {
    if (a || a === 0)
      return a;
    if (l === "dashboard")
      return 75;
  }, [a, l]), g = o || l === "dashboard" && "bottom" || void 0, b = Object.prototype.toString.call(e.strokeColor) === "[object Object]", y = LB({
    success: u,
    strokeColor: e.strokeColor
  }), C = J(`${t}-inner`, {
    [`${t}-circle-gradient`]: b
  }), S = /* @__PURE__ */ s.createElement(Zx, {
    percent: kB(e),
    strokeWidth: v,
    trailWidth: v,
    strokeColor: y,
    strokeLinecap: r,
    trailColor: n,
    prefixCls: t,
    gapDegree: p,
    gapPosition: g
  });
  return /* @__PURE__ */ s.createElement("div", {
    className: C,
    style: h
  }, f <= 20 ? /* @__PURE__ */ s.createElement(Mr, {
    title: c
  }, /* @__PURE__ */ s.createElement("span", null, S)) : /* @__PURE__ */ s.createElement(s.Fragment, null, S, c));
}, AB = zB, ws = "--progress-line-stroke-color", e$ = "--progress-percent", zp = (e) => {
  const t = e ? "100%" : "-100%";
  return new kt(`antProgress${e ? "RTL" : "LTR"}Active`, {
    "0%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.1
    },
    "20%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: "translateX(0) scaleX(1)",
      opacity: 0
    }
  });
}, BB = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Gt(e)), {
      display: "inline-block",
      "&-rtl": {
        direction: "rtl"
      },
      "&-line": {
        position: "relative",
        width: "100%",
        fontSize: e.fontSize,
        marginInlineEnd: e.marginXS,
        marginBottom: e.marginXS
      },
      [`${t}-outer`]: {
        display: "inline-block",
        width: "100%"
      },
      [`&${t}-show-info`]: {
        [`${t}-outer`]: {
          marginInlineEnd: `calc(-2em - ${q(e.marginXS)})`,
          paddingInlineEnd: `calc(2em + ${q(e.paddingXS)})`
        }
      },
      [`${t}-inner`]: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        overflow: "hidden",
        verticalAlign: "middle",
        backgroundColor: e.remainingColor,
        borderRadius: e.lineBorderRadius
      },
      [`${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.defaultColor
        }
      },
      [`${t}-success-bg, ${t}-bg`]: {
        position: "relative",
        background: e.defaultColor,
        borderRadius: e.lineBorderRadius,
        transition: `all ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`
      },
      [`${t}-bg`]: {
        overflow: "hidden",
        "&::after": {
          content: '""',
          background: {
            _multi_value_: !0,
            value: ["inherit", `var(${ws})`]
          },
          height: "100%",
          width: `calc(1 / var(${e$}) * 100%)`,
          display: "block"
        }
      },
      [`${t}-success-bg`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: e.colorSuccess
      },
      [`${t}-text`]: {
        display: "inline-block",
        width: "2em",
        marginInlineStart: e.marginXS,
        color: e.colorText,
        lineHeight: 1,
        whiteSpace: "nowrap",
        textAlign: "start",
        verticalAlign: "middle",
        wordBreak: "normal",
        [n]: {
          fontSize: e.fontSize
        }
      },
      [`&${t}-status-active`]: {
        [`${t}-bg::before`]: {
          position: "absolute",
          inset: 0,
          backgroundColor: e.colorBgContainer,
          borderRadius: e.lineBorderRadius,
          opacity: 0,
          animationName: zp(),
          animationDuration: e.progressActiveMotionDuration,
          animationTimingFunction: e.motionEaseOutQuint,
          animationIterationCount: "infinite",
          content: '""'
        }
      },
      [`&${t}-rtl${t}-status-active`]: {
        [`${t}-bg::before`]: {
          animationName: zp(!0)
        }
      },
      [`&${t}-status-exception`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorError
        },
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`&${t}-status-exception ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorError
        }
      },
      [`&${t}-status-success`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorSuccess
        },
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      },
      [`&${t}-status-success ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorSuccess
        }
      }
    })
  };
}, HB = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [t]: {
      [`${t}-circle-trail`]: {
        stroke: e.remainingColor
      },
      [`&${t}-circle ${t}-inner`]: {
        position: "relative",
        lineHeight: 1,
        backgroundColor: "transparent"
      },
      [`&${t}-circle ${t}-text`]: {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineStart: 0,
        width: "100%",
        margin: 0,
        padding: 0,
        color: e.circleTextColor,
        fontSize: e.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: "normal",
        textAlign: "center",
        transform: "translateY(-50%)",
        [n]: {
          fontSize: e.circleIconFontSize
        }
      },
      [`${t}-circle&-status-exception`]: {
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`${t}-circle&-status-success`]: {
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      }
    },
    [`${t}-inline-circle`]: {
      lineHeight: 1,
      [`${t}-inner`]: {
        verticalAlign: "bottom"
      }
    }
  };
}, VB = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`${t}-steps`]: {
        display: "inline-block",
        "&-outer": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&-item": {
          flexShrink: 0,
          minWidth: e.progressStepMinWidth,
          marginInlineEnd: e.progressStepMarginInlineEnd,
          backgroundColor: e.remainingColor,
          transition: `all ${e.motionDurationSlow}`,
          "&-active": {
            backgroundColor: e.defaultColor
          }
        }
      }
    }
  };
}, WB = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [t]: {
      [`${t}-small&-line, ${t}-small&-line ${t}-text ${n}`]: {
        fontSize: e.fontSizeSM
      }
    }
  };
}, KB = (e) => ({
  circleTextColor: e.colorText,
  defaultColor: e.colorInfo,
  remainingColor: e.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: "1em",
  circleIconFontSize: `${e.fontSize / e.fontSizeSM}em`
}), qB = Xt("Progress", (e) => {
  const t = e.calc(e.marginXXS).div(2).equal(), n = Dt(e, {
    progressStepMarginInlineEnd: t,
    progressStepMinWidth: t,
    progressActiveMotionDuration: "2.4s"
  });
  return [BB(n), HB(n), VB(n), WB(n)];
}, KB);
var GB = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const UB = (e) => {
  let t = [];
  return Object.keys(e).forEach((n) => {
    const r = parseFloat(n.replace(/%/g, ""));
    isNaN(r) || t.push({
      key: r,
      value: e[n]
    });
  }), t = t.sort((n, r) => n.key - r.key), t.map((n) => {
    let {
      key: r,
      value: o
    } = n;
    return `${o} ${r}%`;
  }).join(", ");
}, YB = (e, t) => {
  const {
    from: n = fa.blue,
    to: r = fa.blue,
    direction: o = t === "rtl" ? "to left" : "to right"
  } = e, a = GB(e, ["from", "to", "direction"]);
  if (Object.keys(a).length !== 0) {
    const l = UB(a), c = `linear-gradient(${o}, ${l})`;
    return {
      background: c,
      [ws]: c
    };
  }
  const i = `linear-gradient(${o}, ${n}, ${r})`;
  return {
    background: i,
    [ws]: i
  };
}, XB = (e) => {
  const {
    prefixCls: t,
    direction: n,
    percent: r,
    size: o,
    strokeWidth: a,
    strokeColor: i,
    strokeLinecap: l = "round",
    children: c,
    trailColor: u = null,
    success: d
  } = e, f = i && typeof i != "string" ? YB(i, n) : {
    [ws]: i,
    background: i
  }, m = l === "square" || l === "butt" ? 0 : void 0, v = o ?? [-1, a || (o === "small" ? 6 : 8)], [h, p] = fc(v, "line", {
    strokeWidth: a
  });
  process.env.NODE_ENV !== "production" && Rt("Progress").deprecated(!("strokeWidth" in e), "strokeWidth", "size");
  const g = {
    backgroundColor: u || void 0,
    borderRadius: m
  }, b = Object.assign(Object.assign({
    width: `${ro(r)}%`,
    height: p,
    borderRadius: m
  }, f), {
    [e$]: ro(r) / 100
  }), y = $s(e), C = {
    width: `${ro(y)}%`,
    height: p,
    borderRadius: m,
    backgroundColor: d == null ? void 0 : d.strokeColor
  }, S = {
    width: h < 0 ? "100%" : h,
    height: p
  };
  return /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement("div", {
    className: `${t}-outer`,
    style: S
  }, /* @__PURE__ */ s.createElement("div", {
    className: `${t}-inner`,
    style: g
  }, /* @__PURE__ */ s.createElement("div", {
    className: `${t}-bg`,
    style: b
  }), y !== void 0 ? /* @__PURE__ */ s.createElement("div", {
    className: `${t}-success-bg`,
    style: C
  }) : null)), c);
}, QB = XB, JB = (e) => {
  const {
    size: t,
    steps: n,
    percent: r = 0,
    strokeWidth: o = 8,
    strokeColor: a,
    trailColor: i = null,
    prefixCls: l,
    children: c
  } = e, u = Math.round(n * (r / 100)), f = t ?? [t === "small" ? 2 : 14, o], [m, v] = fc(f, "step", {
    steps: n,
    strokeWidth: o
  }), h = m / n, p = new Array(n);
  for (let g = 0; g < n; g++) {
    const b = Array.isArray(a) ? a[g] : a;
    p[g] = /* @__PURE__ */ s.createElement("div", {
      key: g,
      className: J(`${l}-steps-item`, {
        [`${l}-steps-item-active`]: g <= u - 1
      }),
      style: {
        backgroundColor: g <= u - 1 ? b : i,
        width: h,
        height: v
      }
    });
  }
  return /* @__PURE__ */ s.createElement("div", {
    className: `${l}-steps-outer`
  }, p, c);
}, ZB = JB;
var e4 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const t4 = ["normal", "exception", "active", "success"], t$ = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: r,
    rootClassName: o,
    steps: a,
    strokeColor: i,
    percent: l = 0,
    size: c = "default",
    showInfo: u = !0,
    type: d = "line",
    status: f,
    format: m,
    style: v
  } = e, h = e4(e, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style"]), p = s.useMemo(() => {
    var M, P;
    const _ = $s(e);
    return parseInt(_ !== void 0 ? (M = _ ?? 0) === null || M === void 0 ? void 0 : M.toString() : (P = l ?? 0) === null || P === void 0 ? void 0 : P.toString(), 10);
  }, [l, e.success, e.successPercent]), g = s.useMemo(() => !t4.includes(f) && p >= 100 ? "success" : f || "normal", [f, p]), {
    getPrefixCls: b,
    direction: y,
    progress: C
  } = s.useContext(lt), S = b("progress", n), [$, x, w] = qB(S), N = s.useMemo(() => {
    if (!u)
      return null;
    const M = $s(e);
    let P;
    const _ = m || ((R) => `${R}%`), D = d === "line";
    return m || g !== "exception" && g !== "success" ? P = _(ro(l), ro(M)) : g === "exception" ? P = D ? /* @__PURE__ */ s.createElement(Bo, null) : /* @__PURE__ */ s.createElement(mo, null) : g === "success" && (P = D ? /* @__PURE__ */ s.createElement(ks, null) : /* @__PURE__ */ s.createElement(Kf, null)), /* @__PURE__ */ s.createElement("span", {
      className: `${S}-text`,
      title: typeof P == "string" ? P : void 0
    }, P);
  }, [u, l, p, g, d, S, m]);
  if (process.env.NODE_ENV !== "production") {
    const M = Rt("Progress");
    M.deprecated(!("successPercent" in e), "successPercent", "success.percent"), M.deprecated(!("width" in e), "width", "size"), (d === "circle" || d === "dashboard") && Array.isArray(c) && process.env.NODE_ENV !== "production" && M(!1, "usage", 'Type "circle" and "dashboard" do not accept array as `size`, please use number or preset size instead.'), e.success && "progress" in e.success && M.deprecated(!1, "success.progress", "success.percent");
  }
  const O = Array.isArray(i) ? i[0] : i, E = typeof i == "string" || Array.isArray(i) ? i : void 0;
  let I;
  d === "line" ? I = a ? /* @__PURE__ */ s.createElement(ZB, Object.assign({}, e, {
    strokeColor: E,
    prefixCls: S,
    steps: a
  }), N) : /* @__PURE__ */ s.createElement(QB, Object.assign({}, e, {
    strokeColor: O,
    prefixCls: S,
    direction: y
  }), N) : (d === "circle" || d === "dashboard") && (I = /* @__PURE__ */ s.createElement(AB, Object.assign({}, e, {
    strokeColor: O,
    prefixCls: S,
    progressStatus: g
  }), N));
  const k = J(S, `${S}-status-${g}`, `${S}-${d === "dashboard" && "circle" || a && "steps" || d}`, {
    [`${S}-inline-circle`]: d === "circle" && fc(c, "circle")[0] <= 20,
    [`${S}-show-info`]: u,
    [`${S}-${c}`]: typeof c == "string",
    [`${S}-rtl`]: y === "rtl"
  }, C == null ? void 0 : C.className, r, o, x, w);
  return $(/* @__PURE__ */ s.createElement("div", Object.assign({
    ref: t,
    style: Object.assign(Object.assign({}, C == null ? void 0 : C.style), v),
    className: k,
    role: "progressbar",
    "aria-valuenow": p
  }, an(h, ["trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"])), I));
});
process.env.NODE_ENV !== "production" && (t$.displayName = "Progress");
const n4 = t$;
var r4 = ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"], n$ = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n, r = e.prefixCls, o = r === void 0 ? "rc-switch" : r, a = e.className, i = e.checked, l = e.defaultChecked, c = e.disabled, u = e.loadingIcon, d = e.checkedChildren, f = e.unCheckedChildren, m = e.onClick, v = e.onChange, h = e.onKeyDown, p = vt(e, r4), g = Vt(!1, {
    value: i,
    defaultValue: l
  }), b = Q(g, 2), y = b[0], C = b[1];
  function S(N, O) {
    var E = y;
    return c || (E = N, C(E), v == null || v(E, O)), E;
  }
  function $(N) {
    N.which === Oe.LEFT ? S(!1, N) : N.which === Oe.RIGHT && S(!0, N), h == null || h(N);
  }
  function x(N) {
    var O = S(!y, N);
    m == null || m(O, N);
  }
  var w = J(o, a, (n = {}, z(n, "".concat(o, "-checked"), y), z(n, "".concat(o, "-disabled"), c), n));
  return /* @__PURE__ */ s.createElement("button", fe({}, p, {
    type: "button",
    role: "switch",
    "aria-checked": y,
    disabled: c,
    className: w,
    ref: t,
    onKeyDown: $,
    onClick: x
  }), u, /* @__PURE__ */ s.createElement("span", {
    className: "".concat(o, "-inner")
  }, /* @__PURE__ */ s.createElement("span", {
    className: "".concat(o, "-inner-checked")
  }, d), /* @__PURE__ */ s.createElement("span", {
    className: "".concat(o, "-inner-unchecked")
  }, f)));
});
n$.displayName = "Switch";
const o4 = (e) => {
  const {
    componentCls: t,
    trackHeightSM: n,
    trackPadding: r,
    trackMinWidthSM: o,
    innerMinMarginSM: a,
    innerMaxMarginSM: i,
    handleSizeSM: l,
    calc: c
  } = e, u = `${t}-inner`, d = q(c(l).add(c(r).mul(2)).equal()), f = q(c(i).mul(2).equal());
  return {
    [t]: {
      [`&${t}-small`]: {
        minWidth: o,
        height: n,
        lineHeight: q(n),
        [`${t}-inner`]: {
          paddingInlineStart: i,
          paddingInlineEnd: a,
          [`${u}-checked`]: {
            marginInlineStart: `calc(-100% + ${d} - ${f})`,
            marginInlineEnd: `calc(100% - ${d} + ${f})`
          },
          [`${u}-unchecked`]: {
            marginTop: c(n).mul(-1).equal(),
            marginInlineStart: 0,
            marginInlineEnd: 0
          }
        },
        [`${t}-handle`]: {
          width: l,
          height: l
        },
        [`${t}-loading-icon`]: {
          top: c(c(l).sub(e.switchLoadingIconSize)).div(2).equal(),
          fontSize: e.switchLoadingIconSize
        },
        [`&${t}-checked`]: {
          [`${t}-inner`]: {
            paddingInlineStart: a,
            paddingInlineEnd: i,
            [`${u}-checked`]: {
              marginInlineStart: 0,
              marginInlineEnd: 0
            },
            [`${u}-unchecked`]: {
              marginInlineStart: `calc(100% - ${d} + ${f})`,
              marginInlineEnd: `calc(-100% + ${d} - ${f})`
            }
          },
          [`${t}-handle`]: {
            insetInlineStart: `calc(100% - ${q(c(l).add(r).equal())})`
          }
        },
        [`&:not(${t}-disabled):active`]: {
          [`&:not(${t}-checked) ${u}`]: {
            [`${u}-unchecked`]: {
              marginInlineStart: c(e.marginXXS).div(2).equal(),
              marginInlineEnd: c(e.marginXXS).mul(-1).div(2).equal()
            }
          },
          [`&${t}-checked ${u}`]: {
            [`${u}-checked`]: {
              marginInlineStart: c(e.marginXXS).mul(-1).div(2).equal(),
              marginInlineEnd: c(e.marginXXS).div(2).equal()
            }
          }
        }
      }
    }
  };
}, a4 = (e) => {
  const {
    componentCls: t,
    handleSize: n,
    calc: r
  } = e;
  return {
    [t]: {
      [`${t}-loading-icon${e.iconCls}`]: {
        position: "relative",
        top: r(r(n).sub(e.fontSize)).div(2).equal(),
        color: e.switchLoadingIconColor,
        verticalAlign: "top"
      },
      [`&${t}-checked ${t}-loading-icon`]: {
        color: e.switchColor
      }
    }
  };
}, i4 = (e) => {
  const {
    componentCls: t,
    trackPadding: n,
    handleBg: r,
    handleShadow: o,
    handleSize: a,
    calc: i
  } = e, l = `${t}-handle`;
  return {
    [t]: {
      [l]: {
        position: "absolute",
        top: n,
        insetInlineStart: n,
        width: a,
        height: a,
        transition: `all ${e.switchDuration} ease-in-out`,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          backgroundColor: r,
          borderRadius: i(a).div(2).equal(),
          boxShadow: o,
          transition: `all ${e.switchDuration} ease-in-out`,
          content: '""'
        }
      },
      [`&${t}-checked ${l}`]: {
        insetInlineStart: `calc(100% - ${q(i(a).add(n).equal())})`
      },
      [`&:not(${t}-disabled):active`]: {
        [`${l}::before`]: {
          insetInlineEnd: e.switchHandleActiveInset,
          insetInlineStart: 0
        },
        [`&${t}-checked ${l}::before`]: {
          insetInlineEnd: 0,
          insetInlineStart: e.switchHandleActiveInset
        }
      }
    }
  };
}, l4 = (e) => {
  const {
    componentCls: t,
    trackHeight: n,
    trackPadding: r,
    innerMinMargin: o,
    innerMaxMargin: a,
    handleSize: i,
    calc: l
  } = e, c = `${t}-inner`, u = q(l(i).add(l(r).mul(2)).equal()), d = q(l(a).mul(2).equal());
  return {
    [t]: {
      [c]: {
        display: "block",
        overflow: "hidden",
        borderRadius: 100,
        height: "100%",
        paddingInlineStart: a,
        paddingInlineEnd: o,
        transition: `padding-inline-start ${e.switchDuration} ease-in-out, padding-inline-end ${e.switchDuration} ease-in-out`,
        [`${c}-checked, ${c}-unchecked`]: {
          display: "block",
          color: e.colorTextLightSolid,
          fontSize: e.fontSizeSM,
          transition: `margin-inline-start ${e.switchDuration} ease-in-out, margin-inline-end ${e.switchDuration} ease-in-out`,
          pointerEvents: "none"
        },
        [`${c}-checked`]: {
          marginInlineStart: `calc(-100% + ${u} - ${d})`,
          marginInlineEnd: `calc(100% - ${u} + ${d})`
        },
        [`${c}-unchecked`]: {
          marginTop: l(n).mul(-1).equal(),
          marginInlineStart: 0,
          marginInlineEnd: 0
        }
      },
      [`&${t}-checked ${c}`]: {
        paddingInlineStart: o,
        paddingInlineEnd: a,
        [`${c}-checked`]: {
          marginInlineStart: 0,
          marginInlineEnd: 0
        },
        [`${c}-unchecked`]: {
          marginInlineStart: `calc(100% - ${u} + ${d})`,
          marginInlineEnd: `calc(-100% + ${u} - ${d})`
        }
      },
      [`&:not(${t}-disabled):active`]: {
        [`&:not(${t}-checked) ${c}`]: {
          [`${c}-unchecked`]: {
            marginInlineStart: l(r).mul(2).equal(),
            marginInlineEnd: l(r).mul(-1).mul(2).equal()
          }
        },
        [`&${t}-checked ${c}`]: {
          [`${c}-checked`]: {
            marginInlineStart: l(r).mul(-1).mul(2).equal(),
            marginInlineEnd: l(r).mul(2).equal()
          }
        }
      }
    }
  };
}, s4 = (e) => {
  const {
    componentCls: t,
    trackHeight: n,
    trackMinWidth: r
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Gt(e)), {
      position: "relative",
      display: "inline-block",
      boxSizing: "border-box",
      minWidth: r,
      height: n,
      lineHeight: `${q(n)}`,
      verticalAlign: "middle",
      background: e.colorTextQuaternary,
      border: "0",
      borderRadius: 100,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`,
      userSelect: "none",
      [`&:hover:not(${t}-disabled)`]: {
        background: e.colorTextTertiary
      }
    }), lo(e)), {
      [`&${t}-checked`]: {
        background: e.switchColor,
        [`&:hover:not(${t}-disabled)`]: {
          background: e.colorPrimaryHover
        }
      },
      [`&${t}-loading, &${t}-disabled`]: {
        cursor: "not-allowed",
        opacity: e.switchDisabledOpacity,
        "*": {
          boxShadow: "none",
          cursor: "not-allowed"
        }
      },
      // rtl style
      [`&${t}-rtl`]: {
        direction: "rtl"
      }
    })
  };
}, c4 = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    controlHeight: r,
    colorWhite: o
  } = e, a = t * n, i = r / 2, l = 2, c = a - l * 2, u = i - l * 2;
  return {
    trackHeight: a,
    trackHeightSM: i,
    trackMinWidth: c * 2 + l * 4,
    trackMinWidthSM: u * 2 + l * 2,
    trackPadding: l,
    // Fixed value
    handleBg: o,
    handleSize: c,
    handleSizeSM: u,
    handleShadow: `0 2px 4px 0 ${new Zt("#00230b").setAlpha(0.2).toRgbString()}`,
    innerMinMargin: c / 2,
    innerMaxMargin: c + l + l * 2,
    innerMinMarginSM: u / 2,
    innerMaxMarginSM: u + l + l * 2
  };
}, u4 = Xt("Switch", (e) => {
  const t = Dt(e, {
    switchDuration: e.motionDurationMid,
    switchColor: e.colorPrimary,
    switchDisabledOpacity: e.opacityLoading,
    switchLoadingIconSize: e.calc(e.fontSizeIcon).mul(0.75).equal(),
    switchLoadingIconColor: `rgba(0, 0, 0, ${e.opacityLoading})`,
    switchHandleActiveInset: "-30%"
  });
  return [
    s4(t),
    // inner style
    l4(t),
    // handle style
    i4(t),
    // loading style
    a4(t),
    // small style
    o4(t)
  ];
}, c4);
var d4 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Mm = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    size: r,
    disabled: o,
    loading: a,
    className: i,
    rootClassName: l,
    style: c,
    checked: u,
    value: d,
    defaultChecked: f,
    defaultValue: m,
    onChange: v
  } = e, h = d4(e, ["prefixCls", "size", "disabled", "loading", "className", "rootClassName", "style", "checked", "value", "defaultChecked", "defaultValue", "onChange"]), [p, g] = Vt(!1, {
    value: u ?? d,
    defaultValue: f ?? m
  }), {
    getPrefixCls: b,
    direction: y,
    switch: C
  } = s.useContext(lt), S = s.useContext(dr), $ = (o ?? S) || a, x = b("switch", n), w = /* @__PURE__ */ s.createElement("div", {
    className: `${x}-handle`
  }, a && /* @__PURE__ */ s.createElement(To, {
    className: `${x}-loading-icon`
  })), [N, O, E] = u4(x), I = qn(r), k = J(C == null ? void 0 : C.className, {
    [`${x}-small`]: I === "small",
    [`${x}-loading`]: a,
    [`${x}-rtl`]: y === "rtl"
  }, i, l, O, E), M = Object.assign(Object.assign({}, C == null ? void 0 : C.style), c), P = function() {
    g(arguments.length <= 0 ? void 0 : arguments[0]), v == null || v.apply(void 0, arguments);
  };
  return N(/* @__PURE__ */ s.createElement(Bi, {
    component: "Switch"
  }, /* @__PURE__ */ s.createElement(n$, Object.assign({}, h, {
    checked: p,
    onChange: P,
    prefixCls: x,
    className: k,
    style: M,
    disabled: $,
    ref: t,
    loadingIcon: w
  }))));
});
Mm.__ANT_SWITCH = !0;
process.env.NODE_ENV !== "production" && (Mm.displayName = "Switch");
const f4 = Mm;
var Ir = {}, ol = "rc-table-internal-hook";
function Tm(e) {
  var t = /* @__PURE__ */ s.createContext(void 0), n = function(o) {
    var a = o.value, i = o.children, l = s.useRef(a);
    l.current = a;
    var c = s.useState(function() {
      return {
        getValue: function() {
          return l.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), u = Q(c, 1), d = u[0];
    return Pt(function() {
      Oh(function() {
        d.listeners.forEach(function(f) {
          f(a);
        });
      });
    }, [a]), /* @__PURE__ */ s.createElement(t.Provider, {
      value: d
    }, i);
  };
  return {
    Context: t,
    Provider: n,
    defaultValue: e
  };
}
function Hn(e, t) {
  var n = Lt(typeof t == "function" ? t : function(f) {
    if (t === void 0)
      return f;
    if (!Array.isArray(t))
      return f[t];
    var m = {};
    return t.forEach(function(v) {
      m[v] = f[v];
    }), m;
  }), r = s.useContext(e == null ? void 0 : e.Context), o = r || {}, a = o.listeners, i = o.getValue, l = s.useRef();
  l.current = n(r ? i() : e == null ? void 0 : e.defaultValue);
  var c = s.useState({}), u = Q(c, 2), d = u[1];
  return Pt(function() {
    if (!r)
      return;
    function f(m) {
      var v = n(m);
      Hr(l.current, v, !0) || d({});
    }
    return a.add(f), function() {
      a.delete(f);
    };
  }, [r]), l.current;
}
function m4() {
  var e = /* @__PURE__ */ s.createContext(null);
  function t() {
    return s.useContext(e);
  }
  function n(o, a) {
    var i = Sr(o), l = function(u, d) {
      var f = i ? {
        ref: d
      } : {}, m = s.useRef(0), v = s.useRef(u), h = t();
      return h !== null ? /* @__PURE__ */ s.createElement(o, fe({}, u, f)) : (
        // Always trigger re-render if not provide `notTriggerRender`
        ((!a || a(v.current, u)) && (m.current += 1), v.current = u, /* @__PURE__ */ s.createElement(e.Provider, {
          value: m.current
        }, /* @__PURE__ */ s.createElement(o, fe({}, u, f))))
      );
    };
    return process.env.NODE_ENV !== "production" && (l.displayName = "ImmutableRoot(".concat(o.displayName || o.name, ")")), i ? /* @__PURE__ */ s.forwardRef(l) : l;
  }
  function r(o, a) {
    var i = Sr(o), l = function(u, d) {
      var f = i ? {
        ref: d
      } : {};
      return t(), /* @__PURE__ */ s.createElement(o, fe({}, u, f));
    };
    return process.env.NODE_ENV !== "production" && (l.displayName = "ImmutableResponse(".concat(o.displayName || o.name, ")")), i ? /* @__PURE__ */ s.memo(/* @__PURE__ */ s.forwardRef(l), a) : /* @__PURE__ */ s.memo(l, a);
  }
  return {
    makeImmutable: n,
    responseImmutable: r,
    useImmutableMark: t
  };
}
var _m = m4(), r$ = _m.makeImmutable, Fa = _m.responseImmutable, v4 = _m.useImmutableMark, Yn = Tm();
function o$(e, t) {
  var n = s.useRef(0);
  n.current += 1;
  var r = s.useRef(e), o = [];
  Object.keys(e || {}).map(function(i) {
    var l;
    (e == null ? void 0 : e[i]) !== ((l = r.current) === null || l === void 0 ? void 0 : l[i]) && o.push(i);
  }), r.current = e;
  var a = s.useRef([]);
  return o.length && (a.current = o), s.useDebugValue(n.current), s.useDebugValue(a.current.join(", ")), t && console.log("".concat(t, ":"), n.current, a.current), n.current;
}
const co = process.env.NODE_ENV !== "production" ? o$ : function() {
};
var g4 = /* @__PURE__ */ s.memo(function() {
  var e = o$();
  return /* @__PURE__ */ s.createElement("h1", null, "Render Times: ", e);
});
process.env.NODE_ENV !== "production" && (g4.displayName = "RenderBlock");
var a$ = /* @__PURE__ */ s.createContext({
  renderWithProps: !1
}), p4 = "RC_TABLE_KEY";
function h4(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function mc(e) {
  var t = [], n = {};
  return e.forEach(function(r) {
    for (var o = r || {}, a = o.key, i = o.dataIndex, l = a || h4(i).join("-") || p4; n[l]; )
      l = "".concat(l, "_next");
    n[l] = !0, t.push(l);
  }), t;
}
function Bd(e) {
  return e != null;
}
function b4(e) {
  return e && mt(e) === "object" && !Array.isArray(e) && !/* @__PURE__ */ s.isValidElement(e);
}
function y4(e, t, n, r, o, a) {
  var i = s.useContext(a$), l = v4(), c = Fo(function() {
    if (Bd(r))
      return [r];
    var u = t == null || t === "" ? [] : Array.isArray(t) ? t : [t], d = nr(e, u), f = d, m = void 0;
    if (o) {
      var v = o(d, e, n);
      b4(v) ? (process.env.NODE_ENV !== "production" && tt(!1, "`columns.render` return cell props is deprecated with perf issue, please use `onCell` instead."), f = v.children, m = v.props, i.renderWithProps = !0) : f = v;
    }
    return [f, m];
  }, [
    // Force update deps
    l,
    // Normal deps
    e,
    r,
    t,
    o,
    n
  ], function(u, d) {
    if (a) {
      var f = Q(u, 2), m = f[1], v = Q(d, 2), h = v[1];
      return a(h, m);
    }
    return i.renderWithProps ? !0 : !Hr(u, d, !0);
  });
  return c;
}
function C4(e, t, n, r) {
  var o = e + t - 1;
  return e <= r && o >= n;
}
function S4(e, t) {
  return Hn(Yn, function(n) {
    var r = C4(e, t || 1, n.hoverStartRow, n.hoverEndRow);
    return [r, n.onHover];
  });
}
var x4 = function(t) {
  var n = t.ellipsis, r = t.rowType, o = t.children, a, i = n === !0 ? {
    showTitle: !0
  } : n;
  return i && (i.showTitle || r === "header") && (typeof o == "string" || typeof o == "number" ? a = o.toString() : /* @__PURE__ */ s.isValidElement(o) && typeof o.props.children == "string" && (a = o.props.children)), a;
};
function $4(e) {
  var t, n, r, o, a, i, l, c;
  process.env.NODE_ENV !== "production" && co(e);
  var u = e.component, d = e.children, f = e.ellipsis, m = e.scope, v = e.prefixCls, h = e.className, p = e.align, g = e.record, b = e.render, y = e.dataIndex, C = e.renderIndex, S = e.shouldCellUpdate, $ = e.index, x = e.rowType, w = e.colSpan, N = e.rowSpan, O = e.fixLeft, E = e.fixRight, I = e.firstFixLeft, k = e.lastFixLeft, M = e.firstFixRight, P = e.lastFixRight, _ = e.appendNode, D = e.additionalProps, R = D === void 0 ? {} : D, T = e.isSticky, L = "".concat(v, "-cell"), F = Hn(Yn, ["supportSticky", "allColumnsFixedLeft"]), j = F.supportSticky, A = F.allColumnsFixedLeft, B = y4(g, y, C, d, b, S), K = Q(B, 2), Y = K[0], G = K[1], te = {}, ee = typeof O == "number" && j, oe = typeof E == "number" && j;
  ee && (te.position = "sticky", te.left = O), oe && (te.position = "sticky", te.right = E);
  var X = (t = (n = (r = G == null ? void 0 : G.colSpan) !== null && r !== void 0 ? r : R.colSpan) !== null && n !== void 0 ? n : w) !== null && t !== void 0 ? t : 1, W = (o = (a = (i = G == null ? void 0 : G.rowSpan) !== null && i !== void 0 ? i : R.rowSpan) !== null && a !== void 0 ? a : N) !== null && o !== void 0 ? o : 1, re = S4($, W), Z = Q(re, 2), H = Z[0], U = Z[1], ae = Lt(function(ve) {
    var ge;
    g && U($, $ + W - 1), R == null || (ge = R.onMouseEnter) === null || ge === void 0 || ge.call(R, ve);
  }), ue = Lt(function(ve) {
    var ge;
    g && U(-1, -1), R == null || (ge = R.onMouseLeave) === null || ge === void 0 || ge.call(R, ve);
  });
  if (X === 0 || W === 0)
    return null;
  var de = (l = R.title) !== null && l !== void 0 ? l : x4({
    rowType: x,
    ellipsis: f,
    children: Y
  }), se = J(L, h, (c = {}, z(c, "".concat(L, "-fix-left"), ee && j), z(c, "".concat(L, "-fix-left-first"), I && j), z(c, "".concat(L, "-fix-left-last"), k && j), z(c, "".concat(L, "-fix-left-all"), k && A && j), z(c, "".concat(L, "-fix-right"), oe && j), z(c, "".concat(L, "-fix-right-first"), M && j), z(c, "".concat(L, "-fix-right-last"), P && j), z(c, "".concat(L, "-ellipsis"), f), z(c, "".concat(L, "-with-append"), _), z(c, "".concat(L, "-fix-sticky"), (ee || oe) && T && j), z(c, "".concat(L, "-row-hover"), !G && H), c), R.className, G == null ? void 0 : G.className), ie = {};
  p && (ie.textAlign = p);
  var me = V(V(V(V({}, te), R.style), ie), G == null ? void 0 : G.style), Se = Y;
  return mt(Se) === "object" && !Array.isArray(Se) && !/* @__PURE__ */ s.isValidElement(Se) && (Se = null), f && (k || M) && (Se = /* @__PURE__ */ s.createElement("span", {
    className: "".concat(L, "-content")
  }, Se)), /* @__PURE__ */ s.createElement(u, fe({}, G, R, {
    className: se,
    style: me,
    title: de,
    scope: m,
    onMouseEnter: ae,
    onMouseLeave: ue,
    colSpan: X !== 1 ? X : null,
    rowSpan: W !== 1 ? W : null
  }), _, Se);
}
const qo = /* @__PURE__ */ s.memo($4);
function Dm(e, t, n, r, o, a) {
  var i = n[e] || {}, l = n[t] || {}, c, u;
  i.fixed === "left" ? c = r.left[o === "rtl" ? t : e] : l.fixed === "right" && (u = r.right[o === "rtl" ? e : t]);
  var d = !1, f = !1, m = !1, v = !1, h = n[t + 1], p = n[e - 1], g = !(a != null && a.children);
  if (o === "rtl") {
    if (c !== void 0) {
      var b = p && p.fixed === "left";
      v = !b && g;
    } else if (u !== void 0) {
      var y = h && h.fixed === "right";
      m = !y && g;
    }
  } else if (c !== void 0) {
    var C = h && h.fixed === "left";
    d = !C && g;
  } else if (u !== void 0) {
    var S = p && p.fixed === "right";
    f = !S && g;
  }
  return {
    fixLeft: c,
    fixRight: u,
    lastFixLeft: d,
    firstFixRight: f,
    lastFixRight: m,
    firstFixLeft: v,
    isSticky: r.isSticky
  };
}
var i$ = /* @__PURE__ */ s.createContext({});
function w4(e) {
  var t = e.className, n = e.index, r = e.children, o = e.colSpan, a = o === void 0 ? 1 : o, i = e.rowSpan, l = e.align, c = Hn(Yn, ["prefixCls", "direction"]), u = c.prefixCls, d = c.direction, f = s.useContext(i$), m = f.scrollColumnIndex, v = f.stickyOffsets, h = f.flattenColumns, p = f.columns, g = n + a - 1, b = g + 1 === m ? a + 1 : a, y = Dm(n, n + b - 1, h, v, d, p == null ? void 0 : p[n]);
  return /* @__PURE__ */ s.createElement(qo, fe({
    className: t,
    index: n,
    component: "td",
    prefixCls: u,
    record: null,
    dataIndex: null,
    align: l,
    colSpan: b,
    rowSpan: i,
    render: function() {
      return r;
    }
  }, y));
}
var E4 = ["children"];
function O4(e) {
  var t = e.children, n = vt(e, E4);
  return /* @__PURE__ */ s.createElement("tr", n, t);
}
function vc(e) {
  var t = e.children;
  return t;
}
vc.Row = O4;
vc.Cell = w4;
function N4(e) {
  process.env.NODE_ENV !== "production" && co(e);
  var t = e.children, n = e.stickyOffsets, r = e.flattenColumns, o = e.columns, a = Hn(Yn, "prefixCls"), i = r.length - 1, l = r[i], c = s.useMemo(function() {
    return {
      stickyOffsets: n,
      flattenColumns: r,
      scrollColumnIndex: l != null && l.scrollbar ? i : null,
      columns: o
    };
  }, [l, r, i, n, o]);
  return /* @__PURE__ */ s.createElement(i$.Provider, {
    value: c
  }, /* @__PURE__ */ s.createElement("tfoot", {
    className: "".concat(a, "-summary")
  }, t));
}
const Tl = Fa(N4);
var l$ = vc;
function I4(e) {
  return null;
}
function P4(e) {
  return null;
}
function s$(e, t, n, r, o, a, i) {
  e.push({
    record: t,
    indent: n,
    index: i
  });
  var l = a(t), c = o == null ? void 0 : o.has(l);
  if (t && Array.isArray(t[r]) && c)
    for (var u = 0; u < t[r].length; u += 1)
      s$(e, t[r][u], n + 1, r, o, a, u);
}
function c$(e, t, n, r) {
  var o = s.useMemo(function() {
    if (n != null && n.size) {
      for (var a = [], i = 0; i < (e == null ? void 0 : e.length); i += 1) {
        var l = e[i];
        s$(a, l, 0, t, n, r, i);
      }
      return a;
    }
    return e == null ? void 0 : e.map(function(c, u) {
      return {
        record: c,
        indent: 0,
        index: u
      };
    });
  }, [e, t, n, r]);
  return o;
}
function u$(e, t, n, r) {
  var o = Hn(Yn, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]), a = o.flattenColumns, i = o.expandableType, l = o.expandedKeys, c = o.childrenColumnName, u = o.onTriggerExpand, d = o.rowExpandable, f = o.onRow, m = o.expandRowByClick, v = o.rowClassName, h = i === "nest", p = i === "row" && (!d || d(e)), g = p || h, b = l && l.has(t), y = c && e && e[c], C = Lt(u), S = f == null ? void 0 : f(e, n), $ = S == null ? void 0 : S.onClick, x = function(E) {
    m && g && u(e, E);
    for (var I = arguments.length, k = new Array(I > 1 ? I - 1 : 0), M = 1; M < I; M++)
      k[M - 1] = arguments[M];
    $ == null || $.apply(void 0, [E].concat(k));
  }, w;
  typeof v == "string" ? w = v : typeof v == "function" && (w = v(e, n, r));
  var N = mc(a);
  return V(V({}, o), {}, {
    columnsKey: N,
    nestExpandable: h,
    expanded: b,
    hasNestChildren: y,
    record: e,
    onTriggerExpand: C,
    rowSupportExpand: p,
    expandable: g,
    rowProps: V(V({}, S), {}, {
      className: J(w, S == null ? void 0 : S.className),
      onClick: x
    })
  });
}
function d$(e) {
  process.env.NODE_ENV !== "production" && co(e);
  var t = e.prefixCls, n = e.children, r = e.component, o = e.cellComponent, a = e.className, i = e.expanded, l = e.colSpan, c = e.isEmpty, u = Hn(Yn, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), d = u.scrollbarSize, f = u.fixHeader, m = u.fixColumn, v = u.componentWidth, h = u.horizonScroll, p = n;
  return (c ? h && v : m) && (p = /* @__PURE__ */ s.createElement("div", {
    style: {
      width: v - (f ? d : 0),
      position: "sticky",
      left: 0,
      overflow: "hidden"
    },
    className: "".concat(t, "-expanded-row-fixed")
  }, p)), /* @__PURE__ */ s.createElement(r, {
    className: a,
    style: {
      display: i ? null : "none"
    }
  }, /* @__PURE__ */ s.createElement(qo, {
    component: o,
    prefixCls: t,
    colSpan: l
  }, p));
}
function f$(e, t, n, r, o) {
  var a = e.record, i = e.prefixCls, l = e.columnsKey, c = e.fixedInfoList, u = e.expandIconColumnIndex, d = e.nestExpandable, f = e.indentSize, m = e.expandIcon, v = e.expanded, h = e.hasNestChildren, p = e.onTriggerExpand, g = l[n], b = c[n], y;
  n === (u || 0) && d && (y = /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement("span", {
    style: {
      paddingLeft: "".concat(f * r, "px")
    },
    className: "".concat(i, "-row-indent indent-level-").concat(r)
  }), m({
    prefixCls: i,
    expanded: v,
    expandable: h,
    record: a,
    onExpand: p
  })));
  var C;
  return t.onCell && (C = t.onCell(a, o)), {
    key: g,
    fixedInfo: b,
    appendCellNode: y,
    additionalCellProps: C || {}
  };
}
function m$(e) {
  process.env.NODE_ENV !== "production" && co(e);
  var t = e.className, n = e.style, r = e.record, o = e.index, a = e.renderIndex, i = e.rowKey, l = e.indent, c = l === void 0 ? 0 : l, u = e.rowComponent, d = e.cellComponent, f = e.scopeCellComponent, m = u$(r, i, o, c), v = m.prefixCls, h = m.flattenColumns, p = m.expandedRowClassName, g = m.expandedRowRender, b = m.rowProps, y = m.expanded, C = m.rowSupportExpand, S = s.useRef(!1);
  S.current || (S.current = y), process.env.NODE_ENV !== "production" && co(e);
  var $ = p && p(r, o, c), x = /* @__PURE__ */ s.createElement(u, fe({}, b, {
    "data-row-key": i,
    className: J(t, "".concat(v, "-row"), "".concat(v, "-row-level-").concat(c), b == null ? void 0 : b.className, c >= 1 ? $ : ""),
    style: V(V({}, n), b == null ? void 0 : b.style)
  }), h.map(function(O, E) {
    var I = O.render, k = O.dataIndex, M = O.className, P = f$(m, O, E, c, o), _ = P.key, D = P.fixedInfo, R = P.appendCellNode, T = P.additionalCellProps;
    return /* @__PURE__ */ s.createElement(qo, fe({
      className: M,
      ellipsis: O.ellipsis,
      align: O.align,
      scope: O.rowScope,
      component: O.rowScope ? f : d,
      prefixCls: v,
      key: _,
      record: r,
      index: o,
      renderIndex: a,
      dataIndex: k,
      render: I,
      shouldCellUpdate: O.shouldCellUpdate
    }, D, {
      appendNode: R,
      additionalProps: T
    }));
  })), w;
  if (C && (S.current || y)) {
    var N = g(r, o, c + 1, y);
    w = /* @__PURE__ */ s.createElement(d$, {
      expanded: y,
      className: J("".concat(v, "-expanded-row"), "".concat(v, "-expanded-row-level-").concat(c + 1), $),
      prefixCls: v,
      component: u,
      cellComponent: d,
      colSpan: h.length,
      isEmpty: !1
    }, N);
  }
  return /* @__PURE__ */ s.createElement(s.Fragment, null, x, w);
}
process.env.NODE_ENV !== "production" && (m$.displayName = "BodyRow");
const R4 = Fa(m$);
function M4(e) {
  var t = e.columnKey, n = e.onColumnResize, r = s.useRef();
  return s.useEffect(function() {
    r.current && n(t, r.current.offsetWidth);
  }, []), /* @__PURE__ */ s.createElement(Mn, {
    data: t
  }, /* @__PURE__ */ s.createElement("td", {
    ref: r,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ s.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, " ")));
}
function T4(e) {
  var t = e.prefixCls, n = e.columnsKey, r = e.onColumnResize;
  return /* @__PURE__ */ s.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(t, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    }
  }, /* @__PURE__ */ s.createElement(Mn.Collection, {
    onBatchResize: function(a) {
      a.forEach(function(i) {
        var l = i.data, c = i.size;
        r(l, c.offsetWidth);
      });
    }
  }, n.map(function(o) {
    return /* @__PURE__ */ s.createElement(M4, {
      key: o,
      columnKey: o,
      onColumnResize: r
    });
  })));
}
function v$(e) {
  process.env.NODE_ENV !== "production" && co(e);
  var t = e.data, n = e.measureColumnWidth, r = Hn(Yn, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode"]), o = r.prefixCls, a = r.getComponent, i = r.onColumnResize, l = r.flattenColumns, c = r.getRowKey, u = r.expandedKeys, d = r.childrenColumnName, f = r.emptyNode, m = c$(t, d, u, c), v = s.useRef({
    renderWithProps: !1
  }), h = a(["body", "wrapper"], "tbody"), p = a(["body", "row"], "tr"), g = a(["body", "cell"], "td"), b = a(["body", "cell"], "th"), y;
  t.length ? y = m.map(function(S, $) {
    var x = S.record, w = S.indent, N = S.index, O = c(x, $);
    return /* @__PURE__ */ s.createElement(R4, {
      key: O,
      rowKey: O,
      record: x,
      index: $,
      renderIndex: N,
      rowComponent: p,
      cellComponent: g,
      scopeCellComponent: b,
      getRowKey: c,
      indent: w
    });
  }) : y = /* @__PURE__ */ s.createElement(d$, {
    expanded: !0,
    className: "".concat(o, "-placeholder"),
    prefixCls: o,
    component: p,
    cellComponent: g,
    colSpan: l.length,
    isEmpty: !0
  }, f);
  var C = mc(l);
  return /* @__PURE__ */ s.createElement(a$.Provider, {
    value: v.current
  }, /* @__PURE__ */ s.createElement(h, {
    className: "".concat(o, "-tbody")
  }, n && /* @__PURE__ */ s.createElement(T4, {
    prefixCls: o,
    columnsKey: C,
    onColumnResize: i
  }), y));
}
process.env.NODE_ENV !== "production" && (v$.displayName = "Body");
const _4 = Fa(v$);
var D4 = ["expandable"], hi = "RC_TABLE_INTERNAL_COL_DEFINE";
function k4(e) {
  var t = e.expandable, n = vt(e, D4), r;
  return "expandable" in e ? r = V(V({}, n), t) : (process.env.NODE_ENV !== "production" && ["indentSize", "expandedRowKeys", "defaultExpandedRowKeys", "defaultExpandAllRows", "expandedRowRender", "expandRowByClick", "expandIcon", "onExpand", "onExpandedRowsChange", "expandedRowClassName", "expandIconColumnIndex", "showExpandColumn", "title"].some(function(o) {
    return o in e;
  }) && tt(!1, "expanded related props have been moved into `expandable`."), r = n), r.showExpandColumn === !1 && (r.expandIconColumnIndex = -1), r;
}
var L4 = ["columnType"];
function g$(e) {
  for (var t = e.colWidths, n = e.columns, r = e.columCount, o = [], a = r || n.length, i = !1, l = a - 1; l >= 0; l -= 1) {
    var c = t[l], u = n && n[l], d = u && u[hi];
    if (c || d || i) {
      var f = d || {};
      f.columnType;
      var m = vt(f, L4);
      o.unshift(/* @__PURE__ */ s.createElement("col", fe({
        key: l,
        style: {
          width: c
        }
      }, m))), i = !0;
    }
  }
  return /* @__PURE__ */ s.createElement("colgroup", null, o);
}
var F4 = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];
function j4(e, t) {
  return nn(function() {
    for (var n = [], r = 0; r < t; r += 1) {
      var o = e[r];
      if (o !== void 0)
        n[r] = o;
      else
        return null;
    }
    return n;
  }, [e.join("_"), t]);
}
var p$ = /* @__PURE__ */ s.forwardRef(function(e, t) {
  process.env.NODE_ENV !== "production" && co(e);
  var n = e.className, r = e.noData, o = e.columns, a = e.flattenColumns, i = e.colWidths, l = e.columCount, c = e.stickyOffsets, u = e.direction, d = e.fixHeader, f = e.stickyTopOffset, m = e.stickyBottomOffset, v = e.stickyClassName, h = e.onScroll, p = e.maxContentScroll, g = e.children, b = vt(e, F4), y = Hn(Yn, ["prefixCls", "scrollbarSize", "isSticky"]), C = y.prefixCls, S = y.scrollbarSize, $ = y.isSticky, x = $ && !d ? 0 : S, w = s.useRef(null), N = s.useCallback(function(D) {
    Ci(t, D), Ci(w, D);
  }, []);
  s.useEffect(function() {
    var D;
    function R(T) {
      var L = T, F = L.currentTarget, j = L.deltaX;
      j && (h({
        currentTarget: F,
        scrollLeft: F.scrollLeft + j
      }), T.preventDefault());
    }
    return (D = w.current) === null || D === void 0 || D.addEventListener("wheel", R), function() {
      var T;
      (T = w.current) === null || T === void 0 || T.removeEventListener("wheel", R);
    };
  }, []);
  var O = s.useMemo(function() {
    return a.every(function(D) {
      return D.width;
    });
  }, [a]), E = a[a.length - 1], I = {
    fixed: E ? E.fixed : null,
    scrollbar: !0,
    onHeaderCell: function() {
      return {
        className: "".concat(C, "-cell-scrollbar")
      };
    }
  }, k = nn(function() {
    return x ? [].concat(be(o), [I]) : o;
  }, [x, o]), M = nn(function() {
    return x ? [].concat(be(a), [I]) : a;
  }, [x, a]), P = nn(function() {
    var D = c.right, R = c.left;
    return V(V({}, c), {}, {
      left: u === "rtl" ? [].concat(be(R.map(function(T) {
        return T + x;
      })), [0]) : R,
      right: u === "rtl" ? D : [].concat(be(D.map(function(T) {
        return T + x;
      })), [0]),
      isSticky: $
    });
  }, [x, c, $]), _ = j4(i, l);
  return /* @__PURE__ */ s.createElement("div", {
    style: V({
      overflow: "hidden"
    }, $ ? {
      top: f,
      bottom: m
    } : {}),
    ref: N,
    className: J(n, z({}, v, !!v))
  }, /* @__PURE__ */ s.createElement("table", {
    style: {
      tableLayout: "fixed",
      visibility: r || _ ? null : "hidden"
    }
  }, (!r || !p || O) && /* @__PURE__ */ s.createElement(g$, {
    colWidths: _ ? [].concat(be(_), [x]) : [],
    columCount: l + 1,
    columns: M
  }), g(V(V({}, b), {}, {
    stickyOffsets: P,
    columns: k,
    flattenColumns: M
  }))));
});
process.env.NODE_ENV !== "production" && (p$.displayName = "FixedHolder");
const Ap = /* @__PURE__ */ s.memo(p$);
function h$(e) {
  var t = e.cells, n = e.stickyOffsets, r = e.flattenColumns, o = e.rowComponent, a = e.cellComponent, i = e.tdCellComponent, l = e.onHeaderRow, c = e.index, u = Hn(Yn, ["prefixCls", "direction"]), d = u.prefixCls, f = u.direction, m;
  l && (m = l(t.map(function(h) {
    return h.column;
  }), c));
  var v = mc(t.map(function(h) {
    return h.column;
  }));
  return /* @__PURE__ */ s.createElement(o, m, t.map(function(h, p) {
    var g = h.column, b = Dm(h.colStart, h.colEnd, r, n, f, g), y;
    return g && g.onHeaderCell && (y = h.column.onHeaderCell(g)), /* @__PURE__ */ s.createElement(qo, fe({}, h, {
      scope: g.title ? h.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: g.ellipsis,
      align: g.align,
      component: g.title ? a : i,
      prefixCls: d,
      key: v[p]
    }, b, {
      additionalProps: y,
      rowType: "header"
    }));
  }));
}
process.env.NODE_ENV !== "production" && (h$.displayName = "HeaderRow");
function z4(e) {
  var t = [];
  function n(i, l) {
    var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    t[c] = t[c] || [];
    var u = l, d = i.filter(Boolean).map(function(f) {
      var m = {
        key: f.key,
        className: f.className || "",
        children: f.title,
        column: f,
        colStart: u
      }, v = 1, h = f.children;
      return h && h.length > 0 && (v = n(h, u, c + 1).reduce(function(p, g) {
        return p + g;
      }, 0), m.hasSubColumns = !0), "colSpan" in f && (v = f.colSpan), "rowSpan" in f && (m.rowSpan = f.rowSpan), m.colSpan = v, m.colEnd = m.colStart + v - 1, t[c].push(m), u += v, v;
    });
    return d;
  }
  n(e, 0);
  for (var r = t.length, o = function(l) {
    t[l].forEach(function(c) {
      !("rowSpan" in c) && !c.hasSubColumns && (c.rowSpan = r - l);
    });
  }, a = 0; a < r; a += 1)
    o(a);
  return t;
}
function A4(e) {
  process.env.NODE_ENV !== "production" && co(e);
  var t = e.stickyOffsets, n = e.columns, r = e.flattenColumns, o = e.onHeaderRow, a = Hn(Yn, ["prefixCls", "getComponent"]), i = a.prefixCls, l = a.getComponent, c = s.useMemo(function() {
    return z4(n);
  }, [n]), u = l(["header", "wrapper"], "thead"), d = l(["header", "row"], "tr"), f = l(["header", "cell"], "th"), m = l(["header", "cell"], "td");
  return /* @__PURE__ */ s.createElement(u, {
    className: "".concat(i, "-thead")
  }, c.map(function(v, h) {
    var p = /* @__PURE__ */ s.createElement(h$, {
      key: h,
      flattenColumns: r,
      cells: v,
      stickyOffsets: t,
      rowComponent: d,
      cellComponent: f,
      tdCellComponent: m,
      onHeaderRow: o,
      index: h
    });
    return p;
  }));
}
const Bp = Fa(A4);
function Hp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return typeof t == "number" ? t : t.endsWith("%") ? e * parseFloat(t) / 100 : null;
}
function B4(e, t, n) {
  return s.useMemo(function() {
    if (t && t > 0) {
      var r = 0, o = 0;
      e.forEach(function(m) {
        var v = Hp(t, m.width);
        v ? r += v : o += 1;
      });
      var a = Math.max(t, n), i = Math.max(a - r, o), l = o, c = i / o, u = 0, d = e.map(function(m) {
        var v = V({}, m), h = Hp(t, v.width);
        if (h)
          v.width = h;
        else {
          var p = Math.floor(c);
          v.width = l === 1 ? i : p, i -= p, l -= 1;
        }
        return u += v.width, v;
      });
      if (u < a) {
        var f = a / u;
        i = a, d.forEach(function(m, v) {
          var h = Math.floor(m.width * f);
          m.width = v === d.length - 1 ? i : h, i -= h;
        });
      }
      return [d, Math.max(u, a)];
    }
    return [e, t];
  }, [e, t, n]);
}
var H4 = ["children"], V4 = ["fixed"];
function km(e) {
  return Pn(e).filter(function(t) {
    return /* @__PURE__ */ s.isValidElement(t);
  }).map(function(t) {
    var n = t.key, r = t.props, o = r.children, a = vt(r, H4), i = V({
      key: n
    }, a);
    return o && (i.children = km(o)), i;
  });
}
function b$(e) {
  return e.filter(function(t) {
    return t && mt(t) === "object" && !t.hidden;
  }).map(function(t) {
    var n = t.children;
    return n && n.length > 0 ? V(V({}, t), {}, {
      children: b$(n)
    }) : t;
  });
}
function Hd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return e.filter(function(n) {
    return n && mt(n) === "object";
  }).reduce(function(n, r, o) {
    var a = r.fixed, i = a === !0 ? "left" : a, l = "".concat(t, "-").concat(o), c = r.children;
    return c && c.length > 0 ? [].concat(be(n), be(Hd(c, l).map(function(u) {
      return V({
        fixed: i
      }, u);
    }))) : [].concat(be(n), [V(V({
      key: l
    }, r), {}, {
      fixed: i
    })]);
  }, []);
}
function W4(e) {
  return e.map(function(t) {
    var n = t.fixed, r = vt(t, V4), o = n;
    return n === "left" ? o = "right" : n === "right" && (o = "left"), V({
      fixed: o
    }, r);
  });
}
function K4(e, t) {
  var n = e.prefixCls, r = e.columns, o = e.children, a = e.expandable, i = e.expandedKeys, l = e.columnTitle, c = e.getRowKey, u = e.onTriggerExpand, d = e.expandIcon, f = e.rowExpandable, m = e.expandIconColumnIndex, v = e.direction, h = e.expandRowByClick, p = e.columnWidth, g = e.fixed, b = e.scrollWidth, y = e.clientWidth, C = s.useMemo(function() {
    var k = r || km(o) || [];
    return b$(k.slice());
  }, [r, o]), S = s.useMemo(function() {
    if (a) {
      var k, M = C.slice();
      if (process.env.NODE_ENV !== "production" && m >= 0 && tt(!1, "`expandIconColumnIndex` is deprecated. Please use `Table.EXPAND_COLUMN` in `columns` instead."), !M.includes(Ir)) {
        var P = m || 0;
        P >= 0 && M.splice(P, 0, Ir);
      }
      process.env.NODE_ENV !== "production" && M.filter(function(L) {
        return L === Ir;
      }).length > 1 && tt(!1, "There exist more than one `EXPAND_COLUMN` in `columns`.");
      var _ = M.indexOf(Ir);
      M = M.filter(function(L, F) {
        return L !== Ir || F === _;
      });
      var D = C[_], R;
      (g === "left" || g) && !m ? R = "left" : (g === "right" || g) && m === C.length ? R = "right" : R = D ? D.fixed : null;
      var T = (k = {}, z(k, hi, {
        className: "".concat(n, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), z(k, "title", l), z(k, "fixed", R), z(k, "className", "".concat(n, "-row-expand-icon-cell")), z(k, "width", p), z(k, "render", function(F, j, A) {
        var B = c(j, A), K = i.has(B), Y = f ? f(j) : !0, G = d({
          prefixCls: n,
          expanded: K,
          expandable: Y,
          record: j,
          onExpand: u
        });
        return h ? /* @__PURE__ */ s.createElement("span", {
          onClick: function(ee) {
            return ee.stopPropagation();
          }
        }, G) : G;
      }), k);
      return M.map(function(L) {
        return L === Ir ? T : L;
      });
    }
    return process.env.NODE_ENV !== "production" && C.includes(Ir) && tt(!1, "`expandable` is not config but there exist `EXPAND_COLUMN` in `columns`."), C.filter(function(L) {
      return L !== Ir;
    });
  }, [a, C, c, i, d, v]), $ = s.useMemo(function() {
    var k = S;
    return t && (k = t(k)), k.length || (k = [{
      render: function() {
        return null;
      }
    }]), k;
  }, [t, S, v]), x = s.useMemo(function() {
    return v === "rtl" ? W4(Hd($)) : Hd($);
  }, [$, v, b]), w = s.useMemo(function() {
    for (var k = -1, M = x.length - 1; M >= 0; M -= 1) {
      var P = x[M].fixed;
      if (P === "left" || P === !0) {
        k = M;
        break;
      }
    }
    if (k >= 0)
      for (var _ = 0; _ <= k; _ += 1) {
        var D = x[_].fixed;
        if (D !== "left" && D !== !0)
          return !0;
      }
    var R = x.findIndex(function(F) {
      var j = F.fixed;
      return j === "right";
    });
    if (R >= 0)
      for (var T = R; T < x.length; T += 1) {
        var L = x[T].fixed;
        if (L !== "right")
          return !0;
      }
    return !1;
  }, [x]), N = B4(x, b, y), O = Q(N, 2), E = O[0], I = O[1];
  return [$, E, I, w];
}
function q4(e) {
  var t, n = e.prefixCls, r = e.record, o = e.onExpand, a = e.expanded, i = e.expandable, l = "".concat(n, "-row-expand-icon");
  if (!i)
    return /* @__PURE__ */ s.createElement("span", {
      className: J(l, "".concat(n, "-row-spaced"))
    });
  var c = function(d) {
    o(r, d), d.stopPropagation();
  };
  return /* @__PURE__ */ s.createElement("span", {
    className: J(l, (t = {}, z(t, "".concat(n, "-row-expanded"), a), z(t, "".concat(n, "-row-collapsed"), !a), t)),
    onClick: c
  });
}
function G4(e, t, n) {
  var r = [];
  function o(a) {
    (a || []).forEach(function(i, l) {
      r.push(t(i, l)), o(i[n]);
    });
  }
  return o(e), r;
}
function U4(e, t, n) {
  var r = k4(e), o = r.expandIcon, a = r.expandedRowKeys, i = r.defaultExpandedRowKeys, l = r.defaultExpandAllRows, c = r.expandedRowRender, u = r.onExpand, d = r.onExpandedRowsChange, f = r.childrenColumnName, m = o || q4, v = f || "children", h = s.useMemo(function() {
    return c ? "row" : e.expandable && e.internalHooks === ol && e.expandable.__PARENT_RENDER_ICON__ || t.some(function($) {
      return $ && mt($) === "object" && $[v];
    }) ? "nest" : !1;
  }, [!!c, t]), p = s.useState(function() {
    return i || (l ? G4(t, n, v) : []);
  }), g = Q(p, 2), b = g[0], y = g[1], C = s.useMemo(function() {
    return new Set(a || b || []);
  }, [a, b]), S = s.useCallback(function($) {
    var x = n($, t.indexOf($)), w, N = C.has(x);
    N ? (C.delete(x), w = be(C)) : w = [].concat(be(C), [x]), y(w), u && u(!N, $), d && d(w);
  }, [n, C, t, u, d]);
  return process.env.NODE_ENV !== "production" && c && t.some(function($) {
    return Array.isArray($ == null ? void 0 : $[v]);
  }) && tt(!1, "`expandedRowRender` should not use with nested Table"), [r, h, C, m, v, S];
}
function Y4(e, t, n, r) {
  var o = e.map(function(a, i) {
    return Dm(i, i, e, t, n, r == null ? void 0 : r[i]);
  });
  return Fo(function() {
    return o;
  }, [o], function(a, i) {
    return !Hr(a, i);
  });
}
function y$(e) {
  var t = Xe(e), n = Ht({}), r = Q(n, 2), o = r[1], a = Xe(null), i = Xe([]);
  function l(c) {
    i.current.push(c);
    var u = Promise.resolve();
    a.current = u, u.then(function() {
      if (a.current === u) {
        var d = i.current, f = t.current;
        i.current = [], d.forEach(function(m) {
          t.current = m(t.current);
        }), a.current = null, f !== t.current && o({});
      }
    });
  }
  return Bt(function() {
    return function() {
      a.current = null;
    };
  }, []), [t.current, l];
}
function X4(e) {
  var t = Xe(e || null), n = Xe();
  function r() {
    window.clearTimeout(n.current);
  }
  function o(i) {
    t.current = i, r(), n.current = window.setTimeout(function() {
      t.current = null, n.current = void 0;
    }, 100);
  }
  function a() {
    return t.current;
  }
  return Bt(function() {
    return r;
  }, []), [o, a];
}
function Q4() {
  var e = s.useState(-1), t = Q(e, 2), n = t[0], r = t[1], o = s.useState(-1), a = Q(o, 2), i = a[0], l = a[1], c = s.useCallback(function(u, d) {
    r(u), l(d);
  }, []);
  return [n, i, c];
}
var Vp = pn() ? window : null;
function J4(e, t) {
  var n = mt(e) === "object" ? e : {}, r = n.offsetHeader, o = r === void 0 ? 0 : r, a = n.offsetSummary, i = a === void 0 ? 0 : a, l = n.offsetScroll, c = l === void 0 ? 0 : l, u = n.getContainer, d = u === void 0 ? function() {
    return Vp;
  } : u, f = d() || Vp;
  return s.useMemo(function() {
    var m = !!e;
    return {
      isSticky: m,
      stickyClassName: m ? "".concat(t, "-sticky-holder") : "",
      offsetHeader: o,
      offsetSummary: i,
      offsetScroll: c,
      container: f
    };
  }, [c, o, i, t, f]);
}
function Z4(e, t, n) {
  var r = nn(function() {
    var o = t.length, a = function(u, d, f) {
      for (var m = [], v = 0, h = u; h !== d; h += f)
        m.push(v), t[h].fixed && (v += e[h] || 0);
      return m;
    }, i = a(0, o, 1), l = a(o - 1, -1, -1).reverse();
    return n === "rtl" ? {
      left: l,
      right: i
    } : {
      left: i,
      right: l
    };
  }, [e, t, n]);
  return r;
}
function Wp(e) {
  var t = e.className, n = e.children;
  return /* @__PURE__ */ s.createElement("div", {
    className: t
  }, n);
}
var eH = function(t, n) {
  var r, o, a = t.scrollBodyRef, i = t.onScroll, l = t.offsetScroll, c = t.container, u = Hn(Yn, "prefixCls"), d = ((r = a.current) === null || r === void 0 ? void 0 : r.scrollWidth) || 0, f = ((o = a.current) === null || o === void 0 ? void 0 : o.clientWidth) || 0, m = d && f * (f / d), v = s.useRef(), h = y$({
    scrollLeft: 0,
    isHiddenScrollBar: !1
  }), p = Q(h, 2), g = p[0], b = p[1], y = s.useRef({
    delta: 0,
    x: 0
  }), C = s.useState(!1), S = Q(C, 2), $ = S[0], x = S[1], w = function() {
    x(!1);
  }, N = function(M) {
    M.persist(), y.current.delta = M.pageX - g.scrollLeft, y.current.x = 0, x(!0), M.preventDefault();
  }, O = function(M) {
    var P, _ = M || ((P = window) === null || P === void 0 ? void 0 : P.event), D = _.buttons;
    if (!$ || D === 0) {
      $ && x(!1);
      return;
    }
    var R = y.current.x + M.pageX - y.current.x - y.current.delta;
    R <= 0 && (R = 0), R + m >= f && (R = f - m), i({
      scrollLeft: R / f * (d + 2)
    }), y.current.x = M.pageX;
  }, E = function() {
    if (a.current) {
      var M = Rp(a.current).top, P = M + a.current.offsetHeight, _ = c === window ? document.documentElement.scrollTop + window.innerHeight : Rp(c).top + c.clientHeight;
      P - od() <= _ || M >= _ - l ? b(function(D) {
        return V(V({}, D), {}, {
          isHiddenScrollBar: !0
        });
      }) : b(function(D) {
        return V(V({}, D), {}, {
          isHiddenScrollBar: !1
        });
      });
    }
  }, I = function(M) {
    b(function(P) {
      return V(V({}, P), {}, {
        scrollLeft: M / d * f || 0
      });
    });
  };
  return s.useImperativeHandle(n, function() {
    return {
      setScrollLeft: I
    };
  }), s.useEffect(function() {
    var k = Ml(document.body, "mouseup", w, !1), M = Ml(document.body, "mousemove", O, !1);
    return E(), function() {
      k.remove(), M.remove();
    };
  }, [m, $]), s.useEffect(function() {
    var k = Ml(c, "scroll", E, !1), M = Ml(window, "resize", E, !1);
    return function() {
      k.remove(), M.remove();
    };
  }, [c]), s.useEffect(function() {
    g.isHiddenScrollBar || b(function(k) {
      var M = a.current;
      return M ? V(V({}, k), {}, {
        scrollLeft: M.scrollLeft / M.scrollWidth * M.clientWidth
      }) : k;
    });
  }, [g.isHiddenScrollBar]), d <= f || !m || g.isHiddenScrollBar ? null : /* @__PURE__ */ s.createElement("div", {
    style: {
      height: od(),
      width: f,
      bottom: l
    },
    className: "".concat(u, "-sticky-scroll")
  }, /* @__PURE__ */ s.createElement("div", {
    onMouseDown: N,
    ref: v,
    className: J("".concat(u, "-sticky-scroll-bar"), z({}, "".concat(u, "-sticky-scroll-bar-active"), $)),
    style: {
      width: "".concat(m, "px"),
      transform: "translate3d(".concat(g.scrollLeft, "px, 0, 0)")
    }
  }));
};
const tH = /* @__PURE__ */ s.forwardRef(eH);
var C$ = "rc-table", nH = [], rH = {};
function oH() {
  return "No Data";
}
function aH(e, t) {
  var n, r = V({
    rowKey: "key",
    prefixCls: C$,
    emptyText: oH
  }, e), o = r.prefixCls, a = r.className, i = r.rowClassName, l = r.style, c = r.data, u = r.rowKey, d = r.scroll, f = r.tableLayout, m = r.direction, v = r.title, h = r.footer, p = r.summary, g = r.caption, b = r.id, y = r.showHeader, C = r.components, S = r.emptyText, $ = r.onRow, x = r.onHeaderRow, w = r.internalHooks, N = r.transformColumns, O = r.internalRefs, E = r.tailor, I = r.getContainerWidth, k = r.sticky, M = c || nH, P = !!M.length, _ = w === ol;
  process.env.NODE_ENV !== "production" && (["onRowClick", "onRowDoubleClick", "onRowContextMenu", "onRowMouseEnter", "onRowMouseLeave"].forEach(function(Ct) {
    tt(r[Ct] === void 0, "`".concat(Ct, "` is removed, please use `onRow` instead."));
  }), tt(!("getBodyWrapper" in r), "`getBodyWrapper` is deprecated, please use custom `components` instead."));
  var D = s.useCallback(function(Ct, Ue) {
    return nr(C, Ct) || Ue;
  }, [C]), R = s.useMemo(function() {
    return typeof u == "function" ? u : function(Ct) {
      var Ue = Ct && Ct[u];
      return process.env.NODE_ENV !== "production" && tt(Ue !== void 0, "Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key."), Ue;
    };
  }, [u]), T = D(["body"]), L = Q4(), F = Q(L, 3), j = F[0], A = F[1], B = F[2], K = U4(r, M, R), Y = Q(K, 6), G = Y[0], te = Y[1], ee = Y[2], oe = Y[3], X = Y[4], W = Y[5], re = d == null ? void 0 : d.x, Z = s.useState(0), H = Q(Z, 2), U = H[0], ae = H[1], ue = K4(V(V(V({}, r), G), {}, {
    expandable: !!G.expandedRowRender,
    columnTitle: G.columnTitle,
    expandedKeys: ee,
    getRowKey: R,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: W,
    expandIcon: oe,
    expandIconColumnIndex: G.expandIconColumnIndex,
    direction: m,
    scrollWidth: _ && E && typeof re == "number" ? re : null,
    clientWidth: U
  }), _ ? N : null), de = Q(ue, 4), se = de[0], ie = de[1], me = de[2], Se = de[3], ve = me ?? re, ge = s.useMemo(function() {
    return {
      columns: se,
      flattenColumns: ie
    };
  }, [se, ie]), $e = s.useRef(), we = s.useRef(), _e = s.useRef(), ze = s.useRef();
  s.useImperativeHandle(t, function() {
    return {
      nativeElement: $e.current,
      scrollTo: function(Ue) {
        var st;
        if (_e.current instanceof HTMLElement) {
          var gt = Ue.index, At = Ue.top, bn = Ue.key;
          if (At) {
            var Gn;
            (Gn = _e.current) === null || Gn === void 0 || Gn.scrollTo({
              top: At
            });
          } else {
            var Xn, mr = bn ?? R(M[gt]);
            (Xn = _e.current.querySelector('[data-row-key="'.concat(mr, '"]'))) === null || Xn === void 0 || Xn.scrollIntoView();
          }
        } else
          (st = _e.current) !== null && st !== void 0 && st.scrollTo && _e.current.scrollTo(Ue);
      }
    };
  });
  var Te = s.useRef(), ke = s.useState(!1), Le = Q(ke, 2), Ee = Le[0], xe = Le[1], he = s.useState(!1), pe = Q(he, 2), Pe = pe[0], Re = pe[1], at = y$(/* @__PURE__ */ new Map()), Ze = Q(at, 2), Ie = Ze[0], Be = Ze[1], bt = mc(ie), He = bt.map(function(Ct) {
    return Ie.get(Ct);
  }), nt = s.useMemo(function() {
    return He;
  }, [He.join("_")]), et = Z4(nt, ie, m), Ge = d && Bd(d.y), Ae = d && Bd(ve) || !!G.fixed, qe = Ae && ie.some(function(Ct) {
    var Ue = Ct.fixed;
    return Ue;
  }), Je = s.useRef(), Ke = J4(k, o), Ye = Ke.isSticky, Ve = Ke.offsetHeader, Qe = Ke.offsetSummary, it = Ke.offsetScroll, yt = Ke.stickyClassName, Tt = Ke.container, ne = s.useMemo(function() {
    return p == null ? void 0 : p(M);
  }, [p, M]), ye = (Ge || Ye) && /* @__PURE__ */ s.isValidElement(ne) && ne.type === vc && ne.props.fixed, ce, Ce, je;
  Ge && (Ce = {
    overflowY: "scroll",
    maxHeight: d.y
  }), Ae && (ce = {
    overflowX: "auto"
  }, Ge || (Ce = {
    overflowY: "hidden"
  }), je = {
    width: ve === !0 ? "auto" : ve,
    minWidth: "100%"
  });
  var Ne = s.useCallback(function(Ct, Ue) {
    Ai($e.current) && Be(function(st) {
      if (st.get(Ct) !== Ue) {
        var gt = new Map(st);
        return gt.set(Ct, Ue), gt;
      }
      return st;
    });
  }, []), De = X4(null), Fe = Q(De, 2), ot = Fe[0], pt = Fe[1];
  function St(Ct, Ue) {
    Ue && (typeof Ue == "function" ? Ue(Ct) : Ue.scrollLeft !== Ct && (Ue.scrollLeft = Ct, Ue.scrollLeft !== Ct && setTimeout(function() {
      Ue.scrollLeft = Ct;
    }, 0)));
  }
  var Ot = Lt(function(Ct) {
    var Ue = Ct.currentTarget, st = Ct.scrollLeft, gt = m === "rtl", At = typeof st == "number" ? st : Ue.scrollLeft, bn = Ue || rH;
    if (!pt() || pt() === bn) {
      var Gn;
      ot(bn), St(At, we.current), St(At, _e.current), St(At, Te.current), St(At, (Gn = Je.current) === null || Gn === void 0 ? void 0 : Gn.setScrollLeft);
    }
    var Xn = Ue || we.current;
    if (Xn) {
      var mr = Xn.scrollWidth, Xr = Xn.clientWidth;
      if (mr === Xr) {
        xe(!1), Re(!1);
        return;
      }
      gt ? (xe(-At < mr - Xr), Re(-At > 0)) : (xe(At > 0), Re(At < mr - Xr));
    }
  }), Wt = function() {
    Ae && _e.current ? Ot({
      currentTarget: _e.current
    }) : (xe(!1), Re(!1));
  }, rn = function(Ue) {
    var st = Ue.width, gt = $e.current ? $e.current.offsetWidth : st;
    _ && I && $e.current && (gt = I($e.current, gt) || gt), gt !== U && (Wt(), ae(gt));
  }, Nt = s.useRef(!1);
  s.useEffect(function() {
    Nt.current && Wt();
  }, [Ae, c, se.length]), s.useEffect(function() {
    Nt.current = !0;
  }, []);
  var Ut = s.useState(0), fn = Q(Ut, 2), sn = fn[0], ln = fn[1], _n = s.useState(!0), ut = Q(_n, 2), xt = ut[0], jt = ut[1];
  s.useEffect(function() {
    (!E || !_) && (_e.current instanceof Element ? ln(ad(_e.current).width) : ln(ad(ze.current).width)), jt(id("position", "sticky"));
  }, []), s.useEffect(function() {
    _ && O && (O.body.current = _e.current);
  });
  var on = s.useCallback(function(Ct) {
    return /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(Bp, Ct), ye === "top" && /* @__PURE__ */ s.createElement(Tl, Ct, ne));
  }, [ye, ne]), cn = s.useCallback(function(Ct) {
    return /* @__PURE__ */ s.createElement(Tl, Ct, ne);
  }, [ne]), hn = D(["table"], "table"), Dn = s.useMemo(function() {
    return f || (qe ? ve === "max-content" ? "auto" : "fixed" : Ge || Ye || ie.some(function(Ct) {
      var Ue = Ct.ellipsis;
      return Ue;
    }) ? "fixed" : "auto");
  }, [Ge, qe, ie, f, Ye]), On, mn = {
    colWidths: nt,
    columCount: ie.length,
    stickyOffsets: et,
    onHeaderRow: x,
    fixHeader: Ge,
    scroll: d
  }, kn = s.useMemo(function() {
    return P ? null : typeof S == "function" ? S() : S;
  }, [P, S]), dt = /* @__PURE__ */ s.createElement(_4, {
    data: M,
    measureColumnWidth: Ge || Ae || Ye
  }), rt = /* @__PURE__ */ s.createElement(g$, {
    colWidths: ie.map(function(Ct) {
      var Ue = Ct.width;
      return Ue;
    }),
    columns: ie
  }), wt = g != null ? /* @__PURE__ */ s.createElement("caption", {
    className: "".concat(o, "-caption")
  }, g) : void 0, zt = Bn(r, {
    data: !0
  }), Mt = Bn(r, {
    aria: !0
  });
  if (Ge || Ye) {
    var ct;
    typeof T == "function" ? (ct = T(M, {
      scrollbarSize: sn,
      ref: _e,
      onScroll: Ot
    }), mn.colWidths = ie.map(function(Ct, Ue) {
      var st = Ct.width, gt = Ue === ie.length - 1 ? st - sn : st;
      return typeof gt == "number" && !Number.isNaN(gt) ? gt : (process.env.NODE_ENV !== "production" && tt(r.columns.length === 0, "When use `components.body` with render props. Each column should have a fixed `width` value."), 0);
    })) : ct = /* @__PURE__ */ s.createElement("div", {
      style: V(V({}, ce), Ce),
      onScroll: Ot,
      ref: _e,
      className: J("".concat(o, "-body"))
    }, /* @__PURE__ */ s.createElement(hn, fe({
      style: V(V({}, je), {}, {
        tableLayout: Dn
      })
    }, Mt), wt, rt, dt, !ye && ne && /* @__PURE__ */ s.createElement(Tl, {
      stickyOffsets: et,
      flattenColumns: ie,
      columns: se
    }, ne)));
    var ft = V(V(V({
      noData: !M.length,
      maxContentScroll: Ae && ve === "max-content"
    }, mn), ge), {}, {
      direction: m,
      stickyClassName: yt,
      onScroll: Ot
    });
    On = /* @__PURE__ */ s.createElement(s.Fragment, null, y !== !1 && /* @__PURE__ */ s.createElement(Ap, fe({}, ft, {
      stickyTopOffset: Ve,
      className: "".concat(o, "-header"),
      ref: we
    }), on), ct, ye && ye !== "top" && /* @__PURE__ */ s.createElement(Ap, fe({}, ft, {
      stickyBottomOffset: Qe,
      className: "".concat(o, "-summary"),
      ref: Te
    }), cn), Ye && _e.current && _e.current instanceof Element && /* @__PURE__ */ s.createElement(tH, {
      ref: Je,
      offsetScroll: it,
      scrollBodyRef: _e,
      onScroll: Ot,
      container: Tt
    }));
  } else
    On = /* @__PURE__ */ s.createElement("div", {
      style: V(V({}, ce), Ce),
      className: J("".concat(o, "-content")),
      onScroll: Ot,
      ref: _e
    }, /* @__PURE__ */ s.createElement(hn, fe({
      style: V(V({}, je), {}, {
        tableLayout: Dn
      })
    }, Mt), wt, rt, y !== !1 && /* @__PURE__ */ s.createElement(Bp, fe({}, mn, ge)), dt, ne && /* @__PURE__ */ s.createElement(Tl, {
      stickyOffsets: et,
      flattenColumns: ie,
      columns: se
    }, ne)));
  var Yt = /* @__PURE__ */ s.createElement("div", fe({
    className: J(o, a, (n = {}, z(n, "".concat(o, "-rtl"), m === "rtl"), z(n, "".concat(o, "-ping-left"), Ee), z(n, "".concat(o, "-ping-right"), Pe), z(n, "".concat(o, "-layout-fixed"), f === "fixed"), z(n, "".concat(o, "-fixed-header"), Ge), z(n, "".concat(o, "-fixed-column"), qe), z(n, "".concat(o, "-fixed-column-gapped"), qe && Se), z(n, "".concat(o, "-scroll-horizontal"), Ae), z(n, "".concat(o, "-has-fix-left"), ie[0] && ie[0].fixed), z(n, "".concat(o, "-has-fix-right"), ie[ie.length - 1] && ie[ie.length - 1].fixed === "right"), n)),
    style: l,
    id: b,
    ref: $e
  }, zt), v && /* @__PURE__ */ s.createElement(Wp, {
    className: "".concat(o, "-title")
  }, v(M)), /* @__PURE__ */ s.createElement("div", {
    ref: ze,
    className: "".concat(o, "-container")
  }, On), h && /* @__PURE__ */ s.createElement(Wp, {
    className: "".concat(o, "-footer")
  }, h(M)));
  Ae && (Yt = /* @__PURE__ */ s.createElement(Mn, {
    onResize: rn
  }, Yt));
  var en = Y4(ie, et, m, se), vn = s.useMemo(function() {
    return {
      // Scroll
      scrollX: ve,
      // Table
      prefixCls: o,
      getComponent: D,
      scrollbarSize: sn,
      direction: m,
      fixedInfoList: en,
      isSticky: Ye,
      supportSticky: xt,
      componentWidth: U,
      fixHeader: Ge,
      fixColumn: qe,
      horizonScroll: Ae,
      // Body
      tableLayout: Dn,
      rowClassName: i,
      expandedRowClassName: G.expandedRowClassName,
      expandIcon: oe,
      expandableType: te,
      expandRowByClick: G.expandRowByClick,
      expandedRowRender: G.expandedRowRender,
      onTriggerExpand: W,
      expandIconColumnIndex: G.expandIconColumnIndex,
      indentSize: G.indentSize,
      allColumnsFixedLeft: ie.every(function(Ct) {
        return Ct.fixed === "left";
      }),
      emptyNode: kn,
      // Column
      columns: se,
      flattenColumns: ie,
      onColumnResize: Ne,
      // Row
      hoverStartRow: j,
      hoverEndRow: A,
      onHover: B,
      rowExpandable: G.rowExpandable,
      onRow: $,
      getRowKey: R,
      expandedKeys: ee,
      childrenColumnName: X
    };
  }, [
    // Scroll
    ve,
    // Table
    o,
    D,
    sn,
    m,
    en,
    Ye,
    xt,
    U,
    Ge,
    qe,
    Ae,
    // Body
    Dn,
    i,
    G.expandedRowClassName,
    oe,
    te,
    G.expandRowByClick,
    G.expandedRowRender,
    W,
    G.expandIconColumnIndex,
    G.indentSize,
    kn,
    // Column
    se,
    ie,
    Ne,
    // Row
    j,
    A,
    B,
    G.rowExpandable,
    $,
    R,
    ee,
    X
  ]);
  return /* @__PURE__ */ s.createElement(Yn.Provider, {
    value: vn
  }, Yt);
}
var S$ = /* @__PURE__ */ s.forwardRef(aH);
process.env.NODE_ENV !== "production" && (S$.displayName = "Table");
function x$(e) {
  return r$(S$, e);
}
var ja = x$();
ja.EXPAND_COLUMN = Ir;
ja.INTERNAL_HOOKS = ol;
ja.Column = I4;
ja.ColumnGroup = P4;
ja.Summary = l$;
var Lm = Tm(null), $$ = Tm(null);
function iH(e, t, n) {
  var r = t || 1;
  return n[e + r] - (n[e] || 0);
}
function lH(e) {
  var t = e.rowInfo, n = e.column, r = e.colIndex, o = e.indent, a = e.index, i = e.component, l = e.renderIndex, c = e.record, u = e.style, d = e.className, f = e.inverse, m = e.getHeight, v = n.render, h = n.dataIndex, p = n.className, g = n.width, b = Hn($$, ["columnsOffset"]), y = b.columnsOffset, C = f$(t, n, r, o, a), S = C.key, $ = C.fixedInfo, x = C.appendCellNode, w = C.additionalCellProps, N = w.style, O = w.colSpan, E = O === void 0 ? 1 : O, I = w.rowSpan, k = I === void 0 ? 1 : I, M = r - 1, P = iH(M, E, y), _ = E > 1 ? g - P : 0, D = V(V(V({}, N), u), {}, {
    flex: "0 0 ".concat(P, "px"),
    width: "".concat(P, "px"),
    marginRight: _,
    pointerEvents: "auto"
  }), R = s.useMemo(function() {
    return f ? k <= 1 : E === 0 || k === 0 || k > 1;
  }, [k, E, f]);
  R ? D.visibility = "hidden" : f && (D.height = m == null ? void 0 : m(k));
  var T = R ? function() {
    return null;
  } : v, L = {};
  return (k === 0 || E === 0) && (L.rowSpan = 1, L.colSpan = 1), /* @__PURE__ */ s.createElement(qo, fe({
    className: J(p, d),
    ellipsis: n.ellipsis,
    align: n.align,
    scope: n.rowScope,
    component: i,
    prefixCls: t.prefixCls,
    key: S,
    record: c,
    index: a,
    renderIndex: l,
    dataIndex: h,
    render: T,
    shouldCellUpdate: n.shouldCellUpdate
  }, $, {
    appendNode: x,
    additionalProps: V(V({}, w), {}, {
      style: D
    }, L)
  }));
}
var sH = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"], cH = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.data, r = e.index, o = e.className, a = e.rowKey, i = e.style, l = e.extra, c = e.getHeight, u = vt(e, sH), d = n.record, f = n.indent, m = n.index, v = Hn(Yn, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), h = v.scrollX, p = v.flattenColumns, g = v.prefixCls, b = v.fixColumn, y = v.componentWidth, C = Hn(Lm, ["getComponent"]), S = C.getComponent, $ = u$(d, a, r, f), x = S(["body", "row"], "div"), w = S(["body", "cell"], "div"), N = $.rowSupportExpand, O = $.expanded, E = $.rowProps, I = $.expandedRowRender, k = $.expandedRowClassName, M;
  if (N && O) {
    var P = I(d, r, f + 1, O), _ = k == null ? void 0 : k(d, r, f), D = {};
    b && (D = {
      style: z({}, "--virtual-width", "".concat(y, "px"))
    });
    var R = "".concat(g, "-expanded-row-cell");
    M = /* @__PURE__ */ s.createElement(x, {
      className: J("".concat(g, "-expanded-row"), "".concat(g, "-expanded-row-level-").concat(f + 1), _)
    }, /* @__PURE__ */ s.createElement(qo, {
      component: w,
      prefixCls: g,
      className: J(R, z({}, "".concat(R, "-fixed"), b)),
      additionalProps: D
    }, P));
  }
  var T = V(V({}, i), {}, {
    width: h
  });
  l && (T.position = "absolute", T.pointerEvents = "none");
  var L = /* @__PURE__ */ s.createElement(x, fe({}, E, u, {
    ref: N ? null : t,
    className: J(o, "".concat(g, "-row"), E == null ? void 0 : E.className, z({}, "".concat(g, "-row-extra"), l)),
    style: V(V({}, T), E == null ? void 0 : E.style)
  }), p.map(function(F, j) {
    return /* @__PURE__ */ s.createElement(lH, {
      key: j,
      component: w,
      rowInfo: $,
      column: F,
      colIndex: j,
      indent: f,
      index: r,
      renderIndex: m,
      record: d,
      inverse: l,
      getHeight: c
    });
  }));
  return N ? /* @__PURE__ */ s.createElement("div", {
    ref: t
  }, L, M) : L;
}), Vd = Fa(cH);
process.env.NODE_ENV !== "production" && (Vd.displayName = "BodyLine");
var uH = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.data, r = e.onScroll, o = Hn(Yn, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "emptyNode", "scrollX"]), a = o.flattenColumns, i = o.onColumnResize, l = o.getRowKey, c = o.expandedKeys, u = o.prefixCls, d = o.childrenColumnName, f = o.emptyNode, m = o.scrollX, v = Hn(Lm), h = v.sticky, p = v.scrollY, g = v.listItemHeight, b = v.getComponent, y = s.useRef(), C = c$(n, d, c, l), S = s.useMemo(function() {
    var _ = 0;
    return a.map(function(D) {
      var R = D.width, T = D.key;
      return _ += R, [T, R, _];
    });
  }, [a]), $ = s.useMemo(function() {
    return S.map(function(_) {
      return _[2];
    });
  }, [S]);
  s.useEffect(function() {
    S.forEach(function(_) {
      var D = Q(_, 2), R = D[0], T = D[1];
      i(R, T);
    });
  }, [S]), s.useImperativeHandle(t, function() {
    var _ = {
      scrollTo: function(R) {
        var T;
        (T = y.current) === null || T === void 0 || T.scrollTo(R);
      }
    };
    return Object.defineProperty(_, "scrollLeft", {
      get: function() {
        var R;
        return ((R = y.current) === null || R === void 0 ? void 0 : R.getScrollInfo().x) || 0;
      },
      set: function(R) {
        var T;
        (T = y.current) === null || T === void 0 || T.scrollTo({
          left: R
        });
      }
    }), _;
  });
  var x = function(D, R) {
    var T, L = (T = C[R]) === null || T === void 0 ? void 0 : T.record, F = D.onCell;
    if (F) {
      var j, A = F(L, R);
      return (j = A == null ? void 0 : A.rowSpan) !== null && j !== void 0 ? j : 1;
    }
    return 1;
  }, w = function(D) {
    var R = D.start, T = D.end, L = D.getSize, F = D.offsetY;
    if (T < 0)
      return null;
    for (var j = a.filter(
      // rowSpan is 0
      function(Z) {
        return x(Z, R) === 0;
      }
    ), A = R, B = function(H) {
      if (j = j.filter(function(U) {
        return x(U, H) === 0;
      }), !j.length)
        return A = H, 1;
    }, K = R; K >= 0 && !B(K); K -= 1)
      ;
    for (var Y = a.filter(
      // rowSpan is not 1
      function(Z) {
        return x(Z, T) !== 1;
      }
    ), G = T, te = function(H) {
      if (Y = Y.filter(function(U) {
        return x(U, H) !== 1;
      }), !Y.length)
        return G = Math.max(H - 1, T), 1;
    }, ee = T; ee < C.length && !te(ee); ee += 1)
      ;
    for (var oe = [], X = function(H) {
      var U = C[H];
      if (!U)
        return 1;
      a.some(function(ae) {
        return x(ae, H) > 1;
      }) && oe.push(H);
    }, W = A; W <= G; W += 1)
      X(W);
    var re = oe.map(function(Z) {
      var H = C[Z], U = l(H.record, Z), ae = function(se) {
        var ie = Z + se - 1, me = l(C[ie].record, ie), Se = L(U, me);
        return Se.bottom - Se.top;
      }, ue = L(U);
      return /* @__PURE__ */ s.createElement(Vd, {
        key: Z,
        data: H,
        rowKey: U,
        index: Z,
        style: {
          top: -F + ue.top
        },
        extra: !0,
        getHeight: ae
      });
    });
    return re;
  }, N = s.useMemo(function() {
    return {
      columnsOffset: $
    };
  }, [$]), O = "".concat(u, "-tbody"), E = b(["body", "wrapper"]), I = b(["body", "row"], "div"), k = b(["body", "cell"], "div"), M;
  if (C.length) {
    var P = {};
    h && (P.position = "sticky", P.bottom = 0, mt(h) === "object" && h.offsetScroll && (P.bottom = h.offsetScroll)), M = /* @__PURE__ */ s.createElement(Us, {
      fullHeight: !1,
      ref: y,
      styles: {
        horizontalScrollBar: P
      },
      className: J(O, "".concat(O, "-virtual")),
      height: p,
      itemHeight: g || 24,
      data: C,
      itemKey: function(D) {
        return l(D.record);
      },
      component: E,
      scrollWidth: m,
      onVirtualScroll: function(D) {
        var R = D.x;
        r({
          scrollLeft: R
        });
      },
      extraRender: w
    }, function(_, D, R) {
      var T = l(_.record, D);
      return /* @__PURE__ */ s.createElement(Vd, fe({
        data: _,
        rowKey: T,
        index: D
      }, R));
    });
  } else
    M = /* @__PURE__ */ s.createElement(I, {
      className: J("".concat(u, "-placeholder"))
    }, /* @__PURE__ */ s.createElement(qo, {
      component: k,
      prefixCls: u
    }, f));
  return /* @__PURE__ */ s.createElement($$.Provider, {
    value: N
  }, M);
}), w$ = Fa(uH);
process.env.NODE_ENV !== "production" && (w$.displayName = "ResponseGrid");
var dH = function(t, n) {
  var r = n.ref, o = n.onScroll;
  return /* @__PURE__ */ s.createElement(w$, {
    ref: r,
    data: t,
    onScroll: o
  });
};
function fH(e, t) {
  var n = e.columns, r = e.scroll, o = e.sticky, a = e.prefixCls, i = a === void 0 ? C$ : a, l = e.className, c = e.listItemHeight, u = e.components, d = r || {}, f = d.x, m = d.y;
  typeof f != "number" && (process.env.NODE_ENV !== "production" && tt(!f, "`scroll.x` in virtual table must be number."), f = 1), typeof m != "number" && (m = 500, process.env.NODE_ENV !== "production" && tt(!1, "`scroll.y` in virtual table must be number."));
  var v = Lt(function(p, g) {
    return nr(u, p) || g;
  }), h = s.useMemo(function() {
    return {
      sticky: o,
      scrollY: m,
      listItemHeight: c,
      getComponent: v
    };
  }, [o, m, c, v]);
  return /* @__PURE__ */ s.createElement(Lm.Provider, {
    value: h
  }, /* @__PURE__ */ s.createElement(ja, fe({}, e, {
    className: J(l, "".concat(i, "-virtual")),
    scroll: V(V({}, r), {}, {
      x: f
    }),
    components: V(V({}, u), {}, {
      body: dH
    }),
    columns: n,
    internalHooks: ol,
    tailor: !0,
    ref: t
  })));
}
var E$ = /* @__PURE__ */ s.forwardRef(fH);
process.env.NODE_ENV !== "production" && (E$.displayName = "VirtualTable");
function O$(e) {
  return r$(E$, e);
}
O$();
function mH(e) {
  return null;
}
function vH(e) {
  return null;
}
var Fm = /* @__PURE__ */ s.createContext(null), gH = function(t) {
  for (var n = t.prefixCls, r = t.level, o = t.isStart, a = t.isEnd, i = "".concat(n, "-indent-unit"), l = [], c = 0; c < r; c += 1)
    l.push(/* @__PURE__ */ s.createElement("span", {
      key: c,
      className: J(i, z(z({}, "".concat(i, "-start"), o[c]), "".concat(i, "-end"), a[c]))
    }));
  return /* @__PURE__ */ s.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(n, "-indent")
  }, l);
};
const pH = /* @__PURE__ */ s.memo(gH);
var hH = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], Kp = "open", qp = "close", bH = "---", yH = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n() {
    var r;
    $n(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), z(Me(r), "state", {
      dragNodeHighlight: !1
    }), z(Me(r), "selectHandle", void 0), z(Me(r), "cacheIndent", void 0), z(Me(r), "onSelectorClick", function(l) {
      var c = r.props.context.onNodeClick;
      c(l, yn(r.props)), r.isSelectable() ? r.onSelect(l) : r.onCheck(l);
    }), z(Me(r), "onSelectorDoubleClick", function(l) {
      var c = r.props.context.onNodeDoubleClick;
      c(l, yn(r.props));
    }), z(Me(r), "onSelect", function(l) {
      if (!r.isDisabled()) {
        var c = r.props.context.onNodeSelect;
        c(l, yn(r.props));
      }
    }), z(Me(r), "onCheck", function(l) {
      if (!r.isDisabled()) {
        var c = r.props, u = c.disableCheckbox, d = c.checked, f = r.props.context.onNodeCheck;
        if (!(!r.isCheckable() || u)) {
          var m = !d;
          f(l, yn(r.props), m);
        }
      }
    }), z(Me(r), "onMouseEnter", function(l) {
      var c = r.props.context.onNodeMouseEnter;
      c(l, yn(r.props));
    }), z(Me(r), "onMouseLeave", function(l) {
      var c = r.props.context.onNodeMouseLeave;
      c(l, yn(r.props));
    }), z(Me(r), "onContextMenu", function(l) {
      var c = r.props.context.onNodeContextMenu;
      c(l, yn(r.props));
    }), z(Me(r), "onDragStart", function(l) {
      var c = r.props.context.onNodeDragStart;
      l.stopPropagation(), r.setState({
        dragNodeHighlight: !0
      }), c(l, Me(r));
      try {
        l.dataTransfer.setData("text/plain", "");
      } catch {
      }
    }), z(Me(r), "onDragEnter", function(l) {
      var c = r.props.context.onNodeDragEnter;
      l.preventDefault(), l.stopPropagation(), c(l, Me(r));
    }), z(Me(r), "onDragOver", function(l) {
      var c = r.props.context.onNodeDragOver;
      l.preventDefault(), l.stopPropagation(), c(l, Me(r));
    }), z(Me(r), "onDragLeave", function(l) {
      var c = r.props.context.onNodeDragLeave;
      l.stopPropagation(), c(l, Me(r));
    }), z(Me(r), "onDragEnd", function(l) {
      var c = r.props.context.onNodeDragEnd;
      l.stopPropagation(), r.setState({
        dragNodeHighlight: !1
      }), c(l, Me(r));
    }), z(Me(r), "onDrop", function(l) {
      var c = r.props.context.onNodeDrop;
      l.preventDefault(), l.stopPropagation(), r.setState({
        dragNodeHighlight: !1
      }), c(l, Me(r));
    }), z(Me(r), "onExpand", function(l) {
      var c = r.props, u = c.loading, d = c.context.onNodeExpand;
      u || d(l, yn(r.props));
    }), z(Me(r), "setSelectHandle", function(l) {
      r.selectHandle = l;
    }), z(Me(r), "getNodeState", function() {
      var l = r.props.expanded;
      return r.isLeaf() ? null : l ? Kp : qp;
    }), z(Me(r), "hasChildren", function() {
      var l = r.props.eventKey, c = r.props.context.keyEntities, u = tr(c, l) || {}, d = u.children;
      return !!(d || []).length;
    }), z(Me(r), "isLeaf", function() {
      var l = r.props, c = l.isLeaf, u = l.loaded, d = r.props.context.loadData, f = r.hasChildren();
      return c === !1 ? !1 : c || !d && !f || d && u && !f;
    }), z(Me(r), "isDisabled", function() {
      var l = r.props.disabled, c = r.props.context.disabled;
      return !!(c || l);
    }), z(Me(r), "isCheckable", function() {
      var l = r.props.checkable, c = r.props.context.checkable;
      return !c || l === !1 ? !1 : c;
    }), z(Me(r), "syncLoadData", function(l) {
      var c = l.expanded, u = l.loading, d = l.loaded, f = r.props.context, m = f.loadData, v = f.onNodeLoad;
      u || m && c && !r.isLeaf() && !r.hasChildren() && !d && v(yn(r.props));
    }), z(Me(r), "isDraggable", function() {
      var l = r.props, c = l.data, u = l.context.draggable;
      return !!(u && (!u.nodeDraggable || u.nodeDraggable(c)));
    }), z(Me(r), "renderDragHandler", function() {
      var l = r.props.context, c = l.draggable, u = l.prefixCls;
      return c != null && c.icon ? /* @__PURE__ */ s.createElement("span", {
        className: "".concat(u, "-draggable-icon")
      }, c.icon) : null;
    }), z(Me(r), "renderSwitcherIconDom", function(l) {
      var c = r.props.switcherIcon, u = r.props.context.switcherIcon, d = c || u;
      return typeof d == "function" ? d(V(V({}, r.props), {}, {
        isLeaf: l
      })) : d;
    }), z(Me(r), "renderSwitcher", function() {
      var l = r.props.expanded, c = r.props.context.prefixCls;
      if (r.isLeaf()) {
        var u = r.renderSwitcherIconDom(!0);
        return u !== !1 ? /* @__PURE__ */ s.createElement("span", {
          className: J("".concat(c, "-switcher"), "".concat(c, "-switcher-noop"))
        }, u) : null;
      }
      var d = J("".concat(c, "-switcher"), "".concat(c, "-switcher_").concat(l ? Kp : qp)), f = r.renderSwitcherIconDom(!1);
      return f !== !1 ? /* @__PURE__ */ s.createElement("span", {
        onClick: r.onExpand,
        className: d
      }, f) : null;
    }), z(Me(r), "renderCheckbox", function() {
      var l = r.props, c = l.checked, u = l.halfChecked, d = l.disableCheckbox, f = r.props.context.prefixCls, m = r.isDisabled(), v = r.isCheckable();
      if (!v)
        return null;
      var h = typeof v != "boolean" ? v : null;
      return /* @__PURE__ */ s.createElement("span", {
        className: J("".concat(f, "-checkbox"), c && "".concat(f, "-checkbox-checked"), !c && u && "".concat(f, "-checkbox-indeterminate"), (m || d) && "".concat(f, "-checkbox-disabled")),
        onClick: r.onCheck
      }, h);
    }), z(Me(r), "renderIcon", function() {
      var l = r.props.loading, c = r.props.context.prefixCls;
      return /* @__PURE__ */ s.createElement("span", {
        className: J("".concat(c, "-iconEle"), "".concat(c, "-icon__").concat(r.getNodeState() || "docu"), l && "".concat(c, "-icon_loading"))
      });
    }), z(Me(r), "renderSelector", function() {
      var l = r.state.dragNodeHighlight, c = r.props, u = c.title, d = u === void 0 ? bH : u, f = c.selected, m = c.icon, v = c.loading, h = c.data, p = r.props.context, g = p.prefixCls, b = p.showIcon, y = p.icon, C = p.loadData, S = p.titleRender, $ = r.isDisabled(), x = "".concat(g, "-node-content-wrapper"), w;
      if (b) {
        var N = m || y;
        w = N ? /* @__PURE__ */ s.createElement("span", {
          className: J("".concat(g, "-iconEle"), "".concat(g, "-icon__customize"))
        }, typeof N == "function" ? N(r.props) : N) : r.renderIcon();
      } else
        C && v && (w = r.renderIcon());
      var O;
      typeof d == "function" ? O = d(h) : S ? O = S(h) : O = d;
      var E = /* @__PURE__ */ s.createElement("span", {
        className: "".concat(g, "-title")
      }, O);
      return /* @__PURE__ */ s.createElement("span", {
        ref: r.setSelectHandle,
        title: typeof d == "string" ? d : "",
        className: J("".concat(x), "".concat(x, "-").concat(r.getNodeState() || "normal"), !$ && (f || l) && "".concat(g, "-node-selected")),
        onMouseEnter: r.onMouseEnter,
        onMouseLeave: r.onMouseLeave,
        onContextMenu: r.onContextMenu,
        onClick: r.onSelectorClick,
        onDoubleClick: r.onSelectorDoubleClick
      }, w, E, r.renderDropIndicator());
    }), z(Me(r), "renderDropIndicator", function() {
      var l = r.props, c = l.disabled, u = l.eventKey, d = r.props.context, f = d.draggable, m = d.dropLevelOffset, v = d.dropPosition, h = d.prefixCls, p = d.indent, g = d.dropIndicatorRender, b = d.dragOverNodeKey, y = d.direction, C = !!f, S = !c && C && b === u, $ = p ?? r.cacheIndent;
      return r.cacheIndent = p, S ? g({
        dropPosition: v,
        dropLevelOffset: m,
        indent: $,
        prefixCls: h,
        direction: y
      }) : null;
    }), r;
  }
  return wn(n, [{
    key: "componentDidMount",
    value: (
      // Isomorphic needn't load data in server side
      function() {
        this.syncLoadData(this.props);
      }
    )
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "isSelectable",
    value: function() {
      var o = this.props.selectable, a = this.props.context.selectable;
      return typeof o == "boolean" ? o : a;
    }
  }, {
    key: "render",
    value: (
      // =========================== Render ===========================
      function() {
        var o, a = this.props, i = a.eventKey, l = a.className, c = a.style, u = a.dragOver, d = a.dragOverGapTop, f = a.dragOverGapBottom, m = a.isLeaf, v = a.isStart, h = a.isEnd, p = a.expanded, g = a.selected, b = a.checked, y = a.halfChecked, C = a.loading, S = a.domRef, $ = a.active;
        a.data;
        var x = a.onMouseMove, w = a.selectable, N = vt(a, hH), O = this.props.context, E = O.prefixCls, I = O.filterTreeNode, k = O.keyEntities, M = O.dropContainerKey, P = O.dropTargetKey, _ = O.draggingNodeKey, D = this.isDisabled(), R = Bn(N, {
          aria: !0,
          data: !0
        }), T = tr(k, i) || {}, L = T.level, F = h[h.length - 1], j = this.isDraggable(), A = !D && j, B = _ === i, K = w !== void 0 ? {
          "aria-selected": !!w
        } : void 0;
        return /* @__PURE__ */ s.createElement("div", fe({
          ref: S,
          className: J(l, "".concat(E, "-treenode"), (o = {}, z(z(z(z(z(z(z(z(z(z(o, "".concat(E, "-treenode-disabled"), D), "".concat(E, "-treenode-switcher-").concat(p ? "open" : "close"), !m), "".concat(E, "-treenode-checkbox-checked"), b), "".concat(E, "-treenode-checkbox-indeterminate"), y), "".concat(E, "-treenode-selected"), g), "".concat(E, "-treenode-loading"), C), "".concat(E, "-treenode-active"), $), "".concat(E, "-treenode-leaf-last"), F), "".concat(E, "-treenode-draggable"), j), "dragging", B), z(z(z(z(z(z(o, "drop-target", P === i), "drop-container", M === i), "drag-over", !D && u), "drag-over-gap-top", !D && d), "drag-over-gap-bottom", !D && f), "filter-node", I && I(yn(this.props))))),
          style: c,
          draggable: A,
          "aria-grabbed": B,
          onDragStart: A ? this.onDragStart : void 0,
          onDragEnter: j ? this.onDragEnter : void 0,
          onDragOver: j ? this.onDragOver : void 0,
          onDragLeave: j ? this.onDragLeave : void 0,
          onDrop: j ? this.onDrop : void 0,
          onDragEnd: j ? this.onDragEnd : void 0,
          onMouseMove: x
        }, K, R), /* @__PURE__ */ s.createElement(pH, {
          prefixCls: E,
          level: L,
          isStart: v,
          isEnd: h
        }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
      }
    )
  }]), n;
}(s.Component), Oa = function(t) {
  return /* @__PURE__ */ s.createElement(Fm.Consumer, null, function(n) {
    return /* @__PURE__ */ s.createElement(yH, fe({}, t, {
      context: n
    }));
  });
};
Oa.displayName = "TreeNode";
Oa.isTreeNode = 1;
function Or(e, t) {
  if (!e)
    return [];
  var n = e.slice(), r = n.indexOf(t);
  return r >= 0 && n.splice(r, 1), n;
}
function Lr(e, t) {
  var n = (e || []).slice();
  return n.indexOf(t) === -1 && n.push(t), n;
}
function jm(e) {
  return e.split("-");
}
function CH(e, t) {
  var n = [], r = tr(t, e);
  function o() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    a.forEach(function(i) {
      var l = i.key, c = i.children;
      n.push(l), o(c);
    });
  }
  return o(r.children), n;
}
function SH(e) {
  if (e.parent) {
    var t = jm(e.pos);
    return Number(t[t.length - 1]) === e.parent.children.length - 1;
  }
  return !1;
}
function xH(e) {
  var t = jm(e.pos);
  return Number(t[t.length - 1]) === 0;
}
function Gp(e, t, n, r, o, a, i, l, c, u) {
  var d, f = e.clientX, m = e.clientY, v = e.target.getBoundingClientRect(), h = v.top, p = v.height, g = (u === "rtl" ? -1 : 1) * (((o == null ? void 0 : o.x) || 0) - f), b = (g - 12) / r, y = c.filter(function(D) {
    var R;
    return (R = l[D]) === null || R === void 0 || (R = R.children) === null || R === void 0 ? void 0 : R.length;
  }), C = tr(l, n.props.eventKey);
  if (m < h + p / 2) {
    var S = i.findIndex(function(D) {
      return D.key === C.key;
    }), $ = S <= 0 ? 0 : S - 1, x = i[$].key;
    C = tr(l, x);
  }
  var w = C.key, N = C, O = C.key, E = 0, I = 0;
  if (!y.includes(w))
    for (var k = 0; k < b && SH(C); k += 1)
      C = C.parent, I += 1;
  var M = t.props.data, P = C.node, _ = !0;
  return xH(C) && C.level === 0 && m < h + p / 2 && a({
    dragNode: M,
    dropNode: P,
    dropPosition: -1
  }) && C.key === n.props.eventKey ? E = -1 : (N.children || []).length && y.includes(O) ? a({
    dragNode: M,
    dropNode: P,
    dropPosition: 0
  }) ? E = 0 : _ = !1 : I === 0 ? b > -1.5 ? a({
    dragNode: M,
    dropNode: P,
    dropPosition: 1
  }) ? E = 1 : _ = !1 : a({
    dragNode: M,
    dropNode: P,
    dropPosition: 0
  }) ? E = 0 : a({
    dragNode: M,
    dropNode: P,
    dropPosition: 1
  }) ? E = 1 : _ = !1 : a({
    dragNode: M,
    dropNode: P,
    dropPosition: 1
  }) ? E = 1 : _ = !1, {
    dropPosition: E,
    dropLevelOffset: I,
    dropTargetKey: C.key,
    dropTargetPos: C.pos,
    dragOverNodeKey: O,
    dropContainerKey: E === 0 ? null : ((d = C.parent) === null || d === void 0 ? void 0 : d.key) || null,
    dropAllowed: _
  };
}
function Up(e, t) {
  if (e) {
    var n = t.multiple;
    return n ? e.slice() : e.length ? [e[0]] : e;
  }
}
function du(e) {
  if (!e)
    return null;
  var t;
  if (Array.isArray(e))
    t = {
      checkedKeys: e,
      halfCheckedKeys: void 0
    };
  else if (mt(e) === "object")
    t = {
      checkedKeys: e.checked || void 0,
      halfCheckedKeys: e.halfChecked || void 0
    };
  else
    return tt(!1, "`checkedKeys` is not an array or an object"), null;
  return t;
}
function Wd(e, t) {
  var n = /* @__PURE__ */ new Set();
  function r(o) {
    if (!n.has(o)) {
      var a = tr(t, o);
      if (a) {
        n.add(o);
        var i = a.parent, l = a.node;
        l.disabled || i && r(i.key);
      }
    }
  }
  return (e || []).forEach(function(o) {
    r(o);
  }), be(n);
}
function $H(e) {
  const [t, n] = Ht(null);
  return [Wn((a, i, l) => {
    const c = t ?? a, u = Math.min(c || 0, a), d = Math.max(c || 0, a), f = i.slice(u, d + 1).map((h) => e(h)), m = f.some((h) => !l.has(h)), v = [];
    return f.forEach((h) => {
      m ? (l.has(h) || v.push(h), l.add(h)) : (l.delete(h), v.push(h));
    }), n(m ? d : null), v;
  }, [t]), (a) => {
    n(a);
  }];
}
const Nr = {}, Kd = "SELECT_ALL", qd = "SELECT_INVERT", Gd = "SELECT_NONE", Yp = [], N$ = (e, t) => {
  let n = [];
  return (t || []).forEach((r) => {
    n.push(r), r && typeof r == "object" && e in r && (n = [].concat(be(n), be(N$(e, r[e]))));
  }), n;
}, wH = (e, t) => {
  const {
    preserveSelectedRowKeys: n,
    selectedRowKeys: r,
    defaultSelectedRowKeys: o,
    getCheckboxProps: a,
    onChange: i,
    onSelect: l,
    onSelectAll: c,
    onSelectInvert: u,
    onSelectNone: d,
    onSelectMultiple: f,
    columnWidth: m,
    type: v,
    selections: h,
    fixed: p,
    renderCell: g,
    hideSelectAll: b,
    checkStrictly: y = !0
  } = t || {}, {
    prefixCls: C,
    data: S,
    pageData: $,
    getRecordByKey: x,
    getRowKey: w,
    expandType: N,
    childrenColumnName: O,
    locale: E,
    getPopupContainer: I
  } = e, k = Rt("Table"), [M, P] = $H((W) => W), [_, D] = Vt(r || o || Yp, {
    value: r
  }), R = s.useRef(/* @__PURE__ */ new Map()), T = Wn((W) => {
    if (n) {
      const re = /* @__PURE__ */ new Map();
      W.forEach((Z) => {
        let H = x(Z);
        !H && R.current.has(Z) && (H = R.current.get(Z)), re.set(Z, H);
      }), R.current = re;
    }
  }, [x, n]);
  s.useEffect(() => {
    T(_);
  }, [_]);
  const {
    keyEntities: L
  } = nn(() => {
    if (y)
      return {
        keyEntities: null
      };
    let W = S;
    if (n) {
      const re = new Set(S.map((H, U) => w(H, U))), Z = Array.from(R.current).reduce((H, U) => {
        let [ae, ue] = U;
        return re.has(ae) ? H : H.concat(ue);
      }, []);
      W = [].concat(be(W), be(Z));
    }
    return Cm(W, {
      externalGetKey: w,
      childrenPropName: O
    });
  }, [S, w, y, O, n]), F = nn(() => N$(O, $), [O, $]), j = nn(() => {
    const W = /* @__PURE__ */ new Map();
    return F.forEach((re, Z) => {
      const H = w(re, Z), U = (a ? a(re) : null) || {};
      W.set(H, U), process.env.NODE_ENV !== "production" && k(!("checked" in U || "defaultChecked" in U), "usage", "Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.");
    }), W;
  }, [F, w, a]), A = Wn((W) => {
    var re;
    return !!(!((re = j.get(w(W))) === null || re === void 0) && re.disabled);
  }, [j, w]), [B, K] = nn(() => {
    if (y)
      return [_ || [], []];
    const {
      checkedKeys: W,
      halfCheckedKeys: re
    } = va(_, !0, L, A);
    return [W || [], re];
  }, [_, y, L, A]), Y = nn(() => {
    const W = v === "radio" ? B.slice(0, 1) : B;
    return new Set(W);
  }, [B, v]), G = nn(() => v === "radio" ? /* @__PURE__ */ new Set() : new Set(K), [K, v]);
  s.useEffect(() => {
    t || D(Yp);
  }, [!!t]);
  const te = Wn((W, re) => {
    let Z, H;
    T(W), n ? (Z = W, H = W.map((U) => R.current.get(U))) : (Z = [], H = [], W.forEach((U) => {
      const ae = x(U);
      ae !== void 0 && (Z.push(U), H.push(ae));
    })), D(Z), i == null || i(Z, H, {
      type: re
    });
  }, [D, x, i, n]), ee = Wn((W, re, Z, H) => {
    if (l) {
      const U = Z.map((ae) => x(ae));
      l(x(W), re, U, H);
    }
    te(Z, "single");
  }, [l, x, te]), oe = nn(() => !h || b ? null : (h === !0 ? [Kd, qd, Gd] : h).map((re) => re === Kd ? {
    key: "all",
    text: E.selectionAll,
    onSelect() {
      te(S.map((Z, H) => w(Z, H)).filter((Z) => {
        const H = j.get(Z);
        return !(H != null && H.disabled) || Y.has(Z);
      }), "all");
    }
  } : re === qd ? {
    key: "invert",
    text: E.selectInvert,
    onSelect() {
      const Z = new Set(Y);
      $.forEach((U, ae) => {
        const ue = w(U, ae), de = j.get(ue);
        de != null && de.disabled || (Z.has(ue) ? Z.delete(ue) : Z.add(ue));
      });
      const H = Array.from(Z);
      u && (k.deprecated(!1, "onSelectInvert", "onChange"), u(H)), te(H, "invert");
    }
  } : re === Gd ? {
    key: "none",
    text: E.selectNone,
    onSelect() {
      d == null || d(), te(Array.from(Y).filter((Z) => {
        const H = j.get(Z);
        return H == null ? void 0 : H.disabled;
      }), "none");
    }
  } : re).map((re) => Object.assign(Object.assign({}, re), {
    onSelect: function() {
      for (var Z, H, U = arguments.length, ae = new Array(U), ue = 0; ue < U; ue++)
        ae[ue] = arguments[ue];
      (H = re.onSelect) === null || H === void 0 || (Z = H).call.apply(Z, [re].concat(ae)), P(null);
    }
  })), [h, Y, $, w, u, te]);
  return [Wn((W) => {
    var re;
    if (!t)
      return process.env.NODE_ENV !== "production" && k(!W.includes(Nr), "usage", "`rowSelection` is not config but `SELECTION_COLUMN` exists in the `columns`."), W.filter((ke) => ke !== Nr);
    let Z = be(W);
    const H = new Set(Y), U = F.map(w).filter((ke) => !j.get(ke).disabled), ae = U.every((ke) => H.has(ke)), ue = U.some((ke) => H.has(ke)), de = () => {
      const ke = [];
      ae ? U.forEach((Ee) => {
        H.delete(Ee), ke.push(Ee);
      }) : U.forEach((Ee) => {
        H.has(Ee) || (H.add(Ee), ke.push(Ee));
      });
      const Le = Array.from(H);
      c == null || c(!ae, Le.map((Ee) => x(Ee)), ke.map((Ee) => x(Ee))), te(Le, "all"), P(null);
    };
    let se, ie;
    if (v !== "radio") {
      let ke;
      if (oe) {
        const pe = {
          getPopupContainer: I,
          items: oe.map((Pe, Re) => {
            const {
              key: at,
              text: Ze,
              onSelect: Ie
            } = Pe;
            return {
              key: at ?? Re,
              onClick: () => {
                Ie == null || Ie(U);
              },
              label: Ze
            };
          })
        };
        ke = /* @__PURE__ */ s.createElement("div", {
          className: `${C}-selection-extra`
        }, /* @__PURE__ */ s.createElement(dc, {
          menu: pe,
          getPopupContainer: I
        }, /* @__PURE__ */ s.createElement("span", null, /* @__PURE__ */ s.createElement(Vy, null))));
      }
      const Le = F.map((pe, Pe) => {
        const Re = w(pe, Pe), at = j.get(Re) || {};
        return Object.assign({
          checked: H.has(Re)
        }, at);
      }).filter((pe) => {
        let {
          disabled: Pe
        } = pe;
        return Pe;
      }), Ee = !!Le.length && Le.length === F.length, xe = Ee && Le.every((pe) => {
        let {
          checked: Pe
        } = pe;
        return Pe;
      }), he = Ee && Le.some((pe) => {
        let {
          checked: Pe
        } = pe;
        return Pe;
      });
      ie = /* @__PURE__ */ s.createElement(Ea, {
        checked: Ee ? xe : !!F.length && ae,
        indeterminate: Ee ? !xe && he : !ae && ue,
        onChange: de,
        disabled: F.length === 0 || Ee,
        "aria-label": ke ? "Custom selection" : "Select all",
        skipGroup: !0
      }), se = !b && /* @__PURE__ */ s.createElement("div", {
        className: `${C}-selection`
      }, ie, ke);
    }
    let me;
    v === "radio" ? me = (ke, Le, Ee) => {
      const xe = w(Le, Ee), he = H.has(xe);
      return {
        node: /* @__PURE__ */ s.createElement(tl, Object.assign({}, j.get(xe), {
          checked: he,
          onClick: (pe) => pe.stopPropagation(),
          onChange: (pe) => {
            H.has(xe) || ee(xe, !0, [xe], pe.nativeEvent);
          }
        })),
        checked: he
      };
    } : me = (ke, Le, Ee) => {
      var xe;
      const he = w(Le, Ee), pe = H.has(he), Pe = G.has(he), Re = j.get(he);
      let at;
      return N === "nest" ? (at = Pe, process.env.NODE_ENV !== "production" && k(typeof (Re == null ? void 0 : Re.indeterminate) != "boolean", "usage", "set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.")) : at = (xe = Re == null ? void 0 : Re.indeterminate) !== null && xe !== void 0 ? xe : Pe, {
        node: /* @__PURE__ */ s.createElement(Ea, Object.assign({}, Re, {
          indeterminate: at,
          checked: pe,
          skipGroup: !0,
          onClick: (Ze) => Ze.stopPropagation(),
          onChange: (Ze) => {
            let {
              nativeEvent: Ie
            } = Ze;
            const {
              shiftKey: Be
            } = Ie, bt = U.findIndex((nt) => nt === he), He = B.some((nt) => U.includes(nt));
            if (Be && y && He) {
              const nt = M(bt, U, H), et = Array.from(H);
              f == null || f(!pe, et.map((Ge) => x(Ge)), nt.map((Ge) => x(Ge))), te(et, "multiple");
            } else {
              const nt = B;
              if (y) {
                const et = pe ? Or(nt, he) : Lr(nt, he);
                ee(he, !pe, et, Ie);
              } else {
                const et = va([].concat(be(nt), [he]), !0, L, A), {
                  checkedKeys: Ge,
                  halfCheckedKeys: Ae
                } = et;
                let qe = Ge;
                if (pe) {
                  const Je = new Set(Ge);
                  Je.delete(he), qe = va(Array.from(Je), {
                    checked: !1,
                    halfCheckedKeys: Ae
                  }, L, A).checkedKeys;
                }
                ee(he, !pe, qe, Ie);
              }
            }
            P(pe ? null : bt);
          }
        })),
        checked: pe
      };
    };
    const Se = (ke, Le, Ee) => {
      const {
        node: xe,
        checked: he
      } = me(ke, Le, Ee);
      return g ? g(he, Le, Ee, xe) : xe;
    };
    if (!Z.includes(Nr))
      if (Z.findIndex((ke) => {
        var Le;
        return ((Le = ke[hi]) === null || Le === void 0 ? void 0 : Le.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [ke, ...Le] = Z;
        Z = [ke, Nr].concat(be(Le));
      } else
        Z = [Nr].concat(be(Z));
    const ve = Z.indexOf(Nr);
    process.env.NODE_ENV !== "production" && k(Z.filter((ke) => ke === Nr).length <= 1, "usage", "Multiple `SELECTION_COLUMN` exist in `columns`."), Z = Z.filter((ke, Le) => ke !== Nr || Le === ve);
    const ge = Z[ve - 1], $e = Z[ve + 1];
    let we = p;
    we === void 0 && (($e == null ? void 0 : $e.fixed) !== void 0 ? we = $e.fixed : (ge == null ? void 0 : ge.fixed) !== void 0 && (we = ge.fixed)), we && ge && ((re = ge[hi]) === null || re === void 0 ? void 0 : re.columnType) === "EXPAND_COLUMN" && ge.fixed === void 0 && (ge.fixed = we);
    const _e = J(`${C}-selection-col`, {
      [`${C}-selection-col-with-dropdown`]: h && v === "checkbox"
    }), ze = () => t != null && t.columnTitle ? typeof t.columnTitle == "function" ? t.columnTitle(ie) : t.columnTitle : se, Te = {
      fixed: we,
      width: m,
      className: `${C}-selection-column`,
      title: ze(),
      render: Se,
      onCell: t.onCell,
      [hi]: {
        className: _e
      }
    };
    return Z.map((ke) => ke === Nr ? Te : ke);
  }, [w, F, t, B, Y, G, m, oe, N, j, f, ee, A]), Y];
};
function EH(e, t) {
  return e._antProxy = e._antProxy || {}, Object.keys(t).forEach((n) => {
    if (!(n in e._antProxy)) {
      const r = e[n];
      e._antProxy[n] = r, e[n] = t[n];
    }
  }), e;
}
function OH(e, t) {
  return qr(e, () => {
    const n = t(), {
      nativeElement: r
    } = n;
    return typeof Proxy < "u" ? new Proxy(r, {
      get(o, a) {
        return n[a] ? n[a] : Reflect.get(o, a);
      }
    }) : EH(r, n);
  });
}
function NH(e) {
  return function(n) {
    let {
      prefixCls: r,
      onExpand: o,
      record: a,
      expanded: i,
      expandable: l
    } = n;
    const c = `${r}-row-expand-icon`;
    return /* @__PURE__ */ s.createElement("button", {
      type: "button",
      onClick: (u) => {
        o(a, u), u.stopPropagation();
      },
      className: J(c, {
        [`${c}-spaced`]: !l,
        [`${c}-expanded`]: l && i,
        [`${c}-collapsed`]: l && !i
      }),
      "aria-label": i ? e.collapse : e.expand,
      "aria-expanded": i
    });
  };
}
function IH(e) {
  return (n, r) => {
    const o = n.querySelector(`.${e}-container`);
    let a = r;
    if (o) {
      const i = getComputedStyle(o), l = parseInt(i.borderLeftWidth, 10), c = parseInt(i.borderRightWidth, 10);
      a = r - l - c;
    }
    return a;
  };
}
function ko(e, t) {
  return "key" in e && e.key !== void 0 && e.key !== null ? e.key : e.dataIndex ? Array.isArray(e.dataIndex) ? e.dataIndex.join(".") : e.dataIndex : t;
}
function al(e, t) {
  return t ? `${t}-${e}` : `${e}`;
}
function gc(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function PH(e, t) {
  const n = gc(e, t);
  return Object.prototype.toString.call(n) === "[object Object]" ? "" : n;
}
var RH = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, name: "filter", theme: "filled" };
const MH = RH;
var I$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: MH
  }));
};
process.env.NODE_ENV !== "production" && (I$.displayName = "FilterFilled");
const TH = /* @__PURE__ */ s.forwardRef(I$);
function _H(e) {
  const t = s.useRef(e), n = Gf();
  return [() => t.current, (r) => {
    t.current = r, n();
  }];
}
function DH(e) {
  var t = e.dropPosition, n = e.dropLevelOffset, r = e.indent, o = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (t) {
    case -1:
      o.top = 0, o.left = -n * r;
      break;
    case 1:
      o.bottom = 0, o.left = -n * r;
      break;
    case 0:
      o.bottom = 0, o.left = r;
      break;
  }
  return /* @__PURE__ */ s.createElement("div", {
    style: o
  });
}
function P$(e) {
  if (e == null)
    throw new TypeError("Cannot destructure " + e);
}
function kH(e, t) {
  var n = s.useState(!1), r = Q(n, 2), o = r[0], a = r[1];
  Pt(function() {
    if (o)
      return e(), function() {
        t();
      };
  }, [o]), Pt(function() {
    return a(!0), function() {
      a(!1);
    };
  }, []);
}
var LH = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], R$ = function(t, n) {
  var r = t.className, o = t.style, a = t.motion, i = t.motionNodes, l = t.motionType, c = t.onMotionStart, u = t.onMotionEnd, d = t.active, f = t.treeNodeRequiredProps, m = vt(t, LH), v = s.useState(!0), h = Q(v, 2), p = h[0], g = h[1], b = s.useContext(Fm), y = b.prefixCls, C = i && l !== "hide";
  Pt(function() {
    i && C !== p && g(C);
  }, [i]);
  var S = function() {
    i && c();
  }, $ = s.useRef(!1), x = function() {
    i && !$.current && ($.current = !0, u());
  };
  kH(S, x);
  var w = function(O) {
    C === O && x();
  };
  return i ? /* @__PURE__ */ s.createElement(An, fe({
    ref: n,
    visible: p
  }, a, {
    motionAppear: l === "show",
    onVisibleChanged: w
  }), function(N, O) {
    var E = N.className, I = N.style;
    return /* @__PURE__ */ s.createElement("div", {
      ref: O,
      className: J("".concat(y, "-treenode-motion"), E),
      style: I
    }, i.map(function(k) {
      var M = Object.assign({}, (P$(k.data), k.data)), P = k.title, _ = k.key, D = k.isStart, R = k.isEnd;
      delete M.children;
      var T = gi(_, f);
      return /* @__PURE__ */ s.createElement(Oa, fe({}, M, T, {
        title: P,
        active: d,
        data: k.data,
        key: _,
        isStart: D,
        isEnd: R
      }));
    }));
  }) : /* @__PURE__ */ s.createElement(Oa, fe({
    domRef: n,
    className: r,
    style: o
  }, m, {
    active: d
  }));
};
R$.displayName = "MotionTreeNode";
var FH = /* @__PURE__ */ s.forwardRef(R$);
function jH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = e.length, r = t.length;
  if (Math.abs(n - r) !== 1)
    return {
      add: !1,
      key: null
    };
  function o(a, i) {
    var l = /* @__PURE__ */ new Map();
    a.forEach(function(u) {
      l.set(u, !0);
    });
    var c = i.filter(function(u) {
      return !l.has(u);
    });
    return c.length === 1 ? c[0] : null;
  }
  return n < r ? {
    add: !0,
    key: o(e, t)
  } : {
    add: !1,
    key: o(t, e)
  };
}
function Xp(e, t, n) {
  var r = e.findIndex(function(l) {
    return l.key === n;
  }), o = e[r + 1], a = t.findIndex(function(l) {
    return l.key === n;
  });
  if (o) {
    var i = t.findIndex(function(l) {
      return l.key === o.key;
    });
    return t.slice(a + 1, i);
  }
  return t.slice(a + 1);
}
var zH = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], Qp = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, AH = function() {
}, Lo = "RC_TREE_MOTION_".concat(Math.random()), Ud = {
  key: Lo
}, M$ = {
  key: Lo,
  level: 0,
  index: 0,
  pos: "0",
  node: Ud,
  nodes: [Ud]
}, Jp = {
  parent: null,
  children: [],
  pos: M$.pos,
  data: Ud,
  title: null,
  key: Lo,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function Zp(e, t, n, r) {
  return t === !1 || !n ? e : e.slice(0, Math.ceil(n / r) + 1);
}
function eh(e) {
  var t = e.key, n = e.pos;
  return nl(t, n);
}
function BH(e) {
  for (var t = String(e.data.key), n = e; n.parent; )
    n = n.parent, t = "".concat(n.data.key, " > ").concat(t);
  return t;
}
var T$ = /* @__PURE__ */ s.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.data;
  e.selectable, e.checkable;
  var o = e.expandedKeys, a = e.selectedKeys, i = e.checkedKeys, l = e.loadedKeys, c = e.loadingKeys, u = e.halfCheckedKeys, d = e.keyEntities, f = e.disabled, m = e.dragging, v = e.dragOverNodeKey, h = e.dropPosition, p = e.motion, g = e.height, b = e.itemHeight, y = e.virtual, C = e.focusable, S = e.activeItem, $ = e.focused, x = e.tabIndex, w = e.onKeyDown, N = e.onFocus, O = e.onBlur, E = e.onActiveChange, I = e.onListChangeStart, k = e.onListChangeEnd, M = vt(e, zH), P = s.useRef(null), _ = s.useRef(null);
  s.useImperativeHandle(t, function() {
    return {
      scrollTo: function(me) {
        P.current.scrollTo(me);
      },
      getIndentWidth: function() {
        return _.current.offsetWidth;
      }
    };
  });
  var D = s.useState(o), R = Q(D, 2), T = R[0], L = R[1], F = s.useState(r), j = Q(F, 2), A = j[0], B = j[1], K = s.useState(r), Y = Q(K, 2), G = Y[0], te = Y[1], ee = s.useState([]), oe = Q(ee, 2), X = oe[0], W = oe[1], re = s.useState(null), Z = Q(re, 2), H = Z[0], U = Z[1], ae = s.useRef(r);
  ae.current = r;
  function ue() {
    var ie = ae.current;
    B(ie), te(ie), W([]), U(null), k();
  }
  Pt(function() {
    L(o);
    var ie = jH(T, o);
    if (ie.key !== null)
      if (ie.add) {
        var me = A.findIndex(function(_e) {
          var ze = _e.key;
          return ze === ie.key;
        }), Se = Zp(Xp(A, r, ie.key), y, g, b), ve = A.slice();
        ve.splice(me + 1, 0, Jp), te(ve), W(Se), U("show");
      } else {
        var ge = r.findIndex(function(_e) {
          var ze = _e.key;
          return ze === ie.key;
        }), $e = Zp(Xp(r, A, ie.key), y, g, b), we = r.slice();
        we.splice(ge + 1, 0, Jp), te(we), W($e), U("hide");
      }
    else
      A !== r && (B(r), te(r));
  }, [o, r]), s.useEffect(function() {
    m || ue();
  }, [m]);
  var de = p ? G : r, se = {
    expandedKeys: o,
    selectedKeys: a,
    loadedKeys: l,
    loadingKeys: c,
    checkedKeys: i,
    halfCheckedKeys: u,
    dragOverNodeKey: v,
    dropPosition: h,
    keyEntities: d
  };
  return /* @__PURE__ */ s.createElement(s.Fragment, null, $ && S && /* @__PURE__ */ s.createElement("span", {
    style: Qp,
    "aria-live": "assertive"
  }, BH(S)), /* @__PURE__ */ s.createElement("div", null, /* @__PURE__ */ s.createElement("input", {
    style: Qp,
    disabled: C === !1 || f,
    tabIndex: C !== !1 ? x : null,
    onKeyDown: w,
    onFocus: N,
    onBlur: O,
    value: "",
    onChange: AH,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ s.createElement("div", {
    className: "".concat(n, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ s.createElement("div", {
    className: "".concat(n, "-indent")
  }, /* @__PURE__ */ s.createElement("div", {
    ref: _,
    className: "".concat(n, "-indent-unit")
  }))), /* @__PURE__ */ s.createElement(Us, fe({}, M, {
    data: de,
    itemKey: eh,
    height: g,
    fullHeight: !1,
    virtual: y,
    itemHeight: b,
    prefixCls: "".concat(n, "-list"),
    ref: P,
    onVisibleChange: function(me, Se) {
      var ve = new Set(me), ge = Se.filter(function($e) {
        return !ve.has($e);
      });
      ge.some(function($e) {
        return eh($e) === Lo;
      }) && ue();
    }
  }), function(ie) {
    var me = ie.pos, Se = Object.assign({}, (P$(ie.data), ie.data)), ve = ie.title, ge = ie.key, $e = ie.isStart, we = ie.isEnd, _e = nl(ge, me);
    delete Se.key, delete Se.children;
    var ze = gi(_e, se);
    return /* @__PURE__ */ s.createElement(FH, fe({}, Se, ze, {
      title: ve,
      active: !!S && ge === S.key,
      pos: me,
      data: ie.data,
      isStart: $e,
      isEnd: we,
      motion: p,
      motionNodes: ge === Lo ? X : null,
      motionType: H,
      onMotionStart: I,
      onMotionEnd: ue,
      treeNodeRequiredProps: se,
      onMouseMove: function() {
        E(null);
      }
    }));
  }));
});
T$.displayName = "NodeList";
var HH = 10, zm = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n() {
    var r;
    $n(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), z(Me(r), "destroyed", !1), z(Me(r), "delayedDragEnterLogic", void 0), z(Me(r), "loadingRetryTimes", {}), z(Me(r), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: !0,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: wa()
    }), z(Me(r), "dragStartMousePosition", null), z(Me(r), "dragNode", void 0), z(Me(r), "currentMouseOverDroppableNodeKey", null), z(Me(r), "listRef", /* @__PURE__ */ s.createRef()), z(Me(r), "onNodeDragStart", function(l, c) {
      var u = r.state, d = u.expandedKeys, f = u.keyEntities, m = r.props.onDragStart, v = c.props.eventKey;
      r.dragNode = c, r.dragStartMousePosition = {
        x: l.clientX,
        y: l.clientY
      };
      var h = Or(d, v);
      r.setState({
        draggingNodeKey: v,
        dragChildrenKeys: CH(v, f),
        indent: r.listRef.current.getIndentWidth()
      }), r.setExpandedKeys(h), window.addEventListener("dragend", r.onWindowDragEnd), m == null || m({
        event: l,
        node: yn(c.props)
      });
    }), z(Me(r), "onNodeDragEnter", function(l, c) {
      var u = r.state, d = u.expandedKeys, f = u.keyEntities, m = u.dragChildrenKeys, v = u.flattenNodes, h = u.indent, p = r.props, g = p.onDragEnter, b = p.onExpand, y = p.allowDrop, C = p.direction, S = c.props, $ = S.pos, x = S.eventKey, w = Me(r), N = w.dragNode;
      if (r.currentMouseOverDroppableNodeKey !== x && (r.currentMouseOverDroppableNodeKey = x), !N) {
        r.resetDragState();
        return;
      }
      var O = Gp(l, N, c, h, r.dragStartMousePosition, y, v, f, d, C), E = O.dropPosition, I = O.dropLevelOffset, k = O.dropTargetKey, M = O.dropContainerKey, P = O.dropTargetPos, _ = O.dropAllowed, D = O.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        m.indexOf(k) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !_
      ) {
        r.resetDragState();
        return;
      }
      if (r.delayedDragEnterLogic || (r.delayedDragEnterLogic = {}), Object.keys(r.delayedDragEnterLogic).forEach(function(R) {
        clearTimeout(r.delayedDragEnterLogic[R]);
      }), N.props.eventKey !== c.props.eventKey && (l.persist(), r.delayedDragEnterLogic[$] = window.setTimeout(function() {
        if (r.state.draggingNodeKey !== null) {
          var R = be(d), T = tr(f, c.props.eventKey);
          T && (T.children || []).length && (R = Lr(d, c.props.eventKey)), "expandedKeys" in r.props || r.setExpandedKeys(R), b == null || b(R, {
            node: yn(c.props),
            expanded: !0,
            nativeEvent: l.nativeEvent
          });
        }
      }, 800)), N.props.eventKey === k && I === 0) {
        r.resetDragState();
        return;
      }
      r.setState({
        dragOverNodeKey: D,
        dropPosition: E,
        dropLevelOffset: I,
        dropTargetKey: k,
        dropContainerKey: M,
        dropTargetPos: P,
        dropAllowed: _
      }), g == null || g({
        event: l,
        node: yn(c.props),
        expandedKeys: d
      });
    }), z(Me(r), "onNodeDragOver", function(l, c) {
      var u = r.state, d = u.dragChildrenKeys, f = u.flattenNodes, m = u.keyEntities, v = u.expandedKeys, h = u.indent, p = r.props, g = p.onDragOver, b = p.allowDrop, y = p.direction, C = Me(r), S = C.dragNode;
      if (S) {
        var $ = Gp(l, S, c, h, r.dragStartMousePosition, b, f, m, v, y), x = $.dropPosition, w = $.dropLevelOffset, N = $.dropTargetKey, O = $.dropContainerKey, E = $.dropAllowed, I = $.dropTargetPos, k = $.dragOverNodeKey;
        d.indexOf(N) !== -1 || !E || (S.props.eventKey === N && w === 0 ? r.state.dropPosition === null && r.state.dropLevelOffset === null && r.state.dropTargetKey === null && r.state.dropContainerKey === null && r.state.dropTargetPos === null && r.state.dropAllowed === !1 && r.state.dragOverNodeKey === null || r.resetDragState() : x === r.state.dropPosition && w === r.state.dropLevelOffset && N === r.state.dropTargetKey && O === r.state.dropContainerKey && I === r.state.dropTargetPos && E === r.state.dropAllowed && k === r.state.dragOverNodeKey || r.setState({
          dropPosition: x,
          dropLevelOffset: w,
          dropTargetKey: N,
          dropContainerKey: O,
          dropTargetPos: I,
          dropAllowed: E,
          dragOverNodeKey: k
        }), g == null || g({
          event: l,
          node: yn(c.props)
        }));
      }
    }), z(Me(r), "onNodeDragLeave", function(l, c) {
      r.currentMouseOverDroppableNodeKey === c.props.eventKey && !l.currentTarget.contains(l.relatedTarget) && (r.resetDragState(), r.currentMouseOverDroppableNodeKey = null);
      var u = r.props.onDragLeave;
      u == null || u({
        event: l,
        node: yn(c.props)
      });
    }), z(Me(r), "onWindowDragEnd", function(l) {
      r.onNodeDragEnd(l, null, !0), window.removeEventListener("dragend", r.onWindowDragEnd);
    }), z(Me(r), "onNodeDragEnd", function(l, c) {
      var u = r.props.onDragEnd;
      r.setState({
        dragOverNodeKey: null
      }), r.cleanDragState(), u == null || u({
        event: l,
        node: yn(c.props)
      }), r.dragNode = null, window.removeEventListener("dragend", r.onWindowDragEnd);
    }), z(Me(r), "onNodeDrop", function(l, c) {
      var u, d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, f = r.state, m = f.dragChildrenKeys, v = f.dropPosition, h = f.dropTargetKey, p = f.dropTargetPos, g = f.dropAllowed;
      if (g) {
        var b = r.props.onDrop;
        if (r.setState({
          dragOverNodeKey: null
        }), r.cleanDragState(), h !== null) {
          var y = V(V({}, gi(h, r.getTreeNodeRequiredProps())), {}, {
            active: ((u = r.getActiveItem()) === null || u === void 0 ? void 0 : u.key) === h,
            data: tr(r.state.keyEntities, h).node
          }), C = m.indexOf(h) !== -1;
          tt(!C, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var S = jm(p), $ = {
            event: l,
            node: yn(y),
            dragNode: r.dragNode ? yn(r.dragNode.props) : null,
            dragNodesKeys: [r.dragNode.props.eventKey].concat(m),
            dropToGap: v !== 0,
            dropPosition: v + Number(S[S.length - 1])
          };
          d || b == null || b($), r.dragNode = null;
        }
      }
    }), z(Me(r), "cleanDragState", function() {
      var l = r.state.draggingNodeKey;
      l !== null && r.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), r.dragStartMousePosition = null, r.currentMouseOverDroppableNodeKey = null;
    }), z(Me(r), "triggerExpandActionExpand", function(l, c) {
      var u = r.state, d = u.expandedKeys, f = u.flattenNodes, m = c.expanded, v = c.key, h = c.isLeaf;
      if (!(h || l.shiftKey || l.metaKey || l.ctrlKey)) {
        var p = f.filter(function(b) {
          return b.key === v;
        })[0], g = yn(V(V({}, gi(v, r.getTreeNodeRequiredProps())), {}, {
          data: p.data
        }));
        r.setExpandedKeys(m ? Or(d, v) : Lr(d, v)), r.onNodeExpand(l, g);
      }
    }), z(Me(r), "onNodeClick", function(l, c) {
      var u = r.props, d = u.onClick, f = u.expandAction;
      f === "click" && r.triggerExpandActionExpand(l, c), d == null || d(l, c);
    }), z(Me(r), "onNodeDoubleClick", function(l, c) {
      var u = r.props, d = u.onDoubleClick, f = u.expandAction;
      f === "doubleClick" && r.triggerExpandActionExpand(l, c), d == null || d(l, c);
    }), z(Me(r), "onNodeSelect", function(l, c) {
      var u = r.state.selectedKeys, d = r.state, f = d.keyEntities, m = d.fieldNames, v = r.props, h = v.onSelect, p = v.multiple, g = c.selected, b = c[m.key], y = !g;
      y ? p ? u = Lr(u, b) : u = [b] : u = Or(u, b);
      var C = u.map(function(S) {
        var $ = tr(f, S);
        return $ ? $.node : null;
      }).filter(function(S) {
        return S;
      });
      r.setUncontrolledState({
        selectedKeys: u
      }), h == null || h(u, {
        event: "select",
        selected: y,
        node: c,
        selectedNodes: C,
        nativeEvent: l.nativeEvent
      });
    }), z(Me(r), "onNodeCheck", function(l, c, u) {
      var d = r.state, f = d.keyEntities, m = d.checkedKeys, v = d.halfCheckedKeys, h = r.props, p = h.checkStrictly, g = h.onCheck, b = c.key, y, C = {
        event: "check",
        node: c,
        checked: u,
        nativeEvent: l.nativeEvent
      };
      if (p) {
        var S = u ? Lr(m, b) : Or(m, b), $ = Or(v, b);
        y = {
          checked: S,
          halfChecked: $
        }, C.checkedNodes = S.map(function(I) {
          return tr(f, I);
        }).filter(function(I) {
          return I;
        }).map(function(I) {
          return I.node;
        }), r.setUncontrolledState({
          checkedKeys: S
        });
      } else {
        var x = va([].concat(be(m), [b]), !0, f), w = x.checkedKeys, N = x.halfCheckedKeys;
        if (!u) {
          var O = new Set(w);
          O.delete(b);
          var E = va(Array.from(O), {
            checked: !1,
            halfCheckedKeys: N
          }, f);
          w = E.checkedKeys, N = E.halfCheckedKeys;
        }
        y = w, C.checkedNodes = [], C.checkedNodesPositions = [], C.halfCheckedKeys = N, w.forEach(function(I) {
          var k = tr(f, I);
          if (k) {
            var M = k.node, P = k.pos;
            C.checkedNodes.push(M), C.checkedNodesPositions.push({
              node: M,
              pos: P
            });
          }
        }), r.setUncontrolledState({
          checkedKeys: w
        }, !1, {
          halfCheckedKeys: N
        });
      }
      g == null || g(y, C);
    }), z(Me(r), "onNodeLoad", function(l) {
      var c = l.key, u = new Promise(function(d, f) {
        r.setState(function(m) {
          var v = m.loadedKeys, h = v === void 0 ? [] : v, p = m.loadingKeys, g = p === void 0 ? [] : p, b = r.props, y = b.loadData, C = b.onLoad;
          if (!y || h.indexOf(c) !== -1 || g.indexOf(c) !== -1)
            return null;
          var S = y(l);
          return S.then(function() {
            var $ = r.state.loadedKeys, x = Lr($, c);
            C == null || C(x, {
              event: "load",
              node: l
            }), r.setUncontrolledState({
              loadedKeys: x
            }), r.setState(function(w) {
              return {
                loadingKeys: Or(w.loadingKeys, c)
              };
            }), d();
          }).catch(function($) {
            if (r.setState(function(w) {
              return {
                loadingKeys: Or(w.loadingKeys, c)
              };
            }), r.loadingRetryTimes[c] = (r.loadingRetryTimes[c] || 0) + 1, r.loadingRetryTimes[c] >= HH) {
              var x = r.state.loadedKeys;
              tt(!1, "Retry for `loadData` many times but still failed. No more retry."), r.setUncontrolledState({
                loadedKeys: Lr(x, c)
              }), d();
            }
            f($);
          }), {
            loadingKeys: Lr(g, c)
          };
        });
      });
      return u.catch(function() {
      }), u;
    }), z(Me(r), "onNodeMouseEnter", function(l, c) {
      var u = r.props.onMouseEnter;
      u == null || u({
        event: l,
        node: c
      });
    }), z(Me(r), "onNodeMouseLeave", function(l, c) {
      var u = r.props.onMouseLeave;
      u == null || u({
        event: l,
        node: c
      });
    }), z(Me(r), "onNodeContextMenu", function(l, c) {
      var u = r.props.onRightClick;
      u && (l.preventDefault(), u({
        event: l,
        node: c
      }));
    }), z(Me(r), "onFocus", function() {
      var l = r.props.onFocus;
      r.setState({
        focused: !0
      });
      for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      l == null || l.apply(void 0, u);
    }), z(Me(r), "onBlur", function() {
      var l = r.props.onBlur;
      r.setState({
        focused: !1
      }), r.onActiveChange(null);
      for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      l == null || l.apply(void 0, u);
    }), z(Me(r), "getTreeNodeRequiredProps", function() {
      var l = r.state, c = l.expandedKeys, u = l.selectedKeys, d = l.loadedKeys, f = l.loadingKeys, m = l.checkedKeys, v = l.halfCheckedKeys, h = l.dragOverNodeKey, p = l.dropPosition, g = l.keyEntities;
      return {
        expandedKeys: c || [],
        selectedKeys: u || [],
        loadedKeys: d || [],
        loadingKeys: f || [],
        checkedKeys: m || [],
        halfCheckedKeys: v || [],
        dragOverNodeKey: h,
        dropPosition: p,
        keyEntities: g
      };
    }), z(Me(r), "setExpandedKeys", function(l) {
      var c = r.state, u = c.treeData, d = c.fieldNames, f = ru(u, l, d);
      r.setUncontrolledState({
        expandedKeys: l,
        flattenNodes: f
      }, !0);
    }), z(Me(r), "onNodeExpand", function(l, c) {
      var u = r.state.expandedKeys, d = r.state, f = d.listChanging, m = d.fieldNames, v = r.props, h = v.onExpand, p = v.loadData, g = c.expanded, b = c[m.key];
      if (!f) {
        var y = u.indexOf(b), C = !g;
        if (tt(g && y !== -1 || !g && y === -1, "Expand state not sync with index check"), C ? u = Lr(u, b) : u = Or(u, b), r.setExpandedKeys(u), h == null || h(u, {
          node: c,
          expanded: C,
          nativeEvent: l.nativeEvent
        }), C && p) {
          var S = r.onNodeLoad(c);
          S && S.then(function() {
            var $ = ru(r.state.treeData, u, m);
            r.setUncontrolledState({
              flattenNodes: $
            });
          }).catch(function() {
            var $ = r.state.expandedKeys, x = Or($, b);
            r.setExpandedKeys(x);
          });
        }
      }
    }), z(Me(r), "onListChangeStart", function() {
      r.setUncontrolledState({
        listChanging: !0
      });
    }), z(Me(r), "onListChangeEnd", function() {
      setTimeout(function() {
        r.setUncontrolledState({
          listChanging: !1
        });
      });
    }), z(Me(r), "onActiveChange", function(l) {
      var c = r.state.activeKey, u = r.props, d = u.onActiveChange, f = u.itemScrollOffset, m = f === void 0 ? 0 : f;
      c !== l && (r.setState({
        activeKey: l
      }), l !== null && r.scrollTo({
        key: l,
        offset: m
      }), d == null || d(l));
    }), z(Me(r), "getActiveItem", function() {
      var l = r.state, c = l.activeKey, u = l.flattenNodes;
      return c === null ? null : u.find(function(d) {
        var f = d.key;
        return f === c;
      }) || null;
    }), z(Me(r), "offsetActiveKey", function(l) {
      var c = r.state, u = c.flattenNodes, d = c.activeKey, f = u.findIndex(function(h) {
        var p = h.key;
        return p === d;
      });
      f === -1 && l < 0 && (f = u.length), f = (f + l + u.length) % u.length;
      var m = u[f];
      if (m) {
        var v = m.key;
        r.onActiveChange(v);
      } else
        r.onActiveChange(null);
    }), z(Me(r), "onKeyDown", function(l) {
      var c = r.state, u = c.activeKey, d = c.expandedKeys, f = c.checkedKeys, m = c.fieldNames, v = r.props, h = v.onKeyDown, p = v.checkable, g = v.selectable;
      switch (l.which) {
        case Oe.UP: {
          r.offsetActiveKey(-1), l.preventDefault();
          break;
        }
        case Oe.DOWN: {
          r.offsetActiveKey(1), l.preventDefault();
          break;
        }
      }
      var b = r.getActiveItem();
      if (b && b.data) {
        var y = r.getTreeNodeRequiredProps(), C = b.data.isLeaf === !1 || !!(b.data[m.children] || []).length, S = yn(V(V({}, gi(u, y)), {}, {
          data: b.data,
          active: !0
        }));
        switch (l.which) {
          case Oe.LEFT: {
            C && d.includes(u) ? r.onNodeExpand({}, S) : b.parent && r.onActiveChange(b.parent.key), l.preventDefault();
            break;
          }
          case Oe.RIGHT: {
            C && !d.includes(u) ? r.onNodeExpand({}, S) : b.children && b.children.length && r.onActiveChange(b.children[0].key), l.preventDefault();
            break;
          }
          case Oe.ENTER:
          case Oe.SPACE: {
            p && !S.disabled && S.checkable !== !1 && !S.disableCheckbox ? r.onNodeCheck({}, S, !f.includes(u)) : !p && g && !S.disabled && S.selectable !== !1 && r.onNodeSelect({}, S);
            break;
          }
        }
      }
      h == null || h(l);
    }), z(Me(r), "setUncontrolledState", function(l) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!r.destroyed) {
        var d = !1, f = !0, m = {};
        Object.keys(l).forEach(function(v) {
          if (v in r.props) {
            f = !1;
            return;
          }
          d = !0, m[v] = l[v];
        }), d && (!c || f) && r.setState(V(V({}, m), u));
      }
    }), z(Me(r), "scrollTo", function(l) {
      r.listRef.current.scrollTo(l);
    }), r;
  }
  return wn(n, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var o = this.props, a = o.activeKey, i = o.itemScrollOffset, l = i === void 0 ? 0 : i;
      a !== void 0 && a !== this.state.activeKey && (this.setState({
        activeKey: a
      }), a !== null && this.scrollTo({
        key: a,
        offset: l
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state, a = o.focused, i = o.flattenNodes, l = o.keyEntities, c = o.draggingNodeKey, u = o.activeKey, d = o.dropLevelOffset, f = o.dropContainerKey, m = o.dropTargetKey, v = o.dropPosition, h = o.dragOverNodeKey, p = o.indent, g = this.props, b = g.prefixCls, y = g.className, C = g.style, S = g.showLine, $ = g.focusable, x = g.tabIndex, w = x === void 0 ? 0 : x, N = g.selectable, O = g.showIcon, E = g.icon, I = g.switcherIcon, k = g.draggable, M = g.checkable, P = g.checkStrictly, _ = g.disabled, D = g.motion, R = g.loadData, T = g.filterTreeNode, L = g.height, F = g.itemHeight, j = g.virtual, A = g.titleRender, B = g.dropIndicatorRender, K = g.onContextMenu, Y = g.onScroll, G = g.direction, te = g.rootClassName, ee = g.rootStyle, oe = Bn(this.props, {
        aria: !0,
        data: !0
      }), X;
      return k && (mt(k) === "object" ? X = k : typeof k == "function" ? X = {
        nodeDraggable: k
      } : X = {}), /* @__PURE__ */ s.createElement(Fm.Provider, {
        value: {
          prefixCls: b,
          selectable: N,
          showIcon: O,
          icon: E,
          switcherIcon: I,
          draggable: X,
          draggingNodeKey: c,
          checkable: M,
          checkStrictly: P,
          disabled: _,
          keyEntities: l,
          dropLevelOffset: d,
          dropContainerKey: f,
          dropTargetKey: m,
          dropPosition: v,
          dragOverNodeKey: h,
          indent: p,
          direction: G,
          dropIndicatorRender: B,
          loadData: R,
          filterTreeNode: T,
          titleRender: A,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop
        }
      }, /* @__PURE__ */ s.createElement("div", {
        role: "tree",
        className: J(b, y, te, z(z(z({}, "".concat(b, "-show-line"), S), "".concat(b, "-focused"), a), "".concat(b, "-active-focused"), u !== null)),
        style: ee
      }, /* @__PURE__ */ s.createElement(T$, fe({
        ref: this.listRef,
        prefixCls: b,
        style: C,
        data: i,
        disabled: _,
        selectable: N,
        checkable: !!M,
        motion: D,
        dragging: c !== null,
        height: L,
        itemHeight: F,
        virtual: j,
        focusable: $,
        focused: a,
        tabIndex: w,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: K,
        onScroll: Y
      }, this.getTreeNodeRequiredProps(), oe))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, a) {
      var i = a.prevProps, l = {
        prevProps: o
      };
      function c(x) {
        return !i && x in o || i && i[x] !== o[x];
      }
      var u, d = a.fieldNames;
      if (c("fieldNames") && (d = wa(o.fieldNames), l.fieldNames = d), c("treeData") ? u = o.treeData : c("children") && (tt(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), u = MS(o.children)), u) {
        l.treeData = u;
        var f = Cm(u, {
          fieldNames: d
        });
        l.keyEntities = V(z({}, Lo, M$), f.keyEntities), process.env.NODE_ENV !== "production" && VF(u, d);
      }
      var m = l.keyEntities || a.keyEntities;
      if (c("expandedKeys") || i && c("autoExpandParent"))
        l.expandedKeys = o.autoExpandParent || !i && o.defaultExpandParent ? Wd(o.expandedKeys, m) : o.expandedKeys;
      else if (!i && o.defaultExpandAll) {
        var v = V({}, m);
        delete v[Lo], l.expandedKeys = Object.keys(v).map(function(x) {
          return v[x].key;
        });
      } else
        !i && o.defaultExpandedKeys && (l.expandedKeys = o.autoExpandParent || o.defaultExpandParent ? Wd(o.defaultExpandedKeys, m) : o.defaultExpandedKeys);
      if (l.expandedKeys || delete l.expandedKeys, u || l.expandedKeys) {
        var h = ru(u || a.treeData, l.expandedKeys || a.expandedKeys, d);
        l.flattenNodes = h;
      }
      if (o.selectable && (c("selectedKeys") ? l.selectedKeys = Up(o.selectedKeys, o) : !i && o.defaultSelectedKeys && (l.selectedKeys = Up(o.defaultSelectedKeys, o))), o.checkable) {
        var p;
        if (c("checkedKeys") ? p = du(o.checkedKeys) || {} : !i && o.defaultCheckedKeys ? p = du(o.defaultCheckedKeys) || {} : u && (p = du(o.checkedKeys) || {
          checkedKeys: a.checkedKeys,
          halfCheckedKeys: a.halfCheckedKeys
        }), p) {
          var g = p, b = g.checkedKeys, y = b === void 0 ? [] : b, C = g.halfCheckedKeys, S = C === void 0 ? [] : C;
          if (!o.checkStrictly) {
            var $ = va(y, !0, m);
            y = $.checkedKeys, S = $.halfCheckedKeys;
          }
          l.checkedKeys = y, l.halfCheckedKeys = S;
        }
      }
      return c("loadedKeys") && (l.loadedKeys = o.loadedKeys), l;
    }
  }]), n;
}(s.Component);
z(zm, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: DH,
  allowDrop: function() {
    return !0;
  },
  expandAction: !1
});
z(zm, "TreeNode", Oa);
var VH = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" };
const WH = VH;
var _$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: WH
  }));
};
process.env.NODE_ENV !== "production" && (_$.displayName = "FileOutlined");
const D$ = /* @__PURE__ */ s.forwardRef(_$);
var KH = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" };
const qH = KH;
var k$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: qH
  }));
};
process.env.NODE_ENV !== "production" && (k$.displayName = "FolderOpenOutlined");
const GH = /* @__PURE__ */ s.forwardRef(k$);
var UH = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" };
const YH = UH;
var L$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: YH
  }));
};
process.env.NODE_ENV !== "production" && (L$.displayName = "FolderOutlined");
const XH = /* @__PURE__ */ s.forwardRef(L$);
var QH = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" };
const JH = QH;
var F$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: JH
  }));
};
process.env.NODE_ENV !== "production" && (F$.displayName = "HolderOutlined");
const ZH = /* @__PURE__ */ s.forwardRef(F$), e3 = new kt("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), t3 = (e, t) => ({
  [`.${e}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${t.motionDurationSlow}`
    }
  }
}), n3 = (e, t) => ({
  [`.${e}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: t.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${q(t.lineWidthBold)} solid ${t.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), r3 = (e, t) => {
  const {
    treeCls: n,
    treeNodeCls: r,
    treeNodePadding: o,
    titleHeight: a,
    nodeSelectedBg: i,
    nodeHoverBg: l
  } = t, c = t.paddingXS;
  return {
    [n]: Object.assign(Object.assign({}, Gt(t)), {
      background: t.colorBgContainer,
      borderRadius: t.borderRadius,
      transition: `background-color ${t.motionDurationSlow}`,
      [`&${n}-rtl`]: {
        // >>> Switcher
        [`${n}-switcher`]: {
          "&_close": {
            [`${n}-switcher-icon`]: {
              svg: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      },
      [`&-focused:not(:hover):not(${n}-active-focused)`]: Object.assign({}, io(t)),
      // =================== Virtual List ===================
      [`${n}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${n}-block-node`]: {
        [`${n}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${n}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${r}.dragging`]: {
            position: "relative",
            "&:after": {
              position: "absolute",
              top: 0,
              insetInlineEnd: 0,
              bottom: o,
              insetInlineStart: 0,
              border: `1px solid ${t.colorPrimary}`,
              opacity: 0,
              animationName: e3,
              animationDuration: t.motionDurationSlow,
              animationPlayState: "running",
              animationFillMode: "forwards",
              content: '""',
              pointerEvents: "none"
            }
          }
        }
      },
      // ===================== TreeNode =====================
      [`${r}`]: {
        display: "flex",
        alignItems: "flex-start",
        padding: `0 0 ${q(o)} 0`,
        outline: "none",
        "&-rtl": {
          direction: "rtl"
        },
        // Disabled
        "&-disabled": {
          // >>> Title
          [`${n}-node-content-wrapper`]: {
            color: t.colorTextDisabled,
            cursor: "not-allowed",
            "&:hover": {
              background: "transparent"
            }
          }
        },
        [`&-active ${n}-node-content-wrapper`]: {
          background: t.controlItemBgHover
        },
        [`&:not(${r}-disabled).filter-node ${n}-title`]: {
          color: "inherit",
          fontWeight: 500
        },
        "&-draggable": {
          cursor: "grab",
          [`${n}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: a,
            lineHeight: `${q(a)}`,
            textAlign: "center",
            visibility: "visible",
            opacity: 0.2,
            transition: `opacity ${t.motionDurationSlow}`,
            [`${r}:hover &`]: {
              opacity: 0.45
            }
          },
          [`&${r}-disabled`]: {
            [`${n}-draggable-icon`]: {
              visibility: "hidden"
            }
          }
        }
      },
      // >>> Indent
      [`${n}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: a
        }
      },
      // >>> Drag Handler
      [`${n}-draggable-icon`]: {
        visibility: "hidden"
      },
      // >>> Switcher
      [`${n}-switcher`]: Object.assign(Object.assign({}, t3(e, t)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: a,
        margin: 0,
        lineHeight: `${q(a)}`,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${t.motionDurationSlow}`,
        borderRadius: t.borderRadius,
        "&-noop": {
          cursor: "unset"
        },
        [`&:not(${n}-switcher-noop):hover`]: {
          backgroundColor: t.colorBgTextHover
        },
        "&_close": {
          [`${n}-switcher-icon`]: {
            svg: {
              transform: "rotate(-90deg)"
            }
          }
        },
        "&-loading-icon": {
          color: t.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: t.calc(a).div(2).equal(),
            bottom: t.calc(o).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${t.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: t.calc(t.calc(a).div(2).equal()).mul(0.8).equal(),
            height: t.calc(a).div(2).equal(),
            borderBottom: `1px solid ${t.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Checkbox
      [`${n}-checkbox`]: {
        top: "initial",
        marginInlineEnd: c,
        alignSelf: "flex-start",
        marginTop: t.marginXXS
      },
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${n}-node-content-wrapper, ${n}-checkbox + span`]: {
        position: "relative",
        zIndex: "auto",
        minHeight: a,
        margin: 0,
        padding: `0 ${q(t.calc(t.paddingXS).div(2).equal())}`,
        color: "inherit",
        lineHeight: `${q(a)}`,
        background: "transparent",
        borderRadius: t.borderRadius,
        cursor: "pointer",
        transition: `all ${t.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
        "&:hover": {
          backgroundColor: l
        },
        [`&${n}-node-selected`]: {
          backgroundColor: i
        },
        // Icon
        [`${n}-iconEle`]: {
          display: "inline-block",
          width: a,
          height: a,
          lineHeight: `${q(a)}`,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/28217
      [`${n}-unselectable ${n}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      // ==================== Draggable =====================
      [`${n}-node-content-wrapper`]: Object.assign({
        lineHeight: `${q(a)}`,
        userSelect: "none"
      }, n3(e, t)),
      [`${r}.drop-container`]: {
        "> [draggable]": {
          boxShadow: `0 0 0 2px ${t.colorPrimary}`
        }
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${n}-indent`]: {
          "&-unit": {
            position: "relative",
            height: "100%",
            "&:before": {
              position: "absolute",
              top: 0,
              insetInlineEnd: t.calc(a).div(2).equal(),
              bottom: t.calc(o).mul(-1).equal(),
              borderInlineEnd: `1px solid ${t.colorBorder}`,
              content: '""'
            },
            "&-end": {
              "&:before": {
                display: "none"
              }
            }
          }
        },
        // ============== Cover Background ==============
        [`${n}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${r}-leaf-last`]: {
        [`${n}-switcher`]: {
          "&-leaf-line": {
            "&:before": {
              top: "auto !important",
              bottom: "auto !important",
              height: `${q(t.calc(a).div(2).equal())} !important`
            }
          }
        }
      }
    })
  };
}, o3 = (e) => {
  const {
    treeCls: t,
    treeNodeCls: n,
    treeNodePadding: r,
    directoryNodeSelectedBg: o,
    directoryNodeSelectedColor: a
  } = e;
  return {
    [`${t}${t}-directory`]: {
      // ================== TreeNode ==================
      [n]: {
        position: "relative",
        // Hover color
        "&:before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: r,
          insetInlineStart: 0,
          transition: `background-color ${e.motionDurationMid}`,
          content: '""',
          pointerEvents: "none"
        },
        "&:hover": {
          "&:before": {
            background: e.controlItemBgHover
          }
        },
        // Elements
        "> *": {
          zIndex: 1
        },
        // >>> Switcher
        [`${t}-switcher`]: {
          transition: `color ${e.motionDurationMid}`
        },
        // >>> Title
        [`${t}-node-content-wrapper`]: {
          borderRadius: 0,
          userSelect: "none",
          "&:hover": {
            background: "transparent"
          },
          [`&${t}-node-selected`]: {
            color: a,
            background: "transparent"
          }
        },
        // ============= Selected =============
        "&-selected": {
          [`
            &:hover::before,
            &::before
          `]: {
            background: o
          },
          // >>> Switcher
          [`${t}-switcher`]: {
            color: a
          },
          // >>> Title
          [`${t}-node-content-wrapper`]: {
            color: a,
            background: "transparent"
          }
        }
      }
    }
  };
}, a3 = (e, t) => {
  const n = `.${e}`, r = `${n}-treenode`, o = t.calc(t.paddingXS).div(2).equal(), a = Dt(t, {
    treeCls: n,
    treeNodeCls: r,
    treeNodePadding: o
  });
  return [
    // Basic
    r3(e, a),
    // Directory
    o3(a)
  ];
}, i3 = (e) => {
  const {
    controlHeightSM: t
  } = e;
  return {
    titleHeight: t,
    nodeHoverBg: e.controlItemBgHover,
    nodeSelectedBg: e.controlItemBgActive
  };
}, l3 = (e) => {
  const {
    colorTextLightSolid: t,
    colorPrimary: n
  } = e;
  return Object.assign(Object.assign({}, i3(e)), {
    directoryNodeSelectedColor: t,
    directoryNodeSelectedBg: n
  });
}, s3 = Xt("Tree", (e, t) => {
  let {
    prefixCls: n
  } = t;
  return [{
    [e.componentCls]: _S(`${n}-checkbox`, e)
  }, a3(n, e), qi(e)];
}, l3), th = 4;
function c3(e) {
  const {
    dropPosition: t,
    dropLevelOffset: n,
    prefixCls: r,
    indent: o,
    direction: a = "ltr"
  } = e, i = a === "ltr" ? "left" : "right", l = a === "ltr" ? "right" : "left", c = {
    [i]: -n * o + th,
    [l]: 0
  };
  switch (t) {
    case -1:
      c.top = -3;
      break;
    case 1:
      c.bottom = -3;
      break;
    default:
      c.bottom = -3, c[i] = o + th;
      break;
  }
  return /* @__PURE__ */ le.createElement("div", {
    style: c,
    className: `${r}-drop-indicator`
  });
}
var u3 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" };
const d3 = u3;
var j$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: d3
  }));
};
process.env.NODE_ENV !== "production" && (j$.displayName = "CaretDownFilled");
const f3 = /* @__PURE__ */ s.forwardRef(j$);
var m3 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" };
const v3 = m3;
var z$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: v3
  }));
};
process.env.NODE_ENV !== "production" && (z$.displayName = "MinusSquareOutlined");
const g3 = /* @__PURE__ */ s.forwardRef(z$);
var p3 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" };
const h3 = p3;
var A$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: h3
  }));
};
process.env.NODE_ENV !== "production" && (A$.displayName = "PlusSquareOutlined");
const b3 = /* @__PURE__ */ s.forwardRef(A$), y3 = (e) => {
  const {
    prefixCls: t,
    switcherIcon: n,
    treeNodeProps: r,
    showLine: o
  } = e, {
    isLeaf: a,
    expanded: i,
    loading: l
  } = r;
  if (l)
    return /* @__PURE__ */ s.createElement(To, {
      className: `${t}-switcher-loading-icon`
    });
  let c;
  if (o && typeof o == "object" && (c = o.showLeafIcon), a) {
    if (!o)
      return null;
    if (typeof c != "boolean" && c) {
      const f = typeof c == "function" ? c(r) : c, m = `${t}-switcher-line-custom-icon`;
      return Kn(f) ? xn(f, {
        className: J(f.props.className || "", m)
      }) : f;
    }
    return c ? /* @__PURE__ */ s.createElement(D$, {
      className: `${t}-switcher-line-icon`
    }) : /* @__PURE__ */ s.createElement("span", {
      className: `${t}-switcher-leaf-line`
    });
  }
  const u = `${t}-switcher-icon`, d = typeof n == "function" ? n(r) : n;
  return Kn(d) ? xn(d, {
    className: J(d.props.className || "", u)
  }) : d !== void 0 ? d : o ? i ? /* @__PURE__ */ s.createElement(g3, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ s.createElement(b3, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ s.createElement(f3, {
    className: u
  });
}, C3 = y3, B$ = /* @__PURE__ */ le.forwardRef((e, t) => {
  var n;
  const {
    getPrefixCls: r,
    direction: o,
    virtual: a,
    tree: i
  } = le.useContext(lt), {
    prefixCls: l,
    className: c,
    showIcon: u = !1,
    showLine: d,
    switcherIcon: f,
    blockNode: m = !1,
    children: v,
    checkable: h = !1,
    selectable: p = !0,
    draggable: g,
    motion: b,
    style: y
  } = e, C = r("tree", l), S = r(), $ = b ?? Object.assign(Object.assign({}, ya(S)), {
    motionAppear: !1
  }), x = Object.assign(Object.assign({}, e), {
    checkable: h,
    selectable: p,
    showIcon: u,
    motion: $,
    blockNode: m,
    showLine: !!d,
    dropIndicatorRender: c3
  }), [w, N, O] = s3(C), [, E] = Sn(), I = E.paddingXS / 2 + (((n = E.Tree) === null || n === void 0 ? void 0 : n.titleHeight) || E.controlHeightSM), k = le.useMemo(() => {
    if (!g)
      return !1;
    let P = {};
    switch (typeof g) {
      case "function":
        P.nodeDraggable = g;
        break;
      case "object":
        P = Object.assign({}, g);
        break;
    }
    return P.icon !== !1 && (P.icon = P.icon || /* @__PURE__ */ le.createElement(ZH, null)), P;
  }, [g]), M = (P) => /* @__PURE__ */ le.createElement(C3, {
    prefixCls: C,
    switcherIcon: f,
    treeNodeProps: P,
    showLine: d
  });
  return w(/* @__PURE__ */ le.createElement(zm, Object.assign({
    itemHeight: I,
    ref: t,
    virtual: a
  }, x, {
    // newProps may contain style so declare style below it
    style: Object.assign(Object.assign({}, i == null ? void 0 : i.style), y),
    prefixCls: C,
    className: J({
      [`${C}-icon-hide`]: !u,
      [`${C}-block-node`]: m,
      [`${C}-unselectable`]: !p,
      [`${C}-rtl`]: o === "rtl"
    }, i == null ? void 0 : i.className, c, N, O),
    direction: o,
    checkable: h && /* @__PURE__ */ le.createElement("span", {
      className: `${C}-checkbox-inner`
    }),
    selectable: p,
    switcherIcon: M,
    draggable: k
  }), v));
});
process.env.NODE_ENV !== "production" && (B$.displayName = "Tree");
const H$ = B$;
var Fr;
(function(e) {
  e[e.None = 0] = "None", e[e.Start = 1] = "Start", e[e.End = 2] = "End";
})(Fr || (Fr = {}));
function Am(e, t, n) {
  const {
    key: r,
    children: o
  } = n;
  function a(i) {
    const l = i[r], c = i[o];
    t(l, i) !== !1 && Am(c || [], t, n);
  }
  e.forEach(a);
}
function S3(e) {
  let {
    treeData: t,
    expandedKeys: n,
    startKey: r,
    endKey: o,
    fieldNames: a
  } = e;
  const i = [];
  let l = Fr.None;
  if (r && r === o)
    return [r];
  if (!r || !o)
    return [];
  function c(u) {
    return u === r || u === o;
  }
  return Am(t, (u) => {
    if (l === Fr.End)
      return !1;
    if (c(u)) {
      if (i.push(u), l === Fr.None)
        l = Fr.Start;
      else if (l === Fr.Start)
        return l = Fr.End, !1;
    } else
      l === Fr.Start && i.push(u);
    return n.includes(u);
  }, wa(a)), i;
}
function fu(e, t, n) {
  const r = be(t), o = [];
  return Am(e, (a, i) => {
    const l = r.indexOf(a);
    return l !== -1 && (o.push(i), r.splice(l, 1)), !!r.length;
  }, wa(n)), o;
}
var nh = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function x3(e) {
  const {
    isLeaf: t,
    expanded: n
  } = e;
  return t ? /* @__PURE__ */ s.createElement(D$, null) : n ? /* @__PURE__ */ s.createElement(GH, null) : /* @__PURE__ */ s.createElement(XH, null);
}
function rh(e) {
  let {
    treeData: t,
    children: n
  } = e;
  return t || MS(n);
}
const $3 = (e, t) => {
  var {
    defaultExpandAll: n,
    defaultExpandParent: r,
    defaultExpandedKeys: o
  } = e, a = nh(e, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const i = s.useRef(), l = s.useRef(), c = () => {
    const {
      keyEntities: N
    } = Cm(rh(a));
    let O;
    return n ? O = Object.keys(N) : r ? O = Wd(a.expandedKeys || o || [], N) : O = a.expandedKeys || o, O;
  }, [u, d] = s.useState(a.selectedKeys || a.defaultSelectedKeys || []), [f, m] = s.useState(() => c());
  s.useEffect(() => {
    "selectedKeys" in a && d(a.selectedKeys);
  }, [a.selectedKeys]), s.useEffect(() => {
    "expandedKeys" in a && m(a.expandedKeys);
  }, [a.expandedKeys]);
  const v = (N, O) => {
    var E;
    return "expandedKeys" in a || m(N), (E = a.onExpand) === null || E === void 0 ? void 0 : E.call(a, N, O);
  }, h = (N, O) => {
    var E;
    const {
      multiple: I,
      fieldNames: k
    } = a, {
      node: M,
      nativeEvent: P
    } = O, {
      key: _ = ""
    } = M, D = rh(a), R = Object.assign(Object.assign({}, O), {
      selected: !0
    }), T = (P == null ? void 0 : P.ctrlKey) || (P == null ? void 0 : P.metaKey), L = P == null ? void 0 : P.shiftKey;
    let F;
    I && T ? (F = N, i.current = _, l.current = F, R.selectedNodes = fu(D, F, k)) : I && L ? (F = Array.from(new Set([].concat(be(l.current || []), be(S3({
      treeData: D,
      expandedKeys: f,
      startKey: _,
      endKey: i.current,
      fieldNames: k
    }))))), R.selectedNodes = fu(D, F, k)) : (F = [_], i.current = _, l.current = F, R.selectedNodes = fu(D, F, k)), (E = a.onSelect) === null || E === void 0 || E.call(a, F, R), "selectedKeys" in a || d(F);
  }, {
    getPrefixCls: p,
    direction: g
  } = s.useContext(lt), {
    prefixCls: b,
    className: y,
    showIcon: C = !0,
    expandAction: S = "click"
  } = a, $ = nh(a, ["prefixCls", "className", "showIcon", "expandAction"]), x = p("tree", b), w = J(`${x}-directory`, {
    [`${x}-directory-rtl`]: g === "rtl"
  }, y);
  return /* @__PURE__ */ s.createElement(H$, Object.assign({
    icon: x3,
    ref: t,
    blockNode: !0
  }, $, {
    showIcon: C,
    expandAction: S,
    prefixCls: x,
    className: w,
    expandedKeys: f,
    selectedKeys: u,
    onSelect: h,
    onExpand: v
  }));
}, V$ = /* @__PURE__ */ s.forwardRef($3);
process.env.NODE_ENV !== "production" && (V$.displayName = "DirectoryTree");
const w3 = V$, Bm = H$;
Bm.DirectoryTree = w3;
Bm.TreeNode = Oa;
const E3 = Bm;
function oh(e) {
  let {
    value: t,
    onChange: n,
    filterSearch: r,
    tablePrefixCls: o,
    locale: a
  } = e;
  return r ? /* @__PURE__ */ s.createElement("div", {
    className: `${o}-filter-dropdown-search`
  }, /* @__PURE__ */ s.createElement(ka, {
    prefix: /* @__PURE__ */ s.createElement(qf, null),
    placeholder: a.filterSearchPlaceholder,
    onChange: n,
    value: t,
    // for skip min-width of input
    htmlSize: 1,
    className: `${o}-filter-dropdown-search-input`
  })) : null;
}
const O3 = (e) => {
  const {
    keyCode: t
  } = e;
  t === Oe.ENTER && e.stopPropagation();
}, W$ = /* @__PURE__ */ s.forwardRef((e, t) => /* @__PURE__ */ s.createElement("div", {
  className: e.className,
  onClick: (n) => n.stopPropagation(),
  onKeyDown: O3,
  ref: t
}, e.children));
process.env.NODE_ENV !== "production" && (W$.displayName = "FilterDropdownMenuWrapper");
const N3 = W$;
function ga(e) {
  let t = [];
  return (e || []).forEach((n) => {
    let {
      value: r,
      children: o
    } = n;
    t.push(r), o && (t = [].concat(be(t), be(ga(o))));
  }), t;
}
function I3(e) {
  return e.some((t) => {
    let {
      children: n
    } = t;
    return n;
  });
}
function K$(e, t) {
  return typeof t == "string" || typeof t == "number" ? t == null ? void 0 : t.toString().toLowerCase().includes(e.trim().toLowerCase()) : !1;
}
function q$(e) {
  let {
    filters: t,
    prefixCls: n,
    filteredKeys: r,
    filterMultiple: o,
    searchValue: a,
    filterSearch: i
  } = e;
  return t.map((l, c) => {
    const u = String(l.value);
    if (l.children)
      return {
        key: u || c,
        label: l.text,
        popupClassName: `${n}-dropdown-submenu`,
        children: q$({
          filters: l.children,
          prefixCls: n,
          filteredKeys: r,
          filterMultiple: o,
          searchValue: a,
          filterSearch: i
        })
      };
    const d = o ? Ea : tl, f = {
      key: l.value !== void 0 ? u : c,
      label: /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(d, {
        checked: r.includes(u)
      }), /* @__PURE__ */ s.createElement("span", null, l.text))
    };
    return a.trim() ? typeof i == "function" ? i(a, l) ? f : null : K$(a, l.text) ? f : null : f;
  });
}
function mu(e) {
  return e || [];
}
function P3(e) {
  var t, n;
  const {
    tablePrefixCls: r,
    prefixCls: o,
    column: a,
    dropdownPrefixCls: i,
    columnKey: l,
    filterMultiple: c,
    filterMode: u = "menu",
    filterSearch: d = !1,
    filterState: f,
    triggerFilter: m,
    locale: v,
    children: h,
    getPopupContainer: p,
    rootClassName: g
  } = e, {
    filterDropdownOpen: b,
    onFilterDropdownOpenChange: y,
    filterResetToDefaultFilteredValue: C,
    defaultFilteredValue: S,
    // Deprecated
    filterDropdownVisible: $,
    onFilterDropdownVisibleChange: x
  } = a, [w, N] = s.useState(!1), O = !!(f && (!((t = f.filteredKeys) === null || t === void 0) && t.length || f.forceFiltered)), E = (ae) => {
    N(ae), y == null || y(ae), x == null || x(ae);
  };
  if (process.env.NODE_ENV !== "production") {
    const ae = Rt("Table");
    [["filterDropdownVisible", "filterDropdownOpen", $], ["onFilterDropdownVisibleChange", "onFilterDropdownOpenChange", x]].forEach((ue) => {
      let [de, se, ie] = ue;
      ae.deprecated(ie == null, de, se);
    });
  }
  const I = (n = b ?? $) !== null && n !== void 0 ? n : w, k = f == null ? void 0 : f.filteredKeys, [M, P] = _H(mu(k)), _ = (ae) => {
    let {
      selectedKeys: ue
    } = ae;
    P(ue);
  }, D = (ae, ue) => {
    let {
      node: de,
      checked: se
    } = ue;
    _(c ? {
      selectedKeys: ae
    } : {
      selectedKeys: se && de.key ? [de.key] : []
    });
  };
  s.useEffect(() => {
    w && _({
      selectedKeys: mu(k)
    });
  }, [k]);
  const [R, T] = s.useState([]), L = (ae) => {
    T(ae);
  }, [F, j] = s.useState(""), A = (ae) => {
    const {
      value: ue
    } = ae.target;
    j(ue);
  };
  s.useEffect(() => {
    w || j("");
  }, [w]);
  const B = (ae) => {
    const ue = ae && ae.length ? ae : null;
    if (ue === null && (!f || !f.filteredKeys) || Hr(ue, f == null ? void 0 : f.filteredKeys, !0))
      return null;
    m({
      column: a,
      key: l,
      filteredKeys: ue
    });
  }, K = () => {
    E(!1), B(M());
  }, Y = function() {
    let {
      confirm: ae,
      closeDropdown: ue
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      confirm: !1,
      closeDropdown: !1
    };
    ae && B([]), ue && E(!1), j(""), P(C ? (S || []).map((de) => String(de)) : []);
  }, G = function() {
    let {
      closeDropdown: ae
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      closeDropdown: !0
    };
    ae && E(!1), B(M());
  }, te = (ae, ue) => {
    ue.source === "trigger" && (ae && k !== void 0 && P(mu(k)), E(ae), !ae && !a.filterDropdown && K());
  }, ee = J({
    [`${i}-menu-without-submenu`]: !I3(a.filters || [])
  }), oe = (ae) => {
    if (ae.target.checked) {
      const ue = ga(a == null ? void 0 : a.filters).map((de) => String(de));
      P(ue);
    } else
      P([]);
  }, X = (ae) => {
    let {
      filters: ue
    } = ae;
    return (ue || []).map((de, se) => {
      const ie = String(de.value), me = {
        title: de.text,
        key: de.value !== void 0 ? ie : String(se)
      };
      return de.children && (me.children = X({
        filters: de.children
      })), me;
    });
  }, W = (ae) => {
    var ue;
    return Object.assign(Object.assign({}, ae), {
      text: ae.title,
      value: ae.key,
      children: ((ue = ae.children) === null || ue === void 0 ? void 0 : ue.map((de) => W(de))) || []
    });
  };
  let re;
  if (typeof a.filterDropdown == "function")
    re = a.filterDropdown({
      prefixCls: `${i}-custom`,
      setSelectedKeys: (ae) => _({
        selectedKeys: ae
      }),
      selectedKeys: M(),
      confirm: G,
      clearFilters: Y,
      filters: a.filters,
      visible: I,
      close: () => {
        E(!1);
      }
    });
  else if (a.filterDropdown)
    re = a.filterDropdown;
  else {
    const ae = M() || [], ue = () => (a.filters || []).length === 0 ? /* @__PURE__ */ s.createElement($o, {
      image: $o.PRESENTED_IMAGE_SIMPLE,
      description: v.filterEmptyText,
      imageStyle: {
        height: 24
      },
      style: {
        margin: 0,
        padding: "16px 0"
      }
    }) : u === "tree" ? /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(oh, {
      filterSearch: d,
      value: F,
      onChange: A,
      tablePrefixCls: r,
      locale: v
    }), /* @__PURE__ */ s.createElement("div", {
      className: `${r}-filter-dropdown-tree`
    }, c ? /* @__PURE__ */ s.createElement(Ea, {
      checked: ae.length === ga(a.filters).length,
      indeterminate: ae.length > 0 && ae.length < ga(a.filters).length,
      className: `${r}-filter-dropdown-checkall`,
      onChange: oe
    }, v.filterCheckall) : null, /* @__PURE__ */ s.createElement(E3, {
      checkable: !0,
      selectable: !1,
      blockNode: !0,
      multiple: c,
      checkStrictly: !c,
      className: `${i}-menu`,
      onCheck: D,
      checkedKeys: ae,
      selectedKeys: ae,
      showIcon: !1,
      treeData: X({
        filters: a.filters
      }),
      autoExpandParent: !0,
      defaultExpandAll: !0,
      filterTreeNode: F.trim() ? (se) => typeof d == "function" ? d(F, W(se)) : K$(F, se.title) : void 0
    }))) : /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(oh, {
      filterSearch: d,
      value: F,
      onChange: A,
      tablePrefixCls: r,
      locale: v
    }), /* @__PURE__ */ s.createElement(Zi, {
      selectable: !0,
      multiple: c,
      prefixCls: `${i}-menu`,
      className: ee,
      onSelect: _,
      onDeselect: _,
      selectedKeys: ae,
      getPopupContainer: p,
      openKeys: R,
      onOpenChange: L,
      items: q$({
        filters: a.filters || [],
        filterSearch: d,
        prefixCls: o,
        filteredKeys: M(),
        filterMultiple: c,
        searchValue: F
      })
    })), de = () => C ? Hr((S || []).map((se) => String(se)), ae, !0) : ae.length === 0;
    re = /* @__PURE__ */ s.createElement(s.Fragment, null, ue(), /* @__PURE__ */ s.createElement("div", {
      className: `${o}-dropdown-btns`
    }, /* @__PURE__ */ s.createElement(or, {
      type: "link",
      size: "small",
      disabled: de(),
      onClick: () => Y()
    }, v.filterReset), /* @__PURE__ */ s.createElement(or, {
      type: "primary",
      size: "small",
      onClick: K
    }, v.filterConfirm)));
  }
  a.filterDropdown && (re = /* @__PURE__ */ s.createElement(wC, {
    selectable: void 0
  }, re));
  const Z = () => /* @__PURE__ */ s.createElement(N3, {
    className: `${o}-dropdown`
  }, re);
  let H;
  typeof a.filterIcon == "function" ? H = a.filterIcon(O) : a.filterIcon ? H = a.filterIcon : H = /* @__PURE__ */ s.createElement(TH, null);
  const {
    direction: U
  } = s.useContext(lt);
  return /* @__PURE__ */ s.createElement("div", {
    className: `${o}-column`
  }, /* @__PURE__ */ s.createElement("span", {
    className: `${r}-column-title`
  }, h), /* @__PURE__ */ s.createElement(dc, {
    dropdownRender: Z,
    trigger: ["click"],
    open: I,
    onOpenChange: te,
    getPopupContainer: p,
    placement: U === "rtl" ? "bottomLeft" : "bottomRight",
    rootClassName: g
  }, /* @__PURE__ */ s.createElement("span", {
    role: "button",
    tabIndex: -1,
    className: J(`${o}-trigger`, {
      active: O
    }),
    onClick: (ae) => {
      ae.stopPropagation();
    }
  }, H)));
}
function Yd(e, t, n) {
  let r = [];
  return (e || []).forEach((o, a) => {
    var i;
    const l = al(a, n);
    if (o.filters || "filterDropdown" in o || "onFilter" in o)
      if ("filteredValue" in o) {
        let c = o.filteredValue;
        "filterDropdown" in o || (c = (i = c == null ? void 0 : c.map(String)) !== null && i !== void 0 ? i : c), r.push({
          column: o,
          key: ko(o, l),
          filteredKeys: c,
          forceFiltered: o.filtered
        });
      } else
        r.push({
          column: o,
          key: ko(o, l),
          filteredKeys: t && o.defaultFilteredValue ? o.defaultFilteredValue : void 0,
          forceFiltered: o.filtered
        });
    "children" in o && (r = [].concat(be(r), be(Yd(o.children, t, l))));
  }), r;
}
function G$(e, t, n, r, o, a, i, l, c) {
  return n.map((u, d) => {
    const f = al(d, l), {
      filterMultiple: m = !0,
      filterMode: v,
      filterSearch: h
    } = u;
    let p = u;
    if (p.filters || p.filterDropdown) {
      const g = ko(p, f), b = r.find((y) => {
        let {
          key: C
        } = y;
        return g === C;
      });
      p = Object.assign(Object.assign({}, p), {
        title: (y) => /* @__PURE__ */ s.createElement(P3, {
          tablePrefixCls: e,
          prefixCls: `${e}-filter`,
          dropdownPrefixCls: t,
          column: p,
          columnKey: g,
          filterState: b,
          filterMultiple: m,
          filterMode: v,
          filterSearch: h,
          triggerFilter: a,
          locale: o,
          getPopupContainer: i,
          rootClassName: c
        }, gc(u.title, y))
      });
    }
    return "children" in p && (p = Object.assign(Object.assign({}, p), {
      children: G$(e, t, p.children, r, o, a, i, f, c)
    })), p;
  });
}
function ah(e) {
  const t = {};
  return e.forEach((n) => {
    let {
      key: r,
      filteredKeys: o,
      column: a
    } = n;
    const i = r, {
      filters: l,
      filterDropdown: c
    } = a;
    if (c)
      t[i] = o || null;
    else if (Array.isArray(o)) {
      const u = ga(l);
      t[i] = u.filter((d) => o.includes(String(d)));
    } else
      t[i] = null;
  }), t;
}
function Xd(e, t, n) {
  return t.reduce((r, o) => {
    const {
      column: {
        onFilter: a,
        filters: i
      },
      filteredKeys: l
    } = o;
    return a && l && l.length ? r.map((c) => Object.assign({}, c)).filter((c) => l.some((u) => {
      const d = ga(i), f = d.findIndex((v) => String(v) === String(u)), m = f !== -1 ? d[f] : u;
      return c[n] && (c[n] = Xd(c[n], t, n)), a(m, c);
    })) : r;
  }, e);
}
const U$ = (e) => e.flatMap((t) => "children" in t ? [t].concat(be(U$(t.children || []))) : [t]);
function R3(e) {
  let {
    prefixCls: t,
    dropdownPrefixCls: n,
    mergedColumns: r,
    onFilterChange: o,
    getPopupContainer: a,
    locale: i,
    rootClassName: l
  } = e;
  const c = Rt("Table"), u = s.useMemo(() => U$(r || []), [r]), [d, f] = s.useState(() => Yd(u, !0)), m = s.useMemo(() => {
    const g = Yd(u, !1);
    if (g.length === 0)
      return g;
    let b = !0, y = !0;
    if (g.forEach((C) => {
      let {
        filteredKeys: S
      } = C;
      S !== void 0 ? b = !1 : y = !1;
    }), b) {
      const C = (u || []).map((S, $) => ko(S, al($)));
      return d.filter((S) => {
        let {
          key: $
        } = S;
        return C.includes($);
      }).map((S) => {
        const $ = u[C.findIndex((x) => x === S.key)];
        return Object.assign(Object.assign({}, S), {
          column: Object.assign(Object.assign({}, S.column), $),
          forceFiltered: $.filtered
        });
      });
    }
    return process.env.NODE_ENV !== "production" && c(y, "usage", "Columns should all contain `filteredValue` or not contain `filteredValue`."), g;
  }, [u, d]), v = s.useMemo(() => ah(m), [m]), h = (g) => {
    const b = m.filter((y) => {
      let {
        key: C
      } = y;
      return C !== g.key;
    });
    b.push(g), f(b), o(ah(b), b);
  };
  return [(g) => G$(t, n, g, m, i, h, a, void 0, l), m, v];
}
function M3(e, t, n) {
  const r = s.useRef({});
  function o(a) {
    if (!r.current || r.current.data !== e || r.current.childrenColumnName !== t || r.current.getRowKey !== n) {
      let l = function(c) {
        c.forEach((u, d) => {
          const f = n(u, d);
          i.set(f, u), u && typeof u == "object" && t in u && l(u[t] || []);
        });
      };
      const i = /* @__PURE__ */ new Map();
      l(e), r.current = {
        data: e,
        childrenColumnName: t,
        kvMap: i,
        getRowKey: n
      };
    }
    return r.current.kvMap.get(a);
  }
  return [o];
}
var T3 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Y$ = 10;
function _3(e, t) {
  const n = {
    current: e.current,
    pageSize: e.pageSize
  };
  return Object.keys(t && typeof t == "object" ? t : {}).forEach((o) => {
    const a = e[o];
    typeof a != "function" && (n[o] = a);
  }), n;
}
function D3(e, t, n) {
  const r = n && typeof n == "object" ? n : {}, {
    total: o = 0
  } = r, a = T3(r, ["total"]), [i, l] = Ht(() => ({
    current: "defaultCurrent" in a ? a.defaultCurrent : 1,
    pageSize: "defaultPageSize" in a ? a.defaultPageSize : Y$
  })), c = FA(i, a, {
    total: o > 0 ? o : e
  }), u = Math.ceil((o || e) / c.pageSize);
  c.current > u && (c.current = u || 1);
  const d = (m, v) => {
    l({
      current: m ?? 1,
      pageSize: v || c.pageSize
    });
  }, f = (m, v) => {
    var h;
    n && ((h = n.onChange) === null || h === void 0 || h.call(n, m, v)), d(m, v), t(m, v || (c == null ? void 0 : c.pageSize));
  };
  return n === !1 ? [{}, () => {
  }] : [Object.assign(Object.assign({}, c), {
    onChange: f
  }), d];
}
var k3 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "outlined" };
const L3 = k3;
var X$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: L3
  }));
};
process.env.NODE_ENV !== "production" && (X$.displayName = "CaretDownOutlined");
const F3 = /* @__PURE__ */ s.forwardRef(X$);
var j3 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, name: "caret-up", theme: "outlined" };
const z3 = j3;
var Q$ = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: z3
  }));
};
process.env.NODE_ENV !== "production" && (Q$.displayName = "CaretUpOutlined");
const A3 = /* @__PURE__ */ s.forwardRef(Q$), Ql = "ascend", vu = "descend";
function Es(e) {
  return typeof e.sorter == "object" && typeof e.sorter.multiple == "number" ? e.sorter.multiple : !1;
}
function ih(e) {
  return typeof e == "function" ? e : e && typeof e == "object" && e.compare ? e.compare : !1;
}
function B3(e, t) {
  return t ? e[e.indexOf(t) + 1] : e[0];
}
function Qd(e, t, n) {
  let r = [];
  function o(a, i) {
    r.push({
      column: a,
      key: ko(a, i),
      multiplePriority: Es(a),
      sortOrder: a.sortOrder
    });
  }
  return (e || []).forEach((a, i) => {
    const l = al(i, n);
    a.children ? ("sortOrder" in a && o(a, l), r = [].concat(be(r), be(Qd(a.children, t, l)))) : a.sorter && ("sortOrder" in a ? o(a, l) : t && a.defaultSortOrder && r.push({
      column: a,
      key: ko(a, l),
      multiplePriority: Es(a),
      sortOrder: a.defaultSortOrder
    }));
  }), r;
}
function J$(e, t, n, r, o, a, i, l) {
  return (t || []).map((c, u) => {
    const d = al(u, l);
    let f = c;
    if (f.sorter) {
      const m = f.sortDirections || o, v = f.showSorterTooltip === void 0 ? i : f.showSorterTooltip, h = ko(f, d), p = n.find((N) => {
        let {
          key: O
        } = N;
        return O === h;
      }), g = p ? p.sortOrder : null, b = B3(m, g);
      let y;
      if (c.sortIcon)
        y = c.sortIcon({
          sortOrder: g
        });
      else {
        const N = m.includes(Ql) && /* @__PURE__ */ s.createElement(A3, {
          className: J(`${e}-column-sorter-up`, {
            active: g === Ql
          })
        }), O = m.includes(vu) && /* @__PURE__ */ s.createElement(F3, {
          className: J(`${e}-column-sorter-down`, {
            active: g === vu
          })
        });
        y = /* @__PURE__ */ s.createElement("span", {
          className: J(`${e}-column-sorter`, {
            [`${e}-column-sorter-full`]: !!(N && O)
          })
        }, /* @__PURE__ */ s.createElement("span", {
          className: `${e}-column-sorter-inner`,
          "aria-hidden": "true"
        }, N, O));
      }
      const {
        cancelSort: C,
        triggerAsc: S,
        triggerDesc: $
      } = a || {};
      let x = C;
      b === vu ? x = $ : b === Ql && (x = S);
      const w = typeof v == "object" ? Object.assign({
        title: x
      }, v) : {
        title: x
      };
      f = Object.assign(Object.assign({}, f), {
        className: J(f.className, {
          [`${e}-column-sort`]: g
        }),
        title: (N) => {
          const O = /* @__PURE__ */ s.createElement("div", {
            className: `${e}-column-sorters`
          }, /* @__PURE__ */ s.createElement("span", {
            className: `${e}-column-title`
          }, gc(c.title, N)), y);
          return v ? /* @__PURE__ */ s.createElement(Mr, Object.assign({}, w), O) : O;
        },
        onHeaderCell: (N) => {
          const O = c.onHeaderCell && c.onHeaderCell(N) || {}, E = O.onClick, I = O.onKeyDown;
          O.onClick = (P) => {
            r({
              column: c,
              key: h,
              sortOrder: b,
              multiplePriority: Es(c)
            }), E == null || E(P);
          }, O.onKeyDown = (P) => {
            P.keyCode === Oe.ENTER && (r({
              column: c,
              key: h,
              sortOrder: b,
              multiplePriority: Es(c)
            }), I == null || I(P));
          };
          const k = PH(c.title, {}), M = k == null ? void 0 : k.toString();
          return g ? O["aria-sort"] = g === "ascend" ? "ascending" : "descending" : O["aria-label"] = M || "", O.className = J(O.className, `${e}-column-has-sorters`), O.tabIndex = 0, c.ellipsis && (O.title = (k ?? "").toString()), O;
        }
      });
    }
    return "children" in f && (f = Object.assign(Object.assign({}, f), {
      children: J$(e, f.children, n, r, o, a, i, d)
    })), f;
  });
}
function lh(e) {
  const {
    column: t,
    sortOrder: n
  } = e;
  return {
    column: t,
    order: n,
    field: t.dataIndex,
    columnKey: t.key
  };
}
function sh(e) {
  const t = e.filter((n) => {
    let {
      sortOrder: r
    } = n;
    return r;
  }).map(lh);
  return t.length === 0 && e.length ? Object.assign(Object.assign({}, lh(e[e.length - 1])), {
    column: void 0
  }) : t.length <= 1 ? t[0] || {} : t;
}
function Jd(e, t, n) {
  const r = t.slice().sort((i, l) => l.multiplePriority - i.multiplePriority), o = e.slice(), a = r.filter((i) => {
    let {
      column: {
        sorter: l
      },
      sortOrder: c
    } = i;
    return ih(l) && c;
  });
  return a.length ? o.sort((i, l) => {
    for (let c = 0; c < a.length; c += 1) {
      const u = a[c], {
        column: {
          sorter: d
        },
        sortOrder: f
      } = u, m = ih(d);
      if (m && f) {
        const v = m(i, l, f);
        if (v !== 0)
          return f === Ql ? v : -v;
      }
    }
    return 0;
  }).map((i) => {
    const l = i[n];
    return l ? Object.assign(Object.assign({}, i), {
      [n]: Jd(l, t, n)
    }) : i;
  }) : o;
}
function H3(e) {
  let {
    prefixCls: t,
    mergedColumns: n,
    onSorterChange: r,
    sortDirections: o,
    tableLocale: a,
    showSorterTooltip: i
  } = e;
  const [l, c] = s.useState(Qd(n, !0)), u = s.useMemo(() => {
    let h = !0;
    const p = Qd(n, !1);
    if (!p.length)
      return l;
    const g = [];
    function b(C) {
      h ? g.push(C) : g.push(Object.assign(Object.assign({}, C), {
        sortOrder: null
      }));
    }
    let y = null;
    return p.forEach((C) => {
      y === null ? (b(C), C.sortOrder && (C.multiplePriority === !1 ? h = !1 : y = !0)) : (y && C.multiplePriority !== !1 || (h = !1), b(C));
    }), g;
  }, [n, l]), d = s.useMemo(() => {
    const h = u.map((p) => {
      let {
        column: g,
        sortOrder: b
      } = p;
      return {
        column: g,
        order: b
      };
    });
    return {
      sortColumns: h,
      // Legacy
      sortColumn: h[0] && h[0].column,
      sortOrder: h[0] && h[0].order
    };
  }, [u]);
  function f(h) {
    let p;
    h.multiplePriority === !1 || !u.length || u[0].multiplePriority === !1 ? p = [h] : p = [].concat(be(u.filter((g) => {
      let {
        key: b
      } = g;
      return b !== h.key;
    })), [h]), c(p), r(sh(p), p);
  }
  return [(h) => J$(t, h, u, f, o, a, i), u, d, () => sh(u)];
}
function Z$(e, t) {
  return e.map((n) => {
    const r = Object.assign({}, n);
    return r.title = gc(n.title, t), "children" in r && (r.children = Z$(r.children, t)), r;
  });
}
function V3(e) {
  return [s.useCallback((n) => Z$(n, e), [e])];
}
const W3 = x$((e, t) => {
  const {
    _renderTimes: n
  } = e, {
    _renderTimes: r
  } = t;
  return n !== r;
}), K3 = O$((e, t) => {
  const {
    _renderTimes: n
  } = e, {
    _renderTimes: r
  } = t;
  return n !== r;
}), q3 = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    lineType: r,
    tableBorderColor: o,
    tableHeaderBg: a,
    tablePaddingVertical: i,
    tablePaddingHorizontal: l,
    calc: c
  } = e, u = `${q(n)} ${r} ${o}`, d = (f, m, v) => ({
    [`&${t}-${f}`]: {
      [`> ${t}-container`]: {
        [`> ${t}-content, > ${t}-body`]: {
          [`
            > table > tbody > tr > th,
            > table > tbody > tr > td
          `]: {
            [`> ${t}-expanded-row-fixed`]: {
              margin: `${q(c(m).mul(-1).equal())}
              ${q(c(c(v).add(n)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${t}-wrapper`]: {
      [`${t}${t}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${t}-title`]: {
          border: u,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${t}-container`]: {
          borderInlineStart: u,
          borderTop: u,
          [`
            > ${t}-content,
            > ${t}-header,
            > ${t}-body,
            > ${t}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              [`
                > thead > tr > th,
                > thead > tr > td,
                > tbody > tr > th,
                > tbody > tr > td,
                > tfoot > tr > th,
                > tfoot > tr > td
              `]: {
                borderInlineEnd: u
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: u
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              [`
                > thead > tr,
                > tbody > tr,
                > tfoot > tr
              `]: {
                [`> ${t}-cell-fix-right-first::after`]: {
                  borderInlineEnd: u
                }
              },
              // ========================== Expandable ==========================
              [`
                > tbody > tr > th,
                > tbody > tr > td
              `]: {
                [`> ${t}-expanded-row-fixed`]: {
                  margin: `${q(c(i).mul(-1).equal())} ${q(c(c(l).add(n)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: n,
                    bottom: 0,
                    borderInlineEnd: u,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${t}-scroll-horizontal`]: {
          [`> ${t}-container > ${t}-body`]: {
            "> table > tbody": {
              [`
                > tr${t}-expanded-row,
                > tr${t}-placeholder
              `]: {
                ["> th, > td"]: {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, d("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle)), d("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${t}-footer`]: {
          border: u,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${t}-cell`]: {
        [`${t}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${q(n)} 0 ${q(n)} ${a}`
        }
      },
      [`${t}-bordered ${t}-cell-scrollbar`]: {
        borderInlineEnd: u
      }
    }
  };
}, G3 = q3, U3 = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-cell-ellipsis`]: Object.assign(Object.assign({}, Vr), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${t}-cell-fix-left-last,
          &${t}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${t}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${t}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
}, Y3 = U3, X3 = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-tbody > tr${t}-placeholder`]: {
        textAlign: "center",
        color: e.colorTextDisabled,
        [`
          &:hover > th,
          &:hover > td,
        `]: {
          background: e.colorBgContainer
        }
      }
    }
  };
}, Q3 = X3, J3 = (e) => {
  const {
    componentCls: t,
    antCls: n,
    motionDurationSlow: r,
    lineWidth: o,
    paddingXS: a,
    lineType: i,
    tableBorderColor: l,
    tableExpandIconBg: c,
    tableExpandColumnWidth: u,
    borderRadius: d,
    tablePaddingVertical: f,
    tablePaddingHorizontal: m,
    tableExpandedRowBg: v,
    paddingXXS: h,
    expandIconMarginTop: p,
    expandIconSize: g,
    expandIconHalfInner: b,
    expandIconScale: y,
    calc: C
  } = e, S = `${q(o)} ${i} ${l}`, $ = C(h).sub(o).equal();
  return {
    [`${t}-wrapper`]: {
      [`${t}-expand-icon-col`]: {
        width: u
      },
      [`${t}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${t}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${t}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${t}-row-expand-icon`]: Object.assign(Object.assign({}, vf(e)), {
        position: "relative",
        float: "left",
        boxSizing: "border-box",
        width: g,
        height: g,
        padding: 0,
        color: "inherit",
        lineHeight: q(g),
        background: c,
        border: S,
        borderRadius: d,
        transform: `scale(${y})`,
        transition: `all ${r}`,
        userSelect: "none",
        ["&:focus, &:hover, &:active"]: {
          borderColor: "currentcolor"
        },
        ["&::before, &::after"]: {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${r} ease-out`,
          content: '""'
        },
        "&::before": {
          top: b,
          insetInlineEnd: $,
          insetInlineStart: $,
          height: o
        },
        "&::after": {
          top: $,
          bottom: $,
          insetInlineStart: b,
          width: o,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${t}-row-indent + ${t}-row-expand-icon`]: {
        marginTop: p,
        marginInlineEnd: a
      },
      [`tr${t}-expanded-row`]: {
        "&, &:hover": {
          ["> th, > td"]: {
            background: v
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${n}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "auto"
          }
        }
      },
      // With fixed
      [`${t}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${q(C(f).mul(-1).equal())} ${q(C(m).mul(-1).equal())}`,
        padding: `${q(f)} ${q(m)}`
      }
    }
  };
}, Z3 = J3, eV = (e) => {
  const {
    componentCls: t,
    antCls: n,
    iconCls: r,
    tableFilterDropdownWidth: o,
    tableFilterDropdownSearchWidth: a,
    paddingXXS: i,
    paddingXS: l,
    colorText: c,
    lineWidth: u,
    lineType: d,
    tableBorderColor: f,
    headerIconColor: m,
    fontSizeSM: v,
    tablePaddingHorizontal: h,
    borderRadius: p,
    motionDurationSlow: g,
    colorTextDescription: b,
    colorPrimary: y,
    tableHeaderFilterActiveBg: C,
    colorTextDisabled: S,
    tableFilterDropdownBg: $,
    tableFilterDropdownHeight: x,
    controlItemBgHover: w,
    controlItemBgActive: N,
    boxShadowSecondary: O,
    filterDropdownMenuBg: E,
    calc: I
  } = e, k = `${n}-dropdown`, M = `${t}-filter-dropdown`, P = `${n}-tree`, _ = `${q(u)} ${d} ${f}`;
  return [
    {
      [`${t}-wrapper`]: {
        [`${t}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${t}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: I(i).mul(-1).equal(),
          marginInline: `${q(i)} ${q(I(h).div(2).mul(-1).equal())}`,
          padding: `0 ${q(i)}`,
          color: m,
          fontSize: v,
          borderRadius: p,
          cursor: "pointer",
          transition: `all ${g}`,
          "&:hover": {
            color: b,
            background: C
          },
          "&.active": {
            color: y
          }
        }
      }
    },
    {
      // Dropdown
      [`${n}-dropdown`]: {
        [M]: Object.assign(Object.assign({}, Gt(e)), {
          minWidth: o,
          backgroundColor: $,
          borderRadius: p,
          boxShadow: O,
          overflow: "hidden",
          // Reset menu
          [`${k}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: x,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: E,
            "&:empty::after": {
              display: "block",
              padding: `${q(l)} 0`,
              color: S,
              fontSize: v,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${M}-tree`]: {
            paddingBlock: `${q(l)} 0`,
            paddingInline: l,
            [P]: {
              padding: 0
            },
            [`${P}-treenode ${P}-node-content-wrapper:hover`]: {
              backgroundColor: w
            },
            [`${P}-treenode-checkbox-checked ${P}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: N
              }
            }
          },
          [`${M}-search`]: {
            padding: l,
            borderBottom: _,
            "&-input": {
              input: {
                minWidth: a
              },
              [r]: {
                color: S
              }
            }
          },
          [`${M}-checkall`]: {
            width: "100%",
            marginBottom: i,
            marginInlineStart: i
          },
          // Operation
          [`${M}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${q(I(l).sub(u).equal())} ${q(l)}`,
            overflow: "hidden",
            borderTop: _
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${n}-dropdown ${M}, ${M}-submenu`]: {
        // Checkbox
        [`${n}-checkbox-wrapper + span`]: {
          paddingInlineStart: l,
          color: c
        },
        ["> ul"]: {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
}, tV = eV, nV = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    colorSplit: r,
    motionDurationSlow: o,
    zIndexTableFixed: a,
    tableBg: i,
    zIndexTableSticky: l,
    calc: c
  } = e, u = r;
  return {
    [`${t}-wrapper`]: {
      [`
        ${t}-cell-fix-left,
        ${t}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: a,
        background: i
      },
      [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: c(n).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${o}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: c(n).mul(-1).equal(),
        left: {
          _skip_check_: !0,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${o}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-container`]: {
        position: "relative",
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: c(l).add(1).equal({
            unit: !1
          }),
          width: 30,
          transition: `box-shadow ${o}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${t}-ping-left`]: {
        [`&:not(${t}-has-fix-left) ${t}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${u}`
        },
        [`
          ${t}-cell-fix-left-first::after,
          ${t}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${u}`
        },
        [`${t}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${t}-ping-right`]: {
        [`&:not(${t}-has-fix-right) ${t}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${u}`
        },
        [`
          ${t}-cell-fix-right-first::after,
          ${t}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${u}`
        }
      },
      // Gapped fixed Columns do not show the shadow
      [`${t}-fixed-column-gapped`]: {
        [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after,
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
          boxShadow: "none"
        }
      }
    }
  };
}, rV = nV, oV = (e) => {
  const {
    componentCls: t,
    antCls: n,
    margin: r
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${t}-pagination${n}-pagination`]: {
        margin: `${q(r)} 0`
      },
      [`${t}-pagination`]: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: e.paddingXS,
        "> *": {
          flex: "none"
        },
        "&-left": {
          justifyContent: "flex-start"
        },
        "&-center": {
          justifyContent: "center"
        },
        "&-right": {
          justifyContent: "flex-end"
        }
      }
    }
  };
}, aV = oV, iV = (e) => {
  const {
    componentCls: t,
    tableRadius: n
  } = e;
  return {
    [`${t}-wrapper`]: {
      [t]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${t}-title, ${t}-header`]: {
          borderRadius: `${q(n)} ${q(n)} 0 0`
        },
        [`${t}-title + ${t}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${t}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: n,
          borderStartEndRadius: n,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: n
            },
            "> *:last-child": {
              borderStartEndRadius: n
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${q(n)} ${q(n)}`
        }
      }
    }
  };
}, lV = iV, sV = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${t}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${t}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${t}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${t}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${t}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
}, cV = sV, uV = (e) => {
  const {
    componentCls: t,
    antCls: n,
    iconCls: r,
    fontSizeIcon: o,
    padding: a,
    paddingXS: i,
    headerIconColor: l,
    headerIconHoverColor: c,
    tableSelectionColumnWidth: u,
    tableSelectedRowBg: d,
    tableSelectedRowHoverBg: f,
    tableRowHoverBg: m,
    tablePaddingHorizontal: v,
    calc: h
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Selections ==========================
      [`${t}-selection-col`]: {
        width: u,
        [`&${t}-selection-col-with-dropdown`]: {
          width: h(u).add(o).add(h(a).div(4)).equal()
        }
      },
      [`${t}-bordered ${t}-selection-col`]: {
        width: h(u).add(h(i).mul(2)).equal(),
        [`&${t}-selection-col-with-dropdown`]: {
          width: h(u).add(o).add(h(a).div(4)).add(h(i).mul(2)).equal()
        }
      },
      [`
        table tr th${t}-selection-column,
        table tr td${t}-selection-column,
        ${t}-selection-column
      `]: {
        paddingInlineEnd: e.paddingXS,
        paddingInlineStart: e.paddingXS,
        textAlign: "center",
        [`${n}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${t}-selection-column${t}-cell-fix-left`]: {
        zIndex: e.zIndexTableFixed + 1
      },
      [`table tr th${t}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${t}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${t}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: q(h(v).div(4).equal()),
        [r]: {
          color: l,
          fontSize: o,
          verticalAlign: "baseline",
          "&:hover": {
            color: c
          }
        }
      },
      // ============================= Rows =============================
      [`${t}-tbody`]: {
        [`${t}-row`]: {
          [`&${t}-row-selected`]: {
            [`> ${t}-cell`]: {
              background: d,
              "&-row-hover": {
                background: f
              }
            }
          },
          [`> ${t}-cell-row-hover`]: {
            background: m
          }
        }
      }
    }
  };
}, dV = uV, fV = (e) => {
  const {
    componentCls: t,
    tableExpandColumnWidth: n,
    calc: r
  } = e, o = (a, i, l, c) => ({
    [`${t}${t}-${a}`]: {
      fontSize: c,
      [`
        ${t}-title,
        ${t}-footer,
        ${t}-cell,
        ${t}-thead > tr > th,
        ${t}-tbody > tr > th,
        ${t}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${q(i)} ${q(l)}`
      },
      [`${t}-filter-trigger`]: {
        marginInlineEnd: q(r(l).div(2).mul(-1).equal())
      },
      [`${t}-expanded-row-fixed`]: {
        margin: `${q(r(i).mul(-1).equal())} ${q(r(l).mul(-1).equal())}`
      },
      [`${t}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${t}-wrapper:only-child ${t}`]: {
          marginBlock: q(r(i).mul(-1).equal()),
          marginInline: `${q(r(n).sub(l).equal())} ${q(r(l).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${t}-selection-extra`]: {
        paddingInlineStart: q(r(l).div(4).equal())
      }
    }
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, o("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle, e.tableFontSizeMiddle)), o("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall, e.tableFontSizeSmall))
  };
}, mV = fV, vV = (e) => {
  const {
    componentCls: t,
    marginXXS: n,
    fontSizeIcon: r,
    headerIconColor: o,
    headerIconHoverColor: a
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-thead th${t}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          background: e.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: e.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${t}-cell-fix-left:hover,
          &${t}-cell-fix-right:hover
        `]: {
          background: e.tableFixedHeaderSortActiveBg
        }
      },
      [`${t}-thead th${t}-column-sort`]: {
        background: e.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${t}-column-sort`]: {
        background: e.tableBodySortBg
      },
      [`${t}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1
      },
      [`${t}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${t}-column-sorter`]: {
        marginInlineStart: n,
        color: o,
        fontSize: 0,
        transition: `color ${e.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: r,
          "&.active": {
            color: e.colorPrimary
          }
        },
        [`${t}-column-sorter-up + ${t}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${t}-column-sorters:hover ${t}-column-sorter`]: {
        color: a
      }
    }
  };
}, gV = vV, pV = (e) => {
  const {
    componentCls: t,
    opacityLoading: n,
    tableScrollThumbBg: r,
    tableScrollThumbBgHover: o,
    tableScrollThumbSize: a,
    tableScrollBg: i,
    zIndexTableSticky: l,
    stickyScrollBarBorderRadius: c,
    lineWidth: u,
    lineType: d,
    tableBorderColor: f
  } = e, m = `${q(u)} ${d} ${f}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: l,
          background: e.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${q(a)} !important`,
          zIndex: l,
          display: "flex",
          alignItems: "center",
          background: i,
          borderTop: m,
          opacity: n,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: a,
            backgroundColor: r,
            borderRadius: c,
            transition: `all ${e.motionDurationSlow}, transform none`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: o
            }
          }
        }
      }
    }
  };
}, hV = pV, bV = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    tableBorderColor: r,
    calc: o
  } = e, a = `${q(n)} ${e.lineType} ${r}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-summary`]: {
        position: "relative",
        zIndex: e.zIndexTableFixed,
        background: e.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: a
          }
        }
      },
      [`div${t}-summary`]: {
        boxShadow: `0 ${q(o(n).mul(-1).equal())} 0 ${r}`
      }
    }
  };
}, ch = bV, yV = (e) => {
  const {
    componentCls: t,
    motionDurationMid: n,
    lineWidth: r,
    lineType: o,
    tableBorderColor: a,
    calc: i
  } = e, l = `${q(r)} ${o} ${a}`, c = `${t}-expanded-row-cell`;
  return {
    [`${t}-wrapper`]: {
      // ========================== Row ==========================
      [`${t}-tbody-virtual`]: {
        [`${t}-row`]: {
          display: "flex",
          boxSizing: "border-box",
          width: "100%"
        },
        [`${t}-cell`]: {
          borderBottom: l,
          transition: `background ${n}`
        },
        [`${t}-expanded-row`]: {
          [`${c}${c}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${q(r)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${t}-bordered`]: {
        [`${t}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: l,
            position: "absolute"
          },
          [`${t}-cell`]: {
            borderInlineEnd: l,
            [`&${t}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: i(r).mul(-1).equal(),
              borderInlineStart: l
            }
          }
        },
        // Empty placeholder
        [`&${t}-virtual`]: {
          [`${t}-placeholder ${t}-cell`]: {
            borderInlineEnd: l,
            borderBottom: l
          }
        }
      }
    }
  };
}, CV = yV, SV = (e) => {
  const {
    componentCls: t,
    fontWeightStrong: n,
    tablePaddingVertical: r,
    tablePaddingHorizontal: o,
    tableExpandColumnWidth: a,
    lineWidth: i,
    lineType: l,
    tableBorderColor: c,
    tableFontSize: u,
    tableBg: d,
    tableRadius: f,
    tableHeaderTextColor: m,
    motionDurationMid: v,
    tableHeaderBg: h,
    tableHeaderCellSplitColor: p,
    tableFooterTextColor: g,
    tableFooterBg: b,
    calc: y
  } = e, C = `${q(i)} ${l} ${c}`;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%"
    }, Mo()), {
      [t]: Object.assign(Object.assign({}, Gt(e)), {
        fontSize: u,
        background: d,
        borderRadius: `${q(f)} ${q(f)} 0 0`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${q(f)} ${q(f)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${t}-cell,
          ${t}-thead > tr > th,
          ${t}-tbody > tr > th,
          ${t}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${q(r)} ${q(o)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${t}-title`]: {
        padding: `${q(r)} ${q(o)}`
      },
      // ============================ Header ============================
      [`${t}-thead`]: {
        [`
          > tr > th,
          > tr > td
        `]: {
          position: "relative",
          color: m,
          fontWeight: n,
          textAlign: "start",
          background: h,
          borderBottom: C,
          transition: `background ${v} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${t}-selection-column):not(${t}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: p,
            transform: "translateY(-50%)",
            transition: `background-color ${v}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${t}-tbody`]: {
        "> tr": {
          ["> th, > td"]: {
            transition: `background ${v}, border-color ${v}`,
            borderBottom: C,
            // ========================= Nest Table ===========================
            [`
              > ${t}-wrapper:only-child,
              > ${t}-expanded-row-fixed > ${t}-wrapper:only-child
            `]: {
              [t]: {
                marginBlock: q(y(r).mul(-1).equal()),
                marginInline: `${q(y(a).sub(o).equal())}
                ${q(y(o).mul(-1).equal())}`,
                [`${t}-tbody > tr:last-child > td`]: {
                  borderBottom: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: m,
            fontWeight: n,
            textAlign: "start",
            background: h,
            borderBottom: C,
            transition: `background ${v} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${t}-footer`]: {
        padding: `${q(r)} ${q(o)}`,
        color: g,
        background: b
      }
    })
  };
}, xV = (e) => {
  const {
    colorFillAlter: t,
    colorBgContainer: n,
    colorTextHeading: r,
    colorFillSecondary: o,
    colorFillContent: a,
    controlItemBgActive: i,
    controlItemBgActiveHover: l,
    padding: c,
    paddingSM: u,
    paddingXS: d,
    colorBorderSecondary: f,
    borderRadiusLG: m,
    controlHeight: v,
    colorTextPlaceholder: h,
    fontSize: p,
    fontSizeSM: g,
    lineHeight: b,
    lineWidth: y,
    colorIcon: C,
    colorIconHover: S,
    opacityLoading: $,
    controlInteractiveSize: x
  } = e, w = new Zt(o).onBackground(n).toHexShortString(), N = new Zt(a).onBackground(n).toHexShortString(), O = new Zt(t).onBackground(n).toHexShortString(), E = new Zt(C), I = new Zt(S), k = x / 2 - y, M = k * 2 + y * 3;
  return {
    headerBg: O,
    headerColor: r,
    headerSortActiveBg: w,
    headerSortHoverBg: N,
    bodySortBg: O,
    rowHoverBg: O,
    rowSelectedBg: i,
    rowSelectedHoverBg: l,
    rowExpandedBg: t,
    cellPaddingBlock: c,
    cellPaddingInline: c,
    cellPaddingBlockMD: u,
    cellPaddingInlineMD: d,
    cellPaddingBlockSM: d,
    cellPaddingInlineSM: d,
    borderColor: f,
    headerBorderRadius: m,
    footerBg: O,
    footerColor: r,
    cellFontSize: p,
    cellFontSizeMD: p,
    cellFontSizeSM: p,
    headerSplitColor: f,
    fixedHeaderSortActiveBg: w,
    headerFilterHoverBg: a,
    filterDropdownMenuBg: n,
    filterDropdownBg: n,
    expandIconBg: n,
    selectionColumnWidth: v,
    stickyScrollBarBg: h,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (p * b - y * 3) / 2 - Math.ceil((g * 1.4 - y * 3) / 2),
    headerIconColor: E.clone().setAlpha(E.getAlpha() * $).toRgbString(),
    headerIconHoverColor: I.clone().setAlpha(I.getAlpha() * $).toRgbString(),
    expandIconHalfInner: k,
    expandIconSize: M,
    expandIconScale: x / M
  };
}, $V = Xt("Table", (e) => {
  const {
    colorTextHeading: t,
    colorSplit: n,
    colorBgContainer: r,
    controlInteractiveSize: o,
    headerBg: a,
    headerColor: i,
    headerSortActiveBg: l,
    headerSortHoverBg: c,
    bodySortBg: u,
    rowHoverBg: d,
    rowSelectedBg: f,
    rowSelectedHoverBg: m,
    rowExpandedBg: v,
    cellPaddingBlock: h,
    cellPaddingInline: p,
    cellPaddingBlockMD: g,
    cellPaddingInlineMD: b,
    cellPaddingBlockSM: y,
    cellPaddingInlineSM: C,
    borderColor: S,
    footerBg: $,
    footerColor: x,
    headerBorderRadius: w,
    cellFontSize: N,
    cellFontSizeMD: O,
    cellFontSizeSM: E,
    headerSplitColor: I,
    fixedHeaderSortActiveBg: k,
    headerFilterHoverBg: M,
    filterDropdownBg: P,
    expandIconBg: _,
    selectionColumnWidth: D,
    stickyScrollBarBg: R,
    calc: T
  } = e, L = 2, F = Dt(e, {
    tableFontSize: N,
    tableBg: r,
    tableRadius: w,
    tablePaddingVertical: h,
    tablePaddingHorizontal: p,
    tablePaddingVerticalMiddle: g,
    tablePaddingHorizontalMiddle: b,
    tablePaddingVerticalSmall: y,
    tablePaddingHorizontalSmall: C,
    tableBorderColor: S,
    tableHeaderTextColor: i,
    tableHeaderBg: a,
    tableFooterTextColor: x,
    tableFooterBg: $,
    tableHeaderCellSplitColor: I,
    tableHeaderSortBg: l,
    tableHeaderSortHoverBg: c,
    tableBodySortBg: u,
    tableFixedHeaderSortActiveBg: k,
    tableHeaderFilterActiveBg: M,
    tableFilterDropdownBg: P,
    tableRowHoverBg: d,
    tableSelectedRowBg: f,
    tableSelectedRowHoverBg: m,
    zIndexTableFixed: L,
    zIndexTableSticky: L + 1,
    tableFontSizeMiddle: O,
    tableFontSizeSmall: E,
    tableSelectionColumnWidth: D,
    tableExpandIconBg: _,
    tableExpandColumnWidth: T(o).add(T(e.padding).mul(2)).equal(),
    tableExpandedRowBg: v,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: R,
    tableScrollThumbBgHover: t,
    tableScrollBg: n
  });
  return [SV(F), aV(F), ch(F), gV(F), tV(F), G3(F), lV(F), Z3(F), ch(F), Q3(F), dV(F), rV(F), hV(F), Y3(F), mV(F), cV(F), CV(F)];
}, xV, {
  unitless: {
    expandIconScale: !0
  }
}), wV = [], EV = (e, t) => {
  var n, r;
  const {
    prefixCls: o,
    className: a,
    rootClassName: i,
    style: l,
    size: c,
    bordered: u,
    dropdownPrefixCls: d,
    dataSource: f,
    pagination: m,
    rowSelection: v,
    rowKey: h = "key",
    rowClassName: p,
    columns: g,
    children: b,
    childrenColumnName: y,
    onChange: C,
    getPopupContainer: S,
    loading: $,
    expandIcon: x,
    expandable: w,
    expandedRowRender: N,
    expandIconColumnIndex: O,
    indentSize: E,
    scroll: I,
    sortDirections: k,
    locale: M,
    showSorterTooltip: P = !0,
    virtual: _
  } = e, D = Rt("Table");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && D(!(typeof h == "function" && h.length > 1), "usage", "`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.");
  const R = s.useMemo(() => g || km(b), [g, b]), T = s.useMemo(() => R.some((ce) => ce.responsive), [R]), L = Yy(T), F = s.useMemo(() => {
    const ce = new Set(Object.keys(L).filter((Ce) => L[Ce]));
    return R.filter((Ce) => !Ce.responsive || Ce.responsive.some((je) => ce.has(je)));
  }, [R, L]), j = an(e, ["className", "style", "columns"]), {
    locale: A = xr,
    direction: B,
    table: K,
    renderEmpty: Y,
    getPrefixCls: G,
    getPopupContainer: te
  } = s.useContext(lt), ee = qn(c), oe = Object.assign(Object.assign({}, A.Table), M), X = f || wV, W = G("table", o), re = G("dropdown", d), [, Z] = Sn(), H = En(W), [U, ae, ue] = $V(W, H), de = Object.assign(Object.assign({
    childrenColumnName: y,
    expandIconColumnIndex: O
  }, w), {
    expandIcon: (n = w == null ? void 0 : w.expandIcon) !== null && n !== void 0 ? n : (r = K == null ? void 0 : K.expandable) === null || r === void 0 ? void 0 : r.expandIcon
  }), {
    childrenColumnName: se = "children"
  } = de, ie = s.useMemo(() => X.some((ce) => ce == null ? void 0 : ce[se]) ? "nest" : N || w && w.expandedRowRender ? "row" : null, [X]), me = {
    body: s.useRef()
  }, Se = IH(W), ve = s.useRef(null), ge = s.useRef(null);
  OH(t, () => Object.assign(Object.assign({}, ge.current), {
    nativeElement: ve.current
  }));
  const $e = s.useMemo(() => typeof h == "function" ? h : (ce) => ce == null ? void 0 : ce[h], [h]), [we] = M3(X, se, $e), _e = {}, ze = function(ce, Ce) {
    let je = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    var Ne, De, Fe;
    const ot = Object.assign(Object.assign({}, _e), ce);
    je && ((Ne = _e.resetPagination) === null || Ne === void 0 || Ne.call(_e), !((De = ot.pagination) === null || De === void 0) && De.current && (ot.pagination.current = 1), m && m.onChange && m.onChange(1, (Fe = ot.pagination) === null || Fe === void 0 ? void 0 : Fe.pageSize)), I && I.scrollToFirstRowOnChange !== !1 && me.body.current && eI(0, {
      getContainer: () => me.body.current
    }), C == null || C(ot.pagination, ot.filters, ot.sorter, {
      currentDataSource: Xd(Jd(X, ot.sorterStates, se), ot.filterStates, se),
      action: Ce
    });
  }, Te = (ce, Ce) => {
    ze({
      sorter: ce,
      sorterStates: Ce
    }, "sort", !1);
  }, [ke, Le, Ee, xe] = H3({
    prefixCls: W,
    mergedColumns: F,
    onSorterChange: Te,
    sortDirections: k || ["ascend", "descend"],
    tableLocale: oe,
    showSorterTooltip: P
  }), he = s.useMemo(() => Jd(X, Le, se), [X, Le]);
  _e.sorter = xe(), _e.sorterStates = Le;
  const pe = (ce, Ce) => {
    ze({
      filters: ce,
      filterStates: Ce
    }, "filter", !0);
  }, [Pe, Re, at] = R3({
    prefixCls: W,
    locale: oe,
    dropdownPrefixCls: re,
    mergedColumns: F,
    onFilterChange: pe,
    getPopupContainer: S || te,
    rootClassName: J(i, H)
  }), Ze = Xd(he, Re, se);
  _e.filters = at, _e.filterStates = Re;
  const Ie = s.useMemo(() => {
    const ce = {};
    return Object.keys(at).forEach((Ce) => {
      at[Ce] !== null && (ce[Ce] = at[Ce]);
    }), Object.assign(Object.assign({}, Ee), {
      filters: ce
    });
  }, [Ee, at]), [Be] = V3(Ie), bt = (ce, Ce) => {
    ze({
      pagination: Object.assign(Object.assign({}, _e.pagination), {
        current: ce,
        pageSize: Ce
      })
    }, "paginate");
  }, [He, nt] = D3(Ze.length, bt, m);
  _e.pagination = m === !1 ? {} : _3(He, m), _e.resetPagination = nt;
  const et = s.useMemo(() => {
    if (m === !1 || !He.pageSize)
      return Ze;
    const {
      current: ce = 1,
      total: Ce,
      pageSize: je = Y$
    } = He;
    return process.env.NODE_ENV !== "production" && D(ce > 0, "usage", "`current` should be positive number."), Ze.length < Ce ? Ze.length > je ? (process.env.NODE_ENV !== "production" && D(!1, "usage", "`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode."), Ze.slice((ce - 1) * je, ce * je)) : Ze : Ze.slice((ce - 1) * je, ce * je);
  }, [!!m, Ze, He && He.current, He && He.pageSize, He && He.total]), [Ge, Ae] = wH({
    prefixCls: W,
    data: Ze,
    pageData: et,
    getRowKey: $e,
    getRecordByKey: we,
    expandType: ie,
    childrenColumnName: se,
    locale: oe,
    getPopupContainer: S || te
  }, v), qe = (ce, Ce, je) => {
    let Ne;
    return typeof p == "function" ? Ne = J(p(ce, Ce, je)) : Ne = J(p), J({
      [`${W}-row-selected`]: Ae.has($e(ce, Ce))
    }, Ne);
  };
  de.__PARENT_RENDER_ICON__ = de.expandIcon, de.expandIcon = de.expandIcon || x || NH(oe), ie === "nest" && de.expandIconColumnIndex === void 0 ? de.expandIconColumnIndex = v ? 1 : 0 : de.expandIconColumnIndex > 0 && v && (de.expandIconColumnIndex -= 1), typeof de.indentSize != "number" && (de.indentSize = typeof E == "number" ? E : 15);
  const Je = s.useCallback((ce) => Be(Ge(Pe(ke(ce)))), [ke, Pe, Ge]);
  let Ke, Ye;
  if (m !== !1 && (He != null && He.total)) {
    let ce;
    He.size ? ce = He.size : ce = ee === "small" || ee === "middle" ? "small" : void 0;
    const Ce = (De) => /* @__PURE__ */ s.createElement(nB, Object.assign({}, He, {
      className: J(`${W}-pagination ${W}-pagination-${De}`, He.className),
      size: ce
    })), je = B === "rtl" ? "left" : "right", {
      position: Ne
    } = He;
    if (Ne !== null && Array.isArray(Ne)) {
      const De = Ne.find((pt) => pt.includes("top")), Fe = Ne.find((pt) => pt.includes("bottom")), ot = Ne.every((pt) => `${pt}` == "none");
      !De && !Fe && !ot && (Ye = Ce(je)), De && (Ke = Ce(De.toLowerCase().replace("top", ""))), Fe && (Ye = Ce(Fe.toLowerCase().replace("bottom", "")));
    } else
      Ye = Ce(je);
  }
  let Ve;
  typeof $ == "boolean" ? Ve = {
    spinning: $
  } : typeof $ == "object" && (Ve = Object.assign({
    spinning: !0
  }, $));
  const Qe = J(ue, H, `${W}-wrapper`, K == null ? void 0 : K.className, {
    [`${W}-wrapper-rtl`]: B === "rtl"
  }, a, i, ae), it = Object.assign(Object.assign({}, K == null ? void 0 : K.style), l), yt = M && M.emptyText || (Y == null ? void 0 : Y("Table")) || /* @__PURE__ */ s.createElement(jy, {
    componentName: "Table"
  }), Tt = _ ? K3 : W3, ne = {}, ye = s.useMemo(() => {
    const {
      fontSize: ce,
      lineHeight: Ce,
      padding: je,
      paddingXS: Ne,
      paddingSM: De
    } = Z, Fe = Math.floor(ce * Ce);
    switch (ee) {
      case "large":
        return je * 2 + Fe;
      case "small":
        return Ne * 2 + Fe;
      default:
        return De * 2 + Fe;
    }
  }, [Z, ee]);
  return _ && (ne.listItemHeight = ye), U(/* @__PURE__ */ s.createElement("div", {
    ref: ve,
    className: Qe,
    style: it
  }, /* @__PURE__ */ s.createElement(qx, Object.assign({
    spinning: !1
  }, Ve), Ke, /* @__PURE__ */ s.createElement(Tt, Object.assign({}, ne, j, {
    ref: ge,
    columns: F,
    direction: B,
    expandable: de,
    prefixCls: W,
    className: J({
      [`${W}-middle`]: ee === "middle",
      [`${W}-small`]: ee === "small",
      [`${W}-bordered`]: u,
      [`${W}-empty`]: X.length === 0
    }, ue, H, ae),
    data: et,
    rowKey: $e,
    rowClassName: qe,
    emptyText: yt,
    // Internal
    internalHooks: ol,
    internalRefs: me,
    transformColumns: Je,
    getContainerWidth: Se
  })), Ye)));
}, OV = /* @__PURE__ */ s.forwardRef(EV), NV = (e, t) => {
  const n = s.useRef(0);
  return n.current += 1, /* @__PURE__ */ s.createElement(OV, Object.assign({}, e, {
    ref: t,
    _renderTimes: n.current
  }));
}, Tr = /* @__PURE__ */ s.forwardRef(NV);
Tr.SELECTION_COLUMN = Nr;
Tr.EXPAND_COLUMN = Ir;
Tr.SELECTION_ALL = Kd;
Tr.SELECTION_INVERT = qd;
Tr.SELECTION_NONE = Gd;
Tr.Column = mH;
Tr.ColumnGroup = vH;
Tr.Summary = l$;
process.env.NODE_ENV !== "production" && (Tr.displayName = "Table");
const IV = Tr, PV = (e) => {
  const {
    paddingXXS: t,
    lineWidth: n,
    tagPaddingHorizontal: r,
    componentCls: o,
    calc: a
  } = e, i = a(r).sub(n).equal(), l = a(t).sub(n).equal();
  return {
    // Result
    [o]: Object.assign(Object.assign({}, Gt(e)), {
      display: "inline-block",
      height: "auto",
      marginInlineEnd: e.marginXS,
      paddingInline: i,
      fontSize: e.tagFontSize,
      lineHeight: e.tagLineHeight,
      whiteSpace: "nowrap",
      background: e.defaultBg,
      border: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
      borderRadius: e.borderRadiusSM,
      opacity: 1,
      transition: `all ${e.motionDurationMid}`,
      textAlign: "start",
      position: "relative",
      // RTL
      [`&${o}-rtl`]: {
        direction: "rtl"
      },
      "&, a, a:hover": {
        color: e.defaultColor
      },
      [`${o}-close-icon`]: {
        marginInlineStart: l,
        fontSize: e.tagIconSize,
        color: e.colorTextDescription,
        cursor: "pointer",
        transition: `all ${e.motionDurationMid}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      [`&${o}-has-color`]: {
        borderColor: "transparent",
        [`&, a, a:hover, ${e.iconCls}-close, ${e.iconCls}-close:hover`]: {
          color: e.colorTextLightSolid
        }
      },
      ["&-checkable"]: {
        backgroundColor: "transparent",
        borderColor: "transparent",
        cursor: "pointer",
        [`&:not(${o}-checkable-checked):hover`]: {
          color: e.colorPrimary,
          backgroundColor: e.colorFillSecondary
        },
        "&:active, &-checked": {
          color: e.colorTextLightSolid
        },
        "&-checked": {
          backgroundColor: e.colorPrimary,
          "&:hover": {
            backgroundColor: e.colorPrimaryHover
          }
        },
        "&:active": {
          backgroundColor: e.colorPrimaryActive
        }
      },
      ["&-hidden"]: {
        display: "none"
      },
      // To ensure that a space will be placed between character and `Icon`.
      [`> ${e.iconCls} + span, > span + ${e.iconCls}`]: {
        marginInlineStart: i
      }
    }),
    [`${o}-borderless`]: {
      borderColor: "transparent",
      background: e.tagBorderlessBg
    }
  };
}, Hm = (e) => {
  const {
    lineWidth: t,
    fontSizeIcon: n,
    calc: r
  } = e, o = e.fontSizeSM;
  return Dt(e, {
    tagFontSize: o,
    tagLineHeight: q(r(e.lineHeightSM).mul(o).equal()),
    tagIconSize: r(n).sub(r(t).mul(2)).equal(),
    // Tag icon is much smaller
    tagPaddingHorizontal: 8,
    // Fixed padding.
    tagBorderlessBg: e.colorFillTertiary
  });
}, Vm = (e) => ({
  defaultBg: new Zt(e.colorFillQuaternary).onBackground(e.colorBgContainer).toHexString(),
  defaultColor: e.colorText
}), ew = Xt("Tag", (e) => {
  const t = Hm(e);
  return PV(t);
}, Vm);
var RV = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const MV = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    style: r,
    className: o,
    checked: a,
    onChange: i,
    onClick: l
  } = e, c = RV(e, ["prefixCls", "style", "className", "checked", "onChange", "onClick"]), {
    getPrefixCls: u,
    tag: d
  } = s.useContext(lt), f = (b) => {
    i == null || i(!a), l == null || l(b);
  }, m = u("tag", n), [v, h, p] = ew(m), g = J(m, `${m}-checkable`, {
    [`${m}-checkable-checked`]: a
  }, d == null ? void 0 : d.className, o, h, p);
  return v(/* @__PURE__ */ s.createElement("span", Object.assign({}, c, {
    ref: t,
    style: Object.assign(Object.assign({}, r), d == null ? void 0 : d.style),
    className: g,
    onClick: f
  })));
}), TV = MV, _V = (e) => Ab(e, (t, n) => {
  let {
    textColor: r,
    lightBorderColor: o,
    lightColor: a,
    darkColor: i
  } = n;
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: r,
      background: a,
      borderColor: o,
      // Inverse color
      "&-inverse": {
        color: e.colorTextLightSolid,
        background: i,
        borderColor: i
      },
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}), DV = zo(["Tag", "preset"], (e) => {
  const t = Hm(e);
  return _V(t);
}, Vm);
function kV(e) {
  return typeof e != "string" ? e : e.charAt(0).toUpperCase() + e.slice(1);
}
const _l = (e, t, n) => {
  const r = kV(n);
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: e[`color${n}`],
      background: e[`color${r}Bg`],
      borderColor: e[`color${r}Border`],
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}, LV = zo(["Tag", "status"], (e) => {
  const t = Hm(e);
  return [_l(t, "success", "Success"), _l(t, "processing", "Info"), _l(t, "error", "Error"), _l(t, "warning", "Warning")];
}, Vm);
var FV = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const jV = (e, t) => {
  const {
    prefixCls: n,
    className: r,
    rootClassName: o,
    style: a,
    children: i,
    icon: l,
    color: c,
    onClose: u,
    closeIcon: d,
    closable: f,
    bordered: m = !0
  } = e, v = FV(e, ["prefixCls", "className", "rootClassName", "style", "children", "icon", "color", "onClose", "closeIcon", "closable", "bordered"]), {
    getPrefixCls: h,
    direction: p,
    tag: g
  } = s.useContext(lt), [b, y] = s.useState(!0);
  process.env.NODE_ENV !== "production" && Rt("Tag").deprecated(!("visible" in v), "visible", "visible && <Tag />"), s.useEffect(() => {
    "visible" in v && y(v.visible);
  }, [v.visible]);
  const C = eC(c), S = m_(c), $ = C || S, x = Object.assign(Object.assign({
    backgroundColor: c && !$ ? c : void 0
  }, g == null ? void 0 : g.style), a), w = h("tag", n), [N, O, E] = ew(w), I = J(w, g == null ? void 0 : g.className, {
    [`${w}-${c}`]: $,
    [`${w}-has-color`]: c && !$,
    [`${w}-hidden`]: !b,
    [`${w}-rtl`]: p === "rtl",
    [`${w}-borderless`]: !m
  }, r, o, O, E), k = (T) => {
    T.stopPropagation(), u == null || u(T), !T.defaultPrevented && y(!1);
  }, [, M] = Nf(f, d ?? (g == null ? void 0 : g.closeIcon), (T) => T === null ? /* @__PURE__ */ s.createElement(mo, {
    className: `${w}-close-icon`,
    onClick: k
  }) : /* @__PURE__ */ s.createElement("span", {
    className: `${w}-close-icon`,
    onClick: k
  }, T), null, !1), P = typeof v.onClick == "function" || i && i.type === "a", _ = l || null, D = _ ? /* @__PURE__ */ s.createElement(s.Fragment, null, _, i && /* @__PURE__ */ s.createElement("span", null, i)) : i, R = /* @__PURE__ */ s.createElement("span", Object.assign({}, v, {
    ref: t,
    className: I,
    style: x
  }), D, M, C && /* @__PURE__ */ s.createElement(DV, {
    key: "preset",
    prefixCls: w
  }), S && /* @__PURE__ */ s.createElement(LV, {
    key: "status",
    prefixCls: w
  }));
  return N(P ? /* @__PURE__ */ s.createElement(Bi, {
    component: "Tag"
  }, R) : R);
}, Wm = /* @__PURE__ */ s.forwardRef(jV);
process.env.NODE_ENV !== "production" && (Wm.displayName = "Tag");
Wm.CheckableTag = TV;
const tw = Wm;
var zV = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" };
const AV = zV;
var nw = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: AV
  }));
};
process.env.NODE_ENV !== "production" && (nw.displayName = "DeleteOutlined");
const BV = /* @__PURE__ */ s.forwardRef(nw);
var HV = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const VV = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
}, WV = /* @__PURE__ */ s.forwardRef((e, t) => {
  const n = (u) => {
    const {
      keyCode: d
    } = u;
    d === Oe.ENTER && u.preventDefault();
  }, r = (u) => {
    const {
      keyCode: d
    } = u, {
      onClick: f
    } = e;
    d === Oe.ENTER && f && f();
  }, {
    style: o,
    noStyle: a,
    disabled: i
  } = e, l = HV(e, ["style", "noStyle", "disabled"]);
  let c = {};
  return a || (c = Object.assign({}, VV)), i && (c.pointerEvents = "none"), c = Object.assign(Object.assign({}, c), o), /* @__PURE__ */ s.createElement("div", Object.assign({
    role: "button",
    tabIndex: 0,
    ref: t
  }, l, {
    onKeyDown: n,
    onKeyUp: r,
    style: c
  }));
}), uh = WV;
var KV = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
const qV = KV;
var rw = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: qV
  }));
};
process.env.NODE_ENV !== "production" && (rw.displayName = "CopyOutlined");
const GV = /* @__PURE__ */ s.forwardRef(rw);
var UV = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
const YV = UV;
var ow = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: YV
  }));
};
process.env.NODE_ENV !== "production" && (ow.displayName = "EditOutlined");
const XV = /* @__PURE__ */ s.forwardRef(ow);
var QV = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
    n.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(o) {
      e.addRange(o);
    }), t && t.focus();
  };
}, JV = QV, dh = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, ZV = "Copy to clipboard: #{key}, Enter";
function e6(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function t6(e, t) {
  var n, r, o, a, i, l, c = !1;
  t || (t = {}), n = t.debug || !1;
  try {
    o = JV(), a = document.createRange(), i = document.getSelection(), l = document.createElement("span"), l.textContent = e, l.ariaHidden = "true", l.style.all = "unset", l.style.position = "fixed", l.style.top = 0, l.style.clip = "rect(0, 0, 0, 0)", l.style.whiteSpace = "pre", l.style.webkitUserSelect = "text", l.style.MozUserSelect = "text", l.style.msUserSelect = "text", l.style.userSelect = "text", l.addEventListener("copy", function(d) {
      if (d.stopPropagation(), t.format)
        if (d.preventDefault(), typeof d.clipboardData > "u") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var f = dh[t.format] || dh.default;
          window.clipboardData.setData(f, e);
        } else
          d.clipboardData.clearData(), d.clipboardData.setData(t.format, e);
      t.onCopy && (d.preventDefault(), t.onCopy(d.clipboardData));
    }), document.body.appendChild(l), a.selectNodeContents(l), i.addRange(a);
    var u = document.execCommand("copy");
    if (!u)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (d) {
    n && console.error("unable to copy using execCommand: ", d), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), c = !0;
    } catch (f) {
      n && console.error("unable to copy using clipboardData: ", f), n && console.error("falling back to prompt"), r = e6("message" in t ? t.message : ZV), window.prompt(r, e);
    }
  } finally {
    i && (typeof i.removeRange == "function" ? i.removeRange(a) : i.removeAllRanges()), l && document.body.removeChild(l), o();
  }
  return c;
}
var n6 = t6, r6 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" };
const o6 = r6;
var aw = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: o6
  }));
};
process.env.NODE_ENV !== "production" && (aw.displayName = "EnterOutlined");
const a6 = /* @__PURE__ */ s.forwardRef(aw), i6 = (e, t, n, r) => {
  const {
    titleMarginBottom: o,
    fontWeightStrong: a
  } = r;
  return {
    marginBottom: o,
    color: n,
    fontWeight: a,
    fontSize: e,
    lineHeight: t
  };
}, l6 = (e) => {
  const t = [1, 2, 3, 4, 5], n = {};
  return t.forEach((r) => {
    n[`
      h${r}&,
      div&-h${r},
      div&-h${r} > textarea,
      h${r}
    `] = i6(e[`fontSizeHeading${r}`], e[`lineHeightHeading${r}`], e.colorTextHeading, e);
  }), n;
}, s6 = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    "a&, a": Object.assign(Object.assign({}, vf(e)), {
      textDecoration: e.linkDecoration,
      "&:active, &:hover": {
        textDecoration: e.linkHoverDecoration
      },
      [`&[disabled], &${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: e.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, c6 = (e) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: oO[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: e.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), u6 = (e) => {
  const {
    componentCls: t,
    paddingSM: n
  } = e, r = n;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: e.calc(e.paddingSM).mul(-1).equal(),
        marginTop: e.calc(r).mul(-1).equal(),
        marginBottom: `calc(1em - ${q(r)})`
      },
      [`${t}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: e.calc(e.marginXS).add(2).equal(),
        insetBlockEnd: e.marginXS,
        color: e.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: e.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, d6 = (e) => ({
  [`${e.componentCls}-copy-success`]: {
    [`
    &,
    &:hover,
    &:focus`]: {
      color: e.colorSuccess
    }
  },
  [`${e.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), f6 = () => ({
  [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-single-line": {
    whiteSpace: "nowrap"
  },
  "&-ellipsis-single-line": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), m6 = (e) => {
  const {
    componentCls: t,
    titleMarginTop: n
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: e.colorText,
      wordBreak: "break-word",
      lineHeight: e.lineHeight,
      [`&${t}-secondary`]: {
        color: e.colorTextDescription
      },
      [`&${t}-success`]: {
        color: e.colorSuccess
      },
      [`&${t}-warning`]: {
        color: e.colorWarning
      },
      [`&${t}-danger`]: {
        color: e.colorError,
        "a&:active, a&:focus": {
          color: e.colorErrorActive
        },
        "a&:hover": {
          color: e.colorErrorHover
        }
      },
      [`&${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      [`
        div&,
        p
      `]: {
        marginBottom: "1em"
      }
    }, l6(e)), {
      [`
      & + h1${t},
      & + h2${t},
      & + h3${t},
      & + h4${t},
      & + h5${t}
      `]: {
        marginTop: n
      },
      [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
        [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
          marginTop: n
        }
      }
    }), c6(e)), s6(e)), {
      // Operation
      [`
        ${t}-expand,
        ${t}-edit,
        ${t}-copy
      `]: Object.assign(Object.assign({}, vf(e)), {
        marginInlineStart: e.marginXXS
      })
    }), u6(e)), d6(e)), f6()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, v6 = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), iw = Xt("Typography", (e) => [m6(e)], v6), g6 = (e) => {
  const {
    prefixCls: t,
    "aria-label": n,
    className: r,
    style: o,
    direction: a,
    maxLength: i,
    autoSize: l = !0,
    value: c,
    onSave: u,
    onCancel: d,
    onEnd: f,
    component: m,
    enterIcon: v = /* @__PURE__ */ s.createElement(a6, null)
  } = e, h = s.useRef(null), p = s.useRef(!1), g = s.useRef(), [b, y] = s.useState(c);
  s.useEffect(() => {
    y(c);
  }, [c]), s.useEffect(() => {
    if (h.current && h.current.resizableTextArea) {
      const {
        textArea: _
      } = h.current.resizableTextArea;
      _.focus();
      const {
        length: D
      } = _.value;
      _.setSelectionRange(D, D);
    }
  }, []);
  const C = (_) => {
    let {
      target: D
    } = _;
    y(D.value.replace(/[\n\r]/g, ""));
  }, S = () => {
    p.current = !0;
  }, $ = () => {
    p.current = !1;
  }, x = (_) => {
    let {
      keyCode: D
    } = _;
    p.current || (g.current = D);
  }, w = () => {
    u(b.trim());
  }, N = (_) => {
    let {
      keyCode: D,
      ctrlKey: R,
      altKey: T,
      metaKey: L,
      shiftKey: F
    } = _;
    g.current === D && !p.current && !R && !T && !L && !F && (D === Oe.ENTER ? (w(), f == null || f()) : D === Oe.ESC && d());
  }, O = () => {
    w();
  }, E = m ? `${t}-${m}` : "", [I, k, M] = iw(t), P = J(t, `${t}-edit-content`, {
    [`${t}-rtl`]: a === "rtl"
  }, r, E, k, M);
  return I(/* @__PURE__ */ s.createElement("div", {
    className: P,
    style: o
  }, /* @__PURE__ */ s.createElement(tx, {
    ref: h,
    maxLength: i,
    value: b,
    onChange: C,
    onKeyDown: x,
    onKeyUp: N,
    onCompositionStart: S,
    onCompositionEnd: $,
    onBlur: O,
    "aria-label": n,
    rows: 1,
    autoSize: l
  }), v !== null ? xn(v, {
    className: `${t}-edit-content-confirm`
  }) : null));
}, p6 = g6;
function gu(e, t) {
  return s.useMemo(() => {
    const n = !!e;
    return [n, Object.assign(Object.assign({}, t), n && typeof e == "object" ? e : null)];
  }, [e]);
}
const h6 = (e, t) => {
  const n = s.useRef(!1);
  s.useEffect(() => {
    n.current ? e() : n.current = !0;
  }, t);
}, b6 = h6;
var y6 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const lw = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    prefixCls: n,
    component: r = "article",
    className: o,
    rootClassName: a,
    setContentRef: i,
    children: l,
    direction: c,
    style: u
  } = e, d = y6(e, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: f,
    direction: m,
    typography: v
  } = s.useContext(lt), h = c ?? m;
  let p = t;
  i && (p = Un(t, i)), process.env.NODE_ENV !== "production" && Rt("Typography").deprecated(!i, "setContentRef", "ref");
  const g = f("typography", n), [b, y, C] = iw(g), S = J(g, v == null ? void 0 : v.className, {
    [`${g}-rtl`]: h === "rtl"
  }, o, a, y, C), $ = Object.assign(Object.assign({}, v == null ? void 0 : v.style), u);
  return b(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ s.createElement(r, Object.assign({
      className: S,
      style: $,
      ref: p
    }, d), l)
  );
});
process.env.NODE_ENV !== "production" && (lw.displayName = "Typography");
const sw = lw;
function cw(e) {
  const t = typeof e;
  return t === "string" || t === "number";
}
function C6(e) {
  let t = 0;
  return e.forEach((n) => {
    cw(n) ? t += String(n).length : t += 1;
  }), t;
}
function pu(e, t) {
  let n = 0;
  const r = [];
  for (let o = 0; o < e.length; o += 1) {
    if (n === t)
      return r;
    const a = e[o], l = cw(a) ? String(a).length : 1, c = n + l;
    if (c > t) {
      const u = t - n;
      return r.push(String(a).slice(0, u)), r;
    }
    r.push(a), n = c;
  }
  return e;
}
const S6 = 0, Dl = 1, fh = 2, hu = 3, bu = 4, uw = (e) => {
  let {
    enabledMeasure: t,
    children: n,
    text: r,
    width: o,
    fontSize: a,
    rows: i,
    onEllipsis: l
  } = e;
  const [[c, u, d], f] = s.useState([0, 0, 0]), [m, v] = s.useState(0), [h, p] = s.useState(S6), [g, b] = s.useState(0), y = s.useRef(null), C = s.useRef(null), S = s.useMemo(() => Pn(r), [r]), $ = s.useMemo(() => C6(S), [S]), x = s.useMemo(() => !t || h !== hu ? m && h !== bu && t ? n(pu(S, m), m < $) : n(S, !1) : n(pu(S, u), u < $), [t, h, n, S, u, $]);
  Pt(() => {
    t && o && a && $ && (p(Dl), f([0, Math.ceil($ / 2), $]));
  }, [t, o, a, r, $, i]), Pt(() => {
    var E;
    h === Dl && b(((E = y.current) === null || E === void 0 ? void 0 : E.offsetHeight) || 0);
  }, [h]), Pt(() => {
    var E, I;
    if (g) {
      if (h === Dl) {
        const k = ((E = C.current) === null || E === void 0 ? void 0 : E.offsetHeight) || 0, M = i * g;
        k <= M ? (p(bu), l(!1)) : p(fh);
      } else if (h === fh)
        if (c !== d) {
          const k = ((I = C.current) === null || I === void 0 ? void 0 : I.offsetHeight) || 0, M = i * g;
          let P = c, _ = d;
          c === d - 1 ? _ = c : k <= M ? P = u : _ = u;
          const D = Math.ceil((P + _) / 2);
          f([P, D, _]);
        } else
          p(hu), v(u), l(!0);
    }
  }, [h, c, d, i, g]);
  const w = {
    width: o,
    whiteSpace: "normal",
    margin: 0,
    padding: 0
  }, N = (E, I, k) => /* @__PURE__ */ s.createElement("span", {
    "aria-hidden": !0,
    ref: I,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      zIndex: -9999,
      visibility: "hidden",
      pointerEvents: "none",
      fontSize: Math.ceil(a / 2) * 2
    }, k)
  }, E), O = (E, I) => {
    const k = pu(S, E);
    return N(n(k, !0), I, w);
  };
  return /* @__PURE__ */ s.createElement(s.Fragment, null, x, t && h !== hu && h !== bu && /* @__PURE__ */ s.createElement(s.Fragment, null, N("lg", y, {
    wordBreak: "keep-all",
    whiteSpace: "nowrap"
  }), h === Dl ? N(n(S, !1), C, w) : O(u, C)));
};
process.env.NODE_ENV !== "production" && (uw.displayName = "Ellipsis");
const x6 = uw, dw = (e) => {
  let {
    enabledEllipsis: t,
    isEllipsis: n,
    children: r,
    tooltipProps: o
  } = e;
  return !(o != null && o.title) || !t ? r : /* @__PURE__ */ s.createElement(Mr, Object.assign({
    open: n ? void 0 : !1
  }, o), r);
};
process.env.NODE_ENV !== "production" && (dw.displayName = "EllipsisTooltip");
const $6 = dw;
var w6 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function E6(e, t) {
  let {
    mark: n,
    code: r,
    underline: o,
    delete: a,
    strong: i,
    keyboard: l,
    italic: c
  } = e, u = t;
  function d(f, m) {
    m && (u = /* @__PURE__ */ s.createElement(f, {}, u));
  }
  return d("strong", i), d("u", o), d("del", a), d("code", r), d("mark", n), d("kbd", l), d("i", c), u;
}
function kl(e, t, n) {
  return e === !0 || e === void 0 ? t : e || n && t;
}
function mh(e) {
  return e === !1 ? [!1, !1] : Array.isArray(e) ? e : [e];
}
const O6 = "...", N6 = /* @__PURE__ */ s.forwardRef((e, t) => {
  var n, r, o;
  const {
    prefixCls: a,
    className: i,
    style: l,
    type: c,
    disabled: u,
    children: d,
    ellipsis: f,
    editable: m,
    copyable: v,
    component: h,
    title: p
  } = e, g = w6(e, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: b,
    direction: y
  } = s.useContext(lt), [C] = ur("Text"), S = s.useRef(null), $ = s.useRef(null), x = b("typography", a), w = an(g, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), [N, O] = gu(m), [E, I] = Vt(!1, {
    value: O.editing
  }), {
    triggerType: k = ["icon"]
  } = O, M = (Ie) => {
    var Be;
    Ie && ((Be = O.onStart) === null || Be === void 0 || Be.call(O)), I(Ie);
  };
  b6(() => {
    var Ie;
    E || (Ie = $.current) === null || Ie === void 0 || Ie.focus();
  }, [E]);
  const P = (Ie) => {
    Ie == null || Ie.preventDefault(), M(!0);
  }, _ = (Ie) => {
    var Be;
    (Be = O.onChange) === null || Be === void 0 || Be.call(O, Ie), M(!1);
  }, D = () => {
    var Ie;
    (Ie = O.onCancel) === null || Ie === void 0 || Ie.call(O), M(!1);
  }, [R, T] = gu(v), [L, F] = s.useState(!1), j = s.useRef(null), A = {};
  T.format && (A.format = T.format);
  const B = () => {
    j.current && clearTimeout(j.current);
  }, K = (Ie) => {
    var Be;
    Ie == null || Ie.preventDefault(), Ie == null || Ie.stopPropagation(), n6(T.text || String(d) || "", A), F(!0), B(), j.current = setTimeout(() => {
      F(!1);
    }, 3e3), (Be = T.onCopy) === null || Be === void 0 || Be.call(T, Ie);
  };
  s.useEffect(() => B, []);
  const [Y, G] = s.useState(!1), [te, ee] = s.useState(!1), [oe, X] = s.useState(!1), [W, re] = s.useState(!1), [Z, H] = s.useState(!1), [U, ae] = s.useState(!0), [ue, de] = gu(f, {
    expandable: !1
  }), se = ue && !oe, {
    rows: ie = 1
  } = de, me = s.useMemo(() => (
    // Disable ellipsis
    !se || // Provide suffix
    de.suffix !== void 0 || de.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    de.expandable || N || R
  ), [se, de, N, R]);
  Pt(() => {
    ue && !me && (G(id("webkitLineClamp")), ee(id("textOverflow")));
  }, [me, ue]);
  const Se = s.useMemo(() => me ? !1 : ie === 1 ? te : Y, [me, te, Y]), ve = se && (Se ? Z : W), ge = se && ie === 1 && Se, $e = se && ie > 1 && Se, we = (Ie) => {
    var Be;
    X(!0), (Be = de.onExpand) === null || Be === void 0 || Be.call(de, Ie);
  }, [_e, ze] = s.useState(0), [Te, ke] = s.useState(0), Le = (Ie, Be) => {
    let {
      offsetWidth: bt
    } = Ie;
    var He;
    ze(bt), ke(parseInt((He = window.getComputedStyle) === null || He === void 0 ? void 0 : He.call(window, Be).fontSize, 10) || 0);
  }, Ee = (Ie) => {
    var Be;
    re(Ie), W !== Ie && ((Be = de.onEllipsis) === null || Be === void 0 || Be.call(de, Ie));
  };
  s.useEffect(() => {
    const Ie = S.current;
    if (ue && Se && Ie) {
      const Be = $e ? Ie.offsetHeight < Ie.scrollHeight : Ie.offsetWidth < Ie.scrollWidth;
      Z !== Be && H(Be);
    }
  }, [ue, Se, d, $e, U, _e]), s.useEffect(() => {
    const Ie = S.current;
    if (typeof IntersectionObserver > "u" || !Ie || !Se || !se)
      return;
    const Be = new IntersectionObserver(() => {
      ae(!!Ie.offsetParent);
    });
    return Be.observe(Ie), () => {
      Be.disconnect();
    };
  }, [Se, se]);
  let xe = {};
  de.tooltip === !0 ? xe = {
    title: (n = O.text) !== null && n !== void 0 ? n : d
  } : /* @__PURE__ */ s.isValidElement(de.tooltip) ? xe = {
    title: de.tooltip
  } : typeof de.tooltip == "object" ? xe = Object.assign({
    title: (r = O.text) !== null && r !== void 0 ? r : d
  }, de.tooltip) : xe = {
    title: de.tooltip
  };
  const he = s.useMemo(() => {
    const Ie = (Be) => ["string", "number"].includes(typeof Be);
    if (!(!ue || Se)) {
      if (Ie(O.text))
        return O.text;
      if (Ie(d))
        return d;
      if (Ie(p))
        return p;
      if (Ie(xe.title))
        return xe.title;
    }
  }, [ue, Se, p, xe.title, ve]);
  if (E)
    return /* @__PURE__ */ s.createElement(p6, {
      value: (o = O.text) !== null && o !== void 0 ? o : typeof d == "string" ? d : "",
      onSave: _,
      onCancel: D,
      onEnd: O.onEnd,
      prefixCls: x,
      className: i,
      style: l,
      direction: y,
      component: h,
      maxLength: O.maxLength,
      autoSize: O.autoSize,
      enterIcon: O.enterIcon
    });
  const pe = () => {
    const {
      expandable: Ie,
      symbol: Be
    } = de;
    if (!Ie)
      return null;
    let bt;
    return Be ? bt = Be : bt = C == null ? void 0 : C.expand, /* @__PURE__ */ s.createElement("a", {
      key: "expand",
      className: `${x}-expand`,
      onClick: we,
      "aria-label": C == null ? void 0 : C.expand
    }, bt);
  }, Pe = () => {
    if (!N)
      return;
    const {
      icon: Ie,
      tooltip: Be
    } = O, bt = Pn(Be)[0] || (C == null ? void 0 : C.edit), He = typeof bt == "string" ? bt : "";
    return k.includes("icon") ? /* @__PURE__ */ s.createElement(Mr, {
      key: "edit",
      title: Be === !1 ? "" : bt
    }, /* @__PURE__ */ s.createElement(uh, {
      ref: $,
      className: `${x}-edit`,
      onClick: P,
      "aria-label": He
    }, Ie || /* @__PURE__ */ s.createElement(XV, {
      role: "button"
    }))) : null;
  }, Re = () => {
    if (!R)
      return null;
    const {
      tooltips: Ie,
      icon: Be
    } = T, bt = mh(Ie), He = mh(Be), nt = L ? kl(bt[1], C == null ? void 0 : C.copied) : kl(bt[0], C == null ? void 0 : C.copy), et = L ? C == null ? void 0 : C.copied : C == null ? void 0 : C.copy, Ge = typeof nt == "string" ? nt : et;
    return /* @__PURE__ */ s.createElement(Mr, {
      key: "copy",
      title: nt
    }, /* @__PURE__ */ s.createElement(uh, {
      className: J(`${x}-copy`, {
        [`${x}-copy-success`]: L,
        [`${x}-copy-icon-only`]: d == null
      }),
      onClick: K,
      "aria-label": Ge
    }, L ? kl(He[1], /* @__PURE__ */ s.createElement(Kf, null), !0) : kl(He[0], /* @__PURE__ */ s.createElement(GV, null), !0)));
  }, at = (Ie) => [Ie && pe(), Pe(), Re()], Ze = (Ie) => [Ie && /* @__PURE__ */ s.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, O6), de.suffix, at(Ie)];
  return /* @__PURE__ */ s.createElement(Mn, {
    onResize: Le,
    disabled: !se
  }, (Ie) => /* @__PURE__ */ s.createElement($6, {
    tooltipProps: xe,
    enabledEllipsis: se,
    isEllipsis: ve
  }, /* @__PURE__ */ s.createElement(sw, Object.assign({
    className: J({
      [`${x}-${c}`]: c,
      [`${x}-disabled`]: u,
      [`${x}-ellipsis`]: ue,
      [`${x}-single-line`]: se && ie === 1,
      [`${x}-ellipsis-single-line`]: ge,
      [`${x}-ellipsis-multiple-line`]: $e
    }, i),
    prefixCls: a,
    style: Object.assign(Object.assign({}, l), {
      WebkitLineClamp: $e ? ie : void 0
    }),
    component: h,
    ref: Un(Ie, S, t),
    direction: y,
    onClick: k.includes("text") ? P : void 0,
    "aria-label": he == null ? void 0 : he.toString(),
    title: p
  }, w), /* @__PURE__ */ s.createElement(x6, {
    enabledMeasure: se && !Se,
    text: d,
    rows: ie,
    width: _e,
    fontSize: Te,
    onEllipsis: Ee
  }, (Be, bt) => {
    let He = Be;
    return Be.length && bt && he && (He = /* @__PURE__ */ s.createElement("span", {
      key: "show-content",
      "aria-hidden": !0
    }, He)), E6(e, /* @__PURE__ */ s.createElement(s.Fragment, null, He, Ze(bt)));
  }))));
}), pc = N6;
var I6 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const P6 = /* @__PURE__ */ s.forwardRef((e, t) => {
  var {
    ellipsis: n,
    rel: r
  } = e, o = I6(e, ["ellipsis", "rel"]);
  if (process.env.NODE_ENV !== "production") {
    const i = Rt("Typography.Link");
    process.env.NODE_ENV !== "production" && i(typeof n != "object", "usage", "`ellipsis` only supports boolean value.");
  }
  const a = Object.assign(Object.assign({}, o), {
    rel: r === void 0 && o.target === "_blank" ? "noopener noreferrer" : r
  });
  return delete a.navigate, /* @__PURE__ */ s.createElement(pc, Object.assign({}, a, {
    ref: t,
    ellipsis: !!n,
    component: "a"
  }));
}), R6 = P6, M6 = /* @__PURE__ */ s.forwardRef((e, t) => /* @__PURE__ */ s.createElement(pc, Object.assign({
  ref: t
}, e, {
  component: "div"
}))), T6 = M6;
var _6 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const D6 = (e, t) => {
  var {
    ellipsis: n
  } = e, r = _6(e, ["ellipsis"]);
  const o = s.useMemo(() => n && typeof n == "object" ? an(n, ["expandable", "rows"]) : n, [n]);
  if (process.env.NODE_ENV !== "production") {
    const a = Rt("Typography.Text");
    process.env.NODE_ENV !== "production" && a(typeof n != "object" || !n || !("expandable" in n) && !("rows" in n), "usage", "`ellipsis` do not support `expandable` or `rows` props.");
  }
  return /* @__PURE__ */ s.createElement(pc, Object.assign({
    ref: t
  }, r, {
    ellipsis: o,
    component: "span"
  }));
}, k6 = /* @__PURE__ */ s.forwardRef(D6);
var L6 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const vh = [1, 2, 3, 4, 5], F6 = /* @__PURE__ */ s.forwardRef((e, t) => {
  const {
    level: n = 1
  } = e, r = L6(e, ["level"]);
  let o;
  if (process.env.NODE_ENV !== "production") {
    const a = Rt("Typography.Title");
    process.env.NODE_ENV !== "production" && a(vh.includes(n), "usage", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.");
  }
  return vh.includes(n) ? o = `h${n}` : o = "h1", /* @__PURE__ */ s.createElement(pc, Object.assign({
    ref: t
  }, r, {
    component: o
  }));
}), j6 = F6, il = sw;
il.Text = k6;
il.Link = R6;
il.Title = j6;
il.Paragraph = T6;
const hc = il, yu = function(e, t) {
  if (e && t) {
    var n = Array.isArray(t) ? t : t.split(","), r = e.name || "", o = e.type || "", a = o.replace(/\/.*$/, "");
    return n.some(function(i) {
      var l = i.trim();
      if (/^\*(\/\*)?$/.test(i))
        return !0;
      if (l.charAt(0) === ".") {
        var c = r.toLowerCase(), u = l.toLowerCase(), d = [u];
        return (u === ".jpg" || u === ".jpeg") && (d = [".jpg", ".jpeg"]), d.some(function(f) {
          return c.endsWith(f);
        });
      }
      return /\/\*$/.test(l) ? a === l.replace(/\/.*$/, "") : o === l ? !0 : /^\w+$/.test(l) ? (tt(!1, "Upload takes an invalidate 'accept' type '".concat(l, "'.Skip for check.")), !0) : !1;
    });
  }
  return !0;
};
function z6(e, t) {
  var n = "cannot ".concat(e.method, " ").concat(e.action, " ").concat(t.status, "'"), r = new Error(n);
  return r.status = t.status, r.method = e.method, r.url = e.action, r;
}
function gh(e) {
  var t = e.responseText || e.response;
  if (!t)
    return t;
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}
function A6(e) {
  var t = new XMLHttpRequest();
  e.onProgress && t.upload && (t.upload.onprogress = function(a) {
    a.total > 0 && (a.percent = a.loaded / a.total * 100), e.onProgress(a);
  });
  var n = new FormData();
  e.data && Object.keys(e.data).forEach(function(o) {
    var a = e.data[o];
    if (Array.isArray(a)) {
      a.forEach(function(i) {
        n.append("".concat(o, "[]"), i);
      });
      return;
    }
    n.append(o, a);
  }), e.file instanceof Blob ? n.append(e.filename, e.file, e.file.name) : n.append(e.filename, e.file), t.onerror = function(a) {
    e.onError(a);
  }, t.onload = function() {
    return t.status < 200 || t.status >= 300 ? e.onError(z6(e, t), gh(t)) : e.onSuccess(gh(t), t);
  }, t.open(e.method, e.action, !0), e.withCredentials && "withCredentials" in t && (t.withCredentials = !0);
  var r = e.headers || {};
  return r["X-Requested-With"] !== null && t.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(r).forEach(function(o) {
    r[o] !== null && t.setRequestHeader(o, r[o]);
  }), t.send(n), {
    abort: function() {
      t.abort();
    }
  };
}
function B6(e, t) {
  var n = e.createReader(), r = [];
  function o() {
    n.readEntries(function(a) {
      var i = Array.prototype.slice.apply(a);
      r = r.concat(i);
      var l = !i.length;
      l ? t(r) : o();
    });
  }
  o();
}
var H6 = function(t, n, r) {
  var o = function a(i, l) {
    i && (i.path = l || "", i.isFile ? i.file(function(c) {
      r(c) && (i.fullPath && !c.webkitRelativePath && (Object.defineProperties(c, {
        webkitRelativePath: {
          writable: !0
        }
      }), c.webkitRelativePath = i.fullPath.replace(/^\//, ""), Object.defineProperties(c, {
        webkitRelativePath: {
          writable: !1
        }
      })), n([c]));
    }) : i.isDirectory && B6(i, function(c) {
      c.forEach(function(u) {
        a(u, "".concat(l).concat(i.name, "/"));
      });
    }));
  };
  t.forEach(function(a) {
    o(a.webkitGetAsEntry());
  });
}, V6 = +/* @__PURE__ */ new Date(), W6 = 0;
function Cu() {
  return "rc-upload-".concat(V6, "-").concat(++W6);
}
var K6 = ["component", "prefixCls", "className", "classNames", "disabled", "id", "style", "styles", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave", "hasControlInside"], q6 = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n() {
    var r;
    $n(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), z(Me(r), "state", {
      uid: Cu()
    }), z(Me(r), "reqs", {}), z(Me(r), "fileInput", void 0), z(Me(r), "_isMounted", void 0), z(Me(r), "onChange", function(l) {
      var c = r.props, u = c.accept, d = c.directory, f = l.target.files, m = be(f).filter(function(v) {
        return !d || yu(v, u);
      });
      r.uploadFiles(m), r.reset();
    }), z(Me(r), "onClick", function(l) {
      var c = r.fileInput;
      if (c) {
        var u = l.target, d = r.props.onClick;
        if (u && u.tagName === "BUTTON") {
          var f = c.parentNode;
          f.focus(), u.blur();
        }
        c.click(), d && d(l);
      }
    }), z(Me(r), "onKeyDown", function(l) {
      l.key === "Enter" && r.onClick(l);
    }), z(Me(r), "onFileDrop", function(l) {
      var c = r.props.multiple;
      if (l.preventDefault(), l.type !== "dragover")
        if (r.props.directory)
          H6(Array.prototype.slice.call(l.dataTransfer.items), r.uploadFiles, function(d) {
            return yu(d, r.props.accept);
          });
        else {
          var u = be(l.dataTransfer.files).filter(function(d) {
            return yu(d, r.props.accept);
          });
          c === !1 && (u = u.slice(0, 1)), r.uploadFiles(u);
        }
    }), z(Me(r), "uploadFiles", function(l) {
      var c = be(l), u = c.map(function(d) {
        return d.uid = Cu(), r.processFile(d, c);
      });
      Promise.all(u).then(function(d) {
        var f = r.props.onBatchStart;
        f == null || f(d.map(function(m) {
          var v = m.origin, h = m.parsedFile;
          return {
            file: v,
            parsedFile: h
          };
        })), d.filter(function(m) {
          return m.parsedFile !== null;
        }).forEach(function(m) {
          r.post(m);
        });
      });
    }), z(Me(r), "processFile", /* @__PURE__ */ function() {
      var l = go(/* @__PURE__ */ Fn().mark(function c(u, d) {
        var f, m, v, h, p, g, b, y, C;
        return Fn().wrap(function($) {
          for (; ; )
            switch ($.prev = $.next) {
              case 0:
                if (f = r.props.beforeUpload, m = u, !f) {
                  $.next = 14;
                  break;
                }
                return $.prev = 3, $.next = 6, f(u, d);
              case 6:
                m = $.sent, $.next = 12;
                break;
              case 9:
                $.prev = 9, $.t0 = $.catch(3), m = !1;
              case 12:
                if (m !== !1) {
                  $.next = 14;
                  break;
                }
                return $.abrupt("return", {
                  origin: u,
                  parsedFile: null,
                  action: null,
                  data: null
                });
              case 14:
                if (v = r.props.action, typeof v != "function") {
                  $.next = 21;
                  break;
                }
                return $.next = 18, v(u);
              case 18:
                h = $.sent, $.next = 22;
                break;
              case 21:
                h = v;
              case 22:
                if (p = r.props.data, typeof p != "function") {
                  $.next = 29;
                  break;
                }
                return $.next = 26, p(u);
              case 26:
                g = $.sent, $.next = 30;
                break;
              case 29:
                g = p;
              case 30:
                return b = // string type is from legacy `transformFile`.
                // Not sure if this will work since no related test case works with it
                (mt(m) === "object" || typeof m == "string") && m ? m : u, b instanceof File ? y = b : y = new File([b], u.name, {
                  type: u.type
                }), C = y, C.uid = u.uid, $.abrupt("return", {
                  origin: u,
                  data: g,
                  parsedFile: C,
                  action: h
                });
              case 35:
              case "end":
                return $.stop();
            }
        }, c, null, [[3, 9]]);
      }));
      return function(c, u) {
        return l.apply(this, arguments);
      };
    }()), z(Me(r), "saveFileInput", function(l) {
      r.fileInput = l;
    }), r;
  }
  return wn(n, [{
    key: "componentDidMount",
    value: function() {
      this._isMounted = !0;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._isMounted = !1, this.abort();
    }
  }, {
    key: "post",
    value: function(o) {
      var a = this, i = o.data, l = o.origin, c = o.action, u = o.parsedFile;
      if (this._isMounted) {
        var d = this.props, f = d.onStart, m = d.customRequest, v = d.name, h = d.headers, p = d.withCredentials, g = d.method, b = l.uid, y = m || A6, C = {
          action: c,
          filename: v,
          data: i,
          file: u,
          headers: h,
          withCredentials: p,
          method: g || "post",
          onProgress: function($) {
            var x = a.props.onProgress;
            x == null || x($, u);
          },
          onSuccess: function($, x) {
            var w = a.props.onSuccess;
            w == null || w($, u, x), delete a.reqs[b];
          },
          onError: function($, x) {
            var w = a.props.onError;
            w == null || w($, x, u), delete a.reqs[b];
          }
        };
        f(l), this.reqs[b] = y(C);
      }
    }
  }, {
    key: "reset",
    value: function() {
      this.setState({
        uid: Cu()
      });
    }
  }, {
    key: "abort",
    value: function(o) {
      var a = this.reqs;
      if (o) {
        var i = o.uid ? o.uid : o;
        a[i] && a[i].abort && a[i].abort(), delete a[i];
      } else
        Object.keys(a).forEach(function(l) {
          a[l] && a[l].abort && a[l].abort(), delete a[l];
        });
    }
  }, {
    key: "render",
    value: function() {
      var o, a = this.props, i = a.component, l = a.prefixCls, c = a.className, u = a.classNames, d = u === void 0 ? {} : u, f = a.disabled, m = a.id, v = a.style, h = a.styles, p = h === void 0 ? {} : h, g = a.multiple, b = a.accept, y = a.capture, C = a.children, S = a.directory, $ = a.openFileDialogOnClick, x = a.onMouseEnter, w = a.onMouseLeave, N = a.hasControlInside, O = vt(a, K6), E = J((o = {}, z(o, l, !0), z(o, "".concat(l, "-disabled"), f), z(o, c, c), o)), I = S ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {}, k = f ? {} : {
        onClick: $ ? this.onClick : function() {
        },
        onKeyDown: $ ? this.onKeyDown : function() {
        },
        onMouseEnter: x,
        onMouseLeave: w,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: N ? void 0 : "0"
      };
      return /* @__PURE__ */ le.createElement(i, fe({}, k, {
        className: E,
        role: N ? void 0 : "button",
        style: v
      }), /* @__PURE__ */ le.createElement("input", fe({}, Bn(O, {
        aria: !0,
        data: !0
      }), {
        id: m,
        disabled: f,
        type: "file",
        ref: this.saveFileInput,
        onClick: function(P) {
          return P.stopPropagation();
        },
        key: this.state.uid,
        style: V({
          display: "none"
        }, p.input),
        className: d.input,
        accept: b
      }, I, {
        multiple: g,
        onChange: this.onChange
      }, y != null ? {
        capture: y
      } : {})), C);
    }
  }]), n;
}(wh);
function Su() {
}
var Zd = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Ur(n);
  function n() {
    var r;
    $n(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), z(Me(r), "uploader", void 0), z(Me(r), "saveUploader", function(l) {
      r.uploader = l;
    }), r;
  }
  return wn(n, [{
    key: "abort",
    value: function(o) {
      this.uploader.abort(o);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ le.createElement(q6, fe({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]), n;
}(wh);
z(Zd, "defaultProps", {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: !1,
  onStart: Su,
  onError: Su,
  onSuccess: Su,
  multiple: !1,
  beforeUpload: null,
  customRequest: null,
  withCredentials: !1,
  openFileDialogOnClick: !0,
  hasControlInside: !1
});
const G6 = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-drag`]: {
        position: "relative",
        width: "100%",
        height: "100%",
        textAlign: "center",
        background: e.colorFillAlter,
        border: `${q(e.lineWidth)} dashed ${e.colorBorder}`,
        borderRadius: e.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        [t]: {
          padding: e.padding
        },
        [`${t}-btn`]: {
          display: "table",
          width: "100%",
          height: "100%",
          outline: "none",
          borderRadius: e.borderRadiusLG,
          "&:focus-visible": {
            outline: `${q(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`
          }
        },
        [`${t}-drag-container`]: {
          display: "table-cell",
          verticalAlign: "middle"
        },
        [`
          &:not(${t}-disabled):hover,
          &-hover:not(${t}-disabled)
        `]: {
          borderColor: e.colorPrimaryHover
        },
        [`p${t}-drag-icon`]: {
          marginBottom: e.margin,
          [n]: {
            color: e.colorPrimary,
            fontSize: e.uploadThumbnailSize
          }
        },
        [`p${t}-text`]: {
          margin: `0 0 ${q(e.marginXXS)}`,
          color: e.colorTextHeading,
          fontSize: e.fontSizeLG
        },
        [`p${t}-hint`]: {
          color: e.colorTextDescription,
          fontSize: e.fontSize
        },
        // ===================== Disabled =====================
        [`&${t}-disabled`]: {
          [`p${t}-drag-icon ${n},
            p${t}-text,
            p${t}-hint
          `]: {
            color: e.colorTextDisabled
          }
        }
      }
    }
  };
}, U6 = G6, Y6 = (e) => {
  const {
    componentCls: t,
    antCls: n,
    iconCls: r,
    fontSize: o,
    lineHeight: a,
    calc: i
  } = e, l = `${t}-list-item`, c = `${l}-actions`, u = `${l}-action`, d = e.fontHeightSM;
  return {
    [`${t}-wrapper`]: {
      [`${t}-list`]: Object.assign(Object.assign({}, Mo()), {
        lineHeight: e.lineHeight,
        [l]: {
          position: "relative",
          height: i(e.lineHeight).mul(o).equal(),
          marginTop: e.marginXS,
          fontSize: o,
          display: "flex",
          alignItems: "center",
          transition: `background-color ${e.motionDurationSlow}`,
          "&:hover": {
            backgroundColor: e.controlItemBgHover
          },
          [`${l}-name`]: Object.assign(Object.assign({}, Vr), {
            padding: `0 ${q(e.paddingXS)}`,
            lineHeight: a,
            flex: "auto",
            transition: `all ${e.motionDurationSlow}`
          }),
          [c]: {
            [u]: {
              opacity: 0
            },
            [r]: {
              color: e.actionsColor,
              transition: `all ${e.motionDurationSlow}`
            },
            [`
              ${u}:focus-visible,
              &.picture ${u}
            `]: {
              opacity: 1
            },
            [`${u}${n}-btn`]: {
              height: d,
              border: 0,
              lineHeight: 1
            }
          },
          [`${t}-icon ${r}`]: {
            color: e.colorTextDescription,
            fontSize: o
          },
          [`${l}-progress`]: {
            position: "absolute",
            bottom: e.calc(e.uploadProgressOffset).mul(-1).equal(),
            width: "100%",
            paddingInlineStart: i(o).add(e.paddingXS).equal(),
            fontSize: o,
            lineHeight: 0,
            pointerEvents: "none",
            "> div": {
              margin: 0
            }
          }
        },
        [`${l}:hover ${u}`]: {
          opacity: 1
        },
        [`${l}-error`]: {
          color: e.colorError,
          [`${l}-name, ${t}-icon ${r}`]: {
            color: e.colorError
          },
          [c]: {
            [`${r}, ${r}:hover`]: {
              color: e.colorError
            },
            [u]: {
              opacity: 1
            }
          }
        },
        [`${t}-list-item-container`]: {
          transition: `opacity ${e.motionDurationSlow}, height ${e.motionDurationSlow}`,
          // For smooth removing animation
          "&::before": {
            display: "table",
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
}, X6 = Y6, ph = new kt("uploadAnimateInlineIn", {
  from: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}), hh = new kt("uploadAnimateInlineOut", {
  to: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}), Q6 = (e) => {
  const {
    componentCls: t
  } = e, n = `${t}-animate-inline`;
  return [{
    [`${t}-wrapper`]: {
      [`${n}-appear, ${n}-enter, ${n}-leave`]: {
        animationDuration: e.motionDurationSlow,
        animationTimingFunction: e.motionEaseInOutCirc,
        animationFillMode: "forwards"
      },
      [`${n}-appear, ${n}-enter`]: {
        animationName: ph
      },
      [`${n}-leave`]: {
        animationName: hh
      }
    }
  }, {
    [`${t}-wrapper`]: X0(e)
  }, ph, hh];
}, J6 = Q6, Z6 = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    uploadThumbnailSize: r,
    uploadProgressOffset: o,
    calc: a
  } = e, i = `${t}-list`, l = `${i}-item`;
  return {
    [`${t}-wrapper`]: {
      // ${listCls} 增加优先级
      [`
        ${i}${i}-picture,
        ${i}${i}-picture-card,
        ${i}${i}-picture-circle
      `]: {
        [l]: {
          position: "relative",
          height: a(r).add(a(e.lineWidth).mul(2)).add(a(e.paddingXS).mul(2)).equal(),
          padding: e.paddingXS,
          border: `${q(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusLG,
          "&:hover": {
            background: "transparent"
          },
          [`${l}-thumbnail`]: Object.assign(Object.assign({}, Vr), {
            width: r,
            height: r,
            lineHeight: q(a(r).add(e.paddingSM).equal()),
            textAlign: "center",
            flex: "none",
            [n]: {
              fontSize: e.fontSizeHeading2,
              color: e.colorPrimary
            },
            img: {
              display: "block",
              width: "100%",
              height: "100%",
              overflow: "hidden"
            }
          }),
          [`${l}-progress`]: {
            bottom: o,
            width: `calc(100% - ${q(a(e.paddingSM).mul(2).equal())})`,
            marginTop: 0,
            paddingInlineStart: a(r).add(e.paddingXS).equal()
          }
        },
        [`${l}-error`]: {
          borderColor: e.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          [`${l}-thumbnail ${n}`]: {
            [`svg path[fill='${Wu[0]}']`]: {
              fill: e.colorErrorBg
            },
            [`svg path[fill='${Wu.primary}']`]: {
              fill: e.colorError
            }
          }
        },
        [`${l}-uploading`]: {
          borderStyle: "dashed",
          [`${l}-name`]: {
            marginBottom: o
          }
        }
      },
      [`${i}${i}-picture-circle ${l}`]: {
        [`&, &::before, ${l}-thumbnail`]: {
          borderRadius: "50%"
        }
      }
    }
  };
}, e5 = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontSizeLG: r,
    colorTextLightSolid: o,
    calc: a
  } = e, i = `${t}-list`, l = `${i}-item`, c = e.uploadPicCardSize;
  return {
    [`
      ${t}-wrapper${t}-picture-card-wrapper,
      ${t}-wrapper${t}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, Mo()), {
      display: "inline-block",
      width: "100%",
      [`${t}${t}-select`]: {
        width: c,
        height: c,
        marginInlineEnd: e.marginXS,
        marginBottom: e.marginXS,
        textAlign: "center",
        verticalAlign: "top",
        backgroundColor: e.colorFillAlter,
        border: `${q(e.lineWidth)} dashed ${e.colorBorder}`,
        borderRadius: e.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        [`> ${t}`]: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center"
        },
        [`&:not(${t}-disabled):hover`]: {
          borderColor: e.colorPrimary
        }
      },
      // list
      [`${i}${i}-picture-card, ${i}${i}-picture-circle`]: {
        [`${i}-item-container`]: {
          display: "inline-block",
          width: c,
          height: c,
          marginBlock: `0 ${q(e.marginXS)}`,
          marginInline: `0 ${q(e.marginXS)}`,
          verticalAlign: "top"
        },
        "&::after": {
          display: "none"
        },
        [l]: {
          height: "100%",
          margin: 0,
          "&::before": {
            position: "absolute",
            zIndex: 1,
            width: `calc(100% - ${q(a(e.paddingXS).mul(2).equal())})`,
            height: `calc(100% - ${q(a(e.paddingXS).mul(2).equal())})`,
            backgroundColor: e.colorBgMask,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '" "'
          }
        },
        [`${l}:hover`]: {
          [`&::before, ${l}-actions`]: {
            opacity: 1
          }
        },
        [`${l}-actions`]: {
          position: "absolute",
          insetInlineStart: 0,
          zIndex: 10,
          width: "100%",
          whiteSpace: "nowrap",
          textAlign: "center",
          opacity: 0,
          transition: `all ${e.motionDurationSlow}`,
          [`
            ${n}-eye,
            ${n}-download,
            ${n}-delete
          `]: {
            zIndex: 10,
            width: r,
            margin: `0 ${q(e.marginXXS)}`,
            fontSize: r,
            cursor: "pointer",
            transition: `all ${e.motionDurationSlow}`,
            color: o,
            "&:hover": {
              color: o
            },
            svg: {
              verticalAlign: "baseline"
            }
          }
        },
        [`${l}-thumbnail, ${l}-thumbnail img`]: {
          position: "static",
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain"
        },
        [`${l}-name`]: {
          display: "none",
          textAlign: "center"
        },
        [`${l}-file + ${l}-name`]: {
          position: "absolute",
          bottom: e.margin,
          display: "block",
          width: `calc(100% - ${q(a(e.paddingXS).mul(2).equal())})`
        },
        [`${l}-uploading`]: {
          [`&${l}`]: {
            backgroundColor: e.colorFillAlter
          },
          [`&::before, ${n}-eye, ${n}-download, ${n}-delete`]: {
            display: "none"
          }
        },
        [`${l}-progress`]: {
          bottom: e.marginXL,
          width: `calc(100% - ${q(a(e.paddingXS).mul(2).equal())})`,
          paddingInlineStart: 0
        }
      }
    }),
    [`${t}-wrapper${t}-picture-circle-wrapper`]: {
      [`${t}${t}-select`]: {
        borderRadius: "50%"
      }
    }
  };
}, t5 = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    }
  };
}, n5 = t5, r5 = (e) => {
  const {
    componentCls: t,
    colorTextDisabled: n
  } = e;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, Gt(e)), {
      [t]: {
        outline: 0,
        "input[type='file']": {
          cursor: "pointer"
        }
      },
      [`${t}-select`]: {
        display: "inline-block"
      },
      [`${t}-disabled`]: {
        color: n,
        cursor: "not-allowed"
      }
    })
  };
}, o5 = (e) => ({
  actionsColor: e.colorTextDescription
}), a5 = Xt("Upload", (e) => {
  const {
    fontSizeHeading3: t,
    fontHeight: n,
    lineWidth: r,
    controlHeightLG: o,
    calc: a
  } = e, i = Dt(e, {
    uploadThumbnailSize: a(t).mul(2).equal(),
    uploadProgressOffset: a(a(n).div(2)).add(r).equal(),
    uploadPicCardSize: a(o).mul(2.55).equal()
  });
  return [r5(i), U6(i), Z6(i), e5(i), X6(i), J6(i), n5(i), qi(i)];
}, o5);
var i5 = { icon: function(t, n) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", fill: n } }, { tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", fill: t } }] };
}, name: "file", theme: "twotone" };
const l5 = i5;
var fw = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: l5
  }));
};
process.env.NODE_ENV !== "production" && (fw.displayName = "FileTwoTone");
const s5 = /* @__PURE__ */ s.forwardRef(fw);
var c5 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, name: "paper-clip", theme: "outlined" };
const u5 = c5;
var mw = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: u5
  }));
};
process.env.NODE_ENV !== "production" && (mw.displayName = "PaperClipOutlined");
const d5 = /* @__PURE__ */ s.forwardRef(mw);
var f5 = { icon: function(t, n) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", fill: t } }, { tag: "path", attrs: { d: "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", fill: n } }, { tag: "path", attrs: { d: "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", fill: n } }, { tag: "path", attrs: { d: "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", fill: n } }, { tag: "path", attrs: { d: "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", fill: t } }] };
}, name: "picture", theme: "twotone" };
const m5 = f5;
var vw = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: m5
  }));
};
process.env.NODE_ENV !== "production" && (vw.displayName = "PictureTwoTone");
const v5 = /* @__PURE__ */ s.forwardRef(vw);
function Ll(e) {
  return Object.assign(Object.assign({}, e), {
    lastModified: e.lastModified,
    lastModifiedDate: e.lastModifiedDate,
    name: e.name,
    size: e.size,
    type: e.type,
    uid: e.uid,
    percent: 0,
    originFileObj: e
  });
}
function Fl(e, t) {
  const n = be(t), r = n.findIndex((o) => {
    let {
      uid: a
    } = o;
    return a === e.uid;
  });
  return r === -1 ? n.push(e) : n[r] = e, n;
}
function xu(e, t) {
  const n = e.uid !== void 0 ? "uid" : "name";
  return t.filter((r) => r[n] === e[n])[0];
}
function g5(e, t) {
  const n = e.uid !== void 0 ? "uid" : "name", r = t.filter((o) => o[n] !== e[n]);
  return r.length === t.length ? null : r;
}
const p5 = function() {
  const t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").split("/"), r = t[t.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(r) || [""])[0];
}, gw = (e) => e.indexOf("image/") === 0, h5 = (e) => {
  if (e.type && !e.thumbUrl)
    return gw(e.type);
  const t = e.thumbUrl || e.url || "", n = p5(t);
  return /^data:image\//.test(t) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(n) ? !0 : !(/^data:/.test(t) || n);
}, Zr = 200;
function b5(e) {
  return new Promise((t) => {
    if (!e.type || !gw(e.type)) {
      t("");
      return;
    }
    const n = document.createElement("canvas");
    n.width = Zr, n.height = Zr, n.style.cssText = `position: fixed; left: 0; top: 0; width: ${Zr}px; height: ${Zr}px; z-index: 9999; display: none;`, document.body.appendChild(n);
    const r = n.getContext("2d"), o = new Image();
    if (o.onload = () => {
      const {
        width: a,
        height: i
      } = o;
      let l = Zr, c = Zr, u = 0, d = 0;
      a > i ? (c = i * (Zr / a), d = -(c - l) / 2) : (l = a * (Zr / i), u = -(l - c) / 2), r.drawImage(o, u, d, l, c);
      const f = n.toDataURL();
      document.body.removeChild(n), window.URL.revokeObjectURL(o.src), t(f);
    }, o.crossOrigin = "anonymous", e.type.startsWith("image/svg+xml")) {
      const a = new FileReader();
      a.onload = () => {
        a.result && typeof a.result == "string" && (o.src = a.result);
      }, a.readAsDataURL(e);
    } else if (e.type.startsWith("image/gif")) {
      const a = new FileReader();
      a.onload = () => {
        a.result && t(a.result);
      }, a.readAsDataURL(e);
    } else
      o.src = window.URL.createObjectURL(e);
  });
}
var y5 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "download", theme: "outlined" };
const C5 = y5;
var pw = function(t, n) {
  return /* @__PURE__ */ s.createElement(Ft, fe({}, t, {
    ref: n,
    icon: C5
  }));
};
process.env.NODE_ENV !== "production" && (pw.displayName = "DownloadOutlined");
const S5 = /* @__PURE__ */ s.forwardRef(pw), x5 = /* @__PURE__ */ s.forwardRef((e, t) => {
  let {
    prefixCls: n,
    className: r,
    style: o,
    locale: a,
    listType: i,
    file: l,
    items: c,
    progress: u,
    iconRender: d,
    actionIconRender: f,
    itemRender: m,
    isImgUrl: v,
    showPreviewIcon: h,
    showRemoveIcon: p,
    showDownloadIcon: g,
    previewIcon: b,
    removeIcon: y,
    downloadIcon: C,
    onPreview: S,
    onDownload: $,
    onClose: x
  } = e;
  var w, N;
  const {
    status: O
  } = l, [E, I] = s.useState(O);
  s.useEffect(() => {
    O !== "removed" && I(O);
  }, [O]);
  const [k, M] = s.useState(!1);
  s.useEffect(() => {
    const X = setTimeout(() => {
      M(!0);
    }, 300);
    return () => {
      clearTimeout(X);
    };
  }, []);
  const P = d(l);
  let _ = /* @__PURE__ */ s.createElement("div", {
    className: `${n}-icon`
  }, P);
  if (i === "picture" || i === "picture-card" || i === "picture-circle")
    if (E === "uploading" || !l.thumbUrl && !l.url) {
      const X = J(`${n}-list-item-thumbnail`, {
        [`${n}-list-item-file`]: E !== "uploading"
      });
      _ = /* @__PURE__ */ s.createElement("div", {
        className: X
      }, P);
    } else {
      const X = v != null && v(l) ? /* @__PURE__ */ s.createElement("img", {
        src: l.thumbUrl || l.url,
        alt: l.name,
        className: `${n}-list-item-image`,
        crossOrigin: l.crossOrigin
      }) : P, W = J(`${n}-list-item-thumbnail`, {
        [`${n}-list-item-file`]: v && !v(l)
      });
      _ = /* @__PURE__ */ s.createElement("a", {
        className: W,
        onClick: (re) => S(l, re),
        href: l.url || l.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, X);
    }
  const D = J(`${n}-list-item`, `${n}-list-item-${E}`), R = typeof l.linkProps == "string" ? JSON.parse(l.linkProps) : l.linkProps, T = p ? f(
    (typeof y == "function" ? y(l) : y) || /* @__PURE__ */ s.createElement(BV, null),
    () => x(l),
    n,
    a.removeFile,
    // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    !0
  ) : null, L = g && E === "done" ? f((typeof C == "function" ? C(l) : C) || /* @__PURE__ */ s.createElement(S5, null), () => $(l), n, a.downloadFile) : null, F = i !== "picture-card" && i !== "picture-circle" && /* @__PURE__ */ s.createElement("span", {
    key: "download-delete",
    className: J(`${n}-list-item-actions`, {
      picture: i === "picture"
    })
  }, L, T), j = J(`${n}-list-item-name`), A = l.url ? [/* @__PURE__ */ s.createElement("a", Object.assign({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: j,
    title: l.name
  }, R, {
    href: l.url,
    onClick: (X) => S(l, X)
  }), l.name), F] : [/* @__PURE__ */ s.createElement("span", {
    key: "view",
    className: j,
    onClick: (X) => S(l, X),
    title: l.name
  }, l.name), F], B = h && (l.url || l.thumbUrl) ? /* @__PURE__ */ s.createElement("a", {
    href: l.url || l.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (X) => S(l, X),
    title: a.previewFile
  }, typeof b == "function" ? b(l) : b || /* @__PURE__ */ s.createElement(JS, null)) : null, K = (i === "picture-card" || i === "picture-circle") && E !== "uploading" && /* @__PURE__ */ s.createElement("span", {
    className: `${n}-list-item-actions`
  }, B, E === "done" && L, T), {
    getPrefixCls: Y
  } = s.useContext(lt), G = Y(), te = /* @__PURE__ */ s.createElement("div", {
    className: D
  }, _, A, K, k && /* @__PURE__ */ s.createElement(An, {
    motionName: `${G}-fade`,
    visible: E === "uploading",
    motionDeadline: 2e3
  }, (X) => {
    let {
      className: W
    } = X;
    const re = "percent" in l ? /* @__PURE__ */ s.createElement(n4, Object.assign({}, u, {
      type: "line",
      percent: l.percent,
      "aria-label": l["aria-label"],
      "aria-labelledby": l["aria-labelledby"]
    })) : null;
    return /* @__PURE__ */ s.createElement("div", {
      className: J(`${n}-list-item-progress`, W)
    }, re);
  })), ee = l.response && typeof l.response == "string" ? l.response : ((w = l.error) === null || w === void 0 ? void 0 : w.statusText) || ((N = l.error) === null || N === void 0 ? void 0 : N.message) || a.uploadError, oe = E === "error" ? /* @__PURE__ */ s.createElement(Mr, {
    title: ee,
    getPopupContainer: (X) => X.parentNode
  }, te) : te;
  return /* @__PURE__ */ s.createElement("div", {
    className: J(`${n}-list-item-container`, r),
    style: o,
    ref: t
  }, m ? m(oe, l, c, {
    download: $.bind(null, l),
    preview: S.bind(null, l),
    remove: x.bind(null, l)
  }) : oe);
}), $5 = x5, w5 = (e, t) => {
  const {
    listType: n = "text",
    previewFile: r = b5,
    onPreview: o,
    onDownload: a,
    onRemove: i,
    locale: l,
    iconRender: c,
    isImageUrl: u = h5,
    prefixCls: d,
    items: f = [],
    showPreviewIcon: m = !0,
    showRemoveIcon: v = !0,
    showDownloadIcon: h = !1,
    removeIcon: p,
    previewIcon: g,
    downloadIcon: b,
    progress: y = {
      size: [-1, 2],
      showInfo: !1
    },
    appendAction: C,
    appendActionVisible: S = !0,
    itemRender: $,
    disabled: x
  } = e, w = Gf(), [N, O] = s.useState(!1);
  s.useEffect(() => {
    n !== "picture" && n !== "picture-card" && n !== "picture-circle" || (f || []).forEach((B) => {
      typeof document > "u" || typeof window > "u" || !window.FileReader || !window.File || !(B.originFileObj instanceof File || B.originFileObj instanceof Blob) || B.thumbUrl !== void 0 || (B.thumbUrl = "", r && r(B.originFileObj).then((K) => {
        B.thumbUrl = K || "", w();
      }));
    });
  }, [n, f, r]), s.useEffect(() => {
    O(!0);
  }, []);
  const E = (B, K) => {
    if (o)
      return K == null || K.preventDefault(), o(B);
  }, I = (B) => {
    typeof a == "function" ? a(B) : B.url && window.open(B.url);
  }, k = (B) => {
    i == null || i(B);
  }, M = (B) => {
    if (c)
      return c(B, n);
    const K = B.status === "uploading", Y = u && u(B) ? /* @__PURE__ */ s.createElement(v5, null) : /* @__PURE__ */ s.createElement(s5, null);
    let G = K ? /* @__PURE__ */ s.createElement(To, null) : /* @__PURE__ */ s.createElement(d5, null);
    return n === "picture" ? G = K ? /* @__PURE__ */ s.createElement(To, null) : Y : (n === "picture-card" || n === "picture-circle") && (G = K ? l.uploading : Y), G;
  }, P = (B, K, Y, G, te) => {
    const ee = {
      type: "text",
      size: "small",
      title: G,
      onClick: (oe) => {
        K(), Kn(B) && B.props.onClick && B.props.onClick(oe);
      },
      className: `${Y}-list-item-action`
    };
    if (te && (ee.disabled = x), Kn(B)) {
      const oe = xn(B, Object.assign(Object.assign({}, B.props), {
        onClick: () => {
        }
      }));
      return /* @__PURE__ */ s.createElement(or, Object.assign({}, ee, {
        icon: oe
      }));
    }
    return /* @__PURE__ */ s.createElement(or, Object.assign({}, ee), /* @__PURE__ */ s.createElement("span", null, B));
  };
  s.useImperativeHandle(t, () => ({
    handlePreview: E,
    handleDownload: I
  }));
  const {
    getPrefixCls: _
  } = s.useContext(lt), D = _("upload", d), R = _(), T = J(`${D}-list`, `${D}-list-${n}`), L = be(f.map((B) => ({
    key: B.uid,
    file: B
  })));
  let j = {
    motionDeadline: 2e3,
    motionName: `${D}-${n === "picture-card" || n === "picture-circle" ? "animate-inline" : "animate"}`,
    keys: L,
    motionAppear: N
  };
  const A = s.useMemo(() => {
    const B = Object.assign({}, ya(R));
    return delete B.onAppearEnd, delete B.onEnterEnd, delete B.onLeaveEnd, B;
  }, [R]);
  return n !== "picture-card" && n !== "picture-circle" && (j = Object.assign(Object.assign({}, A), j)), /* @__PURE__ */ s.createElement("div", {
    className: T
  }, /* @__PURE__ */ s.createElement(hf, Object.assign({}, j, {
    component: !1
  }), (B) => {
    let {
      key: K,
      file: Y,
      className: G,
      style: te
    } = B;
    return /* @__PURE__ */ s.createElement($5, {
      key: K,
      locale: l,
      prefixCls: D,
      className: G,
      style: te,
      file: Y,
      items: f,
      progress: y,
      listType: n,
      isImgUrl: u,
      showPreviewIcon: m,
      showRemoveIcon: v,
      showDownloadIcon: h,
      removeIcon: p,
      previewIcon: g,
      downloadIcon: b,
      iconRender: M,
      actionIconRender: P,
      itemRender: $,
      onPreview: E,
      onDownload: I,
      onClose: k
    });
  }), C && /* @__PURE__ */ s.createElement(An, Object.assign({}, j, {
    visible: S,
    forceRender: !0
  }), (B) => {
    let {
      className: K,
      style: Y
    } = B;
    return xn(C, (G) => ({
      className: J(G.className, K),
      style: Object.assign(Object.assign(Object.assign({}, Y), {
        // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
        pointerEvents: K ? "none" : void 0
      }), G.style)
    }));
  }));
}, hw = /* @__PURE__ */ s.forwardRef(w5);
process.env.NODE_ENV !== "production" && (hw.displayName = "UploadList");
const E5 = hw;
var O5 = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function o(a) {
    return a instanceof n ? a : new n(function(i) {
      i(a);
    });
  }
  return new (n || (n = Promise))(function(a, i) {
    function l(d) {
      try {
        u(r.next(d));
      } catch (f) {
        i(f);
      }
    }
    function c(d) {
      try {
        u(r.throw(d));
      } catch (f) {
        i(f);
      }
    }
    function u(d) {
      d.done ? a(d.value) : o(d.value).then(l, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
};
const ai = `__LIST_IGNORE_${Date.now()}__`, N5 = (e, t) => {
  const {
    fileList: n,
    defaultFileList: r,
    onRemove: o,
    showUploadList: a = !0,
    listType: i = "text",
    onPreview: l,
    onDownload: c,
    onChange: u,
    onDrop: d,
    previewFile: f,
    disabled: m,
    locale: v,
    iconRender: h,
    isImageUrl: p,
    progress: g,
    prefixCls: b,
    className: y,
    type: C = "select",
    children: S,
    style: $,
    itemRender: x,
    maxCount: w,
    data: N = {},
    multiple: O = !1,
    hasControlInside: E = !0,
    action: I = "",
    accept: k = "",
    supportServerRender: M = !0,
    rootClassName: P
  } = e, _ = s.useContext(dr), D = m ?? _, [R, T] = Vt(r || [], {
    value: n,
    postState: (Ee) => Ee ?? []
  }), [L, F] = s.useState("drop"), j = s.useRef(null);
  if (process.env.NODE_ENV !== "production") {
    const Ee = Rt("Upload");
    process.env.NODE_ENV !== "production" && Ee("fileList" in e || !("value" in e), "usage", "`value` is not a valid prop, do you mean `fileList`?"), Ee.deprecated(!("transformFile" in e), "transformFile", "beforeUpload");
  }
  s.useMemo(() => {
    const Ee = Date.now();
    (n || []).forEach((xe, he) => {
      !xe.uid && !Object.isFrozen(xe) && (xe.uid = `__AUTO__${Ee}_${he}__`);
    });
  }, [n]);
  const A = (Ee, xe, he) => {
    let pe = be(xe), Pe = !1;
    w === 1 ? pe = pe.slice(-1) : w && (Pe = pe.length > w, pe = pe.slice(0, w)), bi(() => {
      T(pe);
    });
    const Re = {
      file: Ee,
      fileList: pe
    };
    he && (Re.event = he), (!Pe || // We should ignore event if current file is exceed `maxCount`
    pe.some((at) => at.uid === Ee.uid)) && bi(() => {
      u == null || u(Re);
    });
  }, B = (Ee, xe) => O5(void 0, void 0, void 0, function* () {
    const {
      beforeUpload: he,
      transformFile: pe
    } = e;
    let Pe = Ee;
    if (he) {
      const Re = yield he(Ee, xe);
      if (Re === !1)
        return !1;
      if (delete Ee[ai], Re === ai)
        return Object.defineProperty(Ee, ai, {
          value: !0,
          configurable: !0
        }), !1;
      typeof Re == "object" && Re && (Pe = Re);
    }
    return pe && (Pe = yield pe(Pe)), Pe;
  }), K = (Ee) => {
    const xe = Ee.filter((Pe) => !Pe.file[ai]);
    if (!xe.length)
      return;
    const he = xe.map((Pe) => Ll(Pe.file));
    let pe = be(R);
    he.forEach((Pe) => {
      pe = Fl(Pe, pe);
    }), he.forEach((Pe, Re) => {
      let at = Pe;
      if (xe[Re].parsedFile)
        Pe.status = "uploading";
      else {
        const {
          originFileObj: Ze
        } = Pe;
        let Ie;
        try {
          Ie = new File([Ze], Ze.name, {
            type: Ze.type
          });
        } catch {
          Ie = new Blob([Ze], {
            type: Ze.type
          }), Ie.name = Ze.name, Ie.lastModifiedDate = /* @__PURE__ */ new Date(), Ie.lastModified = (/* @__PURE__ */ new Date()).getTime();
        }
        Ie.uid = Pe.uid, at = Ie;
      }
      A(at, pe);
    });
  }, Y = (Ee, xe, he) => {
    try {
      typeof Ee == "string" && (Ee = JSON.parse(Ee));
    } catch {
    }
    if (!xu(xe, R))
      return;
    const pe = Ll(xe);
    pe.status = "done", pe.percent = 100, pe.response = Ee, pe.xhr = he;
    const Pe = Fl(pe, R);
    A(pe, Pe);
  }, G = (Ee, xe) => {
    if (!xu(xe, R))
      return;
    const he = Ll(xe);
    he.status = "uploading", he.percent = Ee.percent;
    const pe = Fl(he, R);
    A(he, pe, Ee);
  }, te = (Ee, xe, he) => {
    if (!xu(he, R))
      return;
    const pe = Ll(he);
    pe.error = Ee, pe.response = xe, pe.status = "error";
    const Pe = Fl(pe, R);
    A(pe, Pe);
  }, ee = (Ee) => {
    let xe;
    Promise.resolve(typeof o == "function" ? o(Ee) : o).then((he) => {
      var pe;
      if (he === !1)
        return;
      const Pe = g5(Ee, R);
      Pe && (xe = Object.assign(Object.assign({}, Ee), {
        status: "removed"
      }), R == null || R.forEach((Re) => {
        const at = xe.uid !== void 0 ? "uid" : "name";
        Re[at] === xe[at] && !Object.isFrozen(Re) && (Re.status = "removed");
      }), (pe = j.current) === null || pe === void 0 || pe.abort(xe), A(xe, Pe));
    });
  }, oe = (Ee) => {
    F(Ee.type), Ee.type === "drop" && (d == null || d(Ee));
  };
  s.useImperativeHandle(t, () => ({
    onBatchStart: K,
    onSuccess: Y,
    onProgress: G,
    onError: te,
    fileList: R,
    upload: j.current
  }));
  const {
    getPrefixCls: X,
    direction: W,
    upload: re
  } = s.useContext(lt), Z = X("upload", b), H = Object.assign(Object.assign({
    onBatchStart: K,
    onError: te,
    onProgress: G,
    onSuccess: Y
  }, e), {
    data: N,
    multiple: O,
    action: I,
    accept: k,
    supportServerRender: M,
    prefixCls: Z,
    disabled: D,
    beforeUpload: B,
    onChange: void 0,
    hasControlInside: E
  });
  delete H.className, delete H.style, (!S || D) && delete H.id;
  const U = `${Z}-wrapper`, [ae, ue, de] = a5(Z, U), [se] = ur("Upload", xr.Upload), {
    showRemoveIcon: ie,
    showPreviewIcon: me,
    showDownloadIcon: Se,
    removeIcon: ve,
    previewIcon: ge,
    downloadIcon: $e
  } = typeof a == "boolean" ? {} : a, we = typeof ie > "u" ? !D : !!ie, _e = (Ee, xe) => a ? /* @__PURE__ */ s.createElement(E5, {
    prefixCls: Z,
    listType: i,
    items: R,
    previewFile: f,
    onPreview: l,
    onDownload: c,
    onRemove: ee,
    showRemoveIcon: we,
    showPreviewIcon: me,
    showDownloadIcon: Se,
    removeIcon: ve,
    previewIcon: ge,
    downloadIcon: $e,
    iconRender: h,
    locale: Object.assign(Object.assign({}, se), v),
    isImageUrl: p,
    progress: g,
    appendAction: Ee,
    appendActionVisible: xe,
    itemRender: x,
    disabled: D
  }) : Ee, ze = J(U, y, P, ue, de, re == null ? void 0 : re.className, {
    [`${Z}-rtl`]: W === "rtl",
    [`${Z}-picture-card-wrapper`]: i === "picture-card",
    [`${Z}-picture-circle-wrapper`]: i === "picture-circle"
  }), Te = Object.assign(Object.assign({}, re == null ? void 0 : re.style), $);
  if (C === "drag") {
    const Ee = J(ue, Z, `${Z}-drag`, {
      [`${Z}-drag-uploading`]: R.some((xe) => xe.status === "uploading"),
      [`${Z}-drag-hover`]: L === "dragover",
      [`${Z}-disabled`]: D,
      [`${Z}-rtl`]: W === "rtl"
    });
    return ae(/* @__PURE__ */ s.createElement("span", {
      className: ze
    }, /* @__PURE__ */ s.createElement("div", {
      className: Ee,
      style: Te,
      onDrop: oe,
      onDragOver: oe,
      onDragLeave: oe
    }, /* @__PURE__ */ s.createElement(Zd, Object.assign({}, H, {
      ref: j,
      className: `${Z}-btn`
    }), /* @__PURE__ */ s.createElement("div", {
      className: `${Z}-drag-container`
    }, S))), _e()));
  }
  const ke = J(Z, `${Z}-select`, {
    [`${Z}-disabled`]: D
  }), Le = /* @__PURE__ */ s.createElement("div", {
    className: ke,
    style: S ? void 0 : {
      display: "none"
    }
  }, /* @__PURE__ */ s.createElement(Zd, Object.assign({}, H, {
    ref: j
  })));
  return ae(i === "picture-card" || i === "picture-circle" ? /* @__PURE__ */ s.createElement("span", {
    className: ze
  }, _e(Le, !!S)) : /* @__PURE__ */ s.createElement("span", {
    className: ze
  }, Le, _e()));
}, bw = /* @__PURE__ */ s.forwardRef(N5);
process.env.NODE_ENV !== "production" && (bw.displayName = "Upload");
const yw = bw;
var I5 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Cw = /* @__PURE__ */ s.forwardRef((e, t) => {
  var {
    style: n,
    height: r,
    hasControlInside: o = !1
  } = e, a = I5(e, ["style", "height", "hasControlInside"]);
  return /* @__PURE__ */ s.createElement(yw, Object.assign({
    ref: t,
    hasControlInside: o
  }, a, {
    type: "drag",
    style: Object.assign(Object.assign({}, n), {
      height: r
    })
  }));
});
process.env.NODE_ENV !== "production" && (Cw.displayName = "Dragger");
const P5 = Cw, Km = yw;
Km.Dragger = P5;
Km.LIST_IGNORE = ai;
const Sw = Km;
var ef = {}, R5 = {
  get exports() {
    return ef;
  },
  set exports(e) {
    ef = e;
  }
}, bc = {}, Di = {}, M5 = {
  get exports() {
    return Di;
  },
  set exports(e) {
    Di = e;
  }
};
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(M5);
var Ya = {}, bh;
function T5() {
  if (bh)
    return Ya;
  bh = 1, Object.defineProperty(Ya, "__esModule", {
    value: !0
  }), Ya.default = void 0;
  var e = {
    // Options
    items_per_page: "件 / ページ",
    jump_to: "移動",
    jump_to_confirm: "確認する",
    page: "ページ",
    // Pagination
    prev_page: "前のページ",
    next_page: "次のページ",
    prev_5: "前 5ページ",
    next_5: "次 5ページ",
    prev_3: "前 3ページ",
    next_3: "次 3ページ",
    page_size: "ページサイズ"
  };
  return Ya.default = e, Ya;
}
var Xa = {}, Qa = {}, Ja = {}, yh;
function _5() {
  if (yh)
    return Ja;
  yh = 1, Object.defineProperty(Ja, "__esModule", {
    value: !0
  }), Ja.default = void 0;
  var e = {
    locale: "ja_JP",
    today: "今日",
    now: "現在時刻",
    backToToday: "今日に戻る",
    ok: "決定",
    timeSelect: "時間を選択",
    dateSelect: "日時を選択",
    weekSelect: "週を選択",
    clear: "クリア",
    month: "月",
    year: "年",
    previousMonth: "前月 (ページアップキー)",
    nextMonth: "翌月 (ページダウンキー)",
    monthSelect: "月を選択",
    yearSelect: "年を選択",
    decadeSelect: "年代を選択",
    yearFormat: "YYYY年",
    dayFormat: "D",
    dateFormat: "YYYY年M月D日",
    dateTimeFormat: "YYYY年M月D日 HH時mm分ss秒",
    previousYear: "前年 (Controlを押しながら左キー)",
    nextYear: "翌年 (Controlを押しながら右キー)",
    previousDecade: "前の年代",
    nextDecade: "次の年代",
    previousCentury: "前の世紀",
    nextCentury: "次の世紀"
  };
  return Ja.default = e, Ja;
}
var Za = {}, Ch;
function xw() {
  if (Ch)
    return Za;
  Ch = 1, Object.defineProperty(Za, "__esModule", {
    value: !0
  }), Za.default = void 0;
  const e = {
    placeholder: "時間を選択",
    rangePlaceholder: ["開始時間", "終了時間"]
  };
  return Za.default = e, Za;
}
var Sh;
function $w() {
  if (Sh)
    return Qa;
  Sh = 1;
  var e = Di;
  Object.defineProperty(Qa, "__esModule", {
    value: !0
  }), Qa.default = void 0;
  var t = e(_5()), n = e(xw());
  const r = {
    lang: Object.assign({
      placeholder: "日付を選択",
      rangePlaceholder: ["開始日付", "終了日付"]
    }, t.default),
    timePickerLocale: Object.assign({}, n.default)
  };
  return Qa.default = r, Qa;
}
var xh;
function D5() {
  if (xh)
    return Xa;
  xh = 1;
  var e = Di;
  Object.defineProperty(Xa, "__esModule", {
    value: !0
  }), Xa.default = void 0;
  var t = e($w());
  return Xa.default = t.default, Xa;
}
var yc = Di;
Object.defineProperty(bc, "__esModule", {
  value: !0
});
var ww = bc.default = void 0, k5 = yc(T5()), L5 = yc(D5()), F5 = yc($w()), j5 = yc(xw());
const Zn = "${label}は有効な${type}ではありません", z5 = {
  locale: "ja",
  Pagination: k5.default,
  DatePicker: F5.default,
  TimePicker: j5.default,
  Calendar: L5.default,
  Table: {
    filterTitle: "フィルター",
    filterConfirm: "OK",
    filterReset: "リセット",
    filterEmptyText: "フィルターなし",
    filterCheckall: "すべてを選択",
    filterSearchPlaceholder: "フィルターで検索",
    selectAll: "ページ単位で選択",
    selectInvert: "ページ単位で反転",
    selectNone: "クリア",
    selectionAll: "すべてを選択",
    sortTitle: "ソート",
    expand: "展開する",
    collapse: "折り畳む",
    triggerDesc: "クリックで降順にソート",
    triggerAsc: "クリックで昇順にソート",
    cancelSort: "ソートをキャンセル"
  },
  Modal: {
    okText: "OK",
    cancelText: "キャンセル",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "キャンセル"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "ここを検索",
    itemUnit: "アイテム",
    itemsUnit: "アイテム"
  },
  Upload: {
    uploading: "アップロード中...",
    removeFile: "ファイルを削除",
    uploadError: "アップロードエラー",
    previewFile: "ファイルをプレビュー",
    downloadFile: "ダウンロードファイル"
  },
  Empty: {
    description: "データがありません"
  },
  Form: {
    defaultValidateMessages: {
      default: "${label}のフィールド検証エラー",
      required: "${label}を入力してください",
      enum: "${label}は[${enum}]のいずれかである必要があります",
      whitespace: "${label}は空白文字にすることはできません",
      date: {
        format: "${label}の日付形式は不正です",
        parse: "${label}は日付に変換できません",
        invalid: "${label}は不正な日付です"
      },
      types: {
        string: Zn,
        method: Zn,
        array: Zn,
        object: Zn,
        number: Zn,
        date: Zn,
        boolean: Zn,
        integer: Zn,
        float: Zn,
        regexp: Zn,
        email: Zn,
        url: Zn,
        hex: Zn
      },
      string: {
        len: "${label}は${len}文字である必要があります",
        min: "${label}は${min}文字以上である必要があります",
        max: "${label}は${max}文字以下である必要があります",
        range: "${label}は${min}-${max}文字の範囲である必要があります"
      },
      number: {
        len: "${label}は${len}と等しい必要があります",
        min: "${label}の最小値は${min}です",
        max: "${label}の最大値は${max}です",
        range: "${label}は${min}-${max}の範囲である必要があります"
      },
      array: {
        len: "${label}は${len}である必要があります",
        min: "${label}の最小は${min}です",
        max: "${label}の最大は${max}です",
        range: "${label}の合計は${min}-${max}の範囲である必要があります"
      },
      pattern: {
        mismatch: "${label}はパターン${pattern}と一致しません"
      }
    }
  }
};
ww = bc.default = z5;
(function(e) {
  e.exports = bc;
})(R5);
const A5 = /* @__PURE__ */ _w(ef), Et = {
  theme: {
    token: {
      colorError: "#f94d42",
      colorWarning: "#f9d342",
      fontSizeHeading1: 25,
      fontSizeHeading2: 20,
      fontSizeHeading3: 18,
      fontSizeHeading4: 15,
      fontSizeXL: 18,
      fontSizeHeading5: 14,
      lineHeightHeading1: 1.3,
      lineHeightHeading2: 1.3,
      lineHeightHeading3: 1.3,
      lineHeightHeading4: 1.3,
      lineHeightHeading5: 1.3,
      lineHeight: 1.5,
      lineHeightSM: 1.5,
      borderRadiusSM: 6,
      borderRadiusXS: 3,
      wireframe: !1,
      colorPrimary: "#142238",
      colorInfo: "#142238",
      colorPrimaryHover: "#68797e",
      colorPrimaryBg: "#142238",
      colorPrimaryBgHover: "#68707E",
      colorPrimaryBorder: "#f2f2f2",
      colorPrimaryBorderHover: "#F9D342",
      colorPrimaryTextHover: "#68707",
      colorPrimaryActive: "#142238",
      colorPrimaryTextActive: "#ffffff"
    },
    components: {
      Input: {
        colorPrimary: "#f9D342",
        colorWarningOutline: "rgba(255, 238, 5, 0.06)",
        controlItemBgActive: "#E5E8F0",
        colorBgContainer: "#F2F2F6",
        colorBorder: "#ffffff",
        colorTextTertiary: "rgba(0, 0, 0, 0.45)",
        colorFillSecondary: "#ffffff",
        lineWidth: 1.5,
        fontSizeIcon: 12,
        controlHeightXS: 16,
        controlHeightSM: 32,
        controlHeight: 40,
        controlOutline: "rgba(255, 238, 5, 0.06)",
        colorFillAlter: "#F5F5F5",
        controlOutlineWidth: 2,
        colorPrimaryHover: "rgb(249, 211, 66)"
      },
      Button: {
        defaultBorderColor: "#142238",
        lineWidth: 2,
        controlOutlineWidth: 0,
        lineHeight: 1,
        fontWeight: 600,
        contentFontSizeLG: 15,
        contentFontSize: 13,
        contentFontSizeSM: 11,
        paddingInlineLG: 32,
        paddingInline: 24,
        paddingInlineSM: 16,
        onlyIconSize: 13,
        onlyIconSizeLG: 15,
        onlyIconSizeSM: 11,
        controlHeightLG: 48,
        controlHeight: 40,
        controlHeightSM: 30,
        textHoverBg: "rgba(0, 0, 0, 0)",
        colorPrimaryHover: "rgba(20, 34, 56, 0.6)",
        colorLinkHover: "rgba(20, 34, 56, 0.6)"
      },
      Radio: {
        colorPrimaryActive: "#142238",
        colorPrimary: "#F9D342"
      },
      Menu: {
        controlItemBgActive: "rgb(229, 232, 240)",
        itemBorderRadius: 3,
        subMenuItemBorderRadius: 3
      },
      Checkbox: {
        borderRadiusSM: 4,
        colorBorder: "#48576A",
        colorBgContainer: "#F2F2F6",
        colorPrimary: "#F9D342",
        colorPrimaryHover: "#FDDD4C"
      },
      Pagination: {
        colorPrimary: "#ffffff",
        colorBgTextActive: "#ffffff",
        colorBgContainer: "#142238",
        colorText: "rgba(0, 0, 0, 0.88)",
        colorPrimaryHover: "#68707E",
        colorBgTextHover: "#ffffff"
      },
      Select: {
        colorPrimary: "#f9D342",
        colorWarningOutline: "rgba(255, 238, 5, 0.06)",
        controlItemBgActive: "#E5E8F0",
        colorBgContainer: "#F2F2F6",
        colorBorder: "#ffffff",
        colorTextTertiary: "rgba(0, 0, 0, 0.45)",
        colorFillSecondary: "#ffffff",
        colorPrimaryHover: "#f9d342",
        lineWidth: 1.5,
        fontSizeIcon: 12,
        controlHeightXS: 16,
        controlHeightSM: 32,
        controlHeight: 40,
        controlOutline: "rgba(255, 238, 5, 0.06)"
      },
      Transfer: {
        controlItemBgActive: "#E5E8F0"
      },
      Tag: {
        lineHeightSM: 2,
        fontSizeSM: 11,
        fontSizeIcon: 11,
        borderRadiusSM: 5
      },
      Calendar: {
        controlItemBgActive: "rgb(195, 209, 233)"
      },
      Form: {
        itemMarginBottom: 40
      },
      Tooltip: {
        paddingSM: 40,
        paddingXS: 20,
        fontSize: 13,
        colorBgSpotlight: "rgb(20, 34, 56)"
      },
      DatePicker: {
        colorWarningOutline: "rgba(255, 238, 5, 0.06)",
        controlItemBgActive: "#E5E8F0",
        colorBgContainer: "#F2F2F6",
        colorBorder: "#ffffff",
        colorTextTertiary: "rgba(0, 0, 0, 0.45)",
        colorFillSecondary: "#ffffff",
        colorPrimaryHover: "#f9d342",
        colorPrimary: "#f9D342",
        lineWidth: 1.5,
        fontSizeIcon: 12,
        controlHeightXS: 16,
        controlHeightSM: 32,
        controlHeight: 40,
        controlOutline: "rgba(255, 238, 5, 0.06)",
        colorFillAlter: "#F5F5F5",
        controlOutlineWidth: 2
      },
      Modal: {
        titleFontSize: 24,
        marginSM: 40,
        fontSize: 16,
        marginXS: 10,
        borderRadiusLG: 6
      }
    }
  },
  locale: A5
}, h8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(or, { ...e }) }), b8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Sm, { ...e }) }), B5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(KS, { ...e }) }), H5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(KS.Panel, { ...e }) });
B5.Panel = H5;
const y8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Tj, { ...e }) }), C8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Bz, { ...e }) }), Cc = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(ka, { ...e }) }), V5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(ka.Search, { ...e }) }), W5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(ka.TextArea, { ...e }) }), K5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(ka.Password, { ...e }) }), q5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(ka.Group, { ...e }) });
Cc.Search = V5;
Cc.Group = q5;
Cc.Textarea = W5;
Cc.Password = K5;
const S8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(hc.Link, { ...e }) }), x8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(hc.Paragraph, { ...e }) }), $8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(IB, { ...e }) }), Ew = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(tl, { ...e }) }), G5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(tl.Button, { ...e }) }), U5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(tl.Group, { ...e }) });
Ew.Button = G5;
Ew.Group = U5;
const w8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(BS, { ...e }) }), Y5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(po, { ...e }) }), X5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(po.Option, { ...e }) });
Y5.Option = X5;
const E8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(wx, { ...e }) }), O8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(f4, { ...e }) }), N8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(jF, { ...e }) }), I8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(hc.Text, { ...e }) }), P8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(hc.Title, { ...e }) }), R8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(vB, { ...e }) }), Q5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Sw, { ...e }) }), J5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Sw.Dragger, { ...e }) });
Q5.Dragger = J5;
const Z5 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Ea, { ...e }) }), e8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Ea.Group, { ...e }) });
Z5.Group = e8;
const M8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(IV, { ...e }) }), t8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(dc, { ...e }) }), n8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(dc.Button, { ...e }) });
t8.Button = n8;
const T8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Mr, { ...e }) }), r8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(tw, { ...e }) }), o8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(tw.CheckableTag, { ...e }) });
r8.CheckableTag = o8;
const _8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(qx, { ...e }) }), Ow = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Zi, { ...e }) }), a8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Zi.Item, { ...e }) }), i8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(Zi.SubMenu, { ...e }) });
Ow.Item = a8;
Ow.SubMenu = i8;
var $h = {}, l8 = {
  get exports() {
    return $h;
  },
  set exports(e) {
    $h = e;
  }
};
(function(e, t) {
  (function(n, r) {
    e.exports = r(ps);
  })(fo, function(n) {
    function r(i) {
      return i && typeof i == "object" && "default" in i ? i : { default: i };
    }
    var o = r(n), a = { name: "ja", weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"), weekdaysShort: "日_月_火_水_木_金_土".split("_"), weekdaysMin: "日_月_火_水_木_金_土".split("_"), months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(i) {
      return i + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日 dddd HH:mm", l: "YYYY/MM/DD", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日(ddd) HH:mm" }, meridiem: function(i) {
      return i < 12 ? "午前" : "午後";
    }, relativeTime: { future: "%s後", past: "%s前", s: "数秒", m: "1分", mm: "%d分", h: "1時間", hh: "%d時間", d: "1日", dd: "%d日", M: "1ヶ月", MM: "%dヶ月", y: "1年", yy: "%d年" } };
    return o.default.locale(a, null, !0), a;
  });
})(l8);
const D8 = (e) => (Vn.locale("ja"), /* @__PURE__ */ We($t, { ...Et, locale: ww, children: /* @__PURE__ */ We(ZL, { ...e }) })), Go = ({ children: e, ...t }) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(rl, { ...t, children: e }) }), s8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(rl.Item, { ...e }) }), c8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(rl.List, { ...e }) }), u8 = ({ children: e, ...t }) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(rl.Provider, { ...t, children: e }) }), d8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(rl.ErrorList, { ...e }) });
Go.Item = s8;
Go.List = c8;
Go.Provider = u8;
Go.ErrorList = d8;
Go.useForm = Nm;
Go.useWatch = Mf;
Go.useFormInstance = Lx;
const k8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(oC, { ...e }) }), f8 = uo({ openNotification: (e, { ...t }) => {
} }), L8 = ({ children: e }) => {
  const [t, n] = SB.useNotification(), r = Wn(
    (a, { ...i }) => {
      t[a]({
        message: i.message,
        description: i.description,
        btn: i.btn,
        key: i.key,
        onClose: i.onClose,
        duration: i.duration,
        icon: i.icon,
        placement: i.placement,
        style: i.style,
        className: i.className,
        onClick: i.onClick,
        closeIcon: i.closeIcon,
        props: i.props,
        role: i.role
      });
    },
    [t]
  ), o = nn(
    () => ({
      openNotification: r
    }),
    [r]
  );
  return /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ Fw(f8.Provider, { value: o, children: [
    n,
    e
  ] }) });
}, m8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(dx, { ...e }) }), v8 = (e) => /* @__PURE__ */ We($t, { ...Et, children: /* @__PURE__ */ We(dx.RangePicker, { ...e }) });
m8.RangePicker = v8;
export {
  h8 as LGButton,
  D8 as LGCalendar,
  Z5 as LGCheckbox,
  b8 as LGCol,
  B5 as LGCollapse,
  m8 as LGDatePicker,
  y8 as LGDivider,
  C8 as LGDrawer,
  t8 as LGDropdown,
  Go as LGForm,
  Cc as LGInput,
  S8 as LGLink,
  Ow as LGMenu,
  R8 as LGModal,
  f8 as LGNotificationContext,
  L8 as LGNotificationRoot,
  x8 as LGParagraph,
  $8 as LGPopconfirm,
  k8 as LGPopover,
  Ew as LGRadio,
  w8 as LGRow,
  Y5 as LGSelect,
  E8 as LGSpace,
  _8 as LGSpin,
  O8 as LGSwitch,
  M8 as LGTable,
  N8 as LGTabs,
  r8 as LGTag,
  I8 as LGText,
  P8 as LGTitle,
  T8 as LGTooltip,
  Q5 as LGUpload
};
